
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec769"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec769"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});

parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bOOlK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $89ab6b9e702438b4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $89ab6b9e702438b4$export$e00380445f2b9e0c);
$parcel$export(module.exports, "internal_serializeStyles", () => $89ab6b9e702438b4$export$13a2d3ef13012b32);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("jjlaj")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("jjlaj")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("2BuCw")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("bBbjn")).default);
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5rflj = parcelRequire("5rflj");

var $8rteH = parcelRequire("8rteH");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $2BuCw = parcelRequire("2BuCw");

var $bBbjn = parcelRequire("bBbjn");
'use client';
function $89ab6b9e702438b4$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5rflj.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $89ab6b9e702438b4$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $89ab6b9e702438b4$var$wrapper = [];
function $89ab6b9e702438b4$export$13a2d3ef13012b32(styles) {
    $89ab6b9e702438b4$var$wrapper[0] = styles;
    return (0, $8rteH.serializeStyles)($89ab6b9e702438b4$var$wrapper);
}

});
parcelRegister("5rflj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5b60245567d758$export$2e2bcd8739ae039);

var $dAzjV = parcelRequire("dAzjV");
parcelRequire("3p9rK");

parcelRequire("8rteH");
parcelRequire("2lACw");
parcelRequire("8ajhZ");
parcelRequire("acw62");
parcelRequire("gd942");
var $3f5b60245567d758$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $dAzjV.default).bind(null);
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dAzjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4a09088fdc2ec0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");

var $8ajhZ = parcelRequire("8ajhZ");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== 'undefined';
var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eP9YU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $eP9YU.T));
            }
            if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eP9YU")).w);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $acad92301ef10c3f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});



parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});



parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("2BuCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e56ca0825dc344f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $eP9YU = parcelRequire("eP9YU");

var $a9M6v = parcelRequire("a9M6v");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $a9M6v.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $1e56ca0825dc344f$var$cacheMap = new Map();
function $1e56ca0825dc344f$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $acw62.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $1e56ca0825dc344f$var$cacheMap.has(cacheKey)) return $1e56ca0825dc344f$var$cacheMap.get(cacheKey);
        const fresh = $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer);
        $1e56ca0825dc344f$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.C), {
        value: cache,
        children: children
    });
    return children;
}

});
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});


parcelRegister("bBbjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $871beca1e2477cf0$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jjlaj.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("dsPLe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cpmCj")).default);

var $cpmCj = parcelRequire("cpmCj");

});
parcelRegister("cpmCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $90895d1859655b11$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $90895d1859655b11$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("lYE9x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("1jJMI")).default);

var $1jJMI = parcelRequire("1jJMI");

});
parcelRegister("1jJMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5b14b581d98cb8$export$2e2bcd8739ae039);
function $0f5b14b581d98cb8$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0f5b14b581d98cb8$export$2e2bcd8739ae039 = $0f5b14b581d98cb8$var$clamp;

});


parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2A1GY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("gxvzd")).default);

var $gxvzd = parcelRequire("gxvzd");

});
parcelRegister("gxvzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a836f2f53d8f74$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");
function $c0a836f2f53d8f74$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $cpmCj.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("eQufN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("eWm0o")).default);

var $eWm0o = parcelRequire("eWm0o");
$parcel$exportWildcard(module.exports, $eWm0o);

});
parcelRegister("eWm0o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $ae078d4716220a63$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $ae078d4716220a63$export$2e2bcd8739ae039);

var $4jPKB = parcelRequire("4jPKB");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $ae078d4716220a63$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $ae078d4716220a63$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($ae078d4716220a63$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $ae078d4716220a63$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $ae078d4716220a63$export$aad197c7121a6651(Component) || fallback;
}
function $ae078d4716220a63$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ae078d4716220a63$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ae078d4716220a63$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ae078d4716220a63$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $4jPKB.ForwardRef:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $4jPKB.Memo:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8ZGCM"));

});
parcelRegister("8ZGCM", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $68c5159438cce3ec$export$a7c73072b1a182ae, (v) => $68c5159438cce3ec$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $68c5159438cce3ec$export$9f27bc3417b4524d, (v) => $68c5159438cce3ec$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $68c5159438cce3ec$export$db77ccec0bb4ccac, (v) => $68c5159438cce3ec$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $68c5159438cce3ec$export$8392c0c9d3dcbd35, (v) => $68c5159438cce3ec$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $68c5159438cce3ec$export$ffb0004e005737fa, (v) => $68c5159438cce3ec$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $68c5159438cce3ec$export$b624eff549462981, (v) => $68c5159438cce3ec$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $68c5159438cce3ec$export$7897aa7841a5380c, (v) => $68c5159438cce3ec$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $68c5159438cce3ec$export$602eac185826482c, (v) => $68c5159438cce3ec$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $68c5159438cce3ec$export$e2c29f18771995cb, (v) => $68c5159438cce3ec$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $68c5159438cce3ec$export$5f8d39834fd61797, (v) => $68c5159438cce3ec$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $68c5159438cce3ec$export$74bf444e3cd11ea5, (v) => $68c5159438cce3ec$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $68c5159438cce3ec$export$998bcd577473dd93, (v) => $68c5159438cce3ec$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $68c5159438cce3ec$export$b706b080d889d2c9, (v) => $68c5159438cce3ec$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $68c5159438cce3ec$export$5be5a87408f70ddc, (v) => $68c5159438cce3ec$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $68c5159438cce3ec$export$45a5e7f76e0caa8d, (v) => $68c5159438cce3ec$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $68c5159438cce3ec$export$455c2e768291efa6, (v) => $68c5159438cce3ec$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $68c5159438cce3ec$export$9522e17588c12572, (v) => $68c5159438cce3ec$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $68c5159438cce3ec$export$2110ac352bb060b9, (v) => $68c5159438cce3ec$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $68c5159438cce3ec$export$56885ab8b9c456ab, (v) => $68c5159438cce3ec$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $68c5159438cce3ec$export$d927fcb6adf8f9de, (v) => $68c5159438cce3ec$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $68c5159438cce3ec$export$b82d16f27459e05a, (v) => $68c5159438cce3ec$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $68c5159438cce3ec$export$522c17b4f5e123e8, (v) => $68c5159438cce3ec$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $68c5159438cce3ec$export$1aabd8a0274ecfd6, (v) => $68c5159438cce3ec$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $68c5159438cce3ec$export$3d6c20d97e46b957, (v) => $68c5159438cce3ec$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $68c5159438cce3ec$export$9b621391a187a31a, (v) => $68c5159438cce3ec$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $68c5159438cce3ec$export$f5bbd400c2f4426f, (v) => $68c5159438cce3ec$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68c5159438cce3ec$export$a7c73072b1a182ae;
var $68c5159438cce3ec$export$9f27bc3417b4524d;
var $68c5159438cce3ec$export$db77ccec0bb4ccac;
var $68c5159438cce3ec$export$8392c0c9d3dcbd35;
var $68c5159438cce3ec$export$ffb0004e005737fa;
var $68c5159438cce3ec$export$b624eff549462981;
var $68c5159438cce3ec$export$7897aa7841a5380c;
var $68c5159438cce3ec$export$602eac185826482c;
var $68c5159438cce3ec$export$e2c29f18771995cb;
var $68c5159438cce3ec$export$5f8d39834fd61797;
var $68c5159438cce3ec$export$74bf444e3cd11ea5;
var $68c5159438cce3ec$export$998bcd577473dd93;
var $68c5159438cce3ec$export$b706b080d889d2c9;
var $68c5159438cce3ec$export$5be5a87408f70ddc;
var $68c5159438cce3ec$export$45a5e7f76e0caa8d;
var $68c5159438cce3ec$export$455c2e768291efa6;
var $68c5159438cce3ec$export$9522e17588c12572;
var $68c5159438cce3ec$export$2110ac352bb060b9;
var $68c5159438cce3ec$export$56885ab8b9c456ab;
var $68c5159438cce3ec$export$d927fcb6adf8f9de;
var $68c5159438cce3ec$export$b82d16f27459e05a;
var $68c5159438cce3ec$export$522c17b4f5e123e8;
var $68c5159438cce3ec$export$1aabd8a0274ecfd6;
var $68c5159438cce3ec$export$3d6c20d97e46b957;
var $68c5159438cce3ec$export$9b621391a187a31a;
var $68c5159438cce3ec$export$f5bbd400c2f4426f;
"use strict";
var $68c5159438cce3ec$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $68c5159438cce3ec$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $68c5159438cce3ec$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $68c5159438cce3ec$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $68c5159438cce3ec$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $68c5159438cce3ec$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $68c5159438cce3ec$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $68c5159438cce3ec$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $68c5159438cce3ec$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE:
                    case $68c5159438cce3ec$var$REACT_PROFILER_TYPE:
                    case $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE:
                    case $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $68c5159438cce3ec$var$REACT_CONTEXT_TYPE:
                            case $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE:
                            case $68c5159438cce3ec$var$REACT_LAZY_TYPE:
                            case $68c5159438cce3ec$var$REACT_MEMO_TYPE:
                                return object;
                            case $68c5159438cce3ec$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $68c5159438cce3ec$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$68c5159438cce3ec$export$a7c73072b1a182ae = $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
$68c5159438cce3ec$export$9f27bc3417b4524d = $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
$68c5159438cce3ec$export$db77ccec0bb4ccac = $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
$68c5159438cce3ec$export$8392c0c9d3dcbd35 = $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
$68c5159438cce3ec$export$ffb0004e005737fa = $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
$68c5159438cce3ec$export$b624eff549462981 = $68c5159438cce3ec$var$REACT_LAZY_TYPE;
$68c5159438cce3ec$export$7897aa7841a5380c = $68c5159438cce3ec$var$REACT_MEMO_TYPE;
$68c5159438cce3ec$export$602eac185826482c = $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
$68c5159438cce3ec$export$e2c29f18771995cb = $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
$68c5159438cce3ec$export$5f8d39834fd61797 = $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
$68c5159438cce3ec$export$74bf444e3cd11ea5 = $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
$68c5159438cce3ec$export$998bcd577473dd93 = $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
$68c5159438cce3ec$export$b706b080d889d2c9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
};
$68c5159438cce3ec$export$5be5a87408f70ddc = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
};
$68c5159438cce3ec$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
};
$68c5159438cce3ec$export$455c2e768291efa6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
};
$68c5159438cce3ec$export$9522e17588c12572 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
};
$68c5159438cce3ec$export$2110ac352bb060b9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_LAZY_TYPE;
};
$68c5159438cce3ec$export$56885ab8b9c456ab = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_MEMO_TYPE;
};
$68c5159438cce3ec$export$d927fcb6adf8f9de = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
};
$68c5159438cce3ec$export$b82d16f27459e05a = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
};
$68c5159438cce3ec$export$522c17b4f5e123e8 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
};
$68c5159438cce3ec$export$1aabd8a0274ecfd6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
};
$68c5159438cce3ec$export$3d6c20d97e46b957 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
};
$68c5159438cce3ec$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE || type === $68c5159438cce3ec$var$REACT_PROFILER_TYPE || type === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $68c5159438cce3ec$var$REACT_LAZY_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_MEMO_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$68c5159438cce3ec$export$f5bbd400c2f4426f = $68c5159438cce3ec$var$typeOf;

});




parcelRegister("5QV4f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6o2lr")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("dLM8u")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("2UDLz")).default);

var $6o2lr = parcelRequire("6o2lr");

var $dLM8u = parcelRequire("dLM8u");

var $2UDLz = parcelRequire("2UDLz");

});
parcelRegister("6o2lr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a66cd95e497efc7$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $dLM8u = parcelRequire("dLM8u");

var $bVuw0 = parcelRequire("bVuw0");

var $2GcsG = parcelRequire("2GcsG");

var $9dZwz = parcelRequire("9dZwz");

var $kOOck = parcelRequire("kOOck");

var $2UDLz = parcelRequire("2UDLz");
const $4a66cd95e497efc7$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $1En50.default)(options, $4a66cd95e497efc7$var$_excluded);
    const breakpoints = (0, $dLM8u.default)(breakpointsInput);
    const spacing = (0, $2GcsG.default)(spacingInput);
    let muiTheme = (0, $3z1Ay.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $8nd05.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $8nd05.default)({}, (0, $bVuw0.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $2UDLz.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $kOOck.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("3z1Ay", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $2985df77ba145d35$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $2985df77ba145d35$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
function $2985df77ba145d35$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $2985df77ba145d35$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || !$2985df77ba145d35$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2985df77ba145d35$var$deepClone(source[key]);
    });
    return output;
}
function $2985df77ba145d35$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $8nd05.default)({}, target) : target;
    if ($2985df77ba145d35$export$53b83ca8eaab0383(target) && $2985df77ba145d35$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key])) output[key] = source[key];
        else if ($2985df77ba145d35$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $2985df77ba145d35$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2985df77ba145d35$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2985df77ba145d35$export$53b83ca8eaab0383(source[key]) ? $2985df77ba145d35$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("dLM8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06500f70819ed69$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $a06500f70819ed69$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $a06500f70819ed69$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $a06500f70819ed69$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $8nd05.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $a06500f70819ed69$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $1En50.default)(breakpoints, $a06500f70819ed69$var$_excluded);
    const sortedValues = $a06500f70819ed69$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $8nd05.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("bVuw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aecb04a157fa644$export$2e2bcd8739ae039);
const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;

});

parcelRegister("2GcsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f392ba2ebd18096$export$2e2bcd8739ae039);

var $cKRCq = parcelRequire("cKRCq");
function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $cKRCq.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("cKRCq", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $94935f79a2c44a85$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $94935f79a2c44a85$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $94935f79a2c44a85$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $94935f79a2c44a85$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $94935f79a2c44a85$export$6f98e8eaf0be1996);


var $3OJTQ = parcelRequire("3OJTQ");

var $k0igC = parcelRequire("k0igC");

var $aFh0N = parcelRequire("aFh0N");

var $hsAPr = parcelRequire("hsAPr");
const $94935f79a2c44a85$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $94935f79a2c44a85$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $94935f79a2c44a85$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $94935f79a2c44a85$var$getCssProperties = (0, $hsAPr.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($94935f79a2c44a85$var$aliases[prop]) prop = $94935f79a2c44a85$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $94935f79a2c44a85$var$properties[a];
    const direction = $94935f79a2c44a85$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $94935f79a2c44a85$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $94935f79a2c44a85$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $94935f79a2c44a85$var$spacingKeys = [
    ...$94935f79a2c44a85$export$aab52a0dde05ad8a,
    ...$94935f79a2c44a85$export$f8397d44f03ab6ad
];
function $94935f79a2c44a85$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $k0igC.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $94935f79a2c44a85$export$1def6f833384e3d1(theme) {
    return $94935f79a2c44a85$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $94935f79a2c44a85$var$getCssProperties(prop);
    const styleFromPropValue = $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $3OJTQ.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $94935f79a2c44a85$var$style(props, keys) {
    const transformer = $94935f79a2c44a85$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $aFh0N.default), {});
}
function $94935f79a2c44a85$export$7ede87f9b603dd3c(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$export$aab52a0dde05ad8a);
}
$94935f79a2c44a85$export$7ede87f9b603dd3c.propTypes = {};
$94935f79a2c44a85$export$7ede87f9b603dd3c.filterProps = $94935f79a2c44a85$export$aab52a0dde05ad8a;
function $94935f79a2c44a85$export$6f98e8eaf0be1996(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$export$f8397d44f03ab6ad);
}
$94935f79a2c44a85$export$6f98e8eaf0be1996.propTypes = {};
$94935f79a2c44a85$export$6f98e8eaf0be1996.filterProps = $94935f79a2c44a85$export$f8397d44f03ab6ad;
function $94935f79a2c44a85$var$spacing(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$var$spacingKeys);
}
$94935f79a2c44a85$var$spacing.propTypes = {};
$94935f79a2c44a85$var$spacing.filterProps = $94935f79a2c44a85$var$spacingKeys;
var $94935f79a2c44a85$export$2e2bcd8739ae039 = $94935f79a2c44a85$var$spacing;

});
parcelRegister("3OJTQ", function(module, exports) {

$parcel$export(module.exports, "values", () => $2c79a5510dec9b08$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $2c79a5510dec9b08$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $2c79a5510dec9b08$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $2c79a5510dec9b08$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $2c79a5510dec9b08$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $2c79a5510dec9b08$export$980e6a259d807490);

var $8nd05 = parcelRequire("8nd05");


var $3z1Ay = parcelRequire("3z1Ay");

var $aFh0N = parcelRequire("aFh0N");
const $2c79a5510dec9b08$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2c79a5510dec9b08$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$2c79a5510dec9b08$export$68c286be0e7e55b7[key]}px)`
};
function $2c79a5510dec9b08$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $2c79a5510dec9b08$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2c79a5510dec9b08$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8nd05.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $aFh0N.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2c79a5510dec9b08$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2c79a5510dec9b08$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3z1Ay.default)(prev, next), {});
    return $2c79a5510dec9b08$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2c79a5510dec9b08$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2c79a5510dec9b08$export$2e2bcd8739ae039 = $2c79a5510dec9b08$var$breakpoints;

});
parcelRegister("aFh0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3aede628aa278f$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $7c3aede628aa278f$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3z1Ay.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $7c3aede628aa278f$export$2e2bcd8739ae039 = $7c3aede628aa278f$var$merge;

});


parcelRegister("k0igC", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $e901fa2f27580273$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $e901fa2f27580273$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $e901fa2f27580273$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");


var $3OJTQ = parcelRequire("3OJTQ");
function $e901fa2f27580273$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $e901fa2f27580273$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $e901fa2f27580273$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $e901fa2f27580273$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $e901fa2f27580273$export$2e2bcd8739ae039 = $e901fa2f27580273$var$style;

});

parcelRegister("hsAPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb619e97db430627$export$2e2bcd8739ae039);
function $cb619e97db430627$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("9dZwz", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $6b750d631801d296$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $6b750d631801d296$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");

var $aFh0N = parcelRequire("aFh0N");

var $k0igC = parcelRequire("k0igC");

var $3OJTQ = parcelRequire("3OJTQ");

var $kOOck = parcelRequire("kOOck");
function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $6b750d631801d296$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $k0igC.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $k0igC.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $k0igC.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $kOOck.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $3OJTQ.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $aFh0N.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $3OJTQ.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $aFh0N.default)(css, breakpointsValues);
                        }
                    } else css = (0, $aFh0N.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $3OJTQ.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $3OJTQ.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    'sx'
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;

});
parcelRegister("kOOck", function(module, exports) {

$parcel$export(module.exports, "default", () => $f27f6a6c429b3415$export$2e2bcd8739ae039);

var $cKRCq = parcelRequire("cKRCq");

var $jxD4j = parcelRequire("jxD4j");

var $nZvud = parcelRequire("nZvud");

var $8ru1G = parcelRequire("8ru1G");

var $imjyU = parcelRequire("imjyU");
const $f27f6a6c429b3415$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $jxD4j.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $jxD4j.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $8ru1G.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $8ru1G.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $8ru1G.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $cKRCq.padding)
    },
    pt: {
        style: (0, $cKRCq.padding)
    },
    pr: {
        style: (0, $cKRCq.padding)
    },
    pb: {
        style: (0, $cKRCq.padding)
    },
    pl: {
        style: (0, $cKRCq.padding)
    },
    px: {
        style: (0, $cKRCq.padding)
    },
    py: {
        style: (0, $cKRCq.padding)
    },
    padding: {
        style: (0, $cKRCq.padding)
    },
    paddingTop: {
        style: (0, $cKRCq.padding)
    },
    paddingRight: {
        style: (0, $cKRCq.padding)
    },
    paddingBottom: {
        style: (0, $cKRCq.padding)
    },
    paddingLeft: {
        style: (0, $cKRCq.padding)
    },
    paddingX: {
        style: (0, $cKRCq.padding)
    },
    paddingY: {
        style: (0, $cKRCq.padding)
    },
    paddingInline: {
        style: (0, $cKRCq.padding)
    },
    paddingInlineStart: {
        style: (0, $cKRCq.padding)
    },
    paddingInlineEnd: {
        style: (0, $cKRCq.padding)
    },
    paddingBlock: {
        style: (0, $cKRCq.padding)
    },
    paddingBlockStart: {
        style: (0, $cKRCq.padding)
    },
    paddingBlockEnd: {
        style: (0, $cKRCq.padding)
    },
    m: {
        style: (0, $cKRCq.margin)
    },
    mt: {
        style: (0, $cKRCq.margin)
    },
    mr: {
        style: (0, $cKRCq.margin)
    },
    mb: {
        style: (0, $cKRCq.margin)
    },
    ml: {
        style: (0, $cKRCq.margin)
    },
    mx: {
        style: (0, $cKRCq.margin)
    },
    my: {
        style: (0, $cKRCq.margin)
    },
    margin: {
        style: (0, $cKRCq.margin)
    },
    marginTop: {
        style: (0, $cKRCq.margin)
    },
    marginRight: {
        style: (0, $cKRCq.margin)
    },
    marginBottom: {
        style: (0, $cKRCq.margin)
    },
    marginLeft: {
        style: (0, $cKRCq.margin)
    },
    marginX: {
        style: (0, $cKRCq.margin)
    },
    marginY: {
        style: (0, $cKRCq.margin)
    },
    marginInline: {
        style: (0, $cKRCq.margin)
    },
    marginInlineStart: {
        style: (0, $cKRCq.margin)
    },
    marginInlineEnd: {
        style: (0, $cKRCq.margin)
    },
    marginBlock: {
        style: (0, $cKRCq.margin)
    },
    marginBlockStart: {
        style: (0, $cKRCq.margin)
    },
    marginBlockEnd: {
        style: (0, $cKRCq.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $nZvud.gap)
    },
    rowGap: {
        style: (0, $nZvud.rowGap)
    },
    columnGap: {
        style: (0, $nZvud.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $imjyU.sizingTransform)
    },
    maxWidth: {
        style: (0, $imjyU.maxWidth)
    },
    minWidth: {
        transform: (0, $imjyU.sizingTransform)
    },
    height: {
        transform: (0, $imjyU.sizingTransform)
    },
    maxHeight: {
        transform: (0, $imjyU.sizingTransform)
    },
    minHeight: {
        transform: (0, $imjyU.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $f27f6a6c429b3415$export$2e2bcd8739ae039 = $f27f6a6c429b3415$var$defaultSxConfig;

});
parcelRegister("jxD4j", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $e39f6794db8cf9ac$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $e39f6794db8cf9ac$export$7a57f79000377ca2);


var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $cKRCq = parcelRequire("cKRCq");

var $3OJTQ = parcelRequire("3OJTQ");
function $e39f6794db8cf9ac$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $e39f6794db8cf9ac$var$createBorderStyle(prop, transform) {
    return (0, $k0igC.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $e39f6794db8cf9ac$export$1edee58a52776cd9 = $e39f6794db8cf9ac$var$createBorderStyle('border', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$f9a7b6bd24892946 = $e39f6794db8cf9ac$var$createBorderStyle('borderTop', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$5abca33e6be905d2 = $e39f6794db8cf9ac$var$createBorderStyle('borderRight', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$e2ce9f12a980a822 = $e39f6794db8cf9ac$var$createBorderStyle('borderBottom', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$47658cca1a909427 = $e39f6794db8cf9ac$var$createBorderStyle('borderLeft', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$e7fb0694ba2404fc = $e39f6794db8cf9ac$var$createBorderStyle('borderColor');
const $e39f6794db8cf9ac$export$126a92c968acdb85 = $e39f6794db8cf9ac$var$createBorderStyle('borderTopColor');
const $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e = $e39f6794db8cf9ac$var$createBorderStyle('borderRightColor');
const $e39f6794db8cf9ac$export$340b0327727f6d1a = $e39f6794db8cf9ac$var$createBorderStyle('borderBottomColor');
const $e39f6794db8cf9ac$export$60beef91a985b4bf = $e39f6794db8cf9ac$var$createBorderStyle('borderLeftColor');
const $e39f6794db8cf9ac$export$f9258c55612cbed7 = $e39f6794db8cf9ac$var$createBorderStyle('outline', $e39f6794db8cf9ac$export$34e2febe53ae29cc);
const $e39f6794db8cf9ac$export$621fe586efeb64b9 = $e39f6794db8cf9ac$var$createBorderStyle('outlineColor');
const $e39f6794db8cf9ac$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$e39f6794db8cf9ac$export$7a57f79000377ca2.propTypes = {};
$e39f6794db8cf9ac$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $e39f6794db8cf9ac$var$borders = (0, $gojsU.default)($e39f6794db8cf9ac$export$1edee58a52776cd9, $e39f6794db8cf9ac$export$f9a7b6bd24892946, $e39f6794db8cf9ac$export$5abca33e6be905d2, $e39f6794db8cf9ac$export$e2ce9f12a980a822, $e39f6794db8cf9ac$export$47658cca1a909427, $e39f6794db8cf9ac$export$e7fb0694ba2404fc, $e39f6794db8cf9ac$export$126a92c968acdb85, $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e, $e39f6794db8cf9ac$export$340b0327727f6d1a, $e39f6794db8cf9ac$export$60beef91a985b4bf, $e39f6794db8cf9ac$export$7a57f79000377ca2, $e39f6794db8cf9ac$export$f9258c55612cbed7, $e39f6794db8cf9ac$export$621fe586efeb64b9);
var $e39f6794db8cf9ac$export$2e2bcd8739ae039 = $e39f6794db8cf9ac$var$borders;

});
parcelRegister("gojsU", function(module, exports) {

$parcel$export(module.exports, "default", () => $beedfc9d7e65f133$export$2e2bcd8739ae039);

var $aFh0N = parcelRequire("aFh0N");
function $beedfc9d7e65f133$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $aFh0N.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $beedfc9d7e65f133$export$2e2bcd8739ae039 = $beedfc9d7e65f133$var$compose;

});


parcelRegister("nZvud", function(module, exports) {

$parcel$export(module.exports, "gap", () => $0481dc1348188242$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $0481dc1348188242$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $0481dc1348188242$export$8a833ffa5f5dbeda);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $cKRCq = parcelRequire("cKRCq");

var $3OJTQ = parcelRequire("3OJTQ");

const $0481dc1348188242$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$5df9adcb0db95e1e.propTypes = {};
$0481dc1348188242$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $0481dc1348188242$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$ec60d70ff941a580.propTypes = {};
$0481dc1348188242$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $0481dc1348188242$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$8a833ffa5f5dbeda.propTypes = {};
$0481dc1348188242$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $0481dc1348188242$export$baf44164ca3a34e8 = (0, $k0igC.default)({
    prop: 'gridColumn'
});
const $0481dc1348188242$export$8f7213a1cd01e832 = (0, $k0igC.default)({
    prop: 'gridRow'
});
const $0481dc1348188242$export$b0e0abbc49ba668 = (0, $k0igC.default)({
    prop: 'gridAutoFlow'
});
const $0481dc1348188242$export$bcd8b929d4b4142 = (0, $k0igC.default)({
    prop: 'gridAutoColumns'
});
const $0481dc1348188242$export$e5039a674e14c828 = (0, $k0igC.default)({
    prop: 'gridAutoRows'
});
const $0481dc1348188242$export$42bd9088661ffb03 = (0, $k0igC.default)({
    prop: 'gridTemplateColumns'
});
const $0481dc1348188242$export$920682ae05b999bc = (0, $k0igC.default)({
    prop: 'gridTemplateRows'
});
const $0481dc1348188242$export$1b88fbdd482fd33a = (0, $k0igC.default)({
    prop: 'gridTemplateAreas'
});
const $0481dc1348188242$export$bdb486e40d52d26f = (0, $k0igC.default)({
    prop: 'gridArea'
});
const $0481dc1348188242$var$grid = (0, $gojsU.default)($0481dc1348188242$export$5df9adcb0db95e1e, $0481dc1348188242$export$ec60d70ff941a580, $0481dc1348188242$export$8a833ffa5f5dbeda, $0481dc1348188242$export$baf44164ca3a34e8, $0481dc1348188242$export$8f7213a1cd01e832, $0481dc1348188242$export$b0e0abbc49ba668, $0481dc1348188242$export$bcd8b929d4b4142, $0481dc1348188242$export$e5039a674e14c828, $0481dc1348188242$export$42bd9088661ffb03, $0481dc1348188242$export$920682ae05b999bc, $0481dc1348188242$export$1b88fbdd482fd33a, $0481dc1348188242$export$bdb486e40d52d26f);
var $0481dc1348188242$export$2e2bcd8739ae039 = $0481dc1348188242$var$grid;

});

parcelRegister("8ru1G", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $625822e5d7cce21a$export$dbaffd4420ea0ac6);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");
function $625822e5d7cce21a$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $625822e5d7cce21a$export$35e9368ef982300f = (0, $k0igC.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$export$2506f56c10355b33 = (0, $k0igC.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$export$8c5a050822fd698c = (0, $k0igC.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$var$palette = (0, $gojsU.default)($625822e5d7cce21a$export$35e9368ef982300f, $625822e5d7cce21a$export$2506f56c10355b33, $625822e5d7cce21a$export$8c5a050822fd698c);
var $625822e5d7cce21a$export$2e2bcd8739ae039 = $625822e5d7cce21a$var$palette;

});

parcelRegister("imjyU", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $d5d974b5976c38ad$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $d5d974b5976c38ad$export$488fda99655ff65a);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $3OJTQ = parcelRequire("3OJTQ");
function $d5d974b5976c38ad$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $d5d974b5976c38ad$export$7e3df82ee760448c = (0, $k0igC.default)({
    prop: 'width',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $3OJTQ.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $d5d974b5976c38ad$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$d5d974b5976c38ad$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $d5d974b5976c38ad$export$ee148fbbe8357dd2 = (0, $k0igC.default)({
    prop: 'minWidth',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$ac607276a8fe9f0a = (0, $k0igC.default)({
    prop: 'height',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$dc0d8bd0b94f8570 = (0, $k0igC.default)({
    prop: 'maxHeight',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$a43cf604e12f3b17 = (0, $k0igC.default)({
    prop: 'minHeight',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$ffed9f14fb65e276 = (0, $k0igC.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$905076ed6620e671 = (0, $k0igC.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$6ccc93f785106a58 = (0, $k0igC.default)({
    prop: 'boxSizing'
});
const $d5d974b5976c38ad$var$sizing = (0, $gojsU.default)($d5d974b5976c38ad$export$7e3df82ee760448c, $d5d974b5976c38ad$export$488fda99655ff65a, $d5d974b5976c38ad$export$ee148fbbe8357dd2, $d5d974b5976c38ad$export$ac607276a8fe9f0a, $d5d974b5976c38ad$export$dc0d8bd0b94f8570, $d5d974b5976c38ad$export$a43cf604e12f3b17, $d5d974b5976c38ad$export$6ccc93f785106a58);
var $d5d974b5976c38ad$export$2e2bcd8739ae039 = $d5d974b5976c38ad$var$sizing;

});



parcelRegister("2UDLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $21efa8802134c535$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $21efa8802134c535$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("2bwhi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("9dZwz")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("9dZwz")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("hcz0Q")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("kOOck")).default);

var $9dZwz = parcelRequire("9dZwz");

var $hcz0Q = parcelRequire("hcz0Q");

var $kOOck = parcelRequire("kOOck");

});
parcelRegister("hcz0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85eb76b78f8a14c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $kOOck = parcelRequire("kOOck");
const $c85eb76b78f8a14c$var$_excluded = [
    "sx"
];
const $c85eb76b78f8a14c$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $kOOck.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c85eb76b78f8a14c$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $1En50.default)(props, $c85eb76b78f8a14c$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $c85eb76b78f8a14c$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3z1Ay.isPlainObject)(result)) return systemProps;
        return (0, $8nd05.default)({}, systemProps, result);
    };
    else finalSx = (0, $8nd05.default)({}, systemProps, inSx);
    return (0, $8nd05.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("7Ekty", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bbT5Q.default;
    }
});

var $bbT5Q = parcelRequire("bbT5Q");

});
parcelRegister("bbT5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $825b752ac2a74c27$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $825b752ac2a74c27$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), (0, $8nd05.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $3ErGR.default).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}

});
parcelRegister("3ErGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8a963e5702921b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2a8a963e5702921b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $aiIP4.getSvgIconUtilityClass), classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $d8seH.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $1En50.default)(props, $2a8a963e5702921b$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$2a8a963e5702921b$var$SvgIcon.muiName = 'SvgIcon';
var $2a8a963e5702921b$export$2e2bcd8739ae039 = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("8Indx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65847140631d74af$export$2e2bcd8739ae039);
function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("jTnBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b578196486f177$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");
var $e7b578196486f177$export$2e2bcd8739ae039 = (0, $gxvzd.default);

});

parcelRegister("1iOpW", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $0f2e94b8fca67639$export$2440da353cedad43);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $aMyfV = parcelRequire("aMyfV");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aMyfV.default), (0, $8nd05.default)({}, props));
}
var $0f2e94b8fca67639$export$2e2bcd8739ae039 = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$export$2440da353cedad43(params) {
    return (0, $aMyfV.useDefaultProps)(params);
}

});
parcelRegister("aMyfV", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $7d98f590ab80e73c$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $7d98f590ab80e73c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $4FZD0 = parcelRequire("4FZD0");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7d98f590ab80e73c$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $7d98f590ab80e73c$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7d98f590ab80e73c$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $7d98f590ab80e73c$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $4FZD0.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $4FZD0.default)(config, props);
    return props;
}
function $7d98f590ab80e73c$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($7d98f590ab80e73c$var$PropsContext);
    return $7d98f590ab80e73c$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $7d98f590ab80e73c$export$2e2bcd8739ae039 = $7d98f590ab80e73c$var$DefaultPropsProvider;

});
parcelRegister("4FZD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $367acbd429e20ec9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $367acbd429e20ec9$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $8nd05.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $8nd05.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $8nd05.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $367acbd429e20ec9$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("d8seH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0277c5e26ff0d56c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rootShouldForwardProp", () => (parcelRequire("8Uq77")).default);

var $bpUvK = parcelRequire("bpUvK");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $8Uq77 = parcelRequire("8Uq77");

var $PJRTc = parcelRequire("PJRTc");
'use client';
const $0277c5e26ff0d56c$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($bpUvK)))({
    themeId: (0, $4jPsi.default),
    defaultTheme: $jR9F1.default,
    rootShouldForwardProp: $8Uq77.default
});
var $0277c5e26ff0d56c$export$2e2bcd8739ae039 = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("bpUvK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84fddd6da8624ed6$var$createStyled;
module.exports.shouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $84fddd6da8624ed6$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2 = $1jnue((parcelRequire("c05no")));

var $84fddd6da8624ed6$var$_styledEngine = $84fddd6da8624ed6$var$_interopRequireWildcard((parcelRequire("bOOlK")));

var $3z1Ay = parcelRequire("3z1Ay");

var $84fddd6da8624ed6$var$_capitalize = $1jnue((parcelRequire("2A1GY")));

var $84fddd6da8624ed6$var$_getDisplayName = $1jnue((parcelRequire("eQufN")));

var $84fddd6da8624ed6$var$_createTheme = $1jnue((parcelRequire("5QV4f")));

var $84fddd6da8624ed6$var$_styleFunctionSx = $1jnue((parcelRequire("2bwhi")));
const $84fddd6da8624ed6$var$_excluded = [
    "ownerState"
], $84fddd6da8624ed6$var$_excluded2 = [
    "variants"
], $84fddd6da8624ed6$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $84fddd6da8624ed6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($84fddd6da8624ed6$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $84fddd6da8624ed6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $84fddd6da8624ed6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $84fddd6da8624ed6$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $84fddd6da8624ed6$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $84fddd6da8624ed6$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $84fddd6da8624ed6$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $84fddd6da8624ed6$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $84fddd6da8624ed6$var$_createTheme.default)();
const $84fddd6da8624ed6$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $84fddd6da8624ed6$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $84fddd6da8624ed6$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $84fddd6da8624ed6$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $84fddd6da8624ed6$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(_ref, $84fddd6da8624ed6$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $84fddd6da8624ed6$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$84fddd6da8624ed6$var$processStyleArg(resolvedStyle, (0, $84fddd6da8624ed6$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $84fddd6da8624ed6$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $84fddd6da8624ed6$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $84fddd6da8624ed6$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $84fddd6da8624ed6$var$shallowLayer((0, $84fddd6da8624ed6$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $84fddd6da8624ed6$var$shallowLayer((0, $84fddd6da8624ed6$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $84fddd6da8624ed6$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $84fddd6da8624ed6$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $84fddd6da8624ed6$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $84fddd6da8624ed6$var$_styleFunctionSx.default)((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
            theme: $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $84fddd6da8624ed6$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $84fddd6da8624ed6$var$defaultOverridesResolver($84fddd6da8624ed6$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $84fddd6da8624ed6$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $84fddd6da8624ed6$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $84fddd6da8624ed6$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($84fddd6da8624ed6$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $84fddd6da8624ed6$var$_styledEngine.default)(tag, (0, $84fddd6da8624ed6$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $84fddd6da8624ed6$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $84fddd6da8624ed6$var$processStyleArg(stylesArg, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $84fddd6da8624ed6$var$processStyleArg(slotStyle, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $84fddd6da8624ed6$var$resolveTheme((0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $84fddd6da8624ed6$var$processStyleArg({
                    variants: themeVariants
                }, (0, $84fddd6da8624ed6$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jR9F1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74a75f0176cf8e3$export$2e2bcd8739ae039);

var $ijOKP = parcelRequire("ijOKP");
'use client';
const $e74a75f0176cf8e3$var$defaultTheme = (0, $ijOKP.default)();
var $e74a75f0176cf8e3$export$2e2bcd8739ae039 = $e74a75f0176cf8e3$var$defaultTheme;

});
parcelRegister("ijOKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5615f18e5cd04fc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $9dZwz = parcelRequire("9dZwz");
var $kOOck = parcelRequire("kOOck");

var $6o2lr = parcelRequire("6o2lr");


var $6plKN = parcelRequire("6plKN");

var $4Gk6P = parcelRequire("4Gk6P");

var $d6q8u = parcelRequire("d6q8u");

var $jtCFx = parcelRequire("jtCFx");

var $bmoVh = parcelRequire("bmoVh");

var $lhXgK = parcelRequire("lhXgK");
const $d5615f18e5cd04fc$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $d5615f18e5cd04fc$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $1En50.default)(options, $d5615f18e5cd04fc$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $cpmCj.default)(18));
    const palette = (0, $4Gk6P.default)(paletteInput);
    const systemTheme = (0, $6o2lr.default)(options);
    let muiTheme = (0, $3z1Ay.default)(systemTheme, {
        mixins: (0, $6plKN.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jtCFx.default).slice(),
        typography: (0, $d6q8u.default)(palette, typographyInput),
        transitions: (0, $bmoVh.default)(transitionsInput),
        zIndex: (0, $8nd05.default)({}, (0, $lhXgK.default))
    });
    muiTheme = (0, $3z1Ay.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $kOOck.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $d5615f18e5cd04fc$var$warnedOnce = false;
function $d5615f18e5cd04fc$export$c469355549431d9b(...args) {
    return $d5615f18e5cd04fc$var$createTheme(...args);
}
var $d5615f18e5cd04fc$export$2e2bcd8739ae039 = $d5615f18e5cd04fc$var$createTheme;

});
parcelRegister("6plKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa5f3b4975f3e4c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $4aa5f3b4975f3e4c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $8nd05.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("4Gk6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $368aaef25f6a2997$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $kSnzZ = parcelRequire("kSnzZ");

var $dzxhF = parcelRequire("dzxhF");

var $eU5ou = parcelRequire("eU5ou");

var $kSXRh = parcelRequire("kSXRh");

var $ln9F4 = parcelRequire("ln9F4");

var $dMYym = parcelRequire("dMYym");

var $bKnBV = parcelRequire("bKnBV");

var $iDVue = parcelRequire("iDVue");

var $e4nxq = parcelRequire("e4nxq");
const $368aaef25f6a2997$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $368aaef25f6a2997$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $dzxhF.default).white,
        default: (0, $dzxhF.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $368aaef25f6a2997$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $dzxhF.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $dzxhF.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $kSnzZ.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $kSnzZ.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bKnBV.default)[200],
        light: (0, $bKnBV.default)[50],
        dark: (0, $bKnBV.default)[400]
    };
    return {
        main: (0, $bKnBV.default)[700],
        light: (0, $bKnBV.default)[400],
        dark: (0, $bKnBV.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kSXRh.default)[200],
        light: (0, $kSXRh.default)[50],
        dark: (0, $kSXRh.default)[400]
    };
    return {
        main: (0, $kSXRh.default)[500],
        light: (0, $kSXRh.default)[300],
        dark: (0, $kSXRh.default)[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ln9F4.default)[500],
        light: (0, $ln9F4.default)[300],
        dark: (0, $ln9F4.default)[700]
    };
    return {
        main: (0, $ln9F4.default)[700],
        light: (0, $ln9F4.default)[400],
        dark: (0, $ln9F4.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $iDVue.default)[400],
        light: (0, $iDVue.default)[300],
        dark: (0, $iDVue.default)[700]
    };
    return {
        main: (0, $iDVue.default)[700],
        light: (0, $iDVue.default)[500],
        dark: (0, $iDVue.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e4nxq.default)[400],
        light: (0, $e4nxq.default)[300],
        dark: (0, $e4nxq.default)[700]
    };
    return {
        main: (0, $e4nxq.default)[800],
        light: (0, $e4nxq.default)[500],
        dark: (0, $e4nxq.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dMYym.default)[400],
        light: (0, $dMYym.default)[300],
        dark: (0, $dMYym.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $dMYym.default)[500],
        dark: (0, $dMYym.default)[900]
    };
}
function $368aaef25f6a2997$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $1En50.default)(palette, $368aaef25f6a2997$var$_excluded);
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kSnzZ.getContrastRatio)(background, $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary : $368aaef25f6a2997$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $8nd05.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $cpmCj.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $cpmCj.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $368aaef25f6a2997$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $368aaef25f6a2997$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $368aaef25f6a2997$export$55ce6f3a06c59543,
        light: $368aaef25f6a2997$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $3z1Ay.default)((0, $8nd05.default)({
        // A collection of common colors.
        common: (0, $8nd05.default)({}, (0, $dzxhF.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $eU5ou.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("kSnzZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $f32b24353f12f45a$var$alpha;
module.exports.blend = $f32b24353f12f45a$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $f32b24353f12f45a$var$darken;
module.exports.decomposeColor = $f32b24353f12f45a$var$decomposeColor;
module.exports.emphasize = $f32b24353f12f45a$var$emphasize;
module.exports.getContrastRatio = $f32b24353f12f45a$var$getContrastRatio;
module.exports.getLuminance = $f32b24353f12f45a$var$getLuminance;
module.exports.hexToRgb = $f32b24353f12f45a$var$hexToRgb;
module.exports.hslToRgb = $f32b24353f12f45a$var$hslToRgb;
module.exports.lighten = $f32b24353f12f45a$var$lighten;
module.exports.private_safeAlpha = $f32b24353f12f45a$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $f32b24353f12f45a$var$private_safeDarken;
module.exports.private_safeEmphasize = $f32b24353f12f45a$var$private_safeEmphasize;
module.exports.private_safeLighten = $f32b24353f12f45a$var$private_safeLighten;
module.exports.recomposeColor = $f32b24353f12f45a$var$recomposeColor;
module.exports.rgbToHex = $f32b24353f12f45a$var$rgbToHex;

var $f32b24353f12f45a$var$_formatMuiErrorMessage2 = $1jnue((parcelRequire("dsPLe")));

var $f32b24353f12f45a$var$_clamp = $1jnue((parcelRequire("lYE9x")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f32b24353f12f45a$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $f32b24353f12f45a$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $f32b24353f12f45a$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $f32b24353f12f45a$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $f32b24353f12f45a$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $f32b24353f12f45a$var$decomposeColor($f32b24353f12f45a$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $f32b24353f12f45a$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $f32b24353f12f45a$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $f32b24353f12f45a$var$colorChannel = (color)=>{
    const decomposedColor = $f32b24353f12f45a$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $f32b24353f12f45a$var$colorChannel;
const $f32b24353f12f45a$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $f32b24353f12f45a$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $f32b24353f12f45a$var$private_safeColorChannel;
function $f32b24353f12f45a$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $f32b24353f12f45a$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $f32b24353f12f45a$var$decomposeColor(color);
    return `#${values.map((n, i)=>$f32b24353f12f45a$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $f32b24353f12f45a$var$hslToRgb(color) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $f32b24353f12f45a$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $f32b24353f12f45a$var$getLuminance(color) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $f32b24353f12f45a$var$decomposeColor($f32b24353f12f45a$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $f32b24353f12f45a$var$getContrastRatio(foreground, background) {
    const lumA = $f32b24353f12f45a$var$getLuminance(foreground);
    const lumB = $f32b24353f12f45a$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$alpha(color, value) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    value = $f32b24353f12f45a$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeAlpha(color, value, warning) {
    try {
        return $f32b24353f12f45a$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$darken(color, coefficient) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    coefficient = $f32b24353f12f45a$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$lighten(color, coefficient) {
    color = $f32b24353f12f45a$var$decomposeColor(color);
    coefficient = $f32b24353f12f45a$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $f32b24353f12f45a$var$recomposeColor(color);
}
function $f32b24353f12f45a$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f32b24353f12f45a$var$emphasize(color, coefficient = 0.15) {
    return $f32b24353f12f45a$var$getLuminance(color) > 0.5 ? $f32b24353f12f45a$var$darken(color, coefficient) : $f32b24353f12f45a$var$lighten(color, coefficient);
}
function $f32b24353f12f45a$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $f32b24353f12f45a$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $f32b24353f12f45a$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $f32b24353f12f45a$var$decomposeColor(background);
    const overlayColor = $f32b24353f12f45a$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $f32b24353f12f45a$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("dzxhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e185cbbdd17e0f7$export$2e2bcd8739ae039);
const $9e185cbbdd17e0f7$var$common = {
    black: '#000',
    white: '#fff'
};
var $9e185cbbdd17e0f7$export$2e2bcd8739ae039 = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9a7ac9db04746c$export$2e2bcd8739ae039);
const $ad9a7ac9db04746c$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $ad9a7ac9db04746c$export$2e2bcd8739ae039 = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34748703626d0dc$export$2e2bcd8739ae039);
const $f34748703626d0dc$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f34748703626d0dc$export$2e2bcd8739ae039 = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f33d825c71610f$export$2e2bcd8739ae039);
const $f8f33d825c71610f$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $f8f33d825c71610f$export$2e2bcd8739ae039 = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09ebaae00c386da$export$2e2bcd8739ae039);
const $a09ebaae00c386da$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $a09ebaae00c386da$export$2e2bcd8739ae039 = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d64e288ac9a70b$export$2e2bcd8739ae039);
const $88d64e288ac9a70b$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $88d64e288ac9a70b$export$2e2bcd8739ae039 = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9287623794ffe70$export$2e2bcd8739ae039);
const $d9287623794ffe70$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $d9287623794ffe70$export$2e2bcd8739ae039 = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e3b29cd31a116f$export$2e2bcd8739ae039);
const $a3e3b29cd31a116f$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $a3e3b29cd31a116f$export$2e2bcd8739ae039 = $a3e3b29cd31a116f$var$green;

});


parcelRegister("d6q8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a01bf22de9dc59$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");
const $98a01bf22de9dc59$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $98a01bf22de9dc59$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $1En50.default)(_ref, $98a01bf22de9dc59$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $8nd05.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
            letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3z1Ay.default)((0, $8nd05.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2deb8a0bbe5ea21$export$2e2bcd8739ae039);
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    'none',
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$export$2e2bcd8739ae039 = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $845514f3678d3888$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $845514f3678d3888$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $845514f3678d3888$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $845514f3678d3888$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $845514f3678d3888$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $8nd05.default)({}, $845514f3678d3888$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $8nd05.default)({}, $845514f3678d3888$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $1En50.default)(options, $845514f3678d3888$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(',');
    };
    return (0, $8nd05.default)({
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("lhXgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9291b6f07cefb$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$export$2e2bcd8739ae039 = $f7f9291b6f07cefb$var$zIndex;

});



parcelRegister("4jPsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3250d9bb994a2d02$export$2e2bcd8739ae039);
var $3250d9bb994a2d02$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("8Uq77", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c7cf568a060c3d$export$2e2bcd8739ae039);

var $PJRTc = parcelRequire("PJRTc");
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes';
var $67c7cf568a060c3d$export$2e2bcd8739ae039 = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b8580029d7f562$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $09b8580029d7f562$export$2e2bcd8739ae039 = $09b8580029d7f562$var$slotShouldForwardProp;

});



parcelRegister("aiIP4", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $77fe5ab326d42cdb$export$c7c50641356bdfa5);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $77fe5ab326d42cdb$export$c7c50641356bdfa5(slot) {
    return (0, $4Cod0.default)('MuiSvgIcon', slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $beCSm.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $77fe5ab326d42cdb$export$2e2bcd8739ae039 = $77fe5ab326d42cdb$var$svgIconClasses;

});
parcelRegister("beCSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82df286c368a2a01$export$2e2bcd8739ae039);

var $4Cod0 = parcelRequire("4Cod0");
function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4Cod0.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("4Cod0", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cd7d64717698f7$export$2e2bcd8739ae039);

var $bnost = parcelRequire("bnost");
const $35cd7d64717698f7$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $35cd7d64717698f7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bnost.default).generate(componentName)}-${slot}`;
}
function $35cd7d64717698f7$export$34c0130b1f3e8ae3(slot) {
    return $35cd7d64717698f7$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("bnost", function(module, exports) {

$parcel$export(module.exports, "default", () => $8484d09248d25570$export$2e2bcd8739ae039);
const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;

});








var $ayMG0 = parcelRequire("ayMG0");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



var $ayMG0 = parcelRequire("ayMG0");
/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $722bc9eaf0c39f46$export$3d7865934588d77e = {
    INITIALIZE_START: "msal:initializeStart",
    INITIALIZE_END: "msal:initializeEnd",
    ACCOUNT_ADDED: "msal:accountAdded",
    ACCOUNT_REMOVED: "msal:accountRemoved",
    ACTIVE_ACCOUNT_CHANGED: "msal:activeAccountChanged",
    LOGIN_START: "msal:loginStart",
    LOGIN_SUCCESS: "msal:loginSuccess",
    LOGIN_FAILURE: "msal:loginFailure",
    ACQUIRE_TOKEN_START: "msal:acquireTokenStart",
    ACQUIRE_TOKEN_SUCCESS: "msal:acquireTokenSuccess",
    ACQUIRE_TOKEN_FAILURE: "msal:acquireTokenFailure",
    ACQUIRE_TOKEN_NETWORK_START: "msal:acquireTokenFromNetworkStart",
    SSO_SILENT_START: "msal:ssoSilentStart",
    SSO_SILENT_SUCCESS: "msal:ssoSilentSuccess",
    SSO_SILENT_FAILURE: "msal:ssoSilentFailure",
    ACQUIRE_TOKEN_BY_CODE_START: "msal:acquireTokenByCodeStart",
    ACQUIRE_TOKEN_BY_CODE_SUCCESS: "msal:acquireTokenByCodeSuccess",
    ACQUIRE_TOKEN_BY_CODE_FAILURE: "msal:acquireTokenByCodeFailure",
    HANDLE_REDIRECT_START: "msal:handleRedirectStart",
    HANDLE_REDIRECT_END: "msal:handleRedirectEnd",
    POPUP_OPENED: "msal:popupOpened",
    LOGOUT_START: "msal:logoutStart",
    LOGOUT_SUCCESS: "msal:logoutSuccess",
    LOGOUT_FAILURE: "msal:logoutFailure",
    LOGOUT_END: "msal:logoutEnd",
    RESTORE_FROM_BFCACHE: "msal:restoreFromBFCache"
};


/*! @azure/msal-react v2.2.0 2024-11-05 */ /*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $acw62 = parcelRequire("acw62");
/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $7c375ae106b964be$export$a002182e51710d39 = {
    LIBRARY_NAME: "MSAL.JS",
    SKU: "msal.js.common",
    // Prefix for all library cache entries
    CACHE_PREFIX: "msal",
    // default authority
    DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
    DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
    DEFAULT_COMMON_TENANT: "common",
    // ADFS String
    ADFS: "adfs",
    DSTS: "dstsv2",
    // Default AAD Instance Discovery Endpoint
    AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
    // CIAM URL
    CIAM_AUTH_URL: ".ciamlogin.com",
    AAD_TENANT_DOMAIN_SUFFIX: ".onmicrosoft.com",
    // Resource delimiter - used for certain cache entries
    RESOURCE_DELIM: "|",
    // Placeholder for non-existent account ids/objects
    NO_ACCOUNT: "NO_ACCOUNT",
    // Claims
    CLAIMS: "claims",
    // Consumer UTID
    CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
    // Default scopes
    OPENID_SCOPE: "openid",
    PROFILE_SCOPE: "profile",
    OFFLINE_ACCESS_SCOPE: "offline_access",
    EMAIL_SCOPE: "email",
    // Default response type for authorization code flow
    CODE_RESPONSE_TYPE: "code",
    CODE_GRANT_TYPE: "authorization_code",
    RT_GRANT_TYPE: "refresh_token",
    FRAGMENT_RESPONSE_MODE: "fragment",
    S256_CODE_CHALLENGE_METHOD: "S256",
    URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
    AUTHORIZATION_PENDING: "authorization_pending",
    NOT_DEFINED: "not_defined",
    EMPTY_STRING: "",
    NOT_APPLICABLE: "N/A",
    NOT_AVAILABLE: "Not Available",
    FORWARD_SLASH: "/",
    IMDS_ENDPOINT: "http://169.254.169.254/metadata/instance/compute/location",
    IMDS_VERSION: "2020-06-01",
    IMDS_TIMEOUT: 2000,
    AZURE_REGION_AUTO_DISCOVER_FLAG: "TryAutoDetect",
    REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX: "login.microsoft.com",
    KNOWN_PUBLIC_CLOUDS: [
        "login.microsoftonline.com",
        "login.windows.net",
        "login.microsoft.com",
        "sts.windows.net"
    ],
    TOKEN_RESPONSE_TYPE: "token",
    ID_TOKEN_RESPONSE_TYPE: "id_token",
    SHR_NONCE_VALIDITY: 240,
    INVALID_INSTANCE: "invalid_instance"
};
const $7c375ae106b964be$export$2b71909294c66558 = {
    SUCCESS: 200,
    SUCCESS_RANGE_START: 200,
    SUCCESS_RANGE_END: 299,
    REDIRECT: 302,
    CLIENT_ERROR: 400,
    CLIENT_ERROR_RANGE_START: 400,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    REQUEST_TIMEOUT: 408,
    TOO_MANY_REQUESTS: 429,
    CLIENT_ERROR_RANGE_END: 499,
    SERVER_ERROR: 500,
    SERVER_ERROR_RANGE_START: 500,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
    SERVER_ERROR_RANGE_END: 599,
    MULTI_SIDED_ERROR: 600
};
const $7c375ae106b964be$export$893b1b5b686d84ef = [
    $7c375ae106b964be$export$a002182e51710d39.OPENID_SCOPE,
    $7c375ae106b964be$export$a002182e51710d39.PROFILE_SCOPE,
    $7c375ae106b964be$export$a002182e51710d39.OFFLINE_ACCESS_SCOPE
];
const $7c375ae106b964be$export$268e88275f5afab2 = [
    ...$7c375ae106b964be$export$893b1b5b686d84ef,
    $7c375ae106b964be$export$a002182e51710d39.EMAIL_SCOPE
];
/**
 * Request header names
 */ const $7c375ae106b964be$export$28d77f87efed1d88 = {
    CONTENT_TYPE: "Content-Type",
    CONTENT_LENGTH: "Content-Length",
    RETRY_AFTER: "Retry-After",
    CCS_HEADER: "X-AnchorMailbox",
    WWWAuthenticate: "WWW-Authenticate",
    AuthenticationInfo: "Authentication-Info",
    X_MS_REQUEST_ID: "x-ms-request-id",
    X_MS_HTTP_VERSION: "x-ms-httpver"
};
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ const $7c375ae106b964be$export$81ab9ba9bd28255c = {
    ID_TOKEN: "idtoken",
    CLIENT_INFO: "client.info",
    ADAL_ID_TOKEN: "adal.idtoken",
    ERROR: "error",
    ERROR_DESC: "error.description",
    ACTIVE_ACCOUNT: "active-account",
    ACTIVE_ACCOUNT_FILTERS: "active-account-filters"
};
/**
 * String constants related to AAD Authority
 */ const $7c375ae106b964be$export$e18ac120172ed505 = {
    COMMON: "common",
    ORGANIZATIONS: "organizations",
    CONSUMERS: "consumers"
};
/**
 * Claims request keys
 */ const $7c375ae106b964be$export$c125cda26c71ef54 = {
    ACCESS_TOKEN: "access_token",
    XMS_CC: "xms_cc"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ const $7c375ae106b964be$export$49a06cbda5acaa5 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * allowed values for codeVerifier
 */ const $7c375ae106b964be$export$a1fe36237c1cc863 = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * allowed values for server response type
 */ const $7c375ae106b964be$export$b34cb6fbea2adc44 = {
    QUERY: "query",
    FRAGMENT: "fragment"
};
/**
 * allowed values for response_mode
 */ const $7c375ae106b964be$export$f990a5bae1260b8c = {
    ...$7c375ae106b964be$export$b34cb6fbea2adc44,
    FORM_POST: "form_post"
};
/**
 * allowed grant_type
 */ const $7c375ae106b964be$export$ce68f19b50b39c0b = {
    IMPLICIT_GRANT: "implicit",
    AUTHORIZATION_CODE_GRANT: "authorization_code",
    CLIENT_CREDENTIALS_GRANT: "client_credentials",
    RESOURCE_OWNER_PASSWORD_GRANT: "password",
    REFRESH_TOKEN_GRANT: "refresh_token",
    DEVICE_CODE_GRANT: "device_code",
    JWT_BEARER: "urn:ietf:params:oauth:grant-type:jwt-bearer"
};
/**
 * Account types in Cache
 */ const $7c375ae106b964be$export$23244fafa2e7f55c = {
    MSSTS_ACCOUNT_TYPE: "MSSTS",
    ADFS_ACCOUNT_TYPE: "ADFS",
    MSAV1_ACCOUNT_TYPE: "MSA",
    GENERIC_ACCOUNT_TYPE: "Generic"
};
/**
 * Separators used in cache
 */ const $7c375ae106b964be$export$520854da2ba5d734 = {
    CACHE_KEY_SEPARATOR: "-",
    CLIENT_INFO_SEPARATOR: "."
};
/**
 * Credential Type stored in the cache
 */ const $7c375ae106b964be$export$eca2dc7e6e608a68 = {
    ID_TOKEN: "IdToken",
    ACCESS_TOKEN: "AccessToken",
    ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
    REFRESH_TOKEN: "RefreshToken"
};
/**
 * Combine all cache types
 */ const $7c375ae106b964be$export$ba193b555633db78 = {
    ADFS: 1001,
    MSA: 1002,
    MSSTS: 1003,
    GENERIC: 1004,
    ACCESS_TOKEN: 2001,
    REFRESH_TOKEN: 2002,
    ID_TOKEN: 2003,
    APP_METADATA: 3001,
    UNDEFINED: 9999
};
/**
 * More Cache related constants
 */ const $7c375ae106b964be$export$7e1bea6dc1b6b32e = "appmetadata";
const $7c375ae106b964be$export$476989d62bcb4c85 = "client_info";
const $7c375ae106b964be$export$978fe7ab5e74b539 = "1";
const $7c375ae106b964be$export$d483f966e66f4db5 = {
    CACHE_KEY: "authority-metadata",
    REFRESH_TIME_SECONDS: 86400
};
const $7c375ae106b964be$export$5d365d77acfcb55d = {
    CONFIG: "config",
    CACHE: "cache",
    NETWORK: "network",
    HARDCODED_VALUES: "hardcoded_values"
};
const $7c375ae106b964be$export$30fa4ad28fb9feeb = {
    SCHEMA_VERSION: 5,
    MAX_CUR_HEADER_BYTES: 80,
    MAX_LAST_HEADER_BYTES: 330,
    MAX_CACHED_ERRORS: 50,
    CACHE_KEY: "server-telemetry",
    CATEGORY_SEPARATOR: "|",
    VALUE_SEPARATOR: ",",
    OVERFLOW_TRUE: "1",
    OVERFLOW_FALSE: "0",
    UNKNOWN_ERROR: "unknown_error"
};
/**
 * Type of the authentication request
 */ const $7c375ae106b964be$export$901491a717da2ba5 = {
    BEARER: "Bearer",
    POP: "pop",
    SSH: "ssh-cert"
};
/**
 * Constants related to throttling
 */ const $7c375ae106b964be$export$a2330d6808e6d893 = {
    // Default time to throttle RequestThumbprint in seconds
    DEFAULT_THROTTLE_TIME_SECONDS: 60,
    // Default maximum time to throttle in seconds, overrides what the server sends back
    DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
    // Prefix for storing throttling entries
    THROTTLING_PREFIX: "throttling",
    // Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
    X_MS_LIB_CAPABILITY_VALUE: "retry-after, h429"
};
const $7c375ae106b964be$export$b8e9cd941e8016ac = {
    INVALID_GRANT_ERROR: "invalid_grant",
    CLIENT_MISMATCH_ERROR: "client_mismatch"
};
/**
 * Password grant parameters
 */ const $7c375ae106b964be$export$fa8b29062cab1da = {
    username: "username",
    password: "password"
};
/**
 * Response codes
 */ const $7c375ae106b964be$export$20ba0879771a17be = {
    httpSuccess: 200,
    httpBadRequest: 400
};
/**
 * Region Discovery Sources
 */ const $7c375ae106b964be$export$3d4a3e11df589b40 = {
    FAILED_AUTO_DETECTION: "1",
    INTERNAL_CACHE: "2",
    ENVIRONMENT_VARIABLE: "3",
    IMDS: "4"
};
/**
 * Region Discovery Outcomes
 */ const $7c375ae106b964be$export$92a685f9218422bd = {
    CONFIGURED_MATCHES_DETECTED: "1",
    CONFIGURED_NO_AUTO_DETECTION: "2",
    CONFIGURED_NOT_DETECTED: "3",
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
    AUTO_DETECTION_REQUESTED_FAILED: "5"
};
/**
 * Specifies the reason for fetching the access token from the identity provider
 */ const $7c375ae106b964be$export$aa4af185ea049f6b = {
    // When a token is found in the cache or the cache is not supposed to be hit when making the request
    NOT_APPLICABLE: "0",
    // When the token request goes to the identity provider because force_refresh was set to true. Also occurs if claims were requested
    FORCE_REFRESH_OR_CLAIMS: "1",
    // When the token request goes to the identity provider because no cached access token exists
    NO_CACHED_ACCESS_TOKEN: "2",
    // When the token request goes to the identity provider because cached access token expired
    CACHED_ACCESS_TOKEN_EXPIRED: "3",
    // When the token request goes to the identity provider because refresh_in was used and the existing token needs to be refreshed
    PROACTIVELY_REFRESHED: "4"
};
const $7c375ae106b964be$export$fe5c42ed17efe603 = {
    Jwt: "JWT",
    Jwk: "JWK",
    Pop: "pop"
};
const $7c375ae106b964be$export$14c29d43b22a755f = 86400000;
// Token renewal offset default in seconds
const $7c375ae106b964be$export$8d50f42618161d1a = 300;


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ const $5ff55562d73e0e2b$export$a0a689e4294b9880 = {
    /**
     * Interaction in progress cache value
     */ INTERACTION_IN_PROGRESS_VALUE: "interaction_in_progress",
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Default popup monitor poll interval in milliseconds
     */ DEFAULT_POLL_INTERVAL_MS: 30,
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
const $5ff55562d73e0e2b$export$fec113838800867f = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS"
};
const $5ff55562d73e0e2b$export$3536098be6c7dadb = {
    HandshakeRequest: "Handshake",
    HandshakeResponse: "HandshakeResponse",
    GetToken: "GetToken",
    Response: "Response"
};
const $5ff55562d73e0e2b$export$573384e47a12d835 = {
    LocalStorage: "localStorage",
    SessionStorage: "sessionStorage",
    MemoryStorage: "memoryStorage"
};
/**
 * HTTP Request types supported by MSAL.
 */ const $5ff55562d73e0e2b$export$c774c31b4c31da8 = {
    GET: "GET",
    POST: "POST"
};
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ const $5ff55562d73e0e2b$export$21d55bedf0d269fb = {
    AUTHORITY: "authority",
    ACQUIRE_TOKEN_ACCOUNT: "acquireToken.account",
    SESSION_STATE: "session.state",
    REQUEST_STATE: "request.state",
    NONCE_IDTOKEN: "nonce.id_token",
    ORIGIN_URI: "request.origin",
    RENEW_STATUS: "token.renew.status",
    URL_HASH: "urlHash",
    REQUEST_PARAMS: "request.params",
    SCOPES: "scopes",
    INTERACTION_STATUS_KEY: "interaction.status",
    CCS_CREDENTIAL: "ccs.credential",
    CORRELATION_ID: "request.correlationId",
    NATIVE_REQUEST: "request.native",
    REDIRECT_CONTEXT: "request.redirect.context"
};
const $5ff55562d73e0e2b$export$f6ce23cce692699f = {
    ACCOUNT_KEYS: "msal.account.keys",
    TOKEN_KEYS: "msal.token.keys",
    VERSION: "msal.version"
};
/**
 * Cache keys stored in-memory
 */ const $5ff55562d73e0e2b$export$8f546f90896bcfa9 = {
    WRAPPER_SKU: "wrapper.sku",
    WRAPPER_VER: "wrapper.version"
};
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 */ const $5ff55562d73e0e2b$export$192d74ad69b40705 = {
    acquireTokenRedirect: 861,
    acquireTokenPopup: 862,
    ssoSilent: 863,
    acquireTokenSilent_authCode: 864,
    handleRedirectPromise: 865,
    acquireTokenByCode: 866,
    acquireTokenSilent_silentFlow: 61,
    logout: 961,
    logoutPopup: 962
};
/*
 * Interaction type of the API - used for state and telemetry
 */ var $5ff55562d73e0e2b$export$4ec29255e7e7f68f;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})($5ff55562d73e0e2b$export$4ec29255e7e7f68f || ($5ff55562d73e0e2b$export$4ec29255e7e7f68f = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ const $5ff55562d73e0e2b$export$bec20eda0179362b = {
    /**
     * Initial status before interaction occurs
     */ Startup: "startup",
    /**
     * Status set when all login calls occuring
     */ Login: "login",
    /**
     * Status set when logout call occuring
     */ Logout: "logout",
    /**
     * Status set for acquireToken calls
     */ AcquireToken: "acquireToken",
    /**
     * Status set for ssoSilent calls
     */ SsoSilent: "ssoSilent",
    /**
     * Status set when handleRedirect in progress
     */ HandleRedirect: "handleRedirect",
    /**
     * Status set when interaction is complete
     */ None: "none"
};
const $5ff55562d73e0e2b$export$7e12949cd6884193 = {
    scopes: (0, $7c375ae106b964be$export$893b1b5b686d84ef)
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ const $5ff55562d73e0e2b$export$1294c3e3f84694cd = "jwk";
// Supported wrapper SKUs
const $5ff55562d73e0e2b$export$8abb9de997bb4e44 = {
    React: "@azure/msal-react",
    Angular: "@azure/msal-angular"
};
// DatabaseStorage Constants
const $5ff55562d73e0e2b$export$3c22ff8b64b8f565 = "msal.db";
const $5ff55562d73e0e2b$export$6a9022b4c5fcea02 = 1;
const $5ff55562d73e0e2b$export$9d785db034fb436f = `${$5ff55562d73e0e2b$export$3c22ff8b64b8f565}.keys`;
const $5ff55562d73e0e2b$export$4394baa7e922d42d = {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ Default: 0,
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ AccessToken: 1,
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ AccessTokenAndRefreshToken: 2,
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ RefreshToken: 3,
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ RefreshTokenAndNetwork: 4,
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ Skip: 5
};
const $5ff55562d73e0e2b$export$736180706fb122ee = [
    $5ff55562d73e0e2b$export$4394baa7e922d42d.Default,
    $5ff55562d73e0e2b$export$4394baa7e922d42d.Skip,
    $5ff55562d73e0e2b$export$4394baa7e922d42d.RefreshTokenAndNetwork
];
const $5ff55562d73e0e2b$export$b28668d53eb57e63 = "msal.browser.log.level";
const $5ff55562d73e0e2b$export$d9bc1c202a3825f1 = "msal.browser.log.pii";
const $5ff55562d73e0e2b$export$54408f0b0cf727d4 = "msal.browser.performance.enabled";

/*! @azure/msal-common v14.16.1 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var $0bf1d54ef751a29c$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})($0bf1d54ef751a29c$export$243e62d78d3b544d || ($0bf1d54ef751a29c$export$243e62d78d3b544d = {}));
/**
 * Class which facilitates logging of messages to a specific place.
 */ class $0bf1d54ef751a29c$export$efa9a398d6368992 {
    constructor(loggerOptions, packageName, packageVersion){
        // Current log level, defaults to info.
        this.level = $0bf1d54ef751a29c$export$243e62d78d3b544d.Info;
        const defaultLoggerCallback = ()=>{
            return;
        };
        const setLoggerOptions = loggerOptions || $0bf1d54ef751a29c$export$efa9a398d6368992.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : $0bf1d54ef751a29c$export$243e62d78d3b544d.Info;
        this.correlationId = setLoggerOptions.correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.packageName = packageName || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.packageVersion = packageVersion || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
    }
    static createDefaultLoggerOptions() {
        return {
            loggerCallback: ()=>{
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Info
        };
    }
    /**
     * Create new Logger with existing configurations.
     */ clone(packageName, packageVersion, correlationId) {
        return new $0bf1d54ef751a29c$export$efa9a398d6368992({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level,
            correlationId: correlationId || this.correlationId
        }, packageName, packageVersion);
    }
    /**
     * Log message with required options.
     */ logMessage(logMessage, options) {
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        const timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        const logHeader = `[${timestamp}] : [${options.correlationId || this.correlationId || ""}]`;
        const log = `${logHeader} : ${this.packageName}@${this.packageVersion} : ${$0bf1d54ef751a29c$export$243e62d78d3b544d[options.logLevel]} - ${logMessage}`;
        // debug(`msal:${LogLevel[options.logLevel]}${options.containsPii ? "-Pii": Constants.EMPTY_STRING}${options.context ? `:${options.context}` : Constants.EMPTY_STRING}`)(logMessage);
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    }
    /**
     * Execute callback with message.
     */ executeCallback(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    }
    /**
     * Logs error messages.
     */ error(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Error,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs error messages with PII.
     */ errorPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Error,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages.
     */ warning(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Warning,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages with PII.
     */ warningPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Warning,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages.
     */ info(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Info,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages with PII.
     */ infoPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Info,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages.
     */ verbose(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Verbose,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages with PII.
     */ verbosePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Verbose,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages.
     */ trace(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Trace,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages with PII.
     */ tracePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Trace,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Returns whether PII Logging is enabled or not.
     */ isPiiLoggingEnabled() {
        return this.piiLoggingEnabled || false;
    }
}

/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 
var $1a08d0bb87f43eeb$exports = {};

$parcel$export($1a08d0bb87f43eeb$exports, "unexpectedError", () => $1a08d0bb87f43eeb$export$efbc88c27b0be04);
$parcel$export($1a08d0bb87f43eeb$exports, "postRequestFailed", () => $1a08d0bb87f43eeb$export$7a1e28a7b60ca602);
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ const $1a08d0bb87f43eeb$export$efbc88c27b0be04 = "unexpected_error";
const $1a08d0bb87f43eeb$export$7a1e28a7b60ca602 = "post_request_failed";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $0ff8310393c4d2db$export$cd5f04206718d3a5 = {
    [(0, $1a08d0bb87f43eeb$export$efbc88c27b0be04)]: "Unexpected error in authentication.",
    [(0, $1a08d0bb87f43eeb$export$7a1e28a7b60ca602)]: "Post request failed from the network, could be a 4xx/5xx or a network unavailability. Please check the exact error code for details."
};
/**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use AuthErrorCodes instead
 */ const $0ff8310393c4d2db$export$930cbd4733f218f0 = {
    unexpectedError: {
        code: (0, $1a08d0bb87f43eeb$export$efbc88c27b0be04),
        desc: $0ff8310393c4d2db$export$cd5f04206718d3a5[0, $1a08d0bb87f43eeb$export$efbc88c27b0be04]
    },
    postRequestFailed: {
        code: (0, $1a08d0bb87f43eeb$export$7a1e28a7b60ca602),
        desc: $0ff8310393c4d2db$export$cd5f04206718d3a5[0, $1a08d0bb87f43eeb$export$7a1e28a7b60ca602]
    }
};
/**
 * General error class thrown by the MSAL.js library.
 */ class $0ff8310393c4d2db$export$145273558d58e0ac extends Error {
    constructor(errorCode, errorMessage, suberror){
        const errorString = errorMessage ? `${errorCode}: ${errorMessage}` : errorCode;
        super(errorString);
        Object.setPrototypeOf(this, $0ff8310393c4d2db$export$145273558d58e0ac.prototype);
        this.errorCode = errorCode || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.errorMessage = errorMessage || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.subError = suberror || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.name = "AuthError";
    }
    setCorrelationId(correlationId) {
        this.correlationId = correlationId;
    }
}
function $0ff8310393c4d2db$export$eb157f7636c79bd2(code, additionalMessage) {
    return new $0ff8310393c4d2db$export$145273558d58e0ac(code, additionalMessage ? `${$0ff8310393c4d2db$export$cd5f04206718d3a5[code]} ${additionalMessage}` : $0ff8310393c4d2db$export$cd5f04206718d3a5[code]);
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $b7c9daf3e548a083$export$41d7a3d4e14d6113 = "storage_not_supported";
const $b7c9daf3e548a083$export$1377ea690fa0b6d8 = "stubbed_public_client_application_called";
const $b7c9daf3e548a083$export$37486e3b6bed61c6 = "in_mem_redirect_unavailable";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d12a658e6d92d79e$export$a14089932466e176 = {
    [(0, $b7c9daf3e548a083$export$41d7a3d4e14d6113)]: "Given storage configuration option was not supported.",
    [(0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)]: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors",
    [(0, $b7c9daf3e548a083$export$37486e3b6bed61c6)]: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use BrowserAuthErrorCodes instead
 */ const $d12a658e6d92d79e$export$daccd9364f884077 = {
    storageNotSupportedError: {
        code: (0, $b7c9daf3e548a083$export$41d7a3d4e14d6113),
        desc: $d12a658e6d92d79e$export$a14089932466e176[0, $b7c9daf3e548a083$export$41d7a3d4e14d6113]
    },
    stubPcaInstanceCalled: {
        code: (0, $b7c9daf3e548a083$export$1377ea690fa0b6d8),
        desc: $d12a658e6d92d79e$export$a14089932466e176[0, $b7c9daf3e548a083$export$1377ea690fa0b6d8]
    },
    inMemRedirectUnavailable: {
        code: (0, $b7c9daf3e548a083$export$37486e3b6bed61c6),
        desc: $d12a658e6d92d79e$export$a14089932466e176[0, $b7c9daf3e548a083$export$37486e3b6bed61c6]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $d12a658e6d92d79e$export$2eb7a1dfdc4c5fba extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(this, $d12a658e6d92d79e$export$2eb7a1dfdc4c5fba.prototype);
    }
}
function $d12a658e6d92d79e$export$176bd5050947ba0c(errorCode) {
    return new $d12a658e6d92d79e$export$2eb7a1dfdc4c5fba(errorCode, $d12a658e6d92d79e$export$a14089932466e176[errorCode]);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d2a81b67c35e82cb$export$29650b96fd06034a = {
    initialize: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    acquireTokenPopup: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    acquireTokenRedirect: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    acquireTokenSilent: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    acquireTokenByCode: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    getAllAccounts: ()=>{
        return [];
    },
    getAccount: ()=>{
        return null;
    },
    getAccountByHomeId: ()=>{
        return null;
    },
    getAccountByUsername: ()=>{
        return null;
    },
    getAccountByLocalId: ()=>{
        return null;
    },
    handleRedirectPromise: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    loginPopup: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    loginRedirect: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    logout: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    logoutRedirect: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    logoutPopup: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    ssoSilent: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    addEventCallback: ()=>{
        return null;
    },
    removeEventCallback: ()=>{
        return;
    },
    addPerformanceCallback: ()=>{
        return "";
    },
    removePerformanceCallback: ()=>{
        return false;
    },
    enableAccountStorageEvents: ()=>{
        return;
    },
    disableAccountStorageEvents: ()=>{
        return;
    },
    getTokenCache: ()=>{
        throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8));
    },
    getLogger: ()=>{
        throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8));
    },
    setLogger: ()=>{
        return;
    },
    setActiveAccount: ()=>{
        return;
    },
    getActiveAccount: ()=>{
        return null;
    },
    initializeWrapperLibrary: ()=>{
        return;
    },
    setNavigationClient: ()=>{
        return;
    },
    getConfiguration: ()=>{
        throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8));
    },
    hydrateCache: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    clearCache: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    }
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*
 * Stubbed context implementation
 * Only used when there is no provider, which is an unsupported scenario
 */ const $1dc604eb300e1131$var$defaultMsalContext = {
    instance: (0, $d2a81b67c35e82cb$export$29650b96fd06034a),
    inProgress: (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None,
    accounts: [],
    logger: new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)({})
};
const $1dc604eb300e1131$export$66324aeea97dd1e5 = $acw62.createContext($1dc604eb300e1131$var$defaultMsalContext);
const $1dc604eb300e1131$export$b74154d0810e24c1 = $1dc604eb300e1131$export$66324aeea97dd1e5.Consumer;


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $acw62 = parcelRequire("acw62");
/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $c309956643209ca0$export$ba9166e03da6599c {
    /**
     * Gets interaction status from event message
     * @param message
     * @param currentStatus
     */ static getInteractionStatusFromEvent(message, currentStatus) {
        switch(message.eventType){
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_START:
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Login;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_START:
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).SsoSilent;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START:
                if (message.interactionType === (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup) return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).AcquireToken;
                break;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_START:
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).HandleRedirect;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_START:
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Logout;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_SUCCESS:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_FAILURE:
                if (currentStatus && currentStatus !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).SsoSilent) break;
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END:
                if (currentStatus && currentStatus !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Logout) break;
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_END:
                if (currentStatus && currentStatus !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).HandleRedirect) break;
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).RESTORE_FROM_BFCACHE:
                if (message.interactionType === (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup) {
                    if (currentStatus && currentStatus !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Login && currentStatus !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).AcquireToken) break;
                    return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
                }
                break;
        }
        return null;
    }
}



/*! @azure/msal-react v2.2.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $1f6f413f87363628$export$7a39d5906c5d6010(children, args) {
    if (typeof children === "function") return children(args);
    return children;
}
/**
 * Helper function to determine whether 2 arrays are equal
 * Used to avoid unnecessary state updates
 * @param arrayA
 * @param arrayB
 */ function $1f6f413f87363628$export$601fd69958c01c8c(arrayA, arrayB) {
    if (arrayA.length !== arrayB.length) return false;
    const comparisonArray = [
        ...arrayB
    ];
    return arrayA.every((elementA)=>{
        const elementB = comparisonArray.shift();
        if (!elementA || !elementB) return false;
        return elementA.homeAccountId === elementB.homeAccountId && elementA.localAccountId === elementB.localAccountId && elementA.username === elementB.username;
    });
}
function $1f6f413f87363628$export$fa581286d49c51db(allAccounts, accountIdentifiers) {
    if (allAccounts.length > 0 && (accountIdentifiers.homeAccountId || accountIdentifiers.localAccountId || accountIdentifiers.username)) {
        const matchedAccounts = allAccounts.filter((accountObj)=>{
            if (accountIdentifiers.username && accountIdentifiers.username.toLowerCase() !== accountObj.username.toLowerCase()) return false;
            if (accountIdentifiers.homeAccountId && accountIdentifiers.homeAccountId.toLowerCase() !== accountObj.homeAccountId.toLowerCase()) return false;
            if (accountIdentifiers.localAccountId && accountIdentifiers.localAccountId.toLowerCase() !== accountObj.localAccountId.toLowerCase()) return false;
            return true;
        });
        return matchedAccounts[0] || null;
    } else return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 'use strict';
/* eslint-disable header/header */ const $31c121d5e6ab4e5f$export$a8ff84c12d48cfa6 = "@azure/msal-react";
const $31c121d5e6ab4e5f$export$83d89fbfd8236492 = "2.2.0";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $7b3e52a40af96eae$var$MsalProviderActionType = {
    UNBLOCK_INPROGRESS: "UNBLOCK_INPROGRESS",
    EVENT: "EVENT"
};
/**
 * Returns the next inProgress and accounts state based on event message
 * @param previousState
 * @param action
 */ const $7b3e52a40af96eae$var$reducer = (previousState, action)=>{
    const { type: type, payload: payload } = action;
    let newInProgress = previousState.inProgress;
    switch(type){
        case $7b3e52a40af96eae$var$MsalProviderActionType.UNBLOCK_INPROGRESS:
            if (previousState.inProgress === (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup) {
                newInProgress = (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
                payload.logger.info("MsalProvider - handleRedirectPromise resolved, setting inProgress to 'none'");
            }
            break;
        case $7b3e52a40af96eae$var$MsalProviderActionType.EVENT:
            const message = payload.message;
            const status = (0, $c309956643209ca0$export$ba9166e03da6599c).getInteractionStatusFromEvent(message, previousState.inProgress);
            if (status) {
                payload.logger.info(`MsalProvider - ${message.eventType} results in setting inProgress from ${previousState.inProgress} to ${status}`);
                newInProgress = status;
            }
            break;
        default:
            throw new Error(`Unknown action type: ${type}`);
    }
    const currentAccounts = payload.instance.getAllAccounts();
    if (newInProgress !== previousState.inProgress && !(0, $1f6f413f87363628$export$601fd69958c01c8c)(currentAccounts, previousState.accounts)) // Both inProgress and accounts changed
    return {
        ...previousState,
        inProgress: newInProgress,
        accounts: currentAccounts
    };
    else if (newInProgress !== previousState.inProgress) // Only only inProgress changed
    return {
        ...previousState,
        inProgress: newInProgress
    };
    else if (!(0, $1f6f413f87363628$export$601fd69958c01c8c)(currentAccounts, previousState.accounts)) // Only accounts changed
    return {
        ...previousState,
        accounts: currentAccounts
    };
    else // Nothing changed
    return previousState;
};
/**
 * MSAL context provider component. This must be rendered above any other components that use MSAL.
 */ function $7b3e52a40af96eae$export$25bac41dc3d78d47({ instance: instance, children: children }) {
    (0, $acw62.useEffect)(()=>{
        instance.initializeWrapperLibrary((0, $5ff55562d73e0e2b$export$8abb9de997bb4e44).React, (0, $31c121d5e6ab4e5f$export$83d89fbfd8236492));
    }, [
        instance
    ]);
    // Create a logger instance for msal-react with the same options as PublicClientApplication
    const logger = (0, $acw62.useMemo)(()=>{
        return instance.getLogger().clone((0, $31c121d5e6ab4e5f$export$a8ff84c12d48cfa6), (0, $31c121d5e6ab4e5f$export$83d89fbfd8236492));
    }, [
        instance
    ]);
    const [state, updateState] = (0, $acw62.useReducer)($7b3e52a40af96eae$var$reducer, undefined, ()=>{
        // Lazy initialization of the initial state
        return {
            inProgress: (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup,
            accounts: instance.getAllAccounts()
        };
    });
    (0, $acw62.useEffect)(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            updateState({
                payload: {
                    instance: instance,
                    logger: logger,
                    message: message
                },
                type: $7b3e52a40af96eae$var$MsalProviderActionType.EVENT
            });
        });
        logger.verbose(`MsalProvider - Registered event callback with id: ${callbackId}`);
        instance.initialize().then(()=>{
            instance.handleRedirectPromise().catch(()=>{
                // Errors should be handled by listening to the LOGIN_FAILURE event
                return;
            }).finally(()=>{
                /*
                 * If handleRedirectPromise returns a cached promise the necessary events may not be fired
                 * This is a fallback to prevent inProgress from getting stuck in 'startup'
                 */ updateState({
                    payload: {
                        instance: instance,
                        logger: logger
                    },
                    type: $7b3e52a40af96eae$var$MsalProviderActionType.UNBLOCK_INPROGRESS
                });
            });
        }).catch(()=>{
            // Errors should be handled by listening to the LOGIN_FAILURE event
            return;
        });
        return ()=>{
            // Remove callback when component unmounts or accounts change
            if (callbackId) {
                logger.verbose(`MsalProvider - Removing event callback ${callbackId}`);
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    const contextValue = {
        instance: instance,
        inProgress: state.inProgress,
        accounts: state.accounts,
        logger: logger
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dc604eb300e1131$export$66324aeea97dd1e5).Provider, {
        value: contextValue
    }, children);
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $acw62 = parcelRequire("acw62");

/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $acw62 = parcelRequire("acw62");

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns Msal Context values
 */ const $5ae49243d6498b42$export$f41558044a1dd55 = ()=>(0, $acw62.useContext)((0, $1dc604eb300e1131$export$66324aeea97dd1e5));


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $acw62 = parcelRequire("acw62");



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $41a0d322aea9de82$var$isAuthenticated(allAccounts, matchAccount) {
    if (matchAccount && (matchAccount.username || matchAccount.homeAccountId || matchAccount.localAccountId)) return !!(0, $1f6f413f87363628$export$fa581286d49c51db)(allAccounts, matchAccount);
    return allAccounts.length > 0;
}
/**
 * Returns whether or not a user is currently signed-in. Optionally provide 1 or more accountIdentifiers to determine if a specific user is signed-in
 * @param matchAccount
 */ function $41a0d322aea9de82$export$7e9c60d6d1836c84(matchAccount) {
    const { accounts: allAccounts, inProgress: inProgress } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const isUserAuthenticated = (0, $acw62.useMemo)(()=>{
        if (inProgress === (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup) return false;
        return $41a0d322aea9de82$var$isAuthenticated(allAccounts, matchAccount);
    }, [
        allAccounts,
        inProgress,
        matchAccount
    ]);
    return isUserAuthenticated;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is authenticated
 * @param props
 */ function $89a512f94435fcda$export$3f7734c901feade6({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const accountIdentifier = (0, $acw62.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = (0, $41a0d322aea9de82$export$7e9c60d6d1836c84)(accountIdentifier);
    if (isAuthenticated && context.inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $1f6f413f87363628$export$7a39d5906c5d6010)(children, context));
    return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $acw62 = parcelRequire("acw62");




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is unauthenticated
 * @param props
 */ function $f0c0868d77661165$export$8285a35799c5812b({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const accountIdentifier = (0, $acw62.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = (0, $41a0d322aea9de82$export$7e9c60d6d1836c84)(accountIdentifier);
    if (!isAuthenticated && context.inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup && context.inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).HandleRedirect) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $1f6f413f87363628$export$7a39d5906c5d6010)(children, context));
    return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $acw62 = parcelRequire("acw62");


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $acw62 = parcelRequire("acw62");
/*! @azure/msal-common v14.16.1 2025-08-05 */ 

var $84767569d86b0bc0$exports = {};

$parcel$export($84767569d86b0bc0$exports, "noTokensFound", () => $84767569d86b0bc0$export$e408b083cd212696);
$parcel$export($84767569d86b0bc0$exports, "nativeAccountUnavailable", () => $84767569d86b0bc0$export$3bf2eb3358f5f570);
$parcel$export($84767569d86b0bc0$exports, "refreshTokenExpired", () => $84767569d86b0bc0$export$a90e8b9c10991b49);
$parcel$export($84767569d86b0bc0$exports, "interactionRequired", () => $84767569d86b0bc0$export$cdb77bf88e749c31);
$parcel$export($84767569d86b0bc0$exports, "consentRequired", () => $84767569d86b0bc0$export$ca4e8d96d12fe4c5);
$parcel$export($84767569d86b0bc0$exports, "loginRequired", () => $84767569d86b0bc0$export$402ebc0f96d7decb);
$parcel$export($84767569d86b0bc0$exports, "badToken", () => $84767569d86b0bc0$export$2e3666c77d45a4da);
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Codes defined by MSAL
const $84767569d86b0bc0$export$e408b083cd212696 = "no_tokens_found";
const $84767569d86b0bc0$export$3bf2eb3358f5f570 = "native_account_unavailable";
const $84767569d86b0bc0$export$a90e8b9c10991b49 = "refresh_token_expired";
// Codes potentially returned by server
const $84767569d86b0bc0$export$cdb77bf88e749c31 = "interaction_required";
const $84767569d86b0bc0$export$ca4e8d96d12fe4c5 = "consent_required";
const $84767569d86b0bc0$export$402ebc0f96d7decb = "login_required";
const $84767569d86b0bc0$export$2e3666c77d45a4da = "bad_token";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ const $18a94acc3dad87ad$export$e16d6a6c677acec5 = [
    (0, $84767569d86b0bc0$export$cdb77bf88e749c31),
    (0, $84767569d86b0bc0$export$ca4e8d96d12fe4c5),
    (0, $84767569d86b0bc0$export$402ebc0f96d7decb),
    (0, $84767569d86b0bc0$export$2e3666c77d45a4da)
];
const $18a94acc3dad87ad$export$9689959ec6716811 = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required",
    "bad_token"
];
const $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages = {
    [(0, $84767569d86b0bc0$export$e408b083cd212696)]: "No refresh token found in the cache. Please sign-in.",
    [(0, $84767569d86b0bc0$export$3bf2eb3358f5f570)]: "The requested account is not available in the native broker. It may have been deleted or logged out. Please sign-in again using an interactive API.",
    [(0, $84767569d86b0bc0$export$a90e8b9c10991b49)]: "Refresh token has expired.",
    [(0, $84767569d86b0bc0$export$2e3666c77d45a4da)]: "Identity provider returned bad_token due to an expired or invalid refresh token. Please invoke an interactive API to resolve."
};
/**
 * Interaction required errors defined by the SDK
 * @deprecated Use InteractionRequiredAuthErrorCodes instead
 */ const $18a94acc3dad87ad$export$d44d3b7b7a580eb6 = {
    noTokensFoundError: {
        code: (0, $84767569d86b0bc0$export$e408b083cd212696),
        desc: $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[0, $84767569d86b0bc0$export$e408b083cd212696]
    },
    native_account_unavailable: {
        code: (0, $84767569d86b0bc0$export$3bf2eb3358f5f570),
        desc: $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[0, $84767569d86b0bc0$export$3bf2eb3358f5f570]
    },
    bad_token: {
        code: (0, $84767569d86b0bc0$export$2e3666c77d45a4da),
        desc: $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[0, $84767569d86b0bc0$export$2e3666c77d45a4da]
    }
};
/**
 * Error thrown when user interaction is required.
 */ class $18a94acc3dad87ad$export$6ba3e818c6bc76ba extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, timestamp, traceId, correlationId, claims, errorNo){
        super(errorCode, errorMessage, subError);
        Object.setPrototypeOf(this, $18a94acc3dad87ad$export$6ba3e818c6bc76ba.prototype);
        this.timestamp = timestamp || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.traceId = traceId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.correlationId = correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.claims = claims || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.name = "InteractionRequiredAuthError";
        this.errorNo = errorNo;
    }
}
/**
 * Helper function used to determine if an error thrown by the server requires interaction to resolve
 * @param errorCode
 * @param errorString
 * @param subError
 */ function $18a94acc3dad87ad$export$376c3c4c19cb933a(errorCode, errorString, subError) {
    const isInteractionRequiredErrorCode = !!errorCode && $18a94acc3dad87ad$export$e16d6a6c677acec5.indexOf(errorCode) > -1;
    const isInteractionRequiredSubError = !!subError && $18a94acc3dad87ad$export$9689959ec6716811.indexOf(subError) > -1;
    const isInteractionRequiredErrorDesc = !!errorString && $18a94acc3dad87ad$export$e16d6a6c677acec5.some((irErrorCode)=>{
        return errorString.indexOf(irErrorCode) > -1;
    });
    return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
}
/**
 * Creates an InteractionRequiredAuthError
 */ function $18a94acc3dad87ad$export$8f7a741750c16535(errorCode) {
    return new $18a94acc3dad87ad$export$6ba3e818c6bc76ba(errorCode, $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[errorCode]);
}




/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $acw62 = parcelRequire("acw62");
/*! @azure/msal-common v14.16.1 2025-08-05 */ 
/*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 
var $6be88bbe69356b76$exports = {};

$parcel$export($6be88bbe69356b76$exports, "clientInfoDecodingError", () => $6be88bbe69356b76$export$ccdf48c387c47b82);
$parcel$export($6be88bbe69356b76$exports, "clientInfoEmptyError", () => $6be88bbe69356b76$export$12315251e24e0181);
$parcel$export($6be88bbe69356b76$exports, "tokenParsingError", () => $6be88bbe69356b76$export$ad362b2e3a260143);
$parcel$export($6be88bbe69356b76$exports, "nullOrEmptyToken", () => $6be88bbe69356b76$export$78d01e29cb494be2);
$parcel$export($6be88bbe69356b76$exports, "endpointResolutionError", () => $6be88bbe69356b76$export$c9fcc93738cc2bc3);
$parcel$export($6be88bbe69356b76$exports, "networkError", () => $6be88bbe69356b76$export$4358cbadf08aa73);
$parcel$export($6be88bbe69356b76$exports, "openIdConfigError", () => $6be88bbe69356b76$export$73566da29bc073eb);
$parcel$export($6be88bbe69356b76$exports, "hashNotDeserialized", () => $6be88bbe69356b76$export$14c4d54a8414667f);
$parcel$export($6be88bbe69356b76$exports, "invalidState", () => $6be88bbe69356b76$export$72a77317632c052b);
$parcel$export($6be88bbe69356b76$exports, "stateMismatch", () => $6be88bbe69356b76$export$6a56d8f882843cd8);
$parcel$export($6be88bbe69356b76$exports, "stateNotFound", () => $6be88bbe69356b76$export$ef9214cfa5960fc);
$parcel$export($6be88bbe69356b76$exports, "nonceMismatch", () => $6be88bbe69356b76$export$edd0491c2c280be7);
$parcel$export($6be88bbe69356b76$exports, "authTimeNotFound", () => $6be88bbe69356b76$export$43356944266c945e);
$parcel$export($6be88bbe69356b76$exports, "maxAgeTranspired", () => $6be88bbe69356b76$export$f95fb86904f89749);
$parcel$export($6be88bbe69356b76$exports, "multipleMatchingTokens", () => $6be88bbe69356b76$export$47c50a2451614107);
$parcel$export($6be88bbe69356b76$exports, "multipleMatchingAccounts", () => $6be88bbe69356b76$export$2804a8b1b4c3be8b);
$parcel$export($6be88bbe69356b76$exports, "multipleMatchingAppMetadata", () => $6be88bbe69356b76$export$575bb2924bcd0084);
$parcel$export($6be88bbe69356b76$exports, "requestCannotBeMade", () => $6be88bbe69356b76$export$4ac9fb1f531eded7);
$parcel$export($6be88bbe69356b76$exports, "cannotRemoveEmptyScope", () => $6be88bbe69356b76$export$f7a276c01beb068a);
$parcel$export($6be88bbe69356b76$exports, "cannotAppendScopeSet", () => $6be88bbe69356b76$export$93883786cf4a4a27);
$parcel$export($6be88bbe69356b76$exports, "emptyInputScopeSet", () => $6be88bbe69356b76$export$41e2ce5958c42c83);
$parcel$export($6be88bbe69356b76$exports, "deviceCodePollingCancelled", () => $6be88bbe69356b76$export$e3af42f9856ab2a);
$parcel$export($6be88bbe69356b76$exports, "deviceCodeExpired", () => $6be88bbe69356b76$export$c0ef55deeb5e30d5);
$parcel$export($6be88bbe69356b76$exports, "deviceCodeUnknownError", () => $6be88bbe69356b76$export$4a9e9cce395ba70c);
$parcel$export($6be88bbe69356b76$exports, "noAccountInSilentRequest", () => $6be88bbe69356b76$export$5a3c7d1c90ac9220);
$parcel$export($6be88bbe69356b76$exports, "invalidCacheRecord", () => $6be88bbe69356b76$export$d396103576f879cc);
$parcel$export($6be88bbe69356b76$exports, "invalidCacheEnvironment", () => $6be88bbe69356b76$export$dedc648643245fa1);
$parcel$export($6be88bbe69356b76$exports, "noAccountFound", () => $6be88bbe69356b76$export$b98ebfe073f0162f);
$parcel$export($6be88bbe69356b76$exports, "noCryptoObject", () => $6be88bbe69356b76$export$c39e501a22cba395);
$parcel$export($6be88bbe69356b76$exports, "unexpectedCredentialType", () => $6be88bbe69356b76$export$21fdd1f95350cd6d);
$parcel$export($6be88bbe69356b76$exports, "invalidAssertion", () => $6be88bbe69356b76$export$e168896c692fb06b);
$parcel$export($6be88bbe69356b76$exports, "invalidClientCredential", () => $6be88bbe69356b76$export$c483ba88a47982b1);
$parcel$export($6be88bbe69356b76$exports, "tokenRefreshRequired", () => $6be88bbe69356b76$export$e23b692cce0c7779);
$parcel$export($6be88bbe69356b76$exports, "userTimeoutReached", () => $6be88bbe69356b76$export$afbb99ff17e87b86);
$parcel$export($6be88bbe69356b76$exports, "tokenClaimsCnfRequiredForSignedJwt", () => $6be88bbe69356b76$export$6f89b8a7d491b526);
$parcel$export($6be88bbe69356b76$exports, "authorizationCodeMissingFromServerResponse", () => $6be88bbe69356b76$export$93625fc864d26bba);
$parcel$export($6be88bbe69356b76$exports, "bindingKeyNotRemoved", () => $6be88bbe69356b76$export$5765db5d84418d29);
$parcel$export($6be88bbe69356b76$exports, "endSessionEndpointNotSupported", () => $6be88bbe69356b76$export$c3bd741c16a889f3);
$parcel$export($6be88bbe69356b76$exports, "keyIdMissing", () => $6be88bbe69356b76$export$3c9338a50e294d1);
$parcel$export($6be88bbe69356b76$exports, "noNetworkConnectivity", () => $6be88bbe69356b76$export$31ae862f18c3b2b7);
$parcel$export($6be88bbe69356b76$exports, "userCanceled", () => $6be88bbe69356b76$export$8ee329e65a880ec7);
$parcel$export($6be88bbe69356b76$exports, "missingTenantIdError", () => $6be88bbe69356b76$export$8c321d057617a458);
$parcel$export($6be88bbe69356b76$exports, "methodNotImplemented", () => $6be88bbe69356b76$export$24176fc1f15eea22);
$parcel$export($6be88bbe69356b76$exports, "nestedAppAuthBridgeDisabled", () => $6be88bbe69356b76$export$3078b0202fe7eea3);
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $6be88bbe69356b76$export$ccdf48c387c47b82 = "client_info_decoding_error";
const $6be88bbe69356b76$export$12315251e24e0181 = "client_info_empty_error";
const $6be88bbe69356b76$export$ad362b2e3a260143 = "token_parsing_error";
const $6be88bbe69356b76$export$78d01e29cb494be2 = "null_or_empty_token";
const $6be88bbe69356b76$export$c9fcc93738cc2bc3 = "endpoints_resolution_error";
const $6be88bbe69356b76$export$4358cbadf08aa73 = "network_error";
const $6be88bbe69356b76$export$73566da29bc073eb = "openid_config_error";
const $6be88bbe69356b76$export$14c4d54a8414667f = "hash_not_deserialized";
const $6be88bbe69356b76$export$72a77317632c052b = "invalid_state";
const $6be88bbe69356b76$export$6a56d8f882843cd8 = "state_mismatch";
const $6be88bbe69356b76$export$ef9214cfa5960fc = "state_not_found";
const $6be88bbe69356b76$export$edd0491c2c280be7 = "nonce_mismatch";
const $6be88bbe69356b76$export$43356944266c945e = "auth_time_not_found";
const $6be88bbe69356b76$export$f95fb86904f89749 = "max_age_transpired";
const $6be88bbe69356b76$export$47c50a2451614107 = "multiple_matching_tokens";
const $6be88bbe69356b76$export$2804a8b1b4c3be8b = "multiple_matching_accounts";
const $6be88bbe69356b76$export$575bb2924bcd0084 = "multiple_matching_appMetadata";
const $6be88bbe69356b76$export$4ac9fb1f531eded7 = "request_cannot_be_made";
const $6be88bbe69356b76$export$f7a276c01beb068a = "cannot_remove_empty_scope";
const $6be88bbe69356b76$export$93883786cf4a4a27 = "cannot_append_scopeset";
const $6be88bbe69356b76$export$41e2ce5958c42c83 = "empty_input_scopeset";
const $6be88bbe69356b76$export$e3af42f9856ab2a = "device_code_polling_cancelled";
const $6be88bbe69356b76$export$c0ef55deeb5e30d5 = "device_code_expired";
const $6be88bbe69356b76$export$4a9e9cce395ba70c = "device_code_unknown_error";
const $6be88bbe69356b76$export$5a3c7d1c90ac9220 = "no_account_in_silent_request";
const $6be88bbe69356b76$export$d396103576f879cc = "invalid_cache_record";
const $6be88bbe69356b76$export$dedc648643245fa1 = "invalid_cache_environment";
const $6be88bbe69356b76$export$b98ebfe073f0162f = "no_account_found";
const $6be88bbe69356b76$export$c39e501a22cba395 = "no_crypto_object";
const $6be88bbe69356b76$export$21fdd1f95350cd6d = "unexpected_credential_type";
const $6be88bbe69356b76$export$e168896c692fb06b = "invalid_assertion";
const $6be88bbe69356b76$export$c483ba88a47982b1 = "invalid_client_credential";
const $6be88bbe69356b76$export$e23b692cce0c7779 = "token_refresh_required";
const $6be88bbe69356b76$export$afbb99ff17e87b86 = "user_timeout_reached";
const $6be88bbe69356b76$export$6f89b8a7d491b526 = "token_claims_cnf_required_for_signedjwt";
const $6be88bbe69356b76$export$93625fc864d26bba = "authorization_code_missing_from_server_response";
const $6be88bbe69356b76$export$5765db5d84418d29 = "binding_key_not_removed";
const $6be88bbe69356b76$export$c3bd741c16a889f3 = "end_session_endpoint_not_supported";
const $6be88bbe69356b76$export$3c9338a50e294d1 = "key_id_missing";
const $6be88bbe69356b76$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $6be88bbe69356b76$export$8ee329e65a880ec7 = "user_canceled";
const $6be88bbe69356b76$export$8c321d057617a458 = "missing_tenant_id_error";
const $6be88bbe69356b76$export$24176fc1f15eea22 = "method_not_implemented";
const $6be88bbe69356b76$export$3078b0202fe7eea3 = "nested_app_auth_bridge_disabled";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $eaea74bac26129fa$export$8190ec70cbf7ec08 = {
    [(0, $6be88bbe69356b76$export$ccdf48c387c47b82)]: "The client info could not be parsed/decoded correctly",
    [(0, $6be88bbe69356b76$export$12315251e24e0181)]: "The client info was empty",
    [(0, $6be88bbe69356b76$export$ad362b2e3a260143)]: "Token cannot be parsed",
    [(0, $6be88bbe69356b76$export$78d01e29cb494be2)]: "The token is null or empty",
    [(0, $6be88bbe69356b76$export$c9fcc93738cc2bc3)]: "Endpoints cannot be resolved",
    [(0, $6be88bbe69356b76$export$4358cbadf08aa73)]: "Network request failed",
    [(0, $6be88bbe69356b76$export$73566da29bc073eb)]: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints.",
    [(0, $6be88bbe69356b76$export$14c4d54a8414667f)]: "The hash parameters could not be deserialized",
    [(0, $6be88bbe69356b76$export$72a77317632c052b)]: "State was not the expected format",
    [(0, $6be88bbe69356b76$export$6a56d8f882843cd8)]: "State mismatch error",
    [(0, $6be88bbe69356b76$export$ef9214cfa5960fc)]: "State not found",
    [(0, $6be88bbe69356b76$export$edd0491c2c280be7)]: "Nonce mismatch error",
    [(0, $6be88bbe69356b76$export$43356944266c945e)]: "Max Age was requested and the ID token is missing the auth_time variable. auth_time is an optional claim and is not enabled by default - it must be enabled. See https://aka.ms/msaljs/optional-claims for more information.",
    [(0, $6be88bbe69356b76$export$f95fb86904f89749)]: "Max Age is set to 0, or too much time has elapsed since the last end-user authentication.",
    [(0, $6be88bbe69356b76$export$47c50a2451614107)]: "The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements such as authority or account.",
    [(0, $6be88bbe69356b76$export$2804a8b1b4c3be8b)]: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account",
    [(0, $6be88bbe69356b76$export$575bb2924bcd0084)]: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata",
    [(0, $6be88bbe69356b76$export$4ac9fb1f531eded7)]: "Token request cannot be made without authorization code or refresh token.",
    [(0, $6be88bbe69356b76$export$f7a276c01beb068a)]: "Cannot remove null or empty scope from ScopeSet",
    [(0, $6be88bbe69356b76$export$93883786cf4a4a27)]: "Cannot append ScopeSet",
    [(0, $6be88bbe69356b76$export$41e2ce5958c42c83)]: "Empty input ScopeSet cannot be processed",
    [(0, $6be88bbe69356b76$export$e3af42f9856ab2a)]: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true.",
    [(0, $6be88bbe69356b76$export$c0ef55deeb5e30d5)]: "Device code is expired.",
    [(0, $6be88bbe69356b76$export$4a9e9cce395ba70c)]: "Device code stopped polling for unknown reasons.",
    [(0, $6be88bbe69356b76$export$5a3c7d1c90ac9220)]: "Please pass an account object, silent flow is not supported without account information",
    [(0, $6be88bbe69356b76$export$d396103576f879cc)]: "Cache record object was null or undefined.",
    [(0, $6be88bbe69356b76$export$dedc648643245fa1)]: "Invalid environment when attempting to create cache entry",
    [(0, $6be88bbe69356b76$export$b98ebfe073f0162f)]: "No account found in cache for given key.",
    [(0, $6be88bbe69356b76$export$c39e501a22cba395)]: "No crypto object detected.",
    [(0, $6be88bbe69356b76$export$21fdd1f95350cd6d)]: "Unexpected credential type.",
    [(0, $6be88bbe69356b76$export$e168896c692fb06b)]: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515",
    [(0, $6be88bbe69356b76$export$c483ba88a47982b1)]: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential",
    [(0, $6be88bbe69356b76$export$e23b692cce0c7779)]: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired.",
    [(0, $6be88bbe69356b76$export$afbb99ff17e87b86)]: "User defined timeout for device code polling reached",
    [(0, $6be88bbe69356b76$export$6f89b8a7d491b526)]: "Cannot generate a POP jwt if the token_claims are not populated",
    [(0, $6be88bbe69356b76$export$93625fc864d26bba)]: "Server response does not contain an authorization code to proceed",
    [(0, $6be88bbe69356b76$export$5765db5d84418d29)]: "Could not remove the credential's binding key from storage.",
    [(0, $6be88bbe69356b76$export$c3bd741c16a889f3)]: "The provided authority does not support logout",
    [(0, $6be88bbe69356b76$export$3c9338a50e294d1)]: "A keyId value is missing from the requested bound token's cache record and is required to match the token to it's stored binding key.",
    [(0, $6be88bbe69356b76$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $6be88bbe69356b76$export$8ee329e65a880ec7)]: "User cancelled the flow.",
    [(0, $6be88bbe69356b76$export$8c321d057617a458)]: "A tenant id - not common, organizations, or consumers - must be specified when using the client_credentials flow.",
    [(0, $6be88bbe69356b76$export$24176fc1f15eea22)]: "This method has not been implemented",
    [(0, $6be88bbe69356b76$export$3078b0202fe7eea3)]: "The nested app auth bridge is disabled"
};
/**
 * String constants used by error codes and messages.
 * @deprecated Use ClientAuthErrorCodes instead
 */ const $eaea74bac26129fa$export$51eee17394e135b = {
    clientInfoDecodingError: {
        code: (0, $6be88bbe69356b76$export$ccdf48c387c47b82),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$ccdf48c387c47b82]
    },
    clientInfoEmptyError: {
        code: (0, $6be88bbe69356b76$export$12315251e24e0181),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$12315251e24e0181]
    },
    tokenParsingError: {
        code: (0, $6be88bbe69356b76$export$ad362b2e3a260143),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$ad362b2e3a260143]
    },
    nullOrEmptyToken: {
        code: (0, $6be88bbe69356b76$export$78d01e29cb494be2),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$78d01e29cb494be2]
    },
    endpointResolutionError: {
        code: (0, $6be88bbe69356b76$export$c9fcc93738cc2bc3),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c9fcc93738cc2bc3]
    },
    networkError: {
        code: (0, $6be88bbe69356b76$export$4358cbadf08aa73),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$4358cbadf08aa73]
    },
    unableToGetOpenidConfigError: {
        code: (0, $6be88bbe69356b76$export$73566da29bc073eb),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$73566da29bc073eb]
    },
    hashNotDeserialized: {
        code: (0, $6be88bbe69356b76$export$14c4d54a8414667f),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$14c4d54a8414667f]
    },
    invalidStateError: {
        code: (0, $6be88bbe69356b76$export$72a77317632c052b),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$72a77317632c052b]
    },
    stateMismatchError: {
        code: (0, $6be88bbe69356b76$export$6a56d8f882843cd8),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$6a56d8f882843cd8]
    },
    stateNotFoundError: {
        code: (0, $6be88bbe69356b76$export$ef9214cfa5960fc),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$ef9214cfa5960fc]
    },
    nonceMismatchError: {
        code: (0, $6be88bbe69356b76$export$edd0491c2c280be7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$edd0491c2c280be7]
    },
    authTimeNotFoundError: {
        code: (0, $6be88bbe69356b76$export$43356944266c945e),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$43356944266c945e]
    },
    maxAgeTranspired: {
        code: (0, $6be88bbe69356b76$export$f95fb86904f89749),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$f95fb86904f89749]
    },
    multipleMatchingTokens: {
        code: (0, $6be88bbe69356b76$export$47c50a2451614107),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$47c50a2451614107]
    },
    multipleMatchingAccounts: {
        code: (0, $6be88bbe69356b76$export$2804a8b1b4c3be8b),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$2804a8b1b4c3be8b]
    },
    multipleMatchingAppMetadata: {
        code: (0, $6be88bbe69356b76$export$575bb2924bcd0084),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$575bb2924bcd0084]
    },
    tokenRequestCannotBeMade: {
        code: (0, $6be88bbe69356b76$export$4ac9fb1f531eded7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$4ac9fb1f531eded7]
    },
    removeEmptyScopeError: {
        code: (0, $6be88bbe69356b76$export$f7a276c01beb068a),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$f7a276c01beb068a]
    },
    appendScopeSetError: {
        code: (0, $6be88bbe69356b76$export$93883786cf4a4a27),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$93883786cf4a4a27]
    },
    emptyInputScopeSetError: {
        code: (0, $6be88bbe69356b76$export$41e2ce5958c42c83),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$41e2ce5958c42c83]
    },
    DeviceCodePollingCancelled: {
        code: (0, $6be88bbe69356b76$export$e3af42f9856ab2a),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$e3af42f9856ab2a]
    },
    DeviceCodeExpired: {
        code: (0, $6be88bbe69356b76$export$c0ef55deeb5e30d5),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c0ef55deeb5e30d5]
    },
    DeviceCodeUnknownError: {
        code: (0, $6be88bbe69356b76$export$4a9e9cce395ba70c),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$4a9e9cce395ba70c]
    },
    NoAccountInSilentRequest: {
        code: (0, $6be88bbe69356b76$export$5a3c7d1c90ac9220),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$5a3c7d1c90ac9220]
    },
    invalidCacheRecord: {
        code: (0, $6be88bbe69356b76$export$d396103576f879cc),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$d396103576f879cc]
    },
    invalidCacheEnvironment: {
        code: (0, $6be88bbe69356b76$export$dedc648643245fa1),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$dedc648643245fa1]
    },
    noAccountFound: {
        code: (0, $6be88bbe69356b76$export$b98ebfe073f0162f),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$b98ebfe073f0162f]
    },
    noCryptoObj: {
        code: (0, $6be88bbe69356b76$export$c39e501a22cba395),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c39e501a22cba395]
    },
    unexpectedCredentialType: {
        code: (0, $6be88bbe69356b76$export$21fdd1f95350cd6d),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$21fdd1f95350cd6d]
    },
    invalidAssertion: {
        code: (0, $6be88bbe69356b76$export$e168896c692fb06b),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$e168896c692fb06b]
    },
    invalidClientCredential: {
        code: (0, $6be88bbe69356b76$export$c483ba88a47982b1),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c483ba88a47982b1]
    },
    tokenRefreshRequired: {
        code: (0, $6be88bbe69356b76$export$e23b692cce0c7779),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$e23b692cce0c7779]
    },
    userTimeoutReached: {
        code: (0, $6be88bbe69356b76$export$afbb99ff17e87b86),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$afbb99ff17e87b86]
    },
    tokenClaimsRequired: {
        code: (0, $6be88bbe69356b76$export$6f89b8a7d491b526),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$6f89b8a7d491b526]
    },
    noAuthorizationCodeFromServer: {
        code: (0, $6be88bbe69356b76$export$93625fc864d26bba),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$93625fc864d26bba]
    },
    bindingKeyNotRemovedError: {
        code: (0, $6be88bbe69356b76$export$5765db5d84418d29),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$5765db5d84418d29]
    },
    logoutNotSupported: {
        code: (0, $6be88bbe69356b76$export$c3bd741c16a889f3),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c3bd741c16a889f3]
    },
    keyIdMissing: {
        code: (0, $6be88bbe69356b76$export$3c9338a50e294d1),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$3c9338a50e294d1]
    },
    noNetworkConnectivity: {
        code: (0, $6be88bbe69356b76$export$31ae862f18c3b2b7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$31ae862f18c3b2b7]
    },
    userCanceledError: {
        code: (0, $6be88bbe69356b76$export$8ee329e65a880ec7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$8ee329e65a880ec7]
    },
    missingTenantIdError: {
        code: (0, $6be88bbe69356b76$export$8c321d057617a458),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$8c321d057617a458]
    },
    nestedAppAuthBridgeDisabled: {
        code: (0, $6be88bbe69356b76$export$3078b0202fe7eea3),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$3078b0202fe7eea3]
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $eaea74bac26129fa$export$a839ff85a7957561 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, additionalMessage){
        super(errorCode, additionalMessage ? `${$eaea74bac26129fa$export$8190ec70cbf7ec08[errorCode]}: ${additionalMessage}` : $eaea74bac26129fa$export$8190ec70cbf7ec08[errorCode]);
        this.name = "ClientAuthError";
        Object.setPrototypeOf(this, $eaea74bac26129fa$export$a839ff85a7957561.prototype);
    }
}
function $eaea74bac26129fa$export$ea892ce48f5bb4f3(errorCode, additionalMessage) {
    return new $eaea74bac26129fa$export$a839ff85a7957561(errorCode, additionalMessage);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function $7aacd5d6e6d7482c$export$575e1419cfbab7f8(rawClientInfo, base64Decode) {
    if (!rawClientInfo) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$12315251e24e0181));
    try {
        const decodedClientInfo = base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ccdf48c387c47b82));
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function $7aacd5d6e6d7482c$export$63508a6d6b7dbe07(homeAccountId) {
    if (!homeAccountId) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ccdf48c387c47b82));
    const clientInfoParts = homeAccountId.split((0, $7c375ae106b964be$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING : clientInfoParts[1]
    };
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns true if tenantId matches the utid portion of homeAccountId
 * @param tenantId
 * @param homeAccountId
 * @returns
 */ function $54830df9a5d9a12c$export$bc62fd222eddc2d7(tenantId, homeAccountId) {
    return !!tenantId && !!homeAccountId && tenantId === homeAccountId.split(".")[1];
}
/**
 * Build tenant profile
 * @param homeAccountId - Home account identifier for this account object
 * @param localAccountId - Local account identifer for this account object
 * @param tenantId - Full tenant or organizational id that this account belongs to
 * @param idTokenClaims - Claims from the ID token
 * @returns
 */ function $54830df9a5d9a12c$export$924857724cb21ba4(homeAccountId, localAccountId, tenantId, idTokenClaims) {
    if (idTokenClaims) {
        const { oid: oid, sub: sub, tid: tid, name: name, tfp: tfp, acr: acr } = idTokenClaims;
        /**
         * Since there is no way to determine if the authority is AAD or B2C, we exhaust all the possible claims that can serve as tenant ID with the following precedence:
         * tid - TenantID claim that identifies the tenant that issued the token in AAD. Expected in all AAD ID tokens, not present in B2C ID Tokens.
         * tfp - Trust Framework Policy claim that identifies the policy that was used to authenticate the user. Functions as tenant for B2C scenarios.
         * acr - Authentication Context Class Reference claim used only with older B2C policies. Fallback in case tfp is not present, but likely won't be present anyway.
         */ const tenantId = tid || tfp || acr || "";
        return {
            tenantId: tenantId,
            localAccountId: oid || sub || "",
            name: name,
            isHomeTenant: $54830df9a5d9a12c$export$bc62fd222eddc2d7(tenantId, homeAccountId)
        };
    } else return {
        tenantId: tenantId,
        localAccountId: localAccountId,
        isHomeTenant: $54830df9a5d9a12c$export$bc62fd222eddc2d7(tenantId, homeAccountId)
    };
}
/**
 * Replaces account info that varies by tenant profile sourced from the ID token claims passed in with the tenant-specific account info
 * @param baseAccountInfo
 * @param idTokenClaims
 * @returns
 */ function $54830df9a5d9a12c$export$452a054c78b83dad(baseAccountInfo, tenantProfile, idTokenClaims, idTokenSecret) {
    let updatedAccountInfo = baseAccountInfo;
    // Tenant Profile overrides passed in account info
    if (tenantProfile) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...tenantProfileOverride } = tenantProfile;
        updatedAccountInfo = {
            ...baseAccountInfo,
            ...tenantProfileOverride
        };
    }
    // ID token claims override passed in account info and tenant profile
    if (idTokenClaims) {
        // Ignore isHomeTenant, loginHint, and sid which are part of tenant profile but not base account info
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...claimsSourcedTenantProfile } = $54830df9a5d9a12c$export$924857724cb21ba4(baseAccountInfo.homeAccountId, baseAccountInfo.localAccountId, baseAccountInfo.tenantId, idTokenClaims);
        updatedAccountInfo = {
            ...updatedAccountInfo,
            ...claimsSourcedTenantProfile,
            idTokenClaims: idTokenClaims,
            idToken: idTokenSecret
        };
        return updatedAccountInfo;
    }
    return updatedAccountInfo;
}



/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ const $70363054a03152f4$export$cd82032b224a3839 = {
    Default: 0,
    Adfs: 1,
    Dsts: 2,
    Ciam: 3
};


/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Gets tenantId from available ID token claims to set as credential realm with the following precedence:
 * 1. tid - if the token is acquired from an Azure AD tenant tid will be present
 * 2. tfp - if the token is acquired from a modern B2C tenant tfp should be present
 * 3. acr - if the token is acquired from a legacy B2C tenant acr should be present
 * Downcased to match the realm case-insensitive comparison requirements
 * @param idTokenClaims
 * @returns
 */ function $da8f9f8eb56c5a02$export$8e1decb9a5e2932(idTokenClaims) {
    if (idTokenClaims) {
        const tenantId = idTokenClaims.tid || idTokenClaims.tfp || idTokenClaims.acr;
        return tenantId || null;
    }
    return null;
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ const $de576c4d1becc778$export$73a3e3dedd37150d = {
    AAD: "AAD",
    OIDC: "OIDC"
};



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Type that defines required and optional parameters for an Account field (based on universal cache schema implemented by all MSALs).
 *
 * Key : Value Schema
 *
 * Key: <home_account_id>-<environment>-<realm*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      localAccountId: Original tenant-specific accountID, usually used for legacy cases
 *      username: primary username that represents the user, usually corresponds to preferred_username in the v2 endpt
 *      authorityType: Accounts authority type as a string
 *      name: Full name for the account, including given name and family name,
 *      lastModificationTime: last time this entity was modified in the cache
 *      lastModificationApp:
 *      nativeAccountId: Account identifier on the native device
 *      tenantProfiles: Array of tenant profile objects for each tenant that the account has authenticated with in the browser
 * }
 * @internal
 */ class $d6acc4a6126921e0$export$680160523e6bfa6a {
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */ generateAccountId() {
        const accountId = [
            this.homeAccountId,
            this.environment
        ];
        return accountId.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Generate Account Cache Key as per the schema: <home_account_id>-<environment>-<realm*>
     */ generateAccountKey() {
        return $d6acc4a6126921e0$export$680160523e6bfa6a.generateAccountCacheKey({
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId
        });
    }
    /**
     * Returns the AccountInfo interface for this account.
     */ getAccountInfo() {
        return {
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId,
            name: this.name,
            nativeAccountId: this.nativeAccountId,
            authorityType: this.authorityType,
            // Deserialize tenant profiles array into a Map
            tenantProfiles: new Map((this.tenantProfiles || []).map((tenantProfile)=>{
                return [
                    tenantProfile.tenantId,
                    tenantProfile
                ];
            }))
        };
    }
    /**
     * Returns true if the account entity is in single tenant format (outdated), false otherwise
     */ isSingleTenant() {
        return !this.tenantProfiles;
    }
    /**
     * Generates account key from interface
     * @param accountInterface
     */ static generateAccountCacheKey(accountInterface) {
        const homeTenantId = accountInterface.homeAccountId.split(".")[1];
        const accountKey = [
            accountInterface.homeAccountId,
            accountInterface.environment || "",
            homeTenantId || accountInterface.tenantId || ""
        ];
        return accountKey.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
     * @param accountDetails
     */ static createAccount(accountDetails, authority, base64Decode) {
        const account = new $d6acc4a6126921e0$export$680160523e6bfa6a();
        if (authority.authorityType === (0, $70363054a03152f4$export$cd82032b224a3839).Adfs) account.authorityType = (0, $7c375ae106b964be$export$23244fafa2e7f55c).ADFS_ACCOUNT_TYPE;
        else if (authority.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).AAD) account.authorityType = (0, $7c375ae106b964be$export$23244fafa2e7f55c).MSSTS_ACCOUNT_TYPE;
        else account.authorityType = (0, $7c375ae106b964be$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        let clientInfo;
        if (accountDetails.clientInfo && base64Decode) clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(accountDetails.clientInfo, base64Decode);
        account.clientInfo = accountDetails.clientInfo;
        account.homeAccountId = accountDetails.homeAccountId;
        account.nativeAccountId = accountDetails.nativeAccountId;
        const env = accountDetails.environment || authority && authority.getPreferredCache();
        if (!env) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$dedc648643245fa1));
        account.environment = env;
        // non AAD scenarios can have empty realm
        account.realm = clientInfo?.utid || (0, $da8f9f8eb56c5a02$export$8e1decb9a5e2932)(accountDetails.idTokenClaims) || "";
        // How do you account for MSA CID here?
        account.localAccountId = clientInfo?.uid || accountDetails.idTokenClaims?.oid || accountDetails.idTokenClaims?.sub || "";
        /*
         * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
         * In most cases it will contain a single email. This field should not be relied upon if a custom
         * policy is configured to return more than 1 email.
         */ const preferredUsername = accountDetails.idTokenClaims?.preferred_username || accountDetails.idTokenClaims?.upn;
        const email = accountDetails.idTokenClaims?.emails ? accountDetails.idTokenClaims.emails[0] : null;
        account.username = preferredUsername || email || "";
        account.name = accountDetails.idTokenClaims?.name || "";
        account.cloudGraphHostName = accountDetails.cloudGraphHostName;
        account.msGraphHost = accountDetails.msGraphHost;
        if (accountDetails.tenantProfiles) account.tenantProfiles = accountDetails.tenantProfiles;
        else {
            const tenantProfile = (0, $54830df9a5d9a12c$export$924857724cb21ba4)(accountDetails.homeAccountId, account.localAccountId, account.realm, accountDetails.idTokenClaims);
            account.tenantProfiles = [
                tenantProfile
            ];
        }
        return account;
    }
    /**
     * Creates an AccountEntity object from AccountInfo
     * @param accountInfo
     * @param cloudGraphHostName
     * @param msGraphHost
     * @returns
     */ static createFromAccountInfo(accountInfo, cloudGraphHostName, msGraphHost) {
        const account = new $d6acc4a6126921e0$export$680160523e6bfa6a();
        account.authorityType = accountInfo.authorityType || (0, $7c375ae106b964be$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        account.homeAccountId = accountInfo.homeAccountId;
        account.localAccountId = accountInfo.localAccountId;
        account.nativeAccountId = accountInfo.nativeAccountId;
        account.realm = accountInfo.tenantId;
        account.environment = accountInfo.environment;
        account.username = accountInfo.username;
        account.name = accountInfo.name;
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        // Serialize tenant profiles map into an array
        account.tenantProfiles = Array.from(accountInfo.tenantProfiles?.values() || []);
        return account;
    }
    /**
     * Generate HomeAccountId from server response
     * @param serverClientInfo
     * @param authType
     */ static generateHomeAccountId(serverClientInfo, authType, logger, cryptoObj, idTokenClaims) {
        // since ADFS/DSTS do not have tid and does not set client_info
        if (!(authType === (0, $70363054a03152f4$export$cd82032b224a3839).Adfs || authType === (0, $70363054a03152f4$export$cd82032b224a3839).Dsts)) {
            // for cases where there is clientInfo
            if (serverClientInfo) try {
                const clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(serverClientInfo, cryptoObj.base64Decode);
                if (clientInfo.uid && clientInfo.utid) return `${clientInfo.uid}.${clientInfo.utid}`;
            } catch (e) {}
            logger.warning("No client info in response");
        }
        // default to "sub" claim
        return idTokenClaims?.sub || "";
    }
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ static isAccountEntity(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
    }
    /**
     * Helper function to determine whether 2 accountInfo objects represent the same account
     * @param accountA
     * @param accountB
     * @param compareClaims - If set to true idTokenClaims will also be compared to determine account equality
     */ static accountInfoIsEqual(accountA, accountB, compareClaims) {
        if (!accountA || !accountB) return false;
        let claimsMatch = true; // default to true so as to not fail comparison below if compareClaims: false
        if (compareClaims) {
            const accountAClaims = accountA.idTokenClaims || {};
            const accountBClaims = accountB.idTokenClaims || {};
            // issued at timestamp and nonce are expected to change each time a new id token is acquired
            claimsMatch = accountAClaims.iat === accountBClaims.iat && accountAClaims.nonce === accountBClaims.nonce;
        }
        return accountA.homeAccountId === accountB.homeAccountId && accountA.localAccountId === accountB.localAccountId && accountA.username === accountB.username && accountA.tenantId === accountB.tenantId && accountA.environment === accountB.environment && accountA.nativeAccountId === accountB.nativeAccountId && claimsMatch;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e5e33773db31b6c0$var$getAccount(instance, accountIdentifiers) {
    if (!accountIdentifiers || !accountIdentifiers.homeAccountId && !accountIdentifiers.localAccountId && !accountIdentifiers.username) // If no account identifiers are provided, return active account
    return instance.getActiveAccount();
    return (0, $1f6f413f87363628$export$fa581286d49c51db)(instance.getAllAccounts(), accountIdentifiers);
}
/**
 * Given 1 or more accountIdentifiers, returns the Account object if the user is signed-in
 * @param accountIdentifiers
 */ function $e5e33773db31b6c0$export$83a8e409853da004(accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const [account, setAccount] = (0, $acw62.useState)(()=>$e5e33773db31b6c0$var$getAccount(instance, accountIdentifiers));
    (0, $acw62.useEffect)(()=>{
        setAccount((currentAccount)=>{
            const nextAccount = $e5e33773db31b6c0$var$getAccount(instance, accountIdentifiers);
            if (!(0, $d6acc4a6126921e0$export$680160523e6bfa6a).accountInfoIsEqual(currentAccount, nextAccount, true)) {
                logger.info("useAccount - Updating account");
                return nextAccount;
            }
            return currentAccount;
        });
    }, [
        inProgress,
        accountIdentifiers,
        instance,
        logger
    ]);
    return account;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $c88e71052189f2fb$export$a77ea62d722c2a73 = {
    invalidInteractionType: {
        code: "invalid_interaction_type",
        desc: "The provided interaction type is invalid."
    },
    unableToFallbackToInteraction: {
        code: "unable_to_fallback_to_interaction",
        desc: "Interaction is required but another interaction is already in progress. Please try again when the current interaction is complete."
    }
};
class $c88e71052189f2fb$export$2aa0f0a55de712e6 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        Object.setPrototypeOf(this, $c88e71052189f2fb$export$2aa0f0a55de712e6.prototype);
        this.name = "ReactAuthError";
    }
    static createInvalidInteractionTypeError() {
        return new $c88e71052189f2fb$export$2aa0f0a55de712e6($c88e71052189f2fb$export$a77ea62d722c2a73.invalidInteractionType.code, $c88e71052189f2fb$export$a77ea62d722c2a73.invalidInteractionType.desc);
    }
    static createUnableToFallbackToInteractionError() {
        return new $c88e71052189f2fb$export$2aa0f0a55de712e6($c88e71052189f2fb$export$a77ea62d722c2a73.unableToFallbackToInteraction.code, $c88e71052189f2fb$export$a77ea62d722c2a73.unableToFallbackToInteraction.desc);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * If a user is not currently signed in this hook invokes a login. Failed logins can be retried using the login callback returned.
 * If a user is currently signed in this hook attempts to acquire a token. Subsequent token requests can use the acquireToken callback returned.
 * Optionally provide a request object to be used in the login/acquireToken call.
 * Optionally provide a specific user that should be logged in.
 * @param interactionType
 * @param authenticationRequest
 * @param accountIdentifiers
 */ function $90c0acaab831205e$export$d130d543558e611f(interactionType, authenticationRequest, accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const isAuthenticated = (0, $41a0d322aea9de82$export$7e9c60d6d1836c84)(accountIdentifiers);
    const account = (0, $e5e33773db31b6c0$export$83a8e409853da004)(accountIdentifiers);
    const [[result, error], setResponse] = (0, $acw62.useState)([
        null,
        null
    ]);
    // Used to prevent state updates after unmount
    const mounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            mounted.current = false;
        };
    }, []);
    // Boolean used to check if interaction is in progress in acquireTokenSilent fallback. Use Ref instead of state to prevent acquireToken function from being regenerated on each change to interactionInProgress value
    const interactionInProgress = (0, $acw62.useRef)(inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None);
    (0, $acw62.useEffect)(()=>{
        interactionInProgress.current = inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
    }, [
        inProgress
    ]);
    // Flag used to control when the hook calls login/acquireToken
    const shouldAcquireToken = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (!!error) {
            // Errors should be handled by consuming component
            shouldAcquireToken.current = false;
            return;
        }
        if (!!result) {
            // Token has already been acquired, consuming component/application is responsible for renewing
            shouldAcquireToken.current = false;
            return;
        }
    }, [
        error,
        result
    ]);
    const login = (0, $acw62.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const loginType = callbackInteractionType || interactionType;
        const loginRequest = callbackRequest || authenticationRequest;
        switch(loginType){
            case (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup:
                logger.verbose("useMsalAuthentication - Calling loginPopup");
                return instance.loginPopup(loginRequest);
            case (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect:
                // This promise is not expected to resolve due to full frame redirect
                logger.verbose("useMsalAuthentication - Calling loginRedirect");
                return instance.loginRedirect(loginRequest).then(null);
            case (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent:
                logger.verbose("useMsalAuthentication - Calling ssoSilent");
                return instance.ssoSilent(loginRequest);
            default:
                throw (0, $c88e71052189f2fb$export$2aa0f0a55de712e6).createInvalidInteractionTypeError();
        }
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger
    ]);
    const acquireToken = (0, $acw62.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const fallbackInteractionType = callbackInteractionType || interactionType;
        let tokenRequest;
        if (callbackRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the callback");
            tokenRequest = {
                ...callbackRequest
            };
        } else if (authenticationRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the hook");
            tokenRequest = {
                ...authenticationRequest,
                scopes: authenticationRequest.scopes || (0, $7c375ae106b964be$export$893b1b5b686d84ef)
            };
        } else {
            logger.trace("useMsalAuthentication - acquireToken - No request object provided, using default request.");
            tokenRequest = {
                scopes: (0, $7c375ae106b964be$export$893b1b5b686d84ef)
            };
        }
        if (!tokenRequest.account && account) {
            logger.trace("useMsalAuthentication - acquireToken - Attaching account to request");
            tokenRequest.account = account;
        }
        const getToken = async ()=>{
            logger.verbose("useMsalAuthentication - Calling acquireTokenSilent");
            return instance.acquireTokenSilent(tokenRequest).catch(async (e)=>{
                if (e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
                    if (!interactionInProgress.current) {
                        logger.error("useMsalAuthentication - Interaction required, falling back to interaction");
                        return login(fallbackInteractionType, tokenRequest);
                    } else {
                        logger.error("useMsalAuthentication - Interaction required but is already in progress. Please try again, if needed, after interaction completes.");
                        throw (0, $c88e71052189f2fb$export$2aa0f0a55de712e6).createUnableToFallbackToInteractionError();
                    }
                }
                throw e;
            });
        };
        return getToken().then((response)=>{
            if (mounted.current) setResponse([
                response,
                null
            ]);
            return response;
        }).catch((e)=>{
            if (mounted.current) setResponse([
                null,
                e
            ]);
            throw e;
        });
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger,
        account,
        login
    ]);
    (0, $acw62.useEffect)(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            switch(message.eventType){
                case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS:
                case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_SUCCESS:
                    if (message.payload) setResponse([
                        message.payload,
                        null
                    ]);
                    break;
                case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE:
                case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_FAILURE:
                    if (message.error) setResponse([
                        null,
                        message.error
                    ]);
                    break;
            }
        });
        logger.verbose(`useMsalAuthentication - Registered event callback with id: ${callbackId}`);
        return ()=>{
            if (callbackId) {
                logger.verbose(`useMsalAuthentication - Removing event callback ${callbackId}`);
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    (0, $acw62.useEffect)(()=>{
        if (shouldAcquireToken.current && inProgress === (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None) {
            shouldAcquireToken.current = false;
            if (!isAuthenticated) {
                logger.info("useMsalAuthentication - No user is authenticated, attempting to login");
                login().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            } else if (account) {
                logger.info("useMsalAuthentication - User is authenticated, attempting to acquire token");
                acquireToken().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            }
        }
    }, [
        isAuthenticated,
        account,
        inProgress,
        login,
        acquireToken,
        logger
    ]);
    return {
        login: login,
        acquireToken: acquireToken,
        result: result,
        error: error
    };
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Attempts to authenticate user if not already authenticated, then renders child components
 * @param props
 */ function $8be22596aceaa726$export$c9cd7a02d4bd7707({ interactionType: interactionType, username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, authenticationRequest: authenticationRequest, loadingComponent: LoadingComponent, errorComponent: ErrorComponent, children: children }) {
    const accountIdentifier = (0, $acw62.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const context = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const msalAuthResult = (0, $90c0acaab831205e$export$d130d543558e611f)(interactionType, authenticationRequest, accountIdentifier);
    const isAuthenticated = (0, $41a0d322aea9de82$export$7e9c60d6d1836c84)(accountIdentifier);
    if (msalAuthResult.error && context.inProgress === (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None) {
        if (!!ErrorComponent) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ErrorComponent, {
            ...msalAuthResult
        });
        throw msalAuthResult.error;
    }
    if (isAuthenticated) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $1f6f413f87363628$export$7a39d5906c5d6010)(children, msalAuthResult));
    if (!!LoadingComponent && context.inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingComponent, {
        ...context
    });
    return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $acw62 = parcelRequire("acw62");

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Higher order component wraps provided component with msal by injecting msal context values into the component's props
 * @param Component
 */ const $89d1927841dd723e$export$8dea26c30ebc61cd = (Component)=>{
    const ComponentWithMsal = (props)=>{
        const msal = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
            ...props,
            msalContext: msal
        });
    };
    const componentName = Component.displayName || Component.name || "Component";
    ComponentWithMsal.displayName = `withMsal(${componentName})`;
    return ComponentWithMsal;
};







'use strict';



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $b6f2914bcc222460$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
var $b6f2914bcc222460$export$2e2bcd8739ae039 = $b6f2914bcc222460$var$ThemeContext;



var $acw62 = parcelRequire("acw62");

function $feefabedf550ce3f$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $b6f2914bcc222460$export$2e2bcd8739ae039));
    return theme;
}


const $20a8501e6e2f4912$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $20a8501e6e2f4912$export$2e2bcd8739ae039 = $20a8501e6e2f4912$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $ayMG0 = parcelRequire("ayMG0");
function $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $fff44a152eb20ab0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $feefabedf550ce3f$export$2e2bcd8739ae039)();
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $20a8501e6e2f4912$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6f2914bcc222460$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $fff44a152eb20ab0$export$2e2bcd8739ae039 = $fff44a152eb20ab0$var$ThemeProvider;



parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
'use client';
function $1f701f7d1726bc9a$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $1f701f7d1726bc9a$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $eP9YU.T));
    return !contextTheme || $1f701f7d1726bc9a$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $1f701f7d1726bc9a$export$2e2bcd8739ae039 = $1f701f7d1726bc9a$var$useTheme;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
const $3bcebab40d8ce666$var$_excluded = [
    "value"
];
const $3bcebab40d8ce666$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $3bcebab40d8ce666$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $1En50.default)(_ref, $3bcebab40d8ce666$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bcebab40d8ce666$var$RtlContext.Provider, (0, $8nd05.default)({
        value: value != null ? value : true
    }, props));
}
const $3bcebab40d8ce666$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($3bcebab40d8ce666$var$RtlContext);
    return value != null ? value : false;
};
var $3bcebab40d8ce666$export$2e2bcd8739ae039 = $3bcebab40d8ce666$var$RtlProvider;



var $aMyfV = parcelRequire("aMyfV");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $aab859a020ad749e$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $aab859a020ad749e$export$2e2bcd8739ae039 = $aab859a020ad749e$var$useEnhancedEffect;



var $acw62 = parcelRequire("acw62");
'use client';
let $7a3a319e7e555608$var$globalId = 0;
function $7a3a319e7e555608$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $7a3a319e7e555608$var$globalId += 1;
            setDefaultId(`mui-${$7a3a319e7e555608$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $7a3a319e7e555608$var$maybeReactUseId = $acw62['useId'.toString()];
function $7a3a319e7e555608$export$2e2bcd8739ae039(idOverride) {
    if ($7a3a319e7e555608$var$maybeReactUseId !== undefined) {
        const reactId = $7a3a319e7e555608$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $7a3a319e7e555608$var$useGlobalId(idOverride);
}


parcelRequire("acw62");


var $bBbjn = parcelRequire("bBbjn");
var $bOOlK = parcelRequire("bOOlK");

var $6o2lr = parcelRequire("6o2lr");

'use client';
const $59c0686cf27fa016$export$35e57303dbd8a66 = (0, $6o2lr.default)();
function $59c0686cf27fa016$var$useTheme(defaultTheme = $59c0686cf27fa016$export$35e57303dbd8a66) {
    return (0, $1f701f7d1726bc9a$export$2e2bcd8739ae039)(defaultTheme);
}
var $59c0686cf27fa016$export$2e2bcd8739ae039 = $59c0686cf27fa016$var$useTheme;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $6942d6ec85232a9d$var$wrapGlobalLayer(styles) {
    const serialized = (0, $bOOlK.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $6942d6ec85232a9d$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $6942d6ec85232a9d$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $6942d6ec85232a9d$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $6942d6ec85232a9d$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBbjn.default), {
        styles: globalStyles
    });
}
var $6942d6ec85232a9d$export$2e2bcd8739ae039 = $6942d6ec85232a9d$var$GlobalStyles;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $34de227aaca64f99$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $1f701f7d1726bc9a$export$2e2bcd8739ae039)();
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6942d6ec85232a9d$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $50ef44b883b4d7f9$var$EMPTY_THEME = {};
function $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $acw62.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $8nd05.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $8nd05.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $8nd05.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $50ef44b883b4d7f9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $1f701f7d1726bc9a$export$2e2bcd8739ae039)($50ef44b883b4d7f9$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $feefabedf550ce3f$export$2e2bcd8739ae039)() || $50ef44b883b4d7f9$var$EMPTY_THEME;
    const engineTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $34de227aaca64f99$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff44a152eb20ab0$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bcebab40d8ce666$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aMyfV.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $50ef44b883b4d7f9$export$2e2bcd8739ae039 = $50ef44b883b4d7f9$var$ThemeProvider;



var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c4650f6dac4940cb$var$_excluded = [
    "theme"
];
function $c4650f6dac4940cb$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $1En50.default)(_ref, $c4650f6dac4940cb$var$_excluded);
    const scopedTheme = themeInput[0, $4jPsi.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $8nd05.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $8nd05.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50ef44b883b4d7f9$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        themeId: scopedTheme ? (0, $4jPsi.default) : undefined,
        theme: finalTheme
    }));
}



var $acw62 = parcelRequire("acw62");
/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-browser v3.30.0 2025-08-05 */ 
/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $399fa9610e7cb0fb$export$4cda21933050d9ec = {
    // AzureCloudInstance is not specified.
    None: "none",
    // Microsoft Azure public cloud
    AzurePublic: "https://login.microsoftonline.com",
    // Microsoft PPE
    AzurePpe: "https://login.windows-ppe.net",
    // Microsoft Chinese national/regional cloud
    AzureChina: "https://login.chinacloudapi.cn",
    // Microsoft German national/regional cloud ("Black Forest")
    AzureGermany: "https://login.microsoftonline.de",
    // US Government cloud
    AzureUsGovernment: "https://login.microsoftonline.us"
};

var $3a016e333d7347e3$exports = {};

$parcel$export($3a016e333d7347e3$exports, "redirectUriEmpty", () => $3a016e333d7347e3$export$7a02f9bdce79dd4e);
$parcel$export($3a016e333d7347e3$exports, "claimsRequestParsingError", () => $3a016e333d7347e3$export$561c97672a478709);
$parcel$export($3a016e333d7347e3$exports, "authorityUriInsecure", () => $3a016e333d7347e3$export$f77c6af656c8444b);
$parcel$export($3a016e333d7347e3$exports, "urlParseError", () => $3a016e333d7347e3$export$ee2a1a3389f75508);
$parcel$export($3a016e333d7347e3$exports, "urlEmptyError", () => $3a016e333d7347e3$export$859df485a5e0f239);
$parcel$export($3a016e333d7347e3$exports, "emptyInputScopesError", () => $3a016e333d7347e3$export$6ac27379c42383f);
$parcel$export($3a016e333d7347e3$exports, "invalidPromptValue", () => $3a016e333d7347e3$export$ccbe5d2d7c960c35);
$parcel$export($3a016e333d7347e3$exports, "invalidClaims", () => $3a016e333d7347e3$export$96e755c70e0d0e34);
$parcel$export($3a016e333d7347e3$exports, "tokenRequestEmpty", () => $3a016e333d7347e3$export$eca67ff7a91fed9d);
$parcel$export($3a016e333d7347e3$exports, "logoutRequestEmpty", () => $3a016e333d7347e3$export$9eb2eeb401492d88);
$parcel$export($3a016e333d7347e3$exports, "invalidCodeChallengeMethod", () => $3a016e333d7347e3$export$b8d8b332f17376dc);
$parcel$export($3a016e333d7347e3$exports, "pkceParamsMissing", () => $3a016e333d7347e3$export$2da3866b327f1753);
$parcel$export($3a016e333d7347e3$exports, "invalidCloudDiscoveryMetadata", () => $3a016e333d7347e3$export$92a2985751150ca5);
$parcel$export($3a016e333d7347e3$exports, "invalidAuthorityMetadata", () => $3a016e333d7347e3$export$edb4d5942bc8ccff);
$parcel$export($3a016e333d7347e3$exports, "untrustedAuthority", () => $3a016e333d7347e3$export$50c3162fda5f57);
$parcel$export($3a016e333d7347e3$exports, "missingSshJwk", () => $3a016e333d7347e3$export$8fbed44b22d9136f);
$parcel$export($3a016e333d7347e3$exports, "missingSshKid", () => $3a016e333d7347e3$export$b728bd8a588956c);
$parcel$export($3a016e333d7347e3$exports, "missingNonceAuthenticationHeader", () => $3a016e333d7347e3$export$4f88b4462bcef15f);
$parcel$export($3a016e333d7347e3$exports, "invalidAuthenticationHeader", () => $3a016e333d7347e3$export$bea58e1a2e503b59);
$parcel$export($3a016e333d7347e3$exports, "cannotSetOIDCOptions", () => $3a016e333d7347e3$export$a5c9fbb90473dca2);
$parcel$export($3a016e333d7347e3$exports, "cannotAllowNativeBroker", () => $3a016e333d7347e3$export$26a4f4cbf9747475);
$parcel$export($3a016e333d7347e3$exports, "authorityMismatch", () => $3a016e333d7347e3$export$91415fb6baea5d09);
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $3a016e333d7347e3$export$7a02f9bdce79dd4e = "redirect_uri_empty";
const $3a016e333d7347e3$export$561c97672a478709 = "claims_request_parsing_error";
const $3a016e333d7347e3$export$f77c6af656c8444b = "authority_uri_insecure";
const $3a016e333d7347e3$export$ee2a1a3389f75508 = "url_parse_error";
const $3a016e333d7347e3$export$859df485a5e0f239 = "empty_url_error";
const $3a016e333d7347e3$export$6ac27379c42383f = "empty_input_scopes_error";
const $3a016e333d7347e3$export$ccbe5d2d7c960c35 = "invalid_prompt_value";
const $3a016e333d7347e3$export$96e755c70e0d0e34 = "invalid_claims";
const $3a016e333d7347e3$export$eca67ff7a91fed9d = "token_request_empty";
const $3a016e333d7347e3$export$9eb2eeb401492d88 = "logout_request_empty";
const $3a016e333d7347e3$export$b8d8b332f17376dc = "invalid_code_challenge_method";
const $3a016e333d7347e3$export$2da3866b327f1753 = "pkce_params_missing";
const $3a016e333d7347e3$export$92a2985751150ca5 = "invalid_cloud_discovery_metadata";
const $3a016e333d7347e3$export$edb4d5942bc8ccff = "invalid_authority_metadata";
const $3a016e333d7347e3$export$50c3162fda5f57 = "untrusted_authority";
const $3a016e333d7347e3$export$8fbed44b22d9136f = "missing_ssh_jwk";
const $3a016e333d7347e3$export$b728bd8a588956c = "missing_ssh_kid";
const $3a016e333d7347e3$export$4f88b4462bcef15f = "missing_nonce_authentication_header";
const $3a016e333d7347e3$export$bea58e1a2e503b59 = "invalid_authentication_header";
const $3a016e333d7347e3$export$a5c9fbb90473dca2 = "cannot_set_OIDCOptions";
const $3a016e333d7347e3$export$26a4f4cbf9747475 = "cannot_allow_native_broker";
const $3a016e333d7347e3$export$91415fb6baea5d09 = "authority_mismatch";

/*! @azure/msal-common v14.16.1 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $350dc36ccc5c7715$export$45752b5111a13710 = {
    [(0, $3a016e333d7347e3$export$7a02f9bdce79dd4e)]: "A redirect URI is required for all calls, and none has been set.",
    [(0, $3a016e333d7347e3$export$561c97672a478709)]: "Could not parse the given claims request object.",
    [(0, $3a016e333d7347e3$export$f77c6af656c8444b)]: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options",
    [(0, $3a016e333d7347e3$export$ee2a1a3389f75508)]: "URL could not be parsed into appropriate segments.",
    [(0, $3a016e333d7347e3$export$859df485a5e0f239)]: "URL was empty or null.",
    [(0, $3a016e333d7347e3$export$6ac27379c42383f)]: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token.",
    [(0, $3a016e333d7347e3$export$ccbe5d2d7c960c35)]: "Please see here for valid configuration options: https://azuread.github.io/microsoft-authentication-library-for-js/ref/modules/_azure_msal_common.html#commonauthorizationurlrequest",
    [(0, $3a016e333d7347e3$export$96e755c70e0d0e34)]: "Given claims parameter must be a stringified JSON object.",
    [(0, $3a016e333d7347e3$export$eca67ff7a91fed9d)]: "Token request was empty and not found in cache.",
    [(0, $3a016e333d7347e3$export$9eb2eeb401492d88)]: "The logout request was null or undefined.",
    [(0, $3a016e333d7347e3$export$b8d8b332f17376dc)]: 'code_challenge_method passed is invalid. Valid values are "plain" and "S256".',
    [(0, $3a016e333d7347e3$export$2da3866b327f1753)]: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request",
    [(0, $3a016e333d7347e3$export$92a2985751150ca5)]: "Invalid cloudDiscoveryMetadata provided. Must be a stringified JSON object containing tenant_discovery_endpoint and metadata fields",
    [(0, $3a016e333d7347e3$export$edb4d5942bc8ccff)]: "Invalid authorityMetadata provided. Must by a stringified JSON object containing authorization_endpoint, token_endpoint, issuer fields.",
    [(0, $3a016e333d7347e3$export$50c3162fda5f57)]: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter.",
    [(0, $3a016e333d7347e3$export$8fbed44b22d9136f)]: "Missing sshJwk in SSH certificate request. A stringified JSON Web Key is required when using the SSH authentication scheme.",
    [(0, $3a016e333d7347e3$export$b728bd8a588956c)]: "Missing sshKid in SSH certificate request. A string that uniquely identifies the public SSH key is required when using the SSH authentication scheme.",
    [(0, $3a016e333d7347e3$export$4f88b4462bcef15f)]: "Unable to find an authentication header containing server nonce. Either the Authentication-Info or WWW-Authenticate headers must be present in order to obtain a server nonce.",
    [(0, $3a016e333d7347e3$export$bea58e1a2e503b59)]: "Invalid authentication header provided",
    [(0, $3a016e333d7347e3$export$a5c9fbb90473dca2)]: "Cannot set OIDCOptions parameter. Please change the protocol mode to OIDC or use a non-Microsoft authority.",
    [(0, $3a016e333d7347e3$export$26a4f4cbf9747475)]: "Cannot set allowNativeBroker parameter to true when not in AAD protocol mode.",
    [(0, $3a016e333d7347e3$export$91415fb6baea5d09)]: "Authority mismatch error. Authority provided in login request or PublicClientApplication config does not match the environment of the provided account. Please use a matching account or make an interactive request to login to this authority."
};
/**
 * ClientConfigurationErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use ClientConfigurationErrorCodes instead
 */ const $350dc36ccc5c7715$export$8a1024301e8298df = {
    redirectUriNotSet: {
        code: (0, $3a016e333d7347e3$export$7a02f9bdce79dd4e),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$7a02f9bdce79dd4e]
    },
    claimsRequestParsingError: {
        code: (0, $3a016e333d7347e3$export$561c97672a478709),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$561c97672a478709]
    },
    authorityUriInsecure: {
        code: (0, $3a016e333d7347e3$export$f77c6af656c8444b),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$f77c6af656c8444b]
    },
    urlParseError: {
        code: (0, $3a016e333d7347e3$export$ee2a1a3389f75508),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$ee2a1a3389f75508]
    },
    urlEmptyError: {
        code: (0, $3a016e333d7347e3$export$859df485a5e0f239),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$859df485a5e0f239]
    },
    emptyScopesError: {
        code: (0, $3a016e333d7347e3$export$6ac27379c42383f),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$6ac27379c42383f]
    },
    invalidPrompt: {
        code: (0, $3a016e333d7347e3$export$ccbe5d2d7c960c35),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$ccbe5d2d7c960c35]
    },
    invalidClaimsRequest: {
        code: (0, $3a016e333d7347e3$export$96e755c70e0d0e34),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$96e755c70e0d0e34]
    },
    tokenRequestEmptyError: {
        code: (0, $3a016e333d7347e3$export$eca67ff7a91fed9d),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$eca67ff7a91fed9d]
    },
    logoutRequestEmptyError: {
        code: (0, $3a016e333d7347e3$export$9eb2eeb401492d88),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$9eb2eeb401492d88]
    },
    invalidCodeChallengeMethod: {
        code: (0, $3a016e333d7347e3$export$b8d8b332f17376dc),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$b8d8b332f17376dc]
    },
    invalidCodeChallengeParams: {
        code: (0, $3a016e333d7347e3$export$2da3866b327f1753),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$2da3866b327f1753]
    },
    invalidCloudDiscoveryMetadata: {
        code: (0, $3a016e333d7347e3$export$92a2985751150ca5),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$92a2985751150ca5]
    },
    invalidAuthorityMetadata: {
        code: (0, $3a016e333d7347e3$export$edb4d5942bc8ccff),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$edb4d5942bc8ccff]
    },
    untrustedAuthority: {
        code: (0, $3a016e333d7347e3$export$50c3162fda5f57),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$50c3162fda5f57]
    },
    missingSshJwk: {
        code: (0, $3a016e333d7347e3$export$8fbed44b22d9136f),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$8fbed44b22d9136f]
    },
    missingSshKid: {
        code: (0, $3a016e333d7347e3$export$b728bd8a588956c),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$b728bd8a588956c]
    },
    missingNonceAuthenticationHeader: {
        code: (0, $3a016e333d7347e3$export$4f88b4462bcef15f),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$4f88b4462bcef15f]
    },
    invalidAuthenticationHeader: {
        code: (0, $3a016e333d7347e3$export$bea58e1a2e503b59),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$bea58e1a2e503b59]
    },
    cannotSetOIDCOptions: {
        code: (0, $3a016e333d7347e3$export$a5c9fbb90473dca2),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$a5c9fbb90473dca2]
    },
    cannotAllowNativeBroker: {
        code: (0, $3a016e333d7347e3$export$26a4f4cbf9747475),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$26a4f4cbf9747475]
    },
    authorityMismatch: {
        code: (0, $3a016e333d7347e3$export$91415fb6baea5d09),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$91415fb6baea5d09]
    }
};
/**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ class $350dc36ccc5c7715$export$ac9d9d20c2327339 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode){
        super(errorCode, $350dc36ccc5c7715$export$45752b5111a13710[errorCode]);
        this.name = "ClientConfigurationError";
        Object.setPrototypeOf(this, $350dc36ccc5c7715$export$ac9d9d20c2327339.prototype);
    }
}
function $350dc36ccc5c7715$export$5d63d098f4f130a1(errorCode) {
    return new $350dc36ccc5c7715$export$ac9d9d20c2327339(errorCode);
}

/*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $dd88ab1a0b4d3851$export$865f57d401606752 = {
    createNewGuid: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    base64Decode: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    base64Encode: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    base64UrlEncode: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    encodeKid: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async getPublicKeyThumbprint () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async removeTokenBindingKey () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async clearKeystore () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async signJwt () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async hashString () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
};




/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/* eslint-disable header/header */ const $4c1e49235f95193e$export$a8ff84c12d48cfa6 = "@azure/msal-common";
const $4c1e49235f95193e$export$83d89fbfd8236492 = "14.16.1";



/*! @azure/msal-common v14.16.1 2025-08-05 */ 
var $9ab3d26df56b176d$exports = {};

$parcel$export($9ab3d26df56b176d$exports, "generateCredentialKey", () => $9ab3d26df56b176d$export$1aaa1362083ec7a3);
$parcel$export($9ab3d26df56b176d$exports, "createIdTokenEntity", () => $9ab3d26df56b176d$export$d8a173a23f325769);
$parcel$export($9ab3d26df56b176d$exports, "createAccessTokenEntity", () => $9ab3d26df56b176d$export$fa005e75d915b6db);
$parcel$export($9ab3d26df56b176d$exports, "createRefreshTokenEntity", () => $9ab3d26df56b176d$export$9095b5885dfa55cc);
$parcel$export($9ab3d26df56b176d$exports, "isCredentialEntity", () => $9ab3d26df56b176d$export$b8fc93e8af17dc04);
$parcel$export($9ab3d26df56b176d$exports, "isAccessTokenEntity", () => $9ab3d26df56b176d$export$d7e6bcc84cf680df);
$parcel$export($9ab3d26df56b176d$exports, "isIdTokenEntity", () => $9ab3d26df56b176d$export$71eec93d11c94dfc);
$parcel$export($9ab3d26df56b176d$exports, "isRefreshTokenEntity", () => $9ab3d26df56b176d$export$f1bb3af43d5b8bc7);
$parcel$export($9ab3d26df56b176d$exports, "isServerTelemetryEntity", () => $9ab3d26df56b176d$export$7ad16989078344e5);
$parcel$export($9ab3d26df56b176d$exports, "isThrottlingEntity", () => $9ab3d26df56b176d$export$7e43cc7efaf4bec2);
$parcel$export($9ab3d26df56b176d$exports, "generateAppMetadataKey", () => $9ab3d26df56b176d$export$ddbc6773ab812685);
$parcel$export($9ab3d26df56b176d$exports, "isAppMetadataEntity", () => $9ab3d26df56b176d$export$bb2a01b66d0b3486);
$parcel$export($9ab3d26df56b176d$exports, "isAuthorityMetadataEntity", () => $9ab3d26df56b176d$export$6231cab310116b3c);
$parcel$export($9ab3d26df56b176d$exports, "generateAuthorityMetadataExpiresAt", () => $9ab3d26df56b176d$export$90f464c4238c27e5);
$parcel$export($9ab3d26df56b176d$exports, "updateAuthorityEndpointMetadata", () => $9ab3d26df56b176d$export$ef87e8fbd8af5f96);
$parcel$export($9ab3d26df56b176d$exports, "updateCloudDiscoveryMetadata", () => $9ab3d26df56b176d$export$6d4972e1d88c8518);
$parcel$export($9ab3d26df56b176d$exports, "isAuthorityMetadataExpired", () => $9ab3d26df56b176d$export$b96839cf63a15b0f);
/*! @azure/msal-common v14.16.1 2025-08-05 */ var $b29e27fb146a7ddd$exports = {};

$parcel$export($b29e27fb146a7ddd$exports, "extractTokenClaims", () => $b29e27fb146a7ddd$export$8a59e6f35fb00518);
$parcel$export($b29e27fb146a7ddd$exports, "getJWSPayload", () => $b29e27fb146a7ddd$export$b9f318d6daf53c97);
$parcel$export($b29e27fb146a7ddd$exports, "checkMaxAge", () => $b29e27fb146a7ddd$export$ee7a34ea7880144c);
/*! @azure/msal-common v14.16.1 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extract token by decoding the rawToken
 *
 * @param encodedToken
 */ function $b29e27fb146a7ddd$export$8a59e6f35fb00518(encodedToken, base64Decode) {
    const jswPayload = $b29e27fb146a7ddd$export$b9f318d6daf53c97(encodedToken);
    // token will be decoded to get the username
    try {
        // base64Decode() should throw an error if there is an issue
        const base64Decoded = base64Decode(jswPayload);
        return JSON.parse(base64Decoded);
    } catch (err) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ad362b2e3a260143));
    }
}
/**
 * decode a JWT
 *
 * @param authToken
 */ function $b29e27fb146a7ddd$export$b9f318d6daf53c97(authToken) {
    if (!authToken) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$78d01e29cb494be2));
    const tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
    const matches = tokenPartsRegex.exec(authToken);
    if (!matches || matches.length < 4) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ad362b2e3a260143));
    /**
     * const crackedToken = {
     *  header: matches[1],
     *  JWSPayload: matches[2],
     *  JWSSig: matches[3],
     * };
     */ return matches[2];
}
/**
 * Determine if the token's max_age has transpired
 */ function $b29e27fb146a7ddd$export$ee7a34ea7880144c(authTime, maxAge) {
    /*
     * per https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * To force an immediate re-authentication: If an app requires that a user re-authenticate prior to access,
     * provide a value of 0 for the max_age parameter and the AS will force a fresh login.
     */ const fiveMinuteSkew = 300000; // five minutes in milliseconds
    if (maxAge === 0 || Date.now() - fiveMinuteSkew > authTime + maxAge) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$f95fb86904f89749));
}




var $0a4a8f22735f9ff5$exports = {};

$parcel$export($0a4a8f22735f9ff5$exports, "nowSeconds", () => $0a4a8f22735f9ff5$export$ae62599a119ac50a);
$parcel$export($0a4a8f22735f9ff5$exports, "isTokenExpired", () => $0a4a8f22735f9ff5$export$b007d77a962aa175);
$parcel$export($0a4a8f22735f9ff5$exports, "wasClockTurnedBack", () => $0a4a8f22735f9ff5$export$8961be72dcbc368e);
$parcel$export($0a4a8f22735f9ff5$exports, "delay", () => $0a4a8f22735f9ff5$export$1391212d75b2ee65);
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for managing date and time operations.
 */ /**
 * return the current time in Unix time (seconds).
 */ function $0a4a8f22735f9ff5$export$ae62599a119ac50a() {
    // Date.getTime() returns in milliseconds.
    return Math.round(new Date().getTime() / 1000.0);
}
/**
 * check if a token is expired based on given UTC time in seconds.
 * @param expiresOn
 */ function $0a4a8f22735f9ff5$export$b007d77a962aa175(expiresOn, offset) {
    // check for access token expiry
    const expirationSec = Number(expiresOn) || 0;
    const offsetCurrentTimeSec = $0a4a8f22735f9ff5$export$ae62599a119ac50a() + offset;
    // If current time + offset is greater than token expiration time, then token is expired.
    return offsetCurrentTimeSec > expirationSec;
}
/**
 * If the current time is earlier than the time that a token was cached at, we must discard the token
 * i.e. The system clock was turned back after acquiring the cached token
 * @param cachedAt
 * @param offset
 */ function $0a4a8f22735f9ff5$export$8961be72dcbc368e(cachedAt) {
    const cachedAtSec = Number(cachedAt);
    return cachedAtSec > $0a4a8f22735f9ff5$export$ae62599a119ac50a();
}
/**
 * Waits for t number of milliseconds
 * @param t number
 * @param value T
 */ function $0a4a8f22735f9ff5$export$1391212d75b2ee65(t, value) {
    return new Promise((resolve)=>setTimeout(()=>resolve(value), t));
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Cache Key: <home_account_id>-<environment>-<credential_type>-<client_id or familyId>-<realm>-<scopes>-<claims hash>-<scheme>
 * IdToken Example: uid.utid-login.microsoftonline.com-idtoken-app_client_id-contoso.com
 * AccessToken Example: uid.utid-login.microsoftonline.com-accesstoken-app_client_id-contoso.com-scope1 scope2--pop
 * RefreshToken Example: uid.utid-login.microsoftonline.com-refreshtoken-1-contoso.com
 * @param credentialEntity
 * @returns
 */ function $9ab3d26df56b176d$export$1aaa1362083ec7a3(credentialEntity) {
    const credentialKey = [
        $9ab3d26df56b176d$var$generateAccountId(credentialEntity),
        $9ab3d26df56b176d$var$generateCredentialId(credentialEntity),
        $9ab3d26df56b176d$var$generateTarget(credentialEntity),
        $9ab3d26df56b176d$var$generateClaimsHash(credentialEntity),
        $9ab3d26df56b176d$var$generateScheme(credentialEntity)
    ];
    return credentialKey.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Create IdTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $9ab3d26df56b176d$export$d8a173a23f325769(homeAccountId, environment, idToken, clientId, tenantId) {
    const idTokenEntity = {
        credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: idToken,
        realm: tenantId
    };
    return idTokenEntity;
}
/**
 * Create AccessTokenEntity
 * @param homeAccountId
 * @param environment
 * @param accessToken
 * @param clientId
 * @param tenantId
 * @param scopes
 * @param expiresOn
 * @param extExpiresOn
 */ function $9ab3d26df56b176d$export$fa005e75d915b6db(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, base64Decode, refreshOn, tokenType, userAssertionHash, keyId, requestedClaims, requestedClaimsHash) {
    const atEntity = {
        homeAccountId: homeAccountId,
        credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN,
        secret: accessToken,
        cachedAt: (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)().toString(),
        expiresOn: expiresOn.toString(),
        extendedExpiresOn: extExpiresOn.toString(),
        environment: environment,
        clientId: clientId,
        realm: tenantId,
        target: scopes,
        tokenType: tokenType || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER
    };
    if (userAssertionHash) atEntity.userAssertionHash = userAssertionHash;
    if (refreshOn) atEntity.refreshOn = refreshOn.toString();
    if (requestedClaims) {
        atEntity.requestedClaims = requestedClaims;
        atEntity.requestedClaimsHash = requestedClaimsHash;
    }
    /*
     * Create Access Token With Auth Scheme instead of regular access token
     * Cast to lower to handle "bearer" from ADFS
     */ if (atEntity.tokenType?.toLowerCase() !== (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER.toLowerCase()) {
        atEntity.credentialType = (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        switch(atEntity.tokenType){
            case (0, $7c375ae106b964be$export$901491a717da2ba5).POP:
                // Make sure keyId is present and add it to credential
                const tokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(accessToken, base64Decode);
                if (!tokenClaims?.cnf?.kid) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$6f89b8a7d491b526));
                atEntity.keyId = tokenClaims.cnf.kid;
                break;
            case (0, $7c375ae106b964be$export$901491a717da2ba5).SSH:
                atEntity.keyId = keyId;
        }
    }
    return atEntity;
}
/**
 * Create RefreshTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $9ab3d26df56b176d$export$9095b5885dfa55cc(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash, expiresOn) {
    const rtEntity = {
        credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: refreshToken
    };
    if (userAssertionHash) rtEntity.userAssertionHash = userAssertionHash;
    if (familyId) rtEntity.familyId = familyId;
    if (expiresOn) rtEntity.expiresOn = expiresOn.toString();
    return rtEntity;
}
function $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) {
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$d7e6bcc84cf680df(entity) {
    if (!entity) return false;
    return $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity.hasOwnProperty("target") && (entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN || entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME);
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$71eec93d11c94dfc(entity) {
    if (!entity) return false;
    return $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN;
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$f1bb3af43d5b8bc7(entity) {
    if (!entity) return false;
    return $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) && entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN;
}
/**
 * Generate Account Id key component as per the schema: <home_account_id>-<environment>
 */ function $9ab3d26df56b176d$var$generateAccountId(credentialEntity) {
    const accountId = [
        credentialEntity.homeAccountId,
        credentialEntity.environment
    ];
    return accountId.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Generate Credential Id key component as per the schema: <credential_type>-<client_id>-<realm>
 */ function $9ab3d26df56b176d$var$generateCredentialId(credentialEntity) {
    const clientOrFamilyId = credentialEntity.credentialType === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN ? credentialEntity.familyId || credentialEntity.clientId : credentialEntity.clientId;
    const credentialId = [
        credentialEntity.credentialType,
        clientOrFamilyId,
        credentialEntity.realm || ""
    ];
    return credentialId.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Generate target key component as per schema: <target>
 */ function $9ab3d26df56b176d$var$generateTarget(credentialEntity) {
    return (credentialEntity.target || "").toLowerCase();
}
/**
 * Generate requested claims key component as per schema: <requestedClaims>
 */ function $9ab3d26df56b176d$var$generateClaimsHash(credentialEntity) {
    return (credentialEntity.requestedClaimsHash || "").toLowerCase();
}
/**
 * Generate scheme key componenet as per schema: <scheme>
 */ function $9ab3d26df56b176d$var$generateScheme(credentialEntity) {
    /*
     * PoP Tokens and SSH certs include scheme in cache key
     * Cast to lowercase to handle "bearer" from ADFS
     */ return credentialEntity.tokenType && credentialEntity.tokenType.toLowerCase() !== (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER.toLowerCase() ? credentialEntity.tokenType.toLowerCase() : "";
}
/**
 * validates if a given cache entry is "Telemetry", parses <key,value>
 * @param key
 * @param entity
 */ function $9ab3d26df56b176d$export$7ad16989078344e5(key, entity) {
    const validateKey = key.indexOf((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CACHE_KEY) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
    return validateKey && validateEntity;
}
/**
 * validates if a given cache entry is "Throttling", parses <key,value>
 * @param key
 * @param entity
 */ function $9ab3d26df56b176d$export$7e43cc7efaf4bec2(key, entity) {
    let validateKey = false;
    if (key) validateKey = key.indexOf((0, $7c375ae106b964be$export$a2330d6808e6d893).THROTTLING_PREFIX) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
    return validateKey && validateEntity;
}
/**
 * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
 */ function $9ab3d26df56b176d$export$ddbc6773ab812685({ environment: environment, clientId: clientId }) {
    const appMetaDataKeyArray = [
        (0, $7c375ae106b964be$export$7e1bea6dc1b6b32e),
        environment,
        clientId
    ];
    return appMetaDataKeyArray.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/*
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$bb2a01b66d0b3486(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $7c375ae106b964be$export$7e1bea6dc1b6b32e)) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$6231cab310116b3c(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $7c375ae106b964be$export$d483f966e66f4db5).CACHE_KEY) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
}
/**
 * Reset the exiresAt value
 */ function $9ab3d26df56b176d$export$90f464c4238c27e5() {
    return (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)() + (0, $7c375ae106b964be$export$d483f966e66f4db5).REFRESH_TIME_SECONDS;
}
function $9ab3d26df56b176d$export$ef87e8fbd8af5f96(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.authorization_endpoint = updatedValues.authorization_endpoint;
    authorityMetadata.token_endpoint = updatedValues.token_endpoint;
    authorityMetadata.end_session_endpoint = updatedValues.end_session_endpoint;
    authorityMetadata.issuer = updatedValues.issuer;
    authorityMetadata.endpointsFromNetwork = fromNetwork;
    authorityMetadata.jwks_uri = updatedValues.jwks_uri;
}
function $9ab3d26df56b176d$export$6d4972e1d88c8518(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.aliases = updatedValues.aliases;
    authorityMetadata.preferred_cache = updatedValues.preferred_cache;
    authorityMetadata.preferred_network = updatedValues.preferred_network;
    authorityMetadata.aliasesFromNetwork = fromNetwork;
}
/**
 * Returns whether or not the data needs to be refreshed
 */ function $9ab3d26df56b176d$export$b96839cf63a15b0f(metadata) {
    return metadata.expiresAt <= (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)();
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ class $442eacaa0418a38d$export$ecc754f99843e759 {
    /**
     * Check if stringified object is empty
     * @param strObj
     */ static isEmptyObj(strObj) {
        if (strObj) try {
            const obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    }
    static startsWith(str, search) {
        return str.indexOf(search) === 0;
    }
    static endsWith(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    }
    /**
     * Parses string into an object.
     *
     * @param query
     */ static queryStringToObject(query) {
        const obj = {};
        const params = query.split("&");
        const decode = (s)=>decodeURIComponent(s.replace(/\+/g, " "));
        params.forEach((pair)=>{
            if (pair.trim()) {
                const [key, value] = pair.split(/=(.+)/g, 2); // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    }
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ static trimArrayEntries(arr) {
        return arr.map((entry)=>entry.trim());
    }
    /**
     * Removes empty strings from array
     * @param arr
     */ static removeEmptyStringsFromArray(arr) {
        return arr.filter((entry)=>{
            return !!entry;
        });
    }
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ static jsonParseHelper(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }
    /**
     * Tests if a given string matches a given pattern, with support for wildcards and queries.
     * @param pattern Wildcard pattern to string match. Supports "*" for wildcards and "?" for queries
     * @param input String to match against
     */ static matchPattern(pattern, input) {
        /**
         * Wildcard support: https://stackoverflow.com/a/3117248/4888559
         * Queries: replaces "?" in string with escaped "\?" for regex test
         */ // eslint-disable-next-line security/detect-non-literal-regexp
        const regex = new RegExp(pattern.replace(/\\/g, "\\\\").replace(/\*/g, "[^ ]*").replace(/\?/g, "\\?"));
        return regex.test(input);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ class $74ffed612cd8faee$export$b9b82b0f94ae1f99 {
    constructor(inputScopes){
        // Filter empty string and null/undefined array items
        const scopeArr = inputScopes ? (0, $442eacaa0418a38d$export$ecc754f99843e759).trimArrayEntries([
            ...inputScopes
        ]) : [];
        const filteredInput = scopeArr ? (0, $442eacaa0418a38d$export$ecc754f99843e759).removeEmptyStringsFromArray(scopeArr) : [];
        // Validate and filter scopes (validate function throws if validation fails)
        this.validateInputScopes(filteredInput);
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach((scope)=>this.scopes.add(scope));
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ static fromString(inputScopeString) {
        const scopeString = inputScopeString || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const inputScopes = scopeString.split(" ");
        return new $74ffed612cd8faee$export$b9b82b0f94ae1f99(inputScopes);
    }
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ static createSearchScopes(inputScopeString) {
        const scopeSet = new $74ffed612cd8faee$export$b9b82b0f94ae1f99(inputScopeString);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope((0, $7c375ae106b964be$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE);
        return scopeSet;
    }
    /**
     * Used to validate the scopes input parameter requested  by the developer.
     * @param {Array<string>} inputScopes - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
     * @param {boolean} scopesRequired - Boolean indicating whether the scopes array is required or not
     */ validateInputScopes(inputScopes) {
        // Check if scopes are required but not given or is an empty array
        if (!inputScopes || inputScopes.length < 1) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$6ac27379c42383f));
    }
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ containsScope(scope) {
        const lowerCaseScopes = this.printScopesLowerCase().split(" ");
        const lowerCaseScopesSet = new $74ffed612cd8faee$export$b9b82b0f94ae1f99(lowerCaseScopes);
        // compare lowercase scopes
        return scope ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    }
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ containsScopeSet(scopeSet) {
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every((scope)=>this.containsScope(scope));
    }
    /**
     * Check if set of scopes contains only the defaults
     */ containsOnlyOIDCScopes() {
        let defaultScopeCount = 0;
        (0, $7c375ae106b964be$export$268e88275f5afab2).forEach((defaultScope)=>{
            if (this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    }
    /**
     * Appends single scope if passed
     * @param newScope
     */ appendScope(newScope) {
        if (newScope) this.scopes.add(newScope.trim());
    }
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ appendScopes(newScopes) {
        try {
            newScopes.forEach((newScope)=>this.appendScope(newScope));
        } catch (e) {
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$93883786cf4a4a27));
        }
    }
    /**
     * Removes element from set of scopes.
     * @param scope
     */ removeScope(scope) {
        if (!scope) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$f7a276c01beb068a));
        this.scopes.delete(scope.trim());
    }
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ removeOIDCScopes() {
        (0, $7c375ae106b964be$export$268e88275f5afab2).forEach((defaultScope)=>{
            this.scopes.delete(defaultScope);
        });
    }
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ unionScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$41e2ce5958c42c83));
        const unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        this.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        return unionScopes;
    }
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ intersectingScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$41e2ce5958c42c83));
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        const unionScopes = this.unionScopeSets(otherScopes);
        const sizeOtherScopes = otherScopes.getScopeCount();
        const sizeThisScopes = this.getScopeCount();
        const sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    }
    /**
     * Returns size of set of scopes.
     */ getScopeCount() {
        return this.scopes.size;
    }
    /**
     * Returns the scopes as an array of string values
     */ asArray() {
        const array = [];
        this.scopes.forEach((val)=>array.push(val));
        return array;
    }
    /**
     * Prints scopes into a space-delimited string
     */ printScopes() {
        if (this.scopes) {
            const scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
    }
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ printScopesLowerCase() {
        return this.printScopes().toLowerCase();
    }
}







/*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 


var $0763983a1d35c4b8$exports = {};

$parcel$export($0763983a1d35c4b8$exports, "stripLeadingHashOrQuery", () => $0763983a1d35c4b8$export$fe89dd256736a6b3);
$parcel$export($0763983a1d35c4b8$exports, "getDeserializedResponse", () => $0763983a1d35c4b8$export$f98e0976781b1204);
/*! @azure/msal-common v14.16.1 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Parses hash string from given string. Returns empty string if no hash symbol is found.
 * @param hashString
 */ function $0763983a1d35c4b8$export$fe89dd256736a6b3(responseString) {
    if (responseString.startsWith("#/")) return responseString.substring(2);
    else if (responseString.startsWith("#") || responseString.startsWith("?")) return responseString.substring(1);
    return responseString;
}
/**
 * Returns URL hash as server auth code response object.
 */ function $0763983a1d35c4b8$export$f98e0976781b1204(responseString) {
    // Check if given hash is empty
    if (!responseString || responseString.indexOf("=") < 0) return null;
    try {
        // Strip the # or ? symbol if present
        const normalizedResponse = $0763983a1d35c4b8$export$fe89dd256736a6b3(responseString);
        // If # symbol was not present, above will return empty string, so give original hash value
        const deserializedHash = Object.fromEntries(new URLSearchParams(normalizedResponse));
        // Check for known response properties
        if (deserializedHash.code || deserializedHash.error || deserializedHash.error_description || deserializedHash.state) return deserializedHash;
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$14c4d54a8414667f));
    }
    return null;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ class $f7f911f196324278$export$3abcdca7229e54f2 {
    get urlString() {
        return this._urlString;
    }
    constructor(url){
        this._urlString = url;
        if (!this._urlString) // Throws error if url is empty
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$859df485a5e0f239));
        if (!url.includes("#")) this._urlString = $f7f911f196324278$export$3abcdca7229e54f2.canonicalizeUri(url);
    }
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ static canonicalizeUri(url) {
        if (url) {
            let lowerCaseUrl = url.toLowerCase();
            if ((0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ((0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!(0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    }
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ validateAsUri() {
        // Attempts to parse url for uri components
        let components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$f77c6af656c8444b));
    }
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ static appendQueryString(url, queryString) {
        if (!queryString) return url;
        return url.indexOf("?") < 0 ? `${url}?${queryString}` : `${url}&${queryString}`;
    }
    /**
     * Returns a url with the hash removed
     * @param url
     */ static removeHashFromUrl(url) {
        return $f7f911f196324278$export$3abcdca7229e54f2.canonicalizeUri(url.split("#")[0]);
    }
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ replaceTenantPath(tenantId) {
        const urlObject = this.getUrlComponents();
        const pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === (0, $7c375ae106b964be$export$e18ac120172ed505).COMMON || pathArray[0] === (0, $7c375ae106b964be$export$e18ac120172ed505).ORGANIZATIONS)) pathArray[0] = tenantId;
        return $f7f911f196324278$export$3abcdca7229e54f2.constructAuthorityUriFromObject(urlObject);
    }
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ getUrlComponents() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        const regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        const match = this.urlString.match(regEx);
        if (!match) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        // Url component object
        const urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        let pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter((val)=>val && val.length > 0); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (urlComponents.QueryString && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    }
    static getDomainFromUrl(url) {
        const regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        const match = url.match(regEx);
        if (!match) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        return match[2];
    }
    static getAbsoluteUrl(relativeUrl, baseUrl) {
        if (relativeUrl[0] === (0, $7c375ae106b964be$export$a002182e51710d39).FORWARD_SLASH) {
            const url = new $f7f911f196324278$export$3abcdca7229e54f2(baseUrl);
            const baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    }
    static constructAuthorityUriFromObject(urlObject) {
        return new $f7f911f196324278$export$3abcdca7229e54f2(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
    }
    /**
     * Check if the hash of the URL string contains known properties
     * @deprecated This API will be removed in a future version
     */ static hashContainsKnownProperties(response) {
        return !!(0, $0763983a1d35c4b8$export$f98e0976781b1204)(response);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $ff4bd32e3511744b$export$223f43dfec89cb87 = {
    endpointMetadata: {
        "login.microsoftonline.com": {
            token_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.com/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.com/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/logout"
        },
        "login.chinacloudapi.cn": {
            token_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.chinacloudapi.cn/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.partner.microsoftonline.cn/{tenantid}/v2.0",
            authorization_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/logout"
        },
        "login.microsoftonline.us": {
            token_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.us/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.us/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/logout"
        }
    },
    instanceDiscoveryMetadata: {
        tenant_discovery_endpoint: "https://{canonicalAuthority}/v2.0/.well-known/openid-configuration",
        metadata: [
            {
                preferred_network: "login.microsoftonline.com",
                preferred_cache: "login.windows.net",
                aliases: [
                    "login.microsoftonline.com",
                    "login.windows.net",
                    "login.microsoft.com",
                    "sts.windows.net"
                ]
            },
            {
                preferred_network: "login.partner.microsoftonline.cn",
                preferred_cache: "login.partner.microsoftonline.cn",
                aliases: [
                    "login.partner.microsoftonline.cn",
                    "login.chinacloudapi.cn"
                ]
            },
            {
                preferred_network: "login.microsoftonline.de",
                preferred_cache: "login.microsoftonline.de",
                aliases: [
                    "login.microsoftonline.de"
                ]
            },
            {
                preferred_network: "login.microsoftonline.us",
                preferred_cache: "login.microsoftonline.us",
                aliases: [
                    "login.microsoftonline.us",
                    "login.usgovcloudapi.net"
                ]
            },
            {
                preferred_network: "login-us.microsoftonline.com",
                preferred_cache: "login-us.microsoftonline.com",
                aliases: [
                    "login-us.microsoftonline.com"
                ]
            }
        ]
    }
};
const $ff4bd32e3511744b$export$f612854287391207 = $ff4bd32e3511744b$export$223f43dfec89cb87.endpointMetadata;
const $ff4bd32e3511744b$export$a21acafc3b6f5582 = $ff4bd32e3511744b$export$223f43dfec89cb87.instanceDiscoveryMetadata;
const $ff4bd32e3511744b$export$7d026f079148cd31 = new Set();
$ff4bd32e3511744b$export$a21acafc3b6f5582.metadata.forEach((metadataEntry)=>{
    metadataEntry.aliases.forEach((alias)=>{
        $ff4bd32e3511744b$export$7d026f079148cd31.add(alias);
    });
});
/**
 * Attempts to get an aliases array from the static authority metadata sources based on the canonical authority host
 * @param staticAuthorityOptions
 * @param logger
 * @returns
 */ function $ff4bd32e3511744b$export$2c21adf4b4d4efc0(staticAuthorityOptions, logger) {
    let staticAliases;
    const canonicalAuthority = staticAuthorityOptions.canonicalAuthority;
    if (canonicalAuthority) {
        const authorityHost = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(canonicalAuthority).getUrlComponents().HostNameAndPort;
        staticAliases = $ff4bd32e3511744b$export$d195904946de56a1(authorityHost, staticAuthorityOptions.cloudDiscoveryMetadata?.metadata, (0, $7c375ae106b964be$export$5d365d77acfcb55d).CONFIG, logger) || $ff4bd32e3511744b$export$d195904946de56a1(authorityHost, $ff4bd32e3511744b$export$a21acafc3b6f5582.metadata, (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES, logger) || staticAuthorityOptions.knownAuthorities;
    }
    return staticAliases || [];
}
/**
 * Returns aliases for from the raw cloud discovery metadata passed in
 * @param authorityHost
 * @param rawCloudDiscoveryMetadata
 * @returns
 */ function $ff4bd32e3511744b$export$d195904946de56a1(authorityHost, cloudDiscoveryMetadata, source, logger) {
    logger?.trace(`getAliasesFromMetadata called with source: ${source}`);
    if (authorityHost && cloudDiscoveryMetadata) {
        const metadata = $ff4bd32e3511744b$export$6e21098ea6e60dc(cloudDiscoveryMetadata, authorityHost);
        if (metadata) {
            logger?.trace(`getAliasesFromMetadata: found cloud discovery metadata in ${source}, returning aliases`);
            return metadata.aliases;
        } else logger?.trace(`getAliasesFromMetadata: did not find cloud discovery metadata in ${source}`);
    }
    return null;
}
/**
 * Get cloud discovery metadata for common authorities
 */ function $ff4bd32e3511744b$export$1b1433f93c9873f(authorityHost) {
    const metadata = $ff4bd32e3511744b$export$6e21098ea6e60dc($ff4bd32e3511744b$export$a21acafc3b6f5582.metadata, authorityHost);
    return metadata;
}
/**
 * Searches instance discovery network response for the entry that contains the host in the aliases list
 * @param response
 * @param authority
 */ function $ff4bd32e3511744b$export$6e21098ea6e60dc(response, authorityHost) {
    for(let i = 0; i < response.length; i++){
        const metadata = response[i];
        if (metadata.aliases.includes(authorityHost)) return metadata;
    }
    return null;
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ var $d0300807e9c5c64e$exports = {};

$parcel$export($d0300807e9c5c64e$exports, "cacheQuotaExceeded", () => $d0300807e9c5c64e$export$e55c8be2f026d30a);
$parcel$export($d0300807e9c5c64e$exports, "cacheErrorUnknown", () => $d0300807e9c5c64e$export$6f650427f72a7890);
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d0300807e9c5c64e$export$e55c8be2f026d30a = "cache_quota_exceeded";
const $d0300807e9c5c64e$export$6f650427f72a7890 = "cache_error_unknown";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $531f2a6dee41cfa4$export$7ab11f0b2c87dadd = {
    [(0, $d0300807e9c5c64e$export$e55c8be2f026d30a)]: "Exceeded cache storage capacity.",
    [(0, $d0300807e9c5c64e$export$6f650427f72a7890)]: "Unexpected error occurred when using cache storage."
};
/**
 * Error thrown when there is an error with the cache
 */ class $531f2a6dee41cfa4$export$78ff06e91c3de382 extends Error {
    constructor(errorCode, errorMessage){
        const message = errorMessage || ($531f2a6dee41cfa4$export$7ab11f0b2c87dadd[errorCode] ? $531f2a6dee41cfa4$export$7ab11f0b2c87dadd[errorCode] : $531f2a6dee41cfa4$export$7ab11f0b2c87dadd[0, $d0300807e9c5c64e$export$6f650427f72a7890]);
        super(`${errorCode}: ${message}`);
        Object.setPrototypeOf(this, $531f2a6dee41cfa4$export$78ff06e91c3de382.prototype);
        this.name = "CacheError";
        this.errorCode = errorCode;
        this.errorMessage = message;
    }
}
/**
 * Helper function to wrap browser errors in a CacheError object
 * @param e
 * @returns
 */ function $531f2a6dee41cfa4$export$2056718aee1b1d88(e) {
    if (!(e instanceof Error)) return new $531f2a6dee41cfa4$export$78ff06e91c3de382((0, $d0300807e9c5c64e$export$6f650427f72a7890));
    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.message.includes("exceeded the quota")) return new $531f2a6dee41cfa4$export$78ff06e91c3de382((0, $d0300807e9c5c64e$export$e55c8be2f026d30a));
    else return new $531f2a6dee41cfa4$export$78ff06e91c3de382(e.name, e.message);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 * @internal
 */ class $0c353f04031c78df$export$996e3ea69314b5c6 {
    constructor(clientId, cryptoImpl, logger, staticAuthorityOptions){
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.commonLogger = logger.clone((0, $4c1e49235f95193e$export$a8ff84c12d48cfa6), (0, $4c1e49235f95193e$export$83d89fbfd8236492));
        this.staticAuthorityOptions = staticAuthorityOptions;
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(correlationId, accountFilter) {
        return this.buildTenantProfiles(this.getAccountsFilteredBy(accountFilter || {}, correlationId), correlationId, accountFilter);
    }
    /**
     * Gets first tenanted AccountInfo object found based on provided filters
     */ getAccountInfoFilteredBy(accountFilter, correlationId) {
        const allAccounts = this.getAllAccounts(correlationId, accountFilter);
        if (allAccounts.length > 1) {
            // If one or more accounts are found, prioritize accounts that have an ID token
            const sortedAccounts = allAccounts.sort((account)=>{
                return account.idTokenClaims ? -1 : 1;
            });
            return sortedAccounts[0];
        } else if (allAccounts.length === 1) // If only one account is found, return it regardless of whether a matching ID token was found
        return allAccounts[0];
        else return null;
    }
    /**
     * Returns a single matching
     * @param accountFilter
     * @returns
     */ getBaseAccountInfo(accountFilter, correlationId) {
        const accountEntities = this.getAccountsFilteredBy(accountFilter, correlationId);
        if (accountEntities.length > 0) return accountEntities[0].getAccountInfo();
        else return null;
    }
    /**
     * Matches filtered account entities with cached ID tokens that match the tenant profile-specific account filters
     * and builds the account info objects from the matching ID token's claims
     * @param cachedAccounts
     * @param accountFilter
     * @returns Array of AccountInfo objects that match account and tenant profile filters
     */ buildTenantProfiles(cachedAccounts, correlationId, accountFilter) {
        return cachedAccounts.flatMap((accountEntity)=>{
            return this.getTenantProfilesFromAccountEntity(accountEntity, correlationId, accountFilter?.tenantId, accountFilter);
        });
    }
    getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter) {
        let tenantedAccountInfo = null;
        let idTokenClaims;
        if (tenantProfileFilter) {
            if (!this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter)) return null;
        }
        const idToken = this.getIdToken(accountInfo, correlationId, tokenKeys, tenantProfile.tenantId);
        if (idToken) {
            idTokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(idToken.secret, this.cryptoImpl.base64Decode);
            if (!this.idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter)) // ID token sourced claims don't match so this tenant profile is not a match
            return null;
        }
        // Expand tenant profile into account info based on matching tenant profile and if available matching ID token claims
        tenantedAccountInfo = (0, $54830df9a5d9a12c$export$452a054c78b83dad)(accountInfo, tenantProfile, idTokenClaims, idToken?.secret);
        return tenantedAccountInfo;
    }
    getTenantProfilesFromAccountEntity(accountEntity, correlationId, targetTenantId, tenantProfileFilter) {
        const accountInfo = accountEntity.getAccountInfo();
        let searchTenantProfiles = accountInfo.tenantProfiles || new Map();
        const tokenKeys = this.getTokenKeys();
        // If a tenant ID was provided, only return the tenant profile for that tenant ID if it exists
        if (targetTenantId) {
            const tenantProfile = searchTenantProfiles.get(targetTenantId);
            if (tenantProfile) // Reduce search field to just this tenant profile
            searchTenantProfiles = new Map([
                [
                    targetTenantId,
                    tenantProfile
                ]
            ]);
            else // No tenant profile for search tenant ID, return empty array
            return [];
        }
        const matchingTenantProfiles = [];
        searchTenantProfiles.forEach((tenantProfile)=>{
            const tenantedAccountInfo = this.getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter);
            if (tenantedAccountInfo) matchingTenantProfiles.push(tenantedAccountInfo);
        });
        return matchingTenantProfiles;
    }
    tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter) {
        if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTenantProfile(tenantProfile, tenantProfileFilter.localAccountId)) return false;
        if (!!tenantProfileFilter.name && !(tenantProfile.name === tenantProfileFilter.name)) return false;
        if (tenantProfileFilter.isHomeTenant !== undefined && !(tenantProfile.isHomeTenant === tenantProfileFilter.isHomeTenant)) return false;
        return true;
    }
    idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter) {
        // Tenant Profile filtering
        if (tenantProfileFilter) {
            if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTokenClaims(idTokenClaims, tenantProfileFilter.localAccountId)) return false;
            if (!!tenantProfileFilter.loginHint && !this.matchLoginHintFromTokenClaims(idTokenClaims, tenantProfileFilter.loginHint)) return false;
            if (!!tenantProfileFilter.username && !this.matchUsername(idTokenClaims.preferred_username, tenantProfileFilter.username)) return false;
            if (!!tenantProfileFilter.name && !this.matchName(idTokenClaims, tenantProfileFilter.name)) return false;
            if (!!tenantProfileFilter.sid && !this.matchSid(idTokenClaims, tenantProfileFilter.sid)) return false;
        }
        return true;
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, storeInCache) {
        if (!cacheRecord) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$d396103576f879cc));
        try {
            if (!!cacheRecord.account) this.setAccount(cacheRecord.account, correlationId);
            if (!!cacheRecord.idToken && storeInCache?.idToken !== false) this.setIdTokenCredential(cacheRecord.idToken, correlationId);
            if (!!cacheRecord.accessToken && storeInCache?.accessToken !== false) await this.saveAccessToken(cacheRecord.accessToken, correlationId);
            if (!!cacheRecord.refreshToken && storeInCache?.refreshToken !== false) this.setRefreshTokenCredential(cacheRecord.refreshToken, correlationId);
            if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata, correlationId);
        } catch (e) {
            this.commonLogger?.error(`CacheManager.saveCacheRecord: failed`);
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) throw e;
            else throw (0, $531f2a6dee41cfa4$export$2056718aee1b1d88)(e);
        }
    }
    /**
     * saves access token credential
     * @param credential
     */ async saveAccessToken(credential, correlationId) {
        const accessTokenFilter = {
            clientId: credential.clientId,
            credentialType: credential.credentialType,
            environment: credential.environment,
            homeAccountId: credential.homeAccountId,
            realm: credential.realm,
            tokenType: credential.tokenType,
            requestedClaimsHash: credential.requestedClaimsHash
        };
        const tokenKeys = this.getTokenKeys();
        const currentScopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(credential.target);
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
            const tokenEntity = this.getAccessTokenCredential(key, correlationId);
            if (tokenEntity && this.credentialMatchesFilter(tokenEntity, accessTokenFilter)) {
                const tokenScopeSet = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(tokenEntity.target);
                if (tokenScopeSet.intersectingScopeSets(currentScopes)) this.removeAccessToken(key, correlationId);
            }
        });
        this.setAccessTokenCredential(credential, correlationId);
    }
    /**
     * Retrieve account entities matching all provided tenant-agnostic filters; if no filter is set, get all account entities in the cache
     * Not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param accountFilter - An object containing Account properties to filter by
     */ getAccountsFilteredBy(accountFilter, correlationId) {
        const allAccountKeys = this.getAccountKeys();
        const matchingAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            if (!this.isAccountKey(cacheKey, accountFilter.homeAccountId)) // Don't parse value if the key doesn't match the account filters
            return;
            const entity = this.getAccount(cacheKey, correlationId, this.commonLogger);
            // Match base account fields
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.username && !this.matchUsername(entity.username, accountFilter.username)) return;
            if (!!accountFilter.environment && !this.matchEnvironment(entity, accountFilter.environment)) return;
            if (!!accountFilter.realm && !this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.nativeAccountId && !this.matchNativeAccountId(entity, accountFilter.nativeAccountId)) return;
            if (!!accountFilter.authorityType && !this.matchAuthorityType(entity, accountFilter.authorityType)) return;
            // If at least one tenant profile matches the tenant profile filter, add the account to the list of matching accounts
            const tenantProfileFilter = {
                localAccountId: accountFilter?.localAccountId,
                name: accountFilter?.name
            };
            const matchingTenantProfiles = entity.tenantProfiles?.filter((tenantProfile)=>{
                return this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter);
            });
            if (matchingTenantProfiles && matchingTenantProfiles.length === 0) // No tenant profile for this account matches filter, don't add to list of matching accounts
            return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    }
    /**
     * Returns true if the given key matches our account key schema. Also matches homeAccountId and/or tenantId if provided
     * @param key
     * @param homeAccountId
     * @param tenantId
     * @returns
     */ isAccountKey(key, homeAccountId, tenantId) {
        if (key.split((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 3) // Account cache keys contain 3 items separated by '-' (each item may also contain '-')
        return false;
        if (homeAccountId && !key.toLowerCase().includes(homeAccountId.toLowerCase())) return false;
        if (tenantId && !key.toLowerCase().includes(tenantId.toLowerCase())) return false;
        // Do not check environment as aliasing can cause false negatives
        return true;
    }
    /**
     * Returns true if the given key matches our credential key schema.
     * @param key
     */ isCredentialKey(key) {
        if (key.split((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 6) // Credential cache keys contain 6 items separated by '-' (each item may also contain '-')
        return false;
        const lowerCaseKey = key.toLowerCase();
        // Credential keys must indicate what credential type they represent
        if (lowerCaseKey.indexOf((0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) === -1) return false;
        if (lowerCaseKey.indexOf((0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) > -1) {
            // Refresh tokens must contain the client id or family id
            const clientIdValidation = `${(0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN}${(0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}${this.clientId}${(0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}`;
            const familyIdValidation = `${(0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN}${(0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}${(0, $7c375ae106b964be$export$978fe7ab5e74b539)}${(0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}`;
            if (lowerCaseKey.indexOf(clientIdValidation.toLowerCase()) === -1 && lowerCaseKey.indexOf(familyIdValidation.toLowerCase()) === -1) return false;
        } else if (lowerCaseKey.indexOf(this.clientId.toLowerCase()) === -1) // Tokens must contain the clientId
        return false;
        return true;
    }
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @returns
     */ credentialMatchesFilter(entity, filter) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target)) return false;
        // If request OR cached entity has requested Claims Hash, check if they match
        if (filter.requestedClaimsHash || entity.requestedClaimsHash) {
            // Don't match if either is undefined or they are different
            if (entity.requestedClaimsHash !== filter.requestedClaimsHash) return false;
        }
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
            // KeyId (sshKid) in request must match cached SSH certificate keyId because SSH cert is bound to a specific key
            if (filter.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
                if (filter.keyId && !this.matchKeyId(entity, filter.keyId)) return false;
            }
        }
        return true;
    }
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     */ getAppMetadataFilteredBy(filter) {
        const allCacheKeys = this.getKeys();
        const matchingAppMetadata = {};
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-appMetadata type cache entities
            if (!this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            const entity = this.getAppMetadata(cacheKey);
            if (!entity) return;
            if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return;
            if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    }
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param filter
     */ getAuthorityMetadataByAlias(host) {
        const allCacheKeys = this.getAuthorityMetadataKeys();
        let matchedEntity = null;
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-authorityMetadata type cache entities
            if (!this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(this.clientId) === -1) return;
            // Attempt retrieval
            const entity = this.getAuthorityMetadata(cacheKey);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    }
    /**
     * Removes all accounts and related tokens from cache.
     */ async removeAllAccounts(correlationId) {
        const allAccountKeys = this.getAccountKeys();
        const removedAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            removedAccounts.push(this.removeAccount(cacheKey, correlationId));
        });
        await Promise.all(removedAccounts);
    }
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ async removeAccount(accountKey, correlationId) {
        const account = this.getAccount(accountKey, correlationId, this.commonLogger);
        if (!account) return;
        await this.removeAccountContext(account, correlationId);
        this.removeItem(accountKey, correlationId);
    }
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ async removeAccountContext(account, correlationId) {
        const allTokenKeys = this.getTokenKeys();
        const accountId = account.generateAccountId();
        allTokenKeys.idToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) this.removeIdToken(key, correlationId);
        });
        allTokenKeys.accessToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) this.removeAccessToken(key, correlationId);
        });
        allTokenKeys.refreshToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) this.removeRefreshToken(key, correlationId);
        });
        this.getKeys().forEach((key)=>{
            if (key.includes(accountId)) this.removeItem(key, correlationId);
        });
    }
    /**
     * Migrates a single-tenant account and all it's associated alternate cross-tenant account objects in the
     * cache into a condensed multi-tenant account object with tenant profiles.
     * @param accountKey
     * @param accountEntity
     * @param logger
     * @returns
     */ updateOutdatedCachedAccount(accountKey, accountEntity, correlationId, logger) {
        // Only update if account entity is defined and has no tenantProfiles object (is outdated)
        if (accountEntity && accountEntity.isSingleTenant()) {
            this.commonLogger?.verbose("updateOutdatedCachedAccount: Found a single-tenant (outdated) account entity in the cache, migrating to multi-tenant account entity");
            // Get keys of all accounts belonging to user
            const matchingAccountKeys = this.getAccountKeys().filter((key)=>{
                return key.startsWith(accountEntity.homeAccountId);
            });
            // Get all account entities belonging to user
            const accountsToMerge = [];
            matchingAccountKeys.forEach((key)=>{
                const account = this.getCachedAccountEntity(key, correlationId);
                if (account) accountsToMerge.push(account);
            });
            // Set base account to home account if available, any account if not
            const baseAccount = accountsToMerge.find((account)=>{
                return (0, $54830df9a5d9a12c$export$bc62fd222eddc2d7)(account.realm, account.homeAccountId);
            }) || accountsToMerge[0];
            // Populate tenant profiles built from each account entity belonging to the user
            baseAccount.tenantProfiles = accountsToMerge.map((account)=>{
                return {
                    tenantId: account.realm,
                    localAccountId: account.localAccountId,
                    name: account.name,
                    isHomeTenant: (0, $54830df9a5d9a12c$export$bc62fd222eddc2d7)(account.realm, account.homeAccountId)
                };
            });
            const updatedAccount = $0c353f04031c78df$export$996e3ea69314b5c6.toObject(new (0, $d6acc4a6126921e0$export$680160523e6bfa6a)(), {
                ...baseAccount
            });
            const newAccountKey = updatedAccount.generateAccountKey();
            // Clear cache of legacy account objects that have been collpsed into tenant profiles
            matchingAccountKeys.forEach((key)=>{
                if (key !== newAccountKey) this.removeOutdatedAccount(accountKey, correlationId);
            });
            // Cache updated account object
            this.setAccount(updatedAccount, correlationId);
            logger?.verbose("Updated an outdated account entity in the cache");
            return updatedAccount;
        }
        // No update is necessary
        return accountEntity;
    }
    /**
     * returns a boolean if the given credential is removed
     * @param credential
     */ removeAccessToken(key, correlationId) {
        const credential = this.getAccessTokenCredential(key, correlationId);
        this.removeItem(key, correlationId);
        if (!credential || credential.credentialType.toLowerCase() !== (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase() || credential.tokenType !== (0, $7c375ae106b964be$export$901491a717da2ba5).POP) return;
        // Remove Token Binding Key from key store for PoP Tokens Credentials
        const kid = credential.keyId;
        if (kid) this.cryptoImpl.removeTokenBindingKey(kid).catch(()=>{
            this.commonLogger.error("Binding key could not be removed");
        });
    }
    /**
     * Removes all app metadata objects from cache.
     */ removeAppMetadata(correlationId) {
        const allCacheKeys = this.getKeys();
        allCacheKeys.forEach((cacheKey)=>{
            if (this.isAppMetadata(cacheKey)) this.removeItem(cacheKey, correlationId);
        });
        return true;
    }
    /**
     * Retrieve AccountEntity from cache
     * @param account
     */ readAccountFromCache(account, correlationId) {
        const accountKey = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateAccountCacheKey(account);
        return this.getAccount(accountKey, correlationId, this.commonLogger);
    }
    /**
     * Retrieve IdTokenEntity from cache
     * @param account {AccountInfo}
     * @param tokenKeys {?TokenKeys}
     * @param targetRealm {?string}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getIdToken(account, correlationId, tokenKeys, targetRealm, performanceClient) {
        this.commonLogger.trace("CacheManager - getIdToken called");
        const idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN,
            clientId: this.clientId,
            realm: targetRealm
        };
        const idTokenMap = this.getIdTokensByFilter(idTokenFilter, correlationId, tokenKeys);
        const numIdTokens = idTokenMap.size;
        if (numIdTokens < 1) {
            this.commonLogger.info("CacheManager:getIdToken - No token found");
            return null;
        } else if (numIdTokens > 1) {
            let tokensToBeRemoved = idTokenMap;
            // Multiple tenant profiles and no tenant specified, pick home account
            if (!targetRealm) {
                const homeIdTokenMap = new Map();
                idTokenMap.forEach((idToken, key)=>{
                    if (idToken.realm === account.tenantId) homeIdTokenMap.set(key, idToken);
                });
                const numHomeIdTokens = homeIdTokenMap.size;
                if (numHomeIdTokens < 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account but none match account entity tenant id, returning first result");
                    return idTokenMap.values().next().value;
                } else if (numHomeIdTokens === 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account, defaulting to home tenant profile");
                    return homeIdTokenMap.values().next().value;
                } else // Multiple ID tokens for home tenant profile, remove all and return null
                tokensToBeRemoved = homeIdTokenMap;
            }
            // Multiple tokens for a single tenant profile, remove all and return null
            this.commonLogger.info("CacheManager:getIdToken - Multiple matching ID tokens found, clearing them");
            tokensToBeRemoved.forEach((idToken, key)=>{
                this.removeIdToken(key, correlationId);
            });
            if (performanceClient && correlationId) performanceClient.addFields({
                multiMatchedID: idTokenMap.size
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getIdToken - Returning ID token");
        return idTokenMap.values().next().value;
    }
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ getIdTokensByFilter(filter, correlationId, tokenKeys) {
        const idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        const idTokens = new Map();
        idTokenKeys.forEach((key)=>{
            if (!this.idTokenKeyMatchesFilter(key, {
                clientId: this.clientId,
                ...filter
            })) return;
            const idToken = this.getIdTokenCredential(key, correlationId);
            if (idToken && this.credentialMatchesFilter(idToken, filter)) idTokens.set(key, idToken);
        });
        return idTokens;
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ idTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Removes idToken from the cache
     * @param key
     */ removeIdToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Removes refresh token from the cache
     * @param key
     */ removeRefreshToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Retrieve AccessTokenEntity from cache
     * @param account {AccountInfo}
     * @param request {BaseAuthRequest}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getAccessToken(account, request, tokenKeys, targetRealm, performanceClient) {
        this.commonLogger.trace("CacheManager - getAccessToken called");
        const scopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).createSearchScopes(request.scopes);
        const authScheme = request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ const credentialType = authScheme && authScheme.toLowerCase() !== (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER.toLowerCase() ? (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME : (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN;
        const accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: targetRealm || account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: request.sshKid,
            requestedClaimsHash: request.requestedClaimsHash
        };
        const accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        const accessTokens = [];
        accessTokenKeys.forEach((key)=>{
            // Validate key
            if (this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                const accessToken = this.getAccessTokenCredential(key, request.correlationId);
                // Validate value
                if (accessToken && this.credentialMatchesFilter(accessToken, accessTokenFilter)) accessTokens.push(accessToken);
            }
        });
        const numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            this.commonLogger.info("CacheManager:getAccessToken - No token found");
            return null;
        } else if (numAccessTokens > 1) {
            this.commonLogger.info("CacheManager:getAccessToken - Multiple access tokens found, clearing them");
            accessTokens.forEach((accessToken)=>{
                this.removeAccessToken((0, $9ab3d26df56b176d$export$1aaa1362083ec7a3)(accessToken), request.correlationId);
            });
            if (performanceClient && request.correlationId) performanceClient.addFields({
                multiMatchedAT: accessTokens.length
            }, request.correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getAccessToken - Returning access token");
        return accessTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ accessTokenKeyMatchesFilter(inputKey, filter, keyMustContainAllScopes) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.requestedClaimsHash && key.indexOf(filter.requestedClaimsHash.toLowerCase()) === -1) return false;
        if (filter.target) {
            const scopes = filter.target.asArray();
            for(let i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    }
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ getAccessTokensByFilter(filter, correlationId) {
        const tokenKeys = this.getTokenKeys();
        const accessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            const accessToken = this.getAccessTokenCredential(key, correlationId);
            if (accessToken && this.credentialMatchesFilter(accessToken, filter)) accessTokens.push(accessToken);
        });
        return accessTokens;
    }
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param account {AccountInfo}
     * @param familyRT {boolean}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getRefreshToken(account, familyRT, correlationId, tokenKeys, performanceClient) {
        this.commonLogger.trace("CacheManager - getRefreshToken called");
        const id = familyRT ? (0, $7c375ae106b964be$export$978fe7ab5e74b539) : undefined;
        const refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        const refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        const refreshTokens = [];
        refreshTokenKeys.forEach((key)=>{
            // Validate key
            if (this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                const refreshToken = this.getRefreshTokenCredential(key, correlationId);
                // Validate value
                if (refreshToken && this.credentialMatchesFilter(refreshToken, refreshTokenFilter)) refreshTokens.push(refreshToken);
            }
        });
        const numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("CacheManager:getRefreshToken - No refresh token found.");
            return null;
        }
        // address the else case after remove functions address environment aliases
        if (numRefreshTokens > 1 && performanceClient && correlationId) performanceClient.addFields({
            multiMatchedRT: numRefreshTokens
        }, correlationId);
        this.commonLogger.info("CacheManager:getRefreshToken - returning refresh token");
        return refreshTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ refreshTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Retrieve AppMetadataEntity from cache
     */ readAppMetadataFromCache(environment) {
        const appMetadataFilter = {
            environment: environment,
            clientId: this.clientId
        };
        const appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter);
        const appMetadataEntries = Object.keys(appMetadata).map((key)=>appMetadata[key]);
        const numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$575bb2924bcd0084));
        return appMetadataEntries[0];
    }
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ isAppMetadataFOCI(environment) {
        const appMetadata = this.readAppMetadataFromCache(environment);
        return !!(appMetadata && appMetadata.familyId === (0, $7c375ae106b964be$export$978fe7ab5e74b539));
    }
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ matchHomeAccountId(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    }
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ matchLocalAccountIdFromTokenClaims(tokenClaims, localAccountId) {
        const idTokenLocalAccountId = tokenClaims.oid || tokenClaims.sub;
        return localAccountId === idTokenLocalAccountId;
    }
    matchLocalAccountIdFromTenantProfile(tenantProfile, localAccountId) {
        return tenantProfile.localAccountId === localAccountId;
    }
    /**
     * helper to match names
     * @param entity
     * @param name
     * @returns true if the downcased name properties are present and match in the filter and the entity
     */ matchName(claims, name) {
        return !!(name.toLowerCase() === claims.name?.toLowerCase());
    }
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ matchUsername(cachedUsername, filterUsername) {
        return !!(cachedUsername && typeof cachedUsername === "string" && filterUsername?.toLowerCase() === cachedUsername.toLowerCase());
    }
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ matchUserAssertionHash(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    }
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ matchEnvironment(entity, environment) {
        // Check static authority options first for cases where authority metadata has not been resolved and cached yet
        if (this.staticAuthorityOptions) {
            const staticAliases = (0, $ff4bd32e3511744b$export$2c21adf4b4d4efc0)(this.staticAuthorityOptions, this.commonLogger);
            if (staticAliases.includes(environment) && staticAliases.includes(entity.environment)) return true;
        }
        // Query metadata cache if no static authority configuration has aliases that match enviroment
        const cloudMetadata = this.getAuthorityMetadataByAlias(environment);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    }
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ matchCredentialType(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    }
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ matchClientId(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    }
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ matchFamilyId(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    }
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ matchRealm(entity, realm) {
        return !!(entity.realm?.toLowerCase() === realm.toLowerCase());
    }
    /**
     * helper to match nativeAccountId
     * @param entity
     * @param nativeAccountId
     * @returns boolean indicating the match result
     */ matchNativeAccountId(entity, nativeAccountId) {
        return !!(entity.nativeAccountId && nativeAccountId === entity.nativeAccountId);
    }
    /**
     * helper to match loginHint which can be either:
     * 1. login_hint ID token claim
     * 2. username in cached account object
     * 3. upn in ID token claims
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintFromTokenClaims(tokenClaims, loginHint) {
        if (tokenClaims.login_hint === loginHint) return true;
        if (tokenClaims.preferred_username === loginHint) return true;
        if (tokenClaims.upn === loginHint) return true;
        return false;
    }
    /**
     * Helper to match sid
     * @param entity
     * @param sid
     * @returns true if the sid claim is present and matches the filter
     */ matchSid(idTokenClaims, sid) {
        return idTokenClaims.sid === sid;
    }
    matchAuthorityType(entity, authorityType) {
        return !!(entity.authorityType && authorityType.toLowerCase() === entity.authorityType.toLowerCase());
    }
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ matchTarget(entity, target) {
        const isNotAccessTokenCredential = entity.credentialType !== (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN && entity.credentialType !== (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        const entityScopeSet = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(entity.target);
        return entityScopeSet.containsScopeSet(target);
    }
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ matchTokenType(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType === tokenType);
    }
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param keyId
     */ matchKeyId(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    }
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ isAppMetadata(key) {
        return key.indexOf((0, $7c375ae106b964be$export$7e1bea6dc1b6b32e)) !== -1;
    }
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ isAuthorityMetadata(key) {
        return key.indexOf((0, $7c375ae106b964be$export$d483f966e66f4db5).CACHE_KEY) !== -1;
    }
    /**
     * returns cache key used for cloud instance metadata
     */ generateAuthorityMetadataCacheKey(authority) {
        return `${(0, $7c375ae106b964be$export$d483f966e66f4db5).CACHE_KEY}-${this.clientId}-${authority}`;
    }
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ static toObject(obj, json) {
        for(const propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    }
}
/** @internal */ class $0c353f04031c78df$export$b7254d304b3004b6 extends $0c353f04031c78df$export$996e3ea69314b5c6 {
    setAccount() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAccount() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getCachedAccountEntity() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setIdTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getIdTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setAccessTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAccessTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setRefreshTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getRefreshTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setAppMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAppMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setServerTelemetry() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getServerTelemetry() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setAuthorityMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAuthorityMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAuthorityMetadataKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setThrottlingCache() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getThrottlingCache() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    removeItem() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAccountKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getTokenKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    updateCredentialCacheKey() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    removeOutdatedAccount() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d21eb39178ebb5ae$export$f7a7dd6bfc156d75 = {
    tokenRenewalOffsetSeconds: (0, $7c375ae106b964be$export$8d50f42618161d1a),
    preventCorsPreflight: false
};
const $d21eb39178ebb5ae$var$DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: ()=>{
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Info,
    correlationId: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
};
const $d21eb39178ebb5ae$var$DEFAULT_CACHE_OPTIONS = {
    claimsBasedCachingEnabled: false
};
const $d21eb39178ebb5ae$var$DEFAULT_NETWORK_IMPLEMENTATION = {
    async sendGetRequestAsync () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async sendPostRequestAsync () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
};
const $d21eb39178ebb5ae$var$DEFAULT_LIBRARY_INFO = {
    sku: (0, $7c375ae106b964be$export$a002182e51710d39).SKU,
    version: (0, $4c1e49235f95193e$export$83d89fbfd8236492),
    cpu: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
    os: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
};
const $d21eb39178ebb5ae$var$DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
    clientAssertion: undefined
};
const $d21eb39178ebb5ae$var$DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: (0, $399fa9610e7cb0fb$export$4cda21933050d9ec).None,
    tenant: `${(0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_COMMON_TENANT}`
};
const $d21eb39178ebb5ae$var$DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 */ function $d21eb39178ebb5ae$export$57a091701dcdabb2({ authOptions: userAuthOptions, systemOptions: userSystemOptions, loggerOptions: userLoggerOption, cacheOptions: userCacheOptions, storageInterface: storageImplementation, networkInterface: networkImplementation, cryptoInterface: cryptoImplementation, clientCredentials: clientCredentials, libraryInfo: libraryInfo, telemetry: telemetry, serverTelemetryManager: serverTelemetryManager, persistencePlugin: persistencePlugin, serializableCache: serializableCache }) {
    const loggerOptions = {
        ...$d21eb39178ebb5ae$var$DEFAULT_LOGGER_IMPLEMENTATION,
        ...userLoggerOption
    };
    return {
        authOptions: $d21eb39178ebb5ae$var$buildAuthOptions(userAuthOptions),
        systemOptions: {
            ...$d21eb39178ebb5ae$export$f7a7dd6bfc156d75,
            ...userSystemOptions
        },
        loggerOptions: loggerOptions,
        cacheOptions: {
            ...$d21eb39178ebb5ae$var$DEFAULT_CACHE_OPTIONS,
            ...userCacheOptions
        },
        storageInterface: storageImplementation || new (0, $0c353f04031c78df$export$b7254d304b3004b6)(userAuthOptions.clientId, (0, $dd88ab1a0b4d3851$export$865f57d401606752), new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(loggerOptions)),
        networkInterface: networkImplementation || $d21eb39178ebb5ae$var$DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || (0, $dd88ab1a0b4d3851$export$865f57d401606752),
        clientCredentials: clientCredentials || $d21eb39178ebb5ae$var$DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: {
            ...$d21eb39178ebb5ae$var$DEFAULT_LIBRARY_INFO,
            ...libraryInfo
        },
        telemetry: {
            ...$d21eb39178ebb5ae$var$DEFAULT_TELEMETRY_OPTIONS,
            ...telemetry
        },
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function $d21eb39178ebb5ae$var$buildAuthOptions(authOptions) {
    return {
        clientCapabilities: [],
        azureCloudOptions: $d21eb39178ebb5ae$var$DEFAULT_AZURE_CLOUD_OPTIONS,
        skipAuthorityMetadataCache: false,
        instanceAware: false,
        ...authOptions
    };
}
/**
 * Returns true if config has protocolMode set to ProtocolMode.OIDC, false otherwise
 * @param ClientConfiguration
 */ function $d21eb39178ebb5ae$export$25afa7198c2ed9b9(config) {
    return config.authOptions.authority.options.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC;
}

/*! @azure/msal-common v14.16.1 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $04922ae8364b32fe$export$6d95060a8ed7155a = {
    sendGetRequestAsync: ()=>{
        return Promise.reject((0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22)));
    },
    sendPostRequestAsync: ()=>{
        return Promise.reject((0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22)));
    }
};

/*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Enumeration of operations that are instrumented by have their performance measured by the PerformanceClient.
 *
 * @export
 * @enum {number}
 */ const $80a5304d92c187bf$export$2f2811a3e1b21823 = {
    /**
     * acquireTokenByCode API (msal-browser and msal-node).
     * Used to acquire tokens by trading an authorization code against the token endpoint.
     */ AcquireTokenByCode: "acquireTokenByCode",
    /**
     * acquireTokenByRefreshToken API (msal-browser and msal-node).
     * Used to renew an access token using a refresh token against the token endpoint.
     */ AcquireTokenByRefreshToken: "acquireTokenByRefreshToken",
    /**
     * acquireTokenSilent API (msal-browser and msal-node).
     * Used to silently acquire a new access token (from the cache or the network).
     */ AcquireTokenSilent: "acquireTokenSilent",
    /**
     * acquireTokenSilentAsync (msal-browser).
     * Internal API for acquireTokenSilent.
     */ AcquireTokenSilentAsync: "acquireTokenSilentAsync",
    /**
     * acquireTokenPopup (msal-browser).
     * Used to acquire a new access token interactively through pop ups
     */ AcquireTokenPopup: "acquireTokenPopup",
    /**
     * acquireTokenPreRedirect (msal-browser).
     * First part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenPreRedirect: "acquireTokenPreRedirect",
    /**
     * acquireTokenRedirect (msal-browser).
     * Second part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenRedirect: "acquireTokenRedirect",
    /**
     * getPublicKeyThumbprint API in CryptoOpts class (msal-browser).
     * Used to generate a public/private keypair and generate a public key thumbprint for pop requests.
     */ CryptoOptsGetPublicKeyThumbprint: "cryptoOptsGetPublicKeyThumbprint",
    /**
     * signJwt API in CryptoOpts class (msal-browser).
     * Used to signed a pop token.
     */ CryptoOptsSignJwt: "cryptoOptsSignJwt",
    /**
     * acquireToken API in the SilentCacheClient class (msal-browser).
     * Used to read access tokens from the cache.
     */ SilentCacheClientAcquireToken: "silentCacheClientAcquireToken",
    /**
     * acquireToken API in the SilentIframeClient class (msal-browser).
     * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
     */ SilentIframeClientAcquireToken: "silentIframeClientAcquireToken",
    AwaitConcurrentIframe: "awaitConcurrentIframe",
    /**
     * acquireToken API in SilentRereshClient (msal-browser).
     * Used to acquire a new set of tokens from the token endpoint using a refresh token.
     */ SilentRefreshClientAcquireToken: "silentRefreshClientAcquireToken",
    /**
     * ssoSilent API (msal-browser).
     * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
     */ SsoSilent: "ssoSilent",
    /**
     * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
     * Used to load authority metadata for a request.
     */ StandardInteractionClientGetDiscoveredAuthority: "standardInteractionClientGetDiscoveredAuthority",
    /**
     * acquireToken APIs in msal-browser.
     * Used to make an /authorize endpoint call with native brokering enabled.
     */ FetchAccountIdWithNativeBroker: "fetchAccountIdWithNativeBroker",
    /**
     * acquireToken API in NativeInteractionClient class (msal-browser).
     * Used to acquire a token from Native component when native brokering is enabled.
     */ NativeInteractionClientAcquireToken: "nativeInteractionClientAcquireToken",
    /**
     * Time spent creating default headers for requests to token endpoint
     */ BaseClientCreateTokenRequestHeaders: "baseClientCreateTokenRequestHeaders",
    /**
     * Time spent sending/waiting for the response of a request to the token endpoint
     */ NetworkClientSendPostRequestAsync: "networkClientSendPostRequestAsync",
    RefreshTokenClientExecutePostToTokenEndpoint: "refreshTokenClientExecutePostToTokenEndpoint",
    AuthorizationCodeClientExecutePostToTokenEndpoint: "authorizationCodeClientExecutePostToTokenEndpoint",
    /**
     * Used to measure the time taken for completing embedded-broker handshake (PW-Broker).
     */ BrokerHandhshake: "brokerHandshake",
    /**
     * acquireTokenByRefreshToken API in BrokerClientApplication (PW-Broker) .
     */ AcquireTokenByRefreshTokenInBroker: "acquireTokenByRefreshTokenInBroker",
    /**
     * Time taken for token acquisition by broker
     */ AcquireTokenByBroker: "acquireTokenByBroker",
    /**
     * Time spent on the network for refresh token acquisition
     */ RefreshTokenClientExecuteTokenRequest: "refreshTokenClientExecuteTokenRequest",
    /**
     * Time taken for acquiring refresh token , records RT size
     */ RefreshTokenClientAcquireToken: "refreshTokenClientAcquireToken",
    /**
     * Time taken for acquiring cached refresh token
     */ RefreshTokenClientAcquireTokenWithCachedRefreshToken: "refreshTokenClientAcquireTokenWithCachedRefreshToken",
    /**
     * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
     */ RefreshTokenClientAcquireTokenByRefreshToken: "refreshTokenClientAcquireTokenByRefreshToken",
    /**
     * Helper function to create token request body in RefreshTokenClient (msal-common).
     */ RefreshTokenClientCreateTokenRequestBody: "refreshTokenClientCreateTokenRequestBody",
    /**
     * acquireTokenFromCache (msal-browser).
     * Internal API for acquiring token from cache
     */ AcquireTokenFromCache: "acquireTokenFromCache",
    SilentFlowClientAcquireCachedToken: "silentFlowClientAcquireCachedToken",
    SilentFlowClientGenerateResultFromCacheRecord: "silentFlowClientGenerateResultFromCacheRecord",
    /**
     * acquireTokenBySilentIframe (msal-browser).
     * Internal API for acquiring token by silent Iframe
     */ AcquireTokenBySilentIframe: "acquireTokenBySilentIframe",
    /**
     * Internal API for initializing base request in BaseInteractionClient (msal-browser)
     */ InitializeBaseRequest: "initializeBaseRequest",
    /**
     * Internal API for initializing silent request in SilentCacheClient (msal-browser)
     */ InitializeSilentRequest: "initializeSilentRequest",
    InitializeClientApplication: "initializeClientApplication",
    /**
     * Helper function in SilentIframeClient class (msal-browser).
     */ SilentIframeClientTokenHelper: "silentIframeClientTokenHelper",
    /**
     * SilentHandler
     */ SilentHandlerInitiateAuthRequest: "silentHandlerInitiateAuthRequest",
    SilentHandlerMonitorIframeForHash: "silentHandlerMonitorIframeForHash",
    SilentHandlerLoadFrame: "silentHandlerLoadFrame",
    SilentHandlerLoadFrameSync: "silentHandlerLoadFrameSync",
    /**
     * Helper functions in StandardInteractionClient class (msal-browser)
     */ StandardInteractionClientCreateAuthCodeClient: "standardInteractionClientCreateAuthCodeClient",
    StandardInteractionClientGetClientConfiguration: "standardInteractionClientGetClientConfiguration",
    StandardInteractionClientInitializeAuthorizationRequest: "standardInteractionClientInitializeAuthorizationRequest",
    StandardInteractionClientInitializeAuthorizationCodeRequest: "standardInteractionClientInitializeAuthorizationCodeRequest",
    /**
     * getAuthCodeUrl API (msal-browser and msal-node).
     */ GetAuthCodeUrl: "getAuthCodeUrl",
    /**
     * Functions from InteractionHandler (msal-browser)
     */ HandleCodeResponseFromServer: "handleCodeResponseFromServer",
    HandleCodeResponse: "handleCodeResponse",
    UpdateTokenEndpointAuthority: "updateTokenEndpointAuthority",
    /**
     * APIs in Authorization Code Client (msal-common)
     */ AuthClientAcquireToken: "authClientAcquireToken",
    AuthClientExecuteTokenRequest: "authClientExecuteTokenRequest",
    AuthClientCreateTokenRequestBody: "authClientCreateTokenRequestBody",
    AuthClientCreateQueryString: "authClientCreateQueryString",
    /**
     * Generate functions in PopTokenGenerator (msal-common)
     */ PopTokenGenerateCnf: "popTokenGenerateCnf",
    PopTokenGenerateKid: "popTokenGenerateKid",
    /**
     * handleServerTokenResponse API in ResponseHandler (msal-common)
     */ HandleServerTokenResponse: "handleServerTokenResponse",
    DeserializeResponse: "deserializeResponse",
    /**
     * Authority functions
     */ AuthorityFactoryCreateDiscoveredInstance: "authorityFactoryCreateDiscoveredInstance",
    AuthorityResolveEndpointsAsync: "authorityResolveEndpointsAsync",
    AuthorityResolveEndpointsFromLocalSources: "authorityResolveEndpointsFromLocalSources",
    AuthorityGetCloudDiscoveryMetadataFromNetwork: "authorityGetCloudDiscoveryMetadataFromNetwork",
    AuthorityUpdateCloudDiscoveryMetadata: "authorityUpdateCloudDiscoveryMetadata",
    AuthorityGetEndpointMetadataFromNetwork: "authorityGetEndpointMetadataFromNetwork",
    AuthorityUpdateEndpointMetadata: "authorityUpdateEndpointMetadata",
    AuthorityUpdateMetadataWithRegionalInformation: "authorityUpdateMetadataWithRegionalInformation",
    /**
     * Region Discovery functions
     */ RegionDiscoveryDetectRegion: "regionDiscoveryDetectRegion",
    RegionDiscoveryGetRegionFromIMDS: "regionDiscoveryGetRegionFromIMDS",
    RegionDiscoveryGetCurrentVersion: "regionDiscoveryGetCurrentVersion",
    AcquireTokenByCodeAsync: "acquireTokenByCodeAsync",
    GetEndpointMetadataFromNetwork: "getEndpointMetadataFromNetwork",
    GetCloudDiscoveryMetadataFromNetworkMeasurement: "getCloudDiscoveryMetadataFromNetworkMeasurement",
    HandleRedirectPromiseMeasurement: "handleRedirectPromise",
    HandleNativeRedirectPromiseMeasurement: "handleNativeRedirectPromise",
    UpdateCloudDiscoveryMetadataMeasurement: "updateCloudDiscoveryMetadataMeasurement",
    UsernamePasswordClientAcquireToken: "usernamePasswordClientAcquireToken",
    NativeMessageHandlerHandshake: "nativeMessageHandlerHandshake",
    NativeGenerateAuthResult: "nativeGenerateAuthResult",
    RemoveHiddenIframe: "removeHiddenIframe",
    /**
     * Cache operations
     */ ClearTokensAndKeysWithClaims: "clearTokensAndKeysWithClaims",
    CacheManagerGetRefreshToken: "cacheManagerGetRefreshToken",
    /**
     * Crypto Operations
     */ GeneratePkceCodes: "generatePkceCodes",
    GenerateCodeVerifier: "generateCodeVerifier",
    GenerateCodeChallengeFromVerifier: "generateCodeChallengeFromVerifier",
    Sha256Digest: "sha256Digest",
    GetRandomValues: "getRandomValues"
};
const $80a5304d92c187bf$export$8dc198b6eb7c4c72 = new Map([
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByCode,
        "ATByCode"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByRefreshToken,
        "ATByRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenSilent,
        "ATS"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenSilentAsync,
        "ATSAsync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenPopup,
        "ATPopup"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenRedirect,
        "ATRedirect"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.CryptoOptsGetPublicKeyThumbprint,
        "CryptoGetPKThumb"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.CryptoOptsSignJwt,
        "CryptoSignJwt"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentCacheClientAcquireToken,
        "SltCacheClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentIframeClientAcquireToken,
        "SltIframeClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentRefreshClientAcquireToken,
        "SltRClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SsoSilent,
        "SsoSlt"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientGetDiscoveredAuthority,
        "StdIntClientGetDiscAuth"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.FetchAccountIdWithNativeBroker,
        "FetchAccIdWithNtvBroker"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NativeInteractionClientAcquireToken,
        "NtvIntClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.BaseClientCreateTokenRequestHeaders,
        "BaseClientCreateTReqHead"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NetworkClientSendPostRequestAsync,
        "NetClientSendPost"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientExecutePostToTokenEndpoint,
        "RTClientExecPost"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorizationCodeClientExecutePostToTokenEndpoint,
        "AuthCodeClientExecPost"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.BrokerHandhshake,
        "BrokerHandshake"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByRefreshTokenInBroker,
        "ATByRTInBroker"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByBroker,
        "ATByBroker"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientExecuteTokenRequest,
        "RTClientExecTReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientAcquireToken,
        "RTClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenWithCachedRefreshToken,
        "RTClientATWithCachedRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenByRefreshToken,
        "RTClientATByRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientCreateTokenRequestBody,
        "RTClientCreateTReqBody"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenFromCache,
        "ATFromCache"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentFlowClientAcquireCachedToken,
        "SltFlowClientATCached"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentFlowClientGenerateResultFromCacheRecord,
        "SltFlowClientGenResFromCache"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenBySilentIframe,
        "ATBySltIframe"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.InitializeBaseRequest,
        "InitBaseReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.InitializeSilentRequest,
        "InitSltReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.InitializeClientApplication,
        "InitClientApplication"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentIframeClientTokenHelper,
        "SIClientTHelper"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerInitiateAuthRequest,
        "SHandlerInitAuthReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerMonitorIframeForHash,
        "SltHandlerMonitorIframeForHash"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerLoadFrame,
        "SHandlerLoadFrame"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerLoadFrameSync,
        "SHandlerLoadFrameSync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientCreateAuthCodeClient,
        "StdIntClientCreateAuthCodeClient"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientGetClientConfiguration,
        "StdIntClientGetClientConf"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientInitializeAuthorizationRequest,
        "StdIntClientInitAuthReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientInitializeAuthorizationCodeRequest,
        "StdIntClientInitAuthCodeReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetAuthCodeUrl,
        "GetAuthCodeUrl"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleCodeResponseFromServer,
        "HandleCodeResFromServer"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleCodeResponse,
        "HandleCodeResp"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.UpdateTokenEndpointAuthority,
        "UpdTEndpointAuth"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthClientAcquireToken,
        "AuthClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthClientExecuteTokenRequest,
        "AuthClientExecTReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthClientCreateTokenRequestBody,
        "AuthClientCreateTReqBody"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthClientCreateQueryString,
        "AuthClientCreateQueryStr"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.PopTokenGenerateCnf,
        "PopTGenCnf"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.PopTokenGenerateKid,
        "PopTGenKid"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleServerTokenResponse,
        "HandleServerTRes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.DeserializeResponse,
        "DeserializeRes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityFactoryCreateDiscoveredInstance,
        "AuthFactCreateDiscInst"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityResolveEndpointsAsync,
        "AuthResolveEndpointsAsync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityResolveEndpointsFromLocalSources,
        "AuthResolveEndpointsFromLocal"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityGetCloudDiscoveryMetadataFromNetwork,
        "AuthGetCDMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityUpdateCloudDiscoveryMetadata,
        "AuthUpdCDMeta"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityGetEndpointMetadataFromNetwork,
        "AuthUpdCDMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityUpdateEndpointMetadata,
        "AuthUpdEndpointMeta"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityUpdateMetadataWithRegionalInformation,
        "AuthUpdMetaWithRegInfo"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RegionDiscoveryDetectRegion,
        "RegDiscDetectReg"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RegionDiscoveryGetRegionFromIMDS,
        "RegDiscGetRegFromIMDS"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RegionDiscoveryGetCurrentVersion,
        "RegDiscGetCurrentVer"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByCodeAsync,
        "ATByCodeAsync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetEndpointMetadataFromNetwork,
        "GetEndpointMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetCloudDiscoveryMetadataFromNetworkMeasurement,
        "GetCDMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleRedirectPromiseMeasurement,
        "HandleRedirectPromise"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleNativeRedirectPromiseMeasurement,
        "HandleNtvRedirectPromise"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.UpdateCloudDiscoveryMetadataMeasurement,
        "UpdateCDMeta"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.UsernamePasswordClientAcquireToken,
        "UserPassClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NativeMessageHandlerHandshake,
        "NtvMsgHandlerHandshake"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NativeGenerateAuthResult,
        "NtvGenAuthRes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RemoveHiddenIframe,
        "RemoveHiddenIframe"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.ClearTokensAndKeysWithClaims,
        "ClearTAndKeysWithClaims"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.CacheManagerGetRefreshToken,
        "CacheManagerGetRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GeneratePkceCodes,
        "GenPkceCodes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateCodeVerifier,
        "GenCodeVerifier"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateCodeChallengeFromVerifier,
        "GenCodeChallengeFromVerifier"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.Sha256Digest,
        "Sha256Digest"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetRandomValues,
        "GetRandomValues"
    ]
]);
/**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ const $80a5304d92c187bf$export$bc3547c8ae7b1db = {
    NotStarted: 0,
    InProgress: 1,
    Completed: 2
};
const $80a5304d92c187bf$export$f16d39729f4b7302 = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "queuedTimeMs",
    "startTimeMs",
    "status",
    "multiMatchedAT",
    "multiMatchedID",
    "multiMatchedRT"
]);


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $c21b15fc7f6dcd1f$export$647004217f4122f0 {
    startMeasurement() {
        return;
    }
    endMeasurement() {
        return;
    }
    flushMeasurement() {
        return null;
    }
}
class $c21b15fc7f6dcd1f$export$c70f2989a65fda3e {
    generateId() {
        return "callback-id";
    }
    startMeasurement(measureName, correlationId) {
        return {
            end: ()=>null,
            discard: ()=>{},
            add: ()=>{},
            increment: ()=>{},
            event: {
                eventId: this.generateId(),
                status: (0, $80a5304d92c187bf$export$bc3547c8ae7b1db).InProgress,
                authority: "",
                libraryName: "",
                libraryVersion: "",
                clientId: "",
                name: measureName,
                startTimeMs: Date.now(),
                correlationId: correlationId || ""
            },
            measurement: new $c21b15fc7f6dcd1f$export$647004217f4122f0()
        };
    }
    startPerformanceMeasurement() {
        return new $c21b15fc7f6dcd1f$export$647004217f4122f0();
    }
    calculateQueuedTime() {
        return 0;
    }
    addQueueMeasurement() {
        return;
    }
    setPreQueueTime() {
        return;
    }
    endMeasurement() {
        return null;
    }
    discardMeasurements() {
        return;
    }
    removePerformanceCallback() {
        return true;
    }
    addPerformanceCallback() {
        return "";
    }
    emitEvents() {
        return;
    }
    addFields() {
        return;
    }
    incrementFields() {
        return;
    }
    cacheEventByCorrelationId() {
        return;
    }
}



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $cb0bb957d18a08cc$export$d0d362a73d466c9b {
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ navigateInternal(url, options) {
        return $cb0bb957d18a08cc$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ navigateExternal(url, options) {
        return $cb0bb957d18a08cc$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ static defaultNavigateWindow(url, options) {
        if (options.noHistory) window.location.replace(url);
        else window.location.assign(url);
        return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve(true);
            }, options.timeout);
        });
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Represents network related errors
 */ class $01c2dbbf2115e471$export$bae979e68e4dc802 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(error, httpStatus, responseHeaders){
        super(error.errorCode, error.errorMessage, error.subError);
        Object.setPrototypeOf(this, $01c2dbbf2115e471$export$bae979e68e4dc802.prototype);
        this.name = "NetworkError";
        this.error = error;
        this.httpStatus = httpStatus;
        this.responseHeaders = responseHeaders;
    }
}
/**
 * Creates NetworkError object for a failed network request
 * @param error - Error to be thrown back to the caller
 * @param httpStatus - Status code of the network request
 * @param responseHeaders - Response headers of the network request, when available
 * @returns NetworkError object
 */ function $01c2dbbf2115e471$export$262c4a35fb53be19(error, httpStatus, responseHeaders) {
    return new $01c2dbbf2115e471$export$bae979e68e4dc802(error, httpStatus, responseHeaders);
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $0780bb28b98eb888$export$ee549107fa376fc1 = "pkce_not_created";
const $0780bb28b98eb888$export$6319761d10f0cc4c = "crypto_nonexistent";
const $0780bb28b98eb888$export$be9285c64f247822 = "empty_navigate_uri";
const $0780bb28b98eb888$export$a29c42a1dd414317 = "hash_empty_error";
const $0780bb28b98eb888$export$211c8e8843a8d278 = "no_state_in_hash";
const $0780bb28b98eb888$export$5743873a5ba5d124 = "hash_does_not_contain_known_properties";
const $0780bb28b98eb888$export$237bdd0b913cb30c = "unable_to_parse_state";
const $0780bb28b98eb888$export$499b1b95c97a1c75 = "state_interaction_type_mismatch";
const $0780bb28b98eb888$export$2700dc1c133d227e = "interaction_in_progress";
const $0780bb28b98eb888$export$f1b7091ee48d0b3e = "popup_window_error";
const $0780bb28b98eb888$export$5e827e513523a576 = "empty_window_error";
const $0780bb28b98eb888$export$6bae303c5e922702 = "user_cancelled";
const $0780bb28b98eb888$export$e2e3374c08b8ef2a = "monitor_popup_timeout";
const $0780bb28b98eb888$export$c8b6efb19551013d = "monitor_window_timeout";
const $0780bb28b98eb888$export$9cc12eb574ceee30 = "redirect_in_iframe";
const $0780bb28b98eb888$export$71bafc2814e56c09 = "block_iframe_reload";
const $0780bb28b98eb888$export$c4a80c97d7b48f72 = "block_nested_popups";
const $0780bb28b98eb888$export$6a76760db525f402 = "iframe_closed_prematurely";
const $0780bb28b98eb888$export$78523a40be105a03 = "silent_logout_unsupported";
const $0780bb28b98eb888$export$87933d7d4116cb12 = "no_account_error";
const $0780bb28b98eb888$export$24dae796d0958d3 = "silent_prompt_value_error";
const $0780bb28b98eb888$export$8b51939fb2aab3d7 = "no_token_request_cache_error";
const $0780bb28b98eb888$export$f3ae24cdfaab4488 = "unable_to_parse_token_request_cache_error";
const $0780bb28b98eb888$export$3a2c83e7753553b = "no_cached_authority_error";
const $0780bb28b98eb888$export$c47649cf6408c7b2 = "auth_request_not_set_error";
const $0780bb28b98eb888$export$ff7164a2aeeff392 = "invalid_cache_type";
const $0780bb28b98eb888$export$932e0f52d657f7fb = "non_browser_environment";
const $0780bb28b98eb888$export$4752ced1a1a262f = "database_not_open";
const $0780bb28b98eb888$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $0780bb28b98eb888$export$7a1e28a7b60ca602 = "post_request_failed";
const $0780bb28b98eb888$export$45e7eaaecd19d31e = "get_request_failed";
const $0780bb28b98eb888$export$96735047beea85a0 = "failed_to_parse_response";
const $0780bb28b98eb888$export$6acf650331eb5f5f = "unable_to_load_token";
const $0780bb28b98eb888$export$a416b0eceb5c15df = "crypto_key_not_found";
const $0780bb28b98eb888$export$e502d98cd8d2da43 = "auth_code_required";
const $0780bb28b98eb888$export$8bea68053103eaeb = "auth_code_or_nativeAccountId_required";
const $0780bb28b98eb888$export$1efb009e9d75bbe4 = "spa_code_and_nativeAccountId_present";
const $0780bb28b98eb888$export$c1110692d2978b8 = "database_unavailable";
const $0780bb28b98eb888$export$b897bbe2c683def2 = "unable_to_acquire_token_from_native_platform";
const $0780bb28b98eb888$export$4747c302ef0117fd = "native_handshake_timeout";
const $0780bb28b98eb888$export$59080ea2398ee306 = "native_extension_not_installed";
const $0780bb28b98eb888$export$7b7357e3538624aa = "native_connection_not_established";
const $0780bb28b98eb888$export$436657cdcd7fe2be = "uninitialized_public_client_application";
const $0780bb28b98eb888$export$62fdd8848aa75547 = "native_prompt_not_supported";
const $0780bb28b98eb888$export$fcc6790b5d12da63 = "invalid_base64_string";
const $0780bb28b98eb888$export$f6f43ae33ad04b91 = "invalid_pop_token_request";
const $0780bb28b98eb888$export$df9e6aae71bd84f = "failed_to_build_headers";
const $0780bb28b98eb888$export$487fe7232a90003c = "failed_to_parse_headers";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $6e0b7bb04b1e6592$var$ErrorLink = "For more visit: aka.ms/msaljs/browser-errors";
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $6e0b7bb04b1e6592$export$16ffff3fb076c606 = {
    [(0, $0780bb28b98eb888$export$ee549107fa376fc1)]: "The PKCE code challenge and verifier could not be generated.",
    [(0, $0780bb28b98eb888$export$6319761d10f0cc4c)]: "The crypto object or function is not available.",
    [(0, $0780bb28b98eb888$export$be9285c64f247822)]: "Navigation URI is empty. Please check stack trace for more info.",
    [(0, $0780bb28b98eb888$export$a29c42a1dd414317)]: `Hash value cannot be processed because it is empty. Please verify that your redirectUri is not clearing the hash. ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$211c8e8843a8d278)]: "Hash does not contain state. Please verify that the request originated from msal.",
    [(0, $0780bb28b98eb888$export$5743873a5ba5d124)]: `Hash does not contain known properites. Please verify that your redirectUri is not changing the hash.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$237bdd0b913cb30c)]: "Unable to parse state. Please verify that the request originated from msal.",
    [(0, $0780bb28b98eb888$export$499b1b95c97a1c75)]: "Hash contains state but the interaction type does not match the caller.",
    [(0, $0780bb28b98eb888$export$2700dc1c133d227e)]: `Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.   ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$f1b7091ee48d0b3e)]: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser.",
    [(0, $0780bb28b98eb888$export$5e827e513523a576)]: "window.open returned null or undefined window object.",
    [(0, $0780bb28b98eb888$export$6bae303c5e922702)]: "User cancelled the flow.",
    [(0, $0780bb28b98eb888$export$e2e3374c08b8ef2a)]: `Token acquisition in popup failed due to timeout.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$c8b6efb19551013d)]: `Token acquisition in iframe failed due to timeout.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$9cc12eb574ceee30)]: "Redirects are not supported for iframed or brokered applications. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs.",
    [(0, $0780bb28b98eb888$export$71bafc2814e56c09)]: `Request was blocked inside an iframe because MSAL detected an authentication response.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$c4a80c97d7b48f72)]: "Request was blocked inside a popup because MSAL detected it was running in a popup.",
    [(0, $0780bb28b98eb888$export$6a76760db525f402)]: "The iframe being monitored was closed prematurely.",
    [(0, $0780bb28b98eb888$export$78523a40be105a03)]: "Silent logout not supported. Please call logoutRedirect or logoutPopup instead.",
    [(0, $0780bb28b98eb888$export$87933d7d4116cb12)]: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request.",
    [(0, $0780bb28b98eb888$export$24dae796d0958d3)]: "The value given for the prompt value is not valid for silent requests - must be set to 'none' or 'no_session'.",
    [(0, $0780bb28b98eb888$export$8b51939fb2aab3d7)]: "No token request found in cache.",
    [(0, $0780bb28b98eb888$export$f3ae24cdfaab4488)]: "The cached token request could not be parsed.",
    [(0, $0780bb28b98eb888$export$3a2c83e7753553b)]: "No cached authority found.",
    [(0, $0780bb28b98eb888$export$c47649cf6408c7b2)]: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler",
    [(0, $0780bb28b98eb888$export$ff7164a2aeeff392)]: "Invalid cache type",
    [(0, $0780bb28b98eb888$export$932e0f52d657f7fb)]: "Login and token requests are not supported in non-browser environments.",
    [(0, $0780bb28b98eb888$export$4752ced1a1a262f)]: "Database is not open!",
    [(0, $0780bb28b98eb888$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $0780bb28b98eb888$export$7a1e28a7b60ca602)]: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'",
    [(0, $0780bb28b98eb888$export$45e7eaaecd19d31e)]: "Network request failed. Please check the network trace to determine root cause.",
    [(0, $0780bb28b98eb888$export$96735047beea85a0)]: "Failed to parse network response. Check network trace.",
    [(0, $0780bb28b98eb888$export$6acf650331eb5f5f)]: "Error loading token to cache.",
    [(0, $0780bb28b98eb888$export$a416b0eceb5c15df)]: "Cryptographic Key or Keypair not found in browser storage.",
    [(0, $0780bb28b98eb888$export$e502d98cd8d2da43)]: "An authorization code must be provided (as the `code` property on the request) to this flow.",
    [(0, $0780bb28b98eb888$export$8bea68053103eaeb)]: "An authorization code or nativeAccountId must be provided to this flow.",
    [(0, $0780bb28b98eb888$export$1efb009e9d75bbe4)]: "Request cannot contain both spa code and native account id.",
    [(0, $0780bb28b98eb888$export$c1110692d2978b8)]: "IndexedDB, which is required for persistent cryptographic key storage, is unavailable. This may be caused by browser privacy features which block persistent storage in third-party contexts.",
    [(0, $0780bb28b98eb888$export$b897bbe2c683def2)]: `Unable to acquire token from native platform.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$4747c302ef0117fd)]: "Timed out while attempting to establish connection to browser extension",
    [(0, $0780bb28b98eb888$export$59080ea2398ee306)]: "Native extension is not installed. If you think this is a mistake call the initialize function.",
    [(0, $0780bb28b98eb888$export$7b7357e3538624aa)]: `Connection to native platform has not been established. Please install a compatible browser extension and run initialize().  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$436657cdcd7fe2be)]: `You must call and await the initialize function before attempting to call any other MSAL API.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$62fdd8848aa75547)]: "The provided prompt is not supported by the native platform. This request should be routed to the web based flow.",
    [(0, $0780bb28b98eb888$export$fcc6790b5d12da63)]: "Invalid base64 encoded string.",
    [(0, $0780bb28b98eb888$export$f6f43ae33ad04b91)]: "Invalid PoP token request. The request should not have both a popKid value and signPopToken set to true.",
    [(0, $0780bb28b98eb888$export$df9e6aae71bd84f)]: "Failed to build request headers object.",
    [(0, $0780bb28b98eb888$export$487fe7232a90003c)]: "Failed to parse response headers"
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use exported BrowserAuthErrorCodes instead.
 * In your app you can do :
 * ```
 * import { BrowserAuthErrorCodes } from "@azure/msal-browser";
 * ```
 */ const $6e0b7bb04b1e6592$export$6deffaef56f0bd5a = {
    pkceNotGenerated: {
        code: (0, $0780bb28b98eb888$export$ee549107fa376fc1),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$ee549107fa376fc1]
    },
    cryptoDoesNotExist: {
        code: (0, $0780bb28b98eb888$export$6319761d10f0cc4c),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6319761d10f0cc4c]
    },
    emptyNavigateUriError: {
        code: (0, $0780bb28b98eb888$export$be9285c64f247822),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$be9285c64f247822]
    },
    hashEmptyError: {
        code: (0, $0780bb28b98eb888$export$a29c42a1dd414317),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$a29c42a1dd414317]
    },
    hashDoesNotContainStateError: {
        code: (0, $0780bb28b98eb888$export$211c8e8843a8d278),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$211c8e8843a8d278]
    },
    hashDoesNotContainKnownPropertiesError: {
        code: (0, $0780bb28b98eb888$export$5743873a5ba5d124),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$5743873a5ba5d124]
    },
    unableToParseStateError: {
        code: (0, $0780bb28b98eb888$export$237bdd0b913cb30c),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$237bdd0b913cb30c]
    },
    stateInteractionTypeMismatchError: {
        code: (0, $0780bb28b98eb888$export$499b1b95c97a1c75),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$499b1b95c97a1c75]
    },
    interactionInProgress: {
        code: (0, $0780bb28b98eb888$export$2700dc1c133d227e),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$2700dc1c133d227e]
    },
    popupWindowError: {
        code: (0, $0780bb28b98eb888$export$f1b7091ee48d0b3e),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$f1b7091ee48d0b3e]
    },
    emptyWindowError: {
        code: (0, $0780bb28b98eb888$export$5e827e513523a576),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$5e827e513523a576]
    },
    userCancelledError: {
        code: (0, $0780bb28b98eb888$export$6bae303c5e922702),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6bae303c5e922702]
    },
    monitorPopupTimeoutError: {
        code: (0, $0780bb28b98eb888$export$e2e3374c08b8ef2a),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$e2e3374c08b8ef2a]
    },
    monitorIframeTimeoutError: {
        code: (0, $0780bb28b98eb888$export$c8b6efb19551013d),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c8b6efb19551013d]
    },
    redirectInIframeError: {
        code: (0, $0780bb28b98eb888$export$9cc12eb574ceee30),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$9cc12eb574ceee30]
    },
    blockTokenRequestsInHiddenIframeError: {
        code: (0, $0780bb28b98eb888$export$71bafc2814e56c09),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$71bafc2814e56c09]
    },
    blockAcquireTokenInPopupsError: {
        code: (0, $0780bb28b98eb888$export$c4a80c97d7b48f72),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c4a80c97d7b48f72]
    },
    iframeClosedPrematurelyError: {
        code: (0, $0780bb28b98eb888$export$6a76760db525f402),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6a76760db525f402]
    },
    silentLogoutUnsupportedError: {
        code: (0, $0780bb28b98eb888$export$78523a40be105a03),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$78523a40be105a03]
    },
    noAccountError: {
        code: (0, $0780bb28b98eb888$export$87933d7d4116cb12),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$87933d7d4116cb12]
    },
    silentPromptValueError: {
        code: (0, $0780bb28b98eb888$export$24dae796d0958d3),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$24dae796d0958d3]
    },
    noTokenRequestCacheError: {
        code: (0, $0780bb28b98eb888$export$8b51939fb2aab3d7),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$8b51939fb2aab3d7]
    },
    unableToParseTokenRequestCacheError: {
        code: (0, $0780bb28b98eb888$export$f3ae24cdfaab4488),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$f3ae24cdfaab4488]
    },
    noCachedAuthorityError: {
        code: (0, $0780bb28b98eb888$export$3a2c83e7753553b),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$3a2c83e7753553b]
    },
    authRequestNotSet: {
        code: (0, $0780bb28b98eb888$export$c47649cf6408c7b2),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c47649cf6408c7b2]
    },
    invalidCacheType: {
        code: (0, $0780bb28b98eb888$export$ff7164a2aeeff392),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$ff7164a2aeeff392]
    },
    notInBrowserEnvironment: {
        code: (0, $0780bb28b98eb888$export$932e0f52d657f7fb),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$932e0f52d657f7fb]
    },
    databaseNotOpen: {
        code: (0, $0780bb28b98eb888$export$4752ced1a1a262f),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$4752ced1a1a262f]
    },
    noNetworkConnectivity: {
        code: (0, $0780bb28b98eb888$export$31ae862f18c3b2b7),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$31ae862f18c3b2b7]
    },
    postRequestFailed: {
        code: (0, $0780bb28b98eb888$export$7a1e28a7b60ca602),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$7a1e28a7b60ca602]
    },
    getRequestFailed: {
        code: (0, $0780bb28b98eb888$export$45e7eaaecd19d31e),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$45e7eaaecd19d31e]
    },
    failedToParseNetworkResponse: {
        code: (0, $0780bb28b98eb888$export$96735047beea85a0),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$96735047beea85a0]
    },
    unableToLoadTokenError: {
        code: (0, $0780bb28b98eb888$export$6acf650331eb5f5f),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6acf650331eb5f5f]
    },
    signingKeyNotFoundInStorage: {
        code: (0, $0780bb28b98eb888$export$a416b0eceb5c15df),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$a416b0eceb5c15df]
    },
    authCodeRequired: {
        code: (0, $0780bb28b98eb888$export$e502d98cd8d2da43),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$e502d98cd8d2da43]
    },
    authCodeOrNativeAccountRequired: {
        code: (0, $0780bb28b98eb888$export$8bea68053103eaeb),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$8bea68053103eaeb]
    },
    spaCodeAndNativeAccountPresent: {
        code: (0, $0780bb28b98eb888$export$1efb009e9d75bbe4),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$1efb009e9d75bbe4]
    },
    databaseUnavailable: {
        code: (0, $0780bb28b98eb888$export$c1110692d2978b8),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c1110692d2978b8]
    },
    unableToAcquireTokenFromNativePlatform: {
        code: (0, $0780bb28b98eb888$export$b897bbe2c683def2),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$b897bbe2c683def2]
    },
    nativeHandshakeTimeout: {
        code: (0, $0780bb28b98eb888$export$4747c302ef0117fd),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$4747c302ef0117fd]
    },
    nativeExtensionNotInstalled: {
        code: (0, $0780bb28b98eb888$export$59080ea2398ee306),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$59080ea2398ee306]
    },
    nativeConnectionNotEstablished: {
        code: (0, $0780bb28b98eb888$export$7b7357e3538624aa),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$7b7357e3538624aa]
    },
    uninitializedPublicClientApplication: {
        code: (0, $0780bb28b98eb888$export$436657cdcd7fe2be),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$436657cdcd7fe2be]
    },
    nativePromptNotSupported: {
        code: (0, $0780bb28b98eb888$export$62fdd8848aa75547),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$62fdd8848aa75547]
    },
    invalidBase64StringError: {
        code: (0, $0780bb28b98eb888$export$fcc6790b5d12da63),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$fcc6790b5d12da63]
    },
    invalidPopTokenRequest: {
        code: (0, $0780bb28b98eb888$export$f6f43ae33ad04b91),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$f6f43ae33ad04b91]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $6e0b7bb04b1e6592$export$f8eb6760ca13876a extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, subError){
        super(errorCode, $6e0b7bb04b1e6592$export$16ffff3fb076c606[errorCode], subError);
        Object.setPrototypeOf(this, $6e0b7bb04b1e6592$export$f8eb6760ca13876a.prototype);
        this.name = "BrowserAuthError";
    }
}
function $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb(errorCode, subError) {
    return new $6e0b7bb04b1e6592$export$f8eb6760ca13876a(errorCode, subError);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ class $f210e947e17010a2$export$4c206ef5be879972 {
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ async sendGetRequestAsync(url, options) {
        let response;
        let responseHeaders = {};
        let responseStatus = 0;
        const reqHeaders = $f210e947e17010a2$var$getFetchHeaders(options);
        try {
            response = await fetch(url, {
                method: (0, $5ff55562d73e0e2b$export$c774c31b4c31da8).GET,
                headers: reqHeaders
            });
        } catch (e) {
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $0780bb28b98eb888$export$45e7eaaecd19d31e) : (0, $0780bb28b98eb888$export$31ae862f18c3b2b7));
        }
        responseHeaders = $f210e947e17010a2$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$96735047beea85a0)), responseStatus, responseHeaders);
        }
    }
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ async sendPostRequestAsync(url, options) {
        const reqBody = options && options.body || "";
        const reqHeaders = $f210e947e17010a2$var$getFetchHeaders(options);
        let response;
        let responseStatus = 0;
        let responseHeaders = {};
        try {
            response = await fetch(url, {
                method: (0, $5ff55562d73e0e2b$export$c774c31b4c31da8).POST,
                headers: reqHeaders,
                body: reqBody
            });
        } catch (e) {
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $0780bb28b98eb888$export$7a1e28a7b60ca602) : (0, $0780bb28b98eb888$export$31ae862f18c3b2b7));
        }
        responseHeaders = $f210e947e17010a2$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$96735047beea85a0)), responseStatus, responseHeaders);
        }
    }
}
/**
 * Get Fetch API Headers object from string map
 * @param inputHeaders
 */ function $f210e947e17010a2$var$getFetchHeaders(options) {
    try {
        const headers = new Headers();
        if (!(options && options.headers)) return headers;
        const optionsHeaders = options.headers;
        Object.entries(optionsHeaders).forEach(([key, value])=>{
            headers.append(key, value);
        });
        return headers;
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$df9e6aae71bd84f));
    }
}
/**
 * Returns object representing response headers
 * @param headers
 * @returns
 */ function $f210e947e17010a2$var$getHeaderDict(headers) {
    try {
        const headerDict = {};
        headers.forEach((value, key)=>{
            headerDict[key] = value;
        });
        return headerDict;
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$487fe7232a90003c));
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ /**
 * Returns URL Safe b64 encoded string from a plaintext string.
 * @param input
 */ function $6f6986007da7f422$export$9ef804feabbcbaf1(input) {
    return encodeURIComponent($6f6986007da7f422$export$e510a73ee562749(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"));
}
/**
 * Returns URL Safe b64 encoded string from an int8Array.
 * @param inputArr
 */ function $6f6986007da7f422$export$84f5a428c7153a69(inputArr) {
    return $6f6986007da7f422$var$base64EncArr(inputArr).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * Returns b64 encoded string from plaintext string.
 * @param input
 */ function $6f6986007da7f422$export$e510a73ee562749(input) {
    return $6f6986007da7f422$var$base64EncArr(new TextEncoder().encode(input));
}
/**
 * Base64 encode byte array
 * @param aBytes
 */ function $6f6986007da7f422$var$base64EncArr(aBytes) {
    const binString = Array.from(aBytes, (x)=>String.fromCodePoint(x)).join("");
    return btoa(binString);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This file defines functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // RSA KeyGen Algorithm
const $4e0948336b4ea4a7$var$PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
// SHA-256 hashing algorithm
const $4e0948336b4ea4a7$var$S256_HASH_ALG = "SHA-256";
// MOD length for PoP tokens
const $4e0948336b4ea4a7$var$MODULUS_LENGTH = 2048;
// Public Exponent
const $4e0948336b4ea4a7$var$PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
// UUID hex digits
const $4e0948336b4ea4a7$var$UUID_CHARS = "0123456789abcdef";
// Array to store UINT32 random value
const $4e0948336b4ea4a7$var$UINT32_ARR = new Uint32Array(1);
const $4e0948336b4ea4a7$var$SUBTLE_SUBERROR = "crypto_subtle_undefined";
const $4e0948336b4ea4a7$var$keygenAlgorithmOptions = {
    name: $4e0948336b4ea4a7$var$PKCS1_V15_KEYGEN_ALG,
    hash: $4e0948336b4ea4a7$var$S256_HASH_ALG,
    modulusLength: $4e0948336b4ea4a7$var$MODULUS_LENGTH,
    publicExponent: $4e0948336b4ea4a7$var$PUBLIC_EXPONENT
};
/**
 * Check whether browser crypto is available.
 */ function $4e0948336b4ea4a7$export$1ddcc6bab2bf2314(skipValidateSubtleCrypto) {
    if (!window) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$932e0f52d657f7fb));
    if (!window.crypto) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6319761d10f0cc4c));
    if (!skipValidateSubtleCrypto && !window.crypto.subtle) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6319761d10f0cc4c), $4e0948336b4ea4a7$var$SUBTLE_SUBERROR);
}
/**
 * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
 * @param dataString {string} data string
 * @param performanceClient {?IPerformanceClient}
 * @param correlationId {?string} correlation id
 */ async function $4e0948336b4ea4a7$export$52caff7bddbaf316(dataString, performanceClient, correlationId) {
    performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).Sha256Digest, correlationId);
    const encoder = new TextEncoder();
    const data = encoder.encode(dataString);
    return window.crypto.subtle.digest($4e0948336b4ea4a7$var$S256_HASH_ALG, data);
}
/**
 * Populates buffer with cryptographically random values.
 * @param dataBuffer
 */ function $4e0948336b4ea4a7$export$960b9ff25e7d4257(dataBuffer) {
    return window.crypto.getRandomValues(dataBuffer);
}
/**
 * Returns random Uint32 value.
 * @returns {number}
 */ function $4e0948336b4ea4a7$var$getRandomUint32() {
    window.crypto.getRandomValues($4e0948336b4ea4a7$var$UINT32_ARR);
    return $4e0948336b4ea4a7$var$UINT32_ARR[0];
}
/**
 * Creates a UUID v7 from the current timestamp.
 * Implementation relies on the system clock to guarantee increasing order of generated identifiers.
 * @returns {number}
 */ function $4e0948336b4ea4a7$export$6ef0355fa80a5278() {
    const currentTimestamp = Date.now();
    const baseRand = $4e0948336b4ea4a7$var$getRandomUint32() * 0x400 + ($4e0948336b4ea4a7$var$getRandomUint32() & 0x3ff);
    // Result byte array
    const bytes = new Uint8Array(16);
    // A 12-bit `rand_a` field value
    const randA = Math.trunc(baseRand / 2 ** 30);
    // The higher 30 bits of 62-bit `rand_b` field value
    const randBHi = baseRand & 2 ** 30 - 1;
    // The lower 32 bits of 62-bit `rand_b` field value
    const randBLo = $4e0948336b4ea4a7$var$getRandomUint32();
    bytes[0] = currentTimestamp / 2 ** 40;
    bytes[1] = currentTimestamp / 2 ** 32;
    bytes[2] = currentTimestamp / 2 ** 24;
    bytes[3] = currentTimestamp / 2 ** 16;
    bytes[4] = currentTimestamp / 256;
    bytes[5] = currentTimestamp;
    bytes[6] = 0x70 | randA >>> 8;
    bytes[7] = randA;
    bytes[8] = 0x80 | randBHi >>> 24;
    bytes[9] = randBHi >>> 16;
    bytes[10] = randBHi >>> 8;
    bytes[11] = randBHi;
    bytes[12] = randBLo >>> 24;
    bytes[13] = randBLo >>> 16;
    bytes[14] = randBLo >>> 8;
    bytes[15] = randBLo;
    let text = "";
    for(let i = 0; i < bytes.length; i++){
        text += $4e0948336b4ea4a7$var$UUID_CHARS.charAt(bytes[i] >>> 4);
        text += $4e0948336b4ea4a7$var$UUID_CHARS.charAt(bytes[i] & 0xf);
        if (i === 3 || i === 5 || i === 7 || i === 9) text += "-";
    }
    return text;
}
/**
 * Generates a keypair based on current keygen algorithm config.
 * @param extractable
 * @param usages
 */ async function $4e0948336b4ea4a7$export$a949d36eab55b41f(extractable, usages) {
    return window.crypto.subtle.generateKey($4e0948336b4ea4a7$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Export key as Json Web Key (JWK)
 * @param key
 */ async function $4e0948336b4ea4a7$export$88781b8595a7d2ff(key) {
    return window.crypto.subtle.exportKey((0, $5ff55562d73e0e2b$export$1294c3e3f84694cd), key);
}
/**
 * Imports key as Json Web Key (JWK), can set extractable and usages.
 * @param key
 * @param extractable
 * @param usages
 */ async function $4e0948336b4ea4a7$export$8bdea4e2e3f593c9(key, extractable, usages) {
    return window.crypto.subtle.importKey((0, $5ff55562d73e0e2b$export$1294c3e3f84694cd), key, $4e0948336b4ea4a7$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Signs given data with given key
 * @param key
 * @param data
 */ async function $4e0948336b4ea4a7$export$c5552dfdbc7cec71(key, data) {
    return window.crypto.subtle.sign($4e0948336b4ea4a7$var$keygenAlgorithmOptions, key, data);
}
/**
 * Returns the SHA-256 hash of an input string
 * @param plainText
 */ async function $4e0948336b4ea4a7$export$9169be2e06c9c165(plainText) {
    const hashBuffer = await $4e0948336b4ea4a7$export$52caff7bddbaf316(plainText);
    const hashBytes = new Uint8Array(hashBuffer);
    return (0, $6f6986007da7f422$export$84f5a428c7153a69)(hashBytes);
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Clears hash from window url.
 */ function $3003b661a087a867$export$a20c3032ba81d6aa(contentWindow) {
    // Office.js sets history.replaceState to null
    contentWindow.location.hash = "";
    if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
    contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}${contentWindow.location.search}`);
}
/**
 * Replaces current hash with hash from provided url
 */ function $3003b661a087a867$export$9bf2691bda54425c(url) {
    const urlParts = url.split("#");
    urlParts.shift(); // Remove part before the hash
    window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
}
/**
 * Returns boolean of whether the current window is in an iframe or not.
 */ function $3003b661a087a867$export$9f140ed41af5108c() {
    return window.parent !== window;
}
/**
 * Returns boolean of whether or not the current window is a popup opened by msal
 */ function $3003b661a087a867$export$722fdce8786cc28b() {
    return typeof window !== "undefined" && !!window.opener && window.opener !== window && typeof window.name === "string" && window.name.indexOf(`${(0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.`) === 0;
}
// #endregion
/**
 * Returns current window URL as redirect uri
 */ function $3003b661a087a867$export$1204531fbbf6ecde() {
    return typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "";
}
/**
 * Gets the homepage url for the current window location.
 */ function $3003b661a087a867$export$60785768478b4ffc() {
    const currentUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(window.location.href);
    const urlComponents = currentUrl.getUrlComponents();
    return `${urlComponents.Protocol}//${urlComponents.HostNameAndPort}/`;
}
/**
 * Throws error if we have completed an auth and are
 * attempting another auth request inside an iframe.
 */ function $3003b661a087a867$export$8fdba407d8e31f54() {
    const isResponseHash = (0, $f7f911f196324278$export$3abcdca7229e54f2).hashContainsKnownProperties(window.location.hash);
    // return an error if called from the hidden iframe created by the msal js silent calls
    if (isResponseHash && $3003b661a087a867$export$9f140ed41af5108c()) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$71bafc2814e56c09));
}
/**
 * Block redirect operations in iframes unless explicitly allowed
 * @param interactionType Interaction type for the request
 * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
 */ function $3003b661a087a867$export$5ae6b09f947c8a9e(allowRedirectInIframe) {
    if ($3003b661a087a867$export$9f140ed41af5108c() && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
    throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$9cc12eb574ceee30));
}
/**
 * Block redirectUri loaded in popup from calling AcquireToken APIs
 */ function $3003b661a087a867$export$dc99b653c8cd2cd7() {
    // Popups opened by msal popup APIs are given a name that starts with "msal."
    if ($3003b661a087a867$export$722fdce8786cc28b()) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$c4a80c97d7b48f72));
}
/**
 * Throws error if token requests are made in non-browser environment
 * @param isBrowserEnvironment Flag indicating if environment is a browser.
 */ function $3003b661a087a867$export$c7939bfe92ae2787() {
    if (typeof window === "undefined") throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$932e0f52d657f7fb));
}
/**
 * Throws error if initialize hasn't been called
 * @param initialized
 */ function $3003b661a087a867$export$630119c5db8b5529(initialized) {
    if (!initialized) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$436657cdcd7fe2be));
}
/**
 * Helper to validate app environment before making an auth request
 * @param initialized
 */ function $3003b661a087a867$export$4dd091cbdc98b52e(initialized) {
    // Block request if not in browser environment
    $3003b661a087a867$export$c7939bfe92ae2787();
    // Block auth requests inside a hidden iframe
    $3003b661a087a867$export$8fdba407d8e31f54();
    // Block redirectUri opened in a popup from calling MSAL APIs
    $3003b661a087a867$export$dc99b653c8cd2cd7();
    // Block token acquisition before initialize has been called
    $3003b661a087a867$export$630119c5db8b5529(initialized);
}
/**
 * Helper to validate app enviornment before making redirect request
 * @param initialized
 * @param config
 */ function $3003b661a087a867$export$62c8f4fdca4df60f(initialized, config) {
    $3003b661a087a867$export$4dd091cbdc98b52e(initialized);
    $3003b661a087a867$export$5ae6b09f947c8a9e(config.system.allowRedirectInIframe);
    // Block redirects if memory storage is enabled but storeAuthStateInCookie is not
    if (config.cache.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage && !config.cache.storeAuthStateInCookie) throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$37486e3b6bed61c6));
}
/**
 * Adds a preconnect link element to the header which begins DNS resolution and SSL connection in anticipation of the /token request
 * @param loginDomain Authority domain, including https protocol e.g. https://login.microsoftonline.com
 * @returns
 */ function $3003b661a087a867$export$a0816fa17a9e79be(authority) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = new URL(authority).origin;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
    // The browser will close connection if not used within a few seconds, remove element from the header after 10s
    window.setTimeout(()=>{
        try {
            document.head.removeChild(link);
        } catch  {}
    }, 10000); // 10s Timeout
}
/**
 * Wrapper function that creates a UUID v7 from the current timestamp.
 * @returns {string}
 */ function $3003b661a087a867$export$7571c350ed9fec74() {
    return (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
const $68fb5a78014bcfe7$export$a5835ee54399d410 = 60000;
const $68fb5a78014bcfe7$export$f3ffe700be354b19 = 10000;
const $68fb5a78014bcfe7$export$293647e7865520c6 = 30000;
const $68fb5a78014bcfe7$export$73d1d87a8b7ddb57 = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function $68fb5a78014bcfe7$export$f8352245bee68086({ auth: userInputAuth, cache: userInputCache, system: userInputSystem, telemetry: userInputTelemetry }, isBrowserEnvironment) {
    // Default auth options for browser
    const DEFAULT_AUTH_OPTIONS = {
        clientId: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        authority: `${(0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_AUTHORITY}`,
        knownAuthorities: [],
        cloudDiscoveryMetadata: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        authorityMetadata: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        redirectUri: typeof window !== "undefined" ? (0, $3003b661a087a867$export$1204531fbbf6ecde)() : "",
        postLogoutRedirectUri: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        navigateToLoginRequestUrl: true,
        clientCapabilities: [],
        protocolMode: (0, $de576c4d1becc778$export$73a3e3dedd37150d).AAD,
        OIDCOptions: {
            serverResponseType: (0, $7c375ae106b964be$export$b34cb6fbea2adc44).FRAGMENT,
            defaultScopes: [
                (0, $7c375ae106b964be$export$a002182e51710d39).OPENID_SCOPE,
                (0, $7c375ae106b964be$export$a002182e51710d39).PROFILE_SCOPE,
                (0, $7c375ae106b964be$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE
            ]
        },
        azureCloudOptions: {
            azureCloudInstance: (0, $399fa9610e7cb0fb$export$4cda21933050d9ec).None,
            tenant: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        },
        skipAuthorityMetadataCache: false,
        supportsNestedAppAuth: false,
        instanceAware: false
    };
    // Default cache options for browser
    const DEFAULT_CACHE_OPTIONS = {
        cacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage,
        temporaryCacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        // Default cache migration to true if cache location is localStorage since entries are preserved across tabs/windows. Migration has little to no benefit in sessionStorage and memoryStorage
        cacheMigrationEnabled: userInputCache && userInputCache.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage ? true : false,
        claimsBasedCachingEnabled: false
    };
    // Default logger options for browser
    const DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: ()=>{
        // allow users to not set logger call back
        },
        logLevel: (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    const DEFAULT_BROWSER_SYSTEM_OPTIONS = {
        ...(0, $d21eb39178ebb5ae$export$f7a7dd6bfc156d75),
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? new (0, $f210e947e17010a2$export$4c206ef5be879972)() : (0, $04922ae8364b32fe$export$6d95060a8ed7155a),
        navigationClient: new (0, $cb0bb957d18a08cc$export$d0d362a73d466c9b)(),
        loadFrameTimeout: 0,
        // If loadFrameTimeout is provided, use that as default.
        windowHashTimeout: userInputSystem?.loadFrameTimeout || $68fb5a78014bcfe7$export$a5835ee54399d410,
        iframeHashTimeout: userInputSystem?.loadFrameTimeout || $68fb5a78014bcfe7$export$f3ffe700be354b19,
        navigateFrameWait: 0,
        redirectNavigationTimeout: $68fb5a78014bcfe7$export$293647e7865520c6,
        asyncPopups: false,
        allowRedirectInIframe: false,
        allowNativeBroker: false,
        nativeBrokerHandshakeTimeout: userInputSystem?.nativeBrokerHandshakeTimeout || $68fb5a78014bcfe7$export$73d1d87a8b7ddb57,
        pollIntervalMilliseconds: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).DEFAULT_POLL_INTERVAL_MS
    };
    const providedSystemOptions = {
        ...DEFAULT_BROWSER_SYSTEM_OPTIONS,
        ...userInputSystem,
        loggerOptions: userInputSystem?.loggerOptions || DEFAULT_LOGGER_OPTIONS
    };
    const DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            appVersion: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        },
        client: new (0, $c21b15fc7f6dcd1f$export$c70f2989a65fda3e)()
    };
    // Throw an error if user has set OIDCOptions without being in OIDC protocol mode
    if (userInputAuth?.protocolMode !== (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC && userInputAuth?.OIDCOptions) {
        const logger = new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(providedSystemOptions.loggerOptions);
        logger.warning(JSON.stringify((0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).cannotSetOIDCOptions)));
    }
    // Throw an error if user has set allowNativeBroker to true without being in AAD protocol mode
    if (userInputAuth?.protocolMode && userInputAuth.protocolMode !== (0, $de576c4d1becc778$export$73a3e3dedd37150d).AAD && providedSystemOptions?.allowNativeBroker) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).cannotAllowNativeBroker);
    const overlayedConfig = {
        auth: {
            ...DEFAULT_AUTH_OPTIONS,
            ...userInputAuth,
            OIDCOptions: {
                ...DEFAULT_AUTH_OPTIONS.OIDCOptions,
                ...userInputAuth?.OIDCOptions
            }
        },
        cache: {
            ...DEFAULT_CACHE_OPTIONS,
            ...userInputCache
        },
        system: providedSystemOptions,
        telemetry: {
            ...DEFAULT_TELEMETRY_OPTIONS,
            ...userInputTelemetry
        }
    };
    return overlayedConfig;
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/* eslint-disable header/header */ const $183cce12cb16965c$export$a8ff84c12d48cfa6 = "@azure/msal-browser";
const $183cce12cb16965c$export$83d89fbfd8236492 = "3.30.0";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base class for operating context
 * Operating contexts are contexts in which MSAL.js is being run
 * More than one operating context may be available at a time
 * It's important from a logging and telemetry point of view for us to be able to identify the operating context.
 * For example: Some operating contexts will pre-cache tokens impacting performance telemetry
 */ class $277b893ea3b41414$export$3aea257f46651b2b {
    static loggerCallback(level, message) {
        switch(level){
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Error:
                // eslint-disable-next-line no-console
                console.error(message);
                return;
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Info:
                // eslint-disable-next-line no-console
                console.info(message);
                return;
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Verbose:
                // eslint-disable-next-line no-console
                console.debug(message);
                return;
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Warning:
                // eslint-disable-next-line no-console
                console.warn(message);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(message);
                return;
        }
    }
    constructor(config){
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.browserEnvironment = typeof window !== "undefined";
        this.config = (0, $68fb5a78014bcfe7$export$f8352245bee68086)(config, this.browserEnvironment);
        let sessionStorage;
        try {
            sessionStorage = window[(0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage];
        // Mute errors if it's a non-browser environment or cookies are blocked.
        } catch (e) {}
        const logLevelKey = sessionStorage?.getItem((0, $5ff55562d73e0e2b$export$b28668d53eb57e63));
        const piiLoggingKey = sessionStorage?.getItem((0, $5ff55562d73e0e2b$export$d9bc1c202a3825f1))?.toLowerCase();
        const piiLoggingEnabled = piiLoggingKey === "true" ? true : piiLoggingKey === "false" ? false : undefined;
        const loggerOptions = {
            ...this.config.system.loggerOptions
        };
        const logLevel = logLevelKey && Object.keys((0, $0bf1d54ef751a29c$export$243e62d78d3b544d)).includes(logLevelKey) ? (0, $0bf1d54ef751a29c$export$243e62d78d3b544d)[logLevelKey] : undefined;
        if (logLevel) {
            loggerOptions.loggerCallback = $277b893ea3b41414$export$3aea257f46651b2b.loggerCallback;
            loggerOptions.logLevel = logLevel;
        }
        if (piiLoggingEnabled !== undefined) loggerOptions.piiLoggingEnabled = piiLoggingEnabled;
        this.logger = new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(loggerOptions, (0, $183cce12cb16965c$export$a8ff84c12d48cfa6), (0, $183cce12cb16965c$export$83d89fbfd8236492));
        this.available = false;
    }
    /**
     * Return the MSAL config
     * @returns BrowserConfiguration
     */ getConfig() {
        return this.config;
    }
    /**
     * Returns the MSAL Logger
     * @returns Logger
     */ getLogger() {
        return this.logger;
    }
    isAvailable() {
        return this.available;
    }
    isBrowserEnvironment() {
        return this.browserEnvironment;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $067e966d84ac4206$export$6d05f68c12a46a00 = {
    UserInteractionRequired: "USER_INTERACTION_REQUIRED",
    UserCancel: "USER_CANCEL",
    NoNetwork: "NO_NETWORK",
    TransientError: "TRANSIENT_ERROR",
    PersistentError: "PERSISTENT_ERROR",
    Disabled: "DISABLED",
    AccountUnavailable: "ACCOUNT_UNAVAILABLE",
    NestedAppAuthUnavailable: "NESTED_APP_AUTH_UNAVAILABLE"
};





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BridgeProxy
 * Provides a proxy for accessing a bridge to a host app and/or
 * platform broker
 */ class $ca5905c77ac1cd45$export$d974b2d5dad1979e {
    /**
     * initializeNestedAppAuthBridge - Initializes the bridge to the host app
     * @returns a promise that resolves to an InitializeBridgeResponse or rejects with an Error
     * @remarks This method will be called by the create factory method
     * @remarks If the bridge is not available, this method will throw an error
     */ static async initializeNestedAppAuthBridge() {
        if (window === undefined) throw new Error("window is undefined");
        if (window.nestedAppAuthBridge === undefined) throw new Error("window.nestedAppAuthBridge is undefined");
        try {
            window.nestedAppAuthBridge.addEventListener("message", (response)=>{
                const responsePayload = typeof response === "string" ? response : response.data;
                const responseEnvelope = JSON.parse(responsePayload);
                const request = $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.find((element)=>element.requestId === responseEnvelope.requestId);
                if (request !== undefined) {
                    $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.splice($ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.indexOf(request), 1);
                    if (responseEnvelope.success) request.resolve(responseEnvelope);
                    else request.reject(responseEnvelope.error);
                }
            });
            const bridgeResponse = await new Promise((resolve, reject)=>{
                const message = $ca5905c77ac1cd45$export$d974b2d5dad1979e.buildRequest("GetInitContext");
                const request = {
                    requestId: message.requestId,
                    method: message.method,
                    resolve: resolve,
                    reject: reject
                };
                $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.push(request);
                window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
            });
            return $ca5905c77ac1cd45$export$d974b2d5dad1979e.validateBridgeResultOrThrow(bridgeResponse.initContext);
        } catch (error) {
            window.console.log(error);
            throw error;
        }
    }
    /**
     * getTokenInteractive - Attempts to get a token interactively from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenInteractive(request) {
        return this.getToken("GetTokenPopup", request);
    }
    /**
     * getTokenSilent Attempts to get a token silently from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenSilent(request) {
        return this.getToken("GetToken", request);
    }
    async getToken(requestType, request) {
        const result = await this.sendRequest(requestType, {
            tokenParams: request
        });
        return {
            token: $ca5905c77ac1cd45$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.token),
            account: $ca5905c77ac1cd45$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.account)
        };
    }
    getHostCapabilities() {
        return this.capabilities ?? null;
    }
    getAccountContext() {
        return this.accountContext ? this.accountContext : null;
    }
    static buildRequest(method, requestParams) {
        return {
            messageType: "NestedAppAuthRequest",
            method: method,
            requestId: (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            sendTime: Date.now(),
            clientLibrary: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU,
            clientLibraryVersion: (0, $183cce12cb16965c$export$83d89fbfd8236492),
            ...requestParams
        };
    }
    /**
     * A method used to send a request to the bridge
     * @param request A token request
     * @returns a promise that resolves to a response of provided type or rejects with a BridgeError
     */ sendRequest(method, requestParams) {
        const message = $ca5905c77ac1cd45$export$d974b2d5dad1979e.buildRequest(method, requestParams);
        const promise = new Promise((resolve, reject)=>{
            const request = {
                requestId: message.requestId,
                method: message.method,
                resolve: resolve,
                reject: reject
            };
            $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.push(request);
            window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
        });
        return promise;
    }
    static validateBridgeResultOrThrow(input) {
        if (input === undefined) {
            const bridgeError = {
                status: (0, $067e966d84ac4206$export$6d05f68c12a46a00).NestedAppAuthUnavailable
            };
            throw bridgeError;
        }
        return input;
    }
    /**
     * Private constructor for BridgeProxy
     * @param sdkName The name of the SDK being used to make requests on behalf of the app
     * @param sdkVersion The version of the SDK being used to make requests on behalf of the app
     * @param capabilities The capabilities of the bridge / SDK / platform broker
     */ constructor(sdkName, sdkVersion, accountContext, capabilities){
        this.sdkName = sdkName;
        this.sdkVersion = sdkVersion;
        this.accountContext = accountContext;
        this.capabilities = capabilities;
    }
    /**
     * Factory method for creating an implementation of IBridgeProxy
     * @returns A promise that resolves to a BridgeProxy implementation
     */ static async create() {
        const response = await $ca5905c77ac1cd45$export$d974b2d5dad1979e.initializeNestedAppAuthBridge();
        return new $ca5905c77ac1cd45$export$d974b2d5dad1979e(response.sdkName, response.sdkVersion, response.accountContext, response.capabilities);
    }
}
$ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests = [];


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $769cd552162fdff8$export$a2170d4e3f010950 extends (0, $277b893ea3b41414$export$3aea257f46651b2b) {
    constructor(){
        super(...arguments);
        this.bridgeProxy = undefined;
        this.accountContext = null;
    }
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $769cd552162fdff8$export$a2170d4e3f010950.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $769cd552162fdff8$export$a2170d4e3f010950.ID;
    }
    /**
     * Returns the current BridgeProxy
     * @returns IBridgeProxy | undefined
     */ getBridgeProxy() {
        return this.bridgeProxy;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        try {
            if (typeof window !== "undefined") {
                if (typeof window.__initializeNestedAppAuth === "function") await window.__initializeNestedAppAuth();
                const bridgeProxy = await (0, $ca5905c77ac1cd45$export$d974b2d5dad1979e).create();
                /*
                 * Because we want single sign on we expect the host app to provide the account context
                 * with a min set of params that can be used to identify the account
                 * this.account = nestedApp.getAccountByFilter(bridgeProxy.getAccountContext());
                 */ this.accountContext = bridgeProxy.getAccountContext();
                this.bridgeProxy = bridgeProxy;
                this.available = bridgeProxy !== undefined;
            }
        } catch (ex) {
            this.logger.infoPii(`Could not initialize Nested App Auth bridge (${ex})`);
        }
        this.logger.info(`Nested App Auth Bridge available: ${this.available}`);
        return this.available;
    }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $769cd552162fdff8$export$a2170d4e3f010950.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $769cd552162fdff8$export$a2170d4e3f010950.ID = "NestedAppOperatingContext";


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $36cb4f619f94d121$export$f39c23bbfed89e6e extends (0, $277b893ea3b41414$export$3aea257f46651b2b) {
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $36cb4f619f94d121$export$f39c23bbfed89e6e.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $36cb4f619f94d121$export$f39c23bbfed89e6e.ID;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        this.available = typeof window !== "undefined";
        return this.available;
    /*
         * NOTE: The standard context is available as long as there is a window.  If/when we split out WAM from Browser
         * We can move the current contents of the initialize method to here and verify that the WAM extension is available
         */ }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $36cb4f619f94d121$export$f39c23bbfed89e6e.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $36cb4f619f94d121$export$f39c23bbfed89e6e.ID = "StandardOperatingContext";


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $449d8ba978713aa9$export$e2ac717a196f20ed = "missing_kid_error";
const $449d8ba978713aa9$export$de67390d0a514010 = "missing_alg_error";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $3953c3c36cc43bcf$export$ce96a12d056376ad = {
    [(0, $449d8ba978713aa9$export$e2ac717a196f20ed)]: "The JOSE Header for the requested JWT, JWS or JWK object requires a keyId to be configured as the 'kid' header claim. No 'kid' value was provided.",
    [(0, $449d8ba978713aa9$export$de67390d0a514010)]: "The JOSE Header for the requested JWT, JWS or JWK object requires an algorithm to be specified as the 'alg' header claim. No 'alg' value was provided."
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $3953c3c36cc43bcf$export$980ad46b7a115fad extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "JoseHeaderError";
        Object.setPrototypeOf(this, $3953c3c36cc43bcf$export$980ad46b7a115fad.prototype);
    }
}
/** Returns JoseHeaderError object */ function $3953c3c36cc43bcf$export$3ef463ea134172ed(code) {
    return new $3953c3c36cc43bcf$export$980ad46b7a115fad(code, $3953c3c36cc43bcf$export$ce96a12d056376ad[code]);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $3c3d586eea595f5f$export$91748d132e6cb9b3 {
    constructor(options){
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object and returns
     * the stringified header object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @returns
     */ static getShrHeaderString(shrHeaderOptions) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw (0, $3953c3c36cc43bcf$export$3ef463ea134172ed)((0, $449d8ba978713aa9$export$e2ac717a196f20ed));
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw (0, $3953c3c36cc43bcf$export$3ef463ea134172ed)((0, $449d8ba978713aa9$export$de67390d0a514010));
        const shrHeader = new $3c3d586eea595f5f$export$91748d132e6cb9b3({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || (0, $7c375ae106b964be$export$fe5c42ed17efe603).Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        });
        return JSON.stringify(shrHeader);
    }
}



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ /**
 * Returns a URL-safe plaintext decoded string from b64 encoded input.
 * @param input
 */ function $581fd3df606755c8$export$c62426fdd000a97e(input) {
    return new TextDecoder().decode($581fd3df606755c8$var$base64DecToArr(input));
}
/**
 * Decodes base64 into Uint8Array
 * @param base64String
 */ function $581fd3df606755c8$var$base64DecToArr(base64String) {
    let encodedString = base64String.replace(/-/g, "+").replace(/_/g, "/");
    switch(encodedString.length % 4){
        case 0:
            break;
        case 2:
            encodedString += "==";
            break;
        case 3:
            encodedString += "=";
            break;
        default:
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$fcc6790b5d12da63));
    }
    const binString = atob(encodedString);
    return Uint8Array.from(binString, (m)=>m.codePointAt(0) || 0);
}




/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ class $f0fb072e99d60057$export$286b0f3b569e5f16 {
    constructor(){
        this.dbName = (0, $5ff55562d73e0e2b$export$3c22ff8b64b8f565);
        this.version = (0, $5ff55562d73e0e2b$export$6a9022b4c5fcea02);
        this.tableName = (0, $5ff55562d73e0e2b$export$9d785db034fb436f);
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ async open() {
        return new Promise((resolve, reject)=>{
            const openDB = window.indexedDB.open(this.dbName, this.version);
            openDB.addEventListener("upgradeneeded", (e)=>{
                const event = e;
                event.target.result.createObjectStore(this.tableName);
            });
            openDB.addEventListener("success", (e)=>{
                const event = e;
                this.db = event.target.result;
                this.dbOpen = true;
                resolve();
            });
            openDB.addEventListener("error", ()=>reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$c1110692d2978b8))));
        });
    }
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ closeConnection() {
        const db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    }
    /**
     * Opens database if it's not already open
     */ async validateDbIsOpen() {
        if (!this.dbOpen) return this.open();
    }
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ async getItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGet = objectStore.get(key);
            dbGet.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGet.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ async setItem(key, payload) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbPut = objectStore.put(payload, key);
            dbPut.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbPut.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ async removeItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbDelete = objectStore.delete(key);
            dbDelete.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbDelete.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ async getKeys() {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGetKeys = objectStore.getAllKeys();
            dbGetKeys.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGetKeys.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ async containsKey(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbContainsKey = objectStore.count(key);
            dbContainsKey.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result === 1);
            });
            dbContainsKey.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ async deleteDatabase() {
        // Check if database being deleted exists
        if (this.db && this.dbOpen) this.closeConnection();
        return new Promise((resolve, reject)=>{
            const deleteDbRequest = window.indexedDB.deleteDatabase((0, $5ff55562d73e0e2b$export$3c22ff8b64b8f565));
            const id = setTimeout(()=>reject(false), 200); // Reject if events aren't raised within 200ms
            deleteDbRequest.addEventListener("success", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("blocked", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("error", ()=>{
                clearTimeout(id);
                return reject(false);
            });
        });
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $6be83965311b144c$export$d7392285c701ecf5 {
    constructor(){
        this.cache = new Map();
    }
    getItem(key) {
        return this.cache.get(key) || null;
    }
    setItem(key, value) {
        this.cache.set(key, value);
    }
    removeItem(key) {
        this.cache.delete(key);
    }
    getKeys() {
        const cacheKeys = [];
        this.cache.forEach((value, key)=>{
            cacheKeys.push(key);
        });
        return cacheKeys;
    }
    containsKey(key) {
        return this.cache.has(key);
    }
    clear() {
        this.cache.clear();
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ class $9f41ba1b3e22ed80$export$b38f35aab37afcde {
    constructor(logger){
        this.inMemoryCache = new (0, $6be83965311b144c$export$d7392285c701ecf5)();
        this.indexedDBCache = new (0, $f0fb072e99d60057$export$286b0f3b569e5f16)();
        this.logger = logger;
    }
    handleDatabaseAccessError(error) {
        if (error instanceof (0, $6e0b7bb04b1e6592$export$f8eb6760ca13876a) && error.errorCode === (0, $0780bb28b98eb888$export$c1110692d2978b8)) this.logger.error("Could not access persistent storage. This may be caused by browser privacy features which block persistent storage in third-party contexts.");
        else throw error;
    }
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     */ async getItem(key) {
        const item = this.inMemoryCache.getItem(key);
        if (!item) try {
            this.logger.verbose("Queried item not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.getItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return item;
    }
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     */ async setItem(key, value) {
        this.inMemoryCache.setItem(key, value);
        try {
            await this.indexedDBCache.setItem(key, value);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     */ async removeItem(key) {
        this.inMemoryCache.removeItem(key);
        try {
            await this.indexedDBCache.removeItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Get all the keys from the in-memory cache as an iterable array of strings. If no keys are found, query the keys in the
     * asynchronous storage object.
     */ async getKeys() {
        const cacheKeys = this.inMemoryCache.getKeys();
        if (cacheKeys.length === 0) try {
            this.logger.verbose("In-memory cache is empty, now querying persistent storage.");
            return await this.indexedDBCache.getKeys();
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return cacheKeys;
    }
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     */ async containsKey(key) {
        const containsKey = this.inMemoryCache.containsKey(key);
        if (!containsKey) try {
            this.logger.verbose("Key not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.containsKey(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return containsKey;
    }
    /**
     * Clears in-memory Map
     */ clearInMemory() {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose(`Deleting in-memory keystore`);
        this.inMemoryCache.clear();
        this.logger.verbose(`In-memory keystore deleted`);
    }
    /**
     * Tries to delete the IndexedDB database
     * @returns
     */ async clearPersistent() {
        try {
            this.logger.verbose("Deleting persistent keystore");
            const dbDeleted = await this.indexedDBCache.deleteDatabase();
            if (dbDeleted) this.logger.verbose("Persistent keystore deleted");
            return dbDeleted;
        } catch (e) {
            this.handleDatabaseAccessError(e);
            return false;
        }
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ class $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14 {
    constructor(logger, performanceClient, skipValidateSubtleCrypto){
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        (0, $4e0948336b4ea4a7$export$1ddcc6bab2bf2314)(skipValidateSubtleCrypto ?? false);
        this.cache = new (0, $9f41ba1b3e22ed80$export$b38f35aab37afcde)(this.logger);
        this.performanceClient = performanceClient;
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ createNewGuid() {
        return (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
    }
    /**
     * Encodes input string to base64.
     * @param input
     */ base64Encode(input) {
        return (0, $6f6986007da7f422$export$e510a73ee562749)(input);
    }
    /**
     * Decodes input string from base64.
     * @param input
     */ base64Decode(input) {
        return (0, $581fd3df606755c8$export$c62426fdd000a97e)(input);
    }
    /**
     * Encodes input string to base64 URL safe string.
     * @param input
     */ base64UrlEncode(input) {
        return (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(input);
    }
    /**
     * Stringifies and base64Url encodes input public key
     * @param inputKid
     * @returns Base64Url encoded public key
     */ encodeKid(inputKid) {
        return this.base64UrlEncode(JSON.stringify({
            kid: inputKid
        }));
    }
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */ async getPublicKeyThumbprint(request) {
        const publicKeyThumbMeasurement = this.performanceClient?.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).CryptoOptsGetPublicKeyThumbprint, request.correlationId);
        // Generate Keypair
        const keyPair = await (0, $4e0948336b4ea4a7$export$a949d36eab55b41f)($e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.EXTRACTABLE, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.POP_KEY_USAGES);
        // Generate Thumbprint for Public Key
        const publicKeyJwk = await (0, $4e0948336b4ea4a7$export$88781b8595a7d2ff)(keyPair.publicKey);
        const pubKeyThumprintObj = {
            e: publicKeyJwk.e,
            kty: publicKeyJwk.kty,
            n: publicKeyJwk.n
        };
        const publicJwkString = $e72c2cdc5fe24d6f$var$getSortedObjectString(pubKeyThumprintObj);
        const publicJwkHash = await this.hashString(publicJwkString);
        // Generate Thumbprint for Private Key
        const privateKeyJwk = await (0, $4e0948336b4ea4a7$export$88781b8595a7d2ff)(keyPair.privateKey);
        // Re-import private key to make it unextractable
        const unextractablePrivateKey = await (0, $4e0948336b4ea4a7$export$8bdea4e2e3f593c9)(privateKeyJwk, false, [
            "sign"
        ]);
        // Store Keypair data in keystore
        await this.cache.setItem(publicJwkHash, {
            privateKey: unextractablePrivateKey,
            publicKey: keyPair.publicKey,
            requestMethod: request.resourceRequestMethod,
            requestUri: request.resourceRequestUri
        });
        if (publicKeyThumbMeasurement) publicKeyThumbMeasurement.end({
            success: true
        });
        return publicJwkHash;
    }
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     */ async removeTokenBindingKey(kid) {
        await this.cache.removeItem(kid);
        const keyFound = await this.cache.containsKey(kid);
        return !keyFound;
    }
    /**
     * Removes all cryptographic keys from IndexedDB storage
     */ async clearKeystore() {
        // Delete in-memory keystores
        this.cache.clearInMemory();
        /**
         * There is only one database, so calling clearPersistent on asymmetric keystore takes care of
         * every persistent keystore
         */ try {
            await this.cache.clearPersistent();
            return true;
        } catch (e) {
            if (e instanceof Error) this.logger.error(`Clearing keystore failed with error: ${e.message}`);
            else this.logger.error("Clearing keystore failed with unknown error");
            return false;
        }
    }
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */ async signJwt(payload, kid, shrOptions, correlationId) {
        const signJwtMeasurement = this.performanceClient?.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).CryptoOptsSignJwt, correlationId);
        const cachedKeyPair = await this.cache.getItem(kid);
        if (!cachedKeyPair) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$a416b0eceb5c15df));
        // Get public key as JWK
        const publicKeyJwk = await (0, $4e0948336b4ea4a7$export$88781b8595a7d2ff)(cachedKeyPair.publicKey);
        const publicKeyJwkString = $e72c2cdc5fe24d6f$var$getSortedObjectString(publicKeyJwk);
        // Base64URL encode public key thumbprint with keyId only: BASE64URL({ kid: "FULL_PUBLIC_KEY_HASH" })
        const encodedKeyIdThumbprint = (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(JSON.stringify({
            kid: kid
        }));
        // Generate header
        const shrHeader = (0, $3c3d586eea595f5f$export$91748d132e6cb9b3).getShrHeaderString({
            ...shrOptions?.header,
            alg: publicKeyJwk.alg,
            kid: encodedKeyIdThumbprint
        });
        const encodedShrHeader = (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(shrHeader);
        // Generate payload
        payload.cnf = {
            jwk: JSON.parse(publicKeyJwkString)
        };
        const encodedPayload = (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(JSON.stringify(payload));
        // Form token string
        const tokenString = `${encodedShrHeader}.${encodedPayload}`;
        // Sign token
        const encoder = new TextEncoder();
        const tokenBuffer = encoder.encode(tokenString);
        const signatureBuffer = await (0, $4e0948336b4ea4a7$export$c5552dfdbc7cec71)(cachedKeyPair.privateKey, tokenBuffer);
        const encodedSignature = (0, $6f6986007da7f422$export$84f5a428c7153a69)(new Uint8Array(signatureBuffer));
        const signedJwt = `${tokenString}.${encodedSignature}`;
        if (signJwtMeasurement) signJwtMeasurement.end({
            success: true
        });
        return signedJwt;
    }
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ async hashString(plainText) {
        return (0, $4e0948336b4ea4a7$export$9169be2e06c9c165)(plainText);
    }
}
$e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.POP_KEY_USAGES = [
    "sign",
    "verify"
];
$e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.EXTRACTABLE = true;
function $e72c2cdc5fe24d6f$var$getSortedObjectString(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $df7cbba4fa13e524$export$aab44dc88900a3b(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}









/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $f7e197739ae81767$export$b288ea4a1e969e42(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $0c23eec3b11a3e26$export$6716273459d383f8(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 

/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Wraps a function with a performance measurement.
 * Usage: invoke(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5386add07ebe4b6d$export$468cda29b159ee5d = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        try {
            const result = callback(...args);
            inProgressEvent?.end({
                success: true
            });
            logger.trace(`Returning result from ${eventName}`);
            return result;
        } catch (e) {
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        }
    };
};
/**
 * Wraps an async function with a performance measurement.
 * Usage: invokeAsync(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 *
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5386add07ebe4b6d$export$e4feded94d9adb18 = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        telemetryClient?.setPreQueueTime(eventName, correlationId);
        return callback(...args).then((response)=>{
            logger.trace(`Returning result from ${eventName}`);
            inProgressEvent?.end({
                success: true
            });
            return response;
        }).catch((e)=>{
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        });
    };
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $43ad213520b7a7a8$export$1afa9d0f261ebb47 {
    constructor(networkInterface, logger, performanceClient, correlationId){
        this.networkInterface = networkInterface;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ async detectRegion(environmentRegion, regionDiscoveryMetadata) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.correlationId);
        // Initialize auto detected region with the region from the envrionment
        let autodetectedRegionName = environmentRegion;
        // Check if a region was detected from the environment, if not, attempt to get the region from IMDS
        if (!autodetectedRegionName) {
            const options = $43ad213520b7a7a8$export$1afa9d0f261ebb47.IMDS_OPTIONS;
            try {
                const localIMDSVersionResponse = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)((0, $7c375ae106b964be$export$a002182e51710d39).IMDS_VERSION, options);
                if (localIMDSVersionResponse.status === (0, $7c375ae106b964be$export$20ba0879771a17be).httpSuccess) {
                    autodetectedRegionName = localIMDSVersionResponse.body;
                    regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).IMDS;
                }
                // If the response using the local IMDS version failed, try to fetch the current version of IMDS and retry.
                if (localIMDSVersionResponse.status === (0, $7c375ae106b964be$export$20ba0879771a17be).httpBadRequest) {
                    const currentIMDSVersion = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getCurrentVersion.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.logger, this.performanceClient, this.correlationId)(options);
                    if (!currentIMDSVersion) {
                        regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                        return null;
                    }
                    const currentIMDSVersionResponse = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)(currentIMDSVersion, options);
                    if (currentIMDSVersionResponse.status === (0, $7c375ae106b964be$export$20ba0879771a17be).httpSuccess) {
                        autodetectedRegionName = currentIMDSVersionResponse.body;
                        regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).IMDS;
                    }
                }
            } catch (e) {
                regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                return null;
            }
        } else regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).ENVIRONMENT_VARIABLE;
        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
        return autodetectedRegionName || null;
    }
    /**
     * Make the call to the IMDS endpoint
     *
     * @param imdsEndpointUrl
     * @returns Promise<NetworkResponse<string>>
     */ async getRegionFromIMDS(version, options) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
        return this.networkInterface.sendGetRequestAsync(`${(0, $7c375ae106b964be$export$a002182e51710d39).IMDS_ENDPOINT}?api-version=${version}&format=text`, options, (0, $7c375ae106b964be$export$a002182e51710d39).IMDS_TIMEOUT);
    }
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ async getCurrentVersion(options) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.correlationId);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(`${(0, $7c375ae106b964be$export$a002182e51710d39).IMDS_ENDPOINT}?format=json`, options);
            // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
            if (response.status === (0, $7c375ae106b964be$export$20ba0879771a17be).httpBadRequest && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return response.body["newest-versions"][0];
            return null;
        } catch (e) {
            return null;
        }
    }
}
// Options for the IMDS endpoint request
$43ad213520b7a7a8$export$1afa9d0f261ebb47.IMDS_OPTIONS = {
    headers: {
        Metadata: "true"
    }
};








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 * @internal
 */ class $77bb430f4568f6e8$export$f1c6ec2e6d68c49c {
    constructor(authority, networkInterface, cacheManager, authorityOptions, logger, correlationId, performanceClient, managedIdentity){
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.managedIdentity = managedIdentity || false;
        this.regionDiscovery = new (0, $43ad213520b7a7a8$export$1afa9d0f261ebb47)(networkInterface, this.logger, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType}
     * @param authorityUri {@link IUri}
     * @private
     */ getAuthorityType(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith((0, $7c375ae106b964be$export$a002182e51710d39).CIAM_AUTH_URL)) return (0, $70363054a03152f4$export$cd82032b224a3839).Ciam;
        const pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case (0, $7c375ae106b964be$export$a002182e51710d39).ADFS:
                return (0, $70363054a03152f4$export$cd82032b224a3839).Adfs;
            case (0, $7c375ae106b964be$export$a002182e51710d39).DSTS:
                return (0, $70363054a03152f4$export$cd82032b224a3839).Dsts;
        }
        return (0, $70363054a03152f4$export$cd82032b224a3839).Default;
    }
    // See above for AuthorityType
    get authorityType() {
        return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
    }
    /**
     * ProtocolMode enum representing the way endpoints are constructed.
     */ get protocolMode() {
        return this.authorityOptions.protocolMode;
    }
    /**
     * Returns authorityOptions which can be used to reinstantiate a new authority instance
     */ get options() {
        return this.authorityOptions;
    }
    /**
     * A URL that is the authority set by the developer
     */ get canonicalAuthority() {
        return this._canonicalAuthority.urlString;
    }
    /**
     * Sets canonical authority.
     */ set canonicalAuthority(url) {
        this._canonicalAuthority = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(url);
        this._canonicalAuthority.validateAsUri();
        this._canonicalAuthorityUrlComponents = null;
    }
    /**
     * Get authority components.
     */ get canonicalAuthorityUrlComponents() {
        if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
        return this._canonicalAuthorityUrlComponents;
    }
    /**
     * Get hostname and port i.e. login.microsoftonline.com
     */ get hostnameAndPort() {
        return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
    }
    /**
     * Get tenant for authority.
     */ get tenant() {
        return this.canonicalAuthorityUrlComponents.PathSegments[0];
    }
    /**
     * OAuth /authorize endpoint for requests
     */ get authorizationEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth /token endpoint for requests
     */ get tokenEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    get deviceCodeEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth logout endpoint for requests
     */ get endSessionEndpoint() {
        if (this.discoveryComplete()) {
            // ROPC policies may not have end_session_endpoint set
            if (!this.metadata.end_session_endpoint) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c3bd741c16a889f3));
            return this.replacePath(this.metadata.end_session_endpoint);
        } else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth issuer for requests
     */ get selfSignedJwtAudience() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * Jwks_uri for token signing keys
     */ get jwksUri() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ canReplaceTenant(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !$77bb430f4568f6e8$export$f1c6ec2e6d68c49c.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === (0, $70363054a03152f4$export$cd82032b224a3839).Default && this.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).AAD;
    }
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ replaceTenant(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    }
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ replacePath(urlString) {
        let endpoint = urlString;
        const cachedAuthorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(this.metadata.canonical_authority);
        const cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        const cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        const currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach((currentPart, index)=>{
            let cachedPart = cachedAuthorityParts[index];
            if (index === 0 && this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                const tenantId = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(this.metadata.authorization_endpoint).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    this.logger.verbose(`Replacing tenant domain name ${cachedPart} with id ${tenantId}`);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace(`/${cachedPart}/`, `/${currentPart}/`);
        });
        return this.replaceTenant(endpoint);
    }
    /**
     * The default open id configuration endpoint for any canonical authority.
     */ get defaultOpenIdConfigurationEndpoint() {
        const canonicalAuthorityHost = this.hostnameAndPort;
        if (this.canonicalAuthority.endsWith("v2.0/") || this.authorityType === (0, $70363054a03152f4$export$cd82032b224a3839).Adfs || this.protocolMode !== (0, $de576c4d1becc778$export$73a3e3dedd37150d).AAD && !this.isAliasOfKnownMicrosoftAuthority(canonicalAuthorityHost)) return `${this.canonicalAuthority}.well-known/openid-configuration`;
        return `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
    }
    /**
     * Boolean that returns whether or not tenant discovery has been completed.
     */ discoveryComplete() {
        return !!this.metadata;
    }
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ async resolveEndpointsAsync() {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, this.correlationId);
        const metadataEntity = this.getCurrentMetadataEntity();
        const cloudDiscoverySource = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateCloudDiscoveryMetadata.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
        const endpointSource = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateEndpointMetadata.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.updateCachedMetadata(metadataEntity, cloudDiscoverySource, {
            source: endpointSource
        });
        this.performanceClient?.addFields({
            cloudDiscoverySource: cloudDiscoverySource,
            authorityEndpointSource: endpointSource
        }, this.correlationId);
    }
    /**
     * Returns metadata entity from cache if it exists, otherwiser returns a new metadata entity built
     * from the configured canonical authority
     * @returns
     */ getCurrentMetadataEntity() {
        let metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort);
        if (!metadataEntity) metadataEntity = {
            aliases: [],
            preferred_cache: this.hostnameAndPort,
            preferred_network: this.hostnameAndPort,
            canonical_authority: this.canonicalAuthority,
            authorization_endpoint: "",
            token_endpoint: "",
            end_session_endpoint: "",
            issuer: "",
            aliasesFromNetwork: false,
            endpointsFromNetwork: false,
            expiresAt: (0, $9ab3d26df56b176d$export$90f464c4238c27e5)(),
            jwks_uri: ""
        };
        return metadataEntity;
    }
    /**
     * Updates cached metadata based on metadata source and sets the instance's metadata
     * property to the same value
     * @param metadataEntity
     * @param cloudDiscoverySource
     * @param endpointMetadataResult
     */ updateCachedMetadata(metadataEntity, cloudDiscoverySource, endpointMetadataResult) {
        if (cloudDiscoverySource !== (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE && endpointMetadataResult?.source !== (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE) {
            // Reset the expiration time unless both values came from a successful cache lookup
            metadataEntity.expiresAt = (0, $9ab3d26df56b176d$export$90f464c4238c27e5)();
            metadataEntity.canonical_authority = this.canonicalAuthority;
        }
        const cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache);
        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity);
        this.metadata = metadataEntity;
    }
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ async updateEndpointMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.correlationId);
        const localMetadata = this.updateEndpointMetadataFromLocalSources(metadataEntity);
        // Further update may be required for hardcoded metadata if regional metadata is preferred
        if (localMetadata) {
            if (localMetadata.source === (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES) {
                // If the user prefers to use an azure region replace the global endpoints with regional information.
                if (this.authorityOptions.azureRegionConfiguration?.azureRegion) {
                    if (localMetadata.metadata) {
                        const hardcodedMetadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(localMetadata.metadata);
                        (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                        metadataEntity.canonical_authority = this.canonicalAuthority;
                    }
                }
            }
            return localMetadata.source;
        }
        // Get metadata from network if local sources aren't available
        let metadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getEndpointMetadataFromNetwork.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            // If the user prefers to use an azure region replace the global endpoints with regional information.
            if (this.authorityOptions.azureRegionConfiguration?.azureRegion) metadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(metadata);
            (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, metadata, true);
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).NETWORK;
        } else // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$73566da29bc073eb), this.defaultOpenIdConfigurationEndpoint);
    }
    /**
     * Updates endpoint metadata from local sources and returns where the information was retrieved from and the metadata config
     * response if the source is hardcoded metadata
     * @param metadataEntity
     * @returns
     */ updateEndpointMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get endpoint metadata from authority configuration");
        const configMetadata = this.getEndpointMetadataFromConfig();
        if (configMetadata) {
            this.logger.verbose("Found endpoint metadata in authority configuration");
            (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, configMetadata, false);
            return {
                source: (0, $7c375ae106b964be$export$5d365d77acfcb55d).CONFIG
            };
        }
        this.logger.verbose("Did not find endpoint metadata in the config... Attempting to get endpoint metadata from the hardcoded values.");
        // skipAuthorityMetadataCache is used to bypass hardcoded authority metadata and force a network metadata cache lookup and network metadata request if no cached response is available.
        if (this.authorityOptions.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get endpoint metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
            if (hardcodedMetadata) {
                (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                return {
                    source: (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES,
                    metadata: hardcodedMetadata
                };
            } else this.logger.verbose("Did not find endpoint metadata in hardcoded values... Attempting to get endpoint metadata from the network metadata cache.");
        }
        // Check cached metadata entity expiration status
        const metadataEntityExpired = (0, $9ab3d26df56b176d$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntityExpired) {
            // No need to update
            this.logger.verbose("Found endpoint metadata in the cache.");
            return {
                source: (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE
            };
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ isAuthoritySameType(metadataEntity) {
        const cachedAuthorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(metadataEntity.canonical_authority);
        const cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    }
    /**
     * Parse authorityMetadata config option
     */ getEndpointMetadataFromConfig() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$edb4d5942bc8ccff));
        }
        return null;
    }
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ async getEndpointMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ const openIdConfigurationEndpoint = this.defaultOpenIdConfigurationEndpoint;
        this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: attempting to retrieve OAuth endpoints from ${openIdConfigurationEndpoint}`);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(openIdConfigurationEndpoint, options);
            const isValidResponse = (0, $df7cbba4fa13e524$export$aab44dc88900a3b)(response.body);
            if (isValidResponse) return response.body;
            else {
                this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: could not parse response as OpenID configuration`);
                return null;
            }
        } catch (e) {
            this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: ${e}`);
            return null;
        }
    }
    /**
     * Get OAuth endpoints for common authorities.
     */ getEndpointMetadataFromHardcodedValues() {
        if (this.hostnameAndPort in (0, $ff4bd32e3511744b$export$f612854287391207)) return (0, $ff4bd32e3511744b$export$f612854287391207)[this.hostnameAndPort];
        return null;
    }
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */ async updateMetadataWithRegionalInformation(metadata) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
        const userConfiguredAzureRegion = this.authorityOptions.azureRegionConfiguration?.azureRegion;
        if (userConfiguredAzureRegion) {
            if (userConfiguredAzureRegion !== (0, $7c375ae106b964be$export$a002182e51710d39).AZURE_REGION_AUTO_DISCOVER_FLAG) {
                this.regionDiscoveryMetadata.region_outcome = (0, $7c375ae106b964be$export$92a685f9218422bd).CONFIGURED_NO_AUTO_DETECTION;
                this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion);
            }
            const autodetectedRegionName = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
            if (autodetectedRegionName) {
                this.regionDiscoveryMetadata.region_outcome = (0, $7c375ae106b964be$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, autodetectedRegionName);
            }
            this.regionDiscoveryMetadata.region_outcome = (0, $7c375ae106b964be$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_FAILED;
        }
        return metadata;
    }
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ async updateCloudDiscoveryMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
        const localMetadataSource = this.updateCloudDiscoveryMetadataFromLocalSources(metadataEntity);
        if (localMetadataSource) return localMetadataSource;
        // Fallback to network as metadata source
        const metadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getCloudDiscoveryMetadataFromNetwork.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            (0, $9ab3d26df56b176d$export$6d4972e1d88c8518)(metadataEntity, metadata, true);
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).NETWORK;
        }
        // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$50c3162fda5f57));
    }
    updateCloudDiscoveryMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get cloud discovery metadata  from authority configuration");
        this.logger.verbosePii(`Known Authorities: ${this.authorityOptions.knownAuthorities || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Authority Metadata: ${this.authorityOptions.authorityMetadata || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Canonical Authority: ${metadataEntity.canonical_authority || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_APPLICABLE}`);
        const metadata = this.getCloudDiscoveryMetadataFromConfig();
        if (metadata) {
            this.logger.verbose("Found cloud discovery metadata in authority configuration");
            (0, $9ab3d26df56b176d$export$6d4972e1d88c8518)(metadataEntity, metadata, false);
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).CONFIG;
        }
        // If the cached metadata came from config but that config was not passed to this instance, we must go to hardcoded values
        this.logger.verbose("Did not find cloud discovery metadata in the config... Attempting to get cloud discovery metadata from the hardcoded values.");
        if (this.options.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded cloud discovery metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get cloud discovery metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = (0, $ff4bd32e3511744b$export$1b1433f93c9873f)(this.hostnameAndPort);
            if (hardcodedMetadata) {
                this.logger.verbose("Found cloud discovery metadata from hardcoded values.");
                (0, $9ab3d26df56b176d$export$6d4972e1d88c8518)(metadataEntity, hardcodedMetadata, false);
                return (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES;
            }
            this.logger.verbose("Did not find cloud discovery metadata in hardcoded values... Attempting to get cloud discovery metadata from the network metadata cache.");
        }
        const metadataEntityExpired = (0, $9ab3d26df56b176d$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
            this.logger.verbose("Found cloud discovery metadata in the cache.");
            // No need to update
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE;
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ getCloudDiscoveryMetadataFromConfig() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === (0, $70363054a03152f4$export$cd82032b224a3839).Ciam) {
            this.logger.verbose("CIAM authorities do not support cloud discovery metadata, generate the aliases from authority host.");
            return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("The cloud discovery metadata has been provided as a network response, in the config.");
            try {
                this.logger.verbose("Attempting to parse the cloud discovery metadata.");
                const parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                const metadata = (0, $ff4bd32e3511744b$export$6e21098ea6e60dc)(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("Parsed the cloud discovery metadata.");
                if (metadata) {
                    this.logger.verbose("There is returnable metadata attached to the parsed cloud discovery metadata.");
                    return metadata;
                } else this.logger.verbose("There is no metadata attached to the parsed cloud discovery metadata.");
            } catch (e) {
                this.logger.verbose("Unable to parse the cloud discovery metadata. Throwing Invalid Cloud Discovery Metadata Error.");
                throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$92a2985751150ca5));
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities()) {
            this.logger.verbose("The host is included in knownAuthorities. Creating new cloud discovery metadata from the host.");
            return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    }
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ async getCloudDiscoveryMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
        const instanceDiscoveryEndpoint = `${(0, $7c375ae106b964be$export$a002182e51710d39).AAD_INSTANCE_DISCOVERY_ENDPT}${this.canonicalAuthority}oauth2/v2.0/authorize`;
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ let match = null;
        try {
            const response = await this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options);
            let typedResponseBody;
            let metadata;
            if ((0, $f7e197739ae81767$export$b288ea4a1e969e42)(response.body)) {
                typedResponseBody = response.body;
                metadata = typedResponseBody.metadata;
                this.logger.verbosePii(`tenant_discovery_endpoint is: ${typedResponseBody.tenant_discovery_endpoint}`);
            } else if ((0, $0c23eec3b11a3e26$export$6716273459d383f8)(response.body)) {
                this.logger.warning(`A CloudInstanceDiscoveryErrorResponse was returned. The cloud instance discovery network request's status code is: ${response.status}`);
                typedResponseBody = response.body;
                if (typedResponseBody.error === (0, $7c375ae106b964be$export$a002182e51710d39).INVALID_INSTANCE) {
                    this.logger.error("The CloudInstanceDiscoveryErrorResponse error is invalid_instance.");
                    return null;
                }
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error is ${typedResponseBody.error}`);
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error description is ${typedResponseBody.error_description}`);
                this.logger.warning("Setting the value of the CloudInstanceDiscoveryMetadata (returned from the network) to []");
                metadata = [];
            } else {
                this.logger.error("AAD did not return a CloudInstanceDiscoveryResponse or CloudInstanceDiscoveryErrorResponse");
                return null;
            }
            this.logger.verbose("Attempting to find a match between the developer's authority and the CloudInstanceDiscoveryMetadata returned from the network request.");
            match = (0, $ff4bd32e3511744b$export$6e21098ea6e60dc)(metadata, this.hostnameAndPort);
        } catch (error) {
            if (error instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) this.logger.error(`There was a network error while attempting to get the cloud discovery instance metadata.\nError: ${error.errorCode}\nError Description: ${error.errorMessage}`);
            else {
                const typedError = error;
                this.logger.error(`A non-MSALJS error was thrown while attempting to get the cloud instance discovery metadata.\nError: ${typedError.name}\nError Description: ${typedError.message}`);
            }
            return null;
        }
        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
        if (!match) {
            this.logger.warning("The developer's authority was not found within the CloudInstanceDiscoveryMetadata returned from the network request.");
            this.logger.verbose("Creating custom Authority for custom domain scenario.");
            match = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return match;
    }
    /**
     * Helper function to determine if this host is included in the knownAuthorities config option
     */ isInKnownAuthorities() {
        const matches = this.authorityOptions.knownAuthorities.filter((authority)=>{
            return authority && (0, $f7f911f196324278$export$3abcdca7229e54f2).getDomainFromUrl(authority).toLowerCase() === this.hostnameAndPort;
        });
        return matches.length > 0;
    }
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ static generateAuthority(authorityString, azureCloudOptions) {
        let authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== (0, $399fa9610e7cb0fb$export$4cda21933050d9ec).None) {
            const tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : (0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_COMMON_TENANT;
            authorityAzureCloudInstance = `${azureCloudOptions.azureCloudInstance}/${tenant}/`;
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    }
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ static createCloudDiscoveryMetadataFromHost(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    }
    /**
     * helper function to generate environment from authority object
     */ getPreferredCache() {
        if (this.managedIdentity) return (0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_AUTHORITY_HOST;
        else if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ isAlias(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    }
    /**
     * Returns whether or not the provided host is an alias of a known Microsoft authority for purposes of endpoint discovery
     * @param host
     */ isAliasOfKnownMicrosoftAuthority(host) {
        return (0, $ff4bd32e3511744b$export$7d026f079148cd31).has(host);
    }
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ static isPublicCloudAuthority(host) {
        return (0, $7c375ae106b964be$export$a002182e51710d39).KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    }
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ static buildRegionalAuthorityString(host, region, queryString) {
        // Create and validate a Url string object with the initial authority string
        const authorityUrlInstance = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(host);
        authorityUrlInstance.validateAsUri();
        const authorityUrlParts = authorityUrlInstance.getUrlComponents();
        let hostNameAndPort = `${region}.${authorityUrlParts.HostNameAndPort}`;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = `${region}.${(0, $7c375ae106b964be$export$a002182e51710d39).REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX}`;
        // Include the query string portion of the url
        const url = (0, $f7f911f196324278$export$3abcdca7229e54f2).constructAuthorityUriFromObject({
            ...authorityUrlInstance.getUrlComponents(),
            HostNameAndPort: hostNameAndPort
        }).urlString;
        // Add the query string if a query string was provided
        if (queryString) return `${url}?${queryString}`;
        return url;
    }
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ static replaceWithRegionalInformation(metadata, azureRegion) {
        const regionalMetadata = {
            ...metadata
        };
        regionalMetadata.authorization_endpoint = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.authorization_endpoint, azureRegion);
        regionalMetadata.token_endpoint = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.token_endpoint, azureRegion);
        if (regionalMetadata.end_session_endpoint) regionalMetadata.end_session_endpoint = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.end_session_endpoint, azureRegion);
        return regionalMetadata;
    }
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ static transformCIAMAuthority(authority) {
        let ciamAuthority = authority;
        const authorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(authority);
        const authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith((0, $7c375ae106b964be$export$a002182e51710d39).CIAM_AUTH_URL)) {
            const tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = `${ciamAuthority}${tenantIdOrDomain}${(0, $7c375ae106b964be$export$a002182e51710d39).AAD_TENANT_DOMAIN_SUFFIX}`;
        }
        return ciamAuthority;
    }
}
// Reserved tenant domain names that will not be replaced with tenant id
$77bb430f4568f6e8$export$f1c6ec2e6d68c49c.reservedTenantDomains = new Set([
    "{tenant}",
    "{tenantid}",
    (0, $7c375ae106b964be$export$e18ac120172ed505).COMMON,
    (0, $7c375ae106b964be$export$e18ac120172ed505).CONSUMERS,
    (0, $7c375ae106b964be$export$e18ac120172ed505).ORGANIZATIONS
]);
/**
 * Extract tenantId from authority
 */ function $77bb430f4568f6e8$export$6ed5af33d279fbc7(authority) {
    const authorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(authority);
    const authorityUrlComponents = authorityUrl.getUrlComponents();
    /**
     * For credential matching purposes, tenantId is the last path segment of the authority URL:
     *  AAD Authority - domain/tenantId -> Credentials are cached with realm = tenantId
     *  B2C Authority - domain/{tenantId}?/.../policy -> Credentials are cached with realm = policy
     *  tenantId is downcased because B2C policies can have mixed case but tfp claim is downcased
     *
     * Note that we may not have any path segments in certain OIDC scenarios.
     */ const tenantId = authorityUrlComponents.PathSegments.slice(-1)[0]?.toLowerCase();
    switch(tenantId){
        case (0, $7c375ae106b964be$export$e18ac120172ed505).COMMON:
        case (0, $7c375ae106b964be$export$e18ac120172ed505).ORGANIZATIONS:
        case (0, $7c375ae106b964be$export$e18ac120172ed505).CONSUMERS:
            return undefined;
        default:
            return tenantId;
    }
}
function $77bb430f4568f6e8$export$4030f3538167cb9e(authorityUri) {
    return authorityUri.endsWith((0, $7c375ae106b964be$export$a002182e51710d39).FORWARD_SLASH) ? authorityUri : `${authorityUri}${(0, $7c375ae106b964be$export$a002182e51710d39).FORWARD_SLASH}`;
}
function $77bb430f4568f6e8$export$2b9ebf6f25078cc0(authOptions) {
    const rawCloudDiscoveryMetadata = authOptions.cloudDiscoveryMetadata;
    let cloudDiscoveryMetadata = undefined;
    if (rawCloudDiscoveryMetadata) try {
        cloudDiscoveryMetadata = JSON.parse(rawCloudDiscoveryMetadata);
    } catch (e) {
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$92a2985751150ca5));
    }
    return {
        canonicalAuthority: authOptions.authority ? $77bb430f4568f6e8$export$4030f3538167cb9e(authOptions.authority) : undefined,
        knownAuthorities: authOptions.knownAuthorities,
        cloudDiscoveryMetadata: cloudDiscoveryMetadata
    };
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $feda987e240ac148$export$17b7b3ac1abef49f = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN"
};

/*! @azure/msal-common v14.16.1 2025-08-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which provides helpers for OAuth 2.0 protocol specific values
 */ class $18d0dfe50b7b79f1$export$871e33217042c65e {
    /**
     * Appends user state with random guid, or returns random guid.
     * @param userState
     * @param randomGuid
     */ static setRequestState(cryptoObj, userState, meta) {
        const libraryState = $18d0dfe50b7b79f1$export$871e33217042c65e.generateLibraryState(cryptoObj, meta);
        return userState ? `${libraryState}${(0, $7c375ae106b964be$export$a002182e51710d39).RESOURCE_DELIM}${userState}` : libraryState;
    }
    /**
     * Generates the state value used by the common library.
     * @param randomGuid
     * @param cryptoObj
     */ static generateLibraryState(cryptoObj, meta) {
        if (!cryptoObj) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c39e501a22cba395));
        // Create a state object containing a unique id and the timestamp of the request creation
        const stateObj = {
            id: cryptoObj.createNewGuid()
        };
        if (meta) stateObj.meta = meta;
        const stateString = JSON.stringify(stateObj);
        return cryptoObj.base64Encode(stateString);
    }
    /**
     * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
     * @param state
     * @param cryptoObj
     */ static parseRequestState(cryptoObj, state) {
        if (!cryptoObj) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c39e501a22cba395));
        if (!state) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b));
        try {
            // Split the state between library state and user passed state and decode them separately
            const splitState = state.split((0, $7c375ae106b964be$export$a002182e51710d39).RESOURCE_DELIM);
            const libraryState = splitState[0];
            const userState = splitState.length > 1 ? splitState.slice(1).join((0, $7c375ae106b964be$export$a002182e51710d39).RESOURCE_DELIM) : (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const libraryStateString = cryptoObj.base64Decode(libraryState);
            const libraryStateObj = JSON.parse(libraryStateString);
            return {
                userRequestState: userState || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
                libraryState: libraryStateObj
            };
        } catch (e) {
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b));
        }
    }
}




/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $fc08fc8f06eda9dc$export$19fffca37ef3e106 {
    constructor(){
        if (!window.localStorage) throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$41d7a3d4e14d6113));
    }
    getItem(key) {
        return window.localStorage.getItem(key);
    }
    setItem(key, value) {
        window.localStorage.setItem(key, value);
    }
    removeItem(key) {
        window.localStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.localStorage);
    }
    containsKey(key) {
        return window.localStorage.hasOwnProperty(key);
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $514a2dc2ad0988f3$export$2c4b17e1c2e0931 {
    constructor(){
        if (!window.sessionStorage) throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$41d7a3d4e14d6113));
    }
    getItem(key) {
        return window.sessionStorage.getItem(key);
    }
    setItem(key, value) {
        window.sessionStorage.setItem(key, value);
    }
    removeItem(key) {
        window.sessionStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.sessionStorage);
    }
    containsKey(key) {
        return window.sessionStorage.hasOwnProperty(key);
    }
}



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts the BrowserStateObject from the state string.
 * @param browserCrypto
 * @param state
 */ function $6ec519bc7bf28780$export$68ec87f530f5f536(browserCrypto, state) {
    if (!state) return null;
    try {
        const requestStateObj = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(browserCrypto, state);
        return requestStateObj.libraryState.meta;
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).invalidState);
    }
}




/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Cookie life calculation (hours * minutes * seconds * ms)
const $bccaa1af695c1c1d$var$COOKIE_LIFE_MULTIPLIER = 86400000;
class $bccaa1af695c1c1d$export$dae7d845015939d5 {
    getItem(key) {
        const name = `${encodeURIComponent(key)}`;
        const cookieList = document.cookie.split(";");
        for(let i = 0; i < cookieList.length; i++){
            const cookie = cookieList[i];
            const [key, ...rest] = decodeURIComponent(cookie).trim().split("=");
            const value = rest.join("=");
            if (key === name) return value;
        }
        return "";
    }
    setItem(key, value, cookieLifeDays, secure = true) {
        let cookieStr = `${encodeURIComponent(key)}=${encodeURIComponent(value)};path=/;SameSite=Lax;`;
        if (cookieLifeDays) {
            const expireTime = $bccaa1af695c1c1d$export$b720d871a37fa65(cookieLifeDays);
            cookieStr += `expires=${expireTime};`;
        }
        if (secure) cookieStr += "Secure;";
        document.cookie = cookieStr;
    }
    removeItem(key) {
        // Setting expiration to -1 removes it
        this.setItem(key, "", -1);
    }
    getKeys() {
        const cookieList = document.cookie.split(";");
        const keys = [];
        cookieList.forEach((cookie)=>{
            const cookieParts = decodeURIComponent(cookie).trim().split("=");
            keys.push(cookieParts[0]);
        });
        return keys;
    }
    containsKey(key) {
        return this.getKeys().includes(key);
    }
}
/**
 * Get cookie expiration time
 * @param cookieLifeDays
 */ function $bccaa1af695c1c1d$export$b720d871a37fa65(cookieLifeDays) {
    const today = new Date();
    const expr = new Date(today.getTime() + cookieLifeDays * $bccaa1af695c1c1d$var$COOKIE_LIFE_MULTIPLIER);
    return expr.toUTCString();
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 * Cookies are only used if storeAuthStateInCookie is true, and are only used for
 * parameters such as state and nonce, generally.
 */ class $d3981d5134d5331a$export$44d7291b5c8cc149 extends (0, $0c353f04031c78df$export$996e3ea69314b5c6) {
    constructor(clientId, cacheConfig, cryptoImpl, logger, staticAuthorityOptions, performanceClient){
        super(clientId, cryptoImpl, logger, staticAuthorityOptions);
        this.cacheConfig = cacheConfig;
        this.logger = logger;
        this.internalStorage = new (0, $6be83965311b144c$export$d7392285c701ecf5)();
        this.browserStorage = this.setupBrowserStorage(this.cacheConfig.cacheLocation);
        this.temporaryCacheStorage = this.setupBrowserStorage(this.cacheConfig.temporaryCacheLocation);
        this.cookieStorage = new (0, $bccaa1af695c1c1d$export$dae7d845015939d5)();
        // Migrate cache entries from older versions of MSAL.
        if (cacheConfig.cacheMigrationEnabled) {
            this.migrateCacheEntries();
            this.createKeyMaps();
        }
        this.performanceClient = performanceClient;
    }
    /**
     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
     * @param cacheLocation
     */ setupBrowserStorage(cacheLocation) {
        try {
            switch(cacheLocation){
                case (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage:
                    return new (0, $fc08fc8f06eda9dc$export$19fffca37ef3e106)();
                case (0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage:
                    return new (0, $514a2dc2ad0988f3$export$2c4b17e1c2e0931)();
                case (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage:
                default:
                    break;
            }
        } catch (e) {
            this.logger.error(e);
        }
        this.cacheConfig.cacheLocation = (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage;
        return new (0, $6be83965311b144c$export$d7392285c701ecf5)();
    }
    /**
     * Migrate all old cache entries to new schema. No rollback supported.
     * @param storeAuthStateInCookie
     */ migrateCacheEntries() {
        const previousVersion = this.browserStorage.getItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).VERSION);
        if (previousVersion) this.logger.info(`MSAL.js was last initialized with version ${previousVersion}`);
        if (previousVersion !== (0, $183cce12cb16965c$export$83d89fbfd8236492)) this.browserStorage.setItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).VERSION, (0, $183cce12cb16965c$export$83d89fbfd8236492));
        const idTokenKey = `${(0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX}.${(0, $7c375ae106b964be$export$81ab9ba9bd28255c).ID_TOKEN}`;
        const clientInfoKey = `${(0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX}.${(0, $7c375ae106b964be$export$81ab9ba9bd28255c).CLIENT_INFO}`;
        const errorKey = `${(0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX}.${(0, $7c375ae106b964be$export$81ab9ba9bd28255c).ERROR}`;
        const errorDescKey = `${(0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX}.${(0, $7c375ae106b964be$export$81ab9ba9bd28255c).ERROR_DESC}`;
        const idTokenValue = this.browserStorage.getItem(idTokenKey);
        const clientInfoValue = this.browserStorage.getItem(clientInfoKey);
        const errorValue = this.browserStorage.getItem(errorKey);
        const errorDescValue = this.browserStorage.getItem(errorDescKey);
        const values = [
            idTokenValue,
            clientInfoValue,
            errorValue,
            errorDescValue
        ];
        const keysToMigrate = [
            (0, $7c375ae106b964be$export$81ab9ba9bd28255c).ID_TOKEN,
            (0, $7c375ae106b964be$export$81ab9ba9bd28255c).CLIENT_INFO,
            (0, $7c375ae106b964be$export$81ab9ba9bd28255c).ERROR,
            (0, $7c375ae106b964be$export$81ab9ba9bd28255c).ERROR_DESC
        ];
        keysToMigrate.forEach((cacheKey, index)=>{
            const value = values[index];
            if (value) this.setTemporaryCache(cacheKey, value, true);
        });
    }
    /**
     * Searches all cache entries for MSAL accounts and creates the account key map
     * This is used to migrate users from older versions of MSAL which did not create the map.
     * @returns
     */ createKeyMaps() {
        this.logger.trace("BrowserCacheManager - createKeyMaps called.");
        const correlationId = this.cryptoImpl.createNewGuid();
        const accountKeys = this.getItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).ACCOUNT_KEYS);
        const tokenKeys = this.getItem(`${(0, $5ff55562d73e0e2b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`);
        if (accountKeys && tokenKeys) {
            this.logger.verbose("BrowserCacheManager:createKeyMaps - account and token key maps already exist, skipping migration.");
            // Key maps already exist, no need to iterate through cache
            return;
        }
        const allKeys = this.browserStorage.getKeys();
        allKeys.forEach((key)=>{
            if (this.isCredentialKey(key)) {
                // Get item, parse, validate and write key to map
                const value = this.getItem(key);
                if (value) {
                    const credObj = this.validateAndParseJson(value);
                    if (credObj && credObj.hasOwnProperty("credentialType")) switch(credObj["credentialType"]){
                        case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN:
                            if ((0, $9ab3d26df56b176d$exports).isIdTokenEntity(credObj)) {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - idToken found, saving key to token key map");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - idToken with key: ${key} found, saving key to token key map`);
                                const idTokenEntity = credObj;
                                const newKey = this.updateCredentialCacheKey(key, idTokenEntity, correlationId);
                                this.addTokenKey(newKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN, correlationId);
                                return;
                            } else {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching idToken schema with value containing idToken credentialType field but value failed IdTokenEntity validation, skipping.");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - failed idToken validation on key: ${key}`);
                            }
                            break;
                        case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                        case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME:
                            if ((0, $9ab3d26df56b176d$exports).isAccessTokenEntity(credObj)) {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - accessToken found, saving key to token key map");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - accessToken with key: ${key} found, saving key to token key map`);
                                const accessTokenEntity = credObj;
                                const newKey = this.updateCredentialCacheKey(key, accessTokenEntity, correlationId);
                                this.addTokenKey(newKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN, correlationId);
                                return;
                            } else {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching accessToken schema with value containing accessToken credentialType field but value failed AccessTokenEntity validation, skipping.");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - failed accessToken validation on key: ${key}`);
                            }
                            break;
                        case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                            if ((0, $9ab3d26df56b176d$exports).isRefreshTokenEntity(credObj)) {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - refreshToken found, saving key to token key map");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - refreshToken with key: ${key} found, saving key to token key map`);
                                const refreshTokenEntity = credObj;
                                const newKey = this.updateCredentialCacheKey(key, refreshTokenEntity, correlationId);
                                this.addTokenKey(newKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN, correlationId);
                                return;
                            } else {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching refreshToken schema with value containing refreshToken credentialType field but value failed RefreshTokenEntity validation, skipping.");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - failed refreshToken validation on key: ${key}`);
                            }
                            break;
                    }
                }
            }
            if (this.isAccountKey(key)) {
                const value = this.getItem(key);
                if (value) {
                    const accountObj = this.validateAndParseJson(value);
                    if (accountObj && (0, $d6acc4a6126921e0$export$680160523e6bfa6a).isAccountEntity(accountObj)) {
                        this.logger.trace("BrowserCacheManager:createKeyMaps - account found, saving key to account key map");
                        this.logger.tracePii(`BrowserCacheManager:createKeyMaps - account with key: ${key} found, saving key to account key map`);
                        this.addAccountKeyToMap(key, correlationId);
                    }
                }
            }
        });
    }
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ validateAndParseJson(jsonValue) {
        try {
            const parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    }
    /**
     * fetches the entry from the browser storage based off the key
     * @param key
     */ getItem(key) {
        return this.browserStorage.getItem(key);
    }
    /**
     * sets the entry in the browser storage
     * @param key
     * @param value
     */ setItem(key, value, correlationId) {
        let accessTokenKeys = [];
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)try {
            this.browserStorage.setItem(key, value);
            if (i > 0) // Finally update the token keys array with the tokens removed
            this.removeAccessTokenKeys(accessTokenKeys.slice(0, i), correlationId);
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = (0, $531f2a6dee41cfa4$export$2056718aee1b1d88)(e);
            if (cacheError.errorCode === (0, $d0300807e9c5c64e$exports).cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) {
                    if (key === `${(0, $5ff55562d73e0e2b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`) // If we are currently trying to set the token keys, use the value we're trying to set
                    accessTokenKeys = JSON.parse(value).accessToken;
                    else // If token keys have not been initialized, get them
                    accessTokenKeys = this.getTokenKeys().accessToken;
                }
                if (accessTokenKeys.length <= i) // Nothing to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * fetch the account entity from the platform cache
     * @param accountKey
     */ getAccount(accountKey, correlationId, logger) {
        this.logger.trace("BrowserCacheManager.getAccount called");
        const accountEntity = this.getCachedAccountEntity(accountKey, correlationId);
        return this.updateOutdatedCachedAccount(accountKey, accountEntity, correlationId, logger);
    }
    /**
     * Reads account from cache, deserializes it into an account entity and returns it.
     * If account is not found from the key, returns null and removes key from map.
     * @param accountKey
     * @returns
     */ getCachedAccountEntity(accountKey, correlationId) {
        const serializedAccount = this.getItem(accountKey);
        if (!serializedAccount) {
            this.removeAccountKeyFromMap(accountKey, correlationId);
            return null;
        }
        const parsedAccount = this.validateAndParseJson(serializedAccount);
        if (!parsedAccount || !(0, $d6acc4a6126921e0$export$680160523e6bfa6a).isAccountEntity(parsedAccount)) return null;
        return (0, $0c353f04031c78df$export$996e3ea69314b5c6).toObject(new (0, $d6acc4a6126921e0$export$680160523e6bfa6a)(), parsedAccount);
    }
    /**
     * set account entity in the platform cache
     * @param account
     */ setAccount(account, correlationId) {
        this.logger.trace("BrowserCacheManager.setAccount called");
        const key = account.generateAccountKey();
        account.lastUpdatedAt = Date.now().toString();
        this.setItem(key, JSON.stringify(account), correlationId);
        this.addAccountKeyToMap(key, correlationId);
    }
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ getAccountKeys() {
        this.logger.trace("BrowserCacheManager.getAccountKeys called");
        const accountKeys = this.getItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).ACCOUNT_KEYS);
        if (accountKeys) return JSON.parse(accountKeys);
        this.logger.verbose("BrowserCacheManager.getAccountKeys - No account keys found");
        return [];
    }
    /**
     * Add a new account to the key map
     * @param key
     */ addAccountKeyToMap(key, correlationId) {
        this.logger.trace("BrowserCacheManager.addAccountKeyToMap called");
        this.logger.tracePii(`BrowserCacheManager.addAccountKeyToMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys), correlationId);
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key added");
        } else this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key already exists in map");
    }
    /**
     * Remove an account from the key map
     * @param key
     */ removeAccountKeyFromMap(key, correlationId) {
        this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap called");
        this.logger.tracePii(`BrowserCacheManager.removeAccountKeyFromMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        const removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            if (accountKeys.length === 0) {
                // If no keys left, remove the map
                this.removeItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).ACCOUNT_KEYS);
                return;
            } else this.setItem((0, $5ff55562d73e0e2b$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys), correlationId);
            this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap account key removed");
        } else this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap key not found in existing map");
    }
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ async removeAccount(key, correlationId) {
        super.removeAccount(key, correlationId);
        this.removeAccountKeyFromMap(key, correlationId);
    }
    /**
     * Remove account entity from the platform cache if it's outdated
     * @param accountKey
     */ removeOutdatedAccount(accountKey, correlationId) {
        this.removeItem(accountKey);
        this.removeAccountKeyFromMap(accountKey, correlationId);
    }
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ removeIdToken(key, correlationId) {
        super.removeIdToken(key, correlationId);
        this.removeTokenKey(key, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN, correlationId);
    }
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ removeAccessToken(key, correlationId, updateTokenKeys = true) {
        super.removeAccessToken(key, correlationId);
        this.performanceClient?.incrementFields({
            accessTokensRemoved: 1
        }, correlationId);
        updateTokenKeys && this.removeTokenKey(key, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN, correlationId);
    }
    removeAccessTokenKeys(keys, correlationId) {
        this.logger.trace("removeAccessTokenKey called");
        const tokenKeys = this.getTokenKeys();
        let keysRemoved = 0;
        keys.forEach((key)=>{
            const accessRemoval = tokenKeys.accessToken.indexOf(key);
            if (accessRemoval > -1) {
                tokenKeys.accessToken.splice(accessRemoval, 1);
                keysRemoved++;
            }
        });
        if (keysRemoved > 0) {
            this.logger.info(`removed ${keysRemoved} accessToken keys from tokenKeys map`);
            this.setTokenKeys(tokenKeys, correlationId);
            return;
        }
    }
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ removeRefreshToken(key, correlationId) {
        super.removeRefreshToken(key, correlationId);
        this.removeTokenKey(key, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN, correlationId);
    }
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ getTokenKeys() {
        this.logger.trace("BrowserCacheManager.getTokenKeys called");
        const item = this.getItem(`${(0, $5ff55562d73e0e2b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`);
        if (item) {
            const tokenKeys = this.validateAndParseJson(item);
            if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
            else this.logger.error("BrowserCacheManager.getTokenKeys - Token keys found but in an unknown format. Returning empty key map.");
        } else this.logger.verbose("BrowserCacheManager.getTokenKeys - No token keys found");
        return {
            idToken: [],
            accessToken: [],
            refreshToken: []
        };
    }
    /**
     * Stores the token keys in the cache
     * @param tokenKeys
     * @param correlationId
     * @returns
     */ setTokenKeys(tokenKeys, correlationId) {
        if (tokenKeys.idToken.length === 0 && tokenKeys.accessToken.length === 0 && tokenKeys.refreshToken.length === 0) {
            // If no keys left, remove the map
            this.removeItem(`${(0, $5ff55562d73e0e2b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`);
            return;
        } else this.setItem(`${(0, $5ff55562d73e0e2b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`, JSON.stringify(tokenKeys), correlationId);
    }
    /**
     * Adds the given key to the token key map
     * @param key
     * @param type
     */ addTokenKey(key, type, correlationId) {
        this.logger.trace("BrowserCacheManager addTokenKey called");
        const tokenKeys = this.getTokenKeys();
        switch(type){
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN:
                if (tokenKeys.idToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - idToken added to map");
                    tokenKeys.idToken.push(key);
                }
                break;
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                const index = tokenKeys.accessToken.indexOf(key);
                if (index !== -1) tokenKeys.accessToken.splice(index, 1); // Remove existing key before pushing to the end
                this.logger.trace(`access token ${index === -1 ? "added to" : "updated in"} map`);
                tokenKeys.accessToken.push(key);
                break;
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                if (tokenKeys.refreshToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - refreshToken added to map");
                    tokenKeys.refreshToken.push(key);
                }
                break;
            default:
                this.logger.error(`BrowserCacheManager:addTokenKey - CredentialType provided invalid. CredentialType: ${type}`);
                throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).unexpectedCredentialType);
        }
        this.setTokenKeys(tokenKeys, correlationId);
    }
    /**
     * Removes the given key from the token key map
     * @param key
     * @param type
     */ removeTokenKey(key, type, correlationId, tokenKeys = this.getTokenKeys()) {
        this.logger.trace("BrowserCacheManager removeTokenKey called");
        switch(type){
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove idToken with key: ${key} from map`);
                const idRemoval = tokenKeys.idToken.indexOf(key);
                if (idRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - idToken removed from map");
                    tokenKeys.idToken.splice(idRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - idToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove accessToken with key: ${key} from map`);
                const accessRemoval = tokenKeys.accessToken.indexOf(key);
                if (accessRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - accessToken removed from map");
                    tokenKeys.accessToken.splice(accessRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - accessToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove refreshToken with key: ${key} from map`);
                const refreshRemoval = tokenKeys.refreshToken.indexOf(key);
                if (refreshRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken removed from map");
                    tokenKeys.refreshToken.splice(refreshRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            default:
                this.logger.error(`BrowserCacheManager:removeTokenKey - CredentialType provided invalid. CredentialType: ${type}`);
                throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).unexpectedCredentialType);
        }
        this.setTokenKeys(tokenKeys, correlationId);
    }
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ getIdTokenCredential(idTokenKey, correlationId) {
        const value = this.getItem(idTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeIdToken(idTokenKey, correlationId);
            return null;
        }
        const parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !(0, $9ab3d26df56b176d$exports).isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getIdTokenCredential: cache hit");
        return parsedIdToken;
    }
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ setIdTokenCredential(idToken, correlationId) {
        this.logger.trace("BrowserCacheManager.setIdTokenCredential called");
        const idTokenKey = (0, $9ab3d26df56b176d$exports).generateCredentialKey(idToken);
        idToken.lastUpdatedAt = Date.now().toString();
        this.setItem(idTokenKey, JSON.stringify(idToken), correlationId);
        this.addTokenKey(idTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN, correlationId);
    }
    /**
     * generates accessToken entity from a string
     * @param key
     */ getAccessTokenCredential(accessTokenKey, correlationId) {
        const value = this.getItem(accessTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN, correlationId);
            return null;
        }
        const parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !(0, $9ab3d26df56b176d$exports).isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAccessTokenCredential: cache hit");
        return parsedAccessToken;
    }
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */ setAccessTokenCredential(accessToken, correlationId) {
        this.logger.trace("BrowserCacheManager.setAccessTokenCredential called");
        const accessTokenKey = (0, $9ab3d26df56b176d$exports).generateCredentialKey(accessToken);
        accessToken.lastUpdatedAt = Date.now().toString();
        this.setItem(accessTokenKey, JSON.stringify(accessToken), correlationId);
        this.addTokenKey(accessTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN, correlationId);
    }
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ getRefreshTokenCredential(refreshTokenKey, correlationId) {
        const value = this.getItem(refreshTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN, correlationId);
            return null;
        }
        const parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !(0, $9ab3d26df56b176d$exports).isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: cache hit");
        return parsedRefreshToken;
    }
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ setRefreshTokenCredential(refreshToken, correlationId) {
        this.logger.trace("BrowserCacheManager.setRefreshTokenCredential called");
        const refreshTokenKey = (0, $9ab3d26df56b176d$exports).generateCredentialKey(refreshToken);
        refreshToken.lastUpdatedAt = Date.now().toString();
        this.setItem(refreshTokenKey, JSON.stringify(refreshToken), correlationId);
        this.addTokenKey(refreshTokenKey, (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN, correlationId);
    }
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     */ getAppMetadata(appMetadataKey) {
        const value = this.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, $9ab3d26df56b176d$exports).isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAppMetadata: cache hit");
        return parsedMetadata;
    }
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     */ setAppMetadata(appMetadata, correlationId) {
        this.logger.trace("BrowserCacheManager.setAppMetadata called");
        const appMetadataKey = (0, $9ab3d26df56b176d$exports).generateAppMetadataKey(appMetadata);
        this.setItem(appMetadataKey, JSON.stringify(appMetadata), correlationId);
    }
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     */ getServerTelemetry(serverTelemetryKey) {
        const value = this.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        const parsedEntity = this.validateAndParseJson(value);
        if (!parsedEntity || !(0, $9ab3d26df56b176d$exports).isServerTelemetryEntity(serverTelemetryKey, parsedEntity)) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getServerTelemetry: cache hit");
        return parsedEntity;
    }
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ setServerTelemetry(serverTelemetryKey, serverTelemetry, correlationId) {
        this.logger.trace("BrowserCacheManager.setServerTelemetry called");
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry), correlationId);
    }
    /**
     *
     */ getAuthorityMetadata(key) {
        const value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && (0, $9ab3d26df56b176d$exports).isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: cache hit");
            return parsedMetadata;
        }
        return null;
    }
    /**
     *
     */ getAuthorityMetadataKeys() {
        const allKeys = this.internalStorage.getKeys();
        return allKeys.filter((key)=>{
            return this.isAuthorityMetadata(key);
        });
    }
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ setWrapperMetadata(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_VER, wrapperVersion);
    }
    /**
     * Returns wrapper metadata from in-memory storage
     */ getWrapperMetadata() {
        const sku = this.internalStorage.getItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_SKU) || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const version = this.internalStorage.getItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_VER) || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        return [
            sku,
            version
        ];
    }
    /**
     *
     * @param entity
     */ setAuthorityMetadata(key, entity) {
        this.logger.trace("BrowserCacheManager.setAuthorityMetadata called");
        this.internalStorage.setItem(key, JSON.stringify(entity));
    }
    /**
     * Gets the active account
     */ getActiveAccount(correlationId) {
        const activeAccountKeyFilters = this.generateCacheKey((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        const activeAccountValueFilters = this.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            // if new active account cache type isn't found, it's an old version, so look for that instead
            this.logger.trace("BrowserCacheManager.getActiveAccount: No active account filters cache schema found, looking for legacy schema");
            const activeAccountKeyLocal = this.generateCacheKey((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT);
            const activeAccountValueLocal = this.getItem(activeAccountKeyLocal);
            if (!activeAccountValueLocal) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
                return null;
            }
            const activeAccount = this.getAccountInfoFilteredBy({
                localAccountId: activeAccountValueLocal
            }, correlationId);
            if (activeAccount) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: Legacy active account cache schema found");
                this.logger.trace("BrowserCacheManager.getActiveAccount: Adding active account filters cache schema");
                this.setActiveAccount(activeAccount, correlationId);
                return activeAccount;
            }
            return null;
        }
        const activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: Active account filters schema found");
            return this.getAccountInfoFilteredBy({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId,
                tenantId: activeAccountValueObj.tenantId
            }, correlationId);
        }
        this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
        return null;
    }
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ setActiveAccount(account, correlationId) {
        const activeAccountKey = this.generateCacheKey((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        const activeAccountKeyLocal = this.generateCacheKey((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT);
        if (account) {
            this.logger.verbose("setActiveAccount: Active account set");
            const activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId,
                tenantId: account.tenantId,
                lastUpdatedAt: Date.now().toString()
            };
            this.setItem(activeAccountKey, JSON.stringify(activeAccountValue), correlationId);
            this.setItem(activeAccountKeyLocal, account.localAccountId, correlationId);
        } else {
            this.logger.verbose("setActiveAccount: No account passed, active account not set");
            this.browserStorage.removeItem(activeAccountKey);
            this.browserStorage.removeItem(activeAccountKeyLocal);
        }
    }
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     */ getThrottlingCache(throttlingCacheKey) {
        const value = this.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        const parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !(0, $9ab3d26df56b176d$exports).isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getThrottlingCache: cache hit");
        return parsedThrottlingCache;
    }
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ setThrottlingCache(throttlingCacheKey, throttlingCache, correlationId) {
        this.logger.trace("BrowserCacheManager.setThrottlingCache called");
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache), correlationId);
    }
    /**
     * Gets cache item with given key.
     * Will retrieve from cookies if storeAuthStateInCookie is set to true.
     * @param key
     */ getTemporaryCache(cacheKey, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        if (this.cacheConfig.storeAuthStateInCookie) {
            const itemCookie = this.cookieStorage.getItem(key);
            if (itemCookie) {
                this.logger.trace("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies");
                return itemCookie;
            }
        }
        const value = this.temporaryCacheStorage.getItem(key);
        if (!value) {
            // If temp cache item not found in session/memory, check local storage for items set by old versions
            if (this.cacheConfig.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage) {
                const item = this.browserStorage.getItem(key);
                if (item) {
                    this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item found in local storage");
                    return item;
                }
            }
            this.logger.trace("BrowserCacheManager.getTemporaryCache: No cache item found in local storage");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item returned");
        return value;
    }
    /**
     * Sets the cache item with the key and value given.
     * Stores in cookie if storeAuthStateInCookie is set to true.
     * This can cause cookie overflow if used incorrectly.
     * @param key
     * @param value
     */ setTemporaryCache(cacheKey, value, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie");
            this.cookieStorage.setItem(key, value, undefined, this.cacheConfig.secureCookies);
        }
    }
    /**
     * Removes the cache item with the given key.
     * @param key
     */ removeItem(key) {
        this.browserStorage.removeItem(key);
    }
    /**
     * Removes the temporary cache item with the given key.
     * Will also clear the cookie item if storeAuthStateInCookie is set to true.
     * @param key
     */ removeTemporaryItem(key) {
        this.temporaryCacheStorage.removeItem(key);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie");
            this.cookieStorage.removeItem(key);
        }
    }
    /**
     * Gets all keys in window.
     */ getKeys() {
        return this.browserStorage.getKeys();
    }
    /**
     * Clears all cache entries created by MSAL.
     */ async clear(correlationId) {
        // Removes all accounts and their credentials
        await this.removeAllAccounts(correlationId);
        this.removeAppMetadata(correlationId);
        // Remove temp storage first to make sure any cookies are cleared
        this.temporaryCacheStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.removeTemporaryItem(cacheKey);
        });
        // Removes all remaining MSAL cache items
        this.browserStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.browserStorage.removeItem(cacheKey);
        });
        this.internalStorage.clear();
    }
    /**
     * Clears all access tokes that have claims prior to saving the current one
     * @param performanceClient {IPerformanceClient}
     * @param correlationId {string} correlation id
     * @returns
     */ async clearTokensAndKeysWithClaims(performanceClient, correlationId) {
        performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, correlationId);
        const tokenKeys = this.getTokenKeys();
        let removedAccessTokens = 0;
        tokenKeys.accessToken.forEach((key)=>{
            // if the access token has claims in its key, remove the token key and the token
            const credential = this.getAccessTokenCredential(key, correlationId);
            if (credential?.requestedClaimsHash && key.includes(credential.requestedClaimsHash.toLowerCase())) {
                this.removeAccessToken(key, correlationId);
                removedAccessTokens++;
            }
        });
        // warn if any access tokens are removed
        if (removedAccessTokens > 0) this.logger.warning(`${removedAccessTokens} access tokens with claims in the cache keys have been removed from the cache.`);
    }
    /**
     * Prepend msal.<client-id> to each key; Skip for any JSON object as Key (defined schemas do not need the key appended: AccessToken Keys or the upcoming schema)
     * @param key
     * @param addInstanceId
     */ generateCacheKey(key) {
        const generatedKey = this.validateAndParseJson(key);
        if (!generatedKey) {
            if ((0, $442eacaa0418a38d$export$ecc754f99843e759).startsWith(key, (0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX) || (0, $442eacaa0418a38d$export$ecc754f99843e759).startsWith(key, (0, $7c375ae106b964be$export$81ab9ba9bd28255c).ADAL_ID_TOKEN)) return key;
            return `${(0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX}.${this.clientId}.${key}`;
        }
        return JSON.stringify(key);
    }
    /**
     * Create authorityKey to cache authority
     * @param state
     */ generateAuthorityKey(stateString) {
        const { libraryState: { id: stateId } } = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString);
        return this.generateCacheKey(`${(0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).AUTHORITY}.${stateId}`);
    }
    /**
     * Create Nonce key to cache nonce
     * @param state
     */ generateNonceKey(stateString) {
        const { libraryState: { id: stateId } } = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString);
        return this.generateCacheKey(`${(0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NONCE_IDTOKEN}.${stateId}`);
    }
    /**
     * Creates full cache key for the request state
     * @param stateString State string for the request
     */ generateStateKey(stateString) {
        // Use the library state id to key temp storage for uniqueness for multiple concurrent requests
        const { libraryState: { id: stateId } } = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString);
        return this.generateCacheKey(`${(0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_STATE}.${stateId}`);
    }
    /**
     * Gets the cached authority based on the cached state. Returns empty if no cached state found.
     */ getCachedAuthority(cachedState) {
        const stateCacheKey = this.generateStateKey(cachedState);
        const state = this.getTemporaryCache(stateCacheKey);
        if (!state) return null;
        const authorityCacheKey = this.generateAuthorityKey(state);
        return this.getTemporaryCache(authorityCacheKey);
    }
    /**
     * Updates account, authority, and state in cache
     * @param serverAuthenticationRequest
     * @param account
     */ updateCacheEntries(state, nonce, authorityInstance, loginHint, account) {
        this.logger.trace("BrowserCacheManager.updateCacheEntries called");
        // Cache the request state
        const stateCacheKey = this.generateStateKey(state);
        this.setTemporaryCache(stateCacheKey, state, false);
        // Cache the nonce
        const nonceCacheKey = this.generateNonceKey(state);
        this.setTemporaryCache(nonceCacheKey, nonce, false);
        // Cache authorityKey
        const authorityCacheKey = this.generateAuthorityKey(state);
        this.setTemporaryCache(authorityCacheKey, authorityInstance, false);
        if (account) {
            const ccsCredential = {
                credential: account.homeAccountId,
                type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
            this.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        } else if (loginHint) {
            const ccsCredential = {
                credential: loginHint,
                type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN
            };
            this.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        }
    }
    /**
     * Reset all temporary cache items
     * @param state
     */ resetRequestCache(state) {
        this.logger.trace("BrowserCacheManager.resetRequestCache called");
        // check state and remove associated cache items
        if (state) {
            this.temporaryCacheStorage.getKeys().forEach((key)=>{
                if (key.indexOf(state) !== -1) this.removeTemporaryItem(key);
            });
            // delete generic interactive request parameters
            this.removeTemporaryItem(this.generateStateKey(state));
            this.removeTemporaryItem(this.generateNonceKey(state));
            this.removeTemporaryItem(this.generateAuthorityKey(state));
        }
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_PARAMS));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).CORRELATION_ID));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).CCS_CREDENTIAL));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST));
        this.setInteractionInProgress(false);
    }
    /**
     * Removes temporary cache for the provided state
     * @param stateString
     */ cleanRequestByState(stateString) {
        this.logger.trace("BrowserCacheManager.cleanRequestByState called");
        // Interaction is completed - remove interaction status.
        if (stateString) {
            const stateKey = this.generateStateKey(stateString);
            const cachedState = this.temporaryCacheStorage.getItem(stateKey);
            this.logger.infoPii(`BrowserCacheManager.cleanRequestByState: Removing temporary cache items for state: ${cachedState}`);
            this.resetRequestCache(cachedState || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING);
        }
    }
    /**
     * Looks in temporary cache for any state values with the provided interactionType and removes all temporary cache items for that state
     * Used in scenarios where temp cache needs to be cleaned but state is not known, such as clicking browser back button.
     * @param interactionType
     */ cleanRequestByInteractionType(interactionType) {
        this.logger.trace("BrowserCacheManager.cleanRequestByInteractionType called");
        // Loop through all keys to find state key
        this.temporaryCacheStorage.getKeys().forEach((key)=>{
            // If this key is not the state key, move on
            if (key.indexOf((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_STATE) === -1) return;
            // Retrieve state value, return if not a valid value
            const stateValue = this.temporaryCacheStorage.getItem(key);
            if (!stateValue) return;
            // Extract state and ensure it matches given InteractionType, then clean request cache
            const parsedState = (0, $6ec519bc7bf28780$export$68ec87f530f5f536)(this.cryptoImpl, stateValue);
            if (parsedState && parsedState.interactionType === interactionType) {
                this.logger.infoPii(`BrowserCacheManager.cleanRequestByInteractionType: Removing temporary cache items for state: ${stateValue}`);
                this.resetRequestCache(stateValue);
            }
        });
        this.setInteractionInProgress(false);
    }
    cacheCodeRequest(authCodeRequest) {
        this.logger.trace("BrowserCacheManager.cacheCodeRequest called");
        const encodedValue = (0, $6f6986007da7f422$export$e510a73ee562749)(JSON.stringify(authCodeRequest));
        this.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_PARAMS, encodedValue, true);
    }
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     */ getCachedRequest(state) {
        this.logger.trace("BrowserCacheManager.getCachedRequest called");
        // Get token request from cache and parse as TokenExchangeParameters.
        const encodedTokenRequest = this.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_PARAMS, true);
        if (!encodedTokenRequest) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$8b51939fb2aab3d7));
        let parsedRequest;
        try {
            parsedRequest = JSON.parse((0, $581fd3df606755c8$export$c62426fdd000a97e)(encodedTokenRequest));
        } catch (e) {
            this.logger.errorPii(`Attempted to parse: ${encodedTokenRequest}`);
            this.logger.error(`Parsing cached token request threw with error: ${e}`);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$f3ae24cdfaab4488));
        }
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_PARAMS));
        // Get cached authority and use if no authority is cached with request.
        if (!parsedRequest.authority) {
            const authorityCacheKey = this.generateAuthorityKey(state);
            const cachedAuthority = this.getTemporaryCache(authorityCacheKey);
            if (!cachedAuthority) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$3a2c83e7753553b));
            parsedRequest.authority = cachedAuthority;
        }
        return parsedRequest;
    }
    /**
     * Gets cached native request for redirect flows
     */ getCachedNativeRequest() {
        this.logger.trace("BrowserCacheManager.getCachedNativeRequest called");
        const cachedRequest = this.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST, true);
        if (!cachedRequest) {
            this.logger.trace("BrowserCacheManager.getCachedNativeRequest: No cached native request found");
            return null;
        }
        const parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("BrowserCacheManager.getCachedNativeRequest: Unable to parse native request");
            return null;
        }
        return parsedRequest;
    }
    isInteractionInProgress(matchClientId) {
        const clientId = this.getInteractionInProgress();
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    }
    getInteractionInProgress() {
        const key = `${(0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX}.${(0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        return this.getTemporaryCache(key, false);
    }
    setInteractionInProgress(inProgress) {
        // Ensure we don't overwrite interaction in progress for a different clientId
        const key = `${(0, $7c375ae106b964be$export$a002182e51710d39).CACHE_PREFIX}.${(0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        if (inProgress) {
            if (this.getInteractionInProgress()) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$2700dc1c133d227e));
            else // No interaction is in progress
            this.setTemporaryCache(key, this.clientId, false);
        } else if (!inProgress && this.getInteractionInProgress() === this.clientId) this.removeTemporaryItem(key);
    }
    /**
     * Returns username retrieved from ADAL or MSAL v1 idToken
     * @deprecated
     */ getLegacyLoginHint() {
        // Only check for adal/msal token if no SSO params are being used
        const adalIdTokenString = this.getTemporaryCache((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ADAL_ID_TOKEN);
        if (adalIdTokenString) {
            this.browserStorage.removeItem((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ADAL_ID_TOKEN);
            this.logger.verbose("Cached ADAL id token retrieved.");
        }
        // Check for cached MSAL v1 id token
        const msalIdTokenString = this.getTemporaryCache((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ID_TOKEN, true);
        if (msalIdTokenString) {
            this.browserStorage.removeItem(this.generateCacheKey((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ID_TOKEN));
            this.logger.verbose("Cached MSAL.js v1 id token retrieved");
        }
        const cachedIdTokenString = msalIdTokenString || adalIdTokenString;
        if (cachedIdTokenString) {
            const idTokenClaims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(cachedIdTokenString, (0, $581fd3df606755c8$export$c62426fdd000a97e));
            if (idTokenClaims.preferred_username) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 preferred_username as loginHint");
                return idTokenClaims.preferred_username;
            } else if (idTokenClaims.upn) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 upn as loginHint");
                return idTokenClaims.upn;
            } else this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, however, no account hint claim found. Enable preferred_username or upn id token claim to get SSO.");
        }
        return null;
    }
    /**
     * Updates a credential's cache key if the current cache key is outdated
     */ updateCredentialCacheKey(currentCacheKey, credential, correlationId) {
        const updatedCacheKey = (0, $9ab3d26df56b176d$exports).generateCredentialKey(credential);
        if (currentCacheKey !== updatedCacheKey) {
            const cacheItem = this.getItem(currentCacheKey);
            if (cacheItem) {
                this.browserStorage.removeItem(currentCacheKey);
                this.setItem(updatedCacheKey, cacheItem, correlationId);
                this.logger.verbose(`Updated an outdated ${credential.credentialType} cache key`);
                return updatedCacheKey;
            } else this.logger.error(`Attempted to update an outdated ${credential.credentialType} cache key but no item matching the outdated key was found in storage`);
        }
        return currentCacheKey;
    }
    /**
     * Builds credential entities from AuthenticationResult object and saves the resulting credentials to the cache
     * @param result
     * @param request
     */ async hydrateCache(result, request) {
        const idTokenEntity = (0, $9ab3d26df56b176d$exports).createIdTokenEntity(result.account?.homeAccountId, result.account?.environment, result.idToken, this.clientId, result.tenantId);
        let claimsHash;
        if (request.claims) claimsHash = await this.cryptoImpl.hashString(request.claims);
        /**
         * meta data for cache stores time in seconds from epoch
         * AuthenticationResult returns expiresOn and extExpiresOn in milliseconds (as a Date object which is in ms)
         * We need to map these for the cache when building tokens from AuthenticationResult
         *
         * The next MSAL VFuture should map these both to same value if possible
         */ const accessTokenEntity = (0, $9ab3d26df56b176d$exports).createAccessTokenEntity(result.account?.homeAccountId, result.account.environment, result.accessToken, this.clientId, result.tenantId, result.scopes.join(" "), result.expiresOn ? result.expiresOn.getTime() / 1000 : 0, result.extExpiresOn ? result.extExpiresOn.getTime() / 1000 : 0, (0, $581fd3df606755c8$export$c62426fdd000a97e), undefined, result.tokenType, undefined, request.sshKid, request.claims, claimsHash);
        const cacheRecord = {
            idToken: idTokenEntity,
            accessToken: accessTokenEntity
        };
        return this.saveCacheRecord(cacheRecord, result.correlationId);
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, storeInCache) {
        try {
            await super.saveCacheRecord(cacheRecord, correlationId, storeInCache);
        } catch (e) {
            if (e instanceof (0, $531f2a6dee41cfa4$export$78ff06e91c3de382) && this.performanceClient && correlationId) try {
                const tokenKeys = this.getTokenKeys();
                this.performanceClient.addFields({
                    cacheRtCount: tokenKeys.refreshToken.length,
                    cacheIdCount: tokenKeys.idToken.length,
                    cacheAtCount: tokenKeys.accessToken.length
                }, correlationId);
            } catch (e) {}
            throw e;
        }
    }
}
const $d3981d5134d5331a$export$8e2d54002f8f6e5d = (clientId, logger)=>{
    const cacheOptions = {
        cacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
        temporaryCacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        cacheMigrationEnabled: false,
        claimsBasedCachingEnabled: false
    };
    return new $d3981d5134d5331a$export$44d7291b5c8cc149(clientId, cacheOptions, (0, $dd88ab1a0b4d3851$export$865f57d401606752), logger);
};


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
 * @param accountFilter - (Optional) filter to narrow down the accounts returned
 * @returns Array of AccountInfo objects in cache
 */ function $807e525bbe19e865$export$a4fc43c2a99143cd(logger, browserStorage, isInBrowser, correlationId, accountFilter) {
    logger.verbose("getAllAccounts called");
    return isInBrowser ? browserStorage.getAllAccounts(correlationId, accountFilter) : [];
}
/**
 * Returns the first account found in the cache that matches the account filter passed in.
 * @param accountFilter
 * @returns The first account found in the cache matching the provided filter or null if no account could be found.
 */ function $807e525bbe19e865$export$4f9234baf34abd0(accountFilter, logger, browserStorage, correlationId) {
    logger.trace("getAccount called");
    if (Object.keys(accountFilter).length === 0) {
        logger.warning("getAccount: No accountFilter provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy(accountFilter, correlationId);
    if (account) {
        logger.verbose("getAccount: Account matching provided filter found, returning");
        return account;
    } else {
        logger.verbose("getAccount: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching username.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found.
 * This API is provided for convenience but getAccountById should be used for best reliability
 * @param username
 * @returns The account object stored in MSAL
 */ function $807e525bbe19e865$export$d915baf55d86927d(username, logger, browserStorage, correlationId) {
    logger.trace("getAccountByUsername called");
    if (!username) {
        logger.warning("getAccountByUsername: No username provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        username: username
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByUsername: Account matching username found, returning");
        logger.verbosePii(`getAccountByUsername: Returning signed-in accounts matching username: ${username}`);
        return account;
    } else {
        logger.verbose("getAccountByUsername: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching homeAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param homeAccountId
 * @returns The account object stored in MSAL
 */ function $807e525bbe19e865$export$d6fa7d1e8099998e(homeAccountId, logger, browserStorage, correlationId) {
    logger.trace("getAccountByHomeId called");
    if (!homeAccountId) {
        logger.warning("getAccountByHomeId: No homeAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        homeAccountId: homeAccountId
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByHomeId: Account matching homeAccountId found, returning");
        logger.verbosePii(`getAccountByHomeId: Returning signed-in accounts matching homeAccountId: ${homeAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByHomeId: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching localAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param localAccountId
 * @returns The account object stored in MSAL
 */ function $807e525bbe19e865$export$7ac8aa09fdf78340(localAccountId, logger, browserStorage, correlationId) {
    logger.trace("getAccountByLocalId called");
    if (!localAccountId) {
        logger.warning("getAccountByLocalId: No localAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        localAccountId: localAccountId
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByLocalId: Account matching localAccountId found, returning");
        logger.verbosePii(`getAccountByLocalId: Returning signed-in accounts matching localAccountId: ${localAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByLocalId: No matching account found, returning null");
        return null;
    }
}
/**
 * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
 * @param account
 */ function $807e525bbe19e865$export$c55c3d25cf1bcd99(account, browserStorage, correlationId) {
    browserStorage.setActiveAccount(account, correlationId);
}
/**
 * Gets the currently active account
 */ function $807e525bbe19e865$export$13dd2e33a23839ad(browserStorage, correlationId) {
    return browserStorage.getActiveAccount(correlationId);
}





/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9f61ab73b66f619a$export$ce0ba2422a1c7815 {
    constructor(logger){
        this.eventCallbacks = new Map();
        this.logger = logger || new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)({});
    }
    /**
     * Adds event callbacks to array
     * @param callback - callback to be invoked when an event is raised
     * @param eventTypes - list of events that this callback will be invoked for, if not provided callback will be invoked for all events
     * @param callbackId - Identifier for the callback, used to locate and remove the callback when no longer required
     */ addEventCallback(callback, eventTypes, callbackId) {
        if (typeof window !== "undefined") {
            const id = callbackId || (0, $3003b661a087a867$export$7571c350ed9fec74)();
            if (this.eventCallbacks.has(id)) {
                this.logger.error(`Event callback with id: ${id} is already registered. Please provide a unique id or remove the existing callback and try again.`);
                return null;
            }
            this.eventCallbacks.set(id, [
                callback,
                eventTypes || []
            ]);
            this.logger.verbose(`Event callback registered with id: ${id}`);
            return id;
        }
        return null;
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose(`Event callback ${callbackId} removed.`);
    }
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ emitEvent(eventType, interactionType, payload, error) {
        if (typeof window !== "undefined") {
            const message = {
                eventType: eventType,
                interactionType: interactionType || null,
                payload: payload || null,
                error: error || null,
                timestamp: Date.now()
            };
            this.eventCallbacks.forEach(([callback, eventTypes], callbackId)=>{
                if (eventTypes.length === 0 || eventTypes.includes(eventType)) {
                    this.logger.verbose(`Emitting event to callback ${callbackId}: ${eventType}`);
                    callback.apply(null, [
                        message
                    ]);
                }
            });
        }
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 
/*! @azure/msal-common v14.16.1 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ class $016e46db2c2afa86$export$ea52035eac03daf0 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, errorNo, status){
        super(errorCode, errorMessage, subError);
        this.name = "ServerError";
        this.errorNo = errorNo;
        this.status = status;
        Object.setPrototypeOf(this, $016e46db2c2afa86$export$ea52035eac03daf0.prototype);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $38fc8bee021018e9$export$c060a619741dd765 {
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ static generateThrottlingStorageKey(thumbprint) {
        return `${(0, $7c375ae106b964be$export$a2330d6808e6d893).THROTTLING_PREFIX}.${JSON.stringify(thumbprint)}`;
    }
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ static preProcess(cacheManager, thumbprint, correlationId) {
        const key = $38fc8bee021018e9$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint);
        const value = cacheManager.getThrottlingCache(key);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key, correlationId);
                return;
            }
            throw new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(value.errorCodes?.join(" ") || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, value.errorMessage, value.subError);
        }
    }
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */ static postProcess(cacheManager, thumbprint, response, correlationId) {
        if ($38fc8bee021018e9$export$c060a619741dd765.checkResponseStatus(response) || $38fc8bee021018e9$export$c060a619741dd765.checkResponseForRetryAfter(response)) {
            const thumbprintValue = {
                throttleTime: $38fc8bee021018e9$export$c060a619741dd765.calculateThrottleTime(parseInt(response.headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache($38fc8bee021018e9$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint), thumbprintValue, correlationId);
        }
    }
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ static checkResponseStatus(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    }
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */ static checkResponseForRetryAfter(response) {
        if (response.headers) return response.headers.hasOwnProperty((0, $7c375ae106b964be$export$28d77f87efed1d88).RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        return false;
    }
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ static calculateThrottleTime(throttleTime) {
        const time = throttleTime <= 0 ? 0 : throttleTime;
        const currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || (0, $7c375ae106b964be$export$a2330d6808e6d893).DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + (0, $7c375ae106b964be$export$a2330d6808e6d893).DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    }
    static removeThrottle(cacheManager, clientId, request, homeAccountIdentifier) {
        const thumbprint = {
            clientId: clientId,
            authority: request.authority,
            scopes: request.scopes,
            homeAccountIdentifier: homeAccountIdentifier,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        const key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key, request.correlationId);
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 





/*! @azure/msal-common v14.16.1 2025-08-05 */ 
var $b00a7f221d8fdf60$exports = {};

$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_ID", () => $b00a7f221d8fdf60$export$c7b1b63f5b60f8e);
$parcel$export($b00a7f221d8fdf60$exports, "REDIRECT_URI", () => $b00a7f221d8fdf60$export$89711068e98820c5);
$parcel$export($b00a7f221d8fdf60$exports, "RESPONSE_TYPE", () => $b00a7f221d8fdf60$export$af70b7209f1c7f6e);
$parcel$export($b00a7f221d8fdf60$exports, "RESPONSE_MODE", () => $b00a7f221d8fdf60$export$2ae8b352eb8edff7);
$parcel$export($b00a7f221d8fdf60$exports, "GRANT_TYPE", () => $b00a7f221d8fdf60$export$47f09697d0642170);
$parcel$export($b00a7f221d8fdf60$exports, "CLAIMS", () => $b00a7f221d8fdf60$export$c9b29cc9615296dd);
$parcel$export($b00a7f221d8fdf60$exports, "SCOPE", () => $b00a7f221d8fdf60$export$1c5a554c78c0cd12);
$parcel$export($b00a7f221d8fdf60$exports, "ERROR", () => $b00a7f221d8fdf60$export$103bedf43ba882db);
$parcel$export($b00a7f221d8fdf60$exports, "ERROR_DESCRIPTION", () => $b00a7f221d8fdf60$export$a9d2d02ea6b73527);
$parcel$export($b00a7f221d8fdf60$exports, "ACCESS_TOKEN", () => $b00a7f221d8fdf60$export$cdbdf26448f9da5b);
$parcel$export($b00a7f221d8fdf60$exports, "ID_TOKEN", () => $b00a7f221d8fdf60$export$9e690c458f1b1eda);
$parcel$export($b00a7f221d8fdf60$exports, "REFRESH_TOKEN", () => $b00a7f221d8fdf60$export$2a2261c5a58ac0);
$parcel$export($b00a7f221d8fdf60$exports, "EXPIRES_IN", () => $b00a7f221d8fdf60$export$a9f2539254087dfb);
$parcel$export($b00a7f221d8fdf60$exports, "REFRESH_TOKEN_EXPIRES_IN", () => $b00a7f221d8fdf60$export$97e3ac17371277);
$parcel$export($b00a7f221d8fdf60$exports, "STATE", () => $b00a7f221d8fdf60$export$63b4527a2777036f);
$parcel$export($b00a7f221d8fdf60$exports, "NONCE", () => $b00a7f221d8fdf60$export$8646168ae3eb91e1);
$parcel$export($b00a7f221d8fdf60$exports, "PROMPT", () => $b00a7f221d8fdf60$export$19855bb42e55939d);
$parcel$export($b00a7f221d8fdf60$exports, "SESSION_STATE", () => $b00a7f221d8fdf60$export$3edd0f3d0bfcddba);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_INFO", () => $b00a7f221d8fdf60$export$476989d62bcb4c85);
$parcel$export($b00a7f221d8fdf60$exports, "CODE", () => $b00a7f221d8fdf60$export$ec5856072852bd7f);
$parcel$export($b00a7f221d8fdf60$exports, "CODE_CHALLENGE", () => $b00a7f221d8fdf60$export$58d2be3216991fee);
$parcel$export($b00a7f221d8fdf60$exports, "CODE_CHALLENGE_METHOD", () => $b00a7f221d8fdf60$export$129e6f0601e36303);
$parcel$export($b00a7f221d8fdf60$exports, "CODE_VERIFIER", () => $b00a7f221d8fdf60$export$a5a34ec10c757281);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_REQUEST_ID", () => $b00a7f221d8fdf60$export$633c8d7cd18ad9a9);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_SKU", () => $b00a7f221d8fdf60$export$fe2f04d04881f19d);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_VER", () => $b00a7f221d8fdf60$export$d0d0201281a553c0);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_OS", () => $b00a7f221d8fdf60$export$35497983a44f9406);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_CPU", () => $b00a7f221d8fdf60$export$d14a6ca469cd1d2b);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_CURR_TELEM", () => $b00a7f221d8fdf60$export$770dc090fda61e98);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_LAST_TELEM", () => $b00a7f221d8fdf60$export$99d6087ff3bfb0d3);
$parcel$export($b00a7f221d8fdf60$exports, "X_MS_LIB_CAPABILITY", () => $b00a7f221d8fdf60$export$c5cd103a582a276);
$parcel$export($b00a7f221d8fdf60$exports, "X_APP_NAME", () => $b00a7f221d8fdf60$export$6101af169595a2ae);
$parcel$export($b00a7f221d8fdf60$exports, "X_APP_VER", () => $b00a7f221d8fdf60$export$a8707209cc4254a);
$parcel$export($b00a7f221d8fdf60$exports, "POST_LOGOUT_URI", () => $b00a7f221d8fdf60$export$965624bb436bcb2);
$parcel$export($b00a7f221d8fdf60$exports, "ID_TOKEN_HINT", () => $b00a7f221d8fdf60$export$8d6737236a319b56);
$parcel$export($b00a7f221d8fdf60$exports, "DEVICE_CODE", () => $b00a7f221d8fdf60$export$a575303545717aec);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_SECRET", () => $b00a7f221d8fdf60$export$69f7aececf3ea5d7);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_ASSERTION", () => $b00a7f221d8fdf60$export$cddd1d85c78cca51);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_ASSERTION_TYPE", () => $b00a7f221d8fdf60$export$21aecb34d0e7d9c0);
$parcel$export($b00a7f221d8fdf60$exports, "TOKEN_TYPE", () => $b00a7f221d8fdf60$export$5706a68daf4f000a);
$parcel$export($b00a7f221d8fdf60$exports, "REQ_CNF", () => $b00a7f221d8fdf60$export$427afb3f9eefe31e);
$parcel$export($b00a7f221d8fdf60$exports, "OBO_ASSERTION", () => $b00a7f221d8fdf60$export$3529b31b0ae94ae0);
$parcel$export($b00a7f221d8fdf60$exports, "REQUESTED_TOKEN_USE", () => $b00a7f221d8fdf60$export$97bc1bf63f077c4a);
$parcel$export($b00a7f221d8fdf60$exports, "ON_BEHALF_OF", () => $b00a7f221d8fdf60$export$4aca5741d44e318e);
$parcel$export($b00a7f221d8fdf60$exports, "FOCI", () => $b00a7f221d8fdf60$export$a03331b9d99609d6);
$parcel$export($b00a7f221d8fdf60$exports, "CCS_HEADER", () => $b00a7f221d8fdf60$export$773357fabf610b1f);
$parcel$export($b00a7f221d8fdf60$exports, "RETURN_SPA_CODE", () => $b00a7f221d8fdf60$export$f58b98a40c1faa68);
$parcel$export($b00a7f221d8fdf60$exports, "NATIVE_BROKER", () => $b00a7f221d8fdf60$export$830ff7e6cf071f86);
$parcel$export($b00a7f221d8fdf60$exports, "LOGOUT_HINT", () => $b00a7f221d8fdf60$export$a96ff88ff08babe2);
$parcel$export($b00a7f221d8fdf60$exports, "SID", () => $b00a7f221d8fdf60$export$e9405f9e95799b52);
$parcel$export($b00a7f221d8fdf60$exports, "LOGIN_HINT", () => $b00a7f221d8fdf60$export$defd6be6e02aaeb3);
$parcel$export($b00a7f221d8fdf60$exports, "DOMAIN_HINT", () => $b00a7f221d8fdf60$export$41459bac1e74ba19);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_EXTRA_SKU", () => $b00a7f221d8fdf60$export$493429868d5ba9bc);
$parcel$export($b00a7f221d8fdf60$exports, "BROKER_CLIENT_ID", () => $b00a7f221d8fdf60$export$3f910906fd5fe047);
$parcel$export($b00a7f221d8fdf60$exports, "BROKER_REDIRECT_URI", () => $b00a7f221d8fdf60$export$c3ecf58e7e228261);
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $b00a7f221d8fdf60$export$c7b1b63f5b60f8e = "client_id";
const $b00a7f221d8fdf60$export$89711068e98820c5 = "redirect_uri";
const $b00a7f221d8fdf60$export$af70b7209f1c7f6e = "response_type";
const $b00a7f221d8fdf60$export$2ae8b352eb8edff7 = "response_mode";
const $b00a7f221d8fdf60$export$47f09697d0642170 = "grant_type";
const $b00a7f221d8fdf60$export$c9b29cc9615296dd = "claims";
const $b00a7f221d8fdf60$export$1c5a554c78c0cd12 = "scope";
const $b00a7f221d8fdf60$export$103bedf43ba882db = "error";
const $b00a7f221d8fdf60$export$a9d2d02ea6b73527 = "error_description";
const $b00a7f221d8fdf60$export$cdbdf26448f9da5b = "access_token";
const $b00a7f221d8fdf60$export$9e690c458f1b1eda = "id_token";
const $b00a7f221d8fdf60$export$2a2261c5a58ac0 = "refresh_token";
const $b00a7f221d8fdf60$export$a9f2539254087dfb = "expires_in";
const $b00a7f221d8fdf60$export$97e3ac17371277 = "refresh_token_expires_in";
const $b00a7f221d8fdf60$export$63b4527a2777036f = "state";
const $b00a7f221d8fdf60$export$8646168ae3eb91e1 = "nonce";
const $b00a7f221d8fdf60$export$19855bb42e55939d = "prompt";
const $b00a7f221d8fdf60$export$3edd0f3d0bfcddba = "session_state";
const $b00a7f221d8fdf60$export$476989d62bcb4c85 = "client_info";
const $b00a7f221d8fdf60$export$ec5856072852bd7f = "code";
const $b00a7f221d8fdf60$export$58d2be3216991fee = "code_challenge";
const $b00a7f221d8fdf60$export$129e6f0601e36303 = "code_challenge_method";
const $b00a7f221d8fdf60$export$a5a34ec10c757281 = "code_verifier";
const $b00a7f221d8fdf60$export$633c8d7cd18ad9a9 = "client-request-id";
const $b00a7f221d8fdf60$export$fe2f04d04881f19d = "x-client-SKU";
const $b00a7f221d8fdf60$export$d0d0201281a553c0 = "x-client-VER";
const $b00a7f221d8fdf60$export$35497983a44f9406 = "x-client-OS";
const $b00a7f221d8fdf60$export$d14a6ca469cd1d2b = "x-client-CPU";
const $b00a7f221d8fdf60$export$770dc090fda61e98 = "x-client-current-telemetry";
const $b00a7f221d8fdf60$export$99d6087ff3bfb0d3 = "x-client-last-telemetry";
const $b00a7f221d8fdf60$export$c5cd103a582a276 = "x-ms-lib-capability";
const $b00a7f221d8fdf60$export$6101af169595a2ae = "x-app-name";
const $b00a7f221d8fdf60$export$a8707209cc4254a = "x-app-ver";
const $b00a7f221d8fdf60$export$965624bb436bcb2 = "post_logout_redirect_uri";
const $b00a7f221d8fdf60$export$8d6737236a319b56 = "id_token_hint";
const $b00a7f221d8fdf60$export$a575303545717aec = "device_code";
const $b00a7f221d8fdf60$export$69f7aececf3ea5d7 = "client_secret";
const $b00a7f221d8fdf60$export$cddd1d85c78cca51 = "client_assertion";
const $b00a7f221d8fdf60$export$21aecb34d0e7d9c0 = "client_assertion_type";
const $b00a7f221d8fdf60$export$5706a68daf4f000a = "token_type";
const $b00a7f221d8fdf60$export$427afb3f9eefe31e = "req_cnf";
const $b00a7f221d8fdf60$export$3529b31b0ae94ae0 = "assertion";
const $b00a7f221d8fdf60$export$97bc1bf63f077c4a = "requested_token_use";
const $b00a7f221d8fdf60$export$4aca5741d44e318e = "on_behalf_of";
const $b00a7f221d8fdf60$export$a03331b9d99609d6 = "foci";
const $b00a7f221d8fdf60$export$773357fabf610b1f = "X-AnchorMailbox";
const $b00a7f221d8fdf60$export$f58b98a40c1faa68 = "return_spa_code";
const $b00a7f221d8fdf60$export$830ff7e6cf071f86 = "nativebroker";
const $b00a7f221d8fdf60$export$a96ff88ff08babe2 = "logout_hint";
const $b00a7f221d8fdf60$export$e9405f9e95799b52 = "sid";
const $b00a7f221d8fdf60$export$defd6be6e02aaeb3 = "login_hint";
const $b00a7f221d8fdf60$export$41459bac1e74ba19 = "domain_hint";
const $b00a7f221d8fdf60$export$493429868d5ba9bc = "x-client-xtra-sku";
const $b00a7f221d8fdf60$export$3f910906fd5fe047 = "brk_client_id";
const $b00a7f221d8fdf60$export$c3ecf58e7e228261 = "brk_redirect_uri";




/*! @azure/msal-common v14.16.1 2025-08-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Validates server consumable params from the "request" objects
 */ class $5a78012ce109fb77$export$9800b929b6984365 {
    /**
     * Utility to check if the `redirectUri` in the request is a non-null value
     * @param redirectUri
     */ static validateRedirectUri(redirectUri) {
        if (!redirectUri) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$7a02f9bdce79dd4e));
    }
    /**
     * Utility to validate prompt sent by the user in the request
     * @param prompt
     */ static validatePrompt(prompt) {
        const promptValues = [];
        for(const value in 0, $7c375ae106b964be$export$49a06cbda5acaa5)promptValues.push((0, $7c375ae106b964be$export$49a06cbda5acaa5)[value]);
        if (promptValues.indexOf(prompt) < 0) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ccbe5d2d7c960c35));
    }
    static validateClaims(claims) {
        try {
            JSON.parse(claims);
        } catch (e) {
            throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$96e755c70e0d0e34));
        }
    }
    /**
     * Utility to validate code_challenge and code_challenge_method
     * @param codeChallenge
     * @param codeChallengeMethod
     */ static validateCodeChallengeParams(codeChallenge, codeChallengeMethod) {
        if (!codeChallenge || !codeChallengeMethod) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$2da3866b327f1753));
        else this.validateCodeChallengeMethod(codeChallengeMethod);
    }
    /**
     * Utility to validate code_challenge_method
     * @param codeChallengeMethod
     */ static validateCodeChallengeMethod(codeChallengeMethod) {
        if ([
            (0, $7c375ae106b964be$export$a1fe36237c1cc863).PLAIN,
            (0, $7c375ae106b964be$export$a1fe36237c1cc863).S256
        ].indexOf(codeChallengeMethod) < 0) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$b8d8b332f17376dc));
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $7d3a00eb36d325b3$var$instrumentBrokerParams(parameters, correlationId, performanceClient) {
    if (!correlationId) return;
    const clientId = parameters.get((0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e));
    if (clientId && parameters.has((0, $b00a7f221d8fdf60$export$3f910906fd5fe047))) performanceClient?.addFields({
        embeddedClientId: clientId,
        embeddedRedirectUri: parameters.get((0, $b00a7f221d8fdf60$export$89711068e98820c5))
    }, correlationId);
}
/** @internal */ class $7d3a00eb36d325b3$export$882078dd8a9e0bfa {
    constructor(correlationId, performanceClient){
        this.parameters = new Map();
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * add response_type = code
     */ addResponseTypeCode() {
        this.parameters.set((0, $b00a7f221d8fdf60$export$af70b7209f1c7f6e), encodeURIComponent((0, $7c375ae106b964be$export$a002182e51710d39).CODE_RESPONSE_TYPE));
    }
    /**
     * add response_type = token id_token
     */ addResponseTypeForTokenAndIdToken() {
        this.parameters.set((0, $b00a7f221d8fdf60$export$af70b7209f1c7f6e), encodeURIComponent(`${(0, $7c375ae106b964be$export$a002182e51710d39).TOKEN_RESPONSE_TYPE} ${(0, $7c375ae106b964be$export$a002182e51710d39).ID_TOKEN_RESPONSE_TYPE}`));
    }
    /**
     * add response_mode. defaults to query.
     * @param responseMode
     */ addResponseMode(responseMode) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$2ae8b352eb8edff7), encodeURIComponent(responseMode ? responseMode : (0, $7c375ae106b964be$export$f990a5bae1260b8c).QUERY));
    }
    /**
     * Add flag to indicate STS should attempt to use WAM if available
     */ addNativeBroker() {
        this.parameters.set((0, $b00a7f221d8fdf60$export$830ff7e6cf071f86), encodeURIComponent("1"));
    }
    /**
     * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
     * @param scopeSet
     * @param addOidcScopes
     */ addScopes(scopes, addOidcScopes = true, defaultScopes = (0, $7c375ae106b964be$export$893b1b5b686d84ef)) {
        // Always add openid to the scopes when adding OIDC scopes
        if (addOidcScopes && !defaultScopes.includes("openid") && !scopes.includes("openid")) defaultScopes.push("openid");
        const requestScopes = addOidcScopes ? [
            ...scopes || [],
            ...defaultScopes
        ] : scopes || [];
        const scopeSet = new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(requestScopes);
        this.parameters.set((0, $b00a7f221d8fdf60$export$1c5a554c78c0cd12), encodeURIComponent(scopeSet.printScopes()));
    }
    /**
     * add clientId
     * @param clientId
     */ addClientId(clientId) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e), encodeURIComponent(clientId));
    }
    /**
     * add redirect_uri
     * @param redirectUri
     */ addRedirectUri(redirectUri) {
        (0, $5a78012ce109fb77$export$9800b929b6984365).validateRedirectUri(redirectUri);
        this.parameters.set((0, $b00a7f221d8fdf60$export$89711068e98820c5), encodeURIComponent(redirectUri));
    }
    /**
     * add post logout redirectUri
     * @param redirectUri
     */ addPostLogoutRedirectUri(redirectUri) {
        (0, $5a78012ce109fb77$export$9800b929b6984365).validateRedirectUri(redirectUri);
        this.parameters.set((0, $b00a7f221d8fdf60$export$965624bb436bcb2), encodeURIComponent(redirectUri));
    }
    /**
     * add id_token_hint to logout request
     * @param idTokenHint
     */ addIdTokenHint(idTokenHint) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$8d6737236a319b56), encodeURIComponent(idTokenHint));
    }
    /**
     * add domain_hint
     * @param domainHint
     */ addDomainHint(domainHint) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$41459bac1e74ba19), encodeURIComponent(domainHint));
    }
    /**
     * add login_hint
     * @param loginHint
     */ addLoginHint(loginHint) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$defd6be6e02aaeb3), encodeURIComponent(loginHint));
    }
    /**
     * Adds the CCS (Cache Credential Service) query parameter for login_hint
     * @param loginHint
     */ addCcsUpn(loginHint) {
        this.parameters.set((0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER, encodeURIComponent(`UPN:${loginHint}`));
    }
    /**
     * Adds the CCS (Cache Credential Service) query parameter for account object
     * @param loginHint
     */ addCcsOid(clientInfo) {
        this.parameters.set((0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER, encodeURIComponent(`Oid:${clientInfo.uid}@${clientInfo.utid}`));
    }
    /**
     * add sid
     * @param sid
     */ addSid(sid) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$e9405f9e95799b52), encodeURIComponent(sid));
    }
    /**
     * add claims
     * @param claims
     */ addClaims(claims, clientCapabilities) {
        const mergedClaims = this.addClientCapabilitiesToClaims(claims, clientCapabilities);
        (0, $5a78012ce109fb77$export$9800b929b6984365).validateClaims(mergedClaims);
        this.parameters.set((0, $b00a7f221d8fdf60$export$c9b29cc9615296dd), encodeURIComponent(mergedClaims));
    }
    /**
     * add correlationId
     * @param correlationId
     */ addCorrelationId(correlationId) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$633c8d7cd18ad9a9), encodeURIComponent(correlationId));
    }
    /**
     * add library info query params
     * @param libraryInfo
     */ addLibraryInfo(libraryInfo) {
        // Telemetry Info
        this.parameters.set((0, $b00a7f221d8fdf60$export$fe2f04d04881f19d), libraryInfo.sku);
        this.parameters.set((0, $b00a7f221d8fdf60$export$d0d0201281a553c0), libraryInfo.version);
        if (libraryInfo.os) this.parameters.set((0, $b00a7f221d8fdf60$export$35497983a44f9406), libraryInfo.os);
        if (libraryInfo.cpu) this.parameters.set((0, $b00a7f221d8fdf60$export$d14a6ca469cd1d2b), libraryInfo.cpu);
    }
    /**
     * Add client telemetry parameters
     * @param appTelemetry
     */ addApplicationTelemetry(appTelemetry) {
        if (appTelemetry?.appName) this.parameters.set((0, $b00a7f221d8fdf60$export$6101af169595a2ae), appTelemetry.appName);
        if (appTelemetry?.appVersion) this.parameters.set((0, $b00a7f221d8fdf60$export$a8707209cc4254a), appTelemetry.appVersion);
    }
    /**
     * add prompt
     * @param prompt
     */ addPrompt(prompt) {
        (0, $5a78012ce109fb77$export$9800b929b6984365).validatePrompt(prompt);
        this.parameters.set(`${(0, $b00a7f221d8fdf60$export$19855bb42e55939d)}`, encodeURIComponent(prompt));
    }
    /**
     * add state
     * @param state
     */ addState(state) {
        if (state) this.parameters.set((0, $b00a7f221d8fdf60$export$63b4527a2777036f), encodeURIComponent(state));
    }
    /**
     * add nonce
     * @param nonce
     */ addNonce(nonce) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$8646168ae3eb91e1), encodeURIComponent(nonce));
    }
    /**
     * add code_challenge and code_challenge_method
     * - throw if either of them are not passed
     * @param codeChallenge
     * @param codeChallengeMethod
     */ addCodeChallengeParams(codeChallenge, codeChallengeMethod) {
        (0, $5a78012ce109fb77$export$9800b929b6984365).validateCodeChallengeParams(codeChallenge, codeChallengeMethod);
        if (codeChallenge && codeChallengeMethod) {
            this.parameters.set((0, $b00a7f221d8fdf60$export$58d2be3216991fee), encodeURIComponent(codeChallenge));
            this.parameters.set((0, $b00a7f221d8fdf60$export$129e6f0601e36303), encodeURIComponent(codeChallengeMethod));
        } else throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$2da3866b327f1753));
    }
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */ addAuthorizationCode(code) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$ec5856072852bd7f), encodeURIComponent(code));
    }
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */ addDeviceCode(code) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$a575303545717aec), encodeURIComponent(code));
    }
    /**
     * add the `refreshToken` passed by the user
     * @param refreshToken
     */ addRefreshToken(refreshToken) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$2a2261c5a58ac0), encodeURIComponent(refreshToken));
    }
    /**
     * add the `code_verifier` passed by the user to exchange for a token
     * @param codeVerifier
     */ addCodeVerifier(codeVerifier) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$a5a34ec10c757281), encodeURIComponent(codeVerifier));
    }
    /**
     * add client_secret
     * @param clientSecret
     */ addClientSecret(clientSecret) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$69f7aececf3ea5d7), encodeURIComponent(clientSecret));
    }
    /**
     * add clientAssertion for confidential client flows
     * @param clientAssertion
     */ addClientAssertion(clientAssertion) {
        if (clientAssertion) this.parameters.set((0, $b00a7f221d8fdf60$export$cddd1d85c78cca51), encodeURIComponent(clientAssertion));
    }
    /**
     * add clientAssertionType for confidential client flows
     * @param clientAssertionType
     */ addClientAssertionType(clientAssertionType) {
        if (clientAssertionType) this.parameters.set((0, $b00a7f221d8fdf60$export$21aecb34d0e7d9c0), encodeURIComponent(clientAssertionType));
    }
    /**
     * add OBO assertion for confidential client flows
     * @param clientAssertion
     */ addOboAssertion(oboAssertion) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$3529b31b0ae94ae0), encodeURIComponent(oboAssertion));
    }
    /**
     * add grant type
     * @param grantType
     */ addRequestTokenUse(tokenUse) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$97bc1bf63f077c4a), encodeURIComponent(tokenUse));
    }
    /**
     * add grant type
     * @param grantType
     */ addGrantType(grantType) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$47f09697d0642170), encodeURIComponent(grantType));
    }
    /**
     * add client info
     *
     */ addClientInfo() {
        this.parameters.set((0, $7c375ae106b964be$export$476989d62bcb4c85), "1");
    }
    /**
     * add extraQueryParams
     * @param eQParams
     */ addExtraQueryParameters(eQParams) {
        Object.entries(eQParams).forEach(([key, value])=>{
            if (!this.parameters.has(key) && value) this.parameters.set(key, value);
        });
    }
    addClientCapabilitiesToClaims(claims, clientCapabilities) {
        let mergedClaims;
        // Parse provided claims into JSON object or initialize empty object
        if (!claims) mergedClaims = {};
        else try {
            mergedClaims = JSON.parse(claims);
        } catch (e) {
            throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$96e755c70e0d0e34));
        }
        if (clientCapabilities && clientCapabilities.length > 0) {
            if (!mergedClaims.hasOwnProperty((0, $7c375ae106b964be$export$c125cda26c71ef54).ACCESS_TOKEN)) // Add access_token key to claims object
            mergedClaims[(0, $7c375ae106b964be$export$c125cda26c71ef54).ACCESS_TOKEN] = {};
            // Add xms_cc claim with provided clientCapabilities to access_token key
            mergedClaims[(0, $7c375ae106b964be$export$c125cda26c71ef54).ACCESS_TOKEN][(0, $7c375ae106b964be$export$c125cda26c71ef54).XMS_CC] = {
                values: clientCapabilities
            };
        }
        return JSON.stringify(mergedClaims);
    }
    /**
     * adds `username` for Password Grant flow
     * @param username
     */ addUsername(username) {
        this.parameters.set((0, $7c375ae106b964be$export$fa8b29062cab1da).username, encodeURIComponent(username));
    }
    /**
     * adds `password` for Password Grant flow
     * @param password
     */ addPassword(password) {
        this.parameters.set((0, $7c375ae106b964be$export$fa8b29062cab1da).password, encodeURIComponent(password));
    }
    /**
     * add pop_jwk to query params
     * @param cnfString
     */ addPopToken(cnfString) {
        if (cnfString) {
            this.parameters.set((0, $b00a7f221d8fdf60$export$5706a68daf4f000a), (0, $7c375ae106b964be$export$901491a717da2ba5).POP);
            this.parameters.set((0, $b00a7f221d8fdf60$export$427afb3f9eefe31e), encodeURIComponent(cnfString));
        }
    }
    /**
     * add SSH JWK and key ID to query params
     */ addSshJwk(sshJwkString) {
        if (sshJwkString) {
            this.parameters.set((0, $b00a7f221d8fdf60$export$5706a68daf4f000a), (0, $7c375ae106b964be$export$901491a717da2ba5).SSH);
            this.parameters.set((0, $b00a7f221d8fdf60$export$427afb3f9eefe31e), encodeURIComponent(sshJwkString));
        }
    }
    /**
     * add server telemetry fields
     * @param serverTelemetryManager
     */ addServerTelemetry(serverTelemetryManager) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$770dc090fda61e98), serverTelemetryManager.generateCurrentRequestHeaderValue());
        this.parameters.set((0, $b00a7f221d8fdf60$export$99d6087ff3bfb0d3), serverTelemetryManager.generateLastRequestHeaderValue());
    }
    /**
     * Adds parameter that indicates to the server that throttling is supported
     */ addThrottling() {
        this.parameters.set((0, $b00a7f221d8fdf60$export$c5cd103a582a276), (0, $7c375ae106b964be$export$a2330d6808e6d893).X_MS_LIB_CAPABILITY_VALUE);
    }
    /**
     * Adds logout_hint parameter for "silent" logout which prevent server account picker
     */ addLogoutHint(logoutHint) {
        this.parameters.set((0, $b00a7f221d8fdf60$export$a96ff88ff08babe2), encodeURIComponent(logoutHint));
    }
    addBrokerParameters(params) {
        const brokerParams = {};
        brokerParams[0, $b00a7f221d8fdf60$export$3f910906fd5fe047] = params.brokerClientId;
        brokerParams[0, $b00a7f221d8fdf60$export$c3ecf58e7e228261] = params.brokerRedirectUri;
        this.addExtraQueryParameters(brokerParams);
    }
    /**
     * Utility to create a URL from the params map
     */ createQueryString() {
        const queryParameterArray = new Array();
        this.parameters.forEach((value, key)=>{
            queryParameterArray.push(`${key}=${value}`);
        });
        $7d3a00eb36d325b3$var$instrumentBrokerParams(this.parameters, this.correlationId, this.performanceClient);
        return queryParameterArray.join("&");
    }
}


var $ef8a264971d8166d$exports = {};

$parcel$export($ef8a264971d8166d$exports, "createDiscoveredInstance", () => $ef8a264971d8166d$export$ab9db5e7e572e7da);
/*! @azure/msal-common v14.16.1 2025-08-05 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create an authority object of the correct type based on the url
 * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
 *
 * Also performs endpoint discovery.
 *
 * @param authorityUri
 * @param networkClient
 * @param protocolMode
 * @internal
 */ async function $ef8a264971d8166d$export$ab9db5e7e572e7da(authorityUri, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient) {
    performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, correlationId);
    const authorityUriFinal = (0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c).transformCIAMAuthority((0, $77bb430f4568f6e8$export$4030f3538167cb9e)(authorityUri));
    // Initialize authority and perform discovery endpoint check.
    const acquireTokenAuthority = new (0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c)(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient);
    try {
        await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(acquireTokenAuthority.resolveEndpointsAsync.bind(acquireTokenAuthority), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, logger, performanceClient, correlationId)();
        return acquireTokenAuthority;
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base application class which will construct requests to send to and handle responses from the Microsoft STS using the authorization code flow.
 * @internal
 */ class $3b13384e79a725db$export$4f22f74eddb7716a {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = (0, $d21eb39178ebb5ae$export$57a091701dcdabb2)(configuration);
        // Initialize the logger
        this.logger = new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(this.config.loggerOptions, (0, $4c1e49235f95193e$export$a8ff84c12d48cfa6), (0, $4c1e49235f95193e$export$83d89fbfd8236492));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Creates default headers for requests to token endpoint
     */ createTokenRequestHeaders(ccsCred) {
        const headers = {};
        headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).CONTENT_TYPE] = (0, $7c375ae106b964be$export$a002182e51710d39).URL_FORM_CONTENT_TYPE;
        if (!this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(ccsCred.credential);
                    headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER] = `Oid:${clientInfo.uid}@${clientInfo.utid}`;
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN:
                headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER] = `UPN: ${ccsCred.credential}`;
                break;
        }
        return headers;
    }
    /**
     * Http post to token endpoint
     * @param tokenEndpoint
     * @param queryString
     * @param headers
     * @param thumbprint
     */ async executePostToTokenEndpoint(tokenEndpoint, queryString, headers, thumbprint, correlationId, queuedEvent) {
        if (queuedEvent) this.performanceClient?.addQueueMeasurement(queuedEvent, correlationId);
        const response = await this.sendPostRequest(thumbprint, tokenEndpoint, {
            body: queryString,
            headers: headers
        }, correlationId);
        if (this.config.serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
        this.config.serverTelemetryManager.clearTelemetryCache();
        return response;
    }
    /**
     * Wraps sendPostRequestAsync with necessary preflight and postflight logic
     * @param thumbprint - Request thumbprint for throttling
     * @param tokenEndpoint - Endpoint to make the POST to
     * @param options - Body and Headers to include on the POST request
     * @param correlationId - CorrelationId for telemetry
     */ async sendPostRequest(thumbprint, tokenEndpoint, options, correlationId) {
        (0, $38fc8bee021018e9$export$c060a619741dd765).preProcess(this.cacheManager, thumbprint, correlationId);
        let response;
        try {
            response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.networkClient.sendPostRequestAsync.bind(this.networkClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).NetworkClientSendPostRequestAsync, this.logger, this.performanceClient, correlationId)(tokenEndpoint, options);
            const responseHeaders = response.headers || {};
            this.performanceClient?.addFields({
                refreshTokenSize: response.body.refresh_token?.length || 0,
                httpVerToken: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                requestId: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID] || ""
            }, correlationId);
        } catch (e) {
            if (e instanceof (0, $01c2dbbf2115e471$export$bae979e68e4dc802)) {
                const responseHeaders = e.responseHeaders;
                if (responseHeaders) this.performanceClient?.addFields({
                    httpVerToken: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                    requestId: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID] || "",
                    contentTypeHeader: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).CONTENT_TYPE] || undefined,
                    contentLengthHeader: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).CONTENT_LENGTH] || undefined,
                    httpStatus: e.httpStatus
                }, correlationId);
                throw e.error;
            }
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) throw e;
            else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$4358cbadf08aa73));
        }
        (0, $38fc8bee021018e9$export$c060a619741dd765).postProcess(this.cacheManager, thumbprint, response, correlationId);
        return response;
    }
    /**
     * Updates the authority object of the client. Endpoint discovery must be completed.
     * @param updatedAuthority
     */ async updateAuthority(cloudInstanceHostname, correlationId) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, correlationId);
        const cloudInstanceAuthorityUri = `https://${cloudInstanceHostname}/${this.authority.tenant}/`;
        const cloudInstanceAuthority = await (0, $ef8a264971d8166d$export$ab9db5e7e572e7da)(cloudInstanceAuthorityUri, this.networkClient, this.cacheManager, this.authority.options, this.logger, correlationId, this.performanceClient);
        this.authority = cloudInstanceAuthority;
    }
    /**
     * Creates query string for the /token request
     * @param request
     */ createTokenQueryParameters(request) {
        const parameterBuilder = new (0, $7d3a00eb36d325b3$export$882078dd8a9e0bfa)(request.correlationId, this.performanceClient);
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        if (request.tokenQueryParameters) parameterBuilder.addExtraQueryParameters(request.tokenQueryParameters);
        parameterBuilder.addCorrelationId(request.correlationId);
        return parameterBuilder.createQueryString();
    }
}






/*! @azure/msal-common v14.16.1 2025-08-05 */ 






/*! @azure/msal-common v14.16.1 2025-08-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $942a44945e07e21d$var$KeyLocation = {
    SW: "sw",
    UHW: "uhw"
};
/** @internal */ class $942a44945e07e21d$export$3dd8467151c83e3e {
    constructor(cryptoUtils, performanceClient){
        this.cryptoUtils = cryptoUtils;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ async generateCnf(request, logger) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
        const reqCnf = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.generateKid.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, logger, this.performanceClient, request.correlationId)(request);
        const reqCnfString = this.cryptoUtils.base64UrlEncode(JSON.stringify(reqCnf));
        return {
            kid: reqCnf.kid,
            reqCnfString: reqCnfString
        };
    }
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ async generateKid(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateKid, request.correlationId);
        const kidThumbprint = await this.cryptoUtils.getPublicKeyThumbprint(request);
        return {
            kid: kidThumbprint,
            xms_ksl: $942a44945e07e21d$var$KeyLocation.SW
        };
    }
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ async signPopToken(accessToken, keyId, request) {
        return this.signPayload(accessToken, keyId, request);
    }
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ async signPayload(payload, keyId, request, claims) {
        // Deconstruct request to extract SHR parameters
        const { resourceRequestMethod: resourceRequestMethod, resourceRequestUri: resourceRequestUri, shrClaims: shrClaims, shrNonce: shrNonce, shrOptions: shrOptions } = request;
        const resourceUrlString = resourceRequestUri ? new (0, $f7f911f196324278$export$3abcdca7229e54f2)(resourceRequestUri) : undefined;
        const resourceUrlComponents = resourceUrlString?.getUrlComponents();
        return this.cryptoUtils.signJwt({
            at: payload,
            ts: (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)(),
            m: resourceRequestMethod?.toUpperCase(),
            u: resourceUrlComponents?.HostNameAndPort,
            nonce: shrNonce || this.cryptoUtils.createNewGuid(),
            p: resourceUrlComponents?.AbsolutePath,
            q: resourceUrlComponents?.QueryString ? [
                [],
                resourceUrlComponents.QueryString
            ] : undefined,
            client_claims: shrClaims || undefined,
            ...claims
        }, keyId, shrOptions, request.correlationId);
    }
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ class $a01edd09af59ca7b$export$500ab620f6bcc747 {
    constructor(tokenCache, hasChanged){
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    /**
     * boolean which indicates the changes in cache
     */ get cacheHasChanged() {
        return this.hasChanged;
    }
    /**
     * function to retrieve the token cache
     */ get tokenCache() {
        return this.cache;
    }
}








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $4039fad97bcf28f6$var$parseServerErrorNo(serverResponse) {
    const errorCodePrefix = "code=";
    const errorCodePrefixIndex = serverResponse.error_uri?.lastIndexOf(errorCodePrefix);
    return errorCodePrefixIndex && errorCodePrefixIndex >= 0 ? serverResponse.error_uri?.substring(errorCodePrefixIndex + errorCodePrefix.length) : undefined;
}
/**
 * Class that handles response parsing.
 * @internal
 */ class $4039fad97bcf28f6$export$f456c9835cc63582 {
    constructor(clientId, cacheStorage, cryptoObj, logger, serializableCache, persistencePlugin, performanceClient){
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
        this.performanceClient = performanceClient;
    }
    /**
     * Function which validates server authorization code response.
     * @param serverResponseHash
     * @param requestState
     * @param cryptoObj
     */ validateServerAuthorizationCodeResponse(serverResponse, requestState) {
        if (!serverResponse.state || !requestState) throw serverResponse.state ? (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ef9214cfa5960fc), "Cached State") : (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ef9214cfa5960fc), "Server State");
        let decodedServerResponseState;
        let decodedRequestState;
        try {
            decodedServerResponseState = decodeURIComponent(serverResponse.state);
        } catch (e) {
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b), serverResponse.state);
        }
        try {
            decodedRequestState = decodeURIComponent(requestState);
        } catch (e) {
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b), serverResponse.state);
        }
        if (decodedServerResponseState !== decodedRequestState) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$6a56d8f882843cd8));
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const serverErrorNo = $4039fad97bcf28f6$var$parseServerErrorNo(serverResponse);
            if ((0, $18a94acc3dad87ad$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.correlation_id || "", serverResponse.claims || "", serverErrorNo);
            throw new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverErrorNo);
        }
    }
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     * @param refreshAccessToken
     */ validateTokenResponse(serverResponse, refreshAccessToken) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const errString = `Error(s): ${serverResponse.error_codes || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Timestamp: ${serverResponse.timestamp || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Description: ${serverResponse.error_description || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Correlation ID: ${serverResponse.correlation_id || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Trace ID: ${serverResponse.trace_id || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE}`;
            const serverErrorNo = serverResponse.error_codes?.length ? serverResponse.error_codes[0] : undefined;
            const serverError = new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(serverResponse.error, errString, serverResponse.suberror, serverErrorNo, serverResponse.status);
            // check if 500 error
            if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $7c375ae106b964be$export$2b71909294c66558).SERVER_ERROR_RANGE_START && serverResponse.status <= (0, $7c375ae106b964be$export$2b71909294c66558).SERVER_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently unavailable and the access token is unable to be refreshed.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            // check if 400 error
            } else if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $7c375ae106b964be$export$2b71909294c66558).CLIENT_ERROR_RANGE_START && serverResponse.status <= (0, $7c375ae106b964be$export$2b71909294c66558).CLIENT_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently available but is unable to refresh the access token.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            }
            if ((0, $18a94acc3dad87ad$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(serverResponse.error, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverResponse.trace_id || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverResponse.correlation_id || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverResponse.claims || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverErrorNo);
            throw serverError;
        }
    }
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ async handleServerTokenResponse(serverTokenResponse, authority, reqTimestamp, request, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleServerTokenResponse, serverTokenResponse.correlation_id);
        // create an idToken object (not entity)
        let idTokenClaims;
        if (serverTokenResponse.id_token) {
            idTokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(serverTokenResponse.id_token || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, this.cryptoObj.base64Decode);
            // token nonce check (TODO: Add a warning if no nonce is given?)
            if (authCodePayload && authCodePayload.nonce) {
                if (idTokenClaims.nonce !== authCodePayload.nonce) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$edd0491c2c280be7));
            }
            // token max_age check
            if (request.maxAge || request.maxAge === 0) {
                const authTime = idTokenClaims.auth_time;
                if (!authTime) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$43356944266c945e));
                (0, $b29e27fb146a7ddd$export$ee7a34ea7880144c)(authTime, request.maxAge);
            }
        }
        // generate homeAccountId
        this.homeAccountIdentifier = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateHomeAccountId(serverTokenResponse.client_info || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        // save the response tokens
        let requestStateObj;
        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(this.cryptoObj, authCodePayload.state);
        // Add keyId from request to serverTokenResponse if defined
        serverTokenResponse.key_id = serverTokenResponse.key_id || request.sshKid || undefined;
        const cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload);
        let cacheContext;
        try {
            if (this.persistencePlugin && this.serializableCache) {
                this.logger.verbose("Persistence enabled, calling beforeCacheAccess");
                cacheContext = new (0, $a01edd09af59ca7b$export$500ab620f6bcc747)(this.serializableCache, true);
                await this.persistencePlugin.beforeCacheAccess(cacheContext);
            }
            /*
             * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
             * If not present, we should return null, as it's the case that another application called removeAccount in between
             * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
             * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
             */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                const key = cacheRecord.account.generateAccountKey();
                const account = this.cacheStorage.getAccount(key, request.correlationId, this.logger);
                if (!account) {
                    this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache");
                    return await $4039fad97bcf28f6$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, undefined, serverRequestId);
                }
            }
            await this.cacheStorage.saveCacheRecord(cacheRecord, request.correlationId, request.storeInCache);
        } finally{
            if (this.persistencePlugin && this.serializableCache && cacheContext) {
                this.logger.verbose("Persistence enabled, calling afterCacheAccess");
                await this.persistencePlugin.afterCacheAccess(cacheContext);
            }
        }
        return $4039fad97bcf28f6$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, serverTokenResponse, serverRequestId);
    }
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload) {
        const env = authority.getPreferredCache();
        if (!env) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$dedc648643245fa1));
        const claimsTenantId = (0, $da8f9f8eb56c5a02$export$8e1decb9a5e2932)(idTokenClaims);
        // IdToken: non AAD scenarios can have empty realm
        let cachedIdToken;
        let cachedAccount;
        if (serverTokenResponse.id_token && !!idTokenClaims) {
            cachedIdToken = (0, $9ab3d26df56b176d$export$d8a173a23f325769)(this.homeAccountIdentifier, env, serverTokenResponse.id_token, this.clientId, claimsTenantId || "");
            cachedAccount = $4039fad97bcf28f6$export$73b84062d58a1307(this.cacheStorage, authority, this.homeAccountIdentifier, this.cryptoObj.base64Decode, request.correlationId, idTokenClaims, serverTokenResponse.client_info, env, claimsTenantId, authCodePayload, undefined, this.logger);
        }
        // AccessToken
        let cachedAccessToken = null;
        if (serverTokenResponse.access_token) {
            // If scopes not returned in server response, use request scopes
            const responseScopes = serverTokenResponse.scope ? (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(serverTokenResponse.scope) : new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(request.scopes || []);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ const expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            const extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            const refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            const tokenExpirationSeconds = reqTimestamp + expiresIn;
            const extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            const refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = (0, $9ab3d26df56b176d$export$fa005e75d915b6db)(this.homeAccountIdentifier, env, serverTokenResponse.access_token, this.clientId, claimsTenantId || authority.tenant || "", responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj.base64Decode, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, request.claims, request.requestedClaimsHash);
        }
        // refreshToken
        let cachedRefreshToken = null;
        if (serverTokenResponse.refresh_token) {
            let rtExpiresOn;
            if (serverTokenResponse.refresh_token_expires_in) {
                const rtExpiresIn = typeof serverTokenResponse.refresh_token_expires_in === "string" ? parseInt(serverTokenResponse.refresh_token_expires_in, 10) : serverTokenResponse.refresh_token_expires_in;
                rtExpiresOn = reqTimestamp + rtExpiresIn;
            }
            cachedRefreshToken = (0, $9ab3d26df56b176d$export$9095b5885dfa55cc)(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token, this.clientId, serverTokenResponse.foci, userAssertionHash, rtExpiresOn);
        }
        // appMetadata
        let cachedAppMetadata = null;
        if (serverTokenResponse.foci) cachedAppMetadata = {
            clientId: this.clientId,
            environment: env,
            familyId: serverTokenResponse.foci
        };
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    }
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ static async generateAuthenticationResult(cryptoObj, authority, cacheRecord, fromTokenCache, request, idTokenClaims, requestState, serverTokenResponse, requestId) {
        let accessToken = (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        let refreshOn;
        let familyId = (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        if (cacheRecord.accessToken) {
            /*
             * if the request object has `popKid` property, `signPopToken` will be set to false and
             * the token will be returned unsigned
             */ if (cacheRecord.accessToken.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP && !request.popKid) {
                const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(cryptoObj);
                const { secret: secret, keyId: keyId } = cacheRecord.accessToken;
                if (!keyId) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$3c9338a50e294d1));
                accessToken = await popTokenGenerator.signPopToken(secret, keyId, request);
            } else accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
            extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
            if (cacheRecord.accessToken.refreshOn) refreshOn = new Date(Number(cacheRecord.accessToken.refreshOn) * 1000);
        }
        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === (0, $7c375ae106b964be$export$978fe7ab5e74b539) ? (0, $7c375ae106b964be$export$978fe7ab5e74b539) : "";
        const uid = idTokenClaims?.oid || idTokenClaims?.sub || "";
        const tid = idTokenClaims?.tid || "";
        // for hybrid + native bridge enablement, send back the native account Id
        if (serverTokenResponse?.spa_accountid && !!cacheRecord.account) cacheRecord.account.nativeAccountId = serverTokenResponse?.spa_accountid;
        const accountInfo = cacheRecord.account ? (0, $54830df9a5d9a12c$export$452a054c78b83dad)(cacheRecord.account.getAccountInfo(), undefined, idTokenClaims, cacheRecord.idToken?.secret) : null;
        return {
            authority: authority.canonicalAuthority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: accountInfo,
            idToken: cacheRecord?.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: fromTokenCache,
            expiresOn: expiresOn,
            extExpiresOn: extExpiresOn,
            refreshOn: refreshOn,
            correlationId: request.correlationId,
            requestId: requestId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            familyId: familyId,
            tokenType: cacheRecord.accessToken?.tokenType || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            state: requestState ? requestState.userRequestState : (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            cloudGraphHostName: cacheRecord.account?.cloudGraphHostName || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            msGraphHost: cacheRecord.account?.msGraphHost || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            code: serverTokenResponse?.spa_code,
            fromNativeBroker: false
        };
    }
}
function $4039fad97bcf28f6$export$73b84062d58a1307(cacheStorage, authority, homeAccountId, base64Decode, correlationId, idTokenClaims, clientInfo, environment, claimsTenantId, authCodePayload, nativeAccountId, logger) {
    logger?.verbose("setCachedAccount called");
    // Check if base account is already cached
    const accountKeys = cacheStorage.getAccountKeys();
    const baseAccountKey = accountKeys.find((accountKey)=>{
        return accountKey.startsWith(homeAccountId);
    });
    let cachedAccount = null;
    if (baseAccountKey) cachedAccount = cacheStorage.getAccount(baseAccountKey, correlationId, logger);
    const baseAccount = cachedAccount || (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createAccount({
        homeAccountId: homeAccountId,
        idTokenClaims: idTokenClaims,
        clientInfo: clientInfo,
        environment: environment,
        cloudGraphHostName: authCodePayload?.cloud_graph_host_name,
        msGraphHost: authCodePayload?.msgraph_host,
        nativeAccountId: nativeAccountId
    }, authority, base64Decode);
    const tenantProfiles = baseAccount.tenantProfiles || [];
    const tenantId = claimsTenantId || baseAccount.realm;
    if (tenantId && !tenantProfiles.find((tenantProfile)=>{
        return tenantProfile.tenantId === tenantId;
    })) {
        const newTenantProfile = (0, $54830df9a5d9a12c$export$924857724cb21ba4)(homeAccountId, baseAccount.localAccountId, tenantId, idTokenClaims);
        tenantProfiles.push(newTenantProfile);
    }
    baseAccount.tenantProfiles = tenantProfiles;
    return baseAccount;
}













/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $e4969f34ccbe14ce$export$620d3a93bf8b59fb(clientAssertion, clientId, tokenEndpoint) {
    if (typeof clientAssertion === "string") return clientAssertion;
    else {
        const config = {
            clientId: clientId,
            tokenEndpoint: tokenEndpoint
        };
        return clientAssertion(config);
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 * @internal
 */ class $7e4376d17ecbf639$export$8538731fd397fb90 extends (0, $3b13384e79a725db$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
        // Flag to indicate if client is for hybrid spa auth code redemption
        this.includeRedirectUri = true;
        this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
    }
    /**
     * Creates the URL of the authorization request letting the user input credentials and consent to the
     * application. The URL target the /authorize endpoint of the authority configured in the
     * application object.
     *
     * Once the user inputs their credentials and consents, the authority will send a response to the redirect URI
     * sent in the request and should contain an authorization code, which can then be used to acquire tokens via
     * acquireToken(AuthorizationCodeRequest)
     * @param request
     */ async getAuthCodeUrl(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetAuthCodeUrl, request.correlationId);
        const queryString = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeUrlQueryString.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientCreateQueryString, this.logger, this.performanceClient, request.correlationId)(request);
        return (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(this.authority.authorizationEndpoint, queryString);
    }
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */ async acquireToken(request, authCodePayload) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientAcquireToken, request.correlationId);
        if (!request.code) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$4ac9fb1f531eded7));
        const reqTimestamp = (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)();
        const response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(this.authority, request);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $4039fad97bcf28f6$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin, this.performanceClient);
        // Validate response. This function throws a server error if an error is returned by the server.
        responseHandler.validateTokenResponse(response.body);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, authCodePayload, undefined, undefined, undefined, requestId);
    }
    /**
     * Handles the hash fragment response from public client code request. Returns a code response used by
     * the client to exchange for a token in acquireToken.
     * @param hashFragment
     */ handleFragmentResponse(serverParams, cachedState) {
        // Handle responses.
        const responseHandler = new (0, $4039fad97bcf28f6$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, null, null);
        // Get code response
        responseHandler.validateServerAuthorizationCodeResponse(serverParams, cachedState);
        // throw when there is no auth code in the response
        if (!serverParams.code) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$93625fc864d26bba));
        return serverParams;
    }
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ getLogoutUri(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$9eb2eeb401492d88));
        const queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(this.authority.endSessionEndpoint, queryString);
    }
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ async executeTokenRequest(authority, request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        let ccsCredential = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCredential = {
                credential: `${clientInfo.uid}${(0, $7c375ae106b964be$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        const headers = this.createTokenRequestHeaders(ccsCredential || request.ccsCredential);
        const thumbprint = {
            clientId: request.tokenBodyParameters?.clientId || this.config.authOptions.clientId,
            authority: authority.canonicalAuthority,
            scopes: request.scopes,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint);
    }
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, request.correlationId);
        const parameterBuilder = new (0, $7d3a00eb36d325b3$export$882078dd8a9e0bfa)(request.correlationId, this.performanceClient);
        parameterBuilder.addClientId(request.embeddedClientId || request.tokenBodyParameters?.[0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        /*
         * For hybrid spa flow, there will be a code but no verifier
         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
         */ if (!this.includeRedirectUri) // Just validate
        (0, $5a78012ce109fb77$export$9800b929b6984365).validateRedirectUri(request.redirectUri);
        else // Validate and include redirect uri
        parameterBuilder.addRedirectUri(request.redirectUri);
        // Add scope array, parameter builder will add default scopes and dedupe
        parameterBuilder.addScopes(request.scopes, true, this.oidcDefaultScopes);
        // add code: user set, not validated
        parameterBuilder.addAuthorizationCode(request.code);
        // Add library metadata
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        parameterBuilder.addThrottling();
        if (this.serverTelemetryManager && !(0, $d21eb39178ebb5ae$export$25afa7198c2ed9b9)(this.config)) parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
        // add code_verifier if passed
        if (request.codeVerifier) parameterBuilder.addCodeVerifier(request.codeVerifier);
        if (this.config.clientCredentials.clientSecret) parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            parameterBuilder.addClientAssertion(await (0, $e4969f34ccbe14ce$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
        }
        parameterBuilder.addGrantType((0, $7c375ae106b964be$export$ce68f19b50b39c0b).AUTHORIZATION_CODE_GRANT);
        parameterBuilder.addClientInfo();
        if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            parameterBuilder.addPopToken(reqCnfData);
        } else if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) parameterBuilder.addSshJwk(request.sshJwk);
            else throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$8fbed44b22d9136f));
        }
        if (!(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        let ccsCred = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCred = {
                credential: `${clientInfo.uid}${(0, $7c375ae106b964be$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        else ccsCred = request.ccsCredential;
        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(ccsCred.credential);
                    parameterBuilder.addCcsOid(clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN:
                parameterBuilder.addCcsUpn(ccsCred.credential);
                break;
        }
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        if (request.tokenBodyParameters) parameterBuilder.addExtraQueryParameters(request.tokenBodyParameters);
        // Add hybrid spa parameters if not already provided
        if (request.enableSpaAuthorizationCode && (!request.tokenBodyParameters || !request.tokenBodyParameters[0, $b00a7f221d8fdf60$export$f58b98a40c1faa68])) parameterBuilder.addExtraQueryParameters({
            [(0, $b00a7f221d8fdf60$export$f58b98a40c1faa68)]: "1"
        });
        return parameterBuilder.createQueryString();
    }
    /**
     * This API validates the `AuthorizationCodeUrlRequest` and creates a URL
     * @param request
     */ async createAuthCodeUrlQueryString(request) {
        // generate the correlationId if not set by the user and add
        const correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientCreateQueryString, correlationId);
        const parameterBuilder = new (0, $7d3a00eb36d325b3$export$882078dd8a9e0bfa)(correlationId, this.performanceClient);
        parameterBuilder.addClientId(request.embeddedClientId || request.extraQueryParameters?.[0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        const requestScopes = [
            ...request.scopes || [],
            ...request.extraScopesToConsent || []
        ];
        parameterBuilder.addScopes(requestScopes, true, this.oidcDefaultScopes);
        // validate the redirectUri (to be a non null value)
        parameterBuilder.addRedirectUri(request.redirectUri);
        parameterBuilder.addCorrelationId(correlationId);
        // add response_mode. If not passed in it defaults to query.
        parameterBuilder.addResponseMode(request.responseMode);
        // add response_type = code
        parameterBuilder.addResponseTypeCode();
        // add library info parameters
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        if (!(0, $d21eb39178ebb5ae$export$25afa7198c2ed9b9)(this.config)) parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        // add client_info=1
        parameterBuilder.addClientInfo();
        if (request.codeChallenge && request.codeChallengeMethod) parameterBuilder.addCodeChallengeParams(request.codeChallenge, request.codeChallengeMethod);
        if (request.prompt) parameterBuilder.addPrompt(request.prompt);
        if (request.domainHint) parameterBuilder.addDomainHint(request.domainHint);
        // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
        if (request.prompt !== (0, $7c375ae106b964be$export$49a06cbda5acaa5).SELECT_ACCOUNT) {
            // AAD will throw if prompt=select_account is passed with an account hint
            if (request.sid && request.prompt === (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE) {
                // SessionID is only used in silent calls
                this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request");
                parameterBuilder.addSid(request.sid);
            } else if (request.account) {
                const accountSid = this.extractAccountSid(request.account);
                let accountLoginHintClaim = this.extractLoginHint(request.account);
                if (accountLoginHintClaim && request.domainHint) {
                    this.logger.warning(`AuthorizationCodeClient.createAuthCodeUrlQueryString: "domainHint" param is set, skipping opaque "login_hint" claim. Please consider not passing domainHint`);
                    accountLoginHintClaim = null;
                }
                // If login_hint claim is present, use it over sid/username
                if (accountLoginHintClaim) {
                    this.logger.verbose("createAuthCodeUrlQueryString: login_hint claim present on account");
                    parameterBuilder.addLoginHint(accountLoginHintClaim);
                    try {
                        const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                        parameterBuilder.addCcsOid(clientInfo);
                    } catch (e) {
                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                } else if (accountSid && request.prompt === (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE) {
                    /*
                     * If account and loginHint are provided, we will check account first for sid before adding loginHint
                     * SessionId is only used in silent calls
                     */ this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account");
                    parameterBuilder.addSid(accountSid);
                    try {
                        const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                        parameterBuilder.addCcsOid(clientInfo);
                    } catch (e) {
                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                } else if (request.loginHint) {
                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request");
                    parameterBuilder.addLoginHint(request.loginHint);
                    parameterBuilder.addCcsUpn(request.loginHint);
                } else if (request.account.username) {
                    // Fallback to account username if provided
                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account");
                    parameterBuilder.addLoginHint(request.account.username);
                    try {
                        const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                        parameterBuilder.addCcsOid(clientInfo);
                    } catch (e) {
                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                }
            } else if (request.loginHint) {
                this.logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request");
                parameterBuilder.addLoginHint(request.loginHint);
                parameterBuilder.addCcsUpn(request.loginHint);
            }
        } else this.logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints");
        if (request.nonce) parameterBuilder.addNonce(request.nonce);
        if (request.state) parameterBuilder.addState(request.state);
        if (request.claims || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        this.addExtraQueryParams(request, parameterBuilder);
        if (request.nativeBroker) {
            // signal ests that this is a WAM call
            parameterBuilder.addNativeBroker();
            // pass the req_cnf for POP
            if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
                const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.cryptoUtils);
                // req_cnf is always sent as a string for SPAs
                let reqCnfData;
                if (!request.popKid) {
                    const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                    reqCnfData = generatedReqCnfData.reqCnfString;
                } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
                parameterBuilder.addPopToken(reqCnfData);
            }
        }
        return parameterBuilder.createQueryString();
    }
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ createLogoutUrlQueryString(request) {
        const parameterBuilder = new (0, $7d3a00eb36d325b3$export$882078dd8a9e0bfa)(request.correlationId, this.performanceClient);
        if (request.postLogoutRedirectUri) parameterBuilder.addPostLogoutRedirectUri(request.postLogoutRedirectUri);
        if (request.correlationId) parameterBuilder.addCorrelationId(request.correlationId);
        if (request.idTokenHint) parameterBuilder.addIdTokenHint(request.idTokenHint);
        if (request.state) parameterBuilder.addState(request.state);
        if (request.logoutHint) parameterBuilder.addLogoutHint(request.logoutHint);
        this.addExtraQueryParams(request, parameterBuilder);
        return parameterBuilder.createQueryString();
    }
    addExtraQueryParams(request, parameterBuilder) {
        const hasRequestInstanceAware = request.extraQueryParameters && request.extraQueryParameters.hasOwnProperty("instance_aware");
        // Set instance_aware flag if config auth param is set
        if (!hasRequestInstanceAware && this.config.authOptions.instanceAware) {
            request.extraQueryParameters = request.extraQueryParameters || {};
            request.extraQueryParameters["instance_aware"] = "true";
        }
        if (request.extraQueryParameters) parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
    }
    /**
     * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
     * @param account
     */ extractAccountSid(account) {
        return account.idTokenClaims?.sid || null;
    }
    extractLoginHint(account) {
        return account.idTokenClaims?.login_hint || null;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9c3cb45936be6b04$var$skuGroupSeparator = ",";
const $9c3cb45936be6b04$var$skuValueSeparator = "|";
function $9c3cb45936be6b04$var$makeExtraSkuString(params) {
    const { skus: skus, libraryName: libraryName, libraryVersion: libraryVersion, extensionName: extensionName, extensionVersion: extensionVersion } = params;
    const skuMap = new Map([
        [
            0,
            [
                libraryName,
                libraryVersion
            ]
        ],
        [
            2,
            [
                extensionName,
                extensionVersion
            ]
        ]
    ]);
    let skuArr = [];
    if (skus?.length) {
        skuArr = skus.split($9c3cb45936be6b04$var$skuGroupSeparator);
        // Ignore invalid input sku param
        if (skuArr.length < 4) return skus;
    } else skuArr = Array.from({
        length: 4
    }, ()=>$9c3cb45936be6b04$var$skuValueSeparator);
    skuMap.forEach((value, key)=>{
        if (value.length === 2 && value[0]?.length && value[1]?.length) $9c3cb45936be6b04$var$setSku({
            skuArr: skuArr,
            index: key,
            skuName: value[0],
            skuVersion: value[1]
        });
    });
    return skuArr.join($9c3cb45936be6b04$var$skuGroupSeparator);
}
function $9c3cb45936be6b04$var$setSku(params) {
    const { skuArr: skuArr, index: index, skuName: skuName, skuVersion: skuVersion } = params;
    if (index >= skuArr.length) return;
    skuArr[index] = [
        skuName,
        skuVersion
    ].join($9c3cb45936be6b04$var$skuValueSeparator);
}
/** @internal */ class $9c3cb45936be6b04$export$bddbbc43a3ca9c53 {
    constructor(telemetryRequest, cacheManager){
        this.cacheOutcome = (0, $7c375ae106b964be$export$aa4af185ea049f6b).NOT_APPLICABLE;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.wrapperVer = telemetryRequest.wrapperVer || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.telemetryCacheKey = (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CACHE_KEY + (0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ generateCurrentRequestHeaderValue() {
        const request = `${this.apiId}${(0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR}${this.cacheOutcome}`;
        const platformFieldsArr = [
            this.wrapperSKU,
            this.wrapperVer
        ];
        const nativeBrokerErrorCode = this.getNativeBrokerErrorCode();
        if (nativeBrokerErrorCode?.length) platformFieldsArr.push(`broker_error=${nativeBrokerErrorCode}`);
        const platformFields = platformFieldsArr.join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const regionDiscoveryFields = this.getRegionDiscoveryFields();
        const requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            requestWithRegionDiscoveryFields,
            platformFields
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to add MSER Telemetry for the last failed request
     */ generateLastRequestHeaderValue() {
        const lastRequests = this.getLastRequests();
        const maxErrors = $9c3cb45936be6b04$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errors = lastRequests.errors.slice(0, maxErrors).join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        const overflow = maxErrors < errorCount ? (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).OVERFLOW_TRUE : (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).OVERFLOW_FALSE;
        const platformFields = [
            errorCount,
            overflow
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ cacheFailedRequest(error) {
        const lastRequests = this.getLastRequests();
        if (lastRequests.errors.length >= (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).MAX_CACHED_ERRORS) {
            // Remove a cached error to make room, first in first out
            lastRequests.failedRequests.shift(); // apiId
            lastRequests.failedRequests.shift(); // correlationId
            lastRequests.errors.shift();
        }
        lastRequests.failedRequests.push(this.apiId, this.correlationId);
        if (error instanceof Error && !!error && error.toString()) {
            if (error instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                if (error.subError) lastRequests.errors.push(error.subError);
                else if (error.errorCode) lastRequests.errors.push(error.errorCode);
                else lastRequests.errors.push(error.toString());
            } else lastRequests.errors.push(error.toString());
        } else lastRequests.errors.push((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).UNKNOWN_ERROR);
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return;
    }
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ incrementCacheHits() {
        const lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return lastRequests.cacheHits;
    }
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ getLastRequests() {
        const initialValue = {
            failedRequests: [],
            errors: [],
            cacheHits: 0
        };
        const lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
        return lastRequests || initialValue;
    }
    /**
     * Remove server telemetry cache entry
     */ clearTelemetryCache() {
        const lastRequests = this.getLastRequests();
        const numErrorsFlushed = $9c3cb45936be6b04$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey, this.correlationId);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            const serverTelemEntity = {
                failedRequests: lastRequests.failedRequests.slice(numErrorsFlushed * 2),
                errors: lastRequests.errors.slice(numErrorsFlushed),
                cacheHits: 0
            };
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity, this.correlationId);
        }
    }
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ static maxErrorsToSend(serverTelemetryEntity) {
        let i;
        let maxErrors = 0;
        let dataSize = 0;
        const errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            const apiId = serverTelemetryEntity.failedRequests[2 * i] || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const errorCode = serverTelemetryEntity.errors[i] || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).MAX_LAST_HEADER_BYTES) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    }
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ getRegionDiscoveryFields() {
        const regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionSource || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionOutcome || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING);
        return regionDiscoveryFields.join(",");
    }
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ updateRegionDiscoveryMetadata(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    }
    /**
     * Set cache outcome
     */ setCacheOutcome(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    }
    setNativeBrokerErrorCode(errorCode) {
        const lastRequests = this.getLastRequests();
        lastRequests.nativeBrokerErrorCode = errorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    getNativeBrokerErrorCode() {
        return this.getLastRequests().nativeBrokerErrorCode;
    }
    clearNativeBrokerErrorCode() {
        const lastRequests = this.getLastRequests();
        delete lastRequests.nativeBrokerErrorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    static makeExtraSkuString(params) {
        return $9c3cb45936be6b04$var$makeExtraSkuString(params);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $cf81b85efeb3dcd5$export$d858565f81c03f1f {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId){
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.nativeMessageHandler = nativeMessageHandler;
        this.correlationId = correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        this.logger = logger.clone((0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU, (0, $183cce12cb16965c$export$83d89fbfd8236492), this.correlationId);
        this.performanceClient = performanceClient;
    }
    async clearCacheOnLogout(account) {
        if (account) {
            if ((0, $d6acc4a6126921e0$export$680160523e6bfa6a).accountInfoIsEqual(account, this.browserStorage.getActiveAccount(this.correlationId), false)) {
                this.logger.verbose("Setting active account to null");
                this.browserStorage.setActiveAccount(null, this.correlationId);
            }
            // Clear given account.
            try {
                await this.browserStorage.removeAccount((0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateAccountCacheKey(account), this.correlationId);
                this.logger.verbose("Cleared cache items belonging to the account provided in the logout request.");
            } catch (error) {
                this.logger.error("Account provided in logout request was not found. Local cache unchanged.");
            }
        } else try {
            this.logger.verbose("No account provided in logout request, clearing all cache items.", this.correlationId);
            // Clear all accounts and tokens
            await this.browserStorage.clear(this.correlationId);
            // Clear any stray keys from IndexedDB
            await this.browserCrypto.clearKeystore();
        } catch (e) {
            this.logger.error("Attempted to clear all MSAL cache items and failed. Local cache unchanged.");
        }
    }
    /**
     *
     * Use to get the redirect uri configured in MSAL or null.
     * @param requestRedirectUri
     * @returns Redirect URL
     *
     */ getRedirectUri(requestRedirectUri) {
        this.logger.verbose("getRedirectUri called");
        const redirectUri = requestRedirectUri || this.config.auth.redirectUri;
        return (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(redirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
    }
    /**
     *
     * @param apiId
     * @param correlationId
     * @param forceRefresh
     */ initializeServerTelemetryManager(apiId, forceRefresh) {
        this.logger.verbose("initializeServerTelemetryManager called");
        const telemetryPayload = {
            clientId: this.config.auth.clientId,
            correlationId: this.correlationId,
            apiId: apiId,
            forceRefresh: forceRefresh || false,
            wrapperSKU: this.browserStorage.getWrapperMetadata()[0],
            wrapperVer: this.browserStorage.getWrapperMetadata()[1]
        };
        return new (0, $9c3cb45936be6b04$export$bddbbc43a3ca9c53)(telemetryPayload, this.browserStorage);
    }
    /**
     * Used to get a discovered version of the default authority.
     * @param params {
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async getDiscoveredAuthority(params) {
        const { account: account } = params;
        const instanceAwareEQ = params.requestExtraQueryParameters && params.requestExtraQueryParameters.hasOwnProperty("instance_aware") ? params.requestExtraQueryParameters["instance_aware"] : undefined;
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
        const authorityOptions = {
            protocolMode: this.config.auth.protocolMode,
            OIDCOptions: this.config.auth.OIDCOptions,
            knownAuthorities: this.config.auth.knownAuthorities,
            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
            authorityMetadata: this.config.auth.authorityMetadata,
            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        };
        // build authority string based on auth params, precedence - azureCloudInstance + tenant >> authority
        const resolvedAuthority = params.requestAuthority || this.config.auth.authority;
        const resolvedInstanceAware = instanceAwareEQ?.length ? instanceAwareEQ === "true" : this.config.auth.instanceAware;
        const userAuthority = account && resolvedInstanceAware ? this.config.auth.authority.replace((0, $f7f911f196324278$export$3abcdca7229e54f2).getDomainFromUrl(resolvedAuthority), account.environment) : resolvedAuthority;
        // fall back to the authority from config
        const builtAuthority = (0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c).generateAuthority(userAuthority, params.requestAzureCloudOptions || this.config.auth.azureCloudOptions);
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $ef8a264971d8166d$exports).createDiscoveredInstance, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, this.logger, this.performanceClient, this.correlationId)(builtAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger, this.correlationId, this.performanceClient);
        if (account && !discoveredAuthority.isAlias(account.environment)) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).authorityMismatch);
        return discoveredAuthority;
    }
}





/*! @azure/msal-browser v3.30.0 2025-08-05 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
const $cab7ad26b4a73b7b$var$RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * This file defines APIs to generate PKCE codes and code verifiers.
 */ /**
 * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
 */ async function $cab7ad26b4a73b7b$export$91d5e5a023803853(performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, correlationId);
    const codeVerifier = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)($cab7ad26b4a73b7b$var$generateCodeVerifier, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateCodeVerifier, logger, performanceClient, correlationId)(performanceClient, logger, correlationId);
    const codeChallenge = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($cab7ad26b4a73b7b$var$generateCodeChallengeFromVerifier, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, logger, performanceClient, correlationId)(codeVerifier, performanceClient, logger, correlationId);
    return {
        verifier: codeVerifier,
        challenge: codeChallenge
    };
}
/**
 * Generates a random 32 byte buffer and returns the base64
 * encoded string to be used as a PKCE Code Verifier
 */ function $cab7ad26b4a73b7b$var$generateCodeVerifier(performanceClient, logger, correlationId) {
    try {
        // Generate random values as utf-8
        const buffer = new Uint8Array($cab7ad26b4a73b7b$var$RANDOM_BYTE_ARR_LENGTH);
        (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $4e0948336b4ea4a7$export$960b9ff25e7d4257), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetRandomValues, logger, performanceClient, correlationId)(buffer);
        // encode verifier as base64
        const pkceCodeVerifierB64 = (0, $6f6986007da7f422$export$84f5a428c7153a69)(buffer);
        return pkceCodeVerifierB64;
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$ee549107fa376fc1));
    }
}
/**
 * Creates a base64 encoded PKCE Code Challenge string from the
 * hash created from the PKCE Code Verifier supplied
 */ async function $cab7ad26b4a73b7b$var$generateCodeChallengeFromVerifier(pkceCodeVerifier, performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, correlationId);
    try {
        // hashed verifier
        const pkceHashedCodeVerifier = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$52caff7bddbaf316), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).Sha256Digest, logger, performanceClient, correlationId)(pkceCodeVerifier, performanceClient, correlationId);
        // encode hash as base64
        return (0, $6f6986007da7f422$export$84f5a428c7153a69)(new Uint8Array(pkceHashedCodeVerifier));
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$ee549107fa376fc1));
    }
}



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Initializer function for all request APIs
 * @param request
 */ async function $550ae9dc1dae1add$export$8e461fcf1fd6910b(request, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, request.correlationId);
    const authority = request.authority || config.auth.authority;
    const scopes = [
        ...request && request.scopes || []
    ];
    const validatedRequest = {
        ...request,
        correlationId: request.correlationId,
        authority: authority,
        scopes: scopes
    };
    // Set authenticationScheme to BEARER if not explicitly set in the request
    if (!validatedRequest.authenticationScheme) {
        validatedRequest.authenticationScheme = (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER;
        logger.verbose('Authentication Scheme wasn\'t explicitly set in request, defaulting to "Bearer" request');
    } else {
        if (validatedRequest.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
            if (!request.sshJwk) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).missingSshJwk);
            if (!request.sshKid) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).missingSshKid);
        }
        logger.verbose(`Authentication Scheme set to "${validatedRequest.authenticationScheme}" as configured in Auth request`);
    }
    // Set requested claims hash if claims-based caching is enabled and claims were requested
    if (config.cache.claimsBasedCachingEnabled && request.claims && // Checks for empty stringified object "{}" which doesn't qualify as requested claims
    !(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims)) validatedRequest.requestedClaimsHash = await (0, $4e0948336b4ea4a7$export$9169be2e06c9c165)(request.claims);
    return validatedRequest;
}
async function $550ae9dc1dae1add$export$4c8aa78c426811d4(request, account, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeSilentRequest, request.correlationId);
    const baseRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($550ae9dc1dae1add$export$8e461fcf1fd6910b, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, logger, performanceClient, request.correlationId)(request, config, performanceClient, logger);
    return {
        ...request,
        ...baseRequest,
        account: account,
        forceRefresh: request.forceRefresh || false
    };
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ class $5d00224fcf1f9e62$export$fa9179cade3eb05a extends (0, $cf81b85efeb3dcd5$export$d858565f81c03f1f) {
    /**
     * Generates an auth code request tied to the url request.
     * @param request
     */ async initializeAuthorizationCodeRequest(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.correlationId);
        const generatedPkceParams = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, this.correlationId)(this.performanceClient, this.logger, this.correlationId);
        const authCodeRequest = {
            ...request,
            redirectUri: request.redirectUri,
            code: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            codeVerifier: generatedPkceParams.verifier
        };
        request.codeChallenge = generatedPkceParams.challenge;
        request.codeChallengeMethod = (0, $7c375ae106b964be$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD;
        return authCodeRequest;
    }
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ initializeLogoutRequest(logoutRequest) {
        this.logger.verbose("initializeLogoutRequest called", logoutRequest?.correlationId);
        const validLogoutRequest = {
            correlationId: this.correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            ...logoutRequest
        };
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    const logoutHint = this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("Setting logoutHint to login_hint ID Token Claim value for the account provided");
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("logoutHint was not set and account was not passed into logout request, logoutHint will not be set");
            } else this.logger.verbose("logoutHint has already been set in logoutRequest");
        } else this.logger.verbose("logoutHint will not be set since no logout request was configured");
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to configured uri", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
            } else {
                this.logger.verbose("Setting postLogoutRedirectUri to current page", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl((0, $3003b661a087a867$export$1204531fbbf6ecde)(), (0, $3003b661a087a867$export$1204531fbbf6ecde)());
            }
        } else this.logger.verbose("postLogoutRedirectUri passed as null, not setting post logout redirect uri", validLogoutRequest.correlationId);
        return validLogoutRequest;
    }
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ getLogoutHintFromIdTokenClaims(account) {
        const idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) return idTokenClaims.login_hint;
            else this.logger.verbose("The ID Token Claims tied to the provided account do not contain a login_hint claim, logoutHint will not be added to logout request");
        } else this.logger.verbose("The provided account does not contain ID Token Claims, logoutHint will not be added to logout request");
        return null;
    }
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createAuthCodeClient(params) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.correlationId);
        // Create auth module.
        const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)(params);
        return new (0, $7e4376d17ecbf639$export$8538731fd397fb90)(clientConfig, this.performanceClient);
    }
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: boolean;
     *         account?: AccountInfo;
     *        }
     */ async getClientConfiguration(params) {
        const { serverTelemetryManager: serverTelemetryManager, requestAuthority: requestAuthority, requestAzureCloudOptions: requestAzureCloudOptions, requestExtraQueryParameters: requestExtraQueryParameters, account: account } = params;
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, this.correlationId)({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: requestAzureCloudOptions,
            requestExtraQueryParameters: requestExtraQueryParameters,
            account: account
        });
        const logger = this.config.system.loggerOptions;
        return {
            authOptions: {
                clientId: this.config.auth.clientId,
                authority: discoveredAuthority,
                clientCapabilities: this.config.auth.clientCapabilities,
                redirectUri: this.config.auth.redirectUri
            },
            systemOptions: {
                tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                preventCorsPreflight: true
            },
            loggerOptions: {
                loggerCallback: logger.loggerCallback,
                piiLoggingEnabled: logger.piiLoggingEnabled,
                logLevel: logger.logLevel,
                correlationId: this.correlationId
            },
            cacheOptions: {
                claimsBasedCachingEnabled: this.config.cache.claimsBasedCachingEnabled
            },
            cryptoInterface: this.browserCrypto,
            networkInterface: this.networkClient,
            storageInterface: this.browserStorage,
            serverTelemetryManager: serverTelemetryManager,
            libraryInfo: {
                sku: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU,
                version: (0, $183cce12cb16965c$export$83d89fbfd8236492),
                cpu: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
                os: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
            },
            telemetry: this.config.telemetry
        };
    }
    /**
     * Helper to initialize required request parameters for interactive APIs and ssoSilent()
     * @param request
     * @param interactionType
     */ async initializeAuthorizationRequest(request, interactionType) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.correlationId);
        const redirectUri = this.getRedirectUri(request.redirectUri);
        const browserState = {
            interactionType: interactionType
        };
        const state = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).setRequestState(this.browserCrypto, request && request.state || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, browserState);
        const baseRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $550ae9dc1dae1add$export$8e461fcf1fd6910b), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, this.correlationId)({
            ...request,
            correlationId: this.correlationId
        }, this.config, this.performanceClient, this.logger);
        const validatedRequest = {
            ...baseRequest,
            redirectUri: redirectUri,
            state: state,
            nonce: request.nonce || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            responseMode: this.config.auth.OIDCOptions.serverResponseType
        };
        // Skip active account lookup if either login hint or session id is set
        if (request.loginHint || request.sid) return validatedRequest;
        const account = request.account || this.browserStorage.getActiveAccount(this.correlationId);
        if (account) {
            this.logger.verbose("Setting validated request account", this.correlationId);
            this.logger.verbosePii(`Setting validated request account: ${account.homeAccountId}`, this.correlationId);
            validatedRequest.account = account;
        }
        // Check for ADAL/MSAL v1 SSO
        if (!validatedRequest.loginHint && !account) {
            const legacyLoginHint = this.browserStorage.getLegacyLoginHint();
            if (legacyLoginHint) validatedRequest.loginHint = legacyLoginHint;
        }
        return validatedRequest;
    }
}





/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $ad0863ed8e4325cb$export$fbe5ac8608048ea9 = "ContentError";
const $ad0863ed8e4325cb$export$966ec8558e4d7922 = "user_switch";


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Status Codes that can be thrown by WAM
const $2f685d09a8b3d741$export$e0aac30e542b316c = "USER_INTERACTION_REQUIRED";
const $2f685d09a8b3d741$export$bec5e49cc27c5c10 = "USER_CANCEL";
const $2f685d09a8b3d741$export$3c68b4973c91ba = "NO_NETWORK";
const $2f685d09a8b3d741$export$b17f0b3cc10a2593 = "PERSISTENT_ERROR";
const $2f685d09a8b3d741$export$8cd212c10b4124d2 = "DISABLED";
const $2f685d09a8b3d741$export$f4c2bddc98c93ffc = "ACCOUNT_UNAVAILABLE";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $a5e5dee51df551c2$var$INVALID_METHOD_ERROR = -2147186943;
const $a5e5dee51df551c2$export$9a1233b0d52ed7cd = {
    [(0, $ad0863ed8e4325cb$export$966ec8558e4d7922)]: "User attempted to switch accounts in the native broker, which is not allowed. All new accounts must sign-in through the standard web flow first, please try again."
};
class $a5e5dee51df551c2$export$4b8a4f6256e840ab extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, description, ext){
        super(errorCode, description);
        Object.setPrototypeOf(this, $a5e5dee51df551c2$export$4b8a4f6256e840ab.prototype);
        this.name = "NativeAuthError";
        this.ext = ext;
    }
}
/**
 * These errors should result in a fallback to the 'standard' browser based auth flow.
 */ function $a5e5dee51df551c2$export$f21e42e365baeb50(error) {
    if (error.ext && error.ext.status && (error.ext.status === (0, $2f685d09a8b3d741$export$b17f0b3cc10a2593) || error.ext.status === (0, $2f685d09a8b3d741$export$8cd212c10b4124d2))) return true;
    if (error.ext && error.ext.error && error.ext.error === $a5e5dee51df551c2$var$INVALID_METHOD_ERROR) return true;
    switch(error.errorCode){
        case 0, $ad0863ed8e4325cb$export$fbe5ac8608048ea9:
            return true;
        default:
            return false;
    }
}
/**
 * Create the appropriate error object based on the WAM status code.
 * @param code
 * @param description
 * @param ext
 * @returns
 */ function $a5e5dee51df551c2$export$9154414ec87d187b(code, description, ext) {
    if (ext && ext.status) switch(ext.status){
        case 0, $2f685d09a8b3d741$export$f4c2bddc98c93ffc:
            return (0, $18a94acc3dad87ad$export$8f7a741750c16535)((0, $84767569d86b0bc0$exports).nativeAccountUnavailable);
        case 0, $2f685d09a8b3d741$export$e0aac30e542b316c:
            return new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(code, description);
        case 0, $2f685d09a8b3d741$export$bec5e49cc27c5c10:
            return (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6bae303c5e922702));
        case 0, $2f685d09a8b3d741$export$3c68b4973c91ba:
            return (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$31ae862f18c3b2b7));
    }
    return new $a5e5dee51df551c2$export$4b8a4f6256e840ab(code, $a5e5dee51df551c2$export$9a1233b0d52ed7cd[code] || description, ext);
}



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
/*! @azure/msal-common v14.16.1 2025-08-05 */ 

/*! @azure/msal-common v14.16.1 2025-08-05 */ 






















'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $bf3b67e227c05f73$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS = 300; // 5 Minutes
/**
 * OAuth2.0 refresh token client
 * @internal
 */ class $bf3b67e227c05f73$export$9cb096b89b92d8a8 extends (0, $3b13384e79a725db$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    async acquireToken(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
        const reqTimestamp = (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)();
        const response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(request, this.authority);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $4039fad97bcf28f6$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
        responseHandler.validateTokenResponse(response.body);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, undefined, undefined, true, request.forceCache, requestId);
    }
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ async acquireTokenByRefreshToken(request) {
        // Cannot renew token if no request object is given.
        if (!request) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$eca67ff7a91fed9d));
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$5a3c7d1c90ac9220));
        // try checking if FOCI is enabled for the given application
        const isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment);
        // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
        if (isFOCI) try {
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, true);
        } catch (e) {
            const noFamilyRTInCache = e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba) && e.errorCode === (0, $84767569d86b0bc0$export$e408b083cd212696);
            const clientMismatchErrorWithFamilyRT = e instanceof (0, $016e46db2c2afa86$export$ea52035eac03daf0) && e.errorCode === (0, $7c375ae106b964be$export$b8e9cd941e8016ac).INVALID_GRANT_ERROR && e.subError === (0, $7c375ae106b964be$export$b8e9cd941e8016ac).CLIENT_MISMATCH_ERROR;
            // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
            if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false);
            else throw e;
        }
        // fall back to application refresh token acquisition
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false);
    }
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ async acquireTokenWithCachedRefreshToken(request, foci) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
        // fetches family RT or application RT based on FOCI value
        const refreshToken = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)(this.cacheManager.getRefreshToken.bind(this.cacheManager), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).CacheManagerGetRefreshToken, this.logger, this.performanceClient, request.correlationId)(request.account, foci, request.correlationId, undefined, this.performanceClient);
        if (!refreshToken) throw (0, $18a94acc3dad87ad$export$8f7a741750c16535)((0, $84767569d86b0bc0$export$e408b083cd212696));
        if (refreshToken.expiresOn && (0, $0a4a8f22735f9ff5$export$b007d77a962aa175)(refreshToken.expiresOn, request.refreshTokenExpirationOffsetSeconds || $bf3b67e227c05f73$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS)) throw (0, $18a94acc3dad87ad$export$8f7a741750c16535)((0, $84767569d86b0bc0$export$a90e8b9c10991b49));
        // attach cached RT size to the current measurement
        const refreshTokenRequest = {
            ...request,
            refreshToken: refreshToken.secret,
            authenticationScheme: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            ccsCredential: {
                credential: request.account.homeAccountId,
                type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            }
        };
        try {
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(refreshTokenRequest);
        } catch (e) {
            if (e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba) && e.subError === (0, $84767569d86b0bc0$export$2e3666c77d45a4da)) {
                // Remove bad refresh token from cache
                this.logger.verbose("acquireTokenWithRefreshToken: bad refresh token, removing from cache");
                const badRefreshTokenKey = (0, $9ab3d26df56b176d$export$1aaa1362083ec7a3)(refreshToken);
                this.cacheManager.removeRefreshToken(badRefreshTokenKey, request.correlationId);
            }
            throw e;
        }
    }
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ async executeTokenRequest(request, authority) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        const headers = this.createTokenRequestHeaders(request.ccsCredential);
        const thumbprint = {
            clientId: request.tokenBodyParameters?.clientId || this.config.authOptions.clientId,
            authority: authority.canonicalAuthority,
            scopes: request.scopes,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint);
    }
    /**
     * Helper function to create the token request body
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, request.correlationId);
        const correlationId = request.correlationId;
        const parameterBuilder = new (0, $7d3a00eb36d325b3$export$882078dd8a9e0bfa)(correlationId, this.performanceClient);
        parameterBuilder.addClientId(request.embeddedClientId || request.tokenBodyParameters?.[0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        if (request.redirectUri) parameterBuilder.addRedirectUri(request.redirectUri);
        parameterBuilder.addScopes(request.scopes, true, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes);
        parameterBuilder.addGrantType((0, $7c375ae106b964be$export$ce68f19b50b39c0b).REFRESH_TOKEN_GRANT);
        parameterBuilder.addClientInfo();
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        parameterBuilder.addThrottling();
        if (this.serverTelemetryManager && !(0, $d21eb39178ebb5ae$export$25afa7198c2ed9b9)(this.config)) parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
        parameterBuilder.addRefreshToken(request.refreshToken);
        if (this.config.clientCredentials.clientSecret) parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            parameterBuilder.addClientAssertion(await (0, $e4969f34ccbe14ce$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
        }
        if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            parameterBuilder.addPopToken(reqCnfData);
        } else if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) parameterBuilder.addSshJwk(request.sshJwk);
            else throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$8fbed44b22d9136f));
        }
        if (!(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.ccsCredential.credential);
                    parameterBuilder.addCcsOid(clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN:
                parameterBuilder.addCcsUpn(request.ccsCredential.credential);
                break;
        }
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        if (request.tokenBodyParameters) parameterBuilder.addExtraQueryParameters(request.tokenBodyParameters);
        return parameterBuilder.createQueryString();
    }
}











'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $da9f8d1ce5c4543c$export$e344f5b12c464597 extends (0, $3b13384e79a725db$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    /**
     * Retrieves a token from cache if it is still valid, or uses the cached refresh token to renew
     * the given token and returns the renewed token
     * @param request
     */ async acquireToken(request) {
        try {
            const [authResponse, cacheOutcome] = await this.acquireCachedToken({
                ...request,
                scopes: request.scopes?.length ? request.scopes : [
                    ...(0, $7c375ae106b964be$export$893b1b5b686d84ef)
                ]
            });
            // if the token is not expired but must be refreshed; get a new one in the background
            if (cacheOutcome === (0, $7c375ae106b964be$export$aa4af185ea049f6b).PROACTIVELY_REFRESHED) {
                this.logger.info("SilentFlowClient:acquireCachedToken - Cached access token's refreshOn property has been exceeded'. It's not expired, but must be refreshed.");
                // refresh the access token in the background
                const refreshTokenClient = new (0, $bf3b67e227c05f73$export$9cb096b89b92d8a8)(this.config, this.performanceClient);
                refreshTokenClient.acquireTokenByRefreshToken(request).catch(()=>{
                // do nothing, this is running in the background and no action is to be taken upon success or failure
                });
            }
            // return the cached token
            return authResponse;
        } catch (e) {
            if (e instanceof (0, $eaea74bac26129fa$export$a839ff85a7957561) && e.errorCode === (0, $6be88bbe69356b76$export$e23b692cce0c7779)) {
                const refreshTokenClient = new (0, $bf3b67e227c05f73$export$9cb096b89b92d8a8)(this.config, this.performanceClient);
                return refreshTokenClient.acquireTokenByRefreshToken(request);
            } else throw e;
        }
    }
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ async acquireCachedToken(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, request.correlationId);
        let lastCacheOutcome = (0, $7c375ae106b964be$export$aa4af185ea049f6b).NOT_APPLICABLE;
        if (request.forceRefresh || !this.config.cacheOptions.claimsBasedCachingEnabled && !(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims)) {
            // Must refresh due to present force_refresh flag.
            this.setCacheOutcome((0, $7c375ae106b964be$export$aa4af185ea049f6b).FORCE_REFRESH_OR_CLAIMS, request.correlationId);
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$e23b692cce0c7779));
        }
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$5a3c7d1c90ac9220));
        const requestTenantId = request.account.tenantId || (0, $77bb430f4568f6e8$export$6ed5af33d279fbc7)(request.authority);
        const tokenKeys = this.cacheManager.getTokenKeys();
        const cachedAccessToken = this.cacheManager.getAccessToken(request.account, request, tokenKeys, requestTenantId, this.performanceClient);
        if (!cachedAccessToken) {
            // must refresh due to non-existent access_token
            this.setCacheOutcome((0, $7c375ae106b964be$export$aa4af185ea049f6b).NO_CACHED_ACCESS_TOKEN, request.correlationId);
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$e23b692cce0c7779));
        } else if ((0, $0a4a8f22735f9ff5$export$8961be72dcbc368e)(cachedAccessToken.cachedAt) || (0, $0a4a8f22735f9ff5$export$b007d77a962aa175)(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
            // must refresh due to the expires_in value
            this.setCacheOutcome((0, $7c375ae106b964be$export$aa4af185ea049f6b).CACHED_ACCESS_TOKEN_EXPIRED, request.correlationId);
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$e23b692cce0c7779));
        } else if (cachedAccessToken.refreshOn && (0, $0a4a8f22735f9ff5$export$b007d77a962aa175)(cachedAccessToken.refreshOn, 0)) // must refresh (in the background) due to the refresh_in value
        lastCacheOutcome = (0, $7c375ae106b964be$export$aa4af185ea049f6b).PROACTIVELY_REFRESHED;
        const environment = request.authority || this.authority.getPreferredCache();
        const cacheRecord = {
            account: this.cacheManager.readAccountFromCache(request.account, request.correlationId),
            accessToken: cachedAccessToken,
            idToken: this.cacheManager.getIdToken(request.account, request.correlationId, tokenKeys, requestTenantId, this.performanceClient),
            refreshToken: null,
            appMetadata: this.cacheManager.readAppMetadataFromCache(environment)
        };
        this.setCacheOutcome(lastCacheOutcome, request.correlationId);
        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
        return [
            await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.generateResultFromCacheRecord.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, this.logger, this.performanceClient, request.correlationId)(cacheRecord, request),
            lastCacheOutcome
        ];
    }
    setCacheOutcome(cacheOutcome, correlationId) {
        this.serverTelemetryManager?.setCacheOutcome(cacheOutcome);
        this.performanceClient?.addFields({
            cacheOutcome: cacheOutcome
        }, correlationId);
        if (cacheOutcome !== (0, $7c375ae106b964be$export$aa4af185ea049f6b).NOT_APPLICABLE) this.logger.info(`Token refresh is required due to cache outcome: ${cacheOutcome}`);
    }
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ async generateResultFromCacheRecord(cacheRecord, request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, request.correlationId);
        let idTokenClaims;
        if (cacheRecord.idToken) idTokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(cacheRecord.idToken.secret, this.config.cryptoInterface.base64Decode);
        // token max_age check
        if (request.maxAge || request.maxAge === 0) {
            const authTime = idTokenClaims?.auth_time;
            if (!authTime) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$43356944266c945e));
            (0, $b29e27fb146a7ddd$export$ee7a34ea7880144c)(authTime, request.maxAge);
        }
        return (0, $4039fad97bcf28f6$export$f456c9835cc63582).generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, idTokenClaims);
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $5d2b86ff94a0079d$export$59d4f873ee62d01e extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ async acquireToken(silentRequest) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, silentRequest.correlationId);
        // Telemetry manager only used to increment cacheHits here
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        const silentAuthClient = new (0, $da9f8d1ce5c4543c$export$e344f5b12c464597)(clientConfig, this.performanceClient);
        this.logger.verbose("Silent auth client created");
        try {
            const response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentAuthClient.acquireCachedToken.bind(silentAuthClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
            const authResponse = response[0];
            this.performanceClient.addFields({
                fromCache: true
            }, silentRequest.correlationId);
            return authResponse;
        } catch (error) {
            if (error instanceof (0, $6e0b7bb04b1e6592$export$f8eb6760ca13876a) && error.errorCode === (0, $0780bb28b98eb888$export$a416b0eceb5c15df)) this.logger.verbose("Signing keypair for bound access token not found. Refreshing bound access token and generating a new crypto keypair.");
            throw error;
        }
    }
    /**
     * API to silenty clear the browser cache.
     * @param logoutRequest
     */ logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        return this.clearCacheOnLogout(validLogoutRequest?.account);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $73ad12e7eda75fba$export$38af86d4cb90fd61 extends (0, $cf81b85efeb3dcd5$export$d858565f81c03f1f) {
    constructor(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId){
        super(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        this.apiId = apiId;
        this.accountId = accountId;
        this.nativeMessageHandler = provider;
        this.nativeStorageManager = nativeStorageImpl;
        this.silentCacheClient = new (0, $5d2b86ff94a0079d$export$59d4f873ee62d01e)(config, this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        this.serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        const extensionName = this.nativeMessageHandler.getExtensionId() === (0, $5ff55562d73e0e2b$export$fec113838800867f).PREFERRED_EXTENSION_ID ? "chrome" : this.nativeMessageHandler.getExtensionId()?.length ? "unknown" : undefined;
        this.skus = (0, $9c3cb45936be6b04$export$bddbbc43a3ca9c53).makeExtraSkuString({
            libraryName: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU,
            libraryVersion: (0, $183cce12cb16965c$export$83d89fbfd8236492),
            extensionName: extensionName,
            extensionVersion: this.nativeMessageHandler.getExtensionVersion()
        });
    }
    /**
     * Adds SKUs to request extra query parameters
     * @param request {NativeTokenRequest}
     * @private
     */ addRequestSKUs(request) {
        request.extraParameters = {
            ...request.extraParameters,
            [(0, $b00a7f221d8fdf60$exports).X_CLIENT_EXTRA_SKU]: this.skus
        };
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, request.correlationId);
        this.logger.trace("NativeInteractionClient - acquireToken called.");
        // start the perf measurement
        const nativeATMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, request.correlationId);
        const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
        try {
            // initialize native request
            const nativeRequest = await this.initializeNativeRequest(request);
            // check if the tokens can be retrieved from internal cache
            try {
                const result = await this.acquireTokensFromCache(this.accountId, nativeRequest);
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: false,
                    fromCache: true
                });
                return result;
            } catch (e) {
                // continue with a native call for any and all errors
                this.logger.info("MSAL internal Cache does not contain tokens, proceed to make a native call");
            }
            const { ...nativeTokenRequest } = nativeRequest;
            // fall back to native calls
            const messageBody = {
                method: (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).GetToken,
                request: nativeTokenRequest
            };
            const response = await this.nativeMessageHandler.sendMessage(messageBody);
            const validatedResponse = this.validateNativeResponse(response);
            return await this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp).then((result)=>{
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: true,
                    requestId: result.requestId
                });
                this.serverTelemetryManager.clearNativeBrokerErrorCode();
                return result;
            }).catch((error)=>{
                nativeATMeasurement.end({
                    success: false,
                    errorCode: error.errorCode,
                    subErrorCode: error.subError,
                    isNativeBroker: true
                });
                throw error;
            });
        } catch (e) {
            if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab)) this.serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
            throw e;
        }
    }
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ createSilentCacheRequest(request, cachedAccount) {
        return {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(request.scope).asArray(),
            account: cachedAccount,
            forceRefresh: false
        };
    }
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ async acquireTokensFromCache(nativeAccountId, request) {
        if (!nativeAccountId) {
            this.logger.warning("NativeInteractionClient:acquireTokensFromCache - No nativeAccountId provided");
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).noAccountFound);
        }
        // fetch the account from browser cache
        const account = this.browserStorage.getBaseAccountInfo({
            nativeAccountId: nativeAccountId
        }, request.correlationId);
        if (!account) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).noAccountFound);
        // leverage silent flow for cached tokens retrieval
        try {
            const silentRequest = this.createSilentCacheRequest(request, account);
            const result = await this.silentCacheClient.acquireToken(silentRequest);
            const fullAccount = {
                ...account,
                idTokenClaims: result?.idTokenClaims,
                idToken: result?.idToken
            };
            return {
                ...result,
                account: fullAccount
            };
        } catch (e) {
            throw e;
        }
    }
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param {RedirectRequest} request
     * @param {InProgressPerformanceEvent} rootMeasurement
     */ async acquireTokenRedirect(request, rootMeasurement) {
        this.logger.trace("NativeInteractionClient - acquireTokenRedirect called.");
        const { ...remainingParameters } = request;
        delete remainingParameters.onRedirectNavigate;
        const nativeRequest = await this.initializeNativeRequest(remainingParameters);
        const messageBody = {
            method: (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).GetToken,
            request: nativeRequest
        };
        try {
            const response = await this.nativeMessageHandler.sendMessage(messageBody);
            this.validateNativeResponse(response);
        } catch (e) {
            // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
            if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab)) {
                this.serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
                if ((0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) throw e;
            }
        }
        this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST, JSON.stringify(nativeRequest), true);
        const navigationOptions = {
            apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: false
        };
        const redirectUri = this.config.auth.navigateToLoginRequestUrl ? window.location.href : this.getRedirectUri(request.redirectUri);
        rootMeasurement.end({
            success: true
        });
        await this.navigationClient.navigateExternal(redirectUri, navigationOptions); // Need to treat this as external to ensure handleRedirectPromise is run again
    }
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     * @param performanceClient {IPerformanceClient?}
     * @param correlationId {string?} correlation identifier
     */ async handleRedirectPromise(performanceClient, correlationId) {
        this.logger.trace("NativeInteractionClient - handleRedirectPromise called.");
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
            return null;
        }
        // remove prompt from the request to prevent WAM from prompting twice
        const cachedRequest = this.browserStorage.getCachedNativeRequest();
        if (!cachedRequest) {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise called but there is no cached request, returning null.");
            if (performanceClient && correlationId) performanceClient?.addFields({
                errorCode: "no_cached_request"
            }, correlationId);
            return null;
        }
        const { prompt: prompt, ...request } = cachedRequest;
        if (prompt) this.logger.verbose("NativeInteractionClient - handleRedirectPromise called and prompt was included in the original request, removing prompt from cached request to prevent second interaction with native broker window.");
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST));
        const messageBody = {
            method: (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).GetToken,
            request: request
        };
        const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
        try {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise sending message to native broker.");
            const response = await this.nativeMessageHandler.sendMessage(messageBody);
            this.validateNativeResponse(response);
            const result = this.handleNativeResponse(response, request, reqTimestamp);
            this.browserStorage.setInteractionInProgress(false);
            const res = await result;
            this.serverTelemetryManager.clearNativeBrokerErrorCode();
            return res;
        } catch (e) {
            this.browserStorage.setInteractionInProgress(false);
            throw e;
        }
    }
    /**
     * Logout from native platform via browser extension
     * @param request
     */ logout() {
        this.logger.trace("NativeInteractionClient - logout called.");
        return Promise.reject("Logout not implemented yet");
    }
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ async handleNativeResponse(response, request, reqTimestamp) {
        this.logger.trace("NativeInteractionClient - handleNativeResponse called.");
        // generate identifiers
        const idTokenClaims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(response.id_token, (0, $581fd3df606755c8$export$c62426fdd000a97e));
        const homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenClaims);
        const cachedhomeAccountId = this.browserStorage.getAccountInfoFilteredBy({
            nativeAccountId: request.accountId
        }, this.correlationId)?.homeAccountId;
        if (homeAccountIdentifier !== cachedhomeAccountId && response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
        throw (0, $a5e5dee51df551c2$export$9154414ec87d187b)((0, $ad0863ed8e4325cb$export$966ec8558e4d7922));
        // Get the preferred_cache domain for the given authority
        const authority = await this.getDiscoveredAuthority({
            requestAuthority: request.authority
        });
        const baseAccount = (0, $4039fad97bcf28f6$export$73b84062d58a1307)(this.browserStorage, authority, homeAccountIdentifier, (0, $581fd3df606755c8$export$c62426fdd000a97e), this.correlationId, idTokenClaims, response.client_info, undefined, idTokenClaims.tid, undefined, response.account.id, this.logger);
        // generate authenticationResult
        const result = await this.generateAuthenticationResult(response, request, idTokenClaims, baseAccount, authority.canonicalAuthority, reqTimestamp);
        // cache accounts and tokens in the appropriate storage
        this.cacheAccount(baseAccount);
        this.cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, response.access_token, result.tenantId, reqTimestamp);
        return result;
    }
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ createHomeAccountIdentifier(response, idTokenClaims) {
        // Save account in browser storage
        const homeAccountIdentifier = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateHomeAccountId(response.client_info || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, (0, $70363054a03152f4$export$cd82032b224a3839).Default, this.logger, this.browserCrypto, idTokenClaims);
        return homeAccountIdentifier;
    }
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ generateScopes(response, request) {
        return response.scope ? (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(response.scope) : (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(request.scope);
    }
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ async generatePopAccessToken(response, request) {
        if (request.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP && request.signPopToken) {
            /**
             * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
             * is still received, SHR is calculated locally
             */ // Check if native layer returned an SHR token
            if (response.shr) {
                this.logger.trace("handleNativeServerResponse: SHR is enabled in native layer");
                return response.shr;
            }
            // Generate SHR in msal js if WAM does not compute it when POP is enabled
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.browserCrypto);
            const shrParameters = {
                resourceRequestMethod: request.resourceRequestMethod,
                resourceRequestUri: request.resourceRequestUri,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            /**
             * KeyID must be present in the native request from when the PoP key was generated in order for
             * PopTokenGenerator to query the full key for signing
             */ if (!request.keyId) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).keyIdMissing);
            return popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters);
        } else return response.access_token;
    }
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ async generateAuthenticationResult(response, request, idTokenClaims, accountEntity, authority, reqTimestamp) {
        // Add Native Broker fields to Telemetry
        const mats = this.addTelemetryFromNativeResponse(response);
        // If scopes not returned in server response, use request scopes
        const responseScopes = response.scope ? (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(response.scope) : (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(request.scope);
        const accountProperties = response.account.properties || {};
        const uid = accountProperties["UID"] || idTokenClaims.oid || idTokenClaims.sub || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const tid = accountProperties["TenantId"] || idTokenClaims.tid || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const accountInfo = (0, $54830df9a5d9a12c$export$452a054c78b83dad)(accountEntity.getAccountInfo(), undefined, idTokenClaims, response.id_token);
        /**
         * In pairwise broker flows, this check prevents the broker's native account id
         * from being returned over the embedded app's account id.
         */ if (accountInfo.nativeAccountId !== response.account.id) accountInfo.nativeAccountId = response.account.id;
        // generate PoP token as needed
        const responseAccessToken = await this.generatePopAccessToken(response, request);
        const tokenType = request.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP ? (0, $7c375ae106b964be$export$901491a717da2ba5).POP : (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER;
        const result = {
            authority: authority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes.asArray(),
            account: accountInfo,
            idToken: response.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: responseAccessToken,
            fromCache: mats ? this.isResponseFromCache(mats) : false,
            expiresOn: new Date(Number(reqTimestamp + response.expires_in) * 1000),
            tokenType: tokenType,
            correlationId: this.correlationId,
            state: response.state,
            fromNativeBroker: true
        };
        return result;
    }
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ cacheAccount(accountEntity) {
        // Store the account info and hence `nativeAccountId` in browser cache
        this.browserStorage.setAccount(accountEntity, this.correlationId);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext(accountEntity, this.correlationId).catch((e)=>{
            this.logger.error(`Error occurred while removing account context from browser storage. ${e}`);
        });
    }
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, responseAccessToken, tenantId, reqTimestamp) {
        const cachedIdToken = (0, $9ab3d26df56b176d$exports).createIdTokenEntity(homeAccountIdentifier, request.authority, response.id_token || "", request.clientId, idTokenClaims.tid || "");
        // cache accessToken in inmemory storage
        const expiresIn = request.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP ? (0, $7c375ae106b964be$export$a002182e51710d39).SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        const tokenExpirationSeconds = reqTimestamp + expiresIn;
        const responseScopes = this.generateScopes(response, request);
        const cachedAccessToken = (0, $9ab3d26df56b176d$exports).createAccessTokenEntity(homeAccountIdentifier, request.authority, responseAccessToken, request.clientId, idTokenClaims.tid || tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, (0, $581fd3df606755c8$export$c62426fdd000a97e), undefined, request.tokenType, undefined, request.keyId);
        const nativeCacheRecord = {
            idToken: cachedIdToken,
            accessToken: cachedAccessToken
        };
        this.nativeStorageManager.saveCacheRecord(nativeCacheRecord, request.correlationId, request.storeInCache);
    }
    addTelemetryFromNativeResponse(response) {
        const mats = this.getMATSFromResponse(response);
        if (!mats) return null;
        this.performanceClient.addFields({
            extensionId: this.nativeMessageHandler.getExtensionId(),
            extensionVersion: this.nativeMessageHandler.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    }
    /**
     * Validates native platform response before processing
     * @param response
     */ validateNativeResponse(response) {
        if (response.hasOwnProperty("access_token") && response.hasOwnProperty("id_token") && response.hasOwnProperty("client_info") && response.hasOwnProperty("account") && response.hasOwnProperty("scope") && response.hasOwnProperty("expires_in")) return response;
        else throw (0, $0ff8310393c4d2db$export$eb157f7636c79bd2)((0, $1a08d0bb87f43eeb$exports).unexpectedError, "Response missing expected properties.");
    }
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ getMATSFromResponse(response) {
        if (response.properties.MATS) try {
            return JSON.parse(response.properties.MATS);
        } catch (e) {
            this.logger.error("NativeInteractionClient - Error parsing MATS telemetry, returning null instead");
        }
        return null;
    }
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ isResponseFromCache(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("NativeInteractionClient - MATS telemetry does not contain field indicating if response was served from cache. Returning false.");
            return false;
        }
        return !!mats.is_cached;
    }
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ async initializeNativeRequest(request) {
        this.logger.trace("NativeInteractionClient - initializeNativeRequest called");
        const requestAuthority = request.authority || this.config.auth.authority;
        if (request.account) // validate authority
        await this.getDiscoveredAuthority({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: request.azureCloudOptions,
            account: request.account
        });
        const canonicalAuthority = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(requestAuthority);
        canonicalAuthority.validateAsUri();
        // scopes are expected to be received by the native broker as "scope" and will be added to the request below. Other properties that should be dropped from the request to the native broker can be included in the object destructuring here.
        const { scopes: scopes, ...remainingProperties } = request;
        const scopeSet = new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(scopes || []);
        scopeSet.appendScopes((0, $7c375ae106b964be$export$893b1b5b686d84ef));
        const getPrompt = ()=>{
            // If request is silent, prompt is always none
            switch(this.apiId){
                case (0, $5ff55562d73e0e2b$export$192d74ad69b40705).ssoSilent:
                case (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow:
                    this.logger.trace("initializeNativeRequest: silent request sets prompt to none");
                    return (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE;
            }
            // Prompt not provided, request may proceed and native broker decides if it needs to prompt
            if (!request.prompt) {
                this.logger.trace("initializeNativeRequest: prompt was not provided");
                return undefined;
            }
            // If request is interactive, check if prompt provided is allowed to go directly to native broker
            switch(request.prompt){
                case (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE:
                case (0, $7c375ae106b964be$export$49a06cbda5acaa5).CONSENT:
                case (0, $7c375ae106b964be$export$49a06cbda5acaa5).LOGIN:
                    this.logger.trace("initializeNativeRequest: prompt is compatible with native flow");
                    return request.prompt;
                default:
                    this.logger.trace(`initializeNativeRequest: prompt = ${request.prompt} is not compatible with native flow`);
                    throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$62fdd8848aa75547));
            }
        };
        const validatedRequest = {
            ...remainingProperties,
            accountId: this.accountId,
            clientId: this.config.auth.clientId,
            authority: canonicalAuthority.urlString,
            scope: scopeSet.printScopes(),
            redirectUri: this.getRedirectUri(request.redirectUri),
            prompt: getPrompt(),
            correlationId: this.correlationId,
            tokenType: request.authenticationScheme,
            windowTitleSubstring: document.title,
            extraParameters: {
                ...request.extraQueryParameters,
                ...request.tokenQueryParameters
            },
            extendedExpiryToken: false,
            keyId: request.popKid
        };
        // Check for PoP token requests: signPopToken should only be set to true if popKid is not set
        if (validatedRequest.signPopToken && !!request.popKid) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$f6f43ae33ad04b91));
        this.handleExtraBrokerParams(validatedRequest);
        validatedRequest.extraParameters = validatedRequest.extraParameters || {};
        validatedRequest.extraParameters.telemetry = (0, $5ff55562d73e0e2b$export$fec113838800867f).MATS_TELEMETRY;
        if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
            // add POP request type
            const shrParameters = {
                resourceRequestUri: request.resourceRequestUri,
                resourceRequestMethod: request.resourceRequestMethod,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.browserCrypto);
            // generate reqCnf if not provided in the request
            let reqCnfData;
            if (!validatedRequest.keyId) {
                const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(shrParameters, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
                validatedRequest.keyId = generatedReqCnfData.kid;
                validatedRequest.signPopToken = true;
            } else {
                reqCnfData = this.browserCrypto.base64UrlEncode(JSON.stringify({
                    kid: validatedRequest.keyId
                }));
                validatedRequest.signPopToken = false;
            }
            // SPAs require whole string to be passed to broker
            validatedRequest.reqCnf = reqCnfData;
        }
        this.addRequestSKUs(validatedRequest);
        return validatedRequest;
    }
    /**
     * Handles extra broker request parameters
     * @param request {NativeTokenRequest}
     * @private
     */ handleExtraBrokerParams(request) {
        const hasExtraBrokerParams = request.extraParameters && request.extraParameters.hasOwnProperty((0, $b00a7f221d8fdf60$exports).BROKER_CLIENT_ID) && request.extraParameters.hasOwnProperty((0, $b00a7f221d8fdf60$exports).BROKER_REDIRECT_URI) && request.extraParameters.hasOwnProperty((0, $b00a7f221d8fdf60$exports).CLIENT_ID);
        if (!request.embeddedClientId && !hasExtraBrokerParams) return;
        let child_client_id = "";
        const child_redirect_uri = request.redirectUri;
        if (request.embeddedClientId) {
            request.redirectUri = this.config.auth.redirectUri;
            child_client_id = request.embeddedClientId;
        } else if (request.extraParameters) {
            request.redirectUri = request.extraParameters[(0, $b00a7f221d8fdf60$exports).BROKER_REDIRECT_URI];
            child_client_id = request.extraParameters[(0, $b00a7f221d8fdf60$exports).CLIENT_ID];
        }
        request.extraParameters = {
            child_client_id: child_client_id,
            child_redirect_uri: child_redirect_uri
        };
        this.performanceClient?.addFields({
            embeddedClientId: child_client_id,
            embeddedRedirectUri: child_redirect_uri
        }, request.correlationId);
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $0cbbbdc8324fb5b9$export$c98888b8059e2702 {
    constructor(logger, handshakeTimeoutMs, performanceClient, extensionId){
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeMessageHandlerHandshake);
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param body
     */ async sendMessage(body) {
        this.logger.trace("NativeMessageHandler - sendMessage called.");
        const req = {
            channel: (0, $5ff55562d73e0e2b$export$fec113838800867f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            body: body
        };
        this.logger.trace("NativeMessageHandler - Sending request to browser extension");
        this.logger.tracePii(`NativeMessageHandler - Sending request to browser extension: ${JSON.stringify(req)}`);
        this.messageChannel.port1.postMessage(req);
        return new Promise((resolve, reject)=>{
            this.resolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
        });
    }
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     * @param {ICrypto} crypto
     */ static async createProvider(logger, handshakeTimeoutMs, performanceClient) {
        logger.trace("NativeMessageHandler - createProvider called.");
        try {
            const preferredProvider = new $0cbbbdc8324fb5b9$export$c98888b8059e2702(logger, handshakeTimeoutMs, performanceClient, (0, $5ff55562d73e0e2b$export$fec113838800867f).PREFERRED_EXTENSION_ID);
            await preferredProvider.sendHandshakeRequest();
            return preferredProvider;
        } catch (e) {
            // If preferred extension fails for whatever reason, fallback to using any installed extension
            const backupProvider = new $0cbbbdc8324fb5b9$export$c98888b8059e2702(logger, handshakeTimeoutMs, performanceClient);
            await backupProvider.sendHandshakeRequest();
            return backupProvider;
        }
    }
    /**
     * Send handshake request helper.
     */ async sendHandshakeRequest() {
        this.logger.trace("NativeMessageHandler - sendHandshakeRequest called.");
        // Register this event listener before sending handshake
        window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
        const req = {
            channel: (0, $5ff55562d73e0e2b$export$fec113838800867f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            body: {
                method: (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).HandshakeRequest
            }
        };
        this.handshakeEvent.add({
            extensionId: this.extensionId,
            extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
        });
        this.messageChannel.port1.onmessage = (event)=>{
            this.onChannelMessage(event);
        };
        window.postMessage(req, window.origin, [
            this.messageChannel.port2
        ]);
        return new Promise((resolve, reject)=>{
            this.handshakeResolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
            this.timeoutId = window.setTimeout(()=>{
                /*
                 * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                 * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                 */ window.removeEventListener("message", this.windowListener, false);
                this.messageChannel.port1.close();
                this.messageChannel.port2.close();
                this.handshakeEvent.end({
                    extensionHandshakeTimedOut: true,
                    success: false
                });
                reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4747c302ef0117fd)));
                this.handshakeResolvers.delete(req.responseId);
            }, this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
        });
    }
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ onWindowMessage(event) {
        this.logger.trace("NativeMessageHandler - onWindowMessage called");
        // We only accept messages from ourselves
        if (event.source !== window) return;
        const request = event.data;
        if (!request.channel || request.channel !== (0, $5ff55562d73e0e2b$export$fec113838800867f).CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).HandshakeRequest) {
            const handshakeResolver = this.handshakeResolvers.get(request.responseId);
            /*
             * Filter out responses with no matched resolvers sooner to keep channel ports open while waiting for
             * the proper response.
             */ if (!handshakeResolver) {
                this.logger.trace(`NativeMessageHandler.onWindowMessage - resolver can't be found for request ${request.responseId}`);
                return;
            }
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? `Extension with id: ${request.extensionId} not installed` : "No extension installed");
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            this.handshakeEvent.end({
                success: false,
                extensionInstalled: false
            });
            handshakeResolver.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$59080ea2398ee306)));
        }
    }
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ onChannelMessage(event) {
        this.logger.trace("NativeMessageHandler - onChannelMessage called.");
        const request = event.data;
        const resolver = this.resolvers.get(request.responseId);
        const handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            const method = request.body.method;
            if (method === (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).Response) {
                if (!resolver) return;
                const response = request.body.response;
                this.logger.trace("NativeMessageHandler - Received response from browser extension");
                this.logger.tracePii(`NativeMessageHandler - Received response from browser extension: ${JSON.stringify(response)}`);
                if (response.status !== "Success") resolver.reject((0, $a5e5dee51df551c2$export$9154414ec87d187b)(response.code, response.description, response.ext));
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) resolver.reject((0, $a5e5dee51df551c2$export$9154414ec87d187b)(response.result["code"], response.result["description"], response.result["ext"]));
                    else resolver.resolve(response.result);
                } else throw (0, $0ff8310393c4d2db$export$eb157f7636c79bd2)((0, $1a08d0bb87f43eeb$exports).unexpectedError, "Event does not contain result.");
                this.resolvers.delete(request.responseId);
            } else if (method === (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).HandshakeResponse) {
                if (!handshakeResolver) {
                    this.logger.trace(`NativeMessageHandler.onChannelMessage - resolver can't be found for request ${request.responseId}`);
                    return;
                }
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose(`NativeMessageHandler - Received HandshakeResponse from extension: ${this.extensionId}`);
                this.handshakeEvent.end({
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
        // Do nothing if method is not Response or HandshakeResponse
        } catch (err) {
            this.logger.error("Error parsing response from WAM Extension");
            this.logger.errorPii(`Error parsing response from WAM Extension: ${err}`);
            this.logger.errorPii(`Unable to parse ${event}`);
            if (resolver) resolver.reject(err);
            else if (handshakeResolver) handshakeResolver.reject(err);
        }
    }
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return this.extensionId;
    }
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ getExtensionVersion() {
        return this.extensionVersion;
    }
    /**
     * Returns boolean indicating whether or not the request should attempt to use native broker
     * @param logger
     * @param config
     * @param nativeExtensionProvider
     * @param authenticationScheme
     */ static isNativeAvailable(config, logger, nativeExtensionProvider, authenticationScheme) {
        logger.trace("isNativeAvailable called");
        if (!config.system.allowNativeBroker) {
            logger.trace("isNativeAvailable: allowNativeBroker is not enabled, returning false");
            // Developer disabled WAM
            return false;
        }
        if (!nativeExtensionProvider) {
            logger.trace("isNativeAvailable: WAM extension provider is not initialized, returning false");
            // Extension is not available
            return false;
        }
        if (authenticationScheme) switch(authenticationScheme){
            case (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER:
            case (0, $7c375ae106b964be$export$901491a717da2ba5).POP:
                logger.trace("isNativeAvailable: authenticationScheme is supported, returning true");
                return true;
            default:
                logger.trace("isNativeAvailable: authenticationScheme is not supported, returning false");
                return false;
        }
        return true;
    }
}



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ class $e330ed825f42f772$export$a30cd982b4e89bdb {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ async handleCodeResponse(response, request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponse, request.correlationId);
        let authCodeResponse;
        try {
            authCodeResponse = this.authModule.handleFragmentResponse(response, request.state);
        } catch (e) {
            if (e instanceof (0, $016e46db2c2afa86$export$ea52035eac03daf0) && e.subError === (0, $0780bb28b98eb888$export$6bae303c5e922702)) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6bae303c5e922702));
            else throw e;
        }
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.handleCodeResponseFromServer.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)(authCodeResponse, request);
    }
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param state
     * @param authority
     * @param networkModule
     * @returns
     */ async handleCodeResponseFromServer(authCodeResponse, request, validateNonce = true) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponseFromServer, request.correlationId);
        this.logger.trace("InteractionHandler.handleCodeResponseFromServer called");
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Check for new cloud instance
        if (authCodeResponse.cloud_instance_host_name) await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.authModule.updateAuthority.bind(this.authModule), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.logger, this.performanceClient, request.correlationId)(authCodeResponse.cloud_instance_host_name, request.correlationId);
        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
        if (validateNonce) // TODO: Assigning "response nonce" to "request nonce" is confusing. Refactor the function doing validation to accept request nonce directly
        authCodeResponse.nonce = request.nonce || undefined;
        authCodeResponse.state = request.state;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const ccsCred = this.createCcsCredentials(request);
            if (ccsCred) this.authCodeRequest.ccsCredential = ccsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.authModule.acquireToken.bind(this.authModule), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(this.authCodeRequest, authCodeResponse);
        return tokenResponse;
    }
    /**
     * Build ccs creds if available
     */ createCcsCredentials(request) {
        if (request.account) return {
            credential: request.account.homeAccountId,
            type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
        };
        else if (request.loginHint) return {
            credential: request.loginHint,
            type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN
        };
        return null;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9c7efd3c039fd7d9$export$e64c1808ed72a7c(responseString, responseLocation, logger) {
    // Deserialize hash fragment response parameters.
    const serverParams = (0, $0763983a1d35c4b8$exports).getDeserializedResponse(responseString);
    if (!serverParams) {
        if (!(0, $0763983a1d35c4b8$exports).stripLeadingHashOrQuery(responseString)) {
            // Hash or Query string is empty
            logger.error(`The request has returned to the redirectUri but a ${responseLocation} is not present. It's likely that the ${responseLocation} has been removed or the page has been redirected by code running on the redirectUri page.`);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$a29c42a1dd414317));
        } else {
            logger.error(`A ${responseLocation} is present in the iframe but it does not contain known properties. It's likely that the ${responseLocation} has been replaced by code running on the redirectUri page.`);
            logger.errorPii(`The ${responseLocation} detected is: ${responseString}`);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$5743873a5ba5d124));
        }
    }
    return serverParams;
}
/**
 * Returns the interaction type that the response object belongs to
 */ function $9c7efd3c039fd7d9$export$af0c72d18284aa0(response, browserCrypto, interactionType) {
    if (!response.state) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$211c8e8843a8d278));
    const platformStateObj = (0, $6ec519bc7bf28780$export$68ec87f530f5f536)(browserCrypto, response.state);
    if (!platformStateObj) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$237bdd0b913cb30c));
    if (platformStateObj.interactionType !== interactionType) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$499b1b95c97a1c75));
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $674f66832275a4d9$export$43b0fce132d066f4 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        // Properly sets this reference for the unload event.
        this.unloadWindow = this.unloadWindow.bind(this);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     */ acquireToken(request) {
        try {
            const popupName = this.generatePopupName(request.scopes || (0, $7c375ae106b964be$export$893b1b5b686d84ef), request.authority || this.config.auth.authority);
            const popupParams = {
                popupName: popupName,
                popupWindowAttributes: request.popupWindowAttributes || {},
                popupWindowParent: request.popupWindowParent ?? window
            };
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true, acquiring token");
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupParams);
            } else {
                // asyncPopups flag is set to false. Opens popup before acquiring token.
                this.logger.verbose("asyncPopup set to false, opening popup before acquiring token");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.acquireTokenPopupAsync(request, popupParams);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logout(logoutRequest) {
        try {
            this.logger.verbose("logoutPopup called");
            const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            const popupParams = {
                popupName: this.generateLogoutPopupName(validLogoutRequest),
                popupWindowAttributes: logoutRequest?.popupWindowAttributes || {},
                popupWindowParent: logoutRequest?.popupWindowParent ?? window
            };
            const authority = logoutRequest && logoutRequest.authority;
            const mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true");
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            } else {
                // asyncPopups flag is set to false. Opens popup before logging out.
                this.logger.verbose("asyncPopup set to false, opening popup");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param validRequest
     * @param popupName
     * @param popup
     * @param popupWindowAttributes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopupAsync(request, popupParams) {
        this.logger.verbose("acquireTokenPopupAsync called");
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup);
        const validRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup);
        (0, $3003b661a087a867$export$a0816fa17a9e79be)(validRequest.authority);
        try {
            // Create auth code request and generate PKCE params
            const authCodeRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationCodeRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.logger, this.performanceClient, this.correlationId)(validRequest);
            // Initialize the client
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: validRequest.authority,
                requestAzureCloudOptions: validRequest.azureCloudOptions,
                requestExtraQueryParameters: validRequest.extraQueryParameters,
                account: validRequest.account
            });
            const isNativeBroker = (0, $0cbbbdc8324fb5b9$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme);
            // Start measurement for server calls with native brokering enabled
            let fetchNativeAccountIdMeasurement;
            if (isNativeBroker) fetchNativeAccountIdMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).FetchAccountIdWithNativeBroker, request.correlationId);
            // Create acquire token url.
            const navigateUrl = await authClient.getAuthCodeUrl({
                ...validRequest,
                nativeBroker: isNativeBroker
            });
            // Create popup interaction handler.
            const interactionHandler = new (0, $e330ed825f42f772$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Show the UI once the url has been created. Get the window handle for the popup.
            const popupWindow = this.initiateAuthRequest(navigateUrl, popupParams);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).POPUP_OPENED, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, {
                popupWindow: popupWindow
            }, null);
            // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
            const responseString = await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent);
            const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.serverResponseType, this.logger);
            // Remove throttle if it exists
            (0, $38fc8bee021018e9$export$c060a619741dd765).removeThrottle(this.browserStorage, this.config.auth.clientId, authCodeRequest);
            if (serverParams.accountId) {
                this.logger.verbose("Account id found in hash, calling WAM for token");
                // end measurement for server call with native brokering enabled
                if (fetchNativeAccountIdMeasurement) fetchNativeAccountIdMeasurement.end({
                    success: true,
                    isNativeBroker: true
                });
                if (!this.nativeMessageHandler) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$7b7357e3538624aa));
                const nativeInteractionClient = new (0, $73ad12e7eda75fba$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, validRequest.correlationId);
                const { userRequestState: userRequestState } = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(this.browserCrypto, validRequest.state);
                return await nativeInteractionClient.acquireToken({
                    ...validRequest,
                    state: userRequestState,
                    prompt: undefined
                });
            }
            // Handle response from hash string.
            const result = await interactionHandler.handleCodeResponse(serverParams, validRequest);
            return result;
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ async logoutPopupAsync(validRequest, popupParams, requestAuthority, mainWindowRedirectUri) {
        this.logger.verbose("logoutPopupAsync called");
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).logoutPopup);
        try {
            // Clear cache on logout
            await this.clearCacheOnLogout(validRequest.account);
            // Initialize the client
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: requestAuthority,
                account: validRequest.account || undefined
            });
            try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validRequest.account?.homeAccountId && validRequest.postLogoutRedirectUri && authClient.authority.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC) {
                    this.browserStorage.removeAccount(validRequest.account?.homeAccountId, this.correlationId);
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
                    if (mainWindowRedirectUri) {
                        const navigationOptions = {
                            apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).logoutPopup,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        const absoluteUrl = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
                        await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                    }
                    popupParams.popup?.close();
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validRequest);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
            // Open the popup window to requestUrl.
            const popupWindow = this.openPopup(logoutUri, popupParams);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).POPUP_OPENED, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, {
                popupWindow: popupWindow
            }, null);
            await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent).catch(()=>{
            // Swallow any errors related to monitoring the window. Server logout is best effort
            });
            if (mainWindowRedirectUri) {
                const navigationOptions = {
                    apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).logoutPopup,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: false
                };
                const absoluteUrl = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
                this.logger.verbose("Redirecting main window to url specified in the request");
                this.logger.verbosePii(`Redirecting main window to: ${absoluteUrl}`);
                await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
            } else this.logger.verbose("No main window navigation requested");
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.browserStorage.setInteractionInProgress(false);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup);
            throw e;
        }
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup);
    }
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ initiateAuthRequest(requestUrl, params) {
        // Check that request url is not empty.
        if (requestUrl) {
            this.logger.infoPii(`Navigate to: ${requestUrl}`);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("Navigate url is empty");
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$be9285c64f247822));
        }
    }
    /**
     * Monitors a window until it loads a url with the same origin.
     * @param popupWindow - window that is being monitored
     * @param timeout - timeout for processing hash once popup is redirected back to application
     */ monitorPopupForHash(popupWindow, popupWindowParent) {
        return new Promise((resolve, reject)=>{
            this.logger.verbose("PopupHandler.monitorPopupForHash - polling started");
            const intervalId = setInterval(()=>{
                // Window is closed
                if (popupWindow.closed) {
                    this.logger.error("PopupHandler.monitorPopupForHash - window closed");
                    clearInterval(intervalId);
                    reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6bae303c5e922702)));
                    return;
                }
                let href = "";
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = popupWindow.location.href;
                } catch (e) {}
                // Don't process blank pages or cross domain
                if (!href || href === "about:blank") return;
                clearInterval(intervalId);
                let responseString = "";
                const responseType = this.config.auth.OIDCOptions.serverResponseType;
                if (popupWindow) {
                    if (responseType === (0, $7c375ae106b964be$export$b34cb6fbea2adc44).QUERY) responseString = popupWindow.location.search;
                    else responseString = popupWindow.location.hash;
                }
                this.logger.verbose("PopupHandler.monitorPopupForHash - popup window is on same origin as caller");
                resolve(responseString);
            }, this.config.system.pollIntervalMilliseconds);
        }).finally(()=>{
            this.cleanPopup(popupWindow, popupWindowParent);
        });
    }
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ openPopup(urlNavigate, popupParams) {
        try {
            let popupWindow;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii(`Navigating popup window to: ${urlNavigate}`);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii(`Opening popup window to: ${urlNavigate}`);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$5e827e513523a576));
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            popupParams.popupWindowParent.addEventListener("beforeunload", this.unloadWindow);
            return popupWindow;
        } catch (e) {
            this.logger.error("error opening popup " + e.message);
            this.browserStorage.setInteractionInProgress(false);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$f1b7091ee48d0b3e));
        }
    }
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ openSizedPopup(urlNavigate, { popupName: popupName, popupWindowAttributes: popupWindowAttributes, popupWindowParent: popupWindowParent }) {
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ const winLeft = popupWindowParent.screenLeft ? popupWindowParent.screenLeft : popupWindowParent.screenX;
        const winTop = popupWindowParent.screenTop ? popupWindowParent.screenTop : popupWindowParent.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ const winWidth = popupWindowParent.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const winHeight = popupWindowParent.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let width = popupWindowAttributes.popupSize?.width;
        let height = popupWindowAttributes.popupSize?.height;
        let top = popupWindowAttributes.popupPosition?.top;
        let left = popupWindowAttributes.popupPosition?.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("Default popup window width used. Window width not configured or invalid.");
            width = (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("Default popup window height used. Window height not configured or invalid.");
            height = (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("Default popup window top position used. Window top not configured or invalid.");
            top = Math.max(0, winHeight / 2 - (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("Default popup window left position used. Window left not configured or invalid.");
            left = Math.max(0, winWidth / 2 - (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_WIDTH / 2 + winLeft);
        }
        return popupWindowParent.open(urlNavigate, popupName, `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes`);
    }
    /**
     * Event callback to unload main window.
     */ unloadWindow(e) {
        this.browserStorage.cleanRequestByInteractionType((0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup);
        if (this.currentWindow) this.currentWindow.close();
        // Guarantees browser unload will happen, so no other errors will be thrown.
        e.preventDefault();
    }
    /**
     * Closes popup, removes any state vars created during popup calls.
     * @param popupWindow
     */ cleanPopup(popupWindow, popupWindowParent) {
        // Close window.
        popupWindow.close();
        // Remove window unload function
        popupWindowParent.removeEventListener("beforeunload", this.unloadWindow);
        // Interaction is completed - remove interaction status.
        this.browserStorage.setInteractionInProgress(false);
    }
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ generatePopupName(scopes, authority) {
        return `${(0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${scopes.join("-")}.${authority}.${this.correlationId}`;
    }
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ generateLogoutPopupName(request) {
        const homeAccountId = request.account && request.account.homeAccountId;
        return `${(0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${homeAccountId}.${this.correlationId}`;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $986bfe3a9105fbd0$export$9af91951fcedc08c {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     */ async initiateAuthRequest(requestUrl, params) {
        this.logger.verbose("RedirectHandler.initiateAuthRequest called");
        // Navigate if valid URL
        if (requestUrl) {
            // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
            if (params.redirectStartPage) {
                this.logger.verbose("RedirectHandler.initiateAuthRequest: redirectStartPage set, caching start page");
                this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI, params.redirectStartPage, true);
            }
            // Set interaction status in the library.
            this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).CORRELATION_ID, this.authCodeRequest.correlationId, true);
            this.browserStorage.cacheCodeRequest(this.authCodeRequest);
            this.logger.infoPii(`RedirectHandler.initiateAuthRequest: Navigate to: ${requestUrl}`);
            const navigationOptions = {
                apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect,
                timeout: params.redirectTimeout,
                noHistory: false
            };
            // If onRedirectNavigate is implemented, invoke it and provide requestUrl
            if (typeof params.onRedirectNavigate === "function") {
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback");
                const navigate = params.onRedirectNavigate(requestUrl);
                // Returning false from onRedirectNavigate will stop navigation
                if (navigate !== false) {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating");
                    await params.navigationClient.navigateExternal(requestUrl, navigationOptions);
                    return;
                } else {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation");
                    return;
                }
            } else {
                // Navigate window to request URL
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url");
                await params.navigationClient.navigateExternal(requestUrl, navigationOptions);
                return;
            }
        } else {
            // Throw error if request URL is empty.
            this.logger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty");
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$be9285c64f247822));
        }
    }
    /**
     * Handle authorization code response in the window.
     * @param hash
     */ async handleCodeResponse(response, state) {
        this.logger.verbose("RedirectHandler.handleCodeResponse called");
        // Interaction is completed - remove interaction status.
        this.browserStorage.setInteractionInProgress(false);
        // Handle code response.
        const stateKey = this.browserStorage.generateStateKey(state);
        const requestState = this.browserStorage.getTemporaryCache(stateKey);
        if (!requestState) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).stateNotFound, "Cached State");
        let authCodeResponse;
        try {
            authCodeResponse = this.authModule.handleFragmentResponse(response, requestState);
        } catch (e) {
            if (e instanceof (0, $016e46db2c2afa86$export$ea52035eac03daf0) && e.subError === (0, $0780bb28b98eb888$export$6bae303c5e922702)) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6bae303c5e922702));
            else throw e;
        }
        // Get cached items
        const nonceKey = this.browserStorage.generateNonceKey(requestState);
        const cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Check for new cloud instance
        if (authCodeResponse.cloud_instance_host_name) await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.authModule.updateAuthority.bind(this.authModule), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.logger, this.performanceClient, this.authCodeRequest.correlationId)(authCodeResponse.cloud_instance_host_name, this.authCodeRequest.correlationId);
        authCodeResponse.nonce = cachedNonce || undefined;
        authCodeResponse.state = requestState;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const cachedCcsCred = this.checkCcsCredentials();
            if (cachedCcsCred) this.authCodeRequest.ccsCredential = cachedCcsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await this.authModule.acquireToken(this.authCodeRequest, authCodeResponse);
        this.browserStorage.cleanRequestByState(state);
        return tokenResponse;
    }
    /**
     * Looks up ccs creds in the cache
     */ checkCcsCredentials() {
        // Look up ccs credential in temp cache
        const cachedCcsCred = this.browserStorage.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).CCS_CREDENTIAL, true);
        if (cachedCcsCred) try {
            return JSON.parse(cachedCcsCred);
        } catch (e) {
            this.authModule.logger.error("Cache credential could not be parsed");
            this.authModule.logger.errorPii(`Cache credential could not be parsed: ${cachedCcsCred}`);
        }
        return null;
    }
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9c96cbdf0340174c$var$getNavigationType() {
    if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.getEntriesByType !== "function") return undefined;
    const navigationEntries = window.performance.getEntriesByType("navigation");
    const navigation = navigationEntries.length ? navigationEntries[0] : undefined;
    return navigation?.type;
}
class $9c96cbdf0340174c$export$a368977effbc1ed6 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ async acquireToken(request) {
        const validRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
        this.browserStorage.updateCacheEntries(validRequest.state, validRequest.nonce, validRequest.authority, validRequest.loginHint || "", validRequest.account || null);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect);
        const handleBackButton = (event)=>{
            // Clear temporary cache if the back button is clicked during the redirect flow.
            if (event.persisted) {
                this.logger.verbose("Page was restored from back/forward cache. Clearing temporary cache.");
                this.browserStorage.cleanRequestByState(validRequest.state);
                this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).RESTORE_FROM_BFCACHE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            }
        };
        try {
            // Create auth code request and generate PKCE params
            const authCodeRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationCodeRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.logger, this.performanceClient, this.correlationId)(validRequest);
            // Initialize the client
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: validRequest.authority,
                requestAzureCloudOptions: validRequest.azureCloudOptions,
                requestExtraQueryParameters: validRequest.extraQueryParameters,
                account: validRequest.account
            });
            // Create redirect interaction handler.
            const interactionHandler = new (0, $986bfe3a9105fbd0$export$9af91951fcedc08c)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Create acquire token url.
            const navigateUrl = await authClient.getAuthCodeUrl({
                ...validRequest,
                nativeBroker: (0, $0cbbbdc8324fb5b9$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme)
            });
            const redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
            this.logger.verbosePii(`Redirect start page: ${redirectStartPage}`);
            // Clear temporary cache if the back button is clicked during the redirect flow.
            window.addEventListener("pageshow", handleBackButton);
            // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
            return await interactionHandler.initiateAuthRequest(navigateUrl, {
                navigationClient: this.navigationClient,
                redirectTimeout: this.config.system.redirectNavigationTimeout,
                redirectStartPage: redirectStartPage,
                onRedirectNavigate: request.onRedirectNavigate || this.config.auth.onRedirectNavigate
            });
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            window.removeEventListener("pageshow", handleBackButton);
            this.browserStorage.cleanRequestByState(validRequest.state);
            throw e;
        }
    }
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash {string} url hash
     * @param parentMeasurement {InProgressPerformanceEvent} parent measurement
     */ async handleRedirectPromise(hash = "", parentMeasurement) {
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).handleRedirectPromise);
        try {
            if (!this.browserStorage.isInteractionInProgress(true)) {
                this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
                return null;
            }
            const [serverParams, responseString] = this.getRedirectResponse(hash || "");
            if (!serverParams) {
                // Not a recognized server response hash or hash not associated with a redirect request
                this.logger.info("handleRedirectPromise did not detect a response as a result of a redirect. Cleaning temporary cache.");
                this.browserStorage.cleanRequestByInteractionType((0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
                // Do not instrument "no_server_response" if user clicked back button
                if ($9c96cbdf0340174c$var$getNavigationType() !== "back_forward") parentMeasurement.event.errorCode = "no_server_response";
                else this.logger.verbose("Back navigation event detected. Muting no_server_response error");
                return null;
            }
            // If navigateToLoginRequestUrl is true, get the url where the redirect request was initiated
            const loginRequestUrl = this.browserStorage.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI, true) || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const loginRequestUrlNormalized = (0, $f7f911f196324278$export$3abcdca7229e54f2).removeHashFromUrl(loginRequestUrl);
            const currentUrlNormalized = (0, $f7f911f196324278$export$3abcdca7229e54f2).removeHashFromUrl(window.location.href);
            if (loginRequestUrlNormalized === currentUrlNormalized && this.config.auth.navigateToLoginRequestUrl) {
                // We are on the page we need to navigate to - handle hash
                this.logger.verbose("Current page is loginRequestUrl, handling response");
                if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                (0, $3003b661a087a867$export$9bf2691bda54425c)(loginRequestUrl);
                const handleHashResult = await this.handleResponse(serverParams, serverTelemetryManager);
                return handleHashResult;
            } else if (!this.config.auth.navigateToLoginRequestUrl) {
                this.logger.verbose("NavigateToLoginRequestUrl set to false, handling response");
                return await this.handleResponse(serverParams, serverTelemetryManager);
            } else if (!(0, $3003b661a087a867$export$9f140ed41af5108c)() || this.config.system.allowRedirectInIframe) {
                /*
                 * Returned from authority using redirect - need to perform navigation before processing response
                 * Cache the hash to be retrieved after the next redirect
                 */ this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH, responseString, true);
                const navigationOptions = {
                    apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).handleRedirectPromise,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: true
                };
                /**
                 * Default behavior is to redirect to the start page and not process the hash now.
                 * The start page is expected to also call handleRedirectPromise which will process the hash in one of the checks above.
                 */ let processHashOnRedirect = true;
                if (!loginRequestUrl || loginRequestUrl === "null") {
                    // Redirect to home page if login request url is null (real null or the string null)
                    const homepage = (0, $3003b661a087a867$export$60785768478b4ffc)();
                    // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                    this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI, homepage, true);
                    this.logger.warning("Unable to get valid login request url from cache, redirecting to home page");
                    processHashOnRedirect = await this.navigationClient.navigateInternal(homepage, navigationOptions);
                } else {
                    // Navigate to page that initiated the redirect request
                    this.logger.verbose(`Navigating to loginRequestUrl: ${loginRequestUrl}`);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions);
                }
                // If navigateInternal implementation returns false, handle the hash now
                if (!processHashOnRedirect) return await this.handleResponse(serverParams, serverTelemetryManager);
            }
            return null;
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.browserStorage.cleanRequestByInteractionType((0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            throw e;
        }
    }
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ getRedirectResponse(userProvidedResponse) {
        this.logger.verbose("getRedirectResponseHash called");
        // Get current location hash from window or cache.
        let responseString = userProvidedResponse;
        if (!responseString) {
            if (this.config.auth.OIDCOptions.serverResponseType === (0, $7c375ae106b964be$export$b34cb6fbea2adc44).QUERY) responseString = window.location.search;
            else responseString = window.location.hash;
        }
        let response = (0, $0763983a1d35c4b8$exports).getDeserializedResponse(responseString);
        if (response) {
            try {
                (0, $9c7efd3c039fd7d9$export$af0c72d18284aa0)(response, this.browserCrypto, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            } catch (e) {
                if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) this.logger.error(`Interaction type validation failed due to ${e.errorCode}: ${e.errorMessage}`);
                return [
                    null,
                    ""
                ];
            }
            (0, $3003b661a087a867$export$a20c3032ba81d6aa)(window);
            this.logger.verbose("Hash contains known properties, returning response hash");
            return [
                response,
                responseString
            ];
        }
        const cachedHash = this.browserStorage.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH));
        if (cachedHash) {
            response = (0, $0763983a1d35c4b8$exports).getDeserializedResponse(cachedHash);
            if (response) {
                this.logger.verbose("Hash does not contain known properties, returning cached hash");
                return [
                    response,
                    cachedHash
                ];
            }
        }
        return [
            null,
            ""
        ];
    }
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ async handleResponse(serverParams, serverTelemetryManager) {
        const state = serverParams.state;
        if (!state) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$211c8e8843a8d278));
        const cachedRequest = this.browserStorage.getCachedRequest(state);
        this.logger.verbose("handleResponse called, retrieved cached request");
        if (serverParams.accountId) {
            this.logger.verbose("Account id found in hash, calling WAM for token");
            if (!this.nativeMessageHandler) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$7b7357e3538624aa));
            const nativeInteractionClient = new (0, $73ad12e7eda75fba$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, cachedRequest.correlationId);
            const { userRequestState: userRequestState } = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(this.browserCrypto, state);
            return nativeInteractionClient.acquireToken({
                ...cachedRequest,
                state: userRequestState,
                prompt: undefined
            }).finally(()=>{
                this.browserStorage.cleanRequestByState(state);
            });
        }
        // Hash contains known properties - handle and return in callback
        const currentAuthority = this.browserStorage.getCachedAuthority(state);
        if (!currentAuthority) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$3a2c83e7753553b));
        const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: currentAuthority
        });
        (0, $38fc8bee021018e9$export$c060a619741dd765).removeThrottle(this.browserStorage, this.config.auth.clientId, cachedRequest);
        const interactionHandler = new (0, $986bfe3a9105fbd0$export$9af91951fcedc08c)(authClient, this.browserStorage, cachedRequest, this.logger, this.performanceClient);
        return interactionHandler.handleCodeResponse(serverParams, state);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).logout);
        try {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, logoutRequest);
            // Clear cache on logout
            await this.clearCacheOnLogout(validLogoutRequest.account);
            const navigationOptions = {
                apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).logout,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: logoutRequest && logoutRequest.authority,
                requestExtraQueryParameters: logoutRequest?.extraQueryParameters,
                account: logoutRequest && logoutRequest.account || undefined
            });
            if (authClient.authority.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC) try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validLogoutRequest.account?.homeAccountId) {
                    this.browserStorage.removeAccount(validLogoutRequest.account?.homeAccountId, this.correlationId);
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validLogoutRequest);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
            // Check if onRedirectNavigate is implemented, and invoke it if so
            if (logoutRequest && typeof logoutRequest.onRedirectNavigate === "function") {
                const navigate = logoutRequest.onRedirectNavigate(logoutUri);
                if (navigate !== false) {
                    this.logger.verbose("Logout onRedirectNavigate did not return false, navigating");
                    // Ensure interaction is in progress
                    if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true);
                    await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                    return;
                } else {
                    // Ensure interaction is not in progress
                    this.browserStorage.setInteractionInProgress(false);
                    this.logger.verbose("Logout onRedirectNavigate returned false, stopping navigation");
                }
            } else {
                // Ensure interaction is in progress
                if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true);
                await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                return;
            }
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            throw e;
        }
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
    }
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ getRedirectStartPage(requestStartPage) {
        const redirectStartPage = requestStartPage || window.location.href;
        return (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(redirectStartPage, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Creates a hidden iframe to given URL using user-requested scopes as an id.
 * @param urlNavigate
 * @param userRequestScopes
 */ async function $b4d2944d1c7d2c68$export$57f8a7967bf66c8e(requestUrl, performanceClient, logger, correlationId, navigateFrameWait) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, correlationId);
    if (!requestUrl) {
        // Throw error if request URL is empty.
        logger.info("Navigate url is empty");
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$be9285c64f247822));
    }
    if (navigateFrameWait) return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($b4d2944d1c7d2c68$var$loadFrame, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerLoadFrame, logger, performanceClient, correlationId)(requestUrl, navigateFrameWait, performanceClient, correlationId);
    return (0, $5386add07ebe4b6d$export$468cda29b159ee5d)($b4d2944d1c7d2c68$var$loadFrameSync, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerLoadFrameSync, logger, performanceClient, correlationId)(requestUrl);
}
/**
 * Monitors an iframe content window until it loads a url with a known hash, or hits a specified timeout.
 * @param iframe
 * @param timeout
 */ async function $b4d2944d1c7d2c68$export$9ee275d2f26db8a7(iframe, timeout, pollIntervalMilliseconds, performanceClient, logger, correlationId, responseType) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, correlationId);
    return new Promise((resolve, reject)=>{
        if (timeout < (0, $68fb5a78014bcfe7$export$f3ffe700be354b19)) logger.warning(`system.loadFrameTimeout or system.iframeHashTimeout set to lower (${timeout}ms) than the default (${(0, $68fb5a78014bcfe7$export$f3ffe700be354b19)}ms). This may result in timeouts.`);
        /*
         * Polling for iframes can be purely timing based,
         * since we don't need to account for interaction.
         */ const timeoutId = window.setTimeout(()=>{
            window.clearInterval(intervalId);
            reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$c8b6efb19551013d)));
        }, timeout);
        const intervalId = window.setInterval(()=>{
            let href = "";
            const contentWindow = iframe.contentWindow;
            try {
                /*
                 * Will throw if cross origin,
                 * which should be caught and ignored
                 * since we need the interval to keep running while on STS UI.
                 */ href = contentWindow ? contentWindow.location.href : "";
            } catch (e) {}
            if (!href || href === "about:blank") return;
            let responseString = "";
            if (contentWindow) {
                if (responseType === (0, $7c375ae106b964be$export$b34cb6fbea2adc44).QUERY) responseString = contentWindow.location.search;
                else responseString = contentWindow.location.hash;
            }
            window.clearTimeout(timeoutId);
            window.clearInterval(intervalId);
            resolve(responseString);
        }, pollIntervalMilliseconds);
    }).finally(()=>{
        (0, $5386add07ebe4b6d$export$468cda29b159ee5d)($b4d2944d1c7d2c68$var$removeHiddenIframe, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RemoveHiddenIframe, logger, performanceClient, correlationId)(iframe);
    });
}
/**
 * @hidden
 * Loads iframe with authorization endpoint URL
 * @ignore
 * @deprecated
 */ function $b4d2944d1c7d2c68$var$loadFrame(urlNavigate, navigateFrameWait, performanceClient, correlationId) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerLoadFrame, correlationId);
    /*
     * This trick overcomes iframe navigation in IE
     * IE does not load the page consistently in iframe
     */ return new Promise((resolve, reject)=>{
        const frameHandle = $b4d2944d1c7d2c68$var$createHiddenIframe();
        window.setTimeout(()=>{
            if (!frameHandle) {
                reject("Unable to load iframe");
                return;
            }
            frameHandle.src = urlNavigate;
            resolve(frameHandle);
        }, navigateFrameWait);
    });
}
/**
 * @hidden
 * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
 * @param urlNavigate
 * @param frameName
 * @param logger
 */ function $b4d2944d1c7d2c68$var$loadFrameSync(urlNavigate) {
    const frameHandle = $b4d2944d1c7d2c68$var$createHiddenIframe();
    frameHandle.src = urlNavigate;
    return frameHandle;
}
/**
 * @hidden
 * Creates a new hidden iframe or gets an existing one for silent token renewal.
 * @ignore
 */ function $b4d2944d1c7d2c68$var$createHiddenIframe() {
    const authFrame = document.createElement("iframe");
    authFrame.className = "msalSilentIframe";
    authFrame.style.visibility = "hidden";
    authFrame.style.position = "absolute";
    authFrame.style.width = authFrame.style.height = "0";
    authFrame.style.border = "0";
    authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
    document.body.appendChild(authFrame);
    return authFrame;
}
/**
 * @hidden
 * Removes a hidden iframe from the page.
 * @ignore
 */ function $b4d2944d1c7d2c68$var$removeHiddenIframe(iframe) {
    if (document.body === iframe.parentNode) document.body.removeChild(iframe);
}








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $73772bb7ece2a11b$export$e81c7938bccef977 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        this.apiId = apiId;
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
        // Check that we have some SSO data
        if (!request.loginHint && !request.sid && (!request.account || !request.account.username)) this.logger.warning("No user hint provided. The authorization server may need more information to complete this request.");
        // Check the prompt value
        const inputRequest = {
            ...request
        };
        if (inputRequest.prompt) {
            if (inputRequest.prompt !== (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE && inputRequest.prompt !== (0, $7c375ae106b964be$export$49a06cbda5acaa5).NO_SESSION) {
                this.logger.warning(`SilentIframeClient. Replacing invalid prompt ${inputRequest.prompt} with ${(0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE}`);
                inputRequest.prompt = (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE;
            }
        } else inputRequest.prompt = (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE;
        // Create silent request
        const silentRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(inputRequest, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent);
        (0, $3003b661a087a867$export$a0816fa17a9e79be)(silentRequest.authority);
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        let authClient;
        try {
            // Initialize the client
            authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, request.correlationId)(authClient, silentRequest);
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            if (!authClient || !(e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) || e.errorCode !== (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).INVALID_GRANT_ERROR) throw e;
            this.performanceClient.addFields({
                retryError: e.errorCode
            }, this.correlationId);
            const retrySilentRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(inputRequest, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent);
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, this.correlationId)(authClient, retrySilentRequest);
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$78523a40be105a03)));
    }
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ async silentTokenHelper(authClient, silentRequest) {
        const correlationId = silentRequest.correlationId;
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, correlationId);
        // Create auth code request and generate PKCE params
        const authCodeRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationCodeRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.logger, this.performanceClient, correlationId)(silentRequest);
        // Create authorize request url
        const navigateUrl = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(authClient.getAuthCodeUrl.bind(authClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)({
            ...silentRequest,
            nativeBroker: (0, $0cbbbdc8324fb5b9$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, silentRequest.authenticationScheme)
        });
        // Create silent handler
        const interactionHandler = new (0, $e330ed825f42f772$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
        // Get the frame handle for the silent request
        const msalFrame = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$57f8a7967bf66c8e), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(navigateUrl, this.performanceClient, this.logger, correlationId, this.config.system.navigateFrameWait);
        const responseType = this.config.auth.OIDCOptions.serverResponseType;
        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$9ee275d2f26db8a7), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(msalFrame, this.config.system.iframeHashTimeout, this.config.system.pollIntervalMilliseconds, this.performanceClient, this.logger, correlationId, responseType);
        const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, responseType, this.logger);
        if (serverParams.accountId) {
            this.logger.verbose("Account id found in hash, calling WAM for token");
            if (!this.nativeMessageHandler) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$7b7357e3538624aa));
            const nativeInteractionClient = new (0, $73ad12e7eda75fba$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.apiId, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.browserStorage, correlationId);
            const { userRequestState: userRequestState } = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(this.browserCrypto, silentRequest.state);
            return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(nativeInteractionClient.acquireToken.bind(nativeInteractionClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, this.logger, this.performanceClient, correlationId)({
                ...silentRequest,
                state: userRequestState,
                prompt: silentRequest.prompt || (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE
            });
        }
        // Handle response from hash string
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(interactionHandler.handleCodeResponse.bind(interactionHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponse, this.logger, this.performanceClient, correlationId)(serverParams, silentRequest);
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9a90898a8c83eb8c$export$b4a36596822a5d2 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, request.correlationId);
        const baseRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $550ae9dc1dae1add$export$8e461fcf1fd6910b), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, request.correlationId)(request, this.config, this.performanceClient, this.logger);
        const silentRequest = {
            ...request,
            ...baseRequest
        };
        if (request.redirectUri) // Make sure any passed redirectUri is converted to an absolute URL - redirectUri is not a required parameter for refresh token redemption so only include if explicitly provided
        silentRequest.redirectUri = this.getRedirectUri(request.redirectUri);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const refreshTokenClient = await this.createRefreshTokenClient({
            serverTelemetryManager: serverTelemetryManager,
            authorityUrl: silentRequest.authority,
            azureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(refreshTokenClient.acquireTokenByRefreshToken.bind(refreshTokenClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, this.logger, this.performanceClient, request.correlationId)(silentRequest).catch((e)=>{
            e.setCorrelationId(this.correlationId);
            serverTelemetryManager.cacheFailedRequest(e);
            throw e;
        });
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$78523a40be105a03)));
    }
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         azureCloudOptions?: AzureCloudOptions;
     *         extraQueryParams?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createRefreshTokenClient(params) {
        // Create auth module.
        const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: params.serverTelemetryManager,
            requestAuthority: params.authorityUrl,
            requestAzureCloudOptions: params.azureCloudOptions,
            requestExtraQueryParameters: params.extraQueryParameters,
            account: params.account
        });
        return new (0, $bf3b67e227c05f73$export$9cb096b89b92d8a8)(clientConfig, this.performanceClient);
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Token cache manager
 */ class $dc748a126de75897$export$ed5d1a18907a1001 {
    constructor(configuration, storage, logger, cryptoObj){
        this.isBrowserEnvironment = typeof window !== "undefined";
        this.config = configuration;
        this.storage = storage;
        this.logger = logger;
        this.cryptoObj = cryptoObj;
    }
    // Move getAllAccounts here and cache utility APIs
    /**
     * API to load tokens to msal-browser cache.
     * @param request
     * @param response
     * @param options
     * @returns `AuthenticationResult` for the response that was loaded.
     */ loadExternalTokens(request, response, options) {
        if (!this.isBrowserEnvironment) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$932e0f52d657f7fb));
        const correlationId = request.correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        const idTokenClaims = response.id_token ? (0, $b29e27fb146a7ddd$exports).extractTokenClaims(response.id_token, (0, $581fd3df606755c8$export$c62426fdd000a97e)) : undefined;
        const authorityOptions = {
            protocolMode: this.config.auth.protocolMode,
            knownAuthorities: this.config.auth.knownAuthorities,
            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
            authorityMetadata: this.config.auth.authorityMetadata,
            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        };
        const authority = request.authority ? new (0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c)((0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c).generateAuthority(request.authority, request.azureCloudOptions), this.config.system.networkClient, this.storage, authorityOptions, this.logger, request.correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)()) : undefined;
        const cacheRecordAccount = this.loadAccount(request, options.clientInfo || response.client_info || "", correlationId, idTokenClaims, authority);
        const idToken = this.loadIdToken(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, correlationId);
        const accessToken = this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, options, correlationId);
        const refreshToken = this.loadRefreshToken(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, correlationId);
        return this.generateAuthenticationResult(request, {
            account: cacheRecordAccount,
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken
        }, idTokenClaims, authority);
    }
    /**
     * Helper function to load account to msal-browser cache
     * @param idToken
     * @param environment
     * @param clientInfo
     * @param authorityType
     * @param requestHomeAccountId
     * @returns `AccountEntity`
     */ loadAccount(request, clientInfo, correlationId, idTokenClaims, authority) {
        this.logger.verbose("TokenCache - loading account");
        if (request.account) {
            const accountEntity = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createFromAccountInfo(request.account);
            this.storage.setAccount(accountEntity, correlationId);
            return accountEntity;
        } else if (!authority || !clientInfo && !idTokenClaims) {
            this.logger.error("TokenCache - if an account is not provided on the request, authority and either clientInfo or idToken must be provided instead.");
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6acf650331eb5f5f));
        }
        const homeAccountId = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateHomeAccountId(clientInfo, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        const claimsTenantId = idTokenClaims?.tid;
        const cachedAccount = (0, $4039fad97bcf28f6$export$73b84062d58a1307)(this.storage, authority, homeAccountId, (0, $581fd3df606755c8$export$c62426fdd000a97e), correlationId, idTokenClaims, clientInfo, authority.hostnameAndPort, claimsTenantId, undefined, undefined, this.logger);
        this.storage.setAccount(cachedAccount, correlationId);
        return cachedAccount;
    }
    /**
     * Helper function to load id tokens to msal-browser cache
     * @param idToken
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `IdTokenEntity`
     */ loadIdToken(response, homeAccountId, environment, tenantId, correlationId) {
        if (!response.id_token) {
            this.logger.verbose("TokenCache - no id token found in response");
            return null;
        }
        this.logger.verbose("TokenCache - loading id token");
        const idTokenEntity = (0, $9ab3d26df56b176d$exports).createIdTokenEntity(homeAccountId, environment, response.id_token, this.config.auth.clientId, tenantId);
        this.storage.setIdTokenCredential(idTokenEntity, correlationId);
        return idTokenEntity;
    }
    /**
     * Helper function to load access tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `AccessTokenEntity`
     */ loadAccessToken(request, response, homeAccountId, environment, tenantId, options, correlationId) {
        if (!response.access_token) {
            this.logger.verbose("TokenCache - no access token found in response");
            return null;
        } else if (!response.expires_in) {
            this.logger.error("TokenCache - no expiration set on the access token. Cannot add it to the cache.");
            return null;
        } else if (!response.scope && (!request.scopes || !request.scopes.length)) {
            this.logger.error("TokenCache - scopes not specified in the request or response. Cannot add token to the cache.");
            return null;
        }
        this.logger.verbose("TokenCache - loading access token");
        const scopes = response.scope ? (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(response.scope) : new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(request.scopes);
        const expiresOn = options.expiresOn || response.expires_in + new Date().getTime() / 1000;
        const extendedExpiresOn = options.extendedExpiresOn || (response.ext_expires_in || response.expires_in) + new Date().getTime() / 1000;
        const accessTokenEntity = (0, $9ab3d26df56b176d$exports).createAccessTokenEntity(homeAccountId, environment, response.access_token, this.config.auth.clientId, tenantId, scopes.printScopes(), expiresOn, extendedExpiresOn, (0, $581fd3df606755c8$export$c62426fdd000a97e));
        this.storage.setAccessTokenCredential(accessTokenEntity, correlationId);
        return accessTokenEntity;
    }
    /**
     * Helper function to load refresh tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @returns `RefreshTokenEntity`
     */ loadRefreshToken(response, homeAccountId, environment, correlationId) {
        if (!response.refresh_token) {
            this.logger.verbose("TokenCache - no refresh token found in response");
            return null;
        }
        this.logger.verbose("TokenCache - loading refresh token");
        const refreshTokenEntity = (0, $9ab3d26df56b176d$exports).createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, this.config.auth.clientId, response.foci, undefined, response.refresh_token_expires_in);
        this.storage.setRefreshTokenCredential(refreshTokenEntity, correlationId);
        return refreshTokenEntity;
    }
    /**
     * Helper function to generate an `AuthenticationResult` for the result.
     * @param request
     * @param idTokenObj
     * @param cacheRecord
     * @param authority
     * @returns `AuthenticationResult`
     */ generateAuthenticationResult(request, cacheRecord, idTokenClaims, authority) {
        let accessToken = "";
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        if (cacheRecord?.accessToken) {
            accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
            extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
        }
        const accountEntity = cacheRecord.account;
        return {
            authority: authority ? authority.canonicalAuthority : "",
            uniqueId: cacheRecord.account.localAccountId,
            tenantId: cacheRecord.account.realm,
            scopes: responseScopes,
            account: accountEntity.getAccountInfo(),
            idToken: cacheRecord.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: true,
            expiresOn: expiresOn,
            correlationId: request.correlationId || "",
            requestId: "",
            extExpiresOn: extExpiresOn,
            familyId: cacheRecord.refreshToken?.familyId || "",
            tokenType: cacheRecord?.accessToken?.tokenType || "",
            state: request.state || "",
            cloudGraphHostName: accountEntity.cloudGraphHostName || "",
            msGraphHost: accountEntity.msGraphHost || "",
            fromNativeBroker: false
        };
    }
}






/*! @azure/msal-browser v3.30.0 2025-08-05 */ 



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $2c25b6e1fc2d7d09$export$a2dbbd28e9bce542 extends (0, $7e4376d17ecbf639$export$8538731fd397fb90) {
    constructor(config){
        super(config);
        this.includeRedirectUri = false;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $74f7d1cf2fd01491$export$d7f5ef311b3e9fca extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        this.apiId = apiId;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ async acquireToken(request) {
        // Auth code payload is required
        if (!request.code) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$e502d98cd8d2da43));
        // Create silent request
        const silentRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(request, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent);
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // Create auth code request (PKCE not needed)
            const authCodeRequest = {
                ...silentRequest,
                code: request.code
            };
            // Initialize the client
            const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            const authClient = new (0, $2c25b6e1fc2d7d09$export$a2dbbd28e9bce542)(clientConfig);
            this.logger.verbose("Auth code client created");
            // Create silent handler
            const interactionHandler = new (0, $e330ed825f42f772$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Handle auth code parameters from request
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(interactionHandler.handleCodeResponseFromServer.bind(interactionHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)({
                code: request.code,
                msgraph_host: request.msGraphHost,
                cloud_graph_host_name: request.cloudGraphHostName,
                cloud_instance_host_name: request.cloudInstanceHostName
            }, silentRequest, false);
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$78523a40be105a03)));
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $1d9f6519fe722240$var$getAccountType(account) {
    const idTokenClaims = account?.idTokenClaims;
    if (idTokenClaims?.tfp || idTokenClaims?.acr) return "B2C";
    if (!idTokenClaims?.tid) return undefined;
    else if (idTokenClaims?.tid === "9188040d-6c67-4c5b-b112-36a304b66dad") return "MSA";
    return "AAD";
}
function $1d9f6519fe722240$var$preflightCheck(initialized, performanceEvent) {
    try {
        (0, $3003b661a087a867$export$4dd091cbdc98b52e)(initialized);
    } catch (e) {
        performanceEvent.end({
            success: false
        }, e);
        throw e;
    }
}
class $1d9f6519fe722240$export$e9d1ef1cb8705404 {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ constructor(operatingContext){
        this.operatingContext = operatingContext;
        this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment();
        // Set the configuration.
        this.config = operatingContext.getConfig();
        this.initialized = false;
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(this.logger, this.performanceClient) : (0, $dd88ab1a0b4d3851$export$865f57d401606752);
        this.eventHandler = new (0, $9f61ab73b66f619a$export$ce0ba2422a1c7815)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new (0, $d3981d5134d5331a$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, (0, $77bb430f4568f6e8$export$2b9ebf6f25078cc0)(this.config.auth), this.performanceClient) : (0, $d3981d5134d5331a$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger);
        // initialize in memory storage for native flows
        const nativeCacheOptions = {
            cacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
            temporaryCacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
            storeAuthStateInCookie: false,
            secureCookies: false,
            cacheMigrationEnabled: false,
            claimsBasedCachingEnabled: false
        };
        this.nativeInternalStorage = new (0, $d3981d5134d5331a$export$44d7291b5c8cc149)(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger, undefined, this.performanceClient);
        // Initialize the token cache
        this.tokenCache = new (0, $dc748a126de75897$export$ed5d1a18907a1001)(this.config, this.browserStorage, this.logger, this.browserCrypto);
        this.activeSilentTokenRequests = new Map();
        // Register listener functions
        this.trackPageVisibility = this.trackPageVisibility.bind(this);
        // Register listener functions
        this.trackPageVisibilityWithMeasurement = this.trackPageVisibilityWithMeasurement.bind(this);
        // account storage events
        this.listeningToStorageEvents = false;
        this.handleAccountCacheChange = this.handleAccountCacheChange.bind(this);
    }
    static async createController(operatingContext, request) {
        const controller = new $1d9f6519fe722240$export$e9d1ef1cb8705404(operatingContext);
        await controller.initialize(request);
        return controller;
    }
    trackPageVisibility(correlationId) {
        if (!correlationId) return;
        this.logger.info("Perf: Visibility change detected");
        this.performanceClient.incrementFields({
            visibilityChangeCount: 1
        }, correlationId);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest} correlation id
     */ async initialize(request) {
        this.logger.trace("initialize called");
        if (this.initialized) {
            this.logger.info("initialize has already been called, exiting early.");
            return;
        }
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, exiting early.");
            this.initialized = true;
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).INITIALIZE_END);
            return;
        }
        const initCorrelationId = request?.correlationId || this.getRequestCorrelationId();
        const allowNativeBroker = this.config.system.allowNativeBroker;
        const initMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeClientApplication, initCorrelationId);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).INITIALIZE_START);
        if (allowNativeBroker) try {
            this.nativeExtensionProvider = await (0, $0cbbbdc8324fb5b9$export$c98888b8059e2702).createProvider(this.logger, this.config.system.nativeBrokerHandshakeTimeout, this.performanceClient);
        } catch (e) {
            this.logger.verbose(e);
        }
        if (!this.config.cache.claimsBasedCachingEnabled) {
            this.logger.verbose("Claims-based caching is disabled. Clearing the previous cache with claims");
            await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.browserStorage.clearTokensAndKeysWithClaims.bind(this.browserStorage), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, this.logger, this.performanceClient, initCorrelationId)(this.performanceClient, initCorrelationId);
        }
        this.initialized = true;
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).INITIALIZE_END);
        initMeasurement.end({
            allowNativeBroker: allowNativeBroker,
            success: true
        });
    }
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ async handleRedirectPromise(hash) {
        this.logger.verbose("handleRedirectPromise called");
        // Block token acquisition before initialize has been called
        (0, $3003b661a087a867$export$630119c5db8b5529)(this.initialized);
        if (this.isBrowserEnvironment) {
            /**
             * Store the promise on the PublicClientApplication instance if this is the first invocation of handleRedirectPromise,
             * otherwise return the promise from the first invocation. Prevents race conditions when handleRedirectPromise is called
             * several times concurrently.
             */ const redirectResponseKey = hash || "";
            let response = this.redirectResponse.get(redirectResponseKey);
            if (typeof response === "undefined") {
                response = this.handleRedirectPromiseInternal(hash);
                this.redirectResponse.set(redirectResponseKey, response);
                this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise");
            } else this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call");
            return response;
        }
        this.logger.verbose("handleRedirectPromise returns null, not browser environment");
        return null;
    }
    /**
     * The internal details of handleRedirectPromise. This is separated out to a helper to allow handleRedirectPromise to memoize requests
     * @param hash
     * @returns
     */ async handleRedirectPromiseInternal(hash) {
        const loggedInAccounts = this.getAllAccounts();
        const request = this.browserStorage.getCachedNativeRequest();
        const useNative = request && (0, $0cbbbdc8324fb5b9$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider) && this.nativeExtensionProvider && !hash;
        const correlationId = useNative ? request?.correlationId : this.browserStorage.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).CORRELATION_ID, true) || "";
        const rootMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenRedirect, correlationId);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
        let redirectResponse;
        if (useNative && this.nativeExtensionProvider) {
            this.logger.trace("handleRedirectPromise - acquiring token from native platform");
            const nativeClient = new (0, $73ad12e7eda75fba$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).handleRedirectPromise, this.performanceClient, this.nativeExtensionProvider, request.accountId, this.nativeInternalStorage, request.correlationId);
            redirectResponse = (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(nativeClient.handleRedirectPromise.bind(nativeClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleNativeRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(this.performanceClient, rootMeasurement.event.correlationId);
        } else {
            this.logger.trace("handleRedirectPromise - acquiring token from web flow");
            const redirectClient = this.createRedirectClient(correlationId);
            redirectResponse = (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(redirectClient.handleRedirectPromise.bind(redirectClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(hash, rootMeasurement);
        }
        return redirectResponse.then((result)=>{
            if (result) {
                // Emit login event if number of accounts change
                const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
                if (isLoggingIn) {
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, login success");
                } else {
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, acquire token success");
                }
                rootMeasurement.end({
                    success: true,
                    accountType: $1d9f6519fe722240$var$getAccountType(result.account)
                });
            } else /*
                 * Instrument an event only if an error code is set. Otherwise, discard it when the redirect response
                 * is empty and the error code is missing.
                 */ if (rootMeasurement.event.errorCode) rootMeasurement.end({
                success: false
            });
            else rootMeasurement.discard();
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            return result;
        }).catch((e)=>{
            const eventError = e;
            // Emit login event if there is an account
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, eventError);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, eventError);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            rootMeasurement.end({
                success: false
            }, eventError);
            throw e;
        });
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async acquireTokenRedirect(request) {
        // Preflight request
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("acquireTokenRedirect called", correlationId);
        const atrMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenPreRedirect, correlationId);
        atrMeasurement.add({
            accountType: $1d9f6519fe722240$var$getAccountType(request.account),
            scenarioId: request.scenarioId
        });
        // Override on request only if set, as onRedirectNavigate field is deprecated
        const onRedirectNavigateCb = request.onRedirectNavigate;
        if (onRedirectNavigateCb) request.onRedirectNavigate = (url)=>{
            const navigate = typeof onRedirectNavigateCb === "function" ? onRedirectNavigateCb(url) : undefined;
            if (navigate !== false) atrMeasurement.end({
                success: true
            });
            else atrMeasurement.discard();
            return navigate;
        };
        else {
            const configOnRedirectNavigateCb = this.config.auth.onRedirectNavigate;
            this.config.auth.onRedirectNavigate = (url)=>{
                const navigate = typeof configOnRedirectNavigateCb === "function" ? configOnRedirectNavigateCb(url) : undefined;
                if (navigate !== false) atrMeasurement.end({
                    success: true
                });
                else atrMeasurement.discard();
                return navigate;
            };
        }
        // If logged in, emit acquire token events
        const isLoggedIn = this.getAllAccounts().length > 0;
        try {
            (0, $3003b661a087a867$export$62c8f4fdca4df60f)(this.initialized, this.config);
            this.browserStorage.setInteractionInProgress(true);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, request);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, request);
            let result;
            if (this.nativeExtensionProvider && this.canUseNative(request)) {
                const nativeClient = new (0, $73ad12e7eda75fba$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect, this.performanceClient, this.nativeExtensionProvider, this.getNativeAccountId(request), this.nativeInternalStorage, correlationId);
                result = nativeClient.acquireTokenRedirect(request, atrMeasurement).catch((e)=>{
                    if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                        this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    } else if (e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
                        this.logger.verbose("acquireTokenRedirect - Resolving interaction required error thrown by native broker by falling back to web flow");
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    }
                    this.browserStorage.setInteractionInProgress(false);
                    throw e;
                });
            } else {
                const redirectClient = this.createRedirectClient(correlationId);
                result = redirectClient.acquireToken(request);
            }
            return await result;
        } catch (e) {
            atrMeasurement.end({
                success: false
            }, e);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, e);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, e);
            throw e;
        }
    }
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenPopup, correlationId);
        atPopupMeasurement.add({
            scenarioId: request.scenarioId,
            accountType: $1d9f6519fe722240$var$getAccountType(request.account)
        });
        try {
            this.logger.verbose("acquireTokenPopup called", correlationId);
            $1d9f6519fe722240$var$preflightCheck(this.initialized, atPopupMeasurement);
            this.browserStorage.setInteractionInProgress(true);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        const loggedInAccounts = this.getAllAccounts();
        if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, request);
        else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, request);
        let result;
        if (this.canUseNative(request)) result = this.acquireTokenNative({
            ...request,
            correlationId: correlationId
        }, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup).then((response)=>{
            this.browserStorage.setInteractionInProgress(false);
            atPopupMeasurement.end({
                success: true,
                isNativeBroker: true,
                accountType: $1d9f6519fe722240$var$getAccountType(response.account)
            });
            return response;
        }).catch((e)=>{
            if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                const popupClient = this.createPopupClient(correlationId);
                return popupClient.acquireToken(request);
            } else if (e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
                this.logger.verbose("acquireTokenPopup - Resolving interaction required error thrown by native broker by falling back to web flow");
                const popupClient = this.createPopupClient(correlationId);
                return popupClient.acquireToken(request);
            }
            this.browserStorage.setInteractionInProgress(false);
            throw e;
        });
        else {
            const popupClient = this.createPopupClient(correlationId);
            result = popupClient.acquireToken(request);
        }
        return result.then((result)=>{
            /*
             *  If logged in, emit acquire token events
             */ const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            if (isLoggingIn) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, result);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.end({
                success: true,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length,
                accountType: $1d9f6519fe722240$var$getAccountType(result.account)
            });
            return result;
        }).catch((e)=>{
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e);
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        });
    }
    trackPageVisibilityWithMeasurement() {
        const measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        this.logger.info("Perf: Visibility change detected in ", measurement.event.name);
        measurement.increment({
            visibilityChangeCount: 1
        });
    }
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async ssoSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const validRequest = {
            ...request,
            // will be PromptValue.NONE or PromptValue.NO_SESSION
            prompt: request.prompt,
            correlationId: correlationId
        };
        this.ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SsoSilent, correlationId);
        this.ssoSilentMeasurement?.add({
            scenarioId: request.scenarioId,
            accountType: $1d9f6519fe722240$var$getAccountType(request.account)
        });
        $1d9f6519fe722240$var$preflightCheck(this.initialized, this.ssoSilentMeasurement);
        this.ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0
        });
        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        this.logger.verbose("ssoSilent called", correlationId);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, validRequest);
        let result;
        if (this.canUseNative(validRequest)) result = this.acquireTokenNative(validRequest, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).ssoSilent).catch((e)=>{
            // If native token acquisition fails for availability reasons fallback to standard flow
            if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                return silentIframeClient.acquireToken(validRequest);
            }
            throw e;
        });
        else {
            const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
            result = silentIframeClient.acquireToken(validRequest);
        }
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, response);
            this.ssoSilentMeasurement?.end({
                success: true,
                isNativeBroker: response.fromNativeBroker,
                accessTokenSize: response.accessToken.length,
                idTokenSize: response.idToken.length,
                accountType: $1d9f6519fe722240$var$getAccountType(response.account)
            });
            return response;
        }).catch((e)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, e);
            this.ssoSilentMeasurement?.end({
                success: false
            }, e);
            throw e;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        });
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenByCode(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("acquireTokenByCode called", correlationId);
        const atbcMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByCode, correlationId);
        $1d9f6519fe722240$var$preflightCheck(this.initialized, atbcMeasurement);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, request);
        atbcMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$1efb009e9d75bbe4));
            else if (request.code) {
                const hybridAuthCode = request.code;
                let response = this.hybridAuthCodeResponses.get(hybridAuthCode);
                if (!response) {
                    this.logger.verbose("Initiating new acquireTokenByCode request", correlationId);
                    response = this.acquireTokenByCodeAsync({
                        ...request,
                        correlationId: correlationId
                    }).then((result)=>{
                        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        atbcMeasurement.end({
                            success: true,
                            isNativeBroker: result.fromNativeBroker,
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length,
                            accountType: $1d9f6519fe722240$var$getAccountType(result.account)
                        });
                        return result;
                    }).catch((error)=>{
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, error);
                        atbcMeasurement.end({
                            success: false
                        }, error);
                        throw error;
                    });
                    this.hybridAuthCodeResponses.set(hybridAuthCode, response);
                } else {
                    this.logger.verbose("Existing acquireTokenByCode request found", correlationId);
                    atbcMeasurement.discard();
                }
                return await response;
            } else if (request.nativeAccountId) {
                if (this.canUseNative(request, request.nativeAccountId)) {
                    const result = await this.acquireTokenNative({
                        ...request,
                        correlationId: correlationId
                    }, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenByCode, request.nativeAccountId).catch((e)=>{
                        // If native token acquisition fails for availability reasons fallback to standard flow
                        if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        throw e;
                    });
                    atbcMeasurement.end({
                        accountType: $1d9f6519fe722240$var$getAccountType(result.account),
                        success: true
                    });
                    return result;
                } else throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$b897bbe2c683def2));
            } else throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$8bea68053103eaeb));
        } catch (e) {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, e);
            atbcMeasurement.end({
                success: false
            }, e);
            throw e;
        }
    }
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ async acquireTokenByCodeAsync(request) {
        this.logger.trace("acquireTokenByCodeAsync called", request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByCodeAsync, request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement?.increment({
            visibilityChangeCount: 0
        });
        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        const silentAuthCodeClient = this.createSilentAuthCodeClient(request.correlationId);
        const silentTokenResult = await silentAuthCodeClient.acquireToken(request).then((response)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: true,
                fromCache: response.fromCache,
                isNativeBroker: response.fromNativeBroker
            });
            return response;
        }).catch((tokenRenewalError)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: false
            }, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        });
        return silentTokenResult;
    }
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenFromCache(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenFromCache, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                const silentCacheClient = this.createSilentCacheClient(commonRequest.correlationId);
                return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentCacheClient.acquireToken.bind(silentCacheClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param cacheLookupPolicy CacheLookupPolicy
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenByRefreshToken(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).RefreshToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).RefreshTokenAndNetwork:
                const silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentRefreshClient.acquireToken.bind(silentRefreshClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenBySilentIframe(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, request.correlationId);
        const silentIframeClient = this.createSilentIframeClient(request.correlationId);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentIframeClient.acquireToken.bind(silentIframeClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(request);
    }
    // #endregion
    // #region Logout
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ async logout(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        this.logger.warning("logout API is deprecated and will be removed in msal-browser v3.0.0. Use logoutRedirect instead.", correlationId);
        return this.logoutRedirect({
            correlationId: correlationId,
            ...logoutRequest
        });
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logoutRedirect(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        (0, $3003b661a087a867$export$62c8f4fdca4df60f)(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true);
        const redirectClient = this.createRedirectClient(correlationId);
        return redirectClient.logout(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        try {
            const correlationId = this.getRequestCorrelationId(logoutRequest);
            (0, $3003b661a087a867$export$4dd091cbdc98b52e)(this.initialized);
            this.browserStorage.setInteractionInProgress(true);
            const popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Creates a cache interaction client to clear broswer cache.
     * @param logoutRequest
     */ async clearCache(logoutRequest) {
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, returning early.");
            return;
        }
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        const cacheClient = this.createSilentCacheClient(correlationId);
        return cacheClient.logout(logoutRequest);
    }
    // #endregion
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnvironment, correlationId, accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$d915baf55d86927d)(username, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        const correlationId = this.getRequestCorrelationId();
        (0, $807e525bbe19e865$export$c55c3d25cf1bcd99)(account, this.browserStorage, correlationId);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$13dd2e33a23839ad)(this.browserStorage, correlationId);
    }
    // #endregion
    /**
     * Hydrates the cache with the tokens from an AuthenticationResult
     * @param result
     * @param request
     * @returns
     */ async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        // Account gets saved to browser storage regardless of native or not
        const accountEntity = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        this.browserStorage.setAccount(accountEntity, result.correlationId);
        if (result.fromNativeBroker) {
            this.logger.verbose("Response was from native broker, storing in-memory");
            // Tokens from native broker are stored in-memory
            return this.nativeInternalStorage.hydrateCache(result, request);
        } else return this.browserStorage.hydrateCache(result, request);
    }
    // #region Helpers
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     */ async acquireTokenNative(request, apiId, accountId) {
        this.logger.trace("acquireTokenNative called");
        if (!this.nativeExtensionProvider) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$7b7357e3538624aa));
        const nativeClient = new (0, $73ad12e7eda75fba$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.nativeExtensionProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
        return nativeClient.acquireToken(request);
    }
    /**
     * Returns boolean indicating if this request can use the native broker
     * @param request
     */ canUseNative(request, accountId) {
        this.logger.trace("canUseNative called");
        if (!(0, $0cbbbdc8324fb5b9$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, request.authenticationScheme)) {
            this.logger.trace("canUseNative: isNativeAvailable returned false, returning false");
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).CONSENT:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).LOGIN:
                this.logger.trace("canUseNative: prompt is compatible with native flow");
                break;
            default:
                this.logger.trace(`canUseNative: prompt = ${request.prompt} is not compatible with native flow, returning false`);
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("canUseNative: nativeAccountId is not available, returning false");
            return false;
        }
        return true;
    }
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ getNativeAccountId(request) {
        const account = request.account || this.getAccount({
            loginHint: request.loginHint,
            sid: request.sid
        }) || this.getActiveAccount();
        return account && account.nativeAccountId || "";
    }
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ createPopupClient(correlationId) {
        return new (0, $674f66832275a4d9$export$43b0fce132d066f4)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ createRedirectClient(correlationId) {
        return new (0, $9c96cbdf0340174c$export$a368977effbc1ed6)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ createSilentIframeClient(correlationId) {
        return new (0, $73772bb7ece2a11b$export$e81c7938bccef977)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).ssoSilent, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ createSilentCacheClient(correlationId) {
        return new (0, $5d2b86ff94a0079d$export$59d4f873ee62d01e)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ createSilentRefreshClient(correlationId) {
        return new (0, $9a90898a8c83eb8c$export$b4a36596822a5d2)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ createSilentAuthCodeClient(correlationId) {
        return new (0, $74f7d1cf2fd01491$export$d7f5ef311b3e9fca)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenByCode, this.performanceClient, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        (0, $3003b661a087a867$export$c7939bfe92ae2787)();
        return this.performanceClient.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ enableAccountStorageEvents() {
        if (typeof window === "undefined") return;
        if (!this.listeningToStorageEvents) {
            this.logger.verbose("Adding account storage listener.");
            this.listeningToStorageEvents = true;
            window.addEventListener("storage", this.handleAccountCacheChange);
        } else this.logger.verbose("Account storage listener already registered.");
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ disableAccountStorageEvents() {
        if (typeof window === "undefined") return;
        if (this.listeningToStorageEvents) {
            this.logger.verbose("Removing account storage listener.");
            window.removeEventListener("storage", this.handleAccountCacheChange);
            this.listeningToStorageEvents = false;
        } else this.logger.verbose("No account storage listener registered.");
    }
    /**
     * Emit account added/removed events when cached accounts are changed in a different tab or frame
     */ handleAccountCacheChange(e) {
        try {
            // Handle active account filter change
            if (e.key?.includes((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS)) // This event has no payload, it only signals cross-tab app instances that the results of calling getActiveAccount() will have changed
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED);
            // Handle account object change
            const cacheValue = e.newValue || e.oldValue;
            if (!cacheValue) return;
            const parsedValue = JSON.parse(cacheValue);
            if (typeof parsedValue !== "object" || !(0, $d6acc4a6126921e0$export$680160523e6bfa6a).isAccountEntity(parsedValue)) return;
            const accountEntity = (0, $0c353f04031c78df$export$996e3ea69314b5c6).toObject(new (0, $d6acc4a6126921e0$export$680160523e6bfa6a)(), parsedValue);
            const accountInfo = accountEntity.getAccountInfo();
            if (!e.oldValue && e.newValue) {
                this.logger.info("Account was added to cache in a different window");
                this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACCOUNT_ADDED, undefined, accountInfo);
            } else if (!e.newValue && e.oldValue) {
                this.logger.info("Account was removed from cache in a different window");
                this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACCOUNT_REMOVED, undefined, accountInfo);
            }
        } catch (e) {
            return;
        }
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.tokenCache;
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.navigationClient = navigationClient;
    }
    /**
     * Returns the configuration object
     */ getConfiguration() {
        return this.config;
    }
    /**
     * Returns the performance client
     */ getPerformanceClient() {
        return this.performanceClient;
    }
    /**
     * Returns the browser env indicator
     */ isBrowserEnv() {
        return this.isBrowserEnvironment;
    }
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ getRequestCorrelationId(request) {
        if (request?.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
    }
    // #endregion
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async loginRedirect(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginRedirect called", correlationId);
        return this.acquireTokenRedirect({
            correlationId: correlationId,
            ...request || (0, $5ff55562d73e0e2b$export$7e12949cd6884193)
        });
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginPopup called", correlationId);
        return this.acquireTokenPopup({
            correlationId: correlationId,
            ...request || (0, $5ff55562d73e0e2b$export$7e12949cd6884193)
        });
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ async acquireTokenSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atsMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilent, correlationId);
        atsMeasurement.add({
            cacheLookupPolicy: request.cacheLookupPolicy,
            scenarioId: request.scenarioId
        });
        $1d9f6519fe722240$var$preflightCheck(this.initialized, atsMeasurement);
        this.logger.verbose("acquireTokenSilent called", correlationId);
        const account = request.account || this.getActiveAccount();
        if (!account) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$87933d7d4116cb12));
        atsMeasurement.add({
            accountType: $1d9f6519fe722240$var$getAccountType(account)
        });
        const thumbprint = {
            clientId: this.config.auth.clientId,
            authority: request.authority || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            scopes: request.scopes,
            homeAccountIdentifier: account.homeAccountId,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid,
            shrOptions: request.shrOptions
        };
        const silentRequestKey = JSON.stringify(thumbprint);
        const cachedResponse = this.activeSilentTokenRequests.get(silentRequestKey);
        if (typeof cachedResponse === "undefined") {
            this.logger.verbose("acquireTokenSilent called for the first time, storing active request", correlationId);
            const response = (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenSilentAsync.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilentAsync, this.logger, this.performanceClient, correlationId)({
                ...request,
                correlationId: correlationId
            }, account).then((result)=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
                atsMeasurement.end({
                    success: true,
                    fromCache: result.fromCache,
                    isNativeBroker: result.fromNativeBroker,
                    cacheLookupPolicy: request.cacheLookupPolicy,
                    accessTokenSize: result.accessToken.length,
                    idTokenSize: result.idToken.length
                });
                return result;
            }).catch((error)=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
                atsMeasurement.end({
                    success: false
                }, error);
                throw error;
            });
            this.activeSilentTokenRequests.set(silentRequestKey, response);
            return {
                ...await response,
                state: request.state
            };
        } else {
            this.logger.verbose("acquireTokenSilent has been called previously, returning the result from the first call", correlationId);
            // Discard measurements for memoized calls, as they are usually only a couple of ms and will artificially deflate metrics
            atsMeasurement.discard();
            return {
                ...await cachedResponse,
                state: request.state
            };
        }
    }
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ async acquireTokenSilentAsync(request, account) {
        const trackPageVisibility = ()=>this.trackPageVisibility(request.correlationId);
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilentAsync, request.correlationId);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, request);
        if (request.correlationId) this.performanceClient.incrementFields({
            visibilityChangeCount: 0
        }, request.correlationId);
        document.addEventListener("visibilitychange", trackPageVisibility);
        const silentRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $550ae9dc1dae1add$export$4c8aa78c426811d4), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeSilentRequest, this.logger, this.performanceClient, request.correlationId)(request, account, this.config, this.performanceClient, this.logger);
        const cacheLookupPolicy = request.cacheLookupPolicy || (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default;
        const result = this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy).catch(async (refreshTokenError)=>{
            const shouldTryToResolveSilently = $1d9f6519fe722240$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy);
            if (shouldTryToResolveSilently) {
                if (!this.activeIframeRequest) {
                    let _resolve;
                    // Always set the active request tracker immediately after checking it to prevent races
                    this.activeIframeRequest = [
                        new Promise((resolve)=>{
                            _resolve = resolve;
                        }),
                        silentRequest.correlationId
                    ];
                    this.logger.verbose("Refresh token expired/invalid or CacheLookupPolicy is set to Skip, attempting acquire token by iframe.", silentRequest.correlationId);
                    return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest).then((iframeResult)=>{
                        _resolve(true);
                        return iframeResult;
                    }).catch((e)=>{
                        _resolve(false);
                        throw e;
                    }).finally(()=>{
                        this.activeIframeRequest = undefined;
                    });
                } else if (cacheLookupPolicy !== (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Skip) {
                    const [activePromise, activeCorrelationId] = this.activeIframeRequest;
                    this.logger.verbose(`Iframe request is already in progress, awaiting resolution for request with correlationId: ${activeCorrelationId}`, silentRequest.correlationId);
                    const awaitConcurrentIframeMeasure = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AwaitConcurrentIframe, silentRequest.correlationId);
                    awaitConcurrentIframeMeasure.add({
                        awaitIframeCorrelationId: activeCorrelationId
                    });
                    const activePromiseResult = await activePromise;
                    awaitConcurrentIframeMeasure.end({
                        success: activePromiseResult
                    });
                    if (activePromiseResult) {
                        this.logger.verbose(`Parallel iframe request with correlationId: ${activeCorrelationId} succeeded. Retrying cache and/or RT redemption`, silentRequest.correlationId);
                        // Retry cache lookup and/or RT exchange after iframe completes
                        return this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy);
                    } else {
                        this.logger.info(`Iframe request with correlationId: ${activeCorrelationId} failed. Interaction is required.`);
                        // If previous iframe request failed, it's unlikely to succeed this time. Throw original error.
                        throw refreshTokenError;
                    }
                } else {
                    // Cache policy set to skip and another iframe request is already in progress
                    this.logger.warning("Another iframe request is currently in progress and CacheLookupPolicy is set to Skip. This may result in degraded performance and/or reliability for both calls. Please consider changing the CacheLookupPolicy to take advantage of request queuing and token cache.", silentRequest.correlationId);
                    return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
                }
            } else // Error cannot be silently resolved or iframe renewal is not allowed, interaction required
            throw refreshTokenError;
        });
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, response);
            if (request.correlationId) this.performanceClient.addFields({
                fromCache: response.fromCache,
                isNativeBroker: response.fromNativeBroker
            }, request.correlationId);
            return response;
        }).catch((tokenRenewalError)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", trackPageVisibility);
        });
    }
    /**
     * AcquireTokenSilent without the iframe fallback. This is used to enable the correct fallbacks in cases where there's a potential for multiple silent requests to be made in parallel and prevent those requests from making concurrent iframe requests.
     * @param silentRequest
     * @param cacheLookupPolicy
     * @returns
     */ async acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy) {
        if ((0, $0cbbbdc8324fb5b9$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, silentRequest.authenticationScheme) && silentRequest.account.nativeAccountId) {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from native platform");
            return this.acquireTokenNative(silentRequest, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow).catch(async (e)=>{
                // If native token acquisition fails for availability reasons fallback to web flow
                if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                    this.logger.verbose("acquireTokenSilent - native platform unavailable, falling back to web flow");
                    this.nativeExtensionProvider = undefined; // Prevent future requests from continuing to attempt
                    // Cache will not contain tokens, given that previous WAM requests succeeded. Skip cache and RT renewal and go straight to iframe renewal
                    throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).tokenRefreshRequired);
                }
                throw e;
            });
        } else {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from web flow");
            return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenFromCache.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenFromCache, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy).catch((cacheError)=>{
                if (cacheLookupPolicy === (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken) throw cacheError;
                this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_NETWORK_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, silentRequest);
                return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenByRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy);
            });
        }
    }
}
/**
 * Determines whether an error thrown by the refresh token endpoint can be resolved without interaction
 * @param refreshTokenError
 * @param silentRequest
 * @param cacheLookupPolicy
 * @returns
 */ function $1d9f6519fe722240$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy) {
    const noInteractionRequired = !(refreshTokenError instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba) && // For refresh token errors, bad_token does not always require interaction (silently resolvable)
    refreshTokenError.subError !== (0, $84767569d86b0bc0$exports).badToken);
    // Errors that result when the refresh token needs to be replaced
    const refreshTokenRefreshRequired = refreshTokenError.errorCode === (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).INVALID_GRANT_ERROR || refreshTokenError.errorCode === (0, $6be88bbe69356b76$exports).tokenRefreshRequired;
    // Errors that may be resolved before falling back to interaction (through iframe renewal)
    const isSilentlyResolvable = noInteractionRequired && refreshTokenRefreshRequired || refreshTokenError.errorCode === (0, $84767569d86b0bc0$exports).noTokensFound || refreshTokenError.errorCode === (0, $84767569d86b0bc0$exports).refreshTokenExpired;
    // Only these policies allow for an iframe renewal attempt
    const tryIframeRenewal = (0, $5ff55562d73e0e2b$export$736180706fb122ee).includes(cacheLookupPolicy);
    return isSilentlyResolvable && tryIframeRenewal;
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $61425a9d4424b5fd$export$caa3bc10e51dd7ee(error) {
    return error.status !== undefined;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $03968fc19372b2df$export$cee94b20506f02aa {
    constructor(clientId, clientCapabilities, crypto, logger){
        this.clientId = clientId;
        this.clientCapabilities = clientCapabilities;
        this.crypto = crypto;
        this.logger = logger;
    }
    toNaaTokenRequest(request) {
        let extraParams;
        if (request.extraQueryParameters === undefined) extraParams = new Map();
        else extraParams = new Map(Object.entries(request.extraQueryParameters));
        const correlationId = request.correlationId || this.crypto.createNewGuid();
        const requestBuilder = new (0, $7d3a00eb36d325b3$export$882078dd8a9e0bfa)(correlationId);
        const claims = requestBuilder.addClientCapabilitiesToClaims(request.claims, this.clientCapabilities);
        const scopes = request.scopes || (0, $7c375ae106b964be$export$893b1b5b686d84ef);
        const tokenRequest = {
            platformBrokerId: request.account?.homeAccountId,
            clientId: this.clientId,
            authority: request.authority,
            scope: scopes.join(" "),
            correlationId: correlationId,
            claims: !(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(claims) ? claims : undefined,
            state: request.state,
            authenticationScheme: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            extraParameters: extraParams
        };
        return tokenRequest;
    }
    fromNaaTokenResponse(request, response, reqTimestamp) {
        if (!response.token.id_token || !response.token.access_token) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).nullOrEmptyToken);
        const expiresOn = new Date((reqTimestamp + (response.token.expires_in || 0)) * 1000);
        const idTokenClaims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(response.token.id_token, this.crypto.base64Decode);
        const account = this.fromNaaAccountInfo(response.account, response.token.id_token, idTokenClaims);
        const scopes = response.token.scope || request.scope;
        const authenticationResult = {
            authority: response.token.authority || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: response.token.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: response.token.access_token,
            fromCache: false,
            expiresOn: expiresOn,
            tokenType: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            correlationId: request.correlationId,
            extExpiresOn: expiresOn,
            state: request.state
        };
        return authenticationResult;
    }
    /*
     *  export type AccountInfo = {
     *     homeAccountId: string;
     *     environment: string;
     *     tenantId: string;
     *     username: string;
     *     localAccountId: string;
     *     name?: string;
     *     idToken?: string;
     *     idTokenClaims?: TokenClaims & {
     *         [key: string]:
     *             | string
     *             | number
     *             | string[]
     *             | object
     *             | undefined
     *             | unknown;
     *     };
     *     nativeAccountId?: string;
     *     authorityType?: string;
     * };
     */ fromNaaAccountInfo(fromAccount, idToken, idTokenClaims) {
        const effectiveIdTokenClaims = idTokenClaims || fromAccount.idTokenClaims;
        const localAccountId = fromAccount.localAccountId || effectiveIdTokenClaims?.oid || effectiveIdTokenClaims?.sub || "";
        const tenantId = fromAccount.tenantId || effectiveIdTokenClaims?.tid || "";
        const homeAccountId = fromAccount.homeAccountId || `${localAccountId}.${tenantId}`;
        const username = fromAccount.username || effectiveIdTokenClaims?.preferred_username || "";
        const name = fromAccount.name || effectiveIdTokenClaims?.name;
        const tenantProfiles = new Map();
        const tenantProfile = (0, $54830df9a5d9a12c$export$924857724cb21ba4)(homeAccountId, localAccountId, tenantId, effectiveIdTokenClaims);
        tenantProfiles.set(tenantId, tenantProfile);
        const account = {
            homeAccountId: homeAccountId,
            environment: fromAccount.environment,
            tenantId: tenantId,
            username: username,
            localAccountId: localAccountId,
            name: name,
            idToken: idToken,
            idTokenClaims: effectiveIdTokenClaims,
            tenantProfiles: tenantProfiles
        };
        return account;
    }
    /**
     *
     * @param error BridgeError
     * @returns AuthError, ClientAuthError, ClientConfigurationError, ServerError, InteractionRequiredError
     */ fromBridgeError(error) {
        if ((0, $61425a9d4424b5fd$export$caa3bc10e51dd7ee)(error)) switch(error.status){
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).UserCancel:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).userCanceled);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).NoNetwork:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).noNetworkConnectivity);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).AccountUnavailable:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).noAccountFound);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).Disabled:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).nestedAppAuthBridgeDisabled);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).NestedAppAuthUnavailable:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)(error.code || (0, $6be88bbe69356b76$exports).nestedAppAuthBridgeDisabled, error.description);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).TransientError:
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).PersistentError:
                return new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(error.code, error.description);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).UserInteractionRequired:
                return new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(error.code, error.description);
            default:
                return new (0, $0ff8310393c4d2db$export$145273558d58e0ac)(error.code, error.description);
        }
        else return new (0, $0ff8310393c4d2db$export$145273558d58e0ac)("unknown_error", "An unknown error occurred");
    }
    /**
     * Returns an AuthenticationResult from the given cache items
     *
     * @param account
     * @param idToken
     * @param accessToken
     * @param reqTimestamp
     * @returns
     */ toAuthenticationResultFromCache(account, idToken, accessToken, request, correlationId) {
        if (!idToken || !accessToken) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).nullOrEmptyToken);
        const idTokenClaims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(idToken.secret, this.crypto.base64Decode);
        const scopes = accessToken.target || request.scopes.join(" ");
        const authenticationResult = {
            authority: accessToken.environment || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: idToken.secret,
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken.secret,
            fromCache: true,
            expiresOn: new Date(Number(accessToken.expiresOn) * 1000),
            tokenType: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            correlationId: correlationId,
            extExpiresOn: new Date(Number(accessToken.extendedExpiresOn) * 1000),
            state: request.state
        };
        return authenticationResult;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * NestedAppAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $f43fb4a2edb734fd$export$81a70490e660273a = {
    unsupportedMethod: {
        code: "unsupported_method",
        desc: "This method is not supported in nested app environment."
    }
};
class $f43fb4a2edb734fd$export$7c79ceb488783308 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        Object.setPrototypeOf(this, $f43fb4a2edb734fd$export$7c79ceb488783308.prototype);
        this.name = "NestedAppAuthError";
    }
    static createUnsupportedError() {
        return new $f43fb4a2edb734fd$export$7c79ceb488783308($f43fb4a2edb734fd$export$81a70490e660273a.unsupportedMethod.code, $f43fb4a2edb734fd$export$81a70490e660273a.unsupportedMethod.desc);
    }
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $8ac21447ebc7e19d$export$2319deb182e38ab3 {
    constructor(operatingContext){
        this.operatingContext = operatingContext;
        const proxy = this.operatingContext.getBridgeProxy();
        if (proxy !== undefined) this.bridgeProxy = proxy;
        else throw new Error("unexpected: bridgeProxy is undefined");
        // Set the configuration.
        this.config = operatingContext.getConfig();
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = operatingContext.isBrowserEnvironment() ? new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(this.logger, this.performanceClient, true) : (0, $dd88ab1a0b4d3851$export$865f57d401606752);
        // Initialize the browser storage class.
        this.browserStorage = this.operatingContext.isBrowserEnvironment() ? new (0, $d3981d5134d5331a$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, (0, $77bb430f4568f6e8$export$2b9ebf6f25078cc0)(this.config.auth)) : (0, $d3981d5134d5331a$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger);
        this.eventHandler = new (0, $9f61ab73b66f619a$export$ce0ba2422a1c7815)(this.logger);
        this.nestedAppAuthAdapter = new (0, $03968fc19372b2df$export$cee94b20506f02aa)(this.config.auth.clientId, this.config.auth.clientCapabilities, this.browserCrypto, this.logger);
        // Set the active account if available
        const accountContext = this.bridgeProxy.getAccountContext();
        if (accountContext) {
            const correlationId = (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
            const cachedAccount = (0, $807e525bbe19e865$export$4f9234baf34abd0)(accountContext, this.logger, this.browserStorage, correlationId);
            (0, $807e525bbe19e865$export$c55c3d25cf1bcd99)(cachedAccount, this.browserStorage, correlationId);
        }
    }
    /**
     * Factory function to create a new instance of NestedAppAuthController
     * @param operatingContext
     * @returns Promise<IController>
     */ static async createController(operatingContext) {
        const controller = new $8ac21447ebc7e19d$export$2319deb182e38ab3(operatingContext);
        return Promise.resolve(controller);
    }
    /**
     * Specific implementation of initialize function for NestedAppAuthController
     * @returns
     */ initialize() {
        // do nothing not required by this controller
        return Promise.resolve();
    }
    /**
     * Validate the incoming request and add correlationId if not present
     * @param request
     * @returns
     */ ensureValidRequest(request) {
        if (request?.correlationId) return request;
        return {
            ...request,
            correlationId: this.browserCrypto.createNewGuid()
        };
    }
    /**
     * Internal implementation of acquireTokenInteractive flow
     * @param request
     * @returns
     */ async acquireTokenInteractive(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenPopup, validRequest.correlationId);
        atPopupMeasurement?.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenInteractive(naaRequest);
            const result = {
                ...this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp)
            };
            // cache the tokens in the response
            await this.hydrateCache(result, request);
            this.browserStorage.setActiveAccount(result.account, result.correlationId);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.end({
                success: true,
                requestId: result.requestId
            });
            return result;
        } catch (e) {
            const error = this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e);
            throw error;
        }
    }
    /**
     * Internal implementation of acquireTokenSilent flow
     * @param request
     * @returns
     */ async acquireTokenSilentInternal(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, validRequest);
        // Look for tokens in the cache first
        const result = await this.acquireTokenFromCache(validRequest);
        if (result) {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
            return result;
        }
        // proceed with acquiring tokens via the host
        const ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SsoSilent, validRequest.correlationId);
        ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0
        });
        ssoSilentMeasurement?.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenSilent(naaRequest);
            const result = this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp);
            // cache the tokens in the response
            await this.hydrateCache(result, request);
            this.browserStorage.setActiveAccount(result.account, result.correlationId);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
            ssoSilentMeasurement?.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            ssoSilentMeasurement?.end({
                success: true,
                requestId: result.requestId
            });
            return result;
        } catch (e) {
            const error = this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, e);
            ssoSilentMeasurement?.end({
                success: false
            }, e);
            throw error;
        }
    }
    /**
     * acquires tokens from cache
     * @param request
     * @returns
     */ async acquireTokenFromCache(request) {
        const atsMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilent, request.correlationId);
        atsMeasurement?.add({
            nestedAppAuthRequest: true
        });
        // if the request has claims, we cannot look up in the cache
        if (request.claims) {
            this.logger.verbose("Claims are present in the request, skipping cache lookup");
            return null;
        }
        // respect cache lookup policy
        let result = null;
        switch(request.cacheLookupPolicy){
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                result = await this.acquireTokenFromCacheInternal(request);
                break;
            default:
                return null;
        }
        if (result) {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
            atsMeasurement?.add({
                accessTokenSize: result?.accessToken.length,
                idTokenSize: result?.idToken.length
            });
            atsMeasurement?.end({
                success: true
            });
            return result;
        }
        this.logger.error("Cached tokens are not found for the account, proceeding with silent token request.");
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null);
        atsMeasurement?.end({
            success: false
        });
        return null;
    }
    /**
     *
     * @param request
     * @returns
     */ async acquireTokenFromCacheInternal(request) {
        const correlationId = request.correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        const accountContext = this.bridgeProxy.getAccountContext();
        let currentAccount = null;
        if (accountContext) {
            const hubAccount = (0, $807e525bbe19e865$export$4f9234baf34abd0)(accountContext, this.logger, this.browserStorage, correlationId);
            // always prioritize for hub account context, the reqirement of `request.account` will be removed soon
            currentAccount = hubAccount || request.account;
        }
        // fall back to brokering if no cached account is found
        if (!currentAccount) {
            this.logger.verbose("No active account found, falling back to the host");
            return Promise.resolve(null);
        }
        this.logger.verbose("active account found, attempting to acquire token silently");
        const authRequest = {
            ...request,
            correlationId: correlationId,
            authority: request.authority || currentAccount.environment,
            scopes: request.scopes?.length ? request.scopes : [
                ...(0, $7c375ae106b964be$export$893b1b5b686d84ef)
            ]
        };
        // fetch access token and check for expiry
        const tokenKeys = this.browserStorage.getTokenKeys();
        const cachedAccessToken = this.browserStorage.getAccessToken(currentAccount, authRequest, tokenKeys, currentAccount.tenantId, this.performanceClient);
        // If there is no access token, log it and return null
        if (!cachedAccessToken) {
            this.logger.verbose("No cached access token found");
            return Promise.resolve(null);
        } else if ((0, $0a4a8f22735f9ff5$exports).wasClockTurnedBack(cachedAccessToken.cachedAt) || (0, $0a4a8f22735f9ff5$exports).isTokenExpired(cachedAccessToken.expiresOn, this.config.system.tokenRenewalOffsetSeconds)) {
            this.logger.verbose("Cached access token has expired");
            return Promise.resolve(null);
        }
        const cachedIdToken = this.browserStorage.getIdToken(currentAccount, authRequest.correlationId, tokenKeys, currentAccount.tenantId, this.performanceClient);
        if (!cachedIdToken) {
            this.logger.verbose("No cached id token found");
            return Promise.resolve(null);
        }
        return this.nestedAppAuthAdapter.toAuthenticationResultFromCache(currentAccount, cachedIdToken, cachedAccessToken, authRequest, authRequest.correlationId);
    }
    /**
     * acquireTokenPopup flow implementation
     * @param request
     * @returns
     */ async acquireTokenPopup(request) {
        return this.acquireTokenInteractive(request);
    }
    /**
     * acquireTokenRedirect flow is not supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenRedirect(request) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenSilent flow implementation
     * @param silentRequest
     * @returns
     */ async acquireTokenSilent(silentRequest) {
        return this.acquireTokenSilentInternal(silentRequest);
    }
    /**
     * Hybrid flow is not currently supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenByCode(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenNative flow is not currently supported in nested app auth
     * @param request
     * @param apiId
     * @param accountId
     */ acquireTokenNative(request, apiId, accountId // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenByRefreshToken flow is not currently supported in nested app auth
     * @param commonRequest
     * @param silentRequest
     */ acquireTokenByRefreshToken(commonRequest, silentRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addPerformanceCallback(callback) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removePerformanceCallback(callbackId) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    enableAccountStorageEvents() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    disableAccountStorageEvents() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        const correlationId = (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        return (0, $807e525bbe19e865$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnv(), correlationId, accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        const correlationId = (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        return (0, $807e525bbe19e865$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        const correlationId = (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        return (0, $807e525bbe19e865$export$d915baf55d86927d)(username, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        const correlationId = (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        return (0, $807e525bbe19e865$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        const correlationId = (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        return (0, $807e525bbe19e865$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        /*
         * StandardController uses this to allow the developer to set the active account
         * in the nested app auth scenario the active account is controlled by the app hosting the nested app
         */ const correlationId = (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        return (0, $807e525bbe19e865$export$c55c3d25cf1bcd99)(account, this.browserStorage, correlationId);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        const correlationId = (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        return (0, $807e525bbe19e865$export$13dd2e33a23839ad)(this.browserStorage, correlationId);
    }
    // #endregion
    handleRedirectPromise(hash // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return Promise.resolve(null);
    }
    loginPopup(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return this.acquireTokenInteractive(request || (0, $5ff55562d73e0e2b$export$7e12949cd6884193));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRedirect(request) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    logout(logoutRequest) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutRedirect(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutPopup(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    ssoSilent(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    request) {
        return this.acquireTokenSilentInternal(request);
    }
    getTokenCache() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initializeWrapperLibrary(sku, version) {
        /*
         * Standard controller uses this to set the sku and version of the wrapper library in the storage
         * we do nothing here
         */ return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setNavigationClient(navigationClient) {
        this.logger.warning("setNavigationClient is not supported in nested app auth");
    }
    getConfiguration() {
        return this.config;
    }
    isBrowserEnv() {
        return this.operatingContext.isBrowserEnvironment();
    }
    getBrowserCrypto() {
        return this.browserCrypto;
    }
    getPerformanceClient() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    getRedirectResponse() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async clearCache(logoutRequest) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        const accountEntity = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        this.browserStorage.setAccount(accountEntity, result.correlationId);
        return this.browserStorage.hydrateCache(result, request);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $54e1c8c64fb5e616$export$414d5e42be8c56db(config, request) {
    const standard = new (0, $36cb4f619f94d121$export$f39c23bbfed89e6e)(config);
    await standard.initialize();
    return (0, $1d9f6519fe722240$export$e9d1ef1cb8705404).createController(standard, request);
}
async function $54e1c8c64fb5e616$export$6a1d744b364856f2(config) {
    const standard = new (0, $36cb4f619f94d121$export$f39c23bbfed89e6e)(config);
    const nestedApp = new (0, $769cd552162fdff8$export$a2170d4e3f010950)(config);
    const operatingContexts = [
        standard.initialize(),
        nestedApp.initialize()
    ];
    await Promise.all(operatingContexts);
    if (nestedApp.isAvailable() && config.auth.supportsNestedAppAuth) return (0, $8ac21447ebc7e19d$export$2319deb182e38ab3).createController(nestedApp);
    else if (standard.isAvailable()) return (0, $1d9f6519fe722240$export$e9d1ef1cb8705404).createController(standard);
    else // Since neither of the actual operating contexts are available keep the UnknownOperatingContextController
    return null;
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ class $5579c29889b267e7$export$89f4855ef88b7920 {
    /**
     * Creates StandardController and passes it to the PublicClientApplication
     *
     * @param configuration {Configuration}
     */ static async createPublicClientApplication(configuration) {
        const controller = await (0, $54e1c8c64fb5e616$export$414d5e42be8c56db)(configuration);
        const pca = new $5579c29889b267e7$export$89f4855ef88b7920(configuration, controller);
        return pca;
    }
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     * @param IController Optional parameter to explictly set the controller. (Will be removed when we remove public constructor)
     */ constructor(configuration, controller){
        this.controller = controller || new (0, $1d9f6519fe722240$export$e9d1ef1cb8705404)(new (0, $36cb4f619f94d121$export$f39c23bbfed89e6e)(configuration));
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest}
     */ async initialize(request) {
        return this.controller.initialize(request);
    }
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopup(request) {
        return this.controller.acquireTokenPopup(request);
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ acquireTokenRedirect(request) {
        return this.controller.acquireTokenRedirect(request);
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthenticationResult} object
     */ acquireTokenSilent(silentRequest) {
        return this.controller.acquireTokenSilent(silentRequest);
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenByCode(request) {
        return this.controller.acquireTokenByCode(request);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.controller.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        return this.controller.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        return this.controller.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.controller.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ enableAccountStorageEvents() {
        this.controller.enableAccountStorageEvents();
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ disableAccountStorageEvents() {
        this.controller.disableAccountStorageEvents();
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return this.controller.getAccount(accountFilter);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByHomeId(homeAccountId) {
        return this.controller.getAccountByHomeId(homeAccountId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByLocalId(localId) {
        return this.controller.getAccountByLocalId(localId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param userName
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByUsername(userName) {
        return this.controller.getAccountByUsername(userName);
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.controller.getAllAccounts(accountFilter);
    }
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ handleRedirectPromise(hash) {
        return this.controller.handleRedirectPromise(hash);
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        return this.controller.loginPopup(request);
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ loginRedirect(request) {
        return this.controller.loginRedirect(request);
    }
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ logout(logoutRequest) {
        return this.controller.logout(logoutRequest);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ logoutRedirect(logoutRequest) {
        return this.controller.logoutRedirect(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        return this.controller.logoutPopup(logoutRequest);
    }
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ssoSilent(request) {
        return this.controller.ssoSilent(request);
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.controller.getTokenCache();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.controller.getLogger();
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.controller.setLogger(logger);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        this.controller.setActiveAccount(account);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return this.controller.getActiveAccount();
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        return this.controller.initializeWrapperLibrary(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.controller.setNavigationClient(navigationClient);
    }
    /**
     * Returns the configuration object
     * @internal
     */ getConfiguration() {
        return this.controller.getConfiguration();
    }
    /**
     * Hydrates cache with the tokens and account in the AuthenticationResult object
     * @param result
     * @param request - The request object that was used to obtain the AuthenticationResult
     * @returns
     */ async hydrateCache(result, request) {
        return this.controller.hydrateCache(result, request);
    }
    /**
     * Clears tokens and account from the browser cache.
     * @param logoutRequest
     */ clearCache(logoutRequest) {
        return this.controller.clearCache(logoutRequest);
    }
}
/**
 * creates NestedAppAuthController and passes it to the PublicClientApplication,
 * falls back to StandardController if NestedAppAuthController is not available
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $5579c29889b267e7$export$210078d2745a65ac(configuration) {
    const nestedAppAuth = new (0, $769cd552162fdff8$export$a2170d4e3f010950)(configuration);
    await nestedAppAuth.initialize();
    if (nestedAppAuth.isAvailable()) {
        const controller = new (0, $8ac21447ebc7e19d$export$2319deb182e38ab3)(nestedAppAuth);
        return new $5579c29889b267e7$export$89f4855ef88b7920(configuration, controller);
    }
    return $5579c29889b267e7$export$f28b97cfb2f3098(configuration);
}
/**
 * creates PublicClientApplication using StandardController
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $5579c29889b267e7$export$f28b97cfb2f3098(configuration) {
    const pca = new $5579c29889b267e7$export$89f4855ef88b7920(configuration);
    await pca.initialize();
    return pca;
}




/**
 * ENUM TYPE DEF
 */ 
class $54bbbf96c1cde9f8$export$a49ce3bbbd0d81e5 {
    constructor(initialVal, isMandatory){
        this.isMandatory = false;
        this.initialVal = initialVal;
        this.isMandatory = isMandatory;
    }
    get value() {
        return this.hasPendingChanges() ? this.pendingVal : this.initialVal;
    }
    set value(val) {
        this.pendingVal = val !== this.initialVal ? val : undefined;
    }
    isValid(val) {
        return !this.isMandatory || (0, $834b9e85ded96783$export$a079a83b07f794bf)(val === undefined ? this.value : val);
    }
    hasPendingChanges() {
        return this.pendingVal !== undefined;
    }
}
const $54bbbf96c1cde9f8$export$e21ffcc1af22774e = (inputLength)=>{
    if (inputLength) {
        if (inputLength >= 30) return 12;
        else if (inputLength >= 12) return 8;
    }
    return 4;
};
class $54bbbf96c1cde9f8$export$a7cc3b15d9fb13b extends $54bbbf96c1cde9f8$export$a49ce3bbbd0d81e5 {
    constructor(initialVal, inputLabel, inputRange, isOptional){
        super(initialVal, !isOptional);
        this.rawInputValue = (0, $834b9e85ded96783$export$d0d57df0e0611bbf)(initialVal);
        this.label = inputLabel;
        this.range = inputRange;
    }
    getNumInputValue(inputVal) {
        inputVal = inputVal !== undefined ? inputVal : super.value;
        return inputVal === '' || inputVal === '-' ? 0 : parseFloat(inputVal);
    }
    checkInputRange(inputVal) {
        const numVal = this.getNumInputValue(inputVal);
        const lowerRangeMatch = isNaN(this.range?.min) || numVal >= this.range.min;
        const upperRangeMatch = isNaN(this.range?.max) || numVal <= this.range.max;
        const rangeMatch = lowerRangeMatch && upperRangeMatch;
        if (!rangeMatch) console.warn(`${this.label} input: out of range value ${numVal}`);
        return rangeMatch;
    }
    checkInputValidity(inputVal) {
        const isValid = !isNaN(inputVal) || inputVal === '' || inputVal === '-';
        if (!isValid) console.warn(`${this.label} input: invalid value ${inputVal}`);
        return isValid;
    }
    isValid() {
        return super.isValid(this.inputValue) && this.checkInputValidity(this.inputValue) && this.checkInputRange(this.inputValue);
    }
    get value() {
        return this.getNumInputValue();
    }
    set value(value) {
        const isValidInput = this.checkInputValidity(value) && this.checkInputRange(value);
        super.value = isValidInput ? value : this.value;
        this.rawInputValue = super.value;
    }
    get inputValue() {
        return this.rawInputValue;
    }
    // temporary setter while editing field, must be saved on focus out by calling value setter
    set inputValue(rawInput) {
        const isValidInput = this.checkInputValidity(rawInput);
        this.rawInputValue = isValidInput ? rawInput : this.rawInputValue;
    }
}
class $54bbbf96c1cde9f8$export$7a2d5763061d09f3 {
    initField(fieldId, field) {
        this.fields[fieldId] = field;
    }
    getField(fieldId) {
        if (!this.fields[fieldId]) console.warn(`[FieldsCollection] undefined field ${fieldId}`);
        return this.fields[fieldId];
    }
    getFieldValue(fieldId) {
        return this.getField(fieldId)?.value;
    }
    setFieldValue(fieldId, fieldVal) {
        return this.fields[fieldId].value = fieldVal;
    }
    isValidField(fieldId) {
        return this.getField(fieldId)?.isValid();
    }
    isValid() {
        return !Object.entries(this.fields).find(([key, field])=>{
            const isValid = field.isValid();
            if (!isValid) console.warn(`[FieldsCollection] invalid field ${key}`);
            return !isValid;
        });
    }
    hasPendingChanges() {
        return !!Object.values(this.fields).find((f)=>f.hasPendingChanges());
    }
    // exporting only modified fields
    getPendingChanges() {
        return Object.fromEntries(Object.entries(this.fields).filter(([, v])=>v.hasPendingChanges()).map(([k, v])=>v instanceof $54bbbf96c1cde9f8$export$7a2d5763061d09f3 ? [
                k,
                v.getPendingChanges()
            ] : [
                k,
                v.value
            ]));
    }
    // exporting all fields
    toStub() {
        return Object.fromEntries(Object.entries(this.fields).map(([k, v])=>[
                k,
                v instanceof $54bbbf96c1cde9f8$export$7a2d5763061d09f3 ? v.toStub() : v.value
            ]));
    }
    constructor(){
        this.fields = {};
    }
}



var $baba9bdf33bc9eca$export$fc850f719b5599d5 = /*#__PURE__*/ function(ShapeType) {
    ShapeType["RECTANGLE"] = "Rectangle";
    ShapeType["CYLINDER"] = "Cylinder";
    return ShapeType;
}({});
const $baba9bdf33bc9eca$export$c78b4673549b3bf9 = [
    "Rectangle",
    "Cylinder"
];
const $baba9bdf33bc9eca$export$2ba33b17e8aed329 = "Rectangle";
class $baba9bdf33bc9eca$export$8f93e34dde8009bd extends (0, $54bbbf96c1cde9f8$export$7a2d5763061d09f3) {
    constructor(stub){
        super();
        this.initFromStub(stub);
    }
    get diameter() {
        return this.getFieldValue('diameter');
    }
    set diameter(val) {
        this.setFieldValue('diameter', val);
    }
    get depth() {
        return this.getFieldValue('depth');
    }
    set depth(val) {
        this.setFieldValue('depth', val);
    }
    isValid() {
        return this.isValidField('depth') && this.isValidField('diameter');
    }
    initFromStub(stub) {
        this.initField('depth', new (0, $54bbbf96c1cde9f8$export$a7cc3b15d9fb13b)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(stub?.depth), 'Depth'));
        this.initField('diameter', new (0, $54bbbf96c1cde9f8$export$a7cc3b15d9fb13b)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(stub?.diameter), 'Diameter'));
    }
    // force exporting all fields when at least one has been modified
    getPendingChanges() {
        return super.hasPendingChanges() ? super.toStub() : {};
    }
}
class $baba9bdf33bc9eca$export$3b161c1935260ac7 extends (0, $54bbbf96c1cde9f8$export$7a2d5763061d09f3) {
    constructor(stub){
        super();
        this.initFromStub(stub);
    }
    get width() {
        return this.getFieldValue('width');
    }
    set width(val) {
        this.setFieldValue('width', val);
    }
    get height() {
        return this.getFieldValue('height');
    }
    set height(val) {
        this.setFieldValue('height', val);
    }
    get length() {
        return this.getFieldValue('length');
    }
    set length(val) {
        this.setFieldValue('length', val);
    }
    isValid() {
        return this.isValidField('width') && this.isValidField('height') && this.isValidField('length');
    }
    initFromStub(stub) {
        this.initField('height', new (0, $54bbbf96c1cde9f8$export$a7cc3b15d9fb13b)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(stub?.height), 'Height'));
        this.initField('width', new (0, $54bbbf96c1cde9f8$export$a7cc3b15d9fb13b)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(stub?.width), 'Width'));
        this.initField('length', new (0, $54bbbf96c1cde9f8$export$a7cc3b15d9fb13b)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(stub?.length), 'Length'));
    }
    // force exporting all fields when at least one has been modified
    getPendingChanges() {
        return super.hasPendingChanges() ? super.toStub() : {};
    }
}


var $fdac710428712a0c$export$846b5e744bfb83f8 = /*#__PURE__*/ function(BimType) {
    BimType["TOWER"] = "Tower";
    BimType["GROUND"] = "Ground";
    return BimType;
}({});
var $fdac710428712a0c$export$13e3300c8755380c = /*#__PURE__*/ function(TowerType) {
    TowerType["STRUCTURE"] = "Structure";
    TowerType["PANEL"] = "Panel";
    TowerType["DISH"] = "Dish";
    TowerType["RRU"] = "Rru";
    TowerType["OMNI"] = "Omni";
    TowerType["DIPOLE"] = "Dipole";
    TowerType["YAGI"] = "Yagi";
    TowerType["BOX"] = "Box";
    TowerType["RAU"] = "Rau";
    TowerType["OTHER"] = "Other";
    TowerType["GPS"] = "Gps";
    TowerType["AWL"] = "Awl";
    TowerType["HEADFRAME"] = "Headframe";
    TowerType["MOUNTS"] = "Mounts";
    return TowerType;
}({});
var $fdac710428712a0c$export$ec4ceab56f21b51 = /*#__PURE__*/ function(GroundType) {
    GroundType["FENCE"] = "Fence";
    GroundType["SHELTER"] = "Shelter";
    GroundType["LEASE"] = "Lease";
    GroundType["ELECTRICAL_BOX"] = "ElectricalBox";
    GroundType["CABLE_TRAY"] = "CableTray";
    return GroundType;
}({});
const $fdac710428712a0c$export$88221fdabbd13752 = [
    "Ground",
    "Tower"
];
const $fdac710428712a0c$export$4c71c0167fb21741 = [
    "Awl",
    "Gps",
    "Structure",
    "Box",
    "Rau",
    "Rru",
    "Other",
    "Headframe",
    "Mounts"
];
const $fdac710428712a0c$export$6c2628d56db252d4 = [
    "Awl",
    "Box",
    "Dipole",
    "Dish",
    "Gps",
    "Headframe",
    "Mounts",
    "Omni",
    "Other",
    "Panel",
    "Rau",
    "Rru",
    "Structure",
    "Yagi"
];
const $fdac710428712a0c$export$21e4b986824bfef4 = [
    "CableTray",
    "ElectricalBox",
    "Fence",
    "Lease",
    "Shelter"
];
const $fdac710428712a0c$export$52f52a5c05885a9b = {
    ["Dipole"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE
    ],
    ["Panel"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE
    ],
    ["Yagi"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE
    ],
    ["Dish"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Omni"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Awl"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Box"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Gps"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Headframe"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Mounts"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Other"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Rau"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Rru"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Structure"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["CableTray"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["ElectricalBox"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Fence"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Lease"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ],
    ["Shelter"]: [
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE,
        (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER
    ]
};
const $fdac710428712a0c$export$648b5c2be518feea = ()=>({
        uid: '',
        makeModel: '',
        manufacturer: '',
        esa: '',
        nadModel: '',
        nadManufacturer: '',
        typeClass: '',
        type: '',
        shape: '',
        shapeDimensions: null,
        portsConfiguration: null
    });
var $fdac710428712a0c$export$e955f760fe56f4ac = /*#__PURE__*/ function(MeshReferenceType) {
    MeshReferenceType["HyperBim"] = "HyperBIM";
    MeshReferenceType["Attachment"] = "attachment";
    return MeshReferenceType;
}({});


var $3b11ea43c4ed5c54$export$49006cd5d177f365 = /*#__PURE__*/ function(NOTIF_TYPE) {
    NOTIF_TYPE[NOTIF_TYPE["SUCCESS"] = 0] = "SUCCESS";
    NOTIF_TYPE[NOTIF_TYPE["ERROR"] = 1] = "ERROR";
    return NOTIF_TYPE;
}({});
class $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0 {
    static showNotification(msg, type) {
        $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0.setNotification({
            msg: msg,
            type: type
        });
    }
    static success(msg) {
        const type = 0;
        $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0.setNotification({
            msg: msg,
            type: type
        });
    }
    static error(msg) {
        const type = 1;
        $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0.setNotification({
            msg: msg,
            type: type
        });
    }
    static clearNotification() {
        $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0.setNotification({
            msg: '',
            type: null
        });
    }
}


function $834b9e85ded96783$export$e51c951f24e12e68(s) {
    switch(s.toLowerCase()){
        case '':
        case '0':
        case 'n':
        case 'no':
        case 'off':
        case 'false':
            return false;
        default:
            return true;
    }
}
const $834b9e85ded96783$export$7116961ee0f13ffe = (req)=>{
    let curlReq = `curl -X '${req.method}' `;
    curlReq += "'" + req.url + "' ";
    for (const element of req.headers.entries())curlReq += `-H '${element[0]}:${element[1]}' `;
    return curlReq;
};
const $834b9e85ded96783$var$UPLOAD_STEPS_MAPPING = [
    'CREATE_ATTACHMENT',
    'BLOB_UPLOAD',
    'FINALISE'
];
const $834b9e85ded96783$export$a5575dbeeffdad98 = async (file, modelId)=>{
    let uploadStep = 0;
    console.log(`[FileUpload] STEP #${uploadStep + 1}: createAttachment`);
    let uploadData;
    const reply = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.createAttachment(modelId, 'file', file.name);
    if (reply.status === 201) {
        uploadData = await reply.json();
        const attachmentId = uploadData.id;
        uploadStep++;
        console.log(`[FileUpload] STEP #${uploadStep + 1}: uploadAttachment for attachmendId: ${attachmentId}`);
        const blobUploadRequest = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.uploadAttachment(uploadData.upload, file, true);
        const finaliseRequest = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.finaliseAttachment(modelId, attachmentId, true);
        try {
            const reply2 = await fetch(blobUploadRequest);
            if (reply2?.status === 201) {
                uploadStep++;
                console.log(`[FileUpload] STEP #${uploadStep + 1}: finaliseAttachment for bim: ${modelId} attachment: ${attachmentId} `);
                const reply3 = await fetch(finaliseRequest);
                if (reply3?.status === 204) uploadStep++;
            }
        // return resp
        } catch (error) {
            console.error(error);
        }
        uploadStep < 3 && (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).error('File uploading partially FAILED');
        uploadStep < 2 && console.warn(`UPLOAD STEP ${uploadStep}: ${$834b9e85ded96783$var$UPLOAD_STEPS_MAPPING[uploadStep]} FAILED => try manual upload using curl`, $834b9e85ded96783$export$7116961ee0f13ffe(blobUploadRequest) + `--upload-file ${file.name}`);
        uploadStep < 3 && console.warn(`UPLOAD STEP ${uploadStep}: ${$834b9e85ded96783$var$UPLOAD_STEPS_MAPPING[uploadStep]} FAILED => try manual upload using curl`, $834b9e85ded96783$export$7116961ee0f13ffe(finaliseRequest) + `--upload-file ${file.name}`);
    } else // show error notification
    (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).error('File uploading FAILED');
    if (uploadStep === 3) (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).success('File uploaded');
    return uploadData;
};
async function $834b9e85ded96783$export$f862cea947f5d50f(request) {
    const response = await fetch(request);
    const responseData = await response.json();
    response.ok;
    return responseData.data;
}
const $834b9e85ded96783$export$324ca61d40111c16 = (tagsArr)=>{
    const tags = {};
    // conert tags array to dict
    tagsArr.forEach((tag)=>tags[tag] = '');
    return tags;
};
const $834b9e85ded96783$export$76a9664b93be647a = 2;
const $834b9e85ded96783$export$4b9672654250d8bc = (val, decimals = $834b9e85ded96783$export$76a9664b93be647a)=>{
    const accuracy = Math.pow(10, decimals);
    return Math.round(val * accuracy) / accuracy;
};
const $834b9e85ded96783$export$d0d57df0e0611bbf = (val, defaultVal = '')=>val !== undefined ? val : defaultVal;
const $834b9e85ded96783$export$a079a83b07f794bf = (val)=>isNaN(val) && typeof val === 'string' ? val.length > 0 : val !== undefined && val !== '';
const $834b9e85ded96783$export$dd6a4ed3ae49aab2 = (input)=>{
    const [min, max] = input.split('-');
    return {
        min: Number.parseInt(min),
        max: Number.parseInt(max)
    };
};
const $834b9e85ded96783$export$d10b4bc54aaefed4 = (target, source)=>{
    const [min1, max1] = target.electricalTilt.split('-');
    const [min2, max2] = source.electricalTilt.split('-');
    const min = Math.min(Number.parseFloat(min1), Number.parseFloat(min2));
    const max = Math.max(Number.parseFloat(max1 ?? min1), Number.parseFloat(max2 ?? min2));
    target.electricalTilt = `${min}-${max}`;
};
const $834b9e85ded96783$export$529397c806e3595c = (typeClass, type)=>typeClass && type && (typeClass === (0, $fdac710428712a0c$export$846b5e744bfb83f8).GROUND || (0, $fdac710428712a0c$export$4c71c0167fb21741).includes(type));


const $e8e02a06888dee3c$export$9a38963e63df6020 = '/node_modules/@sitesee/scene-viewer/static';
const $e8e02a06888dee3c$export$1e80ee9430241cc2 = "https://sitesee-internal-platform-services-cnstn-prod.azure-api.net/internal-bim";
const $e8e02a06888dee3c$export$7f8197e7d83dcce = (0, $834b9e85ded96783$export$e51c951f24e12e68)(undefined ?? '');



const $bc849b5adfe80d87$var$BIM_ENDPOINT = '/api/models';
const $bc849b5adfe80d87$var$APD_ENDPOINT = '/api/apd';
class $bc849b5adfe80d87$export$c892f6e8c0b873f6 {
    // sets used API
    makeDefault() {
        $bc849b5adfe80d87$export$c892f6e8c0b873f6.used = this;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async addDefaultHeaders(_headers) {}
    async fetchItems(textFilter, itemsPerPage = 8, pageId = '') {
        const { baseUrl: baseUrl } = this;
        const endpoint = `${$bc849b5adfe80d87$var$BIM_ENDPOINT}`;
        const queryParams = {
            includeThumbnailPresignedUrl: 'true',
            ...textFilter ? {
                text: textFilter
            } : {}
        };
        console.log('[BIM API] query parameters:', queryParams);
        const urlArgs = `?${new URLSearchParams(queryParams)}`;
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        if (itemsPerPage) {
            headers.append('x-sitesee-page-size', `${itemsPerPage}`);
            pageId.length && headers.append('x-sitesee-page-token', `${pageId}`);
        }
        const req = new Request(baseUrl + endpoint + urlArgs, {
            headers: headers
        });
        return await fetch(req);
    }
    async fetchDetails(modelId, includeParams = true) {
        const endpoint = `${this.baseUrl}${$bc849b5adfe80d87$var$BIM_ENDPOINT}/${modelId}`;
        const params = includeParams ? '?includeParameters=true' : '';
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        // add specific header
        headers.append('Cache-Control', 'no-cache');
        const req = new Request(endpoint + params, {
            headers: headers
        });
        return await fetch(req);
    }
    async buildGlbRequest(modelId, modelParams, refresh) {
        const endpoint = `${this.baseUrl}${$bc849b5adfe80d87$var$BIM_ENDPOINT}/${modelId}`;
        const data = {
            accept: 'model/gltf-binary',
            getLink: true,
            refresh: refresh,
            arguments: modelParams ? modelParams : {}
        };
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        // add specific headers
        headers.append('Cache-Control', 'no-cache');
        headers.append('Content-Type', 'application/json');
        const linkRequest = new Request(`${endpoint}/specialise`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: headers
        });
        const { base64: base64, url: url } = await (0, $834b9e85ded96783$export$f862cea947f5d50f)(linkRequest);
        if (base64) // Was unable to get a link, simply have whole file
        return new Request(`data:model/gltf-binary;base64,${base64}`);
        else if (url) return new Request(url);
        else throw new Error('Unexpected response from backend');
    }
    async fetchApd(nadManufacturer, nadModel, dryRun = false) {
        const searchParams = new URLSearchParams({
            manufacturer: nadManufacturer,
            model: nadModel
        });
        const endpoint = `${this.baseUrl}${$bc849b5adfe80d87$var$APD_ENDPOINT}/antennaPatterns?${searchParams}`;
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        const req = new Request(endpoint, {
            method: 'GET',
            headers: headers
        });
        return dryRun ? req : await fetch(req);
    }
    async createItem(data) {
        const endpoint = `${this.baseUrl}${$bc849b5adfe80d87$var$BIM_ENDPOINT}`;
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        // add specific headers
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', '*/*');
        const req = new Request(endpoint, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: headers
        });
        return await fetch(req);
    }
    async updateItem(modelId, data) {
        const endpoint = `${this.baseUrl}${$bc849b5adfe80d87$var$BIM_ENDPOINT}/${modelId}/`;
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        // add specific headers
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', '*/*');
        const req = new Request(endpoint, {
            method: 'PATCH',
            body: JSON.stringify(data),
            headers: headers
        });
        return await fetch(req);
    }
    async deleteItem(modelId) {
        const endpoint = `${this.baseUrl}${$bc849b5adfe80d87$var$BIM_ENDPOINT}/${modelId}/`;
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        // add specific headers
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', '*/*');
        const req = new Request(endpoint, {
            method: 'DELETE',
            headers: headers
        });
        return await fetch(req);
    }
    async pushTag(modelId, tagName) {
        const endpoint = `${this.baseUrl}${$bc849b5adfe80d87$var$BIM_ENDPOINT}/${modelId}/tags/${tagName}`;
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        // add specific headers
        headers.append('Content-Type', 'text/plain');
        headers.append('Accept', '*/*');
        const data = ''; // TODO put tag value?
        const req = new Request(endpoint, {
            method: 'PUT',
            body: data,
            headers: headers
        });
        return await fetch(req);
    }
    async popTag(modelId, tagName) {
        const endpoint = `${$bc849b5adfe80d87$var$BIM_ENDPOINT}/${modelId}/tags/${tagName}`;
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        // add specific headers
        headers.append('Accept', '*/*');
        const req = new Request(this.baseUrl + endpoint, {
            method: 'DELETE',
            headers: headers
        });
        return await fetch(req);
    }
    async listAttachments(modelId) {
        const endpoint = `${$bc849b5adfe80d87$var$BIM_ENDPOINT}/${modelId}/attachments`;
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        const req = new Request(this.baseUrl + endpoint, {
            headers: headers
        });
        return await fetch(req);
    }
    async getAttachment(modelId, attachmentId) {
        const { baseUrl: baseUrl } = this;
        const endpoint = `${$bc849b5adfe80d87$var$BIM_ENDPOINT}/${modelId}/attachments/${attachmentId}`;
        const urlArgs = '?includePresignedUrl=true';
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        const req = new Request(baseUrl + endpoint + urlArgs, {
            headers: headers
        });
        return await fetch(req);
    }
    async deleteAttachment(modelId, attachmentId) {
        const { baseUrl: baseUrl } = this;
        const endpoint = `${$bc849b5adfe80d87$var$BIM_ENDPOINT}/${modelId}/attachments/${attachmentId}`;
        const urlArgs = '';
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        // add specific headers
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', '*/*');
        const req = new Request(baseUrl + endpoint + urlArgs, {
            method: 'DELETE',
            headers: headers
        });
        return await fetch(req);
    }
    /**
     * AttachmentUpload(STEP #1): get blob store upload url
     */ async createAttachment(modelId, fileType, fileName) {
        const { baseUrl: baseUrl } = this;
        const endpoint = `${$bc849b5adfe80d87$var$BIM_ENDPOINT}/${modelId}/attachments`;
        const urlArgs = '';
        const data = {
            type: fileType,
            title: fileName
        };
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        // add specific headers
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', '*/*');
        const req = new Request(baseUrl + endpoint + urlArgs, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: headers
        });
        return await fetch(req);
    }
    /**
     * AttachmentUpload(STEP #2): send file to blob store using upload infos from createAttachment request
     */ async uploadAttachment(uploadSettings, fileContent, dryRun = false) {
        const headers = new Headers();
        headers.append('content-length', `${fileContent.size}`);
        Object.entries(uploadSettings.headers).forEach(([key, val])=>headers.append(key, val));
        const req = new Request(uploadSettings.url, {
            method: uploadSettings.method.toUpperCase(),
            mode: 'cors',
            headers: headers,
            body: fileContent
        });
        if (!dryRun) try {
            return await fetch(req);
        } catch (error) {
            console.error(error);
        }
        return req;
    }
    /**
     * AttachmentUpload(STEP #3): Finalise uploading after createAttachment and uploadAttachment have been called
     */ async finaliseAttachment(bimId, attachmentId, dryRun = false) {
        const { baseUrl: baseUrl } = this;
        const endpoint = `${$bc849b5adfe80d87$var$BIM_ENDPOINT}/${bimId}/attachments/${attachmentId}/finalise`;
        const urlArgs = '';
        const headers = new Headers();
        await this.addDefaultHeaders(headers);
        // add specific headers
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', '*/*');
        const req = new Request(baseUrl + endpoint + urlArgs, {
            method: 'POST',
            headers: headers
        });
        if (!dryRun) try {
            return await fetch(req);
        } catch (error) {
            console.error(error);
        }
        return req;
    }
}
class $bc849b5adfe80d87$export$55e756c867e644fb extends $bc849b5adfe80d87$export$c892f6e8c0b873f6 {
    static getSingleton() {
        return $bc849b5adfe80d87$export$55e756c867e644fb.singleton || new $bc849b5adfe80d87$export$55e756c867e644fb();
    }
    constructor(){
        super();
        this.baseUrl = '';
        $bc849b5adfe80d87$export$55e756c867e644fb.singleton = this;
    }
}
class $bc849b5adfe80d87$export$e39db57f15f15bf2 extends $bc849b5adfe80d87$export$c892f6e8c0b873f6 {
    static getSingleton() {
        return $bc849b5adfe80d87$export$e39db57f15f15bf2.singleton || new $bc849b5adfe80d87$export$e39db57f15f15bf2();
    }
    async addDefaultHeaders(headers) {
        const { accessToken: accessToken } = await (0, $d94f86a26f94c76a$export$1e26e6335737a8e1)();
        headers.append('Authorization', `Bearer ${accessToken}`);
    }
    constructor(){
        super(), this.msalInstance = (0, $d94f86a26f94c76a$export$4768dfa0f7d78057);
        this.baseUrl = (0, $e8e02a06888dee3c$export$1e80ee9430241cc2);
        $bc849b5adfe80d87$export$e39db57f15f15bf2.singleton = this;
    }
}


const $d94f86a26f94c76a$export$384a6feef7a9a4f6 = "9ff2c1bd-070b-48aa-9905-15985e03eb9d";
const $d94f86a26f94c76a$var$bimApiAppName = "internal-bim-cnstn-prod";
var $d94f86a26f94c76a$export$cc0e003816b34e6b = /*#__PURE__*/ function(MsalLoginType) {
    MsalLoginType["POPUP"] = "popup";
    MsalLoginType["REDIRECT"] = "redirect";
    MsalLoginType["SILENT"] = "silent";
    return MsalLoginType;
}({});
const $d94f86a26f94c76a$export$a7c3064c595ea4b7 = "popup";
const $d94f86a26f94c76a$export$f6d610d2730cbf1a = {
    auth: {
        clientId: "24c89370-c29f-4c39-8f7f-83eb1e0ac251",
        authority: `https://login.microsoftonline.com/${$d94f86a26f94c76a$export$384a6feef7a9a4f6}/`,
        redirectUri: '/',
        postLogoutRedirectUri: '/'
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    },
    system: {
        allowNativeBroker: false
    }
};
// Add here scopes for id token to be used at MS Identity Platform endpoints.
const $d94f86a26f94c76a$var$bimApiRequest = {
    scopes: [
        `api://${$d94f86a26f94c76a$var$bimApiAppName}/.default`
    ]
};
const $d94f86a26f94c76a$export$be6c432b2463c5eb = $d94f86a26f94c76a$var$bimApiRequest;
const $d94f86a26f94c76a$export$4768dfa0f7d78057 = new (0, $5579c29889b267e7$export$89f4855ef88b7920)($d94f86a26f94c76a$export$f6d610d2730cbf1a);
async function $d94f86a26f94c76a$export$aade1390fcc98ec3(pca = $d94f86a26f94c76a$export$4768dfa0f7d78057) {
    await pca.initialize();
    const accounts = pca.getAllAccounts();
    if (accounts.length > 0) {
        const account = accounts.find((acc)=>acc.tenantId === $d94f86a26f94c76a$export$384a6feef7a9a4f6) ?? accounts[0];
        if (accounts.length > 1) console.debug('Multiple accounts found, guessed account for tenant, using:', {
            account: `${account.name} (${account.username})`,
            tenantId: account.tenantId,
            localAccountId: account.localAccountId,
            homeAccountId: account.homeAccountId
        });
        pca.setActiveAccount(account);
    }
    pca.addEventCallback((event)=>{
        if (event.eventType === (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS && event.payload) {
            const payload = event.payload;
            const account = payload.account;
            pca.setActiveAccount(account);
        }
    }, [
        (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS
    ]);
    (0, $bc849b5adfe80d87$export$e39db57f15f15bf2).getSingleton().makeDefault();
    return pca;
}
async function $d94f86a26f94c76a$export$1e26e6335737a8e1(instance = $d94f86a26f94c76a$export$4768dfa0f7d78057, request = $d94f86a26f94c76a$var$bimApiRequest, method = "silent") {
    const account = instance.getActiveAccount();
    if (!account) throw Error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
    if (method === "silent") try {
        return await instance.acquireTokenSilent({
            account: account,
            ...request
        });
    } catch (err) {
        if (err instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
            console.debug('Unable to retrieve token silently, falling back to popup');
            // fallback to interaction when silent call fails
            return $d94f86a26f94c76a$export$1e26e6335737a8e1(instance, request, "popup");
        }
        throw err;
    }
    else if (method === "popup") return instance.acquireTokenPopup(request);
    else if (method === "redirect") throw new Error('MSAL login redirect not yet supported');
    else throw new Error(`Unknown MSAL login type when getting auth: ${method}`);
}


// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $4FZD0 = parcelRequire("4FZD0");
function $8ec30e4d54713c84$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4FZD0.default)(theme.components[name].defaultProps, props);
}



'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $942f413c6b94358c$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $acw62.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $942f413c6b94358c$var$maybeReactUseSyncExternalStore = $acw62.useSyncExternalStore;
function $942f413c6b94358c$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $acw62.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $acw62.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $acw62.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $942f413c6b94358c$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $942f413c6b94358c$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $1f701f7d1726bc9a$export$2e2bcd8739ae039)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $8ec30e4d54713c84$export$2e2bcd8739ae039)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme: theme
    });
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $942f413c6b94358c$var$maybeReactUseSyncExternalStore !== undefined ? $942f413c6b94358c$var$useMediaQueryNew : $942f413c6b94358c$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}


parcelRequire("acw62");


var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $0c87a2f38cd49c7a$export$2e2bcd8739ae039() {
    const theme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)((0, $jR9F1.default));
    return theme[0, $4jPsi.default] || theme;
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $bOOlK = parcelRequire("bOOlK");

var $9dZwz = parcelRequire("9dZwz");
var $hcz0Q = parcelRequire("hcz0Q");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b85125360b778ad2$var$_excluded = [
    "className",
    "component"
];
function $b85125360b778ad2$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $bOOlK.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $9dZwz.default));
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $hcz0Q.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $1En50.default)(_extendSxProp, $b85125360b778ad2$var$_excluded);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, (0, $8nd05.default)({
            as: component,
            ref: ref,
            className: (0, $9QePP.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $bnost = parcelRequire("bnost");

var $ijOKP = parcelRequire("ijOKP");

var $4jPsi = parcelRequire("4jPsi");

var $beCSm = parcelRequire("beCSm");
const $cf808af3a1d339c9$var$boxClasses = (0, $beCSm.default)('MuiBox', [
    'root'
]);
var $cf808af3a1d339c9$export$2e2bcd8739ae039 = $cf808af3a1d339c9$var$boxClasses;


'use client';
const $00a20d475386f68c$var$defaultTheme = (0, $ijOKP.default)();
const $00a20d475386f68c$var$Box = (0, $b85125360b778ad2$export$2e2bcd8739ae039)({
    themeId: (0, $4jPsi.default),
    defaultTheme: $00a20d475386f68c$var$defaultTheme,
    defaultClassName: (0, $cf808af3a1d339c9$export$2e2bcd8739ae039).root,
    generateClassName: (0, $bnost.default).generate
});
var $00a20d475386f68c$export$2e2bcd8739ae039 = $00a20d475386f68c$var$Box;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $acw62 = parcelRequire("acw62");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c8b9145416f64bb2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $27fddc0219860a83$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $72d5a979b2ad8bc9$export$2e2bcd8739ae039 = (0, $27fddc0219860a83$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0c5a7e8ccbc07697$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0c5a7e8ccbc07697$export$2e2bcd8739ae039 = $0c5a7e8ccbc07697$var$useEventCallback;


'use client';
var $331f3746e6346411$export$2e2bcd8739ae039 = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $dd1092ee97d527c8$var$UNINITIALIZED = {};
function $dd1092ee97d527c8$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($dd1092ee97d527c8$var$UNINITIALIZED);
    if (ref.current === $dd1092ee97d527c8$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $acw62 = parcelRequire("acw62");
'use client';
const $a0e38fa988f617e0$var$EMPTY = [];
function $a0e38fa988f617e0$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $a0e38fa988f617e0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $fcd4c6205d65c7df$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $fcd4c6205d65c7df$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $fcd4c6205d65c7df$export$2e2bcd8739ae039() {
    const timeout = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)($fcd4c6205d65c7df$export$786b4da70f00938b.create).current;
    (0, $a0e38fa988f617e0$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $15e2b45accdb3531$var$hadKeyboardEvent = true;
let $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
const $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout = new (0, $fcd4c6205d65c7df$export$786b4da70f00938b)();
const $15e2b45accdb3531$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $15e2b45accdb3531$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $15e2b45accdb3531$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $15e2b45accdb3531$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $15e2b45accdb3531$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $15e2b45accdb3531$var$handlePointerDown() {
    $15e2b45accdb3531$var$hadKeyboardEvent = false;
}
function $15e2b45accdb3531$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($15e2b45accdb3531$var$hadFocusVisibleRecently) $15e2b45accdb3531$var$hadKeyboardEvent = true;
    }
}
function $15e2b45accdb3531$var$prepare(doc) {
    doc.addEventListener('keydown', $15e2b45accdb3531$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $15e2b45accdb3531$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $15e2b45accdb3531$var$hadKeyboardEvent || $15e2b45accdb3531$var$focusTriggersKeyboardModality(target);
}
function $15e2b45accdb3531$export$2e2bcd8739ae039() {
    const ref = $acw62.useCallback((node)=>{
        if (node != null) $15e2b45accdb3531$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $acw62.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $15e2b45accdb3531$var$hadFocusVisibleRecently = true;
            $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($15e2b45accdb3531$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $8fc8239a3939454e$export$2e2bcd8739ae039 = (0, $15e2b45accdb3531$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);



var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1En50.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;



var $9QePP = parcelRequire("9QePP");

var $jjlaj = parcelRequire("jjlaj");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $cb2cd8c78d72bd92$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $9QePP.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $9QePP.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $cb2cd8c78d72bd92$export$2e2bcd8739ae039 = $cb2cd8c78d72bd92$var$Ripple;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $755fb323846f60d4$export$b464606f735ab902(slot) {
    return (0, $4Cod0.default)('MuiTouchRipple', slot);
}
const $755fb323846f60d4$var$touchRippleClasses = (0, $beCSm.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $755fb323846f60d4$export$2e2bcd8739ae039 = $755fb323846f60d4$var$touchRippleClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $855224273a002a0f$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $855224273a002a0f$var$_ = (t)=>t, $855224273a002a0f$var$_t, $855224273a002a0f$var$_t2, $855224273a002a0f$var$_t3, $855224273a002a0f$var$_t4;
const $855224273a002a0f$var$DURATION = 550;
const $855224273a002a0f$export$95d0c9356b2231a3 = 80;
const $855224273a002a0f$var$enterKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t || ($855224273a002a0f$var$_t = $855224273a002a0f$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $855224273a002a0f$var$exitKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t2 || ($855224273a002a0f$var$_t2 = $855224273a002a0f$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $855224273a002a0f$var$pulsateKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t3 || ($855224273a002a0f$var$_t3 = $855224273a002a0f$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $855224273a002a0f$export$f6b7418508c72c25 = (0, $d8seH.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $855224273a002a0f$export$676cfe7b12693c4b = (0, $d8seH.default)((0, $cb2cd8c78d72bd92$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($855224273a002a0f$var$_t4 || ($855224273a002a0f$var$_t4 = $855224273a002a0f$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $755fb323846f60d4$export$2e2bcd8739ae039).rippleVisible, $855224273a002a0f$var$enterKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $755fb323846f60d4$export$2e2bcd8739ae039).child, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childLeaving, $855224273a002a0f$var$exitKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childPulsate, $855224273a002a0f$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $855224273a002a0f$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $1En50.default)(props, $855224273a002a0f$var$_excluded);
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $9QePP.default)(classes.ripple, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $9QePP.default)(classes.rippleVisible, (0, $755fb323846f60d4$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $9QePP.default)(classes.ripplePulsate, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $9QePP.default)(classes.child, (0, $755fb323846f60d4$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $9QePP.default)(classes.childLeaving, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $9QePP.default)(classes.childPulsate, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $855224273a002a0f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($855224273a002a0f$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$f6b7418508c72c25, (0, $8nd05.default)({
        className: (0, $9QePP.default)((0, $755fb323846f60d4$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $855224273a002a0f$export$2e2bcd8739ae039 = $855224273a002a0f$var$TouchRipple;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $42d7f65840078ec1$export$fccb0498dcd99783(slot) {
    return (0, $4Cod0.default)('MuiButtonBase', slot);
}
const $42d7f65840078ec1$var$buttonBaseClasses = (0, $beCSm.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $42d7f65840078ec1$export$2e2bcd8739ae039 = $42d7f65840078ec1$var$buttonBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a35786d89db9dda$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $4a35786d89db9dda$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $42d7f65840078ec1$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a35786d89db9dda$export$7ec0dcc5e3cdcd36 = (0, $d8seH.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $42d7f65840078ec1$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a35786d89db9dda$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $1En50.default)(props, $4a35786d89db9dda$var$_excluded);
    const buttonRef = $acw62.useRef(null);
    const rippleRef = $acw62.useRef(null);
    const handleRippleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $acw62.useRef(false);
    const handleKeyDown = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $8nd05.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $4a35786d89db9dda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a35786d89db9dda$export$7ec0dcc5e3cdcd36, (0, $8nd05.default)({
        as: ComponentProp,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ayMG0.jsx)((0, $855224273a002a0f$export$2e2bcd8739ae039), (0, $8nd05.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $4a35786d89db9dda$export$2e2bcd8739ae039 = $4a35786d89db9dda$var$ButtonBase;



var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $11f546081ba06ace$export$5a6f9035944c8119(slot) {
    return (0, $4Cod0.default)('MuiButton', slot);
}
const $11f546081ba06ace$var$buttonClasses = (0, $beCSm.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $11f546081ba06ace$export$2e2bcd8739ae039 = $11f546081ba06ace$var$buttonClasses;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8639dcef822d5d4c$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $8639dcef822d5d4c$export$2e2bcd8739ae039 = $8639dcef822d5d4c$var$ButtonGroupContext;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $25b1293270900846$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $25b1293270900846$export$2e2bcd8739ae039 = $25b1293270900846$var$ButtonGroupButtonContext;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a02bab8c70a697b$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $4a02bab8c70a697b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`,
            `${variant}Size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $11f546081ba06ace$export$5a6f9035944c8119), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $4a02bab8c70a697b$var$commonIconStyles = (ownerState)=>(0, $8nd05.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $4a02bab8c70a697b$var$ButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $8nd05.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $8nd05.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).focusVisible}`]: (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).disabled}`]: (0, $8nd05.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $4a02bab8c70a697b$var$ButtonStartIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$ButtonEndIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $8639dcef822d5d4c$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $25b1293270900846$export$2e2bcd8739ae039));
    const resolvedProps = (0, $4FZD0.default)(contextProps, inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $1En50.default)(props, $4a02bab8c70a697b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $4a02bab8c70a697b$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a02bab8c70a697b$var$ButtonRoot, (0, $8nd05.default)({
        ownerState: ownerState,
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $4a02bab8c70a697b$export$2e2bcd8739ae039 = $4a02bab8c70a697b$var$Button;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $024a60f892d3fa61$export$46f01d01378ec5a2(slot) {
    return (0, $4Cod0.default)('MuiDivider', slot);
}
const $024a60f892d3fa61$var$dividerClasses = (0, $beCSm.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $024a60f892d3fa61$export$2e2bcd8739ae039 = $024a60f892d3fa61$var$dividerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f875d00b2138afe4$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $f875d00b2138afe4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $024a60f892d3fa61$export$46f01d01378ec5a2), classes);
};
const $f875d00b2138afe4$var$DividerRoot = (0, $d8seH.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $kSnzZ.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $f875d00b2138afe4$var$DividerWrapper = (0, $d8seH.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $f875d00b2138afe4$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $1En50.default)(props, $f875d00b2138afe4$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $f875d00b2138afe4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $f875d00b2138afe4$var$Divider.muiSkipListHighlight = true;
var $f875d00b2138afe4$export$2e2bcd8739ae039 = $f875d00b2138afe4$var$Divider;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $23fa506264c010ed$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $23fa506264c010ed$export$2e2bcd8739ae039 = $23fa506264c010ed$var$getOverlayAlpha;



var $1iOpW = parcelRequire("1iOpW");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ec306d48089c2c9$export$29cdb466b9b6f20b(slot) {
    return (0, $4Cod0.default)('MuiPaper', slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $beCSm.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $4ec306d48089c2c9$export$2e2bcd8739ae039 = $4ec306d48089c2c9$var$paperClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $595185d0d7275c3b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4ec306d48089c2c9$export$29cdb466b9b6f20b), classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $d8seH.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $8nd05.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $8nd05.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $kSnzZ.alpha)('#fff', (0, $23fa506264c010ed$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $kSnzZ.alpha)('#fff', (0, $23fa506264c010ed$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $1En50.default)(props, $595185d0d7275c3b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($595185d0d7275c3b$var$PaperRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other));
});
var $595185d0d7275c3b$export$2e2bcd8739ae039 = $595185d0d7275c3b$var$Paper;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $hcz0Q = parcelRequire("hcz0Q");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $837556bdf75d281f$export$24c1f8f60cbac79e(slot) {
    return (0, $4Cod0.default)('MuiTypography', slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $beCSm.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $837556bdf75d281f$export$2e2bcd8739ae039 = $837556bdf75d281f$var$typographyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2531239e3a525689$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $837556bdf75d281f$export$24c1f8f60cbac79e), classes);
};
const $2531239e3a525689$export$140e2f5526d3cad8 = (0, $d8seH.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $2531239e3a525689$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $2531239e3a525689$var$transformDeprecatedColors = (color)=>{
    return $2531239e3a525689$var$colorTransformations[color] || color;
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $2531239e3a525689$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $hcz0Q.default)((0, $8nd05.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping } = props, other = (0, $1En50.default)(props, $2531239e3a525689$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || 'span';
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2531239e3a525689$export$140e2f5526d3cad8, (0, $8nd05.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
var $2531239e3a525689$export$2e2bcd8739ae039 = $2531239e3a525689$var$Typography;








// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e40d2047b7c1e09d$export$5e8702d71474f093(slot) {
    return (0, $4Cod0.default)('MuiIconButton', slot);
}
const $e40d2047b7c1e09d$var$iconButtonClasses = (0, $beCSm.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $e40d2047b7c1e09d$export$2e2bcd8739ae039 = $e40d2047b7c1e09d$var$iconButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $71c322247f7fbf93$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $71c322247f7fbf93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e40d2047b7c1e09d$export$5e8702d71474f093), classes);
};
const $71c322247f7fbf93$var$IconButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $8nd05.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $8nd05.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $8nd05.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $e40d2047b7c1e09d$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $71c322247f7fbf93$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $1En50.default)(props, $71c322247f7fbf93$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $71c322247f7fbf93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$IconButtonRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $71c322247f7fbf93$export$2e2bcd8739ae039 = $71c322247f7fbf93$var$IconButton;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bOOlK = parcelRequire("bOOlK");

var $3z1Ay = parcelRequire("3z1Ay");



var $6o2lr = parcelRequire("6o2lr");

var $9dZwz = parcelRequire("9dZwz");
const $a0abf5ad226c4fb0$var$_excluded = [
    "ownerState"
], $a0abf5ad226c4fb0$var$_excluded2 = [
    "variants"
], $a0abf5ad226c4fb0$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $a0abf5ad226c4fb0$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $a0abf5ad226c4fb0$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $a0abf5ad226c4fb0$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $a0abf5ad226c4fb0$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $a0abf5ad226c4fb0$export$35e57303dbd8a66 = (0, $6o2lr.default)();
const $a0abf5ad226c4fb0$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a0abf5ad226c4fb0$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $a0abf5ad226c4fb0$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $a0abf5ad226c4fb0$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $a0abf5ad226c4fb0$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $1En50.default)(_ref, $a0abf5ad226c4fb0$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $8nd05.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$a0abf5ad226c4fb0$var$processStyleArg(resolvedStyle, (0, $8nd05.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $1En50.default)(resolvedStylesArg, $a0abf5ad226c4fb0$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $8nd05.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $8nd05.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $a0abf5ad226c4fb0$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $a0abf5ad226c4fb0$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $a0abf5ad226c4fb0$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $a0abf5ad226c4fb0$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $9dZwz.default)((0, $8nd05.default)({}, props, {
            theme: $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $bOOlK.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $a0abf5ad226c4fb0$var$defaultOverridesResolver($a0abf5ad226c4fb0$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $1En50.default)(inputOptions, $a0abf5ad226c4fb0$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $a0abf5ad226c4fb0$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($a0abf5ad226c4fb0$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $bOOlK.default)(tag, (0, $8nd05.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $a0abf5ad226c4fb0$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $a0abf5ad226c4fb0$var$processStyleArg(stylesArg, (0, $8nd05.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $a0abf5ad226c4fb0$var$processStyleArg(slotStyle, (0, $8nd05.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $a0abf5ad226c4fb0$var$processStyleArg({
                    variants: themeVariants
                }, (0, $8nd05.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $0016d2a363b4c314$var$styled = (0, $a0abf5ad226c4fb0$export$2e2bcd8739ae039)();
var $0016d2a363b4c314$export$2e2bcd8739ae039 = $0016d2a363b4c314$var$styled;




'use client';
function $9f45a3834bb6880f$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $8ec30e4d54713c84$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $hcz0Q = parcelRequire("hcz0Q");

var $6o2lr = parcelRequire("6o2lr");

var $3OJTQ = parcelRequire("3OJTQ");

var $cKRCq = parcelRequire("cKRCq");

var $ayMG0 = parcelRequire("ayMG0");
const $d70594339ba23534$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $d70594339ba23534$var$defaultTheme = (0, $6o2lr.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $d70594339ba23534$var$defaultCreateStyledComponent = (0, $0016d2a363b4c314$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $d70594339ba23534$var$useThemePropsDefault(props) {
    return (0, $9f45a3834bb6880f$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $d70594339ba23534$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $d70594339ba23534$var$joinChildren(children, separator) {
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $acw62.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $d70594339ba23534$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $d70594339ba23534$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $3OJTQ.handleBreakpoints)({
        theme: theme
    }, (0, $3OJTQ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $cKRCq.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $cKRCq.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$d70594339ba23534$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $cKRCq.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3z1Ay.default)(styles, (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $3OJTQ.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $d70594339ba23534$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $d70594339ba23534$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $d70594339ba23534$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($d70594339ba23534$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $hcz0Q.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $1En50.default)(props, $d70594339ba23534$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            children: divider ? $d70594339ba23534$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $231d58234d437bc0$var$Stack = (0, $d70594339ba23534$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $231d58234d437bc0$export$2e2bcd8739ae039 = $231d58234d437bc0$var$Stack;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e848e543ed3bf349$var$TableContext = /*#__PURE__*/ $acw62.createContext();
var $e848e543ed3bf349$export$2e2bcd8739ae039 = $e848e543ed3bf349$var$TableContext;



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3e2d01fd3f88b8c8$export$315cb19215f77ce0(slot) {
    return (0, $4Cod0.default)('MuiTable', slot);
}
const $3e2d01fd3f88b8c8$var$tableClasses = (0, $beCSm.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $3e2d01fd3f88b8c8$export$2e2bcd8739ae039 = $3e2d01fd3f88b8c8$var$tableClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22fefd5f207422b3$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $22fefd5f207422b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3e2d01fd3f88b8c8$export$315cb19215f77ce0), classes);
};
const $22fefd5f207422b3$var$TableRoot = (0, $d8seH.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $8nd05.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $22fefd5f207422b3$var$defaultComponent = 'table';
const $22fefd5f207422b3$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $22fefd5f207422b3$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $1En50.default)(props, $22fefd5f207422b3$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $22fefd5f207422b3$var$useUtilityClasses(ownerState);
    const table = $acw62.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e848e543ed3bf349$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$TableRoot, (0, $8nd05.default)({
            as: component,
            role: component === $22fefd5f207422b3$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $22fefd5f207422b3$export$2e2bcd8739ae039 = $22fefd5f207422b3$var$Table;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $09fe163f52c859c8$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
var $09fe163f52c859c8$export$2e2bcd8739ae039 = $09fe163f52c859c8$var$Tablelvl2Context;



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9a6742b7048414d1$export$98bd2a9b566ec665(slot) {
    return (0, $4Cod0.default)('MuiTableBody', slot);
}
const $9a6742b7048414d1$var$tableBodyClasses = (0, $beCSm.default)('MuiTableBody', [
    'root'
]);
var $9a6742b7048414d1$export$2e2bcd8739ae039 = $9a6742b7048414d1$var$tableBodyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09d8a23708c3ccc9$var$_excluded = [
    "className",
    "component"
];
const $09d8a23708c3ccc9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9a6742b7048414d1$export$98bd2a9b566ec665), classes);
};
const $09d8a23708c3ccc9$var$TableBodyRoot = (0, $d8seH.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $09d8a23708c3ccc9$var$tablelvl2 = {
    variant: 'body'
};
const $09d8a23708c3ccc9$var$defaultComponent = 'tbody';
const $09d8a23708c3ccc9$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $09d8a23708c3ccc9$var$defaultComponent } = props, other = (0, $1En50.default)(props, $09d8a23708c3ccc9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $09d8a23708c3ccc9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fe163f52c859c8$export$2e2bcd8739ae039).Provider, {
        value: $09d8a23708c3ccc9$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$TableBodyRoot, (0, $8nd05.default)({
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $09d8a23708c3ccc9$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $09d8a23708c3ccc9$export$2e2bcd8739ae039 = $09d8a23708c3ccc9$var$TableBody;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $jTnBY = parcelRequire("jTnBY");



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b(slot) {
    return (0, $4Cod0.default)('MuiTableCell', slot);
}
const $a8eb3ce62ab46dc7$var$tableCellClasses = (0, $beCSm.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $a8eb3ce62ab46dc7$export$2e2bcd8739ae039 = $a8eb3ce62ab46dc7$var$tableCellClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a71dfe9e22152ea2$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $a71dfe9e22152ea2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            padding !== 'normal' && `padding${(0, $jTnBY.default)(padding)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b), classes);
};
const $a71dfe9e22152ea2$var$TableCellRoot = (0, $d8seH.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $jTnBY.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $kSnzZ.lighten)((0, $kSnzZ.alpha)(theme.palette.divider, 1), 0.88) : (0, $kSnzZ.darken)((0, $kSnzZ.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $a8eb3ce62ab46dc7$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $a71dfe9e22152ea2$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $1En50.default)(props, $a71dfe9e22152ea2$var$_excluded);
    const table = $acw62.useContext((0, $e848e543ed3bf349$export$2e2bcd8739ae039));
    const tablelvl2 = $acw62.useContext((0, $09fe163f52c859c8$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $a71dfe9e22152ea2$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a71dfe9e22152ea2$var$TableCellRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $a71dfe9e22152ea2$export$2e2bcd8739ae039 = $a71dfe9e22152ea2$var$TableCell;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fdf044e88b1c9ad4$export$eed427986a7abdf9(slot) {
    return (0, $4Cod0.default)('MuiTableContainer', slot);
}
const $fdf044e88b1c9ad4$var$tableContainerClasses = (0, $beCSm.default)('MuiTableContainer', [
    'root'
]);
var $fdf044e88b1c9ad4$export$2e2bcd8739ae039 = $fdf044e88b1c9ad4$var$tableContainerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5d7964a6269b66c8$var$_excluded = [
    "className",
    "component"
];
const $5d7964a6269b66c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fdf044e88b1c9ad4$export$eed427986a7abdf9), classes);
};
const $5d7964a6269b66c8$var$TableContainerRoot = (0, $d8seH.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const $5d7964a6269b66c8$var$TableContainer = /*#__PURE__*/ $acw62.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $1En50.default)(props, $5d7964a6269b66c8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $5d7964a6269b66c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5d7964a6269b66c8$var$TableContainerRoot, (0, $8nd05.default)({
        ref: ref,
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $5d7964a6269b66c8$export$2e2bcd8739ae039 = $5d7964a6269b66c8$var$TableContainer;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $cf1017f12785ebe4$export$2e731cea2d1c2392(slot) {
    return (0, $4Cod0.default)('MuiTableHead', slot);
}
const $cf1017f12785ebe4$var$tableHeadClasses = (0, $beCSm.default)('MuiTableHead', [
    'root'
]);
var $cf1017f12785ebe4$export$2e2bcd8739ae039 = $cf1017f12785ebe4$var$tableHeadClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c9c28a8e795911dc$var$_excluded = [
    "className",
    "component"
];
const $c9c28a8e795911dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $cf1017f12785ebe4$export$2e731cea2d1c2392), classes);
};
const $c9c28a8e795911dc$var$TableHeadRoot = (0, $d8seH.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $c9c28a8e795911dc$var$tablelvl2 = {
    variant: 'head'
};
const $c9c28a8e795911dc$var$defaultComponent = 'thead';
const $c9c28a8e795911dc$var$TableHead = /*#__PURE__*/ $acw62.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $c9c28a8e795911dc$var$defaultComponent } = props, other = (0, $1En50.default)(props, $c9c28a8e795911dc$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $c9c28a8e795911dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fe163f52c859c8$export$2e2bcd8739ae039).Provider, {
        value: $c9c28a8e795911dc$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$TableHeadRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            role: component === $c9c28a8e795911dc$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $c9c28a8e795911dc$export$2e2bcd8739ae039 = $c9c28a8e795911dc$var$TableHead;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $321d86e199abda5b$export$ba0a6d6c28940107(slot) {
    return (0, $4Cod0.default)('MuiTableRow', slot);
}
const $321d86e199abda5b$var$tableRowClasses = (0, $beCSm.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $321d86e199abda5b$export$2e2bcd8739ae039 = $321d86e199abda5b$var$tableRowClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22705465ad6920f8$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $22705465ad6920f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $321d86e199abda5b$export$ba0a6d6c28940107), classes);
};
const $22705465ad6920f8$var$TableRowRoot = (0, $d8seH.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $321d86e199abda5b$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $321d86e199abda5b$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $22705465ad6920f8$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $22705465ad6920f8$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $22705465ad6920f8$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $1En50.default)(props, $22705465ad6920f8$var$_excluded);
    const tablelvl2 = $acw62.useContext((0, $09fe163f52c859c8$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $22705465ad6920f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22705465ad6920f8$var$TableRowRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        role: component === $22705465ad6920f8$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
var $22705465ad6920f8$export$2e2bcd8739ae039 = $22705465ad6920f8$var$TableRow;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $3z1Ay = parcelRequire("3z1Ay");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7a8a64e8a5211ee5$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $7a8a64e8a5211ee5$export$2e2bcd8739ae039 = $7a8a64e8a5211ee5$var$isHostComponent;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7cf4d6c2077a48de$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

function $4c8156a231c9130b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $71912e551e227707$export$2e2bcd8739ae039(node) {
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $032c0e7078a9cb7d$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $032c0e7078a9cb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $032c0e7078a9cb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $032c0e7078a9cb7d$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $032c0e7078a9cb7d$var$isEmpty(obj) {
    return $032c0e7078a9cb7d$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $032c0e7078a9cb7d$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $1En50.default)(props, $032c0e7078a9cb7d$var$_excluded);
    const { current: isControlled } = $acw62.useRef(value != null);
    const textareaRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $acw62.useRef(null);
    const hiddenTextareaRef = $acw62.useRef(null);
    const calculateTextareaStyles = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingBottom) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $acw62.useRef(-1);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $7cf4d6c2077a48de$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", (0, $8nd05.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $8nd05.default)({}, $032c0e7078a9cb7d$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $032c0e7078a9cb7d$export$2e2bcd8739ae039 = $032c0e7078a9cb7d$var$TextareaAutosize;


function $766e740713576b8d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $8426ae8303951a73$export$2e2bcd8739ae039 = $8426ae8303951a73$var$FormControlContext;



var $acw62 = parcelRequire("acw62");

'use client';
function $946238fa82894619$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $8426ae8303951a73$export$2e2bcd8739ae039));
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");


'use client';
var $ec346974df496fc5$export$2e2bcd8739ae039 = (0, $aab859a020ad749e$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");



var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6942d6ec85232a9d$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        defaultTheme: (0, $jR9F1.default),
        themeId: (0, $4jPsi.default)
    }));
}
var $03fc756f7adfd498$export$2e2bcd8739ae039 = $03fc756f7adfd498$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $1e4827e2a850b1f0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $1e4827e2a850b1f0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $1e4827e2a850b1f0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9b9dde6aa920e08c$export$ef57d5c8ca2278f6(slot) {
    return (0, $4Cod0.default)('MuiInputBase', slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $beCSm.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $9b9dde6aa920e08c$export$2e2bcd8739ae039 = $9b9dde6aa920e08c$var$inputBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $69d1b2c99a8dc649$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $69d1b2c99a8dc649$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $69d1b2c99a8dc649$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $jTnBY.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9b9dde6aa920e08c$export$ef57d5c8ca2278f6), classes);
};
const $69d1b2c99a8dc649$export$298a043133d72a38 = (0, $d8seH.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $69d1b2c99a8dc649$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $69d1b2c99a8dc649$export$a1ad29c901026019 = (0, $d8seH.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $69d1b2c99a8dc649$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $8nd05.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $8nd05.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $69d1b2c99a8dc649$var$inputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03fc756f7adfd498$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $1En50.default)(props, $69d1b2c99a8dc649$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $cpmCj.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $8nd05.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $8nd05.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $032c0e7078a9cb7d$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $69d1b2c99a8dc649$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $69d1b2c99a8dc649$export$a1ad29c901026019;
    inputProps = (0, $8nd05.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $69d1b2c99a8dc649$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $9QePP.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, (0, $8nd05.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $8nd05.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $9QePP.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $8nd05.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $69d1b2c99a8dc649$export$2e2bcd8739ae039 = $69d1b2c99a8dc649$var$InputBase;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $80c774dd7f29b734$export$cdb270390122322b(slot) {
    return (0, $4Cod0.default)('MuiInput', slot);
}
const $80c774dd7f29b734$var$inputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $80c774dd7f29b734$export$2e2bcd8739ae039 = $80c774dd7f29b734$var$inputClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $76910a07fd4ac4fe$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $80c774dd7f29b734$export$cdb270390122322b), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $8nd05.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}, .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $76910a07fd4ac4fe$var$InputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $76910a07fd4ac4fe$var$_excluded);
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $76910a07fd4ac4fe$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $76910a07fd4ac4fe$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$76910a07fd4ac4fe$var$Input.muiName = 'Input';
var $76910a07fd4ac4fe$export$2e2bcd8739ae039 = $76910a07fd4ac4fe$var$Input;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3z1Ay = parcelRequire("3z1Ay");



var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $b0b42157daacd8b1$export$3331e419f1a48437(slot) {
    return (0, $4Cod0.default)('MuiFilledInput', slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $b0b42157daacd8b1$export$2e2bcd8739ae039 = $b0b42157daacd8b1$var$filledInputClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bb335d5457c07f5b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $b0b42157daacd8b1$export$3331e419f1a48437), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $8nd05.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}, .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $bb335d5457c07f5b$var$FilledInputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $bb335d5457c07f5b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $bb335d5457c07f5b$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $bb335d5457c07f5b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$bb335d5457c07f5b$var$FilledInput.muiName = 'Input';
var $bb335d5457c07f5b$export$2e2bcd8739ae039 = $bb335d5457c07f5b$var$FilledInput;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $746323a953600e78$var$_span;
const $746323a953600e78$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $746323a953600e78$var$NotchedOutlineRoot = (0, $d8seH.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $8Uq77.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $d8seH.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $8Uq77.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $8nd05.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $746323a953600e78$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $1En50.default)(props, $746323a953600e78$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $8nd05.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineRoot, (0, $8nd05.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $6a1dc6d1d7e1816a$export$89922944c7227687(slot) {
    return (0, $4Cod0.default)('MuiOutlinedInput', slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $6a1dc6d1d7e1816a$export$2e2bcd8739ae039 = $6a1dc6d1d7e1816a$var$outlinedInputClasses;




var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d5d55d2dd82639e9$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $6a1dc6d1d7e1816a$export$89922944c7227687), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $69d1b2c99a8dc649$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $8nd05.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).focused} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).error} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).disabled} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $d8seH.default)((0, $746323a953600e78$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $d5d55d2dd82639e9$var$_excluded);
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $d5d55d2dd82639e9$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $d5d55d2dd82639e9$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d5d55d2dd82639e9$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $8nd05.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$d5d55d2dd82639e9$var$OutlinedInput.muiName = 'Input';
var $d5d55d2dd82639e9$export$2e2bcd8739ae039 = $d5d55d2dd82639e9$var$OutlinedInput;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c678fac155df4fc3$export$f7d501e40371cd17(slot) {
    return (0, $4Cod0.default)('MuiFormLabel', slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $beCSm.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $c678fac155df4fc3$export$2e2bcd8739ae039 = $c678fac155df4fc3$var$formLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9b0ab7de0d37835d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c678fac155df4fc3$export$f7d501e40371cd17), classes);
};
const $9b0ab7de0d37835d$export$aa5bc7f8a4705b27 = (0, $d8seH.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $1En50.default)(props, $9b0ab7de0d37835d$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$export$aa5bc7f8a4705b27, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $9b0ab7de0d37835d$export$2e2bcd8739ae039 = $9b0ab7de0d37835d$var$FormLabel;



var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f(slot) {
    return (0, $4Cod0.default)('MuiInputLabel', slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $beCSm.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $9313ead0c5e2e8ca$export$2e2bcd8739ae039 = $9313ead0c5e2e8ca$var$inputLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09846a8ab0aba36e$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $jTnBY.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $d8seH.default)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $8nd05.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $8nd05.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $8nd05.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $1En50.default)(props, $09846a8ab0aba36e$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09846a8ab0aba36e$var$InputLabelRoot, (0, $8nd05.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $09846a8ab0aba36e$export$2e2bcd8739ae039 = $09846a8ab0aba36e$var$InputLabel;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");


var $jTnBY = parcelRequire("jTnBY");

var $acw62 = parcelRequire("acw62");
function $37dfa52af4926933$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $90a633ad7a979daa$export$2e2bcd8739ae039 = (0, $37dfa52af4926933$export$2e2bcd8739ae039);




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ce03a37a8cfb980d$export$149c8b8bab2289d1(slot) {
    return (0, $4Cod0.default)('MuiFormControl', slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $beCSm.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $ce03a37a8cfb980d$export$2e2bcd8739ae039 = $ce03a37a8cfb980d$var$formControlClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bcd22a386c6068c0$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $jTnBY.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ce03a37a8cfb980d$export$149c8b8bab2289d1), classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, styles[`margin${(0, $jTnBY.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $bcd22a386c6068c0$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $1e4827e2a850b1f0$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(child.props, true) || (0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$FormControlRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $bcd22a386c6068c0$export$2e2bcd8739ae039 = $bcd22a386c6068c0$var$FormControl;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $d8seH = parcelRequire("d8seH");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a46b344d341d82c0$export$a394fa61b1d583a9(slot) {
    return (0, $4Cod0.default)('MuiFormHelperText', slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $beCSm.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $a46b344d341d82c0$export$2e2bcd8739ae039 = $a46b344d341d82c0$var$formHelperTextClasses;



var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d23aa5c3ca6913fb$var$_span;
const $d23aa5c3ca6913fb$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $d23aa5c3ca6913fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $jTnBY.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $a46b344d341d82c0$export$a394fa61b1d583a9), classes);
};
const $d23aa5c3ca6913fb$var$FormHelperTextRoot = (0, $d8seH.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $a46b344d341d82c0$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $a46b344d341d82c0$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $d23aa5c3ca6913fb$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $1En50.default)(props, $d23aa5c3ca6913fb$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $d23aa5c3ca6913fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d23aa5c3ca6913fb$var$FormHelperTextRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $d23aa5c3ca6913fb$var$_span || ($d23aa5c3ca6913fb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $d23aa5c3ca6913fb$export$2e2bcd8739ae039 = $d23aa5c3ca6913fb$var$FormHelperText;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $acw62 = parcelRequire("acw62");
function $1d88113360503233$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($acw62.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $c10afe25107351d9$export$2e2bcd8739ae039 = (0, $4c8156a231c9130b$export$2e2bcd8739ae039);



var $jTnBY = parcelRequire("jTnBY");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");


var $8nd05 = parcelRequire("8nd05");

/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $c20bfbd9e98e2eff$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $8nd05.default)({}, otherProps, {
        ownerState: (0, $8nd05.default)({}, otherProps.ownerState, ownerState)
    });
}
var $c20bfbd9e98e2eff$export$2e2bcd8739ae039 = $c20bfbd9e98e2eff$var$appendOwnerState;



var $8nd05 = parcelRequire("8nd05");

var $9QePP = parcelRequire("9QePP");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $afac4abdaa8d83ea$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $afac4abdaa8d83ea$export$2e2bcd8739ae039 = $afac4abdaa8d83ea$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $3ebb326a10a78a15$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3ebb326a10a78a15$export$2e2bcd8739ae039 = $3ebb326a10a78a15$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $135391549c807611$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $9QePP.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $8nd05.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $8nd05.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)((0, $8nd05.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $3ebb326a10a78a15$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $3ebb326a10a78a15$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $9QePP.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $8nd05.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $8nd05.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $135391549c807611$export$2e2bcd8739ae039 = $135391549c807611$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $5f5557fdc8e8d8fa$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $5f5557fdc8e8d8fa$export$2e2bcd8739ae039 = $5f5557fdc8e8d8fa$var$resolveComponentProps;


'use client';
const $aa69d7725f45330b$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $aa69d7725f45330b$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $1En50.default)(parameters, $aa69d7725f45330b$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $135391549c807611$export$2e2bcd8739ae039)((0, $8nd05.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(elementType, (0, $8nd05.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $aa69d7725f45330b$export$2e2bcd8739ae039 = $aa69d7725f45330b$var$useSlotProps;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $2ddba918a398c481$export$2e2bcd8739ae039 = $2ddba918a398c481$var$ListContext;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adbbc5717e0d0350$export$c6bd6795ed6e3203(slot) {
    return (0, $4Cod0.default)('MuiList', slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $beCSm.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $adbbc5717e0d0350$export$2e2bcd8739ae039 = $adbbc5717e0d0350$var$listClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $640cd381f5e8b3ea$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $adbbc5717e0d0350$export$c6bd6795ed6e3203), classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $d8seH.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $1En50.default)(props, $640cd381f5e8b3ea$var$_excluded);
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($640cd381f5e8b3ea$var$ListRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $640cd381f5e8b3ea$export$2e2bcd8739ae039 = $640cd381f5e8b3ea$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $0200cab69b9251c8$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $0d80e79907b6bdbc$export$2e2bcd8739ae039 = (0, $0200cab69b9251c8$export$2e2bcd8739ae039);





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $fbb3fa0cdc277971$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $1En50.default)(props, $fbb3fa0cdc277971$var$_excluded);
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $0d80e79907b6bdbc$export$2e2bcd8739ae039)((0, $c10afe25107351d9$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $640cd381f5e8b3ea$export$2e2bcd8739ae039), (0, $8nd05.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $fbb3fa0cdc277971$export$2e2bcd8739ae039 = $fbb3fa0cdc277971$var$MenuList;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");








var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $0f2866359d6621f3$export$2e2bcd8739ae039 = (0, $7cf4d6c2077a48de$export$2e2bcd8739ae039);




var $707049eb9639aeac$export$2e2bcd8739ae039 = (0, $71912e551e227707$export$2e2bcd8739ae039);




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");





var $1En50 = parcelRequire("1En50");



var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;



const $cc10aae84e3e4b9c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $cc10aae84e3e4b9c$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d6f4882a3b1c59f2$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d6f4882a3b1c59f2$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $d6f4882a3b1c59f2$var$_excluded);
    const timer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, (0, $1d88113360503233$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6f4882a3b1c59f2$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $d6f4882a3b1c59f2$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$export$2e2bcd8739ae039 = $d6f4882a3b1c59f2$var$Grow;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");


var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $f30200a1e85b3f20$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $f30200a1e85b3f20$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $f30200a1e85b3f20$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $f30200a1e85b3f20$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $f30200a1e85b3f20$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($f30200a1e85b3f20$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $f30200a1e85b3f20$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $f30200a1e85b3f20$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $f30200a1e85b3f20$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $f30200a1e85b3f20$var$defaultGetTabbable, isEnabled: isEnabled = $f30200a1e85b3f20$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $f30200a1e85b3f20$export$2e2bcd8739ae039 = $f30200a1e85b3f20$var$FocusTrap;



var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $2117883cc21a32b2$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $2117883cc21a32b2$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(/*#__PURE__*/ $acw62.isValidElement(children) ? (0, $1d88113360503233$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($2117883cc21a32b2$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: mountNode ? /*#__PURE__*/ $11492dca620dcaa5$exports.createPortal(children, mountNode) : mountNode
    });
});
var $2117883cc21a32b2$export$2e2bcd8739ae039 = $2117883cc21a32b2$var$Portal;



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5e5a92158e7d9bd4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $5e5a92158e7d9bd4$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, (0, $1d88113360503233$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $5e5a92158e7d9bd4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $5e5a92158e7d9bd4$export$2e2bcd8739ae039 = $5e5a92158e7d9bd4$var$Fade;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5c4c540114ae85ab$export$9927a91fd93152bd(slot) {
    return (0, $4Cod0.default)('MuiBackdrop', slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $beCSm.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $5c4c540114ae85ab$export$2e2bcd8739ae039 = $5c4c540114ae85ab$var$backdropClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4838e5a14e330013$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5c4c540114ae85ab$export$9927a91fd93152bd), classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $d8seH.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $1En50.default)(props, $4838e5a14e330013$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4838e5a14e330013$var$BackdropRoot, (0, $8nd05.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $9QePP.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $8nd05.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $4838e5a14e330013$export$2e2bcd8739ae039 = $4838e5a14e330013$var$Backdrop;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $cfb86ebe4ea00eb7$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $52971d86e2bcd483$var$isOverflowing(container) {
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $71912e551e227707$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $52971d86e2bcd483$var$getPaddingRight(element) {
    return parseInt((0, $71912e551e227707$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $52971d86e2bcd483$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show);
    });
}
function $52971d86e2bcd483$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $52971d86e2bcd483$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($52971d86e2bcd483$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $0200cab69b9251c8$export$2e2bcd8739ae039)((0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $52971d86e2bcd483$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $52971d86e2bcd483$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $52971d86e2bcd483$var$getHiddenSiblings(container);
        $52971d86e2bcd483$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $52971d86e2bcd483$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $52971d86e2bcd483$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $f86e7d122c1fa324$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $f86e7d122c1fa324$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $f86e7d122c1fa324$var$defaultManager = new (0, $52971d86e2bcd483$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $f86e7d122c1fa324$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $f86e7d122c1fa324$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $acw62.useState(!open);
    const hasTransition = $f86e7d122c1fa324$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $4c8156a231c9130b$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $f86e7d122c1fa324$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $acw62.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $52971d86e2bcd483$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $8nd05.default)({}, propsEventHandlers, otherHandlers);
        return (0, $8nd05.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $8nd05.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $f86e7d122c1fa324$export$2e2bcd8739ae039 = $f86e7d122c1fa324$var$useModal;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0cea91a79e26c98a$export$67960e22b12a638d(slot) {
    return (0, $4Cod0.default)('MuiModal', slot);
}
const $0cea91a79e26c98a$var$modalClasses = (0, $beCSm.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $0cea91a79e26c98a$export$2e2bcd8739ae039 = $0cea91a79e26c98a$var$modalClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0bdcbfecdf3275a2$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $0bdcbfecdf3275a2$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $0cea91a79e26c98a$export$67960e22b12a638d), classes);
};
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $d8seH.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $d8seH.default)((0, $4838e5a14e330013$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $1En50.default)(props, $0bdcbfecdf3275a2$var$_excluded);
    const propsWithDefaults = (0, $8nd05.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $f86e7d122c1fa324$export$2e2bcd8739ae039)((0, $8nd05.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $8nd05.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $0bdcbfecdf3275a2$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $0bdcbfecdf3275a2$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $8nd05.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $9QePP.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2117883cc21a32b2$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, (0, $8nd05.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, (0, $8nd05.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f30200a1e85b3f20$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $0bdcbfecdf3275a2$export$2e2bcd8739ae039 = $0bdcbfecdf3275a2$var$Modal;




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ea2c25a800e729b1$export$88f455dd56c95edb(slot) {
    return (0, $4Cod0.default)('MuiPopover', slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $beCSm.default)('MuiPopover', [
    'root',
    'paper'
]);
var $ea2c25a800e729b1$export$2e2bcd8739ae039 = $ea2c25a800e729b1$var$popoverClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $012baef8dc9ae9d0$var$_excluded = [
    "onEntering"
], $012baef8dc9ae9d0$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $012baef8dc9ae9d0$var$_excluded3 = [
    "slotProps"
];
function $012baef8dc9ae9d0$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ea2c25a800e729b1$export$88f455dd56c95edb), classes);
};
const $012baef8dc9ae9d0$export$bcce13685275fc99 = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $012baef8dc9ae9d0$export$821346c38a2d9390 = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $012baef8dc9ae9d0$var$_excluded), other = (0, $1En50.default)(props, $012baef8dc9ae9d0$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $acw62.useRef();
    const handlePaperRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $c10afe25107351d9$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $acw62.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $c10afe25107351d9$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $012baef8dc9ae9d0$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $012baef8dc9ae9d0$export$821346c38a2d9390;
    const paperProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $8nd05.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $8nd05.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $1En50.default)(_useSlotProps, $012baef8dc9ae9d0$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, (0, $8nd05.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $012baef8dc9ae9d0$export$2e2bcd8739ae039 = $012baef8dc9ae9d0$var$Popover;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fb1e7d0ac8fac824$export$2cf86a63a84fe23d(slot) {
    return (0, $4Cod0.default)('MuiMenu', slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $beCSm.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $fb1e7d0ac8fac824$export$2e2bcd8739ae039 = $fb1e7d0ac8fac824$var$menuClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $364f3db28d8d2e79$var$_excluded = [
    "onEntering"
], $364f3db28d8d2e79$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fb1e7d0ac8fac824$export$2cf86a63a84fe23d), classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $d8seH.default)((0, $012baef8dc9ae9d0$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $364f3db28d8d2e79$export$4f7c51a5920c9f33 = (0, $d8seH.default)((0, $012baef8dc9ae9d0$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $d8seH.default)((0, $fbb3fa0cdc277971$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $364f3db28d8d2e79$var$_excluded), other = (0, $1En50.default)(props, $364f3db28d8d2e79$var$_excluded2);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $364f3db28d8d2e79$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuRoot, (0, $8nd05.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $8nd05.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuMenuList, (0, $8nd05.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $9QePP.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $364f3db28d8d2e79$export$2e2bcd8739ae039 = $364f3db28d8d2e79$var$Menu;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $49a1663d7631a8fa$export$1ee13051fd9e2ab5(slot) {
    return (0, $4Cod0.default)('MuiNativeSelect', slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $beCSm.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $49a1663d7631a8fa$export$2e2bcd8739ae039 = $49a1663d7631a8fa$var$nativeSelectClasses;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $db2c454fb2e8bc3c$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $49a1663d7631a8fa$export$1ee13051fd9e2ab5), classes);
};
const $db2c454fb2e8bc3c$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $8nd05.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $d8seH.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $8Uq77.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($db2c454fb2e8bc3c$export$c1eccd1617458c87);
const $db2c454fb2e8bc3c$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $d8seH.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($db2c454fb2e8bc3c$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $db2c454fb2e8bc3c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, (0, $8nd05.default)({
                ownerState: ownerState,
                className: (0, $9QePP.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $db2c454fb2e8bc3c$export$2e2bcd8739ae039 = $db2c454fb2e8bc3c$var$NativeSelectInput;




var $d8seH = parcelRequire("d8seH");
var $PJRTc = parcelRequire("PJRTc");


var $acw62 = parcelRequire("acw62");
'use client';
function $77aad105771eb889$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $295ecbe78b5bad73$export$2e2bcd8739ae039 = (0, $77aad105771eb889$export$2e2bcd8739ae039);



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $844e08aea9053c4b$export$2c0c1ee5a3392e(slot) {
    return (0, $4Cod0.default)('MuiSelect', slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $beCSm.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $844e08aea9053c4b$export$2e2bcd8739ae039 = $844e08aea9053c4b$var$selectClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $8bd650259be885cb$var$SelectSelect = (0, $d8seH.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $db2c454fb2e8bc3c$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $d8seH.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $db2c454fb2e8bc3c$export$e7a817afd12a40d0));
const $8bd650259be885cb$var$SelectNativeInput = (0, $d8seH.default)('input', {
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $8bd650259be885cb$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8bd650259be885cb$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $844e08aea9053c4b$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $8bd650259be885cb$var$_excluded);
    const [value, setValueState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $cpmCj.default)(2));
            selected = value.some((v)=>$8bd650259be885cb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8bd650259be885cb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    const paperProps = (0, $8nd05.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectSelect, (0, $8nd05.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $9QePP.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8bd650259be885cb$var$isEmpty(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectNativeInput, (0, $8nd05.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $8nd05.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $8nd05.default)({}, MenuProps.slotProps, {
                    paper: (0, $8nd05.default)({}, paperProps, {
                        style: (0, $8nd05.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $8bd650259be885cb$export$2e2bcd8739ae039 = $8bd650259be885cb$var$SelectInput;




parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $5a863bd9b12ca76b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







var $1iOpW = parcelRequire("1iOpW");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96e1233e8d06bb2d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $96e1233e8d06bb2d$var$_excluded2 = [
    "root"
];
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $d8seH.default)((0, $76910a07fd4ac4fe$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $d8seH.default)((0, $d5d55d2dd82639e9$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $d8seH.default)((0, $bb335d5457c07f5b$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $5a863bd9b12ca76b$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $1En50.default)(props, $96e1233e8d06bb2d$var$_excluded);
    const inputComponent = native ? (0, $db2c454fb2e8bc3c$export$2e2bcd8739ae039) : (0, $8bd650259be885cb$export$2e2bcd8739ae039);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $1En50.default)(classes, $96e1233e8d06bb2d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, (0, $1d88113360503233$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, (0, $8nd05.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $8nd05.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $8nd05.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $3z1Ay.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $9QePP.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$96e1233e8d06bb2d$var$Select.muiName = 'Select';
var $96e1233e8d06bb2d$export$2e2bcd8739ae039 = $96e1233e8d06bb2d$var$Select;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $25a6b464d3ca38da$export$c1bdcbaf0596aeda(slot) {
    return (0, $4Cod0.default)('MuiTextField', slot);
}
const $25a6b464d3ca38da$var$textFieldClasses = (0, $beCSm.default)('MuiTextField', [
    'root'
]);
var $25a6b464d3ca38da$export$2e2bcd8739ae039 = $25a6b464d3ca38da$var$textFieldClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d8826083c5af4ea7$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $d8826083c5af4ea7$var$variantComponent = {
    standard: (0, $76910a07fd4ac4fe$export$2e2bcd8739ae039),
    filled: (0, $bb335d5457c07f5b$export$2e2bcd8739ae039),
    outlined: (0, $d5d55d2dd82639e9$export$2e2bcd8739ae039)
};
const $d8826083c5af4ea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $25a6b464d3ca38da$export$c1bdcbaf0596aeda), classes);
};
const $d8826083c5af4ea7$var$TextFieldRoot = (0, $d8seH.default)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d8826083c5af4ea7$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $d8826083c5af4ea7$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $d8826083c5af4ea7$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d8826083c5af4ea7$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputComponent, (0, $8nd05.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d8826083c5af4ea7$var$TextFieldRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), (0, $8nd05.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), (0, $8nd05.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $d8826083c5af4ea7$export$2e2bcd8739ae039 = $d8826083c5af4ea7$var$TextField;


var $14b4fcb0e549e7b0$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($14b4fcb0e549e7b0$exports, "__esModule", {
    value: true
});
$14b4fcb0e549e7b0$exports.default = void 0;

var $14b4fcb0e549e7b0$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $14b4fcb0e549e7b0$var$_default = $14b4fcb0e549e7b0$exports.default = (0, $14b4fcb0e549e7b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');


var $570fd50501d08ed5$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($570fd50501d08ed5$exports, "__esModule", {
    value: true
});
$570fd50501d08ed5$exports.default = void 0;

var $570fd50501d08ed5$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $570fd50501d08ed5$var$_default = $570fd50501d08ed5$exports.default = (0, $570fd50501d08ed5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');





class $4260a18255facc8f$export$d437099f2e6e79c4 extends (0, $54bbbf96c1cde9f8$export$7a2d5763061d09f3) {
    constructor(inputRange){
        super();
        this.initField('min', new (0, $54bbbf96c1cde9f8$export$a7cc3b15d9fb13b)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(inputRange?.min), 'Min'));
        this.initField('max', new (0, $54bbbf96c1cde9f8$export$a7cc3b15d9fb13b)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(inputRange?.max), 'Max'));
    }
    get min() {
        return this.getFieldValue('min');
    }
    set min(val) {
        this.setFieldValue('min', val);
    }
    get max() {
        return this.getFieldValue('max');
    }
    set max(val) {
        this.setFieldValue('max', val);
    }
    isValid() {
        return this.isValidField('min') && this.isValidField('max');
    }
    toStub() {
        return {
            min: this.min,
            max: this.max
        };
    }
}


const $722fd9258a1d0359$var$TableEditableCell = ({ getInputValue: getInputValue, setInputValue: setInputValue, setFinalValue: setFinalValue, readOnly: readOnly })=>{
    const [, onRefresh] = (0, $acw62.useState)(false);
    const value = getInputValue();
    const editMode = !!setFinalValue;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
        align: "right",
        children: readOnly ? value : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
            id: "port",
            size: "small",
            value: value,
            onBlur: (e)=>setFinalValue(e.target.value),
            onChange: (e)=>{
                setInputValue(e.target.value);
                onRefresh((current)=>!current);
            },
            disabled: !editMode
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $722fd9258a1d0359$var$RangeInputCell = ({ rangeInput: rangeInput })=>{
    const [, onRefresh] = (0, $acw62.useState)(false);
    const rangeInputField = (0, $acw62.useMemo)(()=>new (0, $4260a18255facc8f$export$d437099f2e6e79c4)(rangeInput), [
        rangeInput
    ]);
    // update original object
    rangeInput.min = rangeInputField.min;
    rangeInput.max = rangeInputField.max;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
        align: "right",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
            direction: 'row',
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                    id: "port",
                    size: "small",
                    value: rangeInputField.min,
                    onBlur: ()=>null,
                    onChange: (e)=>{
                        rangeInputField.min = e.target.value;
                        onRefresh((current)=>!current);
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    sx: {
                        pt: 1
                    },
                    children: "\xa0-\xa0"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                    id: "port",
                    size: "small",
                    value: rangeInputField.max,
                    onBlur: ()=>null,
                    onChange: (e)=>{
                        rangeInputField.max = e.target.value;
                        onRefresh((current)=>!current);
                    }
                })
            ]
        })
    });
};
/* eslint-disable react/prop-types */ const $722fd9258a1d0359$var$PortsPowerTableRow = ({ rowFields: rowFields, onChange: onChange, children: children, hideExtraColumns: hideExtraColumns = false, editable: editable = false, rowNb: rowNb = null })=>{
    const { port: port, frequency: frequency, power: power, eTilt: eTilt, eTiltRange: eTiltRange } = rowFields;
    const frequencyRange = frequency.range?.min + '-' + frequency.range?.max;
    const fieldValueSetter = (field)=>(val)=>{
            field.value = val;
            onChange();
        };
    const fieldInputValueSetter = (field)=>(val)=>{
            field.inputValue = val;
            onChange();
        };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
        sx: {
            '&:last-child td, &:last-child th': {
                border: 0
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($722fd9258a1d0359$var$TableEditableCell, {
                readOnly: true,
                getInputValue: ()=>port.inputValue,
                setInputValue: rowNb === null && fieldInputValueSetter(port),
                setFinalValue: rowNb === null && fieldValueSetter(port)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($722fd9258a1d0359$var$TableEditableCell, {
                readOnly: true,
                getInputValue: ()=>frequencyRange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($722fd9258a1d0359$var$TableEditableCell, {
                getInputValue: ()=>frequency.inputValue,
                setInputValue: editable && fieldInputValueSetter(frequency),
                setFinalValue: editable && fieldValueSetter(frequency)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($722fd9258a1d0359$var$TableEditableCell, {
                readOnly: true,
                getInputValue: ()=>eTiltRange.value
            }),
            !hideExtraColumns && /*#__PURE__*/ (0, $ayMG0.jsx)($722fd9258a1d0359$var$TableEditableCell, {
                getInputValue: ()=>eTilt.value,
                setInputValue: editable && fieldValueSetter(eTilt),
                setFinalValue: editable && fieldValueSetter(eTilt)
            }),
            !hideExtraColumns && /*#__PURE__*/ (0, $ayMG0.jsx)($722fd9258a1d0359$var$TableEditableCell, {
                getInputValue: ()=>power.inputValue,
                setInputValue: editable && fieldInputValueSetter(power),
                setFinalValue: editable && fieldValueSetter(power)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                children: children
            })
        ]
    }, rowNb !== null ? 'portRow_' + rowNb : 'portRow_new');
};
const $722fd9258a1d0359$export$4900f343cb47e178 = (port, freq)=>{
    return {
        port: port,
        frequency: freq,
        power: 0,
        eTilt: ''
    };
};
const $722fd9258a1d0359$var$DEFAULT_FREQ_RANGE = {
    min: 0,
    max: 1000
};
const $722fd9258a1d0359$export$9a89758239fe2e2b = ({ portsConfiguration: portsConfiguration, editMode: editMode, hideExtraColumns: hideExtraColumns, allowAddDel: allowAddDel, onChange: onChange })=>{
    const [updatedRowState, onUpdatedRow] = (0, $acw62.useState)(false);
    const [addedRowState, onAddedRow] = (0, $acw62.useState)(false);
    // renewed each time new row is added
    const newPort = (0, $acw62.useMemo)(()=>{
        console.log('[PortsPowerTable] create empty port');
        return new (0, $8d3ebfc71b421629$export$f5fe5fc4d5161c76)('', {
            min: $722fd9258a1d0359$var$DEFAULT_FREQ_RANGE.min,
            max: $722fd9258a1d0359$var$DEFAULT_FREQ_RANGE.max
        }, '');
    }, [
        addedRowState
    ]);
    // triggered each time row is added or removed/updated
    (0, $acw62.useEffect)(()=>{
        onChange?.();
    }, [
        addedRowState,
        updatedRowState
    ]);
    const addRow = ()=>{
        portsConfiguration.addPortConfiguration(newPort);
        onAddedRow((current)=>!current);
    };
    const removeRow = (portNb)=>{
        portsConfiguration.removePortConfiguration(portNb);
        onUpdatedRow((current)=>!current);
    };
    const rows = Object.values(portsConfiguration.fields);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d7964a6269b66c8$export$2e2bcd8739ae039), {
            component: (0, $595185d0d7275c3b$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                size: "small",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    children: "Port"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    align: "right",
                                    children: "Freq\xa0(MHz) (min\u2011max)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    align: "right",
                                    children: "Freq\xa0(MHz)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    align: "right",
                                    children: "E\u2011tilt range"
                                }),
                                !hideExtraColumns && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    align: "right",
                                    children: "E\u2011tilt"
                                }),
                                !hideExtraColumns && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    align: "right",
                                    children: "Power\xa0(W)"
                                }),
                                editMode && allowAddDel && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    align: "right"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                        children: [
                            rows?.map((r)=>// eslint-disable-next-line react/jsx-key
                                /*#__PURE__*/ (0, $ayMG0.jsx)($722fd9258a1d0359$var$PortsPowerTableRow, {
                                    hideExtraColumns: hideExtraColumns,
                                    rowNb: r.primaryKey,
                                    rowFields: r.fields,
                                    editable: editMode,
                                    onChange: ()=>onUpdatedRow((current)=>!current),
                                    children: allowAddDel && editMode && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                        onClick: ()=>removeRow(r.primaryKey),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14b4fcb0e549e7b0$exports))), {
                                            fontSize: "small"
                                        })
                                    })
                                })),
                            allowAddDel && editMode && /*#__PURE__*/ (0, $ayMG0.jsx)($722fd9258a1d0359$var$PortsPowerTableRow, {
                                hideExtraColumns: hideExtraColumns,
                                rowFields: newPort.fields,
                                editable: true,
                                onChange: onChange,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                    "aria-label": "cancel",
                                    onClick: addRow,
                                    disabled: !newPort.isValid(),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {})
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};


class $8d3ebfc71b421629$export$c420f81005157a4a extends (0, $54bbbf96c1cde9f8$export$7a2d5763061d09f3) {
    constructor(bimStub){
        super();
        this.initFromStub(bimStub);
    }
    get name() {
        return this.getFieldValue('name');
    }
    set name(val) {
        this.setFieldValue('name', val);
    }
    get bimId() {
        return this.getFieldValue('bimId');
    }
    set bimId(val) {
        this.setFieldValue('bimId', val);
    }
    isNameUnique() {
        const match = Object.values((0, $0bafe5cbc4b092bf$export$9a93b0d49a84081a).instances).find((item)=>item.id !== this.id && item.name === this.name);
        return !match;
    }
    isValidField(field) {
        return field === 'name' ? super.isValidField(field) && this.isNameUnique() : super.isValidField(field);
    }
    isValid() {
        return this.isValidField('name');
    }
    initFromStub(bimStub) {
        this.initField('name', new (0, $54bbbf96c1cde9f8$export$a49ce3bbbd0d81e5)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(bimStub?.displayName), true));
        this.initField('bimId', new (0, $54bbbf96c1cde9f8$export$a49ce3bbbd0d81e5)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(bimStub?.id), true));
    }
    toStub() {
        return Object.values(this.fields).map((field)=>({
                ...field.originalStub,
                value: field.value
            }));
    }
}
class $8d3ebfc71b421629$export$29128e8e1c948ff8 extends (0, $54bbbf96c1cde9f8$export$7a2d5763061d09f3) {
    constructor(meshReference){
        super();
        this.initFromStub(meshReference);
    }
    get id() {
        return this.getFieldValue('id');
    }
    set id(val) {
        this.setFieldValue('id', val);
    }
    get type() {
        return this.getFieldValue('type');
    }
    set type(val) {
        this.setFieldValue('type', val);
    }
    initFromStub(meshReference) {
        this.initField('id', new (0, $54bbbf96c1cde9f8$export$a49ce3bbbd0d81e5)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(meshReference?.id), true));
        this.initField('type', new (0, $54bbbf96c1cde9f8$export$a49ce3bbbd0d81e5)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(meshReference?.type), true));
    }
    toStub() {
        return {
            id: this.id,
            type: this.type
        };
    }
}
/**
 * Clean any deprecated keys
 * @param collection
 * @returns
 */ function $8d3ebfc71b421629$var$cleanBimObjectKeys(collection) {
    // legacy keys type/subtype support
    if (collection.subType) {
        console.warn(`deprecated 'subType' key found => substitute 'type' , 'typeClass' with 'type' `);
        collection.typeClass = collection.type;
        collection.type = collection.subType;
        delete collection.subType;
    }
    const defaultStub = (0, $fdac710428712a0c$export$648b5c2be518feea)();
    for (const key of Object.keys(collection))if (defaultStub[key] === undefined) console.debug(`unexpected key found: ${key}`);
    return collection;
}
class $8d3ebfc71b421629$export$11aebda652217b5f extends (0, $54bbbf96c1cde9f8$export$7a2d5763061d09f3) {
    constructor(bimStub){
        super();
        this.stub = bimStub; // does not assign directly to property but call stub setter instead
    }
    get stub() {
        return this.originalStub;
    }
    set stub(stub) {
        this.originalStub = stub;
        this.initFromStub();
    }
    initFromStub(stub = this.originalStub) {
        const defaultStub = (0, $fdac710428712a0c$export$648b5c2be518feea)();
        const cleanedStub = $8d3ebfc71b421629$var$cleanBimObjectKeys({
            ...defaultStub,
            ...stub
        });
        const mergedStub = {
            ...defaultStub,
            ...cleanedStub
        };
        const mandatoryFields = {
            typeClass: true,
            type: true,
            shape: true
        };
        const fields = Object.fromEntries(Object.entries(mergedStub).filter(([k])=>k !== 'shapeDimensions') // shape dims will be initialized separately
        .map(([k, v])=>[
                k,
                new (0, $54bbbf96c1cde9f8$export$a49ce3bbbd0d81e5)(v, mandatoryFields[k])
            ]));
        Object.assign(this.fields, fields);
        // handle other fields
        const shapeTypeField = this.fields['shape'];
        const shapeType = shapeTypeField?.value || (0, $baba9bdf33bc9eca$export$2ba33b17e8aed329);
        const shapeDimensionsStub = stub?.['shapeDimensions'];
        // init shape dimensions according to shape type
        this.fields['shapeDimensions'] = shapeType === (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER ? new (0, $baba9bdf33bc9eca$export$8f93e34dde8009bd)(shapeDimensionsStub) : new (0, $baba9bdf33bc9eca$export$3b161c1935260ac7)(shapeDimensionsStub);
    }
    get uid() {
        return this.getFieldValue('uid');
    }
    get makeModel() {
        return this.getFieldValue('makeModel');
    }
    get manufacturer() {
        return this.getFieldValue('manufacturer');
    }
    get esa() {
        return this.getFieldValue('esa');
    }
    get nadModel() {
        return this.getFieldValue('nadModel');
    }
    get nadManufacturer() {
        return this.getFieldValue('nadManufacturer');
    }
    get typeClass() {
        return this.getFieldValue('typeClass');
    }
    get type() {
        return this.getFieldValue('type');
    }
    get shape() {
        return this.getFieldValue('shape');
    }
    /**
     * non generic typed field, getter only
     */ get shapeDimensions() {
        return this.getField('shapeDimensions');
    }
    set makeModel(val) {
        this.setFieldValue('makeModel', val);
    }
    set manufacturer(val) {
        this.setFieldValue('manufacturer', val);
    }
    set esa(val) {
        this.setFieldValue('esa', val);
    }
    set nadModel(val) {
        this.setFieldValue('nadModel', val);
    }
    set nadManufacturer(val) {
        this.setFieldValue('nadManufacturer', val);
    }
    set typeClass(typeClass) {
        // on typeClass change reset type
        if (typeClass !== this.typeClass) this.setFieldValue('type', '');
        this.setFieldValue('typeClass', typeClass);
    }
    set type(val) {
        if (val !== this.type) {
            this.setFieldValue('type', val);
            // If passive subtype, reset nadModel and nadManufacturer
            if ((0, $fdac710428712a0c$export$4c71c0167fb21741).includes(val)) {
                this.nadModel = '';
                this.nadManufacturer = '';
                return;
            }
            // Reset shape to the first valid shape for this subtype if current shape invalid
            const shapes = (0, $fdac710428712a0c$export$52f52a5c05885a9b)[val] ?? (0, $baba9bdf33bc9eca$export$c78b4673549b3bf9);
            if (!shapes.includes(this.shape)) {
                // defaults to rectangle if both shape available
                if (shapes.includes((0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE)) this.shape = (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).RECTANGLE;
                else this.shape = shapes[0];
            }
        }
    }
    set shape(val) {
        // on shape type change, (re)set corresponding shape dims
        if (val !== this.shape) {
            // replace shape dims with fresh object
            this.fields['shapeDimensions'] = val === (0, $baba9bdf33bc9eca$export$fc850f719b5599d5).CYLINDER ? new (0, $baba9bdf33bc9eca$export$8f93e34dde8009bd)() : new (0, $baba9bdf33bc9eca$export$3b161c1935260ac7)();
            this.setFieldValue('shape', val);
        }
    }
    filterInputFields() {
        return [
            'makeModel',
            'manufacturer',
            'esa'
        ].map((name)=>({
                name: name,
                value: this[name] || ''
            }));
    }
    toStub() {
        return this.getPendingChanges();
    }
}
class $8d3ebfc71b421629$export$6cf5fd8251c8ec1e extends (0, $54bbbf96c1cde9f8$export$a49ce3bbbd0d81e5) {
    constructor(stub){
        super(stub.value !== undefined ? stub.value : stub.default);
        this.originalStub = stub;
    }
    get name() {
        return this.originalStub.name;
    }
    get label() {
        return this.originalStub.displayName;
    }
}
class $8d3ebfc71b421629$export$475d35c0452706c7 extends (0, $54bbbf96c1cde9f8$export$7a2d5763061d09f3) {
    constructor(stubItems){
        super();
        this.fromStub(stubItems);
    }
    // init from stub
    fromStub(stubItems) {
        stubItems?.forEach((i)=>this.initField(i.name, new $8d3ebfc71b421629$export$6cf5fd8251c8ec1e(i)));
    }
    toStub() {
        return Object.values(this.fields).map((field)=>({
                ...field.originalStub,
                value: field.value
            }));
    }
    pendingChanges() {
        const pendingChanges = {};
        Object.values(this.fields).filter((field)=>field.pendingVal !== undefined).forEach((field)=>pendingChanges[field.name] = field.value);
        return pendingChanges;
    }
}
class $8d3ebfc71b421629$export$f5fe5fc4d5161c76 extends (0, $54bbbf96c1cde9f8$export$7a2d5763061d09f3) {
    constructor(port, freqMinMax, eTiltRange, measurementFrequency = 0, customPortsConfig){
        super();
        console.debug(`[PortPowerFields] constructor`);
        const portsConfig = customPortsConfig || (0, $722fd9258a1d0359$export$4900f343cb47e178)(port, measurementFrequency, eTiltRange);
        this.fromStub(port, freqMinMax, eTiltRange, portsConfig);
    }
    get port() {
        return this.getFieldValue('port');
    }
    set port(val) {
        this.setFieldValue('port', val);
    }
    get frequency() {
        return this.getFieldValue('frequency');
    }
    set frequency(val) {
        this.setFieldValue('frequency', val);
    }
    get power() {
        return this.getFieldValue('power');
    }
    set power(val) {
        this.setFieldValue('power', val);
    }
    get eTilt() {
        return this.getFieldValue('eTilt');
    }
    set eTilt(val) {
        this.setFieldValue('eTilt', val);
    }
    get eTiltRange() {
        return this.getFieldValue('eTiltRange');
    }
    // unique identifier as combination of port, minFraq and maxFreq
    get primaryKey() {
        const frequency = this.getField('frequency');
        return this.port + '_' + frequency.range?.min + '-' + frequency.range?.max;
    }
    fromStub(port, freqMinMax, eTiltRange, customPortsConfig) {
        const powerRange = {
            min: 0,
            max: NaN
        };
        this.initField('port', new (0, $54bbbf96c1cde9f8$export$a7cc3b15d9fb13b)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(port), 'port'));
        this.initField('frequency', new (0, $54bbbf96c1cde9f8$export$a7cc3b15d9fb13b)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(customPortsConfig?.frequency), 'frequency', freqMinMax));
        this.initField('power', new (0, $54bbbf96c1cde9f8$export$a7cc3b15d9fb13b)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(customPortsConfig?.power), 'power', powerRange));
        this.initField('eTiltRange', new (0, $54bbbf96c1cde9f8$export$a49ce3bbbd0d81e5)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(eTiltRange)));
        this.initField('eTilt', new (0, $54bbbf96c1cde9f8$export$a49ce3bbbd0d81e5)((0, $834b9e85ded96783$export$d0d57df0e0611bbf)(customPortsConfig?.eTilt), true));
    }
    toStub() {
        const stubExport = {};
        const freqField = this.getField('frequency');
        const freqRange = freqField.range;
        stubExport.freqMin = freqRange.min;
        stubExport.freqMax = freqRange.max;
        const fields = Object.fromEntries(Object.entries(this.fields).filter(([k])=>k !== 'eTiltRange' && k !== 'primaryKey').map(([k, f])=>[
                k,
                f.value
            ]));
        Object.assign(stubExport, fields);
        return stubExport;
    }
}
class $8d3ebfc71b421629$export$1ee1f07de88734a5 extends (0, $54bbbf96c1cde9f8$export$7a2d5763061d09f3) {
    constructor(apdStub, configStubList){
        super(), this.hasChanged = false;
        this.initialStub = apdStub;
        this.fromStub(apdStub, configStubList);
    }
    addPortConfiguration(portConfig) {
        const { primaryKey: primaryKey } = portConfig;
        if (!this.fields[primaryKey]) {
            this.initField(primaryKey, portConfig);
            this.hasChanged = true;
        } else console.warn(`[PortsConfiguration::addPortConfiguration] key ${primaryKey} already exists, cannot store 2 configuration with same port and frequency range`);
    }
    removePortConfiguration(primaryKey) {
        delete this.fields[primaryKey];
        // avoid skipping pending changes when deleting row
        this.hasChanged = true;
    }
    // init from stub
    fromStub(apdStub = [], configStubList = []) {
        // Sort By Increasing Port value
        apdStub.sort((a, b)=>a.port - b.port);
        const consolidated = [];
        apdStub.forEach((patternStub)=>{
            const existingPort = consolidated.find((p)=>p.port === patternStub.port && p.minimumFrequency === patternStub.minimumFrequency && p.maximumFrequency === patternStub.maximumFrequency);
            if (existingPort) (0, $834b9e85ded96783$export$d10b4bc54aaefed4)(existingPort, patternStub);
            else consolidated.push(patternStub);
        });
        const usedConfigData = [];
        consolidated.forEach((element)=>{
            const { port: port, minimumFrequency: minimumFrequency, maximumFrequency: maximumFrequency, electricalTilt: electricalTilt, measurementFrequency: measurementFrequency } = element;
            const matchingConfigStub = configStubList.find((p)=>p.port === port && p.freqMin === minimumFrequency && p.freqMax === maximumFrequency);
            if (matchingConfigStub) usedConfigData.push(matchingConfigStub);
            const freqRange = {
                min: minimumFrequency,
                max: maximumFrequency
            };
            this.addPortConfiguration(new $8d3ebfc71b421629$export$f5fe5fc4d5161c76(port, freqRange, electricalTilt, measurementFrequency, matchingConfigStub));
        });
        configStubList.filter((e)=>!usedConfigData.includes(e))?.forEach((element)=>{
            const freqRange = {
                min: (0, $834b9e85ded96783$export$d0d57df0e0611bbf)(element?.freqMin, 0),
                max: (0, $834b9e85ded96783$export$d0d57df0e0611bbf)(element?.freqMax, 0)
            };
            this.addPortConfiguration(new $8d3ebfc71b421629$export$f5fe5fc4d5161c76(element.port, freqRange, '', element.frequency));
        });
    }
    toStub() {
        return Object.values(this.fields).map((f)=>f.toStub());
    }
    hasPendingChanges() {
        return super.hasPendingChanges() || this.hasChanged;
    }
    getPendingChanges() {
        const modifiedPorts = super.getPendingChanges();
        console.log('[PortsConfiguration::getPendingChanges]', modifiedPorts);
        return Object.values(modifiedPorts);
    }
}


const $0bafe5cbc4b092bf$var$BIM_ITEMS_FETCH_COUNT = 0;
class $0bafe5cbc4b092bf$export$617f92e08d05bd16 {
    async retrieveModel(forceRefresh) {
        // Fetch model OBJ and MTL content from BIM API
        if (!this.model.request || forceRefresh) {
            const request = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.buildGlbRequest(this.id, this.modelParameters.pendingChanges());
            this.model = {
                request: request
            };
        } else console.info('[BimModel | retrieveModel] using cached model');
    }
    /**
     * First trying to load with parameters included
     * If failing retrying without parameters
     */ async failsafeLoad() {
        let reply = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.fetchDetails(this.id);
        if (reply.status !== 200) {
            console.warn(`fetch model with parameters failed, fallback to no parameters request`);
            reply = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.fetchDetails(this.id, false);
        }
        const bimStub = await reply.json();
        this.initFromStub(bimStub);
        this.isFullyLoaded = true;
    }
    /**
     * Populates list of attachments, skip existing item if any
     */ async preloadAttachments() {
        const reply = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.listAttachments(this.id);
        if (reply.status === 200) {
            const attachmentsStub = await reply.json();
            this.attachments = attachmentsStub.map((stub)=>{
                const existingAttachment = this.attachments.find((a)=>a.id === stub.id);
                return existingAttachment || new $0bafe5cbc4b092bf$export$7a74d234056b756b(stub, this.id);
            });
        }
    }
    getThumbnailAttachment() {
        return this.attachments.find((a)=>a.id === this.thumbnail.id);
    }
    isValid() {
        return this.infoFields.isValid() && this.requiredFields.isValid();
    }
    hasPendingChanges() {
        return this.infoFields.hasPendingChanges() || this.requiredFields.hasPendingChanges() || this.itemReference.hasPendingChanges();
    }
    clearPendingChanges() {
        this.infoFields.pending = {};
        this.requiredFields.pending = {};
        this.itemReference.pending = {};
    }
    initFromStub(bimStub) {
        this.infoFields = new (0, $8d3ebfc71b421629$export$c420f81005157a4a)(bimStub);
        this.id = bimStub?.id || this.id;
        this.tags = bimStub?.tags || this.tags; // init/refresh tags
        this.itemReference = new (0, $8d3ebfc71b421629$export$29128e8e1c948ff8)(bimStub?.itemReference);
        this.thumbnail.url = bimStub?.thumbnailDownload?.url || this.thumbnail.url;
        this.thumbnail.id = bimStub?.thumbnailAttachmentId || this.thumbnail.id;
        this.modelParameters = bimStub?.parameters ? new (0, $8d3ebfc71b421629$export$475d35c0452706c7)(bimStub?.parameters) : this.modelParameters;
        this.requiredFields = this.requiredFields || new (0, $8d3ebfc71b421629$export$11aebda652217b5f)(bimStub?.unstructuredData);
        this.requiredFields.stub = bimStub?.unstructuredData;
    }
    // export object to bimapi create stub
    toUpdateStub() {
        const itemReference = this.itemReference.toStub();
        const requiredFields = this.requiredFields.toStub();
        const pendingChanges = {
            displayName: this.infoFields.name,
            itemReference: itemReference,
            unstructuredData: {
                ...requiredFields
            }
        };
        return this.hasPendingChanges() ? pendingChanges : null;
    }
    // export object to bimapi create stub
    toCreateStub() {
        return {
            displayName: this.infoFields.name,
            tags: this.tags,
            unstructuredData: this.requiredFields.toStub()
        };
    }
    constructor(){
        this.tags = {};
        this.model = {};
        this.thumbnail = {
            id: '',
            url: ''
        };
        this.isFullyLoaded = false // hacky way to tell bim details have been loaded
        ;
        this.attachments = [];
    }
}
class $0bafe5cbc4b092bf$export$7a74d234056b756b {
    constructor(stub, bimId){
        this.isLoaded = false;
        this.id = stub.id;
        this.bimRefId = bimId;
        this.title = stub.title;
        this.type = stub.type;
    }
    /**
     * Load attachment details from api stub
     */ async load(forceRefresh) {
        if (!this.isLoaded || forceRefresh) {
            console.log(`[BimAttachment] fetch details for attachment ${this.id}`);
            this.isLoaded = true; // hack to prevent simultaneous fetch
            const reply = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.getAttachment(this.bimRefId, this.id);
            const attachmentDetails = await reply.json();
            this.size = attachmentDetails.size;
            this.date = attachmentDetails.finaliseDate;
            this.url = attachmentDetails.download?.url;
            console.debug(attachmentDetails);
        } else console.warn(`Skip details fetching and use cache infos for attachment ${this.id}
             => use force refresh flag otherwise `);
    }
    // TODO
    retrieveAttachment() {
        if (!this.url) console.warn(`Skipping image attachment ${this.id} as no download information was found `);
    }
}
class $0bafe5cbc4b092bf$export$9a93b0d49a84081a {
    static{
        this.instances = {} // index of local bim instances
        ;
    }
    static{
        this.isPreloaded = false;
    }
    /**
     * Search/fetch items from BIM API service
     */ static async searchFetch(textFilter, pageId, forceRefresh = false) {
        if (!$0bafe5cbc4b092bf$export$9a93b0d49a84081a.isPreloaded || forceRefresh) {
            console.log('[BimFactory] list text-filter:', textFilter);
            $0bafe5cbc4b092bf$export$9a93b0d49a84081a.isPreloaded = true; // hack to avoid simultaneous requests
            // repopulate local store
            $0bafe5cbc4b092bf$export$9a93b0d49a84081a.instances = {};
            const resp = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.fetchItems(textFilter, $0bafe5cbc4b092bf$var$BIM_ITEMS_FETCH_COUNT, pageId);
            if (resp.status === 200) {
                const data = await resp.json();
                let nextPage;
                for (const [h, v] of resp.headers.entries())nextPage = h === 'x-sitesee-next-page-token' ? v : nextPage;
                const bimItems = data.map((stub)=>$0bafe5cbc4b092bf$export$9a93b0d49a84081a.createFromStub(stub));
                bimItems.forEach((item)=>$0bafe5cbc4b092bf$export$9a93b0d49a84081a.instances[item.id] = item);
                console.log(`[BimFactory] fetched ${bimItems.length} items from server`);
                return nextPage;
            } else {
                const errorMsg = `[BimFactory] error while fetching BIM items error code: ${resp.status}`;
                console.warn(errorMsg);
            }
        } else console.warn('[BimFactory] already populated, use forceRefresh to fetch data again from server');
    }
    static createFromStub(bimStub) {
        const bimInstance = new $0bafe5cbc4b092bf$export$617f92e08d05bd16();
        bimInstance.initFromStub(bimStub);
        return bimInstance;
    }
    static toArray() {
        return Object.values($0bafe5cbc4b092bf$export$9a93b0d49a84081a.instances);
    }
}


// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $89a1bb9709695920$export$f3b76d2cce458caa(slot) {
    return (0, $4Cod0.default)('MuiCard', slot);
}
const $89a1bb9709695920$var$cardClasses = (0, $beCSm.default)('MuiCard', [
    'root'
]);
var $89a1bb9709695920$export$2e2bcd8739ae039 = $89a1bb9709695920$var$cardClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $45313e7d506ce734$var$_excluded = [
    "className",
    "raised"
];
const $45313e7d506ce734$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $89a1bb9709695920$export$f3b76d2cce458caa), classes);
};
const $45313e7d506ce734$var$CardRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $45313e7d506ce734$var$Card = /*#__PURE__*/ $acw62.forwardRef(function Card(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $1En50.default)(props, $45313e7d506ce734$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        raised: raised
    });
    const classes = $45313e7d506ce734$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($45313e7d506ce734$var$CardRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $45313e7d506ce734$export$2e2bcd8739ae039 = $45313e7d506ce734$var$Card;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $273fd99738f3adbe$export$964336739a8c7119(slot) {
    return (0, $4Cod0.default)('MuiCardContent', slot);
}
const $273fd99738f3adbe$var$cardContentClasses = (0, $beCSm.default)('MuiCardContent', [
    'root'
]);
var $273fd99738f3adbe$export$2e2bcd8739ae039 = $273fd99738f3adbe$var$cardContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $28a500ea92f2665f$var$_excluded = [
    "className",
    "component"
];
const $28a500ea92f2665f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $273fd99738f3adbe$export$964336739a8c7119), classes);
};
const $28a500ea92f2665f$var$CardContentRoot = (0, $d8seH.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    };
});
const $28a500ea92f2665f$var$CardContent = /*#__PURE__*/ $acw62.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $1En50.default)(props, $28a500ea92f2665f$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $28a500ea92f2665f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($28a500ea92f2665f$var$CardContentRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $28a500ea92f2665f$export$2e2bcd8739ae039 = $28a500ea92f2665f$var$CardContent;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $72f090ff2322b6ae$export$5f5333fe417019a7(slot) {
    return (0, $4Cod0.default)('MuiCardMedia', slot);
}
const $72f090ff2322b6ae$var$cardMediaClasses = (0, $beCSm.default)('MuiCardMedia', [
    'root',
    'media',
    'img'
]);
var $72f090ff2322b6ae$export$2e2bcd8739ae039 = $72f090ff2322b6ae$var$cardMediaClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $891b59d4b36435bb$var$_excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const $891b59d4b36435bb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            'root',
            isMediaComponent && 'media',
            isImageComponent && 'img'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $72f090ff2322b6ae$export$5f5333fe417019a7), classes);
};
const $891b59d4b36435bb$var$CardMediaRoot = (0, $d8seH.default)('div', {
    name: 'MuiCardMedia',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'block',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
    }, ownerState.isMediaComponent && {
        width: '100%'
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: 'cover'
    }));
const $891b59d4b36435bb$var$MEDIA_COMPONENTS = [
    'video',
    'audio',
    'picture',
    'iframe',
    'img'
];
const $891b59d4b36435bb$var$IMAGE_COMPONENTS = [
    'picture',
    'img'
];
const $891b59d4b36435bb$var$CardMedia = /*#__PURE__*/ $acw62.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCardMedia'
    });
    const { children: children, className: className, component: component = 'div', image: image, src: src, style: style } = props, other = (0, $1En50.default)(props, $891b59d4b36435bb$var$_excluded);
    const isMediaComponent = $891b59d4b36435bb$var$MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, $8nd05.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $891b59d4b36435bb$var$IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = $891b59d4b36435bb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($891b59d4b36435bb$var$CardMediaRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? 'img' : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
var $891b59d4b36435bb$export$2e2bcd8739ae039 = $891b59d4b36435bb$var$CardMedia;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $kSnzZ = parcelRequire("kSnzZ");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");






var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b23cfd2067550897$export$5682c366c0c669d9(slot) {
    return (0, $4Cod0.default)('MuiListItem', slot);
}
const $b23cfd2067550897$var$listItemClasses = (0, $beCSm.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $b23cfd2067550897$export$2e2bcd8739ae039 = $b23cfd2067550897$var$listItemClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a1fd72c2634274a8$export$c09531d8563c67a5(slot) {
    return (0, $4Cod0.default)('MuiListItemButton', slot);
}
const $a1fd72c2634274a8$var$listItemButtonClasses = (0, $beCSm.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $a1fd72c2634274a8$export$2e2bcd8739ae039 = $a1fd72c2634274a8$var$listItemButtonClasses;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $558d665a4b71ad4c$export$ccdb26aeba48a86e(slot) {
    return (0, $4Cod0.default)('MuiListItemSecondaryAction', slot);
}
const $558d665a4b71ad4c$var$listItemSecondaryActionClasses = (0, $beCSm.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $558d665a4b71ad4c$export$2e2bcd8739ae039 = $558d665a4b71ad4c$var$listItemSecondaryActionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9924235485c5a222$var$_excluded = [
    "className"
];
const $9924235485c5a222$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $558d665a4b71ad4c$export$ccdb26aeba48a86e), classes);
};
const $9924235485c5a222$var$ListItemSecondaryActionRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $9924235485c5a222$var$ListItemSecondaryAction = /*#__PURE__*/ $acw62.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $9924235485c5a222$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $9924235485c5a222$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9924235485c5a222$var$ListItemSecondaryActionRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$9924235485c5a222$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $9924235485c5a222$export$2e2bcd8739ae039 = $9924235485c5a222$var$ListItemSecondaryAction;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f92832698674c928$var$_excluded = [
    "className"
], $f92832698674c928$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $f92832698674c928$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $f92832698674c928$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $b23cfd2067550897$export$5682c366c0c669d9), classes);
};
const $f92832698674c928$export$aed538f7519abe89 = (0, $d8seH.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $f92832698674c928$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $8nd05.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $a1fd72c2634274a8$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $f92832698674c928$var$ListItemContainer = (0, $d8seH.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $f92832698674c928$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $1En50.default)(props.ContainerProps, $f92832698674c928$var$_excluded), other = (0, $1En50.default)(props, $f92832698674c928$var$_excluded2);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $acw62.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $f92832698674c928$var$useUtilityClasses(ownerState);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $f92832698674c928$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $9QePP.default)((0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $4a35786d89db9dda$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f92832698674c928$var$ListItemContainer, (0, $8nd05.default)({
                as: ContainerComponent,
                className: (0, $9QePP.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
                        as: Component,
                        ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
            ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9924235485c5a222$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $f92832698674c928$export$2e2bcd8739ae039 = $f92832698674c928$var$ListItem;



const $647b290a2a3a9460$var$BimPreviewCard = ({ item: item, onClick: onClick, isSelected: isSelected = false })=>{
    const [, setHovered] = (0, $acw62.useState)(false);
    const [editMode, setEditMode] = (0, $acw62.useState)(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const updateField = (fieldName, fieldValue)=>{
        const changes = {};
        changes[fieldName] = fieldValue;
        return (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.updateItem(item.id, changes).then(()=>setEditMode(false));
    };
    (0, $acw62.useEffect)(()=>{
        // if editMode was previously activated, resest it when item is deselected
        if (editMode && !isSelected) {
            console.log('[BimPreviewCard] reset edit mode');
            setEditMode(false);
        }
    }, [
        isSelected
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $45313e7d506ce734$export$2e2bcd8739ae039), {
        onClick: onClick,
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        sx: {
            width: '100%',
            display: 'flex',
            '&:hover': {
                border: '1px solid lightgrey',
                cursor: 'pointer'
            },
            backgroundColor: isSelected ? '#f0f1f5' : 'white',
            border: isSelected ? '1px solid lightgrey' : ''
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28a500ea92f2665f$export$2e2bcd8739ae039), {
                    sx: {
                        flex: '1 0 auto'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        component: "div",
                        variant: "subtitle1",
                        children: item.infoFields.name
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $891b59d4b36435bb$export$2e2bcd8739ae039), {
                component: "img",
                sx: {
                    width: 'auto',
                    height: '80px',
                    marginLeft: 'auto'
                },
                image: item.thumbnail?.url
            })
        ]
    });
};
const $647b290a2a3a9460$export$77dbd89d2efb3023 = ({ items: items, selectItem: selectItem, selectedId: selectedId })=>{
    /* eslint-disable react/prop-types */ return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $640cd381f5e8b3ea$export$2e2bcd8739ae039), {
        sx: {
            width: '100%',
            maxWidth: 460,
            bgcolor: 'background.paper'
        },
        children: items.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f92832698674c928$export$2e2bcd8739ae039), {
                alignItems: "flex-start",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($647b290a2a3a9460$var$BimPreviewCard, {
                    item: item,
                    onClick: ()=>selectItem(item.id),
                    isSelected: item.id === selectedId
                })
            }, item.id))
    });
/* eslint-enable react/prop-types */ };


// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jjlaj = parcelRequire("jjlaj");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b86eb8364bb4993c$export$29cad1383b3f235d(slot) {
    return (0, $4Cod0.default)('MuiCircularProgress', slot);
}
const $b86eb8364bb4993c$var$circularProgressClasses = (0, $beCSm.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $b86eb8364bb4993c$export$2e2bcd8739ae039 = $b86eb8364bb4993c$var$circularProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $19b4ac261663afa8$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $19b4ac261663afa8$var$_ = (t)=>t, $19b4ac261663afa8$var$_t, $19b4ac261663afa8$var$_t2, $19b4ac261663afa8$var$_t3, $19b4ac261663afa8$var$_t4;
const $19b4ac261663afa8$var$SIZE = 44;
const $19b4ac261663afa8$var$circularRotateKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t || ($19b4ac261663afa8$var$_t = $19b4ac261663afa8$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $19b4ac261663afa8$var$circularDashKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t2 || ($19b4ac261663afa8$var$_t2 = $19b4ac261663afa8$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $19b4ac261663afa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $jTnBY.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $jTnBY.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $b86eb8364bb4993c$export$29cad1383b3f235d), classes);
};
const $19b4ac261663afa8$var$CircularProgressRoot = (0, $d8seH.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $jjlaj.css)($19b4ac261663afa8$var$_t3 || ($19b4ac261663afa8$var$_t3 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $19b4ac261663afa8$var$circularRotateKeyframe));
const $19b4ac261663afa8$var$CircularProgressSVG = (0, $d8seH.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $19b4ac261663afa8$var$CircularProgressCircle = (0, $d8seH.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $jjlaj.css)($19b4ac261663afa8$var$_t4 || ($19b4ac261663afa8$var$_t4 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $19b4ac261663afa8$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $19b4ac261663afa8$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $1En50.default)(props, $19b4ac261663afa8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $19b4ac261663afa8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($19b4ac261663afa8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        style: (0, $8nd05.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE} ${$19b4ac261663afa8$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $19b4ac261663afa8$var$SIZE,
                cy: $19b4ac261663afa8$var$SIZE,
                r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $19b4ac261663afa8$export$2e2bcd8739ae039 = $19b4ac261663afa8$var$CircularProgress;


// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $7027da6f4b17de9d$var$usePreviousProps = (value)=>{
    const ref = $acw62.useRef({});
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $7027da6f4b17de9d$export$2e2bcd8739ae039 = $7027da6f4b17de9d$var$usePreviousProps;


'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $23a03a376a300fc5$var$stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function $23a03a376a300fc5$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $23a03a376a300fc5$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $23a03a376a300fc5$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $23a03a376a300fc5$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $23a03a376a300fc5$var$defaultFilterOptions = $23a03a376a300fc5$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $23a03a376a300fc5$var$pageSize = 5;
const $23a03a376a300fc5$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
const $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE = [];
function $23a03a376a300fc5$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $23a03a376a300fc5$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $23a03a376a300fc5$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $acw62.useRef(false);
    const firstFocus = $acw62.useRef(true);
    const inputRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [focusedTag, setFocusedTag] = $acw62.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $acw62.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $acw62.useState(false);
    const resetInputValue = $acw62.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, 'reset');
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $acw62.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $7027da6f4b17de9d$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $acw62.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $acw62.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = 'auto' })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = 'next', reason: reason = 'auto' })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $23a03a376a300fc5$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $acw62.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $23a03a376a300fc5$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $23a03a376a300fc5$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((node)=>{
        (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $acw62.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $acw62.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $23a03a376a300fc5$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$23a03a376a300fc5$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $23a03a376a300fc5$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $8nd05.default)({
                'aria-owns': listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $8nd05.default)({
                key: index,
                'data-tag-index': index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $23a03a376a300fc5$export$2e2bcd8739ae039 = $23a03a376a300fc5$var$useAutocomplete;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
var $41136b35f34e8eee$exports = {};
"use strict";
'use client';
Object.defineProperty($41136b35f34e8eee$exports, "__esModule", {
    value: true
});
$41136b35f34e8eee$exports.default = void 0;

var $41136b35f34e8eee$var$React = $41136b35f34e8eee$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
function $41136b35f34e8eee$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($41136b35f34e8eee$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $41136b35f34e8eee$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $41136b35f34e8eee$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $41136b35f34e8eee$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $41136b35f34e8eee$var$useTheme(defaultTheme = null) {
    const contextTheme = $41136b35f34e8eee$var$React.useContext($eP9YU.T);
    return !contextTheme || $41136b35f34e8eee$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $41136b35f34e8eee$var$_default = $41136b35f34e8eee$exports.default = $41136b35f34e8eee$var$useTheme;






var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $8Indx = parcelRequire("8Indx");



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1(slot) {
    return (0, $4Cod0.default)('MuiPopper', slot);
}
const $bb1b487b0ea8f7b1$var$popperClasses = (0, $beCSm.default)('MuiPopper', [
    'root'
]);
var $bb1b487b0ea8f7b1$export$2e2bcd8739ae039 = $bb1b487b0ea8f7b1$var$popperClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5a1e9a841ed0d0fc$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $5a1e9a841ed0d0fc$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $5a1e9a841ed0d0fc$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $5a1e9a841ed0d0fc$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $5a1e9a841ed0d0fc$var$isVirtualElement(element) {
    return !$5a1e9a841ed0d0fc$var$isHTMLElement(element);
}
const $5a1e9a841ed0d0fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1), classes);
};
const $5a1e9a841ed0d0fc$var$defaultPopperOptions = {};
const $5a1e9a841ed0d0fc$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded);
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $5a1e9a841ed0d0fc$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $acw62.useState($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $acw62.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $8nd05.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $5a1e9a841ed0d0fc$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $5a1e9a841ed0d0fc$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $5a1e9a841ed0d0fc$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded2);
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) ? (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2117883cc21a32b2$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$PopperTooltip, (0, $8nd05.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $8nd05.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $5a1e9a841ed0d0fc$export$2e2bcd8739ae039 = $5a1e9a841ed0d0fc$var$Popper;



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a4669aa090d445bd$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $a4669aa090d445bd$var$PopperRoot = (0, $d8seH.default)((0, $5a1e9a841ed0d0fc$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $a4669aa090d445bd$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($41136b35f34e8eee$exports)))();
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $a4669aa090d445bd$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $8nd05.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a4669aa090d445bd$var$PopperRoot, (0, $8nd05.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $a4669aa090d445bd$export$2e2bcd8739ae039 = $a4669aa090d445bd$var$Popper;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d7f4cf29715b69dd$export$6816d4fc0981ec7(slot) {
    return (0, $4Cod0.default)('MuiListSubheader', slot);
}
const $d7f4cf29715b69dd$var$listSubheaderClasses = (0, $beCSm.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $d7f4cf29715b69dd$export$2e2bcd8739ae039 = $d7f4cf29715b69dd$var$listSubheaderClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5408b2039b9d572c$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $5408b2039b9d572c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d7f4cf29715b69dd$export$6816d4fc0981ec7), classes);
};
const $5408b2039b9d572c$var$ListSubheaderRoot = (0, $d8seH.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $5408b2039b9d572c$var$ListSubheader = /*#__PURE__*/ $acw62.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $1En50.default)(props, $5408b2039b9d572c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $5408b2039b9d572c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5408b2039b9d572c$var$ListSubheaderRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$5408b2039b9d572c$var$ListSubheader.muiSkipListHighlight = true;
var $5408b2039b9d572c$export$2e2bcd8739ae039 = $5408b2039b9d572c$var$ListSubheader;





var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $62d1787512a69c15$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');





var $jTnBY = parcelRequire("jTnBY");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $db0771a9e6a32b1d$export$31444911e4ee6fdd(slot) {
    return (0, $4Cod0.default)('MuiChip', slot);
}
const $db0771a9e6a32b1d$var$chipClasses = (0, $beCSm.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $db0771a9e6a32b1d$export$2e2bcd8739ae039 = $db0771a9e6a32b1d$var$chipClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $47d4f79319086dc5$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $47d4f79319086dc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $jTnBY.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $jTnBY.default)(color)}`,
            `${variant}${(0, $jTnBY.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $jTnBY.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $jTnBY.default)(size)}`,
            `avatarColor${(0, $jTnBY.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(size)}`,
            `iconColor${(0, $jTnBY.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $jTnBY.default)(size)}`,
            `deleteIconColor${(0, $jTnBY.default)(color)}`,
            `deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $db0771a9e6a32b1d$export$31444911e4ee6fdd), classes);
};
const $47d4f79319086dc5$var$ChipRoot = (0, $d8seH.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $jTnBY.default)(iconColor)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $jTnBY.default)(size)}`],
            styles[`color${(0, $jTnBY.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $jTnBY.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $jTnBY.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $jTnBY.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $8nd05.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: (0, $8nd05.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $8nd05.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: (0, $8nd05.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $kSnzZ.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $kSnzZ.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kSnzZ.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $47d4f79319086dc5$var$ChipLabel = (0, $d8seH.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $jTnBY.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $47d4f79319086dc5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $47d4f79319086dc5$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $1En50.default)(props, $47d4f79319086dc5$var$_excluded);
    const chipRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $4a35786d89db9dda$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $acw62.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $47d4f79319086dc5$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $4a35786d89db9dda$export$2e2bcd8739ae039) ? (0, $8nd05.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
        className: (0, $9QePP.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62d1787512a69c15$export$2e2bcd8739ae039), {
        className: (0, $9QePP.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $9QePP.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($47d4f79319086dc5$var$ChipRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)($47d4f79319086dc5$var$ChipLabel, {
                className: (0, $9QePP.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $47d4f79319086dc5$export$2e2bcd8739ae039 = $47d4f79319086dc5$var$Chip;






parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $f7280bbf95507cba$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $723a67e53eb4dc4c$export$8ee01529667e66d9(slot) {
    return (0, $4Cod0.default)('MuiAutocomplete', slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $beCSm.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $723a67e53eb4dc4c$export$2e2bcd8739ae039 = $723a67e53eb4dc4c$var$autocompleteClasses;



var $jTnBY = parcelRequire("jTnBY");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $9396253983985262$var$_ClearIcon, $9396253983985262$var$_ArrowDropDownIcon;
const $9396253983985262$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $9396253983985262$var$_excluded2 = [
    "ref"
], $9396253983985262$var$_excluded3 = [
    "key"
], $9396253983985262$var$_excluded4 = [
    "key"
];
const $9396253983985262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $jTnBY.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $723a67e53eb4dc4c$export$8ee01529667e66d9), classes);
};
const $9396253983985262$var$AutocompleteRoot = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused} .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $9396253983985262$var$AutocompleteEndAdornment = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $9396253983985262$var$AutocompleteClearIndicator = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $9396253983985262$var$AutocompletePopupIndicator = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $8nd05.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $9396253983985262$var$AutocompletePopper = (0, $d8seH.default)((0, $a4669aa090d445bd$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    }));
const $9396253983985262$var$AutocompletePaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body1, {
        overflow: 'auto'
    }));
const $9396253983985262$var$AutocompleteLoading = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $9396253983985262$var$AutocompleteNoOptions = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $9396253983985262$var$AutocompleteListbox = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $9396253983985262$var$AutocompleteGroupLabel = (0, $d8seH.default)((0, $5408b2039b9d572c$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $9396253983985262$var$AutocompleteGroupUl = (0, $d8seH.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $9396253983985262$var$Autocomplete = /*#__PURE__*/ $acw62.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $9396253983985262$var$_ClearIcon || ($9396253983985262$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7280bbf95507cba$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = 'ul', ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', openOnFocus: openOnFocus = false, openText: openText = 'Open', PaperComponent: PaperComponent = (0, $595185d0d7275c3b$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $a4669aa090d445bd$export$2e2bcd8739ae039), popupIcon: popupIcon = $9396253983985262$var$_ArrowDropDownIcon || ($9396253983985262$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a863bd9b12ca76b$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $9396253983985262$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $23a03a376a300fc5$export$2e2bcd8739ae039)((0, $8nd05.default)({}, props, {
        componentName: 'Autocomplete'
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $1En50.default)(_getListboxProps, $9396253983985262$var$_excluded2);
    const combinedListboxRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $8nd05.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $9396253983985262$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $8nd05.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const _getCustomizedTagProp = getCustomizedTagProps({
                index: index
            }), { key: key } = _getCustomizedTagProp, customTagProps = (0, $1En50.default)(_getCustomizedTagProp, $9396253983985262$var$_excluded3);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), (0, $8nd05.default)({
                label: getOptionLabel(option),
                size: size
            }, customTagProps, ChipProps), key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $1En50.default)(props2, $9396253983985262$var$_excluded4);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", (0, $8nd05.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $8nd05.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteRoot, (0, $8nd05.default)({
                ref: ref,
                className: (0, $9QePP.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $8nd05.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteClearIndicator, (0, $8nd05.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopupIndicator, (0, $8nd05.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $8nd05.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopper, (0, $8nd05.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $9QePP.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompletePaper, (0, $8nd05.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $9QePP.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteListbox, (0, $8nd05.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $9396253983985262$export$2e2bcd8739ae039 = $9396253983985262$var$Autocomplete;



const $bb7aa6a5931da2b2$export$d0b89778d85285fc = ({ tags: tags, onTagsChange: onTagsChange })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9396253983985262$export$2e2bcd8739ae039), {
        multiple: true,
        id: "tags",
        options: [],
        value: tags,
        freeSolo: true,
        size: (0, $71900262780a903e$export$16784d4c3a087cb5),
        sx: {
            marginTop: 2
        },
        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                ...params,
                variant: "outlined",
                label: "Optional tags",
                placeholder: "Type and press enter"
            }),
        onChange: onTagsChange
    });
};
const $bb7aa6a5931da2b2$export$3a27290e23f4ac1e = ({ tags: tags, setTags: setTags })=>{
    const tagsArr = Object.keys(tags);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9396253983985262$export$2e2bcd8739ae039), {
        multiple: true,
        id: "tags",
        options: [],
        value: tagsArr,
        freeSolo: true,
        sx: {
            marginTop: 4
        },
        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                ...params,
                variant: "outlined",
                label: "Labels",
                placeholder: setTags ? 'Type and press enter' : ''
            }),
        disabled: !setTags
    });
};
const $bb7aa6a5931da2b2$export$a26644aeff9fb039 = ({ tags: tags, onTagAdded: onTagAdded, onTagRemoved: onTagRemoved })=>{
    const tagsArr = Object.keys(tags);
    // add/remove tag in server
    const onTagsChange = async (event, newTags)=>{
        // compute diff to find added or removed tag
        const diffCount = newTags.length - tagsArr.length;
        const isAdded = diffCount > 0;
        const tagsCount = {};
        [
            ...tagsArr,
            ...newTags
        ].forEach((tagName)=>tagsCount[tagName] = tagsCount[tagName] ? tagsCount[tagName] + 1 : 1);
        const tag = Object.entries(tagsCount).find(([, count])=>count === 1)?.[0];
        console.log(`${isAdded ? 'added' : 'removes'} tag: ${tag}`);
        isAdded ? onTagAdded(tag) : onTagRemoved(tag);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9396253983985262$export$2e2bcd8739ae039), {
        multiple: true,
        id: "tags",
        options: [],
        value: tagsArr,
        freeSolo: true,
        size: (0, $71900262780a903e$export$16784d4c3a087cb5),
        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                ...params,
                variant: "outlined",
                label: "Labels",
                placeholder: "Type and press enter"
            }),
        onChange: onTagsChange
    });
};





// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3OJTQ = parcelRequire("3OJTQ");

var $hcz0Q = parcelRequire("hcz0Q");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e1c9164ec15102c7$var$GridContext = /*#__PURE__*/ $acw62.createContext();
var $e1c9164ec15102c7$export$2e2bcd8739ae039 = $e1c9164ec15102c7$var$GridContext;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f35b8acab3fc2f62$export$9973ac5fd0181f33(slot) {
    return (0, $4Cod0.default)('MuiGrid', slot);
}
const $f35b8acab3fc2f62$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f35b8acab3fc2f62$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $f35b8acab3fc2f62$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $f35b8acab3fc2f62$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f35b8acab3fc2f62$var$gridClasses = (0, $beCSm.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$f35b8acab3fc2f62$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$f35b8acab3fc2f62$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$f35b8acab3fc2f62$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f35b8acab3fc2f62$export$2e2bcd8739ae039 = $f35b8acab3fc2f62$var$gridClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9450fbc34cc5b2ea$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $9450fbc34cc5b2ea$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $9450fbc34cc5b2ea$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $3OJTQ.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $8nd05.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $9450fbc34cc5b2ea$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $3OJTQ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $3OJTQ.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $9450fbc34cc5b2ea$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $9450fbc34cc5b2ea$var$GridRoot = (0, $d8seH.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $9450fbc34cc5b2ea$export$71d4225eeb1bc13e, $9450fbc34cc5b2ea$export$380604d7c79f9e8f, $9450fbc34cc5b2ea$export$4315fba5128fb4a1, $9450fbc34cc5b2ea$export$ca2a698f6020fda);
function $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $9450fbc34cc5b2ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f35b8acab3fc2f62$export$9973ac5fd0181f33), classes);
};
const $9450fbc34cc5b2ea$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const props = (0, $hcz0Q.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $1En50.default)(props, $9450fbc34cc5b2ea$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $acw62.useContext((0, $e1c9164ec15102c7$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $8nd05.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $9450fbc34cc5b2ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1c9164ec15102c7$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9450fbc34cc5b2ea$var$GridRoot, (0, $8nd05.default)({
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $9450fbc34cc5b2ea$export$2e2bcd8739ae039 = $9450fbc34cc5b2ea$var$Grid;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");




var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3e589c60baacdec$export$4b135a4b3a6c4550(slot) {
    return (0, $4Cod0.default)('MuiInputAdornment', slot);
}
const $f3e589c60baacdec$var$inputAdornmentClasses = (0, $beCSm.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $f3e589c60baacdec$export$2e2bcd8739ae039 = $f3e589c60baacdec$var$inputAdornmentClasses;



var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d0c64ff513a9933f$var$_span;
const $d0c64ff513a9933f$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $d0c64ff513a9933f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d0c64ff513a9933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $jTnBY.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f3e589c60baacdec$export$4b135a4b3a6c4550), classes);
};
const $d0c64ff513a9933f$var$InputAdornmentRoot = (0, $d8seH.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $d0c64ff513a9933f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $d0c64ff513a9933f$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $1En50.default)(props, $d0c64ff513a9933f$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $d0c64ff513a9933f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$InputAdornmentRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d0c64ff513a9933f$var$_span || ($d0c64ff513a9933f$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $d0c64ff513a9933f$export$2e2bcd8739ae039 = $d0c64ff513a9933f$var$InputAdornment;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");






var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9c1b7b40cd19f5fe$export$81478e24460c57f2(slot) {
    return (0, $4Cod0.default)('MuiListItemIcon', slot);
}
const $9c1b7b40cd19f5fe$var$listItemIconClasses = (0, $beCSm.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $9c1b7b40cd19f5fe$export$2e2bcd8739ae039 = $9c1b7b40cd19f5fe$var$listItemIconClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c01aa6ddbe5e68bd$export$1061006a0db3aeb5(slot) {
    return (0, $4Cod0.default)('MuiListItemText', slot);
}
const $c01aa6ddbe5e68bd$var$listItemTextClasses = (0, $beCSm.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $c01aa6ddbe5e68bd$export$2e2bcd8739ae039 = $c01aa6ddbe5e68bd$var$listItemTextClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adff06ac3b11e066$export$515f8c67b5305377(slot) {
    return (0, $4Cod0.default)('MuiMenuItem', slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $beCSm.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $adff06ac3b11e066$export$2e2bcd8739ae039 = $adff06ac3b11e066$var$menuItemClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1ac984bce84b2164$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $1ac984bce84b2164$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $1ac984bce84b2164$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $adff06ac3b11e066$export$515f8c67b5305377), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $1ac984bce84b2164$var$MenuItemRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $1ac984bce84b2164$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kSnzZ.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $024a60f892d3fa61$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $024a60f892d3fa61$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $9c1b7b40cd19f5fe$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $8nd05.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $9c1b7b40cd19f5fe$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $1ac984bce84b2164$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $1En50.default)(props, $1ac984bce84b2164$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $1ac984bce84b2164$var$useUtilityClasses(props);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$MenuItemRoot, (0, $8nd05.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $1ac984bce84b2164$export$2e2bcd8739ae039 = $1ac984bce84b2164$var$MenuItem;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");





'use client';
var $4105219ee6538ed1$export$2e2bcd8739ae039 = (0, $7a3a319e7e555608$export$2e2bcd8739ae039);





var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $add5737403c6a16a$export$837848f5f6cee923(slot) {
    return (0, $4Cod0.default)('MuiTooltip', slot);
}
const $add5737403c6a16a$var$tooltipClasses = (0, $beCSm.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $add5737403c6a16a$export$2e2bcd8739ae039 = $add5737403c6a16a$var$tooltipClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96a8b4f445fd9172$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $96a8b4f445fd9172$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $96a8b4f445fd9172$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $jTnBY.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $add5737403c6a16a$export$837848f5f6cee923), classes);
};
const $96a8b4f445fd9172$var$TooltipPopper = (0, $d8seH.default)((0, $a4669aa090d445bd$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $96a8b4f445fd9172$var$TooltipTooltip = (0, $d8seH.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $jTnBY.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kSnzZ.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$96a8b4f445fd9172$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $8nd05.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $8nd05.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $8nd05.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $8nd05.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $8nd05.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $8nd05.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $96a8b4f445fd9172$var$TooltipArrow = (0, $d8seH.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kSnzZ.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $96a8b4f445fd9172$var$hystersisOpen = false;
const $96a8b4f445fd9172$var$hystersisTimer = new (0, $fcd4c6205d65c7df$export$786b4da70f00938b)();
let $96a8b4f445fd9172$var$cursorPosition = {
    x: 0,
    y: 0
};
function $96a8b4f445fd9172$export$b9ee5a7ace0541f8() {
    $96a8b4f445fd9172$var$hystersisOpen = false;
    $96a8b4f445fd9172$var$hystersisTimer.clear();
}
function $96a8b4f445fd9172$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $96a8b4f445fd9172$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $96a8b4f445fd9172$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $acw62.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const enterTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const touchTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $acw62.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.clear();
        $96a8b4f445fd9172$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $331f3746e6346411$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $96a8b4f445fd9172$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $96a8b4f445fd9172$var$hystersisOpen && enterNextDelay) enterTimer.start($96a8b4f445fd9172$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $96a8b4f445fd9172$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $8nd05.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $9QePP.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $96a8b4f445fd9172$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $96a8b4f445fd9172$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $96a8b4f445fd9172$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $96a8b4f445fd9172$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $acw62.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $8nd05.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $96a8b4f445fd9172$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $96a8b4f445fd9172$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $96a8b4f445fd9172$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $96a8b4f445fd9172$var$TooltipArrow;
    const popperProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(PopperComponent, (0, $8nd05.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $9QePP.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(TransitionComponent, (0, $8nd05.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(TooltipComponent, (0, $8nd05.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $9QePP.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(ArrowComponent, (0, $8nd05.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $9QePP.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperComponent, (0, $8nd05.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $a4669aa090d445bd$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $96a8b4f445fd9172$var$cursorPosition.y,
                            left: $96a8b4f445fd9172$var$cursorPosition.x,
                            right: $96a8b4f445fd9172$var$cursorPosition.x,
                            bottom: $96a8b4f445fd9172$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipComponent, (0, $8nd05.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowComponent, (0, $8nd05.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $96a8b4f445fd9172$export$2e2bcd8739ae039 = $96a8b4f445fd9172$var$Tooltip;


var $8c6ad197f63b3f3e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($8c6ad197f63b3f3e$exports, "__esModule", {
    value: true
});
$8c6ad197f63b3f3e$exports.default = void 0;

var $8c6ad197f63b3f3e$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8c6ad197f63b3f3e$var$_default = $8c6ad197f63b3f3e$exports.default = (0, $8c6ad197f63b3f3e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');


var $6eefe30025c8ad9a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($6eefe30025c8ad9a$exports, "__esModule", {
    value: true
});
$6eefe30025c8ad9a$exports.default = void 0;

var $6eefe30025c8ad9a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $6eefe30025c8ad9a$var$_default = $6eefe30025c8ad9a$exports.default = (0, $6eefe30025c8ad9a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3-10H5V5h10z"
}), 'Save');




const $d5a7174531dda72b$var$WIDE_FIELD_TRESHOLD = 30;
const $d5a7174531dda72b$export$bd94812d4d5b131f = ({ fields: fields, customAccessors: customAccessors, ...otherProps })=>{
    const [, setRefresh] = (0, $acw62.useState)(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const isWideField = (fieldValue)=>fieldValue?.length > $d5a7174531dda72b$var$WIDE_FIELD_TRESHOLD;
    const { getFieldName: getFieldName, getFieldValue: getFieldValue, getInputType: getInputType = ()=>'', getFieldId: getFieldId = getFieldName, getCustomWidth: getCustomWidth = (item)=>(0, $54bbbf96c1cde9f8$export$e21ffcc1af22774e)(getFieldValue(item)?.length) } = customAccessors;
    // common
    const { setFieldValue: setFieldValue, getFieldValidity: getFieldValidity = ()=>true, getCustomMsg: getCustomMsg = ()=>'', isEditable: isEditable = ()=>true } = customAccessors;
    // text only
    const { setFinalValue: setFinalValue = ()=>'', getUnits: getUnits = ()=>'' } = customAccessors;
    // select only
    const { getEnumValues: getEnumValues, getOptionLabel: getOptionLabel } = customAccessors;
    const updateField = (field, inputValue)=>{
        if (setFieldValue) {
            setFieldValue(field, inputValue);
            setRefresh((current)=>!current);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        spacing: fields.length > 1 ? 2 : 0,
        children: fields?.map((item)=>{
            const type = getInputType(item);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                xs: getCustomWidth?.(item),
                children: type === 'select' ? /*#__PURE__*/ (0, $ayMG0.jsx)($d5a7174531dda72b$export$f458baad8d8346bf, {
                    name: getFieldName(item),
                    options: getEnumValues(item),
                    selected: getFieldValue(item),
                    setSelected: isEditable(item) ? (val)=>setFieldValue(item, val) : null,
                    getOptionLabel: getOptionLabel,
                    validity: getFieldValidity(item)
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                    // key={'field_' + getFieldId(item)}
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                        title: getFieldName(item),
                        placement: "top",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: getFieldName(item)
                        })
                    }),
                    variant: "outlined",
                    value: getFieldValue(item) || '',
                    onChange: (e)=>updateField(item, e.target.value),
                    onBlur: (e)=>setFinalValue(item, e.target.value),
                    size: (0, $71900262780a903e$export$16784d4c3a087cb5),
                    error: !getFieldValidity(item),
                    disabled: !isEditable(item),
                    inputProps: {
                        inputMode: 'numeric',
                        pattern: '[0-9]*'
                    },
                    helperText: !getFieldValidity(item) ? getCustomMsg(item) : '',
                    fullWidth: true,
                    InputProps: {
                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0c64ff513a9933f$export$2e2bcd8739ae039), {
                            position: "end",
                            children: getUnits(item)
                        }),
                        // This start adornment is only here to prevent the label from moving inside the text box
                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0c64ff513a9933f$export$2e2bcd8739ae039), {
                            position: "start"
                        })
                    },
                    ...otherProps
                })
            }, 'field_' + getFieldId(item));
        })
    });
};
const $d5a7174531dda72b$export$f458baad8d8346bf = ({ name: name, options: options, getOptionValue: getOptionValue = (item)=>item, getOptionLabel: getOptionLabel = (item)=>item, selected: selected, setSelected: setSelected, validity: validity, hidden: hidden = false })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
        fullWidth: true,
        size: "small",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                id: "demo-select-small",
                children: name
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                labelId: "demo-select-small",
                id: "demo-select-small",
                value: selected || '',
                label: name,
                onChange: (e)=>setSelected(e.target.value),
                error: !validity(),
                disabled: !setSelected,
                hidden: hidden,
                children: options.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                        value: getOptionValue(opt),
                        children: getOptionLabel(opt)
                    }, getOptionValue(opt)))
            })
        ]
    });
};
/* eslint-enable react/prop-types */ // multiline threshold: max chars count per line before switching to multiline
const $d5a7174531dda72b$var$MAX_SINGLE_LINE_LENGTH = 20;
const $d5a7174531dda72b$export$d2053b7a2741b533 = ({ items: items, setFieldData: setFieldData, lineSplitLenght: lineSplitLenght = $d5a7174531dda72b$var$MAX_SINGLE_LINE_LENGTH })=>{
    console.log(items);
    /* eslint-disable react/prop-types */ return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
        spacing: 2,
        justifyContent: "center",
        alignItems: "center",
        children: items.map(([key, val])=>{
            const value = val?.value !== undefined ? val.value : val || '';
            const inputProps = !isNaN(value) ? {
                inputMode: 'numeric',
                pattern: '[0-9]*'
            } : null;
            // const isFullWidth = typeof value === "string"
            const isMultiline = isNaN(value) && value.length > lineSplitLenght;
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                label: val?.label || key,
                variant: "outlined",
                value: value,
                onChange: (e)=>setFieldData?.(key, e.target.value),
                style: {
                    marginBottom: '5px'
                },
                size: (0, $71900262780a903e$export$16784d4c3a087cb5),
                disabled: !setFieldData,
                inputProps: inputProps || {},
                multiline: isMultiline,
                fullWidth: !inputProps
            }, key);
        })
    });
/* eslint-enable react/prop-types */ };
const $d5a7174531dda72b$export$ca9e13afb3a05c5f = ({ initialValue: initialValue, onSave: onSave, defaultEdit: defaultEdit })=>{
    const [editMode, setEditMode] = (0, $acw62.useState)(!!defaultEdit);
    const [saveInProgress, setSaveInProgress] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)();
    const toggleEditSave = ()=>{
        if (editMode) {
            setSaveInProgress(true);
            const value = ref.current?.children?.[0]?.value;
            onSave(value).then(()=>{
                console.log('[EditSaveField] done saving edit');
                setSaveInProgress(false);
                setEditMode(!editMode);
            });
        } else setEditMode(!editMode);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5d55d2dd82639e9$export$2e2bcd8739ae039), {
        ref: ref,
        defaultValue: initialValue,
        size: "small",
        label: "Name",
        endAdornment: onSave ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0c64ff513a9933f$export$2e2bcd8739ae039), {
            position: "end",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                onClick: toggleEditSave,
                // onMouseDown={handleMouseDownPassword}
                edge: "end",
                children: [
                    editMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6eefe30025c8ad9a$exports))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {}),
                    saveInProgress && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                        size: 30,
                        sx: {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-15px',
                            marginLeft: '-15px'
                        }
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}),
        disabled: !editMode
    });
};
const $d5a7174531dda72b$export$a26644aeff9fb039 = ({ name: name = 'Tags', tags: tags, onTagAdded: onTagAdded, onTagRemoved: onTagRemoved })=>{
    // add/remove tag in server
    const onTagsChange = async (_event, newTags)=>{
        // const tags = Object.keys(bimCopy.tags)
        // compute diff to find added or removed tag
        const diffCount = newTags.length - tags.length;
        const isAdded = diffCount > 0;
        const tagsCount = {};
        [
            ...tags,
            ...newTags
        ].forEach((tagName)=>tagsCount[tagName] = tagsCount[tagName] ? tagsCount[tagName] + 1 : 1);
        const tag = Object.entries(tagsCount).find(([, count])=>count === 1)?.[0];
        isAdded ? onTagAdded(tag) : onTagRemoved(tag);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9396253983985262$export$2e2bcd8739ae039), {
        multiple: true,
        id: "tagsEditableList",
        options: [],
        value: tags,
        freeSolo: true,
        size: (0, $71900262780a903e$export$16784d4c3a087cb5),
        // sx={{ m: 2 }}
        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                ...params,
                variant: "outlined",
                label: name,
                placeholder: "Type and press enter"
            }),
        onChange: onTagsChange,
        disabled: !onTagAdded && !onTagRemoved
    });
};



const $847c89107864d1f8$export$b681679b4be4a0a8 = ({ bimModel: bimModel, validate: validate, editable: editable, onValidityChange: onValidityChange, displayIdAndName: displayIdAndName = true })=>{
    const { infoFields: infoFields } = bimModel;
    const getCustomWidth = (key)=>{
        const fieldVal = bimModel[key];
        const defaultWidth = (0, $54bbbf96c1cde9f8$export$e21ffcc1af22774e)(fieldVal?.length);
        return key === 'name' ? Math.max(4, defaultWidth) : defaultWidth;
    };
    const checkValidity = (key)=>{
        const fieldValidity = infoFields.isValidField(key);
        onValidityChange?.(fieldValidity);
        return fieldValidity;
    };
    const fieldPropsAccessors = {
        getFieldName: (key)=>key,
        getFieldValue: (key)=>infoFields[key],
        setFieldValue: (key, val)=>infoFields[key] = val,
        getFieldValidity: (key)=>validate ? checkValidity(key) : true,
        getCustomMsg: (key)=>key === 'name' ? 'unique name required' : 'required field',
        getCustomWidth: getCustomWidth,
        isEditable: (key)=>key !== 'bimId' && editable
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            width: '90%',
            m: 'auto'
        },
        children: displayIdAndName ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$bd94812d4d5b131f), {
            fields: [
                'bimId',
                'name'
            ],
            customAccessors: fieldPropsAccessors
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$bd94812d4d5b131f), {
            fields: [
                'name'
            ],
            customAccessors: fieldPropsAccessors
        })
    });
};
function $847c89107864d1f8$export$7f22536e6dff5ed7({ bimModel: bimModel, validate: validate, editable: editable }) {
    const { attachments: attachments, itemReference: itemReference } = bimModel;
    const [, setRefresh] = (0, $acw62.useState)(false);
    function checkValidity(key) {
        return itemReference.isValidField(key);
    }
    const fieldPropsAccessors = {
        getFieldName: (key)=>key,
        getFieldValue: (key)=>itemReference[key],
        setFieldValue: (key, val)=>itemReference[key] = val,
        getFieldValidity: (key)=>validate ? checkValidity(key) : true,
        getCustomWidth: ()=>12,
        isEditable: ()=>editable
    };
    // TODO: Maybe filter out attachments that can't be used as mesh reference
    const attachmentOptions = attachments.map((a)=>({
            id: a.id,
            type: (0, $fdac710428712a0c$export$e955f760fe56f4ac).Attachment,
            title: a.title
        }));
    // eslint-disable-next-line react/prop-types
    const AttachmentOptions = ({ options: options })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$f458baad8d8346bf), {
            name: 'Attachments',
            getOptionLabel: (item)=>item.title,
            getOptionValue: (item)=>item.id,
            options: options,
            selected: bimModel.itemReference.id,
            validity: ()=>validate ? checkValidity('id') : true,
            setSelected: editable ? (val)=>{
                // update BIM Model Reference
                bimModel.itemReference.type = (0, $fdac710428712a0c$export$e955f760fe56f4ac).Attachment;
                bimModel.itemReference.id = val;
                setRefresh((current)=>!current);
            } : null
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
        sx: {
            m: 2,
            mr: 4,
            ml: 4,
            width: '80%'
        },
        spacing: 2,
        direction: 'row',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$f458baad8d8346bf), {
                name: 'Type',
                options: [
                    (0, $fdac710428712a0c$export$e955f760fe56f4ac).Attachment,
                    (0, $e8e02a06888dee3c$export$7f8197e7d83dcce) ? (0, $fdac710428712a0c$export$e955f760fe56f4ac).HyperBim : null
                ],
                selected: bimModel.itemReference.type,
                validity: ()=>validate ? checkValidity('type') : true,
                setSelected: editable ? (val)=>{
                    console.log('setting mesh reference type');
                    bimModel.itemReference.type = val;
                    setRefresh((current)=>!current);
                } : null
            }),
            bimModel.itemReference.type === (0, $fdac710428712a0c$export$e955f760fe56f4ac).HyperBim ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$bd94812d4d5b131f), {
                fields: [
                    'id'
                ],
                customAccessors: fieldPropsAccessors
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)(AttachmentOptions, {
                options: attachmentOptions
            })
        ]
    });
}
const $847c89107864d1f8$var$BIM_TYPE_LABELS = {};
$847c89107864d1f8$var$BIM_TYPE_LABELS[(0, $fdac710428712a0c$export$846b5e744bfb83f8).GROUND] = 'Ground';
$847c89107864d1f8$var$BIM_TYPE_LABELS[(0, $fdac710428712a0c$export$846b5e744bfb83f8).TOWER] = 'Tower';
function $847c89107864d1f8$export$277f8897b6619a83({ bimRequiredFields: bimRequiredFields, validate: validate, editable: editable, onChange: onChange }) {
    const [, setRefresh] = (0, $acw62.useState)(false);
    const checkValidity = (item)=>{
        const fieldValidity = bimRequiredFields.isValidField(item.name);
        onChange?.();
        return fieldValidity;
    };
    const fieldPropsAccessors = {
        getFieldName: (item)=>item.name,
        getFieldValue: (item)=>item.value,
        setFieldValue: (field, val)=>{
            bimRequiredFields[field.name] = val;
            setRefresh((current)=>!current);
        },
        getFieldValidity: (item)=>validate ? checkValidity(item) : true,
        getCustomMsg: ()=>'required field',
        isEditable: ()=>editable
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            width: '90%',
            m: 'auto'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$bd94812d4d5b131f), {
            fields: bimRequiredFields.filterInputFields(),
            customAccessors: fieldPropsAccessors
        })
    });
}
function $847c89107864d1f8$export$474c1af473291c4a({ bimRequiredFields: bimRequiredFields, validate: validate, editable: editable, onChange: onChange }) {
    const [, setRefresh] = (0, $acw62.useState)(false);
    // const typeField: GenericField = bimRequiredFields.getField('typeClass');
    const subTypeField = bimRequiredFields.getField('type');
    const bimType = bimRequiredFields.typeClass;
    const bimSubtype = bimRequiredFields.type;
    console.log(`typeClass: ${bimType} type:${bimSubtype}`);
    const checkValidity = (field)=>{
        onChange?.();
        return bimRequiredFields.isValidField(field);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
            sx: {
                m: 2,
                mr: 4,
                ml: 4,
                width: '80%'
            },
            spacing: 4,
            direction: 'row',
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$f458baad8d8346bf), {
                    name: 'Type',
                    options: (0, $fdac710428712a0c$export$88221fdabbd13752),
                    selected: bimType,
                    getOptionLabel: (optVal)=>$847c89107864d1f8$var$BIM_TYPE_LABELS[optVal],
                    getOptionValue: (optVal)=>optVal,
                    validity: ()=>validate ? checkValidity('typeClass') : true,
                    setSelected: editable ? (val)=>{
                        bimRequiredFields.typeClass = val;
                        setRefresh((current)=>!current);
                    } : null
                }),
                subTypeField && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$f458baad8d8346bf), {
                    name: 'Subtype',
                    options: bimType === (0, $fdac710428712a0c$export$846b5e744bfb83f8).TOWER ? (0, $fdac710428712a0c$export$6c2628d56db252d4) : (0, $fdac710428712a0c$export$21e4b986824bfef4),
                    selected: bimSubtype,
                    getOptionLabel: (optVal)=>optVal,
                    getOptionValue: (optVal)=>optVal,
                    validity: ()=>validate ? checkValidity('type') : true,
                    setSelected: editable ? (val)=>{
                        bimRequiredFields.type = val;
                        setRefresh((current)=>!current);
                        onChange?.();
                    } : null
                })
            ]
        })
    });
}
function $847c89107864d1f8$export$6422c795941ce074({ bimRequiredFields: bimRequiredFields, validate: validate, editable: editable, onChange: onChange }) {
    const [, setRefresh] = (0, $acw62.useState)(false);
    const availableShapes = (0, $fdac710428712a0c$export$52f52a5c05885a9b)[bimRequiredFields.type] ?? (0, $baba9bdf33bc9eca$export$c78b4673549b3bf9);
    const fieldPropsAccessors = {
        getFieldName: (kv)=>kv[0],
        getFieldValue: (kv)=>kv[1].inputValue,
        setFieldValue: (kv, val)=>{
            const field = kv[1];
            field.inputValue = val;
            setRefresh((current)=>!current);
        },
        setFinalValue: (kv, finalValue)=>{
            const field = kv[1];
            field.value = finalValue;
            onChange?.();
        },
        getFieldValidity: (kv)=>validate ? kv[1].isValid() : true,
        getCustomMsg: ()=>'required field',
        isEditable: ()=>editable,
        getUnits: ()=>'m'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
        sx: {
            m: 2
        },
        direction: 'row',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: '30%',
                    marginRight: '20px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$f458baad8d8346bf), {
                    name: 'Shape',
                    options: availableShapes,
                    selected: bimRequiredFields.shape,
                    getOptionLabel: (elt)=>elt,
                    getOptionValue: (elt)=>elt,
                    validity: ()=>validate ? bimRequiredFields.isValidField('shape') : true,
                    setSelected: editable ? (val)=>{
                        bimRequiredFields.shape = val;
                        setRefresh((current)=>!current);
                        onChange?.();
                    } : null
                })
            }),
            bimRequiredFields.isValidField('shape') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$bd94812d4d5b131f), {
                fields: Object.entries(bimRequiredFields.shapeDimensions.fields),
                customAccessors: fieldPropsAccessors
            })
        ]
    });
}
const $847c89107864d1f8$export$cf2ee7f36841893a = ({ bimModelParameters: bimModelParameters, editable: editable })=>{
    const fieldPropsAccessors = {
        getFieldName: (field)=>bimModelParameters.getField(field.name)?.originalStub?.displayName,
        getFieldValue: (field)=>bimModelParameters.getFieldValue(field.name),
        getFieldId: (item)=>item?.originalStub?.name,
        setFieldValue: (field, val)=>bimModelParameters.setFieldValue(field.name, val),
        isEditable: ()=>editable,
        getUnits: (field)=>bimModelParameters.getField(field.name)?.originalStub?.units,
        getCustomWidth: ()=>4
    };
    const { fields: fields } = bimModelParameters;
    const iterableFields = Object.values(fields);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        sx: {
            width: '90%',
            m: 'auto'
        },
        children: iterableFields && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$bd94812d4d5b131f), {
            fields: iterableFields,
            customAccessors: fieldPropsAccessors
        })
    });
};
const $847c89107864d1f8$export$ab8fdc71b7d358bb = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
        sx: {
            width: '50%',
            m: 'auto',
            mt: 3,
            mb: 3
        }
    });
const $847c89107864d1f8$export$69bc41ee738923ec = ({ name: name })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
        sx: {
            m: 1,
            mb: 2
        },
        variant: "subtitle1",
        color: "text.secondary",
        component: "div",
        children: name
    });
const $847c89107864d1f8$export$cf345ef34cd72655 = ({ name: name })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
        sx: {
            m: 1
        },
        variant: "subtitle2",
        color: "text.secondary",
        component: "div",
        children: name
    });
const $847c89107864d1f8$export$9866a9152e8350fd = ({ text: text })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
        sx: {
            m: 'auto',
            width: '10%'
        },
        color: "text.secondary",
        display: "block",
        variant: "caption",
        children: text
    });
};
const $847c89107864d1f8$export$3c3f1a2447cee63c = ({ Icon: Icon, titleName: titleName })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
        direction: "row",
        sx: {
            m: 2,
            marginBottom: 3
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                fontSize: "small",
                sx: {
                    marginRight: 1
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                color: "text.secondary",
                component: "div",
                children: titleName
            })
        ]
    });
const $847c89107864d1f8$export$a042bb35a525900c = ({ children: children })=>{
    /* eslint-disable react/prop-types */ return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children.map((child, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    i && /*#__PURE__*/ (0, $ayMG0.jsx)($847c89107864d1f8$export$ab8fdc71b7d358bb, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        children: child
                    })
                ]
            }))
    });
/* eslint-enable react/prop-types */ };






const $e6e81b952cae6437$export$613a539023b8e9f5 = ({ itemId: itemId })=>{
    const [, setRefresh] = (0, $acw62.useState)(false);
    const [updateInProgress, setUpdateInProgress] = (0, $acw62.useState)(false);
    const [apdStub, setApdStub] = (0, $acw62.useState)();
    const loadInProgressRef = (0, $acw62.useRef)(false);
    const reload = async ()=>{
        loadInProgressRef.current = true;
        setRefresh((current)=>!current);
        await bimModel.failsafeLoad();
        loadInProgressRef.current = false;
        setRefresh((current)=>!current);
    };
    const onTagAdded = async (tag)=>{
        const resp = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.pushTag(itemId, tag);
        console.log(resp);
        reload();
    };
    const onTagRemoved = async (tag)=>{
        const resp = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.popTag(itemId, tag);
        console.log(resp);
        reload();
    };
    const onSaveFields = async ()=>{
        if (bimModel.hasPendingChanges()) {
            if (bimModel.isValid()) {
                setUpdateInProgress(true);
                const pendingChanges = bimModel.toUpdateStub();
                console.log(pendingChanges);
                const reply = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.updateItem(itemId, pendingChanges);
                if (reply.status === 200 || reply.status === 204) {
                    bimModel.clearPendingChanges();
                    (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).success('Updated BIM fields');
                } else {
                    (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).error('Failed to update BIM fields');
                    console.log(reply);
                }
                await reload();
                setUpdateInProgress(false);
            } else console.log('invalid inputs');
        } else console.log('no pending changes to save');
    };
    const fieldPropsAccessors = {
        getFieldName: (key)=>key,
        getFieldValue: (key)=>requiredFields[key],
        setFieldValue: (key, val)=>requiredFields[key] = val,
        getCustomMsg: ()=>'required field',
        getCustomWidth: ()=>6,
        isEditable: ()=>true
    };
    // query APD endpoint to retrieve ports configuration for specific nadModel and nadManufacturer
    const getPortsConfig = async ()=>{
        // TODO fetch infos from backend
        console.log('getPortsConfig');
        const { nadModel: nadModel, nadManufacturer: nadManufacturer } = requiredFields;
        setApdStub(null);
        // no fields saved previously => don't show table
        if (nadModel && nadManufacturer) {
            console.log(`[BimDetails::getPortsConfig] current APD conf: nadModel ${nadModel} nadManufacturer ${nadManufacturer}`);
            const res = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.fetchApd(nadManufacturer, nadModel);
            const { status: status } = res;
            if (status === 200) {
                // success this will allow table display
                const apdStubData = await res.json();
                console.log(apdStubData);
                setApdStub(apdStubData);
            } else if (status === 404) (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).error('Error: nadModel/nadManufacturer not found');
            else (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).error('An error occured while requesting APD service');
        } else console.warn(`[BimDetails::getPortsConfig] missing nadModel and nadManufacturer`);
    };
    // each time apd stub is renewed, refresh data showed in ports configuration table
    const portsConfiguration = (0, $acw62.useMemo)(()=>{
        return apdStub ? new (0, $8d3ebfc71b421629$export$1ee1f07de88734a5)(apdStub) : null;
    }, [
        apdStub
    ]);
    (0, $acw62.useEffect)(()=>{
        reload();
        !hideEmeConfiguration && getPortsConfig();
    // if no thumbnail url exists, try to fetch thumbnail attachment to get it
    }, [
        itemId
    ]);
    const bimModel = (0, $0bafe5cbc4b092bf$export$9a93b0d49a84081a).instances[itemId];
    const { modelParameters: modelParameters, requiredFields: requiredFields } = bimModel || {};
    const invalidForm = !bimModel.isValid();
    const noPendingChanges = !bimModel.hasPendingChanges();
    const saveDisabled = false; //invalidForm || noPendingChanges    // not working for strange reasons!! #TODO check why save button stay disable
    const hideEmeConfiguration = (0, $834b9e85ded96783$export$529397c806e3595c)(requiredFields.typeClass, requiredFields.type);
    const loadInProgress = loadInProgressRef.current;
    (0, $acw62.useEffect)(()=>{
        const { nadModel: nadModel, nadManufacturer: nadManufacturer } = requiredFields;
        if (nadModel && nadManufacturer) getPortsConfig();
        else setApdStub(null);
    }, [
        requiredFields.nadModel,
        requiredFields.nadManufacturer
    ]);
    console.log(`invalidForm: ${invalidForm}, no pending changes: ${noPendingChanges} => save disabled: ${saveDisabled}`);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    overflowY: 'auto',
                    height: '79vh'
                },
                children: [
                    loadInProgress && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                        size: 30,
                        sx: {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-15px',
                            marginLeft: '-15px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        sx: {
                            m: 1,
                            mb: 2,
                            mt: 2
                        },
                        variant: "subtitle2",
                        color: "text.secondary",
                        component: "div",
                        children: "Info"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847c89107864d1f8$export$b681679b4be4a0a8), {
                        bimModel: bimModel,
                        editable: true,
                        validate: true,
                        onValidityChange: ()=>setRefresh((current)=>!current)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        sx: {
                            m: 1,
                            mb: 2,
                            mt: 2
                        },
                        variant: "subtitle2",
                        color: "text.secondary",
                        component: "div",
                        children: "Mesh Reference"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847c89107864d1f8$export$7f22536e6dff5ed7), {
                        bimModel: bimModel,
                        editable: true,
                        validate: true
                    }),
                    bimModel?.requiredFields && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                sx: {
                                    m: 1,
                                    mb: 1
                                },
                                variant: "subtitle2",
                                color: "text.secondary",
                                component: "div",
                                children: "Characteristics"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847c89107864d1f8$export$277f8897b6619a83), {
                                bimRequiredFields: bimModel.requiredFields,
                                editable: true,
                                validate: true,
                                onChange: ()=>setRefresh((current)=>!current)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                sx: {
                                    m: 1,
                                    mb: 1,
                                    mt: 2
                                },
                                variant: "subtitle2",
                                color: "text.secondary",
                                component: "div",
                                children: "Type/Subtype"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847c89107864d1f8$export$474c1af473291c4a), {
                                bimRequiredFields: bimModel.requiredFields,
                                editable: true,
                                validate: true,
                                onChange: ()=>setRefresh((current)=>!current)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                sx: {
                                    m: 1,
                                    mb: 0,
                                    mt: 2
                                },
                                variant: "subtitle2",
                                color: "text.secondary",
                                component: "div",
                                children: "Shape & dimensions"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847c89107864d1f8$export$6422c795941ce074), {
                                bimRequiredFields: bimModel.requiredFields,
                                editable: true,
                                validate: true,
                                onChange: ()=>setRefresh((current)=>!current)
                            })
                        ]
                    }),
                    bimModel?.tags && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                sx: {
                                    m: 1,
                                    mt: 2
                                },
                                variant: "subtitle2",
                                color: "text.secondary",
                                component: "div",
                                children: "Tags"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '90%',
                                    m: 'auto',
                                    mt: 2,
                                    mb: 2
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb7aa6a5931da2b2$export$a26644aeff9fb039), {
                                    tags: bimModel.tags,
                                    onTagAdded: onTagAdded,
                                    onTagRemoved: onTagRemoved
                                })
                            })
                        ]
                    }),
                    Object.keys(modelParameters?.fields?.fields ?? {}).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                sx: {
                                    m: 1,
                                    mb: 2,
                                    mt: 2
                                },
                                variant: "subtitle2",
                                color: "text.secondary",
                                component: "div",
                                children: "Model Parameters"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847c89107864d1f8$export$cf2ee7f36841893a), {
                                bimModelParameters: modelParameters
                            })
                        ]
                    }),
                    !hideEmeConfiguration && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                sx: {
                                    m: 1,
                                    mb: 2,
                                    mt: 4
                                },
                                variant: "subtitle2",
                                color: "text.secondary",
                                component: "div",
                                children: "EME Configuration"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '95%',
                                    m: 'auto'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
                                        direction: "row",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '70%',
                                                    m: 'auto'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a7174531dda72b$export$bd94812d4d5b131f), {
                                                    fields: [
                                                        'nadManufacturer',
                                                        'nadModel'
                                                    ],
                                                    customAccessors: fieldPropsAccessors
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                                component: "label",
                                                variant: "outlined",
                                                onClick: getPortsConfig,
                                                sx: {
                                                    marginLeft: 'auto'
                                                },
                                                disabled: false,
                                                children: "Get config"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        sx: {
                                            mt: 4
                                        },
                                        component: "div"
                                    }),
                                    portsConfiguration ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $722fd9258a1d0359$export$9a89758239fe2e2b), {
                                        portsConfiguration: portsConfiguration,
                                        hideExtraColumns: true,
                                        editMode: false,
                                        onChange: undefined
                                    }) : ''
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    m: 1,
                    textAlign: 'right'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        component: "label",
                        variant: "outlined",
                        onClick: onSaveFields,
                        sx: {
                            marginLeft: 'auto'
                        },
                        disabled: saveDisabled,
                        children: "Save"
                    }),
                    updateInProgress && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                        size: 30,
                        sx: {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-15px',
                            marginLeft: '-15px'
                        }
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $9a402a389bd8b499$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $478fe5b437ab8d6f$export$ffd560f22c0ecf04(slot) {
    return (0, $4Cod0.default)('MuiAvatar', slot);
}
const $478fe5b437ab8d6f$var$avatarClasses = (0, $beCSm.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $478fe5b437ab8d6f$export$2e2bcd8739ae039 = $478fe5b437ab8d6f$var$avatarClasses;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");




'use client';
const $49e8399bd2388464$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $49e8399bd2388464$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $49e8399bd2388464$var$_excluded3 = [
    "component"
];
function $49e8399bd2388464$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $1En50.default)(parameters, $49e8399bd2388464$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $1En50.default)(externalForwardedProps, $49e8399bd2388464$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $135391549c807611$export$2e2bcd8739ae039)((0, $8nd05.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $1En50.default)(_mergeSlotProps.props, $49e8399bd2388464$var$_excluded3);
    const ref = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $8nd05.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(elementType, (0, $8nd05.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1894f4268467302e$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $1894f4268467302e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $478fe5b437ab8d6f$export$ffd560f22c0ecf04), classes);
};
const $1894f4268467302e$var$AvatarRoot = (0, $d8seH.default)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $8nd05.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $8nd05.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles('dark', {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $1894f4268467302e$var$AvatarImg = (0, $d8seH.default)('img', {
    name: 'MuiAvatar',
    slot: 'Img',
    overridesResolver: (props, styles)=>styles.img
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $1894f4268467302e$var$AvatarFallback = (0, $d8seH.default)((0, $9a402a389bd8b499$export$2e2bcd8739ae039), {
    name: 'MuiAvatar',
    slot: 'Fallback',
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: '75%',
    height: '75%'
});
function $1894f4268467302e$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $1894f4268467302e$var$Avatar = /*#__PURE__*/ $acw62.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular' } = props, other = (0, $1En50.default)(props, $1894f4268467302e$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $1894f4268467302e$var$useLoaded((0, $8nd05.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    const ownerState = (0, $8nd05.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $1894f4268467302e$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('img', {
        className: classes.img,
        elementType: $1894f4268467302e$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: (0, $8nd05.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $ayMG0.jsx)(ImgSlot, (0, $8nd05.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $1894f4268467302e$export$2e2bcd8739ae039 = $1894f4268467302e$var$Avatar;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9055a111c146fc9b$export$e4f04f80f2ce3fc0(slot) {
    return (0, $4Cod0.default)('MuiListItemAvatar', slot);
}
const $9055a111c146fc9b$var$listItemAvatarClasses = (0, $beCSm.default)('MuiListItemAvatar', [
    'root',
    'alignItemsFlexStart'
]);
var $9055a111c146fc9b$export$2e2bcd8739ae039 = $9055a111c146fc9b$var$listItemAvatarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5e1a7f5eff0ff3e8$var$_excluded = [
    "className"
];
const $5e1a7f5eff0ff3e8$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9055a111c146fc9b$export$e4f04f80f2ce3fc0), classes);
};
const $5e1a7f5eff0ff3e8$var$ListItemAvatarRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        minWidth: 56,
        flexShrink: 0
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */ const $5e1a7f5eff0ff3e8$var$ListItemAvatar = /*#__PURE__*/ $acw62.forwardRef(function ListItemAvatar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemAvatar'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $5e1a7f5eff0ff3e8$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $5e1a7f5eff0ff3e8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5e1a7f5eff0ff3e8$var$ListItemAvatarRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $5e1a7f5eff0ff3e8$export$2e2bcd8739ae039 = $5e1a7f5eff0ff3e8$var$ListItemAvatar;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0d696835f9b43a35$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $0d696835f9b43a35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c01aa6ddbe5e68bd$export$1061006a0db3aeb5), classes);
};
const $0d696835f9b43a35$var$ListItemTextRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $0d696835f9b43a35$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $1En50.default)(props, $0d696835f9b43a35$var$_excluded);
    const { dense: dense } = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $0d696835f9b43a35$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0d696835f9b43a35$var$ListItemTextRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $0d696835f9b43a35$export$2e2bcd8739ae039 = $0d696835f9b43a35$var$ListItemText;


var $8e5988604132aefe$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($8e5988604132aefe$exports, "__esModule", {
    value: true
});
$8e5988604132aefe$exports.default = void 0;

var $8e5988604132aefe$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8e5988604132aefe$var$_default = $8e5988604132aefe$exports.default = (0, $8e5988604132aefe$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6z"
}), 'AttachFile');



var $5352a9483755aaf8$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($5352a9483755aaf8$exports, "__esModule", {
    value: true
});
$5352a9483755aaf8$exports.default = void 0;

var $5352a9483755aaf8$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $5352a9483755aaf8$var$_default = $5352a9483755aaf8$exports.default = (0, $5352a9483755aaf8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
}), 'UploadFile');


var $546f4335ad644031$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($546f4335ad644031$exports, "__esModule", {
    value: true
});
$546f4335ad644031$exports.default = void 0;

var $546f4335ad644031$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $546f4335ad644031$var$_default = $546f4335ad644031$exports.default = (0, $546f4335ad644031$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), 'Download');





var $1a6d66fa26b52d0d$export$13fc5789028276e1 = /*#__PURE__*/ function(BIM_DIALOG_TYPE) {
    BIM_DIALOG_TYPE[BIM_DIALOG_TYPE["None"] = 0] = "None";
    BIM_DIALOG_TYPE[BIM_DIALOG_TYPE["Create"] = 1] = "Create";
    BIM_DIALOG_TYPE[BIM_DIALOG_TYPE["Delete"] = 2] = "Delete";
    BIM_DIALOG_TYPE[BIM_DIALOG_TYPE["DeleteAttachment"] = 3] = "DeleteAttachment";
    return BIM_DIALOG_TYPE;
}({});
class $1a6d66fa26b52d0d$export$48bf5c62bf01d809 {
    static onDialogOpen(type) {
        $1a6d66fa26b52d0d$export$48bf5c62bf01d809.setOpenReactState(type);
    }
    static onCreateDialogOpen() {
        $1a6d66fa26b52d0d$export$48bf5c62bf01d809.onDialogOpen(1);
    }
    static onDeleteDialogOpen() {
        $1a6d66fa26b52d0d$export$48bf5c62bf01d809.onDialogOpen(2);
    }
    static deleteAttachmentDialog(onDialogClose) {
        $1a6d66fa26b52d0d$export$48bf5c62bf01d809.onDialogOpen(3);
        $1a6d66fa26b52d0d$export$48bf5c62bf01d809.onCloseReactRef.current = onDialogClose;
    }
}



const $a63880032b53cc05$export$efb3fa57c18b8b51 = ({ bimId: bimId })=>{
    const [, setRefresh] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [uploadInProgress, setUploadInProgress] = (0, $acw62.useState)(false);
    const loadInProgressRef = (0, $acw62.useRef)(false);
    const bimModel = (0, $0bafe5cbc4b092bf$export$9a93b0d49a84081a).instances[bimId];
    const { attachments: attachments } = bimModel;
    const refreshAll = async ()=>{
        loadInProgressRef.current = true;
        setRefresh((current)=>!current);
        await bimModel.preloadAttachments();
        const needsLoading = bimModel.attachments.filter((attachment)=>!attachment.isLoaded);
        console.log(needsLoading);
        await Promise.all(needsLoading.map((attachment)=>attachment.load()));
        loadInProgressRef.current = false;
        setRefresh((current)=>!current);
    };
    const onUpload = async (e)=>{
        const file = e.target.files?.[0];
        if (file) {
            setUploadInProgress(true);
            await (0, $834b9e85ded96783$export$a5575dbeeffdad98)(file, bimId);
            setUploadInProgress(false);
            refreshAll();
        }
    };
    const onDelete = async (attachId)=>{
        console.log(`[BimAttachments] deleting attachment ${attachId}`);
        const resp = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.deleteAttachment(bimId, attachId);
        if (resp.status === 204) {
            console.log(`[BimAttachments] SUCCESS deleting attachment ${attachId}`);
            (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).success('Success: deleting attachment');
        } else {
            (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).error('Error: could not delete attachment');
            const errorData = await resp.json();
            console.warn(errorData.message);
        }
        refreshAll();
    };
    (0, $acw62.useEffect)(()=>{
        refreshAll();
    }, [
        bimId
    ]);
    console.log(attachments);
    const loadInProgress = loadInProgressRef.current;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: "bimAttachments",
                style: {
                    height: '90%',
                    overflowY: 'auto',
                    position: 'relative'
                },
                children: loadInProgress ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                    size: 30,
                    sx: {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-15px',
                        marginLeft: '-15px'
                    }
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $640cd381f5e8b3ea$export$2e2bcd8739ae039), {
                    dense: true,
                    subheader: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5408b2039b9d572c$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            p: 0
                        },
                        children: [
                            "Attachments",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                sx: {
                                    flexGrow: 1
                                }
                            })
                        ]
                    }),
                    children: attachments.map((attach)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f92832698674c928$export$2e2bcd8739ae039), {
                            secondaryAction: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                        size: "small",
                                        edge: "end",
                                        sx: {
                                            m: 0.5,
                                            '&:hover': {
                                                color: 'red'
                                            }
                                        },
                                        onClick: ()=>(0, $1a6d66fa26b52d0d$export$48bf5c62bf01d809).deleteAttachmentDialog(()=>onDelete(attach.id)),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14b4fcb0e549e7b0$exports))), {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                        edge: "end",
                                        color: "primary",
                                        sx: {
                                            m: 0.5
                                        },
                                        onClick: ()=>window.open(attach.url, '_blank'),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($546f4335ad644031$exports))), {})
                                    })
                                ]
                            }),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e1a7f5eff0ff3e8$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8e5988604132aefe$exports))), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                    primary: attach.title,
                                    secondary: attach.type
                                })
                            ]
                        }, attach.id))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    m: 1,
                    position: 'relative',
                    textAlign: 'right'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        component: "label",
                        variant: "outlined",
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5352a9483755aaf8$exports))), {}),
                        sx: {
                            margin: 'auto',
                            marginRight: 1.5
                        },
                        children: [
                            "upload",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "file",
                                hidden: true,
                                onChange: onUpload
                            })
                        ]
                    }),
                    uploadInProgress && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                        size: 30,
                        sx: {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-15px',
                            marginLeft: '-15px'
                        }
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4828cb1f30b841b0$export$47a2da616e55e8e9(slot) {
    return (0, $4Cod0.default)('MuiAppBar', slot);
}
const $4828cb1f30b841b0$var$appBarClasses = (0, $beCSm.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $4828cb1f30b841b0$export$2e2bcd8739ae039 = $4828cb1f30b841b0$var$appBarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $37a342382669398e$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $37a342382669398e$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            `position${(0, $jTnBY.default)(position)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4828cb1f30b841b0$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $37a342382669398e$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})` : var2;
const $37a342382669398e$var$AppBarRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === 'fixed' && {
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0,
        '@media print': {
            // Prevent the app bar to be visible on each printed page.
            position: 'absolute'
        }
    }, ownerState.position === 'absolute' && {
        position: 'absolute',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'sticky' && {
        // ⚠️ sticky is not supported by IE11.
        position: 'sticky',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'static' && {
        position: 'static'
    }, ownerState.position === 'relative' && {
        position: 'relative'
    }, !theme.vars && (0, $8nd05.default)({}, ownerState.color === 'default' && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === 'transparent' && (0, $8nd05.default)({
        backgroundColor: 'transparent',
        color: 'inherit'
    }, theme.palette.mode === 'dark' && {
        backgroundImage: 'none'
    })), theme.vars && (0, $8nd05.default)({}, ownerState.color === 'default' && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, ![
        'inherit',
        'transparent'
    ].includes(ownerState.color) && {
        backgroundColor: 'var(--AppBar-background)'
    }, {
        color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
    }, ownerState.color === 'transparent' && {
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        color: 'inherit'
    }));
});
const $37a342382669398e$var$AppBar = /*#__PURE__*/ $acw62.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed' } = props, other = (0, $1En50.default)(props, $37a342382669398e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $37a342382669398e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($37a342382669398e$var$AppBarRoot, (0, $8nd05.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $9QePP.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
var $37a342382669398e$export$2e2bcd8739ae039 = $37a342382669398e$var$AppBar;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");




var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5cff6b4166fff27c$export$717666c39ec07e12(slot) {
    return (0, $4Cod0.default)('MuiFormControlLabel', slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $beCSm.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $5cff6b4166fff27c$export$2e2bcd8739ae039 = $5cff6b4166fff27c$var$formControlLabelClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a034abd43bd8eee$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $1a034abd43bd8eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $jTnBY.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5cff6b4166fff27c$export$717666c39ec07e12), classes);
};
const $1a034abd43bd8eee$export$1b479270917a5676 = (0, $d8seH.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $jTnBY.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $1a034abd43bd8eee$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $1a034abd43bd8eee$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $1a034abd43bd8eee$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $1a034abd43bd8eee$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $9QePP.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$export$1b479270917a5676, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $1a034abd43bd8eee$export$2e2bcd8739ae039 = $1a034abd43bd8eee$var$FormControlLabel;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $de580948e3d734b1$export$d72d4cbdc30b331f(slot) {
    return (0, $4Cod0.default)('MuiFormGroup', slot);
}
const $de580948e3d734b1$var$formGroupClasses = (0, $beCSm.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $de580948e3d734b1$export$2e2bcd8739ae039 = $de580948e3d734b1$var$formGroupClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5042f159189dda87$var$_excluded = [
    "className",
    "row"
];
const $5042f159189dda87$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $de580948e3d734b1$export$d72d4cbdc30b331f), classes);
};
const $5042f159189dda87$var$FormGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    }, ownerState.row && {
        flexDirection: 'row'
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $5042f159189dda87$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false } = props, other = (0, $1En50.default)(props, $5042f159189dda87$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $5042f159189dda87$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5042f159189dda87$var$FormGroupRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $5042f159189dda87$export$2e2bcd8739ae039 = $5042f159189dda87$var$FormGroup;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d3b4e1a115786e57$export$b12cb262231eef32(slot) {
    return (0, $4Cod0.default)('MuiToolbar', slot);
}
const $d3b4e1a115786e57$var$toolbarClasses = (0, $beCSm.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $d3b4e1a115786e57$export$2e2bcd8739ae039 = $d3b4e1a115786e57$var$toolbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef8072c26f712b4c$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $ef8072c26f712b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d3b4e1a115786e57$export$b12cb262231eef32), classes);
};
const $ef8072c26f712b4c$var$ToolbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $ef8072c26f712b4c$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $1En50.default)(props, $ef8072c26f712b4c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $ef8072c26f712b4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef8072c26f712b4c$var$ToolbarRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $ef8072c26f712b4c$export$2e2bcd8739ae039 = $ef8072c26f712b4c$var$Toolbar;



var $cpmCj = parcelRequire("cpmCj");

var $1jJMI = parcelRequire("1jJMI");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $e0579d99723e0dfe$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $1jJMI.default)(value, min, max);
}
function $e0579d99723e0dfe$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $e0579d99723e0dfe$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $e0579d99723e0dfe$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $cpmCj.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $cpmCj.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $e0579d99723e0dfe$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $e0579d99723e0dfe$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $e0579d99723e0dfe$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $e0579d99723e0dfe$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $e0579d99723e0dfe$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $e0579d99723e0dfe$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $e0579d99723e0dfe$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$e0579d99723e0dfe$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $e0579d99723e0dfe$export$29fb7152bd3f781a(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $e0579d99723e0dfe$export$c852d90bf7403b62(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $e0579d99723e0dfe$export$d061e26956a60b0a(foreground, background) {
    const lumA = $e0579d99723e0dfe$export$c852d90bf7403b62(foreground);
    const lumB = $e0579d99723e0dfe$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $e0579d99723e0dfe$export$58f0f39f63f3cf42(color, value) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    value = $e0579d99723e0dfe$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $e0579d99723e0dfe$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $e0579d99723e0dfe$export$c852d90bf7403b62(color) > 0.5 ? $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) : $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient);
}
function $e0579d99723e0dfe$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $e0579d99723e0dfe$export$677b39864803984e(background);
    const overlayColor = $e0579d99723e0dfe$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


var $d8seH = parcelRequire("d8seH");
var $794d5dbdb05a5402$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($794d5dbdb05a5402$exports, "__esModule", {
    value: true
});
$794d5dbdb05a5402$exports.default = void 0;

var $794d5dbdb05a5402$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $794d5dbdb05a5402$var$_default = $794d5dbdb05a5402$exports.default = (0, $794d5dbdb05a5402$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');


var $20e4b243ccff587b$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($20e4b243ccff587b$exports, "__esModule", {
    value: true
});
$20e4b243ccff587b$exports.default = void 0;

var $20e4b243ccff587b$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $20e4b243ccff587b$var$_default = $20e4b243ccff587b$exports.default = (0, $20e4b243ccff587b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');


function $ed5c3fde1b6266f6$export$2e2bcd8739ae039({ onSearchChange: onSearchChange }) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        name: true,
        desc: false,
        tags: false
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleChange = (event)=>{
        setState({
            ...state,
            [event.target.name]: event.target.checked
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
        sx: {
            p: 1
        },
        component: "fieldset",
        variant: "standard",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
            row: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $ayMG0.jsxs)($ed5c3fde1b6266f6$var$Search, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($ed5c3fde1b6266f6$var$SearchIconWrapper, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($20e4b243ccff587b$exports))), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($ed5c3fde1b6266f6$var$StyledInputBase, {
                            placeholder: "Filter BIM Catalog...",
                            onChange: onSearchChange,
                            inputProps: {
                                'aria-label': 'search'
                            }
                        })
                    ]
                }),
                label: ""
            })
        })
    });
}
const $ed5c3fde1b6266f6$var$Search = (0, $d8seH.default)('div')(({ theme: theme })=>({
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: (0, $e0579d99723e0dfe$export$58f0f39f63f3cf42)(theme.palette.common.white, 0.5),
        '&:hover': {
            backgroundColor: (0, $e0579d99723e0dfe$export$58f0f39f63f3cf42)(theme.palette.common.white, 0.95)
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto'
        }
    }));
const $ed5c3fde1b6266f6$var$SearchIconWrapper = (0, $d8seH.default)('div')(({ theme: theme })=>({
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }));
const $ed5c3fde1b6266f6$var$StyledInputBase = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039))(({ theme: theme })=>({
        color: 'inherit',
        '& .MuiInputBase-input': {
            padding: theme.spacing(1, 1, 1, 0),
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(4)})`,
            transition: theme.transitions.create('width'),
            width: '100%',
            [theme.breakpoints.up('lg')]: {
                width: '20ch',
                '&:focus': {
                    width: '30ch'
                }
            }
        }
    }));
const $ed5c3fde1b6266f6$export$227960c19708e0ad = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $37a342382669398e$export$2e2bcd8739ae039), {
        sx: {
            position: 'relative'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ef8072c26f712b4c$export$2e2bcd8739ae039), {
            variant: "dense",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                    color: "inherit",
                    "aria-label": "open drawer",
                    //   onClick={() => setOpenDrawer(true)}
                    edge: "start",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($794d5dbdb05a5402$exports))), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    variant: "h6",
                    noWrap: true,
                    component: "div",
                    children: "BIM Catalog"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($ed5c3fde1b6266f6$var$Search, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($ed5c3fde1b6266f6$var$SearchIconWrapper, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($20e4b243ccff587b$exports))), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($ed5c3fde1b6266f6$var$StyledInputBase, {
                            placeholder: "Search\u2026",
                            inputProps: {
                                'aria-label': 'search'
                            }
                        })
                    ]
                })
            ]
        })
    });
};





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $jTnBY = parcelRequire("jTnBY");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $1da0e229d53b4459$export$69aecd24bc2cf7e3(slot) {
    return (0, $4Cod0.default)('MuiAlert', slot);
}
const $1da0e229d53b4459$var$alertClasses = (0, $beCSm.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $1da0e229d53b4459$export$2e2bcd8739ae039 = $1da0e229d53b4459$var$alertClasses;



parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $0eec239707c48bf2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $611e456547a52fc7$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $af7987087272cca1$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $76204164d2201318$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d7b9f0ef25189a24$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $d7b9f0ef25189a24$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color || severity)}`,
            `${variant}${(0, $jTnBY.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $1da0e229d53b4459$export$69aecd24bc2cf7e3), classes);
};
const $d7b9f0ef25189a24$var$AlertRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $kSnzZ.darken) : (0, $kSnzZ.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $kSnzZ.lighten) : (0, $kSnzZ.darken);
    return (0, $8nd05.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: (0, $8nd05.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $d7b9f0ef25189a24$var$AlertIcon = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $d7b9f0ef25189a24$var$AlertMessage = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $d7b9f0ef25189a24$var$AlertAction = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $d7b9f0ef25189a24$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eec239707c48bf2$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $611e456547a52fc7$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af7987087272cca1$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76204164d2201318$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $d7b9f0ef25189a24$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $d7b9f0ef25189a24$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $d7b9f0ef25189a24$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $d7b9f0ef25189a24$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $8nd05.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $8nd05.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $71c322247f7fbf93$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $f7280bbf95507cba$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d7b9f0ef25189a24$var$AlertRoot, (0, $8nd05.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $d7b9f0ef25189a24$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseButtonSlot, (0, $8nd05.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseIconSlot, (0, $8nd05.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $d7b9f0ef25189a24$export$2e2bcd8739ae039 = $d7b9f0ef25189a24$var$Alert;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


'use client';
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $2d16bff1157c299f$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $acw62.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $acw62.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $acw62.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $8nd05.default)({}, (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(parameters), (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(externalProps));
        return (0, $8nd05.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation'
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $2d16bff1157c299f$export$2e2bcd8739ae039 = $2d16bff1157c299f$var$useSnackbar;



var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $f0f105dbd8c07c9e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $f0f105dbd8c07c9e$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, childrenProps)
    });
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kSnzZ = parcelRequire("kSnzZ");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4d2fdf4430378182$export$def81488db1a3216(slot) {
    return (0, $4Cod0.default)('MuiSnackbarContent', slot);
}
const $4d2fdf4430378182$var$snackbarContentClasses = (0, $beCSm.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $4d2fdf4430378182$export$2e2bcd8739ae039 = $4d2fdf4430378182$var$snackbarContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $dbe322effc7340b4$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $dbe322effc7340b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4d2fdf4430378182$export$def81488db1a3216), classes);
};
const $dbe322effc7340b4$var$SnackbarContentRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $kSnzZ.emphasize)(theme.palette.background.default, emphasis);
    return (0, $8nd05.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    });
});
const $dbe322effc7340b4$var$SnackbarContentMessage = (0, $d8seH.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $dbe322effc7340b4$var$SnackbarContentAction = (0, $d8seH.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $dbe322effc7340b4$var$SnackbarContent = /*#__PURE__*/ $acw62.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert' } = props, other = (0, $1En50.default)(props, $dbe322effc7340b4$var$_excluded);
    const ownerState = props;
    const classes = $dbe322effc7340b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dbe322effc7340b4$var$SnackbarContentRoot, (0, $8nd05.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $dbe322effc7340b4$export$2e2bcd8739ae039 = $dbe322effc7340b4$var$SnackbarContent;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3bdc4d25b715a88$export$6cb096457f5926f4(slot) {
    return (0, $4Cod0.default)('MuiSnackbar', slot);
}
const $f3bdc4d25b715a88$var$snackbarClasses = (0, $beCSm.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $f3bdc4d25b715a88$export$2e2bcd8739ae039 = $f3bdc4d25b715a88$var$snackbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef601776ba11bb1e$var$_excluded = [
    "onEnter",
    "onExited"
], $ef601776ba11bb1e$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $ef601776ba11bb1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f3bdc4d25b715a88$export$6cb096457f5926f4), classes);
};
const $ef601776ba11bb1e$var$SnackbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $jTnBY.default)(ownerState.anchorOrigin.vertical)}${(0, $jTnBY.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    };
    return (0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.anchorOrigin.vertical === 'top' ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === 'left' && {
        justifyContent: 'flex-start'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
        justifyContent: 'flex-end'
    }, {
        [theme.breakpoints.up('sm')]: (0, $8nd05.default)({}, ownerState.anchorOrigin.vertical === 'top' ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
            left: 24,
            right: 'auto'
        }, ownerState.anchorOrigin.horizontal === 'right' && {
            right: 24,
            left: 'auto'
        })
    });
});
const $ef601776ba11bb1e$var$Snackbar = /*#__PURE__*/ $acw62.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $ef601776ba11bb1e$var$_excluded), other = (0, $1En50.default)(props, $ef601776ba11bb1e$var$_excluded2);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $ef601776ba11bb1e$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $2d16bff1157c299f$export$2e2bcd8739ae039)((0, $8nd05.default)({}, ownerState));
    const [exited, setExited] = $acw62.useState(true);
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: $ef601776ba11bb1e$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0f105dbd8c07c9e$export$58385c17fee43f89), (0, $8nd05.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ef601776ba11bb1e$var$SnackbarRoot, (0, $8nd05.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === 'top' ? 'down' : 'up',
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbe322effc7340b4$export$2e2bcd8739ae039), (0, $8nd05.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $ef601776ba11bb1e$export$2e2bcd8739ae039 = $ef601776ba11bb1e$var$Snackbar;



const $e5bac0c5be581ac8$export$36ba2f559d49a8f6 = ()=>{
    const [notification, setNotification] = (0, $acw62.useState)({
        msg: '',
        type: null
    });
    (0, $acw62.useEffect)(()=>{
        console.log('Bind notifications component to NotificationService');
        (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).setNotification = setNotification;
    }, []);
    const handleCloseNotification = (event, reason)=>{
        if (reason === 'clickaway') return;
        (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).clearNotification();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef601776ba11bb1e$export$2e2bcd8739ae039), {
            open: notification.msg?.length > 0,
            autoHideDuration: 6000,
            onClose: handleCloseNotification,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                onClose: handleCloseNotification,
                severity: notification.type === (0, $3b11ea43c4ed5c54$export$49006cd5d177f365).SUCCESS ? 'success' : 'error',
                sx: {
                    width: '100%'
                },
                children: notification.msg
            })
        })
    });
};


// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $d8seH = parcelRequire("d8seH");
const $e38dca3b8c2d6ab3$var$ImageButton = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039))(({ theme: theme })=>({
        position: 'relative',
        height: 200,
        [theme.breakpoints.down('sm')]: {
            width: '100% !important',
            height: 100
        },
        '&:hover, &.Mui-focusVisible': {
            zIndex: 1,
            '& .MuiImageBackdrop-root': {
                opacity: 0.4
            },
            '& .uploadBtn': {
                opacity: 0.8
            }
        }
    }));
const $e38dca3b8c2d6ab3$var$ImageSrc = (0, $d8seH.default)('span')({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
});
const $e38dca3b8c2d6ab3$var$Image = (0, $d8seH.default)('span')(({ theme: theme })=>({
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.common.white
    }));
const $e38dca3b8c2d6ab3$var$ImageBackdrop = (0, $d8seH.default)('span')(({ theme: theme, transparentBackground: transparentBackground })=>({
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: transparentBackground ? 'transparent' : theme.palette.common.black,
        opacity: 0.1,
        transition: theme.transitions.create('opacity')
    }));
const $e38dca3b8c2d6ab3$export$cbafa1ad4452dd0d = ({ imgUrl: imgUrl, upload: upload })=>{
    const fileInputRef = (0, $acw62.useRef)();
    const [uploadInProgress, setUploadInProgress] = (0, $acw62.useState)(false);
    const onUpload = async (e)=>{
        const file = e.target.files?.[0];
        console.log(file);
        if (!uploadInProgress && file) {
            setUploadInProgress(true);
            upload(file).then(()=>{
                console.log('[ImageUpload] End of thumbnail upload process');
                setUploadInProgress(false);
            });
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            margin: 'auto',
            marginBottom: '30px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($e38dca3b8c2d6ab3$var$ImageButton, {
                focusRipple: true,
                style: {
                    width: '100%'
                },
                onClick: ()=>fileInputRef.current.click(),
                children: [
                    imgUrl && /*#__PURE__*/ (0, $ayMG0.jsx)($e38dca3b8c2d6ab3$var$ImageSrc, {
                        style: {
                            backgroundImage: `url(${imgUrl})`
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e38dca3b8c2d6ab3$var$ImageBackdrop, {
                        className: "MuiImageBackdrop-root",
                        transparentBackground: !!imgUrl
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($e38dca3b8c2d6ab3$var$Image, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5352a9483755aaf8$exports))), {
                                className: "uploadBtn",
                                fontSize: "large",
                                sx: {
                                    opacity: 0.3
                                }
                            }),
                            uploadInProgress && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                                size: 48,
                                sx: {
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    marginTop: '-24px',
                                    marginLeft: '-24px'
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ref: fileInputRef,
                type: "file",
                accept: "image/*",
                disabled: uploadInProgress,
                hidden: true,
                onChange: onUpload
            })
        ]
    });
};


// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $jTnBY = parcelRequire("jTnBY");




var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c5762e789acf7dcc$export$2177af0aa15c34c2(slot) {
    return (0, $4Cod0.default)('MuiDialog', slot);
}
const $c5762e789acf7dcc$var$dialogClasses = (0, $beCSm.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $c5762e789acf7dcc$export$2e2bcd8739ae039 = $c5762e789acf7dcc$var$dialogClasses;



var $acw62 = parcelRequire("acw62");
const $68187f174395cd28$var$DialogContext = /*#__PURE__*/ $acw62.createContext({});
var $68187f174395cd28$export$2e2bcd8739ae039 = $68187f174395cd28$var$DialogContext;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4f13784bd714c44e$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $4f13784bd714c44e$var$DialogBackdrop = (0, $d8seH.default)((0, $4838e5a14e330013$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $4f13784bd714c44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $jTnBY.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $jTnBY.default)(scroll)}`,
            `paperWidth${(0, $jTnBY.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c5762e789acf7dcc$export$2177af0aa15c34c2), classes);
};
const $4f13784bd714c44e$var$DialogRoot = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $4f13784bd714c44e$var$DialogContainer = (0, $d8seH.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $jTnBY.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $4f13784bd714c44e$var$DialogPaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $jTnBY.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $4f13784bd714c44e$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $595185d0d7275c3b$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $4f13784bd714c44e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $4f13784bd714c44e$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $4f13784bd714c44e$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $8nd05.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogContainer, {
                className: (0, $9QePP.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogPaper, (0, $8nd05.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $9QePP.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68187f174395cd28$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $4f13784bd714c44e$export$2e2bcd8739ae039 = $4f13784bd714c44e$var$Dialog;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3a31c1516a2c01e5$export$5e57a444791c63be(slot) {
    return (0, $4Cod0.default)('MuiDialogActions', slot);
}
const $3a31c1516a2c01e5$var$dialogActionsClasses = (0, $beCSm.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $3a31c1516a2c01e5$export$2e2bcd8739ae039 = $3a31c1516a2c01e5$var$dialogActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $207bc6ab7c60f4b2$var$_excluded = [
    "className",
    "disableSpacing"
];
const $207bc6ab7c60f4b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3a31c1516a2c01e5$export$5e57a444791c63be), classes);
};
const $207bc6ab7c60f4b2$var$DialogActionsRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $207bc6ab7c60f4b2$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $1En50.default)(props, $207bc6ab7c60f4b2$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $207bc6ab7c60f4b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($207bc6ab7c60f4b2$var$DialogActionsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $207bc6ab7c60f4b2$export$2e2bcd8739ae039 = $207bc6ab7c60f4b2$var$DialogActions;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c877f2cebcabf5cb$export$61b0ee1f05fb344e(slot) {
    return (0, $4Cod0.default)('MuiDialogContent', slot);
}
const $c877f2cebcabf5cb$var$dialogContentClasses = (0, $beCSm.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $c877f2cebcabf5cb$export$2e2bcd8739ae039 = $c877f2cebcabf5cb$var$dialogContentClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f2e7257b2514744a$export$f5d2ec7e4c47e088(slot) {
    return (0, $4Cod0.default)('MuiDialogTitle', slot);
}
const $f2e7257b2514744a$var$dialogTitleClasses = (0, $beCSm.default)('MuiDialogTitle', [
    'root'
]);
var $f2e7257b2514744a$export$2e2bcd8739ae039 = $f2e7257b2514744a$var$dialogTitleClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4fa8e9c420cdee0a$var$_excluded = [
    "className",
    "dividers"
];
const $4fa8e9c420cdee0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c877f2cebcabf5cb$export$61b0ee1f05fb344e), classes);
};
const $4fa8e9c420cdee0a$var$DialogContentRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $f2e7257b2514744a$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $4fa8e9c420cdee0a$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $1En50.default)(props, $4fa8e9c420cdee0a$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        dividers: dividers
    });
    const classes = $4fa8e9c420cdee0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4fa8e9c420cdee0a$var$DialogContentRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $4fa8e9c420cdee0a$export$2e2bcd8739ae039 = $4fa8e9c420cdee0a$var$DialogContent;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $64180fe1152829a7$export$d9c6dc45f75b0e4f(slot) {
    return (0, $4Cod0.default)('MuiDialogContentText', slot);
}
const $64180fe1152829a7$var$dialogContentTextClasses = (0, $beCSm.default)('MuiDialogContentText', [
    'root'
]);
var $64180fe1152829a7$export$2e2bcd8739ae039 = $64180fe1152829a7$var$dialogContentTextClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $aad93085434ac13f$var$_excluded = [
    "children",
    "className"
];
const $aad93085434ac13f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $64180fe1152829a7$export$d9c6dc45f75b0e4f), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $aad93085434ac13f$var$DialogContentTextRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $aad93085434ac13f$var$DialogContentText = /*#__PURE__*/ $acw62.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { className: className } = props, ownerState = (0, $1En50.default)(props, $aad93085434ac13f$var$_excluded);
    const classes = $aad93085434ac13f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aad93085434ac13f$var$DialogContentTextRoot, (0, $8nd05.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
var $aad93085434ac13f$export$2e2bcd8739ae039 = $aad93085434ac13f$var$DialogContentText;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a6ac58aca374c76c$var$_excluded = [
    "className",
    "id"
];
const $a6ac58aca374c76c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f2e7257b2514744a$export$f5d2ec7e4c47e088), classes);
};
const $a6ac58aca374c76c$var$DialogTitleRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $a6ac58aca374c76c$var$DialogTitle = /*#__PURE__*/ $acw62.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $1En50.default)(props, $a6ac58aca374c76c$var$_excluded);
    const ownerState = props;
    const classes = $a6ac58aca374c76c$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $acw62.useContext((0, $68187f174395cd28$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a6ac58aca374c76c$var$DialogTitleRoot, (0, $8nd05.default)({
        component: "h2",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $a6ac58aca374c76c$export$2e2bcd8739ae039 = $a6ac58aca374c76c$var$DialogTitle;










const $53e1d3e086e443b2$export$7012ac741ddc1f84 = ({ currentBimId: currentBimId, onDone: onDone })=>{
    const [openDialog, setOpenDialog] = (0, $acw62.useState)((0, $1a6d66fa26b52d0d$export$13fc5789028276e1).None);
    const onCloseCallbackRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        console.log('Bind BimDialogs react component to BimDialogService static class');
        (0, $1a6d66fa26b52d0d$export$48bf5c62bf01d809).setOpenReactState = setOpenDialog;
        (0, $1a6d66fa26b52d0d$export$48bf5c62bf01d809).onCloseReactRef = onCloseCallbackRef;
    }, []);
    const createBimItem = async (bimCreateStub)=>{
        console.log('createBimItem: ', bimCreateStub);
        const res = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.createItem(bimCreateStub);
        const resp = res.status === 201 ? await res.json() : null;
        setOpenDialog((0, $1a6d66fa26b52d0d$export$13fc5789028276e1).None);
        resp ? (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).success(`successfully created item ${resp.id}`) : (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).error(`error while creating item`);
        onDone();
    };
    const deleteBimItem = ()=>{
        console.log('deleteBimItem');
        (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.deleteItem(currentBimId).then((resp)=>{
            console.log(resp);
            setOpenDialog((0, $1a6d66fa26b52d0d$export$13fc5789028276e1).None);
            resp.status === 204 ? (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).success(`successfully deleted item ${resp.id}`) : (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).error(`error could not delete item`);
            onDone(true);
        });
    };
    const customDialogAction = ()=>{
        setOpenDialog((0, $1a6d66fa26b52d0d$export$13fc5789028276e1).None);
        onCloseCallbackRef.current();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            openDialog === (0, $1a6d66fa26b52d0d$export$13fc5789028276e1).Create && /*#__PURE__*/ (0, $ayMG0.jsx)($53e1d3e086e443b2$var$BimCreateDialog, {
                onClose: ()=>setOpenDialog((0, $1a6d66fa26b52d0d$export$13fc5789028276e1).None),
                onConfirm: createBimItem
            }),
            openDialog === (0, $1a6d66fa26b52d0d$export$13fc5789028276e1).Delete && /*#__PURE__*/ (0, $ayMG0.jsx)($53e1d3e086e443b2$var$BimDeleteDialog, {
                onClose: ()=>setOpenDialog((0, $1a6d66fa26b52d0d$export$13fc5789028276e1).None),
                onConfirm: deleteBimItem
            }),
            openDialog === (0, $1a6d66fa26b52d0d$export$13fc5789028276e1).DeleteAttachment && /*#__PURE__*/ (0, $ayMG0.jsx)($53e1d3e086e443b2$var$BimDeleteAttachmentDialog, {
                onClose: ()=>setOpenDialog((0, $1a6d66fa26b52d0d$export$13fc5789028276e1).None),
                onConfirm: customDialogAction
            })
        ]
    });
};
// eslint-disable-next-line react/prop-types
const $53e1d3e086e443b2$var$BimCreateDialog = ({ onClose: onClose, onConfirm: onConfirm })=>{
    const [, setRefresh] = (0, $acw62.useState)(false);
    const [submitted, setSubmitted] = (0, $acw62.useState)(false);
    const newBimModel = (0, $acw62.useMemo)(()=>{
        const bimModel = new (0, $0bafe5cbc4b092bf$export$617f92e08d05bd16)();
        bimModel.initFromStub();
        return bimModel;
    }, []);
    const setBimField = (fieldName, fieldValue)=>{
        newBimModel[fieldName] = fieldValue;
        setRefresh((current)=>!current);
    };
    const onSubmit = ()=>{
        newBimModel.isValid() ? onConfirm(newBimModel.toCreateStub()) : setSubmitted(true);
    };
    newBimModel.requiredFields = newBimModel.requiredFields || new (0, $8d3ebfc71b421629$export$11aebda652217b5f)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4f13784bd714c44e$export$2e2bcd8739ae039), {
        open: true,
        onClose: onClose,
        fullWidth: true,
        maxWidth: "sm",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6ac58aca374c76c$export$2e2bcd8739ae039), {
                children: "Create BIM item"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fa8e9c420cdee0a$export$2e2bcd8739ae039), {
                sx: {
                    flexGrow: 1,
                    width: '90%',
                    margin: 'auto'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        sx: {
                            m: 1
                        },
                        variant: "subtitle2",
                        color: "text.secondary",
                        component: "div",
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847c89107864d1f8$export$b681679b4be4a0a8), {
                        bimModel: newBimModel,
                        validate: submitted,
                        editable: true,
                        displayIdAndName: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        sx: {
                            m: 1
                        },
                        variant: "subtitle2",
                        color: "text.secondary",
                        component: "div",
                        children: "Characteristics"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847c89107864d1f8$export$277f8897b6619a83), {
                        bimRequiredFields: newBimModel.requiredFields,
                        validate: submitted,
                        editable: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        sx: {
                            m: 1
                        },
                        variant: "subtitle2",
                        color: "text.secondary",
                        component: "div",
                        children: "Type/Subtype"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847c89107864d1f8$export$474c1af473291c4a), {
                        bimRequiredFields: newBimModel.requiredFields,
                        validate: submitted,
                        editable: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        sx: {
                            m: 1
                        },
                        variant: "subtitle2",
                        color: "text.secondary",
                        component: "div",
                        children: "Shape & dimensions"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847c89107864d1f8$export$6422c795941ce074), {
                        bimRequiredFields: newBimModel.requiredFields,
                        validate: submitted,
                        editable: true,
                        onChange: ()=>setRefresh((current)=>!current)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        sx: {
                            m: 1
                        },
                        variant: "subtitle2",
                        color: "text.secondary",
                        component: "div",
                        children: "Labels"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            width: '90%',
                            m: 'auto',
                            mt: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb7aa6a5931da2b2$export$d0b89778d85285fc), {
                            tags: Object.keys(newBimModel.tags),
                            onTagsChange: (event, newTags)=>setBimField('tags', (0, $834b9e85ded96783$export$324ca61d40111c16)(newTags))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $207bc6ab7c60f4b2$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        onClick: onSubmit,
                        children: "Create"
                    })
                ]
            })
        ]
    });
};
// eslint-disable-next-line react/prop-types
const $53e1d3e086e443b2$var$BimDeleteDialog = ({ onClose: onClose, onConfirm: onConfirm })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4f13784bd714c44e$export$2e2bcd8739ae039), {
        open: true,
        onClose: onClose,
        fullWidth: true,
        maxWidth: "xs",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6ac58aca374c76c$export$2e2bcd8739ae039), {
                children: "Delete BIM item"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fa8e9c420cdee0a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aad93085434ac13f$export$2e2bcd8739ae039), {
                    children: "Are you sure you want to delete BIM item?"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $207bc6ab7c60f4b2$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        onClick: ()=>onConfirm(),
                        children: "Delete"
                    })
                ]
            })
        ]
    });
};
// eslint-disable-next-line react/prop-types
const $53e1d3e086e443b2$var$BimDeleteAttachmentDialog = ({ onClose: onClose, onConfirm: onConfirm })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4f13784bd714c44e$export$2e2bcd8739ae039), {
        open: true,
        onClose: onClose,
        fullWidth: true,
        maxWidth: "xs",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6ac58aca374c76c$export$2e2bcd8739ae039), {
                children: "Delete BIM Attachment"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fa8e9c420cdee0a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aad93085434ac13f$export$2e2bcd8739ae039), {
                    children: "Are you sure you want to delete BIM attachment?"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $207bc6ab7c60f4b2$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        onClick: ()=>onConfirm(),
                        children: "Delete"
                    })
                ]
            })
        ]
    });
};




const $71900262780a903e$export$16784d4c3a087cb5 = 'small';
const $71900262780a903e$export$3e5d0a726801a3cc = ()=>{
    const [, setRefresh] = (0, $acw62.useState)(false);
    const [searchPattern, setSearchPattern] = (0, $acw62.useState)('');
    const [bimId, setBimId] = (0, $acw62.useState)();
    const bimItems = (0, $0bafe5cbc4b092bf$export$9a93b0d49a84081a).toArray();
    const bimModel = bimId ? (0, $0bafe5cbc4b092bf$export$9a93b0d49a84081a).instances[bimId] : null;
    // responsive dialog width
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    // By default normal size is lg
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const isCompact = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.down('md')); // below md => full size (xl)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const isLarge = (0, $942f413c6b94358c$export$2e2bcd8739ae039)(theme.breakpoints.up('lg')); // above lg => min size (md)
    const mainLayoutStyle = {
        display: 'grid',
        gridTemplateColumns: '22% auto',
        gridTemplateAreas: `'list details'`
    };
    const getSearchedFields = (item)=>{
        let searchStr = item.name ? item.name.toLowerCase() : '';
        searchStr += item.tags ? Object.keys(item.tags).reduce((res, val)=>res + ' ' + val, ' ') : '';
        searchStr += item.requiredFields?.originalStub ? Object.values(item.requiredFields.originalStub).map((reqField)=>typeof reqField === 'string' ? reqField.toLowerCase() : '').reduce((concat, val)=>concat + ' ' + val, ' ') : '';
        return searchStr;
    };
    const filteredItems = searchPattern.length ? bimItems.filter((item)=>getSearchedFields(item).includes(searchPattern)) : bimItems;
    const preloadItems = async (doReset = false)=>{
        doReset && setBimId(null);
        await (0, $0bafe5cbc4b092bf$export$9a93b0d49a84081a).searchFetch(' ', null, true);
        setRefresh((current)=>!current);
    };
    const reload = async ()=>{
        await bimModel.failsafeLoad();
        setRefresh((current)=>!current);
    };
    const reloadThumbnail = async ()=>{
        await bimModel.preloadAttachments();
        const thumbnailAttachment = bimModel.getThumbnailAttachment();
        await thumbnailAttachment?.load();
        bimModel.thumbnail.url = thumbnailAttachment.url;
        setRefresh((current)=>!current);
    };
    const onThumbnailUpload = async (file)=>{
        const { id: thumbnailAttachmentId } = await (0, $834b9e85ded96783$export$a5575dbeeffdad98)(file, bimId);
        if (thumbnailAttachmentId) {
            console.log(`[onThumbnailUpload] FINAL STEP (#4): update model ${bimId} with thumbnailAttachmentId ${thumbnailAttachmentId} `);
            const reply = await (0, $bc849b5adfe80d87$export$c892f6e8c0b873f6).used.updateItem(bimId, {
                thumbnailAttachmentId: thumbnailAttachmentId
            });
            if (reply?.status === 204) {
                (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).success('Thumbnail successfully uploaded');
                await reload();
                reloadThumbnail();
            } else (0, $3b11ea43c4ed5c54$export$cfe57eeafcf44ca0).error('an error occured during thumbnail uploading');
        }
    };
    (0, $acw62.useEffect)(()=>{
        // populate bim data from server (this should only be done once)
        preloadItems();
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: mainLayoutStyle,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                        id: "main",
                        style: {
                            gridArea: 'list',
                            width: '95%',
                            height: '90vh',
                            margin: 'auto',
                            marginTop: '10px',
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    backgroundColor: '#f5f5f5',
                                    width: '100%'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed5c3fde1b6266f6$export$2e2bcd8739ae039), {
                                    onSearchChange: (e)=>setSearchPattern(e.target.value?.toLowerCase() ?? '')
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    overflowY: 'auto',
                                    height: '72vh'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $647b290a2a3a9460$export$77dbd89d2efb3023), {
                                    items: filteredItems,
                                    selectItem: setBimId,
                                    selectedId: bimId
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    width: '100%',
                                    marginBottom: 'auto',
                                    position: 'absolute',
                                    bottom: '0px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        sx: {
                                            flexGrow: 1
                                        }
                                    }),
                                    bimId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                        onClick: (0, $1a6d66fa26b52d0d$export$48bf5c62bf01d809).onDeleteDialogOpen,
                                        variant: "outlined",
                                        sx: {
                                            margin: 1
                                        },
                                        children: "Delete"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                        onClick: (0, $1a6d66fa26b52d0d$export$48bf5c62bf01d809).onCreateDialogOpen,
                                        variant: "outlined",
                                        sx: {
                                            margin: 1
                                        },
                                        children: "Create"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                        style: {
                            gridArea: 'details',
                            width: '95%',
                            height: '90vh',
                            margin: 'auto',
                            marginTop: '10px',
                            display: 'flex'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: '57%',
                                    height: '85vh',
                                    overflowY: 'auto',
                                    paddingRight: '25px',
                                    margin: 'auto',
                                    marginRight: '0px'
                                },
                                children: bimId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6e81b952cae6437$export$613a539023b8e9f5), {
                                    itemId: bimId
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                                orientation: "vertical",
                                sx: {
                                    height: '80%',
                                    mt: 'auto',
                                    mb: 'auto'
                                }
                            }),
                            bimModel && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    width: '38%',
                                    margin: 'auto',
                                    marginTop: '20px',
                                    height: '85vh'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        sx: {
                                            m: 1,
                                            mb: 2
                                        },
                                        variant: "subtitle2",
                                        color: "text.secondary",
                                        component: "div",
                                        children: "Thumbnail"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            width: '50%',
                                            margin: 'auto'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e38dca3b8c2d6ab3$export$cbafa1ad4452dd0d), {
                                            imgUrl: bimModel.thumbnail.url,
                                            upload: onThumbnailUpload
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            height: '50vh',
                                            overflowY: 'auto'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a63880032b53cc05$export$efb3fa57c18b8b51), {
                                            bimId: bimId
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $53e1d3e086e443b2$export$7012ac741ddc1f84), {
                onDone: preloadItems,
                currentBimId: bimId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5bac0c5be581ac8$export$36ba2f559d49a8f6), {})
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fd904517f2a78af6$export$d6efab9620b78fec(slot) {
    return (0, $4Cod0.default)('MuiLink', slot);
}
const $fd904517f2a78af6$var$linkClasses = (0, $beCSm.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $fd904517f2a78af6$export$2e2bcd8739ae039 = $fd904517f2a78af6$var$linkClasses;



var $k0igC = parcelRequire("k0igC");

var $kSnzZ = parcelRequire("kSnzZ");
const $204cbcbead979fad$export$c4e140d5d351182b = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $204cbcbead979fad$var$transformDeprecatedColors = (color)=>{
    return $204cbcbead979fad$export$c4e140d5d351182b[color] || color;
};
const $204cbcbead979fad$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $204cbcbead979fad$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $k0igC.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $k0igC.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $kSnzZ.alpha)(color, 0.4);
};
var $204cbcbead979fad$export$2e2bcd8739ae039 = $204cbcbead979fad$var$getTextDecoration;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $731ce78e0c47d0a7$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $731ce78e0c47d0a7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $jTnBY.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fd904517f2a78af6$export$d6efab9620b78fec), classes);
};
const $731ce78e0c47d0a7$var$LinkRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $jTnBY.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $8nd05.default)({}, ownerState.underline === 'none' && {
        textDecoration: 'none'
    }, ownerState.underline === 'hover' && {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }, ownerState.underline === 'always' && (0, $8nd05.default)({
        textDecoration: 'underline'
    }, ownerState.color !== 'inherit' && {
        textDecorationColor: (0, $204cbcbead979fad$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        '&:hover': {
            textDecorationColor: 'inherit'
        }
    }), ownerState.component === 'button' && {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $fd904517f2a78af6$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: 'auto'
        }
    });
});
const $731ce78e0c47d0a7$var$Link = /*#__PURE__*/ $acw62.forwardRef(function Link(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx } = props, other = (0, $1En50.default)(props, $731ce78e0c47d0a7$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    const handlerRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $731ce78e0c47d0a7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($731ce78e0c47d0a7$var$LinkRoot, (0, $8nd05.default)({
        color: color,
        className: (0, $9QePP.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $204cbcbead979fad$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $731ce78e0c47d0a7$export$2e2bcd8739ae039 = $731ce78e0c47d0a7$var$Link;





var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");
const $d71ad851a14a3549$var$ProfileName = ()=>{
    const { instance: instance } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const account = (0, $e5e33773db31b6c0$export$83a8e409853da004)(instance.getActiveAccount() || {});
    const [name, setName] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        if (account?.name) setName(account.name);
        else setName('');
    }, [
        account
    ]);
    if (name) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
        variant: "h6",
        children: name
    });
    return null;
};
var $d71ad851a14a3549$export$2e2bcd8739ae039 = $d71ad851a14a3549$var$ProfileName;



var $ayMG0 = parcelRequire("ayMG0");



var $ayMG0 = parcelRequire("ayMG0");





var $acw62 = parcelRequire("acw62");

const $b3ff59e668975151$export$e4624626de9ce646 = ()=>{
    const { instance: instance } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    const open = Boolean(anchorEl);
    const handleLogin = async (loginType)=>{
        setAnchorEl(null);
        if (loginType === (0, $d94f86a26f94c76a$export$cc0e003816b34e6b).POPUP) return instance.loginPopup((0, $d94f86a26f94c76a$export$be6c432b2463c5eb));
        if (loginType === (0, $d94f86a26f94c76a$export$cc0e003816b34e6b).REDIRECT) return instance.loginRedirect((0, $d94f86a26f94c76a$export$be6c432b2463c5eb));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                onClick: (event)=>setAnchorEl(event.currentTarget),
                color: "inherit",
                children: "Login"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), {
                id: "menu-appbar",
                anchorEl: anchorEl,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                keepMounted: true,
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                open: open,
                onClose: ()=>setAnchorEl(null),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                    onClick: ()=>handleLogin((0, $d94f86a26f94c76a$export$a7c3064c595ea4b7)),
                    children: "Sign In"
                }, "signin")
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $7d42bca4a99d9e7e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($7d42bca4a99d9e7e$exports, "__esModule", {
    value: true
});
$7d42bca4a99d9e7e$exports.default = void 0;

var $7d42bca4a99d9e7e$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $7d42bca4a99d9e7e$var$_default = $7d42bca4a99d9e7e$exports.default = (0, $7d42bca4a99d9e7e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20"
}), 'AccountCircle');






var $acw62 = parcelRequire("acw62");

const $2b4d92a52745f537$export$2d26853fef4d9a02 = ()=>{
    const { instance: instance } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    const open = Boolean(anchorEl);
    const handleLogout = (logoutType)=>{
        setAnchorEl(null);
        if (logoutType === (0, $d94f86a26f94c76a$export$cc0e003816b34e6b).POPUP) instance.logoutPopup({
            mainWindowRedirectUri: '/'
        });
        else if (logoutType === (0, $d94f86a26f94c76a$export$cc0e003816b34e6b).REDIRECT) instance.logoutRedirect();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                onClick: (event)=>setAnchorEl(event.currentTarget),
                color: "inherit",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7d42bca4a99d9e7e$exports))), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), {
                id: "menu-appbar",
                anchorEl: anchorEl,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                keepMounted: true,
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                open: open,
                onClose: ()=>setAnchorEl(null),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                    onClick: ()=>handleLogout((0, $d94f86a26f94c76a$export$a7c3064c595ea4b7)),
                    children: "Logout"
                }, "logout")
            })
        ]
    });
};


const $5e70916c9cf4b2e1$var$SignInSignOutButton = ()=>{
    const { inProgress: inProgress } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const isAuthenticated = (0, $41a0d322aea9de82$export$7e9c60d6d1836c84)();
    if (isAuthenticated) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b4d92a52745f537$export$2d26853fef4d9a02), {});
    if (inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup && inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).HandleRedirect) // inProgress check prevents sign-in button from being displayed briefly after returning
    // from a redirect sign-in. Processing the server response takes a render cycle or two
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3ff59e668975151$export$e4624626de9ce646), {});
    return null;
};
var $5e70916c9cf4b2e1$export$2e2bcd8739ae039 = $5e70916c9cf4b2e1$var$SignInSignOutButton;


const $5828c4d25b1c30f1$var$NavBar = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            flexGrow: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $37a342382669398e$export$2e2bcd8739ae039), {
            position: "static",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ef8072c26f712b4c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        style: {
                            flexGrow: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $731ce78e0c47d0a7$export$2e2bcd8739ae039), {
                            // component={RouterLink}
                            href: "/",
                            color: "inherit",
                            variant: "h6",
                            children: "SiteSee BIM Admin"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d71ad851a14a3549$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e70916c9cf4b2e1$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
var $5828c4d25b1c30f1$export$2e2bcd8739ae039 = $5828c4d25b1c30f1$var$NavBar;


const $e0e19662b9f9e8bd$export$6d1402fb58384e4f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5828c4d25b1c30f1$export$2e2bcd8739ae039), {}),
            children
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $a24499e9cfcadef8$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($a24499e9cfcadef8$exports, "__esModule", {
    value: true
});
$a24499e9cfcadef8$exports.default = void 0;

var $a24499e9cfcadef8$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a24499e9cfcadef8$var$_default = $a24499e9cfcadef8$exports.default = (0, $a24499e9cfcadef8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9zm9 14H6V10h12zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2"
}), 'LockOutlined');








var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $gxvzd = parcelRequire("gxvzd");



var $6o2lr = parcelRequire("6o2lr");

var $ayMG0 = parcelRequire("ayMG0");
const $9d2a35bf051ea407$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $9d2a35bf051ea407$var$defaultTheme = (0, $6o2lr.default)();
const $9d2a35bf051ea407$var$defaultCreateStyledComponent = (0, $0016d2a363b4c314$export$2e2bcd8739ae039)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $gxvzd.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $9d2a35bf051ea407$var$useThemePropsDefault = (inProps)=>(0, $9f45a3834bb6880f$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $9d2a35bf051ea407$var$defaultTheme
    });
const $9d2a35bf051ea407$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $4Cod0.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $gxvzd.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, getContainerUtilityClass, classes);
};
function $9d2a35bf051ea407$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $9d2a35bf051ea407$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $9d2a35bf051ea407$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            display: 'block'
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('sm')]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.maxWidth === 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('xs')]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $acw62.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg' } = props, other = (0, $1En50.default)(props, $9d2a35bf051ea407$var$_excluded);
        const ownerState = (0, $8nd05.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $9d2a35bf051ea407$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $2291beb327d500f8$var$Container = (0, $9d2a35bf051ea407$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $2291beb327d500f8$export$2e2bcd8739ae039 = $2291beb327d500f8$var$Container;





// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $e2aa2d4e9a54751a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        height: "24",
        width: "24",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: "Microsoft Entra ID Logo"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#f3f3f3",
                d: "M0 0h23v23H0z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#f35325",
                d: "M1 1h10v10H1z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#81bc06",
                d: "M12 1h10v10H12z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#05a6f0",
                d: "M1 12h10v10H1z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#ffba08",
                d: "M12 12h10v10H12z"
            })
        ]
    });
}


const $3c40f029ce85dd4e$var$LoginPage = ({ error: error })=>{
    const { instance: instance } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const handleLogin = async (loginType)=>{
        if (loginType === (0, $d94f86a26f94c76a$export$cc0e003816b34e6b).POPUP) return instance.loginPopup((0, $d94f86a26f94c76a$export$be6c432b2463c5eb));
        if (loginType === (0, $d94f86a26f94c76a$export$cc0e003816b34e6b).REDIRECT) return instance.loginRedirect((0, $d94f86a26f94c76a$export$be6c432b2463c5eb));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        component: "main",
        maxWidth: "xs",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
                    sx: {
                        my: 1,
                        mb: 2,
                        bgcolor: 'primary.main'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a24499e9cfcadef8$exports))), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    variant: "h5",
                    color: "textPrimary",
                    gutterBottom: true,
                    textAlign: "center",
                    children: "Sign in"
                }),
                error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                    sx: {
                        my: 2
                    },
                    severity: "error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        mt: 2
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
                        spacing: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            variant: "contained",
                            fullWidth: true,
                            size: "large",
                            disableElevation: true,
                            name: 'provider',
                            color: 'primary',
                            value: 'msal',
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e2aa2d4e9a54751a$export$2e2bcd8739ae039), {}),
                            onClick: ()=>handleLogin((0, $d94f86a26f94c76a$export$a7c3064c595ea4b7)),
                            sx: {
                                textTransform: 'capitalize',
                                filter: 'opacity(0.9)',
                                transition: 'filter 0.2s ease-in',
                                '&:hover': {
                                    filter: 'opacity(1)'
                                }
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Sign in"
                            })
                        }, 'msal.login')
                    })
                })
            ]
        })
    });
};
var $3c40f029ce85dd4e$export$2e2bcd8739ae039 = $3c40f029ce85dd4e$var$LoginPage;



var $ln9F4 = parcelRequire("ln9F4");

var $3z1Ay = parcelRequire("3z1Ay");

var $ijOKP = parcelRequire("ijOKP");
function $3d23504439aa8524$export$2e2bcd8739ae039(options, ...args) {
    return (0, $ijOKP.default)((0, $3z1Ay.default)({
        unstable_strictMode: true
    }, options), ...args);
}


const $a9cf7089200d1eb9$export$bca14c5b3b88a9c9 = (0, $3d23504439aa8524$export$2e2bcd8739ae039)({
    palette: {
        mode: 'light',
        primary: {
            main: '#1976d2'
        },
        secondary: {
            main: '#19857b'
        },
        error: {
            main: (0, $ln9F4.default).A400
        },
        background: {
            default: '#fff'
        }
    }
});


function $6840e8b44f75a905$export$86fbec116b87613f() {
    const [instance, setInstance] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)(undefined);
    (0, $acw62.useEffect)(()=>{
        (0, $d94f86a26f94c76a$export$aade1390fcc98ec3)().then((instance)=>{
            instance.addEventCallback((event)=>{
                if (event.eventType === (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE && event.error) {
                    const error = event.error;
                    setError(error);
                }
            }, [
                (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE
            ]);
            setInstance(instance);
        }).catch((e)=>{
            console.error('Error occured initialising MSAL', e);
            setError(JSON.stringify(e));
        });
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4650f6dac4940cb$export$2e2bcd8739ae039), {
            theme: (0, $a9cf7089200d1eb9$export$bca14c5b3b88a9c9),
            children: instance ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b3e52a40af96eae$export$25bac41dc3d78d47), {
                instance: instance,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e0e19662b9f9e8bd$export$6d1402fb58384e4f), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89a512f94435fcda$export$3f7734c901feade6), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71900262780a903e$export$3e5d0a726801a3cc), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0c0868d77661165$export$8285a35799c5812b), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c40f029ce85dd4e$export$2e2bcd8739ae039), {
                                error: error?.toString()
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Initialising..."
            }) // FIXME: Make this pretty
        })
    });
}


const $70fc9a727fa662ae$var$container = document.getElementById('app');
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($70fc9a727fa662ae$var$container); // createRoot(container!) if you use TypeScript
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6840e8b44f75a905$export$86fbec116b87613f), {}));


//# sourceMappingURL=bim-admin-gui.1682b0f6.js.map
